import { A as e, At as t, C as n, Ct as r, D as i, Dt as a, Ft as o, G as s, I as c, It as l, J as u, K as d, Lt as f, M as p, Mt as m, N as h, Nt as g, Ot as _, Pt as v, Q as y, Rt as b, S as x, T as S, Tt as C, U as w, W as T, X as ee, Y as te, Z as ne, _ as re, _t as ie, a as ae, at as oe, b as se, bt as ce, ct as le, dt as ue, et as de, g as fe, gt as pe, h as me, ht as he, it as ge, jt as _e, k as ve, kt as ye, l as be, lt as xe, mt as Se, n as Ce, nt as we, ot as Te, pt as Ee, q as De, rt as Oe, s as ke, st as Ae, t as je, tt as Me, u as Ne, ut as Pe, v as Fe, vt as Ie, w as Le, x as Re, xt as ze, yt as Be, zt as Ve } from "./dist-CkS8TOF-.js";
import { i as He, n as Ue, o as We, r as Ge } from "./dist-CwwjEPEF.js";
import { r as Ke } from "./dist-BMLc5gbK.js";
import { n as qe } from "./dist-BCsnVsiY.js";
import { Fragment as E, KeepAlive as Je, computed as D, createBlock as O, createCommentVNode as k, createElementBlock as A, createElementVNode as j, createSlots as Ye, createTextVNode as M, createVNode as N, defineAsyncComponent as Xe, defineComponent as P, getCurrentInstance as Ze, guardReactiveProps as Qe, h as $e, inject as et, isRef as tt, markRaw as nt, mergeModels as rt, mergeProps as F, nextTick as it, normalizeClass as I, normalizeProps as at, normalizeStyle as ot, onBeforeUnmount as st, onBeforeUpdate as ct, onMounted as lt, onUnmounted as ut, openBlock as L, provide as dt, reactive as ft, ref as R, renderList as z, renderSlot as B, resolveComponent as pt, resolveDynamicComponent as mt, shallowRef as ht, toDisplayString as V, toHandlers as gt, toRaw as _t, toRefs as vt, unref as H, useAttrs as yt, useId as bt, useModel as xt, useSlots as St, vModelText as Ct, vShow as wt, watch as U, withCtx as W, withDirectives as Tt, withKeys as Et, withModifiers as Dt } from "vue";
import { apiSettings as Ot, dialogVisibilityKey as kt, getHelixApiBaseUrl as At, hGetAppRouteUrl as jt, isExternalUrl as Mt, isUrlWithBase as Nt, publicSettings as Pt, resolvePublicLogoUrl as Ft, useAdminResourcesEnabled as It, useAdministrationFeatures as Lt, useHAlerts as Rt, useHCardResolver as zt, useHCommon as Bt, useHConfig as Vt, useHConfirm as Ht, useHDateRangePresets as Ut, useHDefaults as G, useHFormField as Wt, useHFormatDateTime as Gt, useHLocale as Kt, useHLocaleFallback as qt, useHNamespaceProps as Jt, useHPageHead as Yt, useHThemePack as Xt, useHThemePackDefaults as Zt, useHTranslate as K, useOCommon as Qt, useOSettings as $t, useOUserSettingsStore as en, useTooltipGroup as tn } from "@onify/helix-core";
import { VBreadcrumbs as nn } from "vuetify/components/VBreadcrumbs";
import { VCard as rn, VCardActions as an, VCardItem as on, VCardSubtitle as sn, VCardText as cn, VCardTitle as ln } from "vuetify/components/VCard";
import { VBtn as q } from "vuetify/components/VBtn";
import { VTooltip as un } from "vuetify/components/VTooltip";
import { VIcon as J } from "vuetify/components/VIcon";
import { VCol as dn, VContainer as fn, VRow as pn, VSpacer as mn } from "vuetify/components/VGrid";
import { VTextField as hn } from "vuetify/components/VTextField";
import { VSelect as gn } from "vuetify/components/VSelect";
import { VAutocomplete as _n } from "vuetify/components/VAutocomplete";
import { VCombobox as vn } from "vuetify/components/VCombobox";
import { VTextarea as yn } from "vuetify/components/VTextarea";
import { VSwitch as bn } from "vuetify/components/VSwitch";
import { VDatePicker as xn } from "vuetify/components/VDatePicker";
import { VMenu as Sn } from "vuetify/components/VMenu";
import { VTimePicker as Cn } from "vuetify/components/VTimePicker";
import { VInput as wn } from "vuetify/components/VInput";
import { RouterLink as Tn, loadRouteLocation as En, routeLocationKey as Dn, useRoute as On, useRouter as kn } from "vue-router";
import { computedAsync as An, useArrayEvery as jn, useElementSize as Mn, useEventListener as Nn, useIntervalFn as Pn, useResizeObserver as Fn, useTimeoutFn as In, useToggle as Ln, useVModel as Rn, useVModels as zn } from "@vueuse/core";
import { VList as Bn, VListGroup as Vn, VListItem as Hn, VListItemSubtitle as Un, VListItemTitle as Wn, VListSubheader as Gn } from "vuetify/components/VList";
import { VExpandTransition as Kn } from "vuetify/components/transitions";
import { VChip as qn } from "vuetify/components/VChip";
import { VBadge as Jn } from "vuetify/components/VBadge";
import { VImg as Yn } from "vuetify/components/VImg";
import { VCheckbox as Xn, VCheckboxBtn as Zn } from "vuetify/components/VCheckbox";
import { VDataTableFooter as Qn, VDataTableServer as $n } from "vuetify/components/VDataTable";
import { VDivider as er } from "vuetify/components/VDivider";
import { VAvatar as tr } from "vuetify/components/VAvatar";
import { VDialog as nr } from "vuetify/components/VDialog";
import { VTable as rr } from "vuetify/components/VTable";
import { useDisplay as ir, useTheme as ar } from "vuetify";
import { VDefaultsProvider as or } from "vuetify/components/VDefaultsProvider";
import { VAutocomplete as sr, VAvatar as cr, VBtn as lr, VDialog as ur, VIcon as dr } from "vuetify/components";
import { VAlert as fr } from "vuetify/components/VAlert";
import { VExpansionPanel as pr, VExpansionPanelText as mr, VExpansionPanels as hr } from "vuetify/components/VExpansionPanel";
import { VFileInput as gr } from "vuetify/components/VFileInput";
import { VSheet as _r } from "vuetify/components/VSheet";
import { VLayout as vr } from "vuetify/components/VLayout";
import { VMain as yr } from "vuetify/components/VMain";
import { VNavigationDrawer as br } from "vuetify/components/VNavigationDrawer";
import { injectDefaults as xr } from "vuetify/lib/composables/defaults.js";
import { VForm as Sr } from "vuetify/components/VForm";
import { VOverlay as Cr } from "vuetify/components/VOverlay";
import { VProgressCircular as wr } from "vuetify/components/VProgressCircular";
import { VStepper as Tr, VStepperHeader as Er, VStepperItem as Dr } from "vuetify/components/VStepper";
import { addDays as Or, format as kr, formatDistance as Ar, isValid as jr, isWeekend as Mr, parseISO as Nr, startOfDay as Pr } from "date-fns";
import { enUS as Fr, fi as Ir, sv as Lr } from "date-fns/locale";
import { storeToRefs as Rr } from "pinia";
import { Tooltip as zr } from "vuetify/directives";
import { VBtnToggle as Br } from "vuetify/components/VBtnToggle";
import { VSkeletonLoader as Vr } from "vuetify/components/VSkeletonLoader";
//#region src/components/admin/admin-layout.vue?vue&type=script&setup=true&lang.ts
var Hr = { class: "h-admin-page__breadcrumbs" }, Ur = { class: "h-admin-page__header" }, Wr = { class: "h-admin-page__heading-row" }, Gr = { class: "h-admin-page__heading" }, Kr = { class: "h-admin-page__title" }, qr = { class: "h-admin-page__header-controls" }, Jr = /*@__PURE__*/ P({
	__name: "admin-layout",
	props: {
		pageTitle: { default: "" },
		pagePrefix: { default: "" },
		headerTitle: { default: "" },
		headerDescription: { default: "" },
		pageKey: {},
		breadcrumbItems: { default: () => [] }
	},
	setup(e) {
		let t = G(e, "HAdminLayout"), n = D(() => {
			let e = [...t.breadcrumbItems || []];
			if (!e.length) return [];
			let n = K("home"), r = e[0];
			return r.href !== "/" && r.title !== n && r.text !== n && e.unshift({
				title: n,
				href: "/"
			}), e.map((t, n) => ({
				title: t.title || t.text || "",
				to: n === 0 ? "/" : t.href || (n === 1 ? "/admin/dashboard" : void 0),
				disabled: n === e.length - 1
			}));
		});
		return (t, r) => {
			let i = pt("h-page-container");
			return L(), O(i, {
				"page-title": e.pageTitle,
				"page-prefix": e.pagePrefix,
				class: I(["h-admin-page", e.pageKey && `h-admin-${e.pageKey}-page`])
			}, {
				default: W(() => [
					B(t.$slots, "header-top", {}, () => [j("div", Hr, [e.breadcrumbItems && e.breadcrumbItems.length > 0 ? (L(), O(nn, {
						key: 0,
						items: n.value,
						class: "h-admin-breadcrumbs",
						icon: "mdi:mdi-home-outline"
					}, {
						divider: W(() => [...r[0] ||= [j("svg", {
							width: "20",
							height: "20",
							viewBox: "0 0 24 24",
							fill: "currentColor",
							"aria-hidden": "true",
							focusable: "false"
						}, [j("path", { d: "M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z" })], -1)]]),
						_: 1
					}, 8, ["items"])) : k("", !0)])], !0),
					j("div", Ur, [B(t.$slots, "header-container", {}, () => [j("div", Wr, [B(t.$slots, "header-left", {}, () => [j("div", Gr, [B(t.$slots, "header-left-content", {}, () => [j("div", Kr, [j("h1", null, V(e.headerTitle), 1)])], !0)])], !0), B(t.$slots, "header-right", {}, () => [j("div", qr, [B(t.$slots, "header-right-content", {}, void 0, !0)])], !0)])], !0)]),
					B(t.$slots, "default", {}, void 0, !0)
				]),
				_: 3
			}, 8, [
				"page-title",
				"page-prefix",
				"class"
			]);
		};
	}
}), Y = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, Yr = /*#__PURE__*/ Y(Jr, [["__scopeId", "data-v-8792fee4"]]), Xr = { class: "h-admin-page__filters mb-4" }, Zr = { key: 1 }, Qr = { key: 2 }, $r = { key: 0 }, ei = { class: "h-admin-filter-row d-flex flex-row flex-wrap ga-2" }, ti = { class: "h-admin-filter-group-fields" }, ni = { class: "h-admin-page__widgets" }, ri = { class: "h-admin-page__content" }, ii = /* @__PURE__ */ P({
	__name: "admin-data-view",
	props: /*@__PURE__*/ rt({
		summaryLabel: {},
		filtersActive: { type: Boolean },
		tableShowSelect: { type: Boolean },
		externalFilterToggle: { type: Boolean },
		filterPanelId: {},
		totalResults: {},
		isFilterActive: {},
		tableHeaders: {},
		tableData: {},
		tableLoading: { type: Boolean },
		tableActions: { default: () => [] },
		tableRowsPerPage: { default: 25 },
		tableTotalItemsLimit: { default: 1e4 },
		tableRowsPerPageOptions: { default: () => [
			25,
			50,
			100,
			500
		] },
		tableNonPaginatedLimit: {},
		tablePagination: {
			type: Boolean,
			default: !0
		},
		filtersConfig: {},
		pageKey: { default: "" }
	}, {
		tableParams: {},
		tableParamsModifiers: {},
		filters: {},
		filtersModifiers: {},
		filtersExpanded: {
			type: Boolean,
			default: !1
		},
		filtersExpandedModifiers: {}
	}),
	emits: /*@__PURE__*/ rt([
		"update:table-sort",
		"update:table-page",
		"clear-filters"
	], [
		"update:tableParams",
		"update:filters",
		"update:filtersExpanded"
	]),
	setup(e, { emit: t }) {
		dt("adminFilterDesign", !0), dt("adminResponsiveChips", !0);
		let n = G(e, "HAdminDataView"), r = xt(e, "tableParams"), i = xt(e, "filters"), a = xt(e, "filtersExpanded"), o = t, s = R(null);
		function c() {
			return typeof window < "u" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
		}
		function l() {
			if (typeof window > "u") return;
			let e = c() ? "auto" : "smooth", t = s.value;
			for (; t;) {
				let n = getComputedStyle(t).overflowY;
				(n === "auto" || n === "scroll") && t.scrollHeight > t.clientHeight && typeof t.scrollTo == "function" && t.scrollTo({
					top: 0,
					behavior: e
				}), t = t.parentElement;
			}
			window.scrollTo({
				top: 0,
				behavior: e
			});
		}
		let u = R([...(n.tableHeaders ?? []).map((e) => ({
			...e,
			width: e.width || 150
		})), ...n.tableActions?.length > 0 ? [{
			title: "actions",
			key: "actions",
			sortable: !1,
			width: n.tableActions.length * 32 + 16,
			translate: !0
		}] : []]), d = D(() => {
			let e = i.value?.sortBy;
			for (let t of u.value) if (t.customSortKey === e) {
				e = t.key ?? e;
				break;
			}
			return [{
				key: e ?? "",
				order: i.value?.sortOrder ?? "desc"
			}];
		});
		lt(() => {
			n.tableActions || (r.value.pagesize = n.tableNonPaginatedLimit || n.tableRowsPerPage, r.value.startfrom = 0);
		});
		function f(e) {
			i.value.sortBy = e.key, i.value.sortOrder = e.order, o("update:table-sort", e);
		}
		function p(e) {
			!i.value || i.value.page === e || (i.value.page = e, o("update:table-page", e), l());
		}
		function m(e) {
			!i.value || i.value.pageSize === e || (i.value.pageSize = e, i.value.page !== 1 && (i.value.page = 1), l());
		}
		function h(e) {
			return `item.${e}`;
		}
		function g(e) {
			let t = {
				...e.props,
				...e.attrs
			};
			return n.pageKey && (t.classPrefix = n.pageKey, t.filterKey = e.key), Object.keys(t).forEach((e) => {
				tt(t[e]) && (t[e] = H(t[e])), typeof t[e] == "function" && (t[e] = t[e](i.value));
			}), t;
		}
		function _(e) {
			if (!e.events) return {};
			let t = {};
			return Object.entries(e.events).forEach(([e, n]) => {
				typeof n == "function" ? t[e] = n : console.warn(`Event handler for "${e}" must be a function, received: ${typeof n}`);
			}), t;
		}
		return (t, n) => {
			let o = pt("h-filters-container"), c = pt("h-data-table");
			return L(), A("div", {
				ref_key: "dataViewRef",
				ref: s,
				class: "h-admin-data-view"
			}, [
				j("div", Xr, [B(t.$slots, "filters-container", {}, () => [N(o, {
					expanded: a.value,
					"onUpdate:expanded": n[1] ||= (e) => a.value = e,
					results: e.totalResults,
					"hide-toggle": e.externalFilterToggle,
					"panel-id": e.filterPanelId,
					"hide-clear": e.externalFilterToggle && !e.filtersActive && !a.value,
					active: e.filtersActive || a.value,
					"clear-disabled": !e.filtersActive,
					onClearFilters: n[2] ||= (e) => t.$emit("clear-filters")
				}, {
					results: W(() => [t.$slots["filter-results"] ? B(t.$slots, "filter-results", { key: 0 }) : e.summaryLabel && !e.filtersActive && !a.value ? (L(), A("span", Zr, V(e.summaryLabel) + ": " + V(e.totalResults), 1)) : (L(), A("span", Qr, V(H(K)("admin_filter_results", { results: e.totalResults })), 1))]),
					filters: W(() => [B(t.$slots, "filters", {}, () => [e.filtersConfig && e.filtersConfig.filters && e.filtersConfig.filters.length > 0 ? (L(), A("div", $r, [j("div", ei, [(L(!0), A(E, null, z(e.filtersConfig.filters, (e) => (L(), A(E, { key: e.key }, [e.type !== "group" && e.props?.showMatchTypeSelector ? (L(), O(mt(e.component), F({
						key: 0,
						modelValue: i.value[e.model || e.key],
						"onUpdate:modelValue": (t) => i.value[e.model || e.key] = t,
						"match-type": i.value[`${e.key}MatchType`],
						"onUpdate:matchType": (t) => i.value[`${e.key}MatchType`] = t
					}, { ref_for: !0 }, g(e), gt(_(e))), null, 16, [
						"modelValue",
						"onUpdate:modelValue",
						"match-type",
						"onUpdate:matchType"
					])) : e.type === "group" ? (L(), O(mt(e.component), F({
						key: 2,
						filters: i.value,
						"onUpdate:filters": n[0] ||= (e) => i.value = e,
						"filter-keys": e.filters?.map((e) => e.model || e.key)
					}, { ref_for: !0 }, g(e)), {
						default: W(() => [j("div", ti, [(L(!0), A(E, null, z(e.filters, (e) => (L(), A(E, { key: e.key }, [e.props?.showMatchTypeSelector ? (L(), O(mt(e.component), F({
							key: 0,
							modelValue: i.value[e.model || e.key],
							"onUpdate:modelValue": (t) => i.value[e.model || e.key] = t,
							"match-type": i.value[`${e.key}MatchType`],
							"onUpdate:matchType": (t) => i.value[`${e.key}MatchType`] = t
						}, { ref_for: !0 }, g(e), gt(_(e))), null, 16, [
							"modelValue",
							"onUpdate:modelValue",
							"match-type",
							"onUpdate:matchType"
						])) : (L(), O(mt(e.component), F({
							key: 1,
							modelValue: i.value[e.model || e.key],
							"onUpdate:modelValue": (t) => i.value[e.model || e.key] = t
						}, { ref_for: !0 }, g(e), gt(_(e))), null, 16, ["modelValue", "onUpdate:modelValue"]))], 64))), 128))])]),
						_: 2
					}, 1040, ["filters", "filter-keys"])) : (L(), O(mt(e.component), F({
						key: 1,
						modelValue: i.value[e.model || e.key],
						"onUpdate:modelValue": (t) => i.value[e.model || e.key] = t
					}, { ref_for: !0 }, g(e), gt(_(e))), null, 16, ["modelValue", "onUpdate:modelValue"]))], 64))), 128))])])) : k("", !0)])]),
					_: 3
				}, 8, [
					"expanded",
					"results",
					"hide-toggle",
					"panel-id",
					"hide-clear",
					"active",
					"clear-disabled"
				])])]),
				j("div", ni, [B(t.$slots, "widgets")]),
				j("div", ri, [B(t.$slots, "content", {}, () => [N(rn, {
					class: "mt-3 h-admin-template-content-card",
					rounded: "lg"
				}, {
					default: W(() => [N(c, {
						"data-params": r.value,
						"onUpdate:dataParams": n[3] ||= (e) => r.value = e,
						headers: u.value,
						data: e.tableData,
						loading: e.tableLoading,
						"is-cell-active": e.isFilterActive,
						"total-items-limit": e.tableTotalItemsLimit,
						"items-per-page-options": e.tableRowsPerPageOptions,
						"items-per-page": Number(i.value?.pageSize) > 0 ? Number(i.value?.pageSize) : e.tableRowsPerPage,
						page: Number(i.value?.page) > 0 ? Number(i.value?.page) : 1,
						"item-actions": e.tableActions,
						"non-paginated-limit": e.tableNonPaginatedLimit,
						pagination: e.tablePagination,
						"sort-by": d.value,
						"class-prefix": e.pageKey,
						"show-select": e.tableShowSelect,
						"item-value": (e) => e.id || e.key,
						"onUpdate:sort": f,
						"onUpdate:page": p,
						"onUpdate:pageSize": m
					}, Ye({ _: 2 }, [z(e.tableHeaders, (e) => ({
						name: h(e.key),
						fn: W((n) => [B(t.$slots, h(e.key), at(Qe(n)))])
					})), t.$slots.bottom ? {
						name: "bottom",
						fn: W(() => [B(t.$slots, "bottom")]),
						key: "0"
					} : void 0]), 1032, [
						"data-params",
						"headers",
						"data",
						"loading",
						"is-cell-active",
						"total-items-limit",
						"items-per-page-options",
						"items-per-page",
						"page",
						"item-actions",
						"non-paginated-limit",
						"pagination",
						"sort-by",
						"class-prefix",
						"show-select",
						"item-value"
					])]),
					_: 3
				})])])
			], 512);
		};
	}
}), ai = {
	key: 0,
	class: "h-admin-page__filter-count"
}, oi = /* @__PURE__ */ P({
	__name: "admin-template",
	props: /*@__PURE__*/ rt({
		pageConfiguration: {},
		filtersConfig: {},
		widgetsConfig: {},
		tableHeaders: {},
		totalResults: {},
		isFilterActive: {},
		tableData: {},
		tableLoading: { type: Boolean },
		tableActions: { default: () => [] },
		tableRowsPerPage: { default: 25 },
		tableTotalItemsLimit: { default: 1e4 },
		tableRowsPerPageOptions: { default: () => [
			5,
			10,
			25,
			50,
			100,
			500
		] },
		tableNonPaginatedLimit: {},
		tablePagination: {
			type: Boolean,
			default: !0
		},
		openForm: {}
	}, {
		autoSearchEnabled: {
			type: Boolean,
			default: !0
		},
		autoSearchEnabledModifiers: {},
		tableParams: {},
		tableParamsModifiers: {},
		filters: {},
		filtersModifiers: {}
	}),
	emits: /*@__PURE__*/ rt([
		"update:table-sort",
		"update:table-page",
		"clear-filters",
		"search"
	], [
		"update:autoSearchEnabled",
		"update:tableParams",
		"update:filters"
	]),
	setup(e, { emit: t }) {
		let n = G(e, "HAdminTemplate"), r = xt(e, "autoSearchEnabled"), i = R(!1), a = `admin-filters-${bt()}`, o = xt(e, "tableParams"), s = xt(e, "filters"), c = (e) => e == null || e === "" || e === "*" || Array.isArray(e) && e.length === 0 ? "" : JSON.stringify(e), l = Object.fromEntries(Object.entries(s.value || {}).map(([e, t]) => [e, c(t)])), u = /* @__PURE__ */ new Set([
			"page",
			"pageSize",
			"sortBy",
			"sortOrder"
		]), d = D(() => Object.entries(s.value || {}).some(([e, t]) => !u.has(e) && c(t) !== (l[e] ?? ""))), f = D(() => Object.entries(s.value || {}).reduce((e, [t, n]) => u.has(t) || t.endsWith("MatchType") || !t.endsWith("Preset") && c(s.value?.[`${t}Preset`]) || !c(n) || c(n) === (l[t] ?? "") ? e : e + (Array.isArray(n) ? n.length : 1), 0)), p = D(() => n.pageConfiguration?.pageTitle ?? ""), m = D(() => n.pageConfiguration?.pagePrefix ?? ""), h = D(() => n.pageConfiguration?.headerTitle ?? ""), g = D(() => n.pageConfiguration?.headerDescription ?? ""), _ = D(() => n.pageConfiguration?.searchPlaceholder ?? ""), v = D(() => n.pageConfiguration?.breadcrumbItems ?? []), y = D(() => n.pageConfiguration?.pageKey ?? ""), b = D(() => n.widgetsConfig?.widgets?.find((e) => e.summary)), x = D(() => n.widgetsConfig?.widgets?.filter((e) => !e.summary) ?? []), S = D(() => n.tableHeaders ?? []), C = D(() => n.filtersConfig ?? { filters: [] }), w = D(() => K("create"));
		return (t, c) => {
			let l = pt("h-search"), u = pt("h-widgets-container"), T = pt("h-theme-scope");
			return L(), O(Yr, {
				"page-title": p.value,
				"page-prefix": m.value,
				"header-title": h.value,
				"page-key": y.value,
				"header-description": g.value,
				"breadcrumb-items": v.value
			}, {
				"header-right-content": W(() => [N(l, {
					modelValue: s.value.term,
					"onUpdate:modelValue": c[0] ||= (e) => s.value.term = e,
					"auto-search-enabled": r.value,
					"onUpdate:autoSearchEnabled": c[1] ||= (e) => r.value = e,
					class: "h-admin-page__search",
					"page-name": _.value,
					"settings-menu": "",
					onSearch: c[2] ||= (e) => t.$emit("search")
				}, null, 8, [
					"modelValue",
					"auto-search-enabled",
					"page-name"
				]), N(q, {
					class: I(["h-admin-page__filter-toggle h-filters-container__toggle-filters", { "h-admin-page__filter-toggle--active": i.value || d.value }]),
					variant: "flat",
					color: "secondary",
					"prepend-icon": "mdi:mdi-filter",
					"aria-expanded": i.value,
					"aria-controls": a,
					onClick: c[3] ||= (e) => i.value = !i.value
				}, {
					default: W(() => [M(V(H(K)("admin_filters")) + " ", 1), f.value ? (L(), A("span", ai, V(f.value), 1)) : k("", !0)]),
					_: 1
				}, 8, ["class", "aria-expanded"])]),
				default: W(() => [N(ii, {
					"filters-expanded": i.value,
					"onUpdate:filtersExpanded": c[4] ||= (e) => i.value = e,
					filters: s.value,
					"onUpdate:filters": c[5] ||= (e) => s.value = e,
					"table-params": o.value,
					"onUpdate:tableParams": c[6] ||= (e) => o.value = e,
					"total-results": e.totalResults,
					"summary-label": b.value?.title,
					"filters-active": d.value,
					"is-filter-active": e.isFilterActive,
					"table-headers": S.value,
					"table-data": e.tableData,
					"table-loading": e.tableLoading,
					"table-actions": e.tableActions,
					"table-rows-per-page": e.tableRowsPerPage,
					"table-total-items-limit": e.tableTotalItemsLimit,
					"table-rows-per-page-options": e.tableRowsPerPageOptions,
					"table-non-paginated-limit": e.tableNonPaginatedLimit,
					"table-pagination": e.tablePagination,
					"filters-config": C.value,
					"page-key": y.value,
					"filter-panel-id": a,
					"external-filter-toggle": "",
					onClearFilters: c[7] ||= (e) => t.$emit("clear-filters"),
					"onUpdate:tableSort": c[8] ||= (e) => t.$emit("update:table-sort", e),
					"onUpdate:tablePage": c[9] ||= (e) => t.$emit("update:table-page", e)
				}, Ye({
					widgets: W(() => [x.value?.length ? (L(), O(u, {
						key: 0,
						widgets: x.value,
						class: "h-widgets-container"
					}, null, 8, ["widgets"])) : k("", !0)]),
					_: 2
				}, [z(t.$slots, (e, n) => ({
					name: n,
					fn: W((e) => [B(t.$slots, n, at(Qe(e)))])
				})), t.$slots.bottom ? {
					name: "bottom",
					fn: W(() => [N(T, { name: "HScopedAdminTemplateTableBottom" }, {
						default: W(() => [B(t.$slots, "bottom")]),
						_: 3
					})]),
					key: "0"
				} : void 0]), 1032, [
					"filters-expanded",
					"filters",
					"table-params",
					"total-results",
					"summary-label",
					"filters-active",
					"is-filter-active",
					"table-headers",
					"table-data",
					"table-loading",
					"table-actions",
					"table-rows-per-page",
					"table-total-items-limit",
					"table-rows-per-page-options",
					"table-non-paginated-limit",
					"table-pagination",
					"filters-config",
					"page-key"
				]), H(n).openForm ? (L(), O(un, {
					key: 0,
					location: "left"
				}, {
					activator: W(({ props: t }) => [N(q, F(t, {
						icon: "mdi:mdi-plus",
						color: "primary",
						size: "large",
						elevation: "3",
						class: "position-fixed ma-6",
						style: {
							bottom: "0",
							right: "0",
							"z-index": "99"
						},
						"aria-label": w.value,
						onClick: e.openForm
					}), null, 16, ["aria-label", "onClick"])]),
					default: W(() => [j("span", null, V(w.value), 1)]),
					_: 1
				})) : k("", !0)]),
				_: 3
			}, 8, [
				"page-title",
				"page-prefix",
				"header-title",
				"page-key",
				"header-description",
				"breadcrumb-items"
			]);
		};
	}
}), si = ["for"], ci = /*@__PURE__*/ Object.assign({
	name: "HFormLabel",
	inheritAttrs: !1
}, {
	__name: "form-label",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: "neutral-70"
		},
		iconSize: {
			type: String,
			default: "small"
		},
		labelColor: {
			type: String,
			default: "on-surface-variant"
		},
		labelWeight: {
			type: String,
			default: "font-weight-bold"
		},
		errorColor: {
			type: String,
			default: "error"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: !1
		},
		fieldId: {
			type: String,
			default: void 0
		},
		shrink: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let t = G(e, "HFormLabel"), n = D(() => t.error);
		return (t, r) => e.icon || e.label ? (L(), A("label", {
			key: 0,
			for: e.fieldId,
			class: I(["d-flex align-center ga-1 cursor-pointer", { "flex-shrink-0": e.shrink }])
		}, [
			e.icon ? (L(), O(J, {
				key: 0,
				size: e.iconSize,
				icon: e.icon,
				color: n.value ? e.errorColor : e.iconColor
			}, null, 8, [
				"size",
				"icon",
				"color"
			])) : k("", !0),
			e.label ? (L(), A("span", {
				key: 1,
				class: I([
					"text-body-medium",
					e.labelWeight,
					n.value ? `text-${e.errorColor}` : `text-${e.labelColor}`
				])
			}, V(e.label), 3)) : k("", !0),
			e.required ? (L(), A("span", {
				key: 2,
				class: I([`text-${e.errorColor}`])
			}, "*", 2)) : k("", !0)
		], 10, si)) : k("", !0);
	}
}), li = { class: "d-flex align-center ga-2" }, ui = {
	key: 0,
	class: "header-spacing"
}, di = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HFormField",
	inheritAttrs: !1
}, {
	__name: "form-field",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: "neutral-70"
		},
		iconSize: {
			type: String,
			default: "small"
		},
		labelColor: {
			type: String,
			default: "on-surface-variant"
		},
		labelWeight: {
			type: String,
			default: "font-weight-bold"
		},
		errorColor: {
			type: String,
			default: "error"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		labelPlacement: {
			type: String,
			default: "top",
			validator: (e) => ["top", "left"].includes(e)
		},
		indent: {
			type: Boolean,
			default: !1
		}
	},
	setup(e, { expose: t }) {
		let n = G(e, "HFormField"), r = bt(), i = R(null), a = D(() => {
			if (n.error !== void 0) return n.error;
			let e = i.value;
			return e ? e.hasError || e.errorMessages && e.errorMessages.length > 0 || e.isValid === !1 : !1;
		});
		function o() {
			i.value?.focus && i.value.focus();
		}
		return t({
			fieldRef: i,
			fieldId: r,
			hasError: a,
			focusField: o
		}), (t, n) => e.labelPlacement === "left" ? (L(), O(dn, {
			key: 0,
			class: "d-flex"
		}, {
			default: W(() => [j("div", li, [N(ci, {
				label: e.label,
				icon: e.icon,
				"icon-color": e.iconColor,
				"icon-size": e.iconSize,
				"label-color": e.labelColor,
				"label-weight": e.labelWeight,
				"error-color": e.errorColor,
				required: e.required,
				error: a.value,
				"field-id": H(r),
				shrink: !0
			}, null, 8, [
				"label",
				"icon",
				"icon-color",
				"icon-size",
				"label-color",
				"label-weight",
				"error-color",
				"required",
				"error",
				"field-id"
			]), j("div", { class: I({ "px-6": e.indent }) }, [B(t.$slots, "default", at(Qe({
				id: H(r),
				"aria-required": e.required,
				"aria-label": e.ariaLabel || e.label
			})), void 0, !0)], 2)])]),
			_: 3
		})) : (L(), O(dn, {
			key: 1,
			class: "d-flex flex-column"
		}, {
			default: W(() => [e.icon || e.label ? (L(), A("div", ui, [N(ci, {
				label: e.label,
				icon: e.icon,
				"icon-color": e.iconColor,
				"icon-size": e.iconSize,
				"label-color": e.labelColor,
				"label-weight": e.labelWeight,
				"error-color": e.errorColor,
				required: e.required,
				error: a.value,
				"field-id": H(r)
			}, null, 8, [
				"label",
				"icon",
				"icon-color",
				"icon-size",
				"label-color",
				"label-weight",
				"error-color",
				"required",
				"error",
				"field-id"
			])])) : k("", !0), j("div", { class: I(["mt-0", { "px-6": e.indent }]) }, [B(t.$slots, "default", at(Qe({
				id: H(r),
				"aria-required": e.required,
				"aria-label": e.ariaLabel || e.label
			})), void 0, !0)], 2)]),
			_: 3
		}));
	}
}), [["__scopeId", "data-v-ab1ffdac"]]), fi = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HFormText",
	inheritAttrs: !1
}, {
	__name: "form-text",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "default"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["keydown:enter", "keydown:esc"],
	setup(e, { expose: t, emit: n }) {
		let r = n, i = yt(), a = G(e, "HFormText"), o = R(null), s = R(null), { handleKeydown: c, focus: l } = Wt(o, s, i, r, "input");
		function u() {
			return (o.value?.$el ?? o.value)?.querySelector?.("input")?.value ?? "";
		}
		return t({
			fieldRef: o,
			focus: l,
			getValue: u
		}), (t, n) => (L(), O(di, {
			ref_key: "formFieldRef",
			ref: s,
			label: H(a).variant === "filled" ? void 0 : e.label,
			icon: H(a).variant === "filled" ? void 0 : e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: W((n) => [N(hn, F({
				ref_key: "fieldRef",
				ref: o
			}, {
				...n,
				...t.$attrs,
				label: H(a).variant === "filled" ? e.label : void 0,
				prependInnerIcon: H(a).variant === "filled" ? e.icon : void 0,
				variant: H(a).variant,
				bgColor: H(a).bgColor,
				color: H(a).color,
				baseColor: H(a).baseColor,
				rounded: H(a).rounded,
				density: H(a).density,
				hideDetails: H(a).hideDetails,
				persistentHint: H(a).persistentHint
			}, { onKeydown: H(c) }), Ye({ _: 2 }, [t.$slots["append-inner"] ? {
				name: "append-inner",
				fn: W((e) => [B(t.$slots, "append-inner", at(Qe(e || {})), void 0, !0)]),
				key: "0"
			} : void 0]), 1040, ["onKeydown"])]),
			_: 3
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-8de0626f"]]), pi = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HFormSelect",
	inheritAttrs: !1
}, {
	__name: "form-select",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "default"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		items: {
			type: Array,
			default: () => []
		},
		multiple: {
			type: Boolean,
			default: !1
		},
		chips: {
			type: Boolean,
			default: !1
		},
		closableChips: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["keydown:enter", "keydown:esc"],
	setup(e, { expose: t, emit: n }) {
		let r = n, i = yt(), a = G(e, "HFormSelect"), o = R(null), s = R(null), { handleKeydown: c, focus: l } = Wt(o, s, i, r, "select");
		return t({
			fieldRef: o,
			focus: l
		}), (t, n) => (L(), O(di, {
			ref_key: "formFieldRef",
			ref: s,
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: W((e) => [N(gn, F({
				ref_key: "fieldRef",
				ref: o
			}, {
				...e,
				...t.$attrs,
				variant: H(a).variant,
				bgColor: H(a).bgColor,
				color: H(a).color,
				baseColor: H(a).baseColor,
				rounded: H(a).rounded,
				density: H(a).density,
				hideDetails: H(a).hideDetails,
				persistentHint: H(a).persistentHint,
				items: H(a).items,
				multiple: H(a).multiple,
				chips: H(a).chips,
				closableChips: H(a).closableChips
			}, { onKeydown: H(c) }), Ye({ _: 2 }, [z(t.$slots, (e, n) => ({
				name: n,
				fn: W((e) => [B(t.$slots, n, at(Qe(e || {})), void 0, !0)])
			}))]), 1040, ["onKeydown"])]),
			_: 3
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-86dc11fd"]]), mi = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HFormAutocomplete",
	inheritAttrs: !1
}, {
	__name: "form-autocomplete",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "default"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		items: {
			type: Array,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: !1
		},
		multiple: {
			type: Boolean,
			default: !1
		},
		chips: {
			type: Boolean,
			default: !1
		},
		closableChips: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["keydown:enter", "keydown:esc"],
	setup(e, { expose: t, emit: n }) {
		let r = n, i = yt(), a = G(e, "HFormAutocomplete"), o = R(null), s = R(null), { handleKeydown: c, focus: l } = Wt(o, s, i, r, "autocomplete");
		return t({
			fieldRef: o,
			focus: l
		}), (t, n) => (L(), O(di, {
			ref_key: "formFieldRef",
			ref: s,
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: W((e) => [N(_n, F({
				ref_key: "fieldRef",
				ref: o
			}, {
				...e,
				...t.$attrs,
				variant: H(a).variant,
				bgColor: H(a).bgColor,
				color: H(a).color,
				baseColor: H(a).baseColor,
				rounded: H(a).rounded,
				density: H(a).density,
				hideDetails: H(a).hideDetails,
				persistentHint: H(a).persistentHint,
				items: H(a).items,
				loading: H(a).loading,
				multiple: H(a).multiple,
				chips: H(a).chips,
				closableChips: H(a).closableChips
			}, { onKeydown: H(c) }), Ye({ _: 2 }, [z(t.$slots, (e, n) => ({
				name: n,
				fn: W((e) => [B(t.$slots, n, at(Qe(e || {})), void 0, !0)])
			}))]), 1040, ["onKeydown"])]),
			_: 3
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-4bc6de4f"]]), hi = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HFormCombobox",
	inheritAttrs: !1
}, {
	__name: "form-combobox",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "default"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		items: {
			type: Array,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: !1
		},
		multiple: {
			type: Boolean,
			default: !1
		},
		chips: {
			type: Boolean,
			default: !1
		},
		closableChips: {
			type: Boolean,
			default: !1
		},
		validateOn: {
			type: String,
			default: "blur"
		}
	},
	emits: ["keydown:enter", "keydown:esc"],
	setup(e, { expose: t, emit: n }) {
		let r = n, i = yt(), a = G(e, "HFormCombobox"), o = R(null), s = R(null), { handleKeydown: c, focus: l } = Wt(o, s, i, r, "combobox");
		return t({
			fieldRef: o,
			focus: l
		}), (t, n) => (L(), O(di, {
			ref_key: "formFieldRef",
			ref: s,
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: W((e) => [N(vn, F({
				ref_key: "fieldRef",
				ref: o
			}, {
				...e,
				...t.$attrs,
				validateOn: H(a).validateOn,
				variant: H(a).variant,
				bgColor: H(a).bgColor,
				color: H(a).color,
				baseColor: H(a).baseColor,
				rounded: H(a).rounded,
				density: H(a).density,
				hideDetails: H(a).hideDetails,
				persistentHint: H(a).persistentHint,
				items: H(a).items,
				loading: H(a).loading,
				multiple: H(a).multiple,
				chips: H(a).chips,
				closableChips: H(a).closableChips
			}, { onKeydown: H(c) }), Ye({ _: 2 }, [z(t.$slots, (e, n) => ({
				name: n,
				fn: W((e) => [B(t.$slots, n, at(Qe(e || {})), void 0, !0)])
			}))]), 1040, ["onKeydown"])]),
			_: 3
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-3273b534"]]), gi = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HFormTextarea",
	inheritAttrs: !1
}, {
	__name: "form-textarea",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "default"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		autoGrow: {
			type: Boolean,
			default: !1
		},
		rows: {
			type: [Number, String],
			default: 3
		}
	},
	emits: ["keydown:enter", "keydown:esc"],
	setup(e, { expose: t, emit: n }) {
		let r = n, i = yt(), a = G(e, "HFormTextarea"), o = R(null), s = R(null), { handleKeydown: c, focus: l } = Wt(o, s, i, r, "textarea");
		return t({
			fieldRef: o,
			focus: l
		}), (t, n) => (L(), O(di, {
			ref_key: "formFieldRef",
			ref: s,
			label: H(a).variant === "filled" ? void 0 : e.label,
			icon: H(a).variant === "filled" ? void 0 : e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: W((n) => [N(yn, F({
				ref_key: "fieldRef",
				ref: o
			}, {
				...n,
				...t.$attrs,
				label: H(a).variant === "filled" ? e.label : void 0,
				prependInnerIcon: H(a).variant === "filled" ? e.icon : void 0,
				variant: H(a).variant,
				bgColor: H(a).bgColor,
				color: H(a).color,
				baseColor: H(a).baseColor,
				rounded: H(a).rounded,
				density: H(a).density,
				hideDetails: H(a).hideDetails,
				persistentHint: H(a).persistentHint,
				autoGrow: H(a).autoGrow,
				rows: H(a).rows
			}, { onKeydown: H(c) }), null, 16, ["onKeydown"])]),
			_: 1
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-dba304d3"]]), _i = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HFormSwitch",
	inheritAttrs: !1
}, {
	__name: "form-switch",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		color: {
			type: String,
			default: "primary"
		},
		baseColor: {
			type: String,
			default: "neutral-70"
		},
		density: {
			type: String,
			default: "default"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		inset: {
			type: Boolean,
			default: !1
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		labelPlacement: {
			type: String,
			default: "top",
			validator: (e) => ["top", "left"].includes(e)
		}
	},
	setup(e, { expose: t }) {
		let n = G(e, "HFormSwitch"), r = R(null);
		return t({
			fieldRef: r,
			focus: () => r.value?.focus()
		}), (t, i) => (L(), O(di, {
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel,
			"label-placement": e.labelPlacement
		}, {
			default: W((e) => [N(bn, F({
				ref_key: "fieldRef",
				ref: r
			}, {
				...e,
				...t.$attrs,
				color: H(n).color,
				baseColor: H(n).baseColor,
				density: H(n).density,
				hideDetails: H(n).hideDetails,
				persistentHint: H(n).persistentHint,
				inset: H(n).inset,
				disabled: H(n).disabled
			}), null, 16)]),
			_: 1
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label",
			"label-placement"
		]));
	}
}), [["__scopeId", "data-v-037a9dc4"]]), vi = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HFormDatePicker",
	inheritAttrs: !1
}, {
	__name: "form-date-picker",
	props: {
		modelValue: {
			type: [
				String,
				Number,
				Date,
				Array
			],
			default: null
		},
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "comfortable"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		pickerColor: {
			type: String,
			default: "primary"
		},
		pickerBgColor: {
			type: String,
			default: "surface"
		},
		pickerHeader: {
			type: String,
			default: void 0
		},
		pickerTitle: {
			type: String,
			default: void 0
		},
		hideHeader: {
			type: Boolean,
			default: !0
		},
		hideActions: {
			type: Boolean,
			default: !1
		},
		showAdjacentMonths: {
			type: Boolean,
			default: !1
		},
		showWeek: {
			type: Boolean,
			default: !1
		},
		multiple: {
			type: [
				Boolean,
				Number,
				String
			],
			default: !1
		},
		min: {
			type: [
				String,
				Number,
				Date
			],
			default: void 0
		},
		max: {
			type: [
				String,
				Number,
				Date
			],
			default: void 0
		},
		allowedDates: {
			type: [Array, Function],
			default: void 0
		},
		dateFormat: {
			type: Function,
			default: (e) => {
				if (!e) return "";
				let t = new Date(e);
				return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
			}
		},
		menuTransition: {
			type: String,
			default: "scale-transition"
		},
		menuLocation: {
			type: String,
			default: "bottom"
		},
		menuMinWidth: {
			type: String,
			default: "auto"
		},
		clearable: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		let r = n, i = G(e, "HFormDatePicker"), a = R(null), o = R(!1), s = R(i.modelValue);
		U(() => i.modelValue, (e) => {
			s.value = e;
		});
		let c = D(() => s.value ? Array.isArray(s.value) ? s.value.map((e) => i.dateFormat(e)).join(", ") : i.dateFormat(s.value) : ""), l = (e) => {
			s.value = e, r("update:modelValue", e), i.multiple || (o.value = !1);
		}, u = () => {
			s.value = null, r("update:modelValue", null), o.value = !1;
		};
		return t({
			fieldRef: a,
			focus: () => a.value?.focus(),
			clear: u
		}), (t, n) => (L(), O(Sn, {
			modelValue: o.value,
			"onUpdate:modelValue": n[1] ||= (e) => o.value = e,
			"close-on-content-click": !1,
			transition: e.menuTransition,
			location: e.menuLocation,
			"min-width": e.menuMinWidth
		}, {
			activator: W(({ props: n }) => [N(fi, F({
				ref_key: "fieldRef",
				ref: a
			}, {
				...n,
				...t.$attrs
			}, {
				"model-value": c.value,
				label: e.label,
				icon: e.icon,
				"icon-color": e.iconColor,
				"icon-size": e.iconSize,
				required: e.required,
				error: e.error,
				"aria-label": e.ariaLabel,
				variant: e.variant,
				"bg-color": e.bgColor,
				color: e.color,
				"base-color": e.baseColor,
				rounded: e.rounded,
				density: e.density,
				"hide-details": e.hideDetails,
				class: { "h-form-date-picker--has-clear": e.clearable && c.value },
				readonly: ""
			}), Ye({ _: 2 }, [e.clearable && c.value ? {
				name: "append-inner",
				fn: W(() => [N(q, {
					class: "h-form-date-picker-clear",
					icon: "",
					variant: "text",
					size: "small",
					"aria-label": H(K)("clear"),
					onClick: Dt(u, ["stop", "prevent"])
				}, {
					default: W(() => [N(J, {
						icon: "mdi:mdi-close",
						size: "small"
					})]),
					_: 1
				}, 8, ["aria-label"])]),
				key: "0"
			} : void 0]), 1040, [
				"model-value",
				"label",
				"icon",
				"icon-color",
				"icon-size",
				"required",
				"error",
				"aria-label",
				"variant",
				"bg-color",
				"color",
				"base-color",
				"rounded",
				"density",
				"hide-details",
				"class"
			])]),
			default: W(() => [N(xn, {
				modelValue: s.value,
				"onUpdate:modelValue": [n[0] ||= (e) => s.value = e, l],
				color: e.pickerColor,
				"bg-color": e.pickerBgColor,
				header: e.pickerHeader,
				title: e.pickerTitle,
				"hide-header": e.hideHeader,
				"hide-actions": e.hideActions,
				"show-adjacent-months": e.showAdjacentMonths,
				"show-week": e.showWeek,
				multiple: e.multiple,
				min: e.min,
				max: e.max,
				"allowed-dates": e.allowedDates
			}, Ye({ _: 2 }, [z(t.$slots, (e, n) => ({
				name: n,
				fn: W((e) => [B(t.$slots, n, at(Qe(e || {})), void 0, !0)])
			}))]), 1032, [
				"modelValue",
				"color",
				"bg-color",
				"header",
				"title",
				"hide-header",
				"hide-actions",
				"show-adjacent-months",
				"show-week",
				"multiple",
				"min",
				"max",
				"allowed-dates"
			])]),
			_: 3
		}, 8, [
			"modelValue",
			"transition",
			"location",
			"min-width"
		]));
	}
}), [["__scopeId", "data-v-4d6c29eb"]]);
//#endregion
//#region src/components/composed/form/date-value.js
function yi(e) {
	return String(e).padStart(2, "0");
}
function bi(e) {
	return e.includes("Z") || e.includes("z") || e.includes("+") ? !0 : e.lastIndexOf("-") > 10;
}
function xi(e) {
	if (e == null || e === "") return null;
	if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
	if (typeof e == "number") {
		let t = new Date(e);
		return Number.isNaN(t.getTime()) ? null : t;
	}
	if (typeof e != "string") {
		let t = new Date(e);
		return Number.isNaN(t.getTime()) ? null : t;
	}
	if (e.length === 10 && e[4] === "-" && e[7] === "-") {
		let t = new Date(Number(e.slice(0, 4)), Number(e.slice(5, 7)) - 1, Number(e.slice(8, 10)));
		return Number.isNaN(t.getTime()) ? null : t;
	}
	let t = e[10];
	if ((t === " " || t === "T") && e.length >= 16 && !bi(e)) {
		let t = e.length >= 19 && e[16] === ":" ? Number(e.slice(17, 19)) : 0, n = new Date(Number(e.slice(0, 4)), Number(e.slice(5, 7)) - 1, Number(e.slice(8, 10)), Number(e.slice(11, 13)), Number(e.slice(14, 16)), Number.isFinite(t) ? t : 0);
		return Number.isNaN(n.getTime()) ? null : n;
	}
	let n = new Date(e);
	return Number.isNaN(n.getTime()) ? null : n;
}
function Si(e, t) {
	let n = xi(e) ?? /* @__PURE__ */ new Date(), r = new Date(n.getTime()), [i, a, o] = (typeof t == "string" && t ? t : "00:00").split(":").map((e) => Number(e));
	return r.setHours(Number.isFinite(i) ? i : 0, Number.isFinite(a) ? a : 0, Number.isFinite(o) ? o : 0, 0), r;
}
function Ci(e) {
	let t = xi(e);
	return t ? `${`${t.getFullYear()}-${yi(t.getMonth() + 1)}-${yi(t.getDate())}`} ${yi(t.getHours())}:${yi(t.getMinutes())}` : "";
}
function wi(e) {
	let t = xi(e);
	return t ? `${t.getFullYear()}-${yi(t.getMonth() + 1)}-${yi(t.getDate())}` : "";
}
//#endregion
//#region src/components/composed/form/form-date-time-picker.vue
var Ti = { class: "h-form-date-time-picker-menu" }, Ei = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HFormDateTimePicker",
	inheritAttrs: !1
}, {
	__name: "form-date-time-picker",
	props: {
		modelValue: {
			type: [
				String,
				Number,
				Date
			],
			default: null
		},
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "comfortable"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		pickerColor: {
			type: String,
			default: "primary"
		},
		pickerBgColor: {
			type: String,
			default: "surface"
		},
		pickerHeader: {
			type: String,
			default: void 0
		},
		pickerTitle: {
			type: String,
			default: void 0
		},
		hideHeader: {
			type: Boolean,
			default: !0
		},
		showAdjacentMonths: {
			type: Boolean,
			default: !1
		},
		showWeek: {
			type: Boolean,
			default: !1
		},
		min: {
			type: [
				String,
				Number,
				Date
			],
			default: void 0
		},
		max: {
			type: [
				String,
				Number,
				Date
			],
			default: void 0
		},
		allowedDates: {
			type: [Array, Function],
			default: void 0
		},
		menuTransition: {
			type: String,
			default: "scale-transition"
		},
		menuLocation: {
			type: String,
			default: "bottom"
		},
		menuMinWidth: {
			type: String,
			default: "328px"
		},
		clearable: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		let r = n, i = G(e, "HFormDateTimePicker"), a = R(null), o = R(!1), s = R("date"), c = R(i.modelValue), l = R(xi(i.modelValue)), u = R(null);
		U(() => i.modelValue, (e) => {
			c.value = e, s.value === "date" && (l.value = xi(e));
		}), U(o, (e) => {
			e || m();
		});
		let d = D(() => l.value ?? xi(c.value)), f = D(() => wi(l.value ?? c.value)), p = D(() => Ci(c.value));
		function m() {
			s.value = "date", l.value = xi(c.value), u.value = null;
		}
		function h(e) {
			e && (l.value = xi(e) ?? e, u.value = null, s.value = "time");
		}
		function g(e) {
			if (!e) return;
			let t = Si(l.value ?? c.value, e);
			c.value = t, r("update:modelValue", t), o.value = !1, m();
		}
		function _() {
			u.value = null, s.value = "date";
		}
		function v() {
			c.value = null, l.value = null, u.value = null, s.value = "date", r("update:modelValue", null), o.value = !1;
		}
		return t({
			fieldRef: a,
			focus: () => a.value?.focus?.(),
			clear: v
		}), (t, n) => (L(), O(Sn, {
			modelValue: o.value,
			"onUpdate:modelValue": n[0] ||= (e) => o.value = e,
			"close-on-content-click": !1,
			transition: e.menuTransition,
			location: e.menuLocation,
			"min-width": e.menuMinWidth,
			"max-width": e.menuMinWidth
		}, {
			activator: W(({ props: n }) => [N(fi, F({
				ref_key: "fieldRef",
				ref: a
			}, {
				...n,
				...t.$attrs
			}, {
				"model-value": p.value,
				label: e.label,
				icon: e.icon,
				"icon-color": e.iconColor,
				"icon-size": e.iconSize,
				required: e.required,
				error: e.error,
				"aria-label": e.ariaLabel,
				variant: e.variant,
				"bg-color": e.bgColor,
				color: e.color,
				"base-color": e.baseColor,
				rounded: e.rounded,
				density: e.density,
				"hide-details": e.hideDetails,
				class: { "h-form-date-time-picker--has-clear": e.clearable && p.value },
				readonly: ""
			}), Ye({ _: 2 }, [e.clearable && p.value ? {
				name: "append-inner",
				fn: W(() => [N(q, {
					class: "h-form-date-time-picker-clear",
					icon: "",
					variant: "text",
					size: "small",
					"aria-label": H(K)("clear"),
					onClick: Dt(v, ["stop", "prevent"])
				}, {
					default: W(() => [N(J, {
						icon: "mdi:mdi-close",
						size: "small"
					})]),
					_: 1
				}, 8, ["aria-label"])]),
				key: "0"
			} : void 0]), 1040, [
				"model-value",
				"label",
				"icon",
				"icon-color",
				"icon-size",
				"required",
				"error",
				"aria-label",
				"variant",
				"bg-color",
				"color",
				"base-color",
				"rounded",
				"density",
				"hide-details",
				"class"
			])]),
			default: W(() => [j("div", Ti, [s.value === "date" ? (L(), O(xn, {
				key: 0,
				"model-value": d.value,
				color: e.pickerColor,
				"bg-color": e.pickerBgColor,
				header: e.pickerHeader,
				title: e.pickerTitle,
				"hide-header": e.hideHeader,
				"hide-actions": "",
				"show-adjacent-months": e.showAdjacentMonths,
				"show-week": e.showWeek,
				min: e.min,
				max: e.max,
				"allowed-dates": e.allowedDates,
				"onUpdate:modelValue": h
			}, Ye({ _: 2 }, [z(t.$slots, (e, n) => ({
				name: n,
				fn: W((e) => [B(t.$slots, n, at(Qe(e || {})), void 0, !0)])
			}))]), 1032, [
				"model-value",
				"color",
				"bg-color",
				"header",
				"title",
				"hide-header",
				"show-adjacent-months",
				"show-week",
				"min",
				"max",
				"allowed-dates"
			])) : s.value === "time" ? (L(), A(E, { key: 1 }, [N(q, {
				class: "h-form-date-time-picker-back",
				variant: "text",
				"prepend-icon": "mdi:mdi-chevron-left",
				"aria-label": H(K)("back"),
				onClick: _
			}, {
				default: W(() => [M(V(f.value), 1)]),
				_: 1
			}, 8, ["aria-label"]), N(Cn, {
				class: "h-form-date-time-picker-time",
				"model-value": u.value,
				color: e.pickerColor,
				"bg-color": e.pickerBgColor,
				format: "24hr",
				"hide-header": "",
				"onUpdate:modelValue": g
			}, null, 8, [
				"model-value",
				"color",
				"bg-color"
			])], 64)) : k("", !0)])]),
			_: 3
		}, 8, [
			"modelValue",
			"transition",
			"location",
			"min-width",
			"max-width"
		]));
	}
}), [["__scopeId", "data-v-09a981a0"]]), Di = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HFormOtpInput",
	inheritAttrs: !1
}, {
	__name: "form-otp-input",
	props: {
		modelValue: {
			type: String,
			default: ""
		},
		length: {
			type: Number,
			default: 6,
			validator: (e) => e > 0 && e <= 12
		},
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: void 0
		},
		required: {
			type: Boolean,
			default: !1
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "filled"
		},
		density: {
			type: String,
			default: "comfortable"
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: !1
		},
		hideDetails: {
			type: Boolean,
			default: !0
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		gap: {
			type: String,
			default: "4px"
		},
		customDefaults: {
			type: Object,
			default: void 0
		}
	},
	emits: ["update:modelValue", "complete"],
	setup(e, { expose: t, emit: n }) {
		let r = n;
		yt();
		let i = G(e, "HFormOtpInput"), a = R(null), o = R([]), s = (e, t) => {
			e && (o.value[t] = e);
		}, c = R(Array(i.length).fill("")), l = D(() => i.gap);
		U(() => i.modelValue, (e) => {
			let t = (e || "").split("").slice(0, i.length);
			c.value = [...t, ...Array(i.length - t.length).fill("")];
		}, { immediate: !0 }), U(c, (e) => {
			let t = e.join("");
			r("update:modelValue", t), t.length === i.length && !t.includes("") && r("complete", t);
		}, { deep: !0 });
		let u = (e, t) => {
			let n = t.target.value;
			n && (c.value[e] = n.slice(-1), e < i.length - 1 && _(e + 1));
		}, d = (e, t) => {
			!c.value[e] && e > 0 ? (t.preventDefault(), c.value[e - 1] = "", _(e - 1)) : c.value[e] && (c.value[e] = "");
		}, f = (e) => {
			c.value[e] = "";
		}, p = (e) => {
			e > 0 && _(e - 1);
		}, m = (e) => {
			e < i.length - 1 && _(e + 1);
		}, h = (e, t) => {
			t.preventDefault();
			let n = t.clipboardData.getData("text").trim();
			if (n) {
				let t = n.split("").slice(0, i.length - e);
				t.forEach((t, n) => {
					e + n < i.length && /^[a-zA-Z0-9]$/.test(t) && (c.value[e + n] = t);
				});
				let r = c.value.findIndex((t, n) => n >= e && !t);
				_(r === -1 ? Math.min(e + t.length, i.length - 1) : r);
			}
		}, g = (e) => {
			it(() => {
				let t = v(e);
				t && t.select();
			});
		}, _ = (e) => {
			it(() => {
				let t = v(e);
				t && t.focus();
			});
		}, v = (e) => {
			let t = o.value[e];
			return t ? t.$el?.querySelector("input") : null;
		};
		return t({
			clear: () => {
				c.value = Array(i.length).fill(""), _(0);
			},
			focus: () => {
				_(0);
			},
			formFieldRef: a
		}), (t, n) => (L(), O(di, {
			ref_key: "formFieldRef",
			ref: a,
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: W(() => [j("div", {
				class: "h-form-otp-input d-flex",
				style: ot({ gap: l.value })
			}, [(L(!0), A(E, null, z(c.value, (t, n) => (L(), O(hn, {
				key: n,
				ref_for: !0,
				ref: (e) => s(e, n),
				modelValue: c.value[n],
				"onUpdate:modelValue": (e) => c.value[n] = e,
				variant: e.variant,
				density: e.density,
				disabled: e.disabled,
				error: e.error,
				"hide-details": e.hideDetails,
				"persistent-hint": e.persistentHint,
				color: "primary",
				class: "h-form-otp-input__field",
				maxlength: "1",
				onInput: (e) => u(n, e),
				onKeydown: [
					Et((e) => d(n, e), ["backspace"]),
					Et((e) => f(n), ["delete"]),
					Et((e) => p(n), ["left"]),
					Et((e) => m(n), ["right"])
				],
				onPaste: (e) => h(n, e),
				onFocus: (e) => g(n)
			}, null, 8, [
				"modelValue",
				"onUpdate:modelValue",
				"variant",
				"density",
				"disabled",
				"error",
				"hide-details",
				"persistent-hint",
				"onInput",
				"onKeydown",
				"onPaste",
				"onFocus"
			]))), 128))], 4)]),
			_: 1
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-c6033d1d"]]), Oi = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HFormPassword",
	inheritAttrs: !1
}, {
	__name: "form-password",
	props: {
		modelValue: {
			type: String,
			default: ""
		},
		allowEmpty: {
			type: Boolean,
			default: !1
		},
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: "mdi:mdi-lock"
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "on-surface-variant"
		},
		rounded: {
			type: [
				Boolean,
				String,
				Number
			],
			default: void 0
		},
		density: {
			type: String,
			default: "comfortable"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		passwordLabel: {
			type: String,
			default: void 0
		},
		confirmLabel: {
			type: String,
			default: void 0
		},
		minPasswordLength: {
			type: Number,
			default: 8
		},
		id: {
			type: String,
			default: void 0
		},
		disableAutofill: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		let r = `password-confirm-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`, i = G(e, "HFormPassword"), a = n, o = D(() => i.disableAutofill ? {
			autocomplete: "new-password",
			"data-1p-ignore": !0,
			"data-lpignore": "true"
		} : {}), s = i.id || r, c = `${s}-password`, l = `${s}-confirm`, u = R(null), d = R(null), f = R(""), p = R(""), m = R(!1), h = R(!1), g = R(!1), _ = R(void 0);
		U(() => i.modelValue, (e) => {
			e !== _.value && (g.value = !0, i.allowEmpty && e ? (f.value = "", p.value = "") : (f.value = e || "", p.value = ""), it(() => {
				g.value = !1;
			}));
		}, { immediate: !0 });
		let v = D(() => {
			let e = [];
			return i.required && !i.allowEmpty && e.push((e) => !!e || K("password_required")), f.value && f.value.length > 0 && e.push((e) => e && e.length >= i.minPasswordLength || K("password_min_length", { length: i.minPasswordLength })), e;
		}), y = D(() => {
			let e = [];
			return f.value && (e.push((e) => !!e || K("confirm_password_required")), e.push((e) => e === f.value || K("passwords_must_match"))), e;
		});
		return U([f, p], ([e, t]) => {
			g.value || e === t && (_.value = e, a("update:modelValue", e));
		}), t({
			passwordFieldRef: u,
			confirmFieldRef: d,
			focus: () => u.value?.focus()
		}), (t, n) => (L(), O(di, {
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: W((t) => [N(pn, null, {
				default: W(() => [N(dn, { cols: "12" }, {
					default: W(() => [N(hn, F({
						id: c,
						ref_key: "passwordFieldRef",
						ref: u,
						modelValue: f.value,
						"onUpdate:modelValue": n[3] ||= (e) => f.value = e,
						type: m.value ? "text" : "password",
						placeholder: e.allowEmpty && !f.value ? "••••••" : "",
						label: e.passwordLabel,
						variant: e.variant,
						"bg-color": e.bgColor,
						color: e.color,
						"base-color": e.baseColor,
						rounded: e.rounded,
						density: e.density,
						"hide-details": e.hideDetails,
						"persistent-hint": e.persistentHint,
						disabled: e.disabled,
						rules: v.value
					}, {
						...t,
						...o.value
					}), {
						"append-inner": W(() => [N(J, {
							icon: m.value ? "mdi:mdi-eye-off" : "mdi:mdi-eye",
							role: "button",
							tabindex: "0",
							"aria-label": H(K)("toggle_password_visibility"),
							class: "cursor-pointer",
							onClick: n[0] ||= (e) => m.value = !m.value,
							onKeydown: [n[1] ||= Et((e) => m.value = !m.value, ["enter"]), n[2] ||= Et(Dt((e) => m.value = !m.value, ["prevent"]), ["space"])]
						}, null, 8, ["icon", "aria-label"])]),
						_: 1
					}, 16, [
						"modelValue",
						"type",
						"placeholder",
						"label",
						"variant",
						"bg-color",
						"color",
						"base-color",
						"rounded",
						"density",
						"hide-details",
						"persistent-hint",
						"disabled",
						"rules"
					])]),
					_: 2
				}, 1024), N(dn, { cols: "12" }, {
					default: W(() => [N(hn, F({
						id: l,
						ref_key: "confirmFieldRef",
						ref: d,
						modelValue: p.value,
						"onUpdate:modelValue": n[5] ||= (e) => p.value = e,
						type: h.value ? "text" : "password",
						label: e.confirmLabel,
						variant: e.variant,
						"bg-color": e.bgColor,
						color: e.color,
						"base-color": e.baseColor,
						rounded: e.rounded,
						density: e.density,
						"hide-details": e.hideDetails,
						"persistent-hint": e.persistentHint,
						disabled: e.disabled,
						rules: y.value
					}, {
						...t,
						...o.value
					}), {
						"append-inner": W(() => [N(J, {
							icon: h.value ? "mdi:mdi-eye-off" : "mdi:mdi-eye",
							role: "button",
							tabindex: "0",
							"aria-label": H(K)("toggle_password_visibility"),
							class: "cursor-pointer",
							onClick: n[4] ||= (e) => h.value = !h.value
						}, null, 8, ["icon", "aria-label"])]),
						_: 1
					}, 16, [
						"modelValue",
						"type",
						"label",
						"variant",
						"bg-color",
						"color",
						"base-color",
						"rounded",
						"density",
						"hide-details",
						"persistent-hint",
						"disabled",
						"rules"
					])]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024)]),
			_: 1
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-68d82515"]]), ki = (e) => {
	let { state: t } = e, n = t.doc.lineAt(t.selection.main.from), r = Pi(e.state, n.from);
	return r.line ? ji(e) : r.block ? Ni(e) : !1;
};
function Ai(e, t) {
	return ({ state: n, dispatch: r }) => {
		if (n.readOnly) return !1;
		let i = e(t, n);
		return i ? (r(n.update(i)), !0) : !1;
	};
}
var ji = /*@__PURE__*/ Ai(zi, 0), Mi = /*@__PURE__*/ Ai(Ri, 0), Ni = /*@__PURE__*/ Ai((e, t) => Ri(e, t, Li(t)), 0);
function Pi(e, t) {
	let n = e.languageDataAt("commentTokens", t, 1);
	return n.length ? n[0] : {};
}
var Fi = 50;
function Ii(e, { open: t, close: n }, r, i) {
	let a = e.sliceDoc(r - Fi, r), o = e.sliceDoc(i, i + Fi), s = /\s*$/.exec(a)[0].length, c = /^\s*/.exec(o)[0].length, l = a.length - s;
	if (a.slice(l - t.length, l) == t && o.slice(c, c + n.length) == n) return {
		open: {
			pos: r - s,
			margin: s && 1
		},
		close: {
			pos: i + c,
			margin: c && 1
		}
	};
	let u, d;
	i - r <= 2 * Fi ? u = d = e.sliceDoc(r, i) : (u = e.sliceDoc(r, r + Fi), d = e.sliceDoc(i - Fi, i));
	let f = /^\s*/.exec(u)[0].length, p = /\s*$/.exec(d)[0].length, m = d.length - p - n.length;
	return u.slice(f, f + t.length) == t && d.slice(m, m + n.length) == n ? {
		open: {
			pos: r + f + t.length,
			margin: +!!/\s/.test(u.charAt(f + t.length))
		},
		close: {
			pos: i - p - n.length,
			margin: +!!/\s/.test(d.charAt(m - 1))
		}
	} : null;
}
function Li(e) {
	let t = [];
	for (let n of e.selection.ranges) {
		let r = e.doc.lineAt(n.from), i = n.to <= r.to ? r : e.doc.lineAt(n.to);
		i.from > r.from && i.from == n.to && (i = n.to == r.to + 1 ? r : e.doc.lineAt(n.to - 1));
		let a = t.length - 1;
		a >= 0 && t[a].to > r.from ? t[a].to = i.to : t.push({
			from: r.from + /^\s*/.exec(r.text)[0].length,
			to: i.to
		});
	}
	return t;
}
function Ri(e, t, n = t.selection.ranges) {
	let r = n.map((e) => Pi(t, e.from).block);
	if (!r.every((e) => e)) return null;
	let i = n.map((e, n) => Ii(t, r[n], e.from, e.to));
	if (e != 2 && !i.every((e) => e)) return { changes: t.changes(n.map((e, t) => i[t] ? [] : [{
		from: e.from,
		insert: r[t].open + " "
	}, {
		from: e.to,
		insert: " " + r[t].close
	}])) };
	if (e != 1 && i.some((e) => e)) {
		let e = [];
		for (let t = 0, n; t < i.length; t++) if (n = i[t]) {
			let i = r[t], { open: a, close: o } = n;
			e.push({
				from: a.pos - i.open.length,
				to: a.pos + a.margin
			}, {
				from: o.pos - o.margin,
				to: o.pos + i.close.length
			});
		}
		return { changes: e };
	}
	return null;
}
function zi(e, t, n = t.selection.ranges) {
	let r = [], i = -1;
	ranges: for (let { from: e, to: a } of n) {
		let n = r.length, o = 1e9, s;
		for (let n = e; n <= a;) {
			let c = t.doc.lineAt(n);
			if (s == null && (s = Pi(t, c.from).line, !s)) continue ranges;
			if (c.from > i && (e == a || a > c.from)) {
				i = c.from;
				let e = /^\s*/.exec(c.text)[0].length, t = e == c.length, n = c.text.slice(e, e + s.length) == s ? e : -1;
				e < c.text.length && e < o && (o = e), r.push({
					line: c,
					comment: n,
					token: s,
					indent: e,
					empty: t,
					single: !1
				});
			}
			n = c.to + 1;
		}
		if (o < 1e9) for (let e = n; e < r.length; e++) r[e].indent < r[e].line.text.length && (r[e].indent = o);
		r.length == n + 1 && (r[n].single = !0);
	}
	if (e != 2 && r.some((e) => e.comment < 0 && (!e.empty || e.single))) {
		let e = [];
		for (let { line: t, token: n, indent: i, empty: a, single: o } of r) (o || !a) && e.push({
			from: t.from + i,
			insert: n + " "
		});
		let n = t.changes(e);
		return {
			changes: n,
			selection: t.selection.map(n, 1)
		};
	} else if (e != 1 && r.some((e) => e.comment >= 0)) {
		let e = [];
		for (let { line: t, comment: n, token: i } of r) if (n >= 0) {
			let r = t.from + n, a = r + i.length;
			t.text[a - t.from] == " " && a++, e.push({
				from: r,
				to: a
			});
		}
		return { changes: e };
	}
	return null;
}
var Bi = /*@__PURE__*/ Se.define(), Vi = /*@__PURE__*/ Se.define(), Hi = /*@__PURE__*/ ze.define(), Ui = /*@__PURE__*/ ze.define({ combine(e) {
	return g(e, {
		minDepth: 100,
		newGroupDelay: 500,
		joinToEvent: (e, t) => t
	}, {
		minDepth: Math.max,
		newGroupDelay: Math.min,
		joinToEvent: (e, t) => (n, r) => e(n, r) || t(n, r)
	});
} }), Wi = /*@__PURE__*/ _.define({
	create() {
		return la.empty;
	},
	update(e, n) {
		let r = n.state.facet(Ui), i = n.annotation(Bi);
		if (i) {
			let t = Zi.fromTransaction(n, i.selection), a = i.side, o = a == 0 ? e.undone : e.done;
			return o = t ? Qi(o, o.length, r.minDepth, t) : ia(o, n.startState.selection), new la(a == 0 ? i.rest : o, a == 0 ? o : i.rest);
		}
		let a = n.annotation(Vi);
		if ((a == "full" || a == "before") && (e = e.isolate()), n.annotation(t.addToHistory) === !1) return n.changes.empty ? e : e.addMapping(n.changes.desc);
		let o = Zi.fromTransaction(n), s = n.annotation(t.time), c = n.annotation(t.userEvent);
		return o ? e = e.addChanges(o, s, c, r, n) : n.selection && (e = e.addSelection(n.startState.selection, s, c, r.newGroupDelay)), (a == "full" || a == "after") && (e = e.isolate()), e;
	},
	toJSON(e) {
		return {
			done: e.done.map((e) => e.toJSON()),
			undone: e.undone.map((e) => e.toJSON())
		};
	},
	fromJSON(e) {
		return new la(e.done.map(Zi.fromJSON), e.undone.map(Zi.fromJSON));
	}
});
function Gi(e = {}) {
	return [
		Wi,
		Ui.of(e),
		s.domEventHandlers({ beforeinput(e, t) {
			let n = e.inputType == "historyUndo" ? qi : e.inputType == "historyRedo" ? Ji : null;
			return n ? (e.preventDefault(), n(t)) : !1;
		} })
	];
}
function Ki(e, t) {
	return function({ state: n, dispatch: r }) {
		if (!t && n.readOnly) return !1;
		let i = n.field(Wi, !1);
		if (!i) return !1;
		let a = i.pop(e, n, t);
		return a ? (r(a), !0) : !1;
	};
}
var qi = /*@__PURE__*/ Ki(0, !1), Ji = /*@__PURE__*/ Ki(1, !1), Yi = /*@__PURE__*/ Ki(0, !0), Xi = /*@__PURE__*/ Ki(1, !0), Zi = class e {
	constructor(e, t, n, r, i) {
		this.changes = e, this.effects = t, this.mapped = n, this.startSelection = r, this.selectionsAfter = i;
	}
	setSelAfter(t) {
		return new e(this.changes, this.effects, this.mapped, this.startSelection, t);
	}
	toJSON() {
		return {
			changes: this.changes?.toJSON(),
			mapped: this.mapped?.toJSON(),
			startSelection: this.startSelection?.toJSON(),
			selectionsAfter: this.selectionsAfter.map((e) => e.toJSON())
		};
	}
	static fromJSON(t) {
		return new e(t.changes && pe.fromJSON(t.changes), [], t.mapped && he.fromJSON(t.mapped), t.startSelection && Be.fromJSON(t.startSelection), t.selectionsAfter.map(Be.fromJSON));
	}
	static fromTransaction(t, n) {
		let r = na;
		for (let e of t.startState.facet(Hi)) {
			let n = e(t);
			n.length && (r = r.concat(n));
		}
		return !r.length && t.changes.empty ? null : new e(t.changes.invert(t.startState.doc), r, void 0, n || t.startState.selection, na);
	}
	static selection(t) {
		return new e(void 0, na, void 0, void 0, t);
	}
};
function Qi(e, t, n, r) {
	let i = t + 1 > n + 20 ? t - n - 1 : 0, a = e.slice(i, t);
	return a.push(r), a;
}
function $i(e, t) {
	let n = [], r = !1;
	return e.iterChangedRanges((e, t) => n.push(e, t)), t.iterChangedRanges((e, t, i, a) => {
		for (let e = 0; e < n.length;) {
			let t = n[e++], o = n[e++];
			a >= t && i <= o && (r = !0);
		}
	}), r;
}
function ea(e, t) {
	return e.ranges.length == t.ranges.length && e.ranges.filter((e, n) => e.empty != t.ranges[n].empty).length === 0;
}
function ta(e, t) {
	return e.length ? t.length ? e.concat(t) : e : t;
}
var na = [], ra = 200;
function ia(e, t) {
	if (e.length) {
		let n = e[e.length - 1], r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - ra));
		return r.length && r[r.length - 1].eq(t) ? e : (r.push(t), Qi(e, e.length - 1, 1e9, n.setSelAfter(r)));
	} else return [Zi.selection([t])];
}
function aa(e) {
	let t = e[e.length - 1], n = e.slice();
	return n[e.length - 1] = t.setSelAfter(t.selectionsAfter.slice(0, t.selectionsAfter.length - 1)), n;
}
function oa(e, t) {
	if (!e.length) return e;
	let n = e.length, r = na;
	for (; n;) {
		let i = sa(e[n - 1], t, r);
		if (i.changes && !i.changes.empty || i.effects.length) {
			let t = e.slice(0, n);
			return t[n - 1] = i, t;
		} else t = i.mapped, n--, r = i.selectionsAfter;
	}
	return r.length ? [Zi.selection(r)] : na;
}
function sa(e, t, n) {
	let r = ta(e.selectionsAfter.length ? e.selectionsAfter.map((e) => e.map(t)) : na, n);
	if (!e.changes) return Zi.selection(r);
	let i = e.changes.map(t), o = t.mapDesc(e.changes, !0), s = e.mapped ? e.mapped.composeDesc(o) : o;
	return new Zi(i, a.mapEffects(e.effects, t), s, e.startSelection.map(o), r);
}
var ca = /^(input\.type|delete)($|\.)/, la = class e {
	constructor(e, t, n = 0, r = void 0) {
		this.done = e, this.undone = t, this.prevTime = n, this.prevUserEvent = r;
	}
	isolate() {
		return this.prevTime ? new e(this.done, this.undone) : this;
	}
	addChanges(t, n, r, i, o) {
		let s = this.done, c = s[s.length - 1];
		return s = c && c.changes && !c.changes.empty && t.changes && (!r || ca.test(r)) && (!c.selectionsAfter.length && n - this.prevTime < i.newGroupDelay && i.joinToEvent(o, $i(c.changes, t.changes)) || r == "input.type.compose") ? Qi(s, s.length - 1, i.minDepth, new Zi(t.changes.compose(c.changes), ta(a.mapEffects(t.effects, c.changes), c.effects), c.mapped, c.startSelection, na)) : Qi(s, s.length, i.minDepth, t), new e(s, na, n, r);
	}
	addSelection(t, n, r, i) {
		let a = this.done.length ? this.done[this.done.length - 1].selectionsAfter : na;
		return a.length > 0 && n - this.prevTime < i && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && ea(a[a.length - 1], t) ? this : new e(ia(this.done, t), this.undone, n, r);
	}
	addMapping(t) {
		return new e(oa(this.done, t), oa(this.undone, t), this.prevTime, this.prevUserEvent);
	}
	pop(e, t, n) {
		let r = e == 0 ? this.done : this.undone;
		if (r.length == 0) return null;
		let i = r[r.length - 1], a = i.selectionsAfter[0] || (i.startSelection ? i.startSelection.map(i.changes.invertedDesc, 1) : t.selection);
		if (n && i.selectionsAfter.length) return t.update({
			selection: i.selectionsAfter[i.selectionsAfter.length - 1],
			annotations: Bi.of({
				side: e,
				rest: aa(r),
				selection: a
			}),
			userEvent: e == 0 ? "select.undo" : "select.redo",
			scrollIntoView: !0
		});
		if (i.changes) {
			let n = r.length == 1 ? na : r.slice(0, r.length - 1);
			return i.mapped && (n = oa(n, i.mapped)), t.update({
				changes: i.changes,
				selection: i.startSelection,
				effects: i.effects,
				annotations: Bi.of({
					side: e,
					rest: n,
					selection: a
				}),
				filter: !1,
				userEvent: e == 0 ? "undo" : "redo",
				scrollIntoView: !0
			});
		} else return null;
	}
};
la.empty = /*@__PURE__*/ new la(na, na);
var ua = [
	{
		key: "Mod-z",
		run: qi,
		preventDefault: !0
	},
	{
		key: "Mod-y",
		mac: "Mod-Shift-z",
		run: Ji,
		preventDefault: !0
	},
	{
		linux: "Ctrl-Shift-z",
		run: Ji,
		preventDefault: !0
	},
	{
		key: "Mod-u",
		run: Yi,
		preventDefault: !0
	},
	{
		key: "Alt-u",
		mac: "Mod-Shift-u",
		run: Xi,
		preventDefault: !0
	}
];
function da(e, t) {
	return Be.create(e.ranges.map(t), e.mainIndex);
}
function fa(e, t) {
	return e.update({
		selection: t,
		scrollIntoView: !0,
		userEvent: "select"
	});
}
function pa({ state: e, dispatch: t }, n) {
	let r = da(e.selection, n);
	return r.eq(e.selection, !0) ? !1 : (t(fa(e, r)), !0);
}
function ma(e, t) {
	return Be.cursor(t ? e.to : e.from);
}
function ha(e, t) {
	return pa(e, (n) => n.empty ? e.moveByChar(n, t) : ma(n, t));
}
function ga(e) {
	return e.textDirectionAt(e.state.selection.main.head) == T.LTR;
}
var _a = (e) => ha(e, !ga(e)), va = (e) => ha(e, ga(e));
function ya(e, t) {
	return pa(e, (n) => n.empty ? e.moveByGroup(n, t) : ma(n, t));
}
var ba = (e) => ya(e, !ga(e)), xa = (e) => ya(e, ga(e));
typeof Intl < "u" && Intl.Segmenter;
function Sa(e, t, n) {
	if (t.type.prop(n)) return !0;
	let r = t.to - t.from;
	return r && (r > 2 || /[^\s,.;:]/.test(e.sliceDoc(t.from, t.to))) || t.firstChild;
}
function Ca(t, n, r) {
	let a = e(t).resolveInner(n.head), o = r ? c.closedBy : c.openedBy;
	for (let e = n.head;;) {
		let n = r ? a.childAfter(e) : a.childBefore(e);
		if (!n) break;
		Sa(t, n, o) ? a = n : e = r ? n.to : n.from;
	}
	let s = a.type.prop(o), l, u;
	return u = s && (l = r ? i(t, a.from, 1) : i(t, a.to, -1)) && l.matched ? r ? l.end.to : l.end.from : r ? a.to : a.from, Be.cursor(u, r ? -1 : 1);
}
var wa = (e) => pa(e, (t) => Ca(e.state, t, !ga(e))), Ta = (e) => pa(e, (t) => Ca(e.state, t, ga(e)));
function Ea(e, t) {
	return pa(e, (n) => {
		if (!n.empty) return ma(n, t);
		let r = e.moveVertically(n, t);
		return r.head == n.head ? e.moveToLineBoundary(n, t) : r;
	});
}
var Da = (e) => Ea(e, !1), Oa = (e) => Ea(e, !0);
function ka(e) {
	let t = e.scrollDOM.clientHeight < e.scrollDOM.scrollHeight - 2, n = 0, r = 0, i;
	if (t) {
		for (let t of e.state.facet(s.scrollMargins)) {
			let i = t(e);
			i?.top && (n = Math.max(i?.top, n)), i?.bottom && (r = Math.max(i?.bottom, r));
		}
		i = e.scrollDOM.clientHeight - n - r;
	} else i = (e.dom.ownerDocument.defaultView || window).innerHeight;
	return {
		marginTop: n,
		marginBottom: r,
		selfScroll: t,
		height: Math.max(e.defaultLineHeight, i - 5)
	};
}
function Aa(e, t) {
	let n = ka(e), { state: r } = e, i = da(r.selection, (r) => r.empty ? e.moveVertically(r, t, n.height) : ma(r, t));
	if (i.eq(r.selection)) return !1;
	let a;
	if (n.selfScroll) {
		let t = e.coordsAtPos(r.selection.main.head), o = e.scrollDOM.getBoundingClientRect(), c = o.top + n.marginTop, l = o.bottom - n.marginBottom;
		t && t.top > c && t.bottom < l && (a = s.scrollIntoView(i.main.head, {
			y: "start",
			yMargin: t.top - c
		}));
	}
	return e.dispatch(fa(r, i), { effects: a }), !0;
}
var ja = (e) => Aa(e, !1), Ma = (e) => Aa(e, !0);
function Na(e, t, n) {
	let r = e.lineBlockAt(t.head), i = e.moveToLineBoundary(t, n);
	if (i.head == t.head && i.head != (n ? r.to : r.from) && (i = e.moveToLineBoundary(t, n, !1)), !n && i.head == r.from && r.length) {
		let n = /^\s*/.exec(e.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
		n && t.head != r.from + n && (i = Be.cursor(r.from + n));
	}
	return i;
}
var Pa = (e) => pa(e, (t) => Na(e, t, !0)), Fa = (e) => pa(e, (t) => Na(e, t, !1)), Ia = (e) => pa(e, (t) => Na(e, t, !ga(e))), La = (e) => pa(e, (t) => Na(e, t, ga(e))), Ra = (e) => pa(e, (t) => Be.cursor(e.lineBlockAt(t.head).from, 1)), za = (e) => pa(e, (t) => Be.cursor(e.lineBlockAt(t.head).to, -1));
function Ba(e, t, n) {
	let r = !1, a = da(e.selection, (t) => {
		let a = i(e, t.head, -1) || i(e, t.head, 1) || t.head > 0 && i(e, t.head - 1, 1) || t.head < e.doc.length && i(e, t.head + 1, -1);
		if (!a || !a.end) return t;
		r = !0;
		let o = a.start.from == t.head ? a.end.to : a.end.from;
		return n ? Be.range(t.anchor, o) : Be.cursor(o);
	});
	return r ? (t(fa(e, a)), !0) : !1;
}
var Va = ({ state: e, dispatch: t }) => Ba(e, t, !1);
function Ha(e, t, n) {
	let r = da(e.state.selection, (e) => {
		e.undirectional && e.head >= e.anchor != t && (e = Be.range(e.head, e.anchor));
		let r = n(e);
		return Be.range(e.anchor, r.head, r.goalColumn, r.bidiLevel || void 0, r.assoc);
	});
	return r.eq(e.state.selection) ? !1 : (e.dispatch(fa(e.state, r)), !0);
}
function Ua(e, t) {
	return Ha(e, t, (n) => e.moveByChar(n, t));
}
var Wa = (e) => Ua(e, !ga(e)), Ga = (e) => Ua(e, ga(e));
function Ka(e, t) {
	return Ha(e, t, (n) => e.moveByGroup(n, t));
}
var qa = (e) => Ka(e, !ga(e)), Ja = (e) => Ka(e, ga(e)), Ya = (e) => {
	let t = !ga(e);
	return Ha(e, t, (n) => Ca(e.state, n, t));
}, Xa = (e) => {
	let t = ga(e);
	return Ha(e, t, (n) => Ca(e.state, n, t));
};
function Za(e, t) {
	return Ha(e, t, (n) => e.moveVertically(n, t));
}
var Qa = (e) => Za(e, !1), $a = (e) => Za(e, !0);
function eo(e, t) {
	return Ha(e, t, (n) => e.moveVertically(n, t, ka(e).height));
}
var to = (e) => eo(e, !1), no = (e) => eo(e, !0), ro = (e) => Ha(e, !0, (t) => Na(e, t, !0)), io = (e) => Ha(e, !1, (t) => Na(e, t, !1)), ao = (e) => {
	let t = !ga(e);
	return Ha(e, t, (n) => Na(e, n, t));
}, oo = (e) => {
	let t = ga(e);
	return Ha(e, t, (n) => Na(e, n, t));
}, so = (e) => Ha(e, !1, (t) => Be.cursor(e.lineBlockAt(t.head).from)), co = (e) => Ha(e, !0, (t) => Be.cursor(e.lineBlockAt(t.head).to)), lo = ({ state: e, dispatch: t }) => (t(fa(e, { anchor: 0 })), !0), uo = ({ state: e, dispatch: t }) => (t(fa(e, { anchor: e.doc.length })), !0), fo = ({ state: e, dispatch: t }) => (t(fa(e, {
	anchor: e.selection.main.anchor,
	head: 0
})), !0), po = ({ state: e, dispatch: t }) => (t(fa(e, {
	anchor: e.selection.main.anchor,
	head: e.doc.length
})), !0), mo = ({ state: e, dispatch: t }) => (t(e.update({
	selection: {
		anchor: 0,
		head: e.doc.length
	},
	userEvent: "select"
})), !0), ho = ({ state: e, dispatch: t }) => {
	let n = Po(e).map(({ from: t, to: n }) => Be.range(t, Math.min(n + 1, e.doc.length)));
	return t(e.update({
		selection: Be.create(n),
		userEvent: "select"
	})), !0;
}, go = ({ state: t, dispatch: n }) => {
	let r = da(t.selection, (n) => {
		let r = e(t), i = r.resolveStack(n.from, 1);
		if (n.empty) {
			let e = r.resolveStack(n.from, -1);
			e.node.from >= i.node.from && e.node.to <= i.node.to && (i = e);
		}
		for (let e = i; e; e = e.next) {
			let { node: t } = e;
			if ((t.from < n.from && t.to >= n.to || t.to > n.to && t.from <= n.from) && e.next) return Be.range(t.to, t.from);
		}
		return n;
	});
	return r.eq(t.selection) ? !1 : (n(fa(t, r)), !0);
};
function _o(e, t) {
	let { state: n } = e, r = n.selection, i = n.selection.ranges.slice();
	for (let r of n.selection.ranges) {
		let a = n.doc.lineAt(r.head);
		if (t ? a.to < e.state.doc.length : a.from > 0) for (let n = r;;) {
			let r = e.moveVertically(n, t);
			if (r.head < a.from || r.head > a.to) {
				i.some((e) => e.head == r.head) || i.push(r);
				break;
			} else if (r.head == n.head) break;
			else n = r;
		}
	}
	return i.length == r.ranges.length ? !1 : (e.dispatch(fa(n, Be.create(i, i.length - 1))), !0);
}
var vo = (e) => _o(e, !1), yo = (e) => _o(e, !0), bo = ({ state: e, dispatch: t }) => {
	let n = e.selection, r = null;
	return n.ranges.length > 1 ? r = Be.create([n.main]) : n.main.empty || (r = Be.create([Be.cursor(n.main.head)])), r ? (t(fa(e, r)), !0) : !1;
};
function xo(e, t) {
	if (e.state.readOnly) return !1;
	let n = "delete.selection", { state: r } = e, i = r.changeByRange((r) => {
		let { from: i, to: a } = r;
		if (i == a) {
			let o = t(r);
			o < i ? (n = "delete.backward", o = So(e, o, !1)) : o > i && (n = "delete.forward", o = So(e, o, !0)), i = Math.min(i, o), a = Math.max(a, o);
		} else i = So(e, i, !1), a = So(e, a, !0);
		return i == a ? { range: r } : {
			changes: {
				from: i,
				to: a
			},
			range: Be.cursor(i, i < r.head ? -1 : 1)
		};
	});
	return i.changes.empty ? !1 : (e.dispatch(r.update(i, {
		scrollIntoView: !0,
		userEvent: n,
		effects: n == "delete.selection" ? s.announce.of(r.phrase("Selection deleted")) : void 0
	})), !0);
}
function So(e, t, n) {
	if (e instanceof s) for (let r of e.state.facet(s.atomicRanges).map((t) => t(e))) r.between(t, t, (e, r) => {
		e < t && r > t && (t = n ? r : e);
	});
	return t;
}
var Co = (e, t, n) => xo(e, (r) => {
	let i = r.from, { state: a } = e, s = a.doc.lineAt(i), c, l;
	if (n && !t && i > s.from && i < s.from + 200 && !/[^ \t]/.test(c = s.text.slice(0, i - s.from))) {
		if (c[c.length - 1] == "	") return i - 1;
		let e = v(c, a.tabSize) % se(a) || se(a);
		for (let t = 0; t < e && c[c.length - 1 - t] == " "; t++) i--;
		l = i;
	} else l = o(s.text, i - s.from, t, t) + s.from, l == i && s.number != (t ? a.doc.lines : 1) ? l += t ? 1 : -1 : !t && /[\ufe00-\ufe0f]/.test(s.text.slice(l - s.from, i - s.from)) && (l = o(s.text, l - s.from, !1, !1) + s.from);
	return l;
}), wo = (e) => Co(e, !1, !0), To = (e) => Co(e, !0, !1), Eo = (e, t) => xo(e, (n) => {
	let r = n.head, { state: i } = e, a = i.doc.lineAt(r), s = i.charCategorizer(r);
	for (let e = null;;) {
		if (r == (t ? a.to : a.from)) {
			r == n.head && a.number != (t ? i.doc.lines : 1) && (r += t ? 1 : -1);
			break;
		}
		let c = o(a.text, r - a.from, t) + a.from, l = a.text.slice(Math.min(r, c) - a.from, Math.max(r, c) - a.from), u = s(l);
		if (e != null && u != e) break;
		(l != " " || r != n.head) && (e = u), r = c;
	}
	return r;
}), Do = (e) => Eo(e, !1), Oo = (e) => Eo(e, !0), ko = (e) => xo(e, (t) => {
	let n = e.lineBlockAt(t.head).to;
	return t.head < n ? n : Math.min(e.state.doc.length, t.head + 1);
}), Ao = (e) => xo(e, (t) => {
	let n = e.moveToLineBoundary(t, !1).head;
	return t.head > n ? n : Math.max(0, t.head - 1);
}), jo = (e) => xo(e, (t) => {
	let n = e.moveToLineBoundary(t, !0).head;
	return t.head < n ? n : Math.min(e.state.doc.length, t.head + 1);
}), Mo = ({ state: e, dispatch: t }) => {
	if (e.readOnly) return !1;
	let n = e.changeByRange((e) => ({
		changes: {
			from: e.from,
			to: e.to,
			insert: ye.of(["", ""])
		},
		range: Be.cursor(e.from)
	}));
	return t(e.update(n, {
		scrollIntoView: !0,
		userEvent: "input"
	})), !0;
}, No = ({ state: e, dispatch: t }) => {
	if (e.readOnly) return !1;
	let n = e.changeByRange((t) => {
		if (!t.empty || t.from == 0 || t.from == e.doc.length) return { range: t };
		let n = t.from, r = e.doc.lineAt(n), i = n == r.from ? n - 1 : o(r.text, n - r.from, !1) + r.from, a = n == r.to ? n + 1 : o(r.text, n - r.from, !0) + r.from;
		return {
			changes: {
				from: i,
				to: a,
				insert: e.doc.slice(n, a).append(e.doc.slice(i, n))
			},
			range: Be.cursor(a)
		};
	});
	return n.changes.empty ? !1 : (t(e.update(n, {
		scrollIntoView: !0,
		userEvent: "move.character"
	})), !0);
};
function Po(e) {
	let t = [], n = -1;
	for (let r of e.selection.ranges) {
		let i = e.doc.lineAt(r.from), a = e.doc.lineAt(r.to);
		if (!r.empty && r.to == a.from && (a = e.doc.lineAt(r.to - 1)), n >= i.number) {
			let e = t[t.length - 1];
			e.to = a.to, e.ranges.push(r);
		} else t.push({
			from: i.from,
			to: a.to,
			ranges: [r]
		});
		n = a.number + 1;
	}
	return t;
}
function Fo(e, t, n) {
	if (e.readOnly) return !1;
	let r = [], i = [];
	for (let t of Po(e)) {
		if (n ? t.to == e.doc.length : t.from == 0) continue;
		let a = e.doc.lineAt(n ? t.to + 1 : t.from - 1), o = a.length + 1;
		if (n) {
			r.push({
				from: t.to,
				to: a.to
			}, {
				from: t.from,
				insert: a.text + e.lineBreak
			});
			for (let n of t.ranges) i.push(Be.range(Math.min(e.doc.length, n.anchor + o), Math.min(e.doc.length, n.head + o)));
		} else {
			r.push({
				from: a.from,
				to: t.from
			}, {
				from: t.to,
				insert: e.lineBreak + a.text
			});
			for (let e of t.ranges) i.push(Be.range(e.anchor - o, e.head - o));
		}
	}
	return r.length ? (t(e.update({
		changes: r,
		scrollIntoView: !0,
		selection: Be.create(i, e.selection.mainIndex),
		userEvent: "move.line"
	})), !0) : !1;
}
var Io = ({ state: e, dispatch: t }) => Fo(e, t, !1), Lo = ({ state: e, dispatch: t }) => Fo(e, t, !0);
function Ro(e, t, n) {
	if (e.readOnly) return !1;
	let r = [];
	for (let t of Po(e)) n ? r.push({
		from: t.from,
		insert: e.doc.slice(t.from, t.to) + e.lineBreak
	}) : r.push({
		from: t.to,
		insert: e.lineBreak + e.doc.slice(t.from, t.to)
	});
	let i = e.changes(r);
	return t(e.update({
		changes: i,
		selection: e.selection.map(i, n ? 1 : -1),
		scrollIntoView: !0,
		userEvent: "input.copyline"
	})), !0;
}
var zo = ({ state: e, dispatch: t }) => Ro(e, t, !1), Bo = ({ state: e, dispatch: t }) => Ro(e, t, !0), Vo = (e) => {
	if (e.state.readOnly) return !1;
	let { state: t } = e, n = t.changes(Po(t).map(({ from: e, to: n }) => (e > 0 ? e-- : n < t.doc.length && n++, {
		from: e,
		to: n
	}))), r = da(t.selection, (t) => {
		let n;
		if (e.lineWrapping) {
			let r = e.lineBlockAt(t.head), i = e.coordsAtPos(t.head, t.assoc || 1);
			i && (n = r.bottom + e.documentTop - i.bottom + e.defaultLineHeight / 2);
		}
		return e.moveVertically(t, !0, n);
	}).map(n);
	return e.dispatch({
		changes: n,
		selection: r,
		scrollIntoView: !0,
		userEvent: "delete.line"
	}), !0;
};
function Ho(t, n) {
	if (/\(\)|\[\]|\{\}/.test(t.sliceDoc(n - 1, n + 1))) return {
		from: n,
		to: n
	};
	let r = e(t).resolveInner(n), i = r.childBefore(n), a = r.childAfter(n), o;
	return i && a && i.to <= n && a.from >= n && (o = i.type.prop(c.closedBy)) && o.indexOf(a.name) > -1 && t.doc.lineAt(i.to).from == t.doc.lineAt(a.from).from && !/\S/.test(t.sliceDoc(i.to, a.from)) ? {
		from: i.to,
		to: a.from
	} : null;
}
var Uo = /*@__PURE__*/ Go(!1), Wo = /*@__PURE__*/ Go(!0);
function Go(e) {
	return ({ state: t, dispatch: n }) => {
		if (t.readOnly) return !1;
		let r = t.changeByRange((n) => {
			let { from: r, to: i } = n, a = t.doc.lineAt(r), o = !e && r == i && Ho(t, r);
			e && (r = i = (i <= a.to ? a : t.doc.lineAt(i)).to);
			let s = new je(t, {
				simulateBreak: r,
				simulateDoubleBreak: !!o
			}), c = Re(s, r);
			for (c ??= v(/^\s*/.exec(t.doc.lineAt(r).text)[0], t.tabSize); i < a.to && /\s/.test(a.text[i - a.from]);) i++;
			o ? {from: r, to: i} = o : r > a.from && r < a.from + 100 && !/\S/.test(a.text.slice(0, r)) && (r = a.from);
			let l = ["", Le(t, c)];
			return o && l.push(Le(t, s.lineIndent(a.from, -1))), {
				changes: {
					from: r,
					to: i,
					insert: ye.of(l)
				},
				range: Be.cursor(r + 1 + l[1].length)
			};
		});
		return n(t.update(r, {
			scrollIntoView: !0,
			userEvent: "input"
		})), !0;
	};
}
function Ko(e, t) {
	let n = -1;
	return e.changeByRange((r) => {
		let i = [];
		for (let a = r.from; a <= r.to;) {
			let o = e.doc.lineAt(a);
			o.number > n && (r.empty || r.to > o.from) && (t(o, i, r), n = o.number), a = o.to + 1;
		}
		let a = e.changes(i);
		return {
			changes: i,
			range: Be.range(a.mapPos(r.anchor, 1), a.mapPos(r.head, 1))
		};
	});
}
var qo = ({ state: e, dispatch: t }) => {
	if (e.readOnly) return !1;
	let n = Object.create(null), r = new je(e, { overrideIndentation: (e) => n[e] ?? -1 }), i = Ko(e, (t, i, a) => {
		let o = Re(r, t.from);
		if (o == null) return;
		/\S/.test(t.text) || (o = 0);
		let s = /^\s*/.exec(t.text)[0], c = Le(e, o);
		(s != c || a.from < t.from + s.length) && (n[t.from] = o, i.push({
			from: t.from,
			to: t.from + s.length,
			insert: c
		}));
	});
	return i.changes.empty || t(e.update(i, { userEvent: "indent" })), !0;
}, Jo = ({ state: e, dispatch: t }) => e.readOnly ? !1 : (t(e.update(Ko(e, (t, n) => {
	n.push({
		from: t.from,
		insert: e.facet(S)
	});
}), { userEvent: "input.indent" })), !0), Yo = ({ state: e, dispatch: t }) => e.readOnly ? !1 : (t(e.update(Ko(e, (t, n) => {
	let r = /^\s*/.exec(t.text)[0];
	if (!r) return;
	let i = v(r, e.tabSize), a = 0, o = Le(e, Math.max(0, i - se(e)));
	for (; a < r.length && a < o.length && r.charCodeAt(a) == o.charCodeAt(a);) a++;
	n.push({
		from: t.from + a,
		to: t.from + r.length,
		insert: o.slice(a)
	});
}), { userEvent: "delete.dedent" })), !0), Xo = (e) => (e.setTabFocusMode(), !0), Zo = [
	{
		key: "Ctrl-b",
		run: _a,
		shift: Wa,
		preventDefault: !0
	},
	{
		key: "Ctrl-f",
		run: va,
		shift: Ga
	},
	{
		key: "Ctrl-p",
		run: Da,
		shift: Qa
	},
	{
		key: "Ctrl-n",
		run: Oa,
		shift: $a
	},
	{
		key: "Ctrl-a",
		run: Ra,
		shift: so
	},
	{
		key: "Ctrl-e",
		run: za,
		shift: co
	},
	{
		key: "Ctrl-d",
		run: To
	},
	{
		key: "Ctrl-h",
		run: wo
	},
	{
		key: "Ctrl-k",
		run: ko
	},
	{
		key: "Ctrl-Alt-h",
		run: Do
	},
	{
		key: "Ctrl-o",
		run: Mo
	},
	{
		key: "Ctrl-t",
		run: No
	},
	{
		key: "Ctrl-v",
		run: Ma
	}
], Qo = /*@__PURE__*/ [
	{
		key: "ArrowLeft",
		run: _a,
		shift: Wa,
		preventDefault: !0
	},
	{
		key: "Mod-ArrowLeft",
		mac: "Alt-ArrowLeft",
		run: ba,
		shift: qa,
		preventDefault: !0
	},
	{
		mac: "Cmd-ArrowLeft",
		run: Ia,
		shift: ao,
		preventDefault: !0
	},
	{
		key: "ArrowRight",
		run: va,
		shift: Ga,
		preventDefault: !0
	},
	{
		key: "Mod-ArrowRight",
		mac: "Alt-ArrowRight",
		run: xa,
		shift: Ja,
		preventDefault: !0
	},
	{
		mac: "Cmd-ArrowRight",
		run: La,
		shift: oo,
		preventDefault: !0
	},
	{
		key: "ArrowUp",
		run: Da,
		shift: Qa,
		preventDefault: !0
	},
	{
		mac: "Cmd-ArrowUp",
		run: lo,
		shift: fo
	},
	{
		mac: "Ctrl-ArrowUp",
		run: ja,
		shift: to
	},
	{
		key: "ArrowDown",
		run: Oa,
		shift: $a,
		preventDefault: !0
	},
	{
		mac: "Cmd-ArrowDown",
		run: uo,
		shift: po
	},
	{
		mac: "Ctrl-ArrowDown",
		run: Ma,
		shift: no
	},
	{
		key: "PageUp",
		run: ja,
		shift: to
	},
	{
		key: "PageDown",
		run: Ma,
		shift: no
	},
	{
		key: "Home",
		run: Fa,
		shift: io,
		preventDefault: !0
	},
	{
		key: "Mod-Home",
		run: lo,
		shift: fo
	},
	{
		key: "End",
		run: Pa,
		shift: ro,
		preventDefault: !0
	},
	{
		key: "Mod-End",
		run: uo,
		shift: po
	},
	{
		key: "Enter",
		run: Uo,
		shift: Uo
	},
	{
		key: "Mod-a",
		run: mo
	},
	{
		key: "Backspace",
		run: wo,
		shift: wo,
		preventDefault: !0
	},
	{
		key: "Delete",
		run: To,
		preventDefault: !0
	},
	{
		key: "Mod-Backspace",
		mac: "Alt-Backspace",
		run: Do,
		preventDefault: !0
	},
	{
		key: "Mod-Delete",
		mac: "Alt-Delete",
		run: Oo,
		preventDefault: !0
	},
	{
		mac: "Mod-Backspace",
		run: Ao,
		preventDefault: !0
	},
	{
		mac: "Mod-Delete",
		run: jo,
		preventDefault: !0
	}
].concat(/*@__PURE__*/ Zo.map((e) => ({
	mac: e.key,
	run: e.run,
	shift: e.shift
}))), $o = /*@__PURE__*/ [
	{
		key: "Alt-ArrowLeft",
		mac: "Ctrl-ArrowLeft",
		run: wa,
		shift: Ya
	},
	{
		key: "Alt-ArrowRight",
		mac: "Ctrl-ArrowRight",
		run: Ta,
		shift: Xa
	},
	{
		key: "Alt-ArrowUp",
		run: Io
	},
	{
		key: "Shift-Alt-ArrowUp",
		run: zo
	},
	{
		key: "Alt-ArrowDown",
		run: Lo
	},
	{
		key: "Shift-Alt-ArrowDown",
		run: Bo
	},
	{
		key: "Mod-Alt-ArrowUp",
		run: vo
	},
	{
		key: "Mod-Alt-ArrowDown",
		run: yo
	},
	{
		key: "Escape",
		run: bo
	},
	{
		key: "Mod-Enter",
		run: Wo
	},
	{
		key: "Alt-l",
		mac: "Ctrl-l",
		run: ho
	},
	{
		key: "Mod-i",
		run: go,
		preventDefault: !0
	},
	{
		key: "Mod-[",
		run: Yo
	},
	{
		key: "Mod-]",
		run: Jo
	},
	{
		key: "Mod-Alt-\\",
		run: qo
	},
	{
		key: "Shift-Mod-k",
		run: Vo
	},
	{
		key: "Shift-Mod-\\",
		run: Va
	},
	{
		key: "Mod-/",
		run: ki
	},
	{
		key: "Alt-A",
		run: Mi
	},
	{
		key: "Ctrl-m",
		mac: "Shift-Alt-m",
		run: Xo
	}
].concat(Qo), es = {
	key: "Tab",
	run: Jo,
	shift: Yo
}, ts = typeof String.prototype.normalize == "function" ? (e) => e.normalize("NFKD") : (e) => e, ns = class {
	constructor(e, t, n = 0, r = e.length, i, a) {
		this.test = a, this.value = {
			from: 0,
			to: 0,
			precise: !1
		}, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = e.iterRange(n, r), this.bufferStart = n, this.normalize = i ? (e) => i(ts(e)) : ts, this.query = this.normalize(t);
	}
	peek() {
		if (this.bufferPos == this.buffer.length) {
			if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done) return -1;
			this.bufferPos = 0, this.buffer = this.iter.value;
		}
		return _e(this.buffer, this.bufferPos);
	}
	next() {
		for (; this.matches.length;) this.matches.pop();
		return this.nextOverlapping();
	}
	nextOverlapping() {
		for (;;) {
			let e = this.peek();
			if (e < 0) return this.done = !0, this;
			let t = l(e), n = this.bufferStart + this.bufferPos;
			this.bufferPos += m(e);
			let r = this.normalize(t);
			if (r.length) for (let e = 0, i = n, a = !0;; e++) {
				let n = r.charCodeAt(e), o = this.match(n, i, a, this.bufferPos + this.bufferStart, e == r.length - 1);
				if (o) return this.value = o, this;
				if (e == r.length - 1) break;
				a && e < t.length && t.charCodeAt(e) == n ? i++ : a = !1;
			}
		}
	}
	match(e, t, n, r, i) {
		let a = null;
		for (let t = 0; t < this.matches.length;) {
			let n = this.matches[t], o = !1;
			this.query.charCodeAt(n.index) == e && (n.index == this.query.length - 1 ? a = {
				from: n.from,
				to: r,
				precise: i && n.precise
			} : (n.index++, o = !0)), o ? t++ : this.matches.splice(t, 1);
		}
		return this.query.charCodeAt(0) == e && (this.query.length == 1 ? a = {
			from: t,
			to: r,
			precise: n && i
		} : this.matches.push({
			from: t,
			index: 1,
			precise: n
		})), a && this.test && !this.test(a.from, a.to, this.buffer, this.bufferStart) && (a = null), a;
	}
};
typeof Symbol < "u" && (ns.prototype[Symbol.iterator] = function() {
	return this;
});
var rs = {
	from: -1,
	to: -1,
	match: /*@__PURE__*/ /.*/.exec(""),
	precise: !0
}, is = "gm" + (/x/.unicode == null ? "" : "u"), as = class {
	constructor(e, t, n, r = 0, i = e.length) {
		if (this.text = e, this.to = i, this.curLine = "", this.done = !1, this.value = rs, /\\[sWDnr]|\n|\r|\[\^/.test(t)) return new cs(e, t, n, r, i);
		this.re = new RegExp(t, is + (n?.ignoreCase ? "i" : "")), this.test = n?.test, this.iter = e.iter();
		let a = e.lineAt(r);
		this.curLineStart = a.from, this.matchPos = us(e, r), this.getLine(this.curLineStart);
	}
	getLine(e) {
		this.iter.next(e), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
	}
	nextLine() {
		this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
	}
	next() {
		for (let e = this.matchPos - this.curLineStart;;) {
			this.re.lastIndex = e;
			let t = this.matchPos <= this.to && this.re.exec(this.curLine);
			if (t) {
				let n = this.curLineStart + t.index, r = n + t[0].length;
				if (this.matchPos = us(this.text, r + +(n == r)), n == this.curLineStart + this.curLine.length && this.nextLine(), (n < r || n > this.value.to) && (!this.test || this.test(n, r, t))) return this.value = {
					from: n,
					to: r,
					precise: !0,
					match: t
				}, this;
				e = this.matchPos - this.curLineStart;
			} else if (this.curLineStart + this.curLine.length < this.to) this.nextLine(), e = 0;
			else return this.done = !0, this;
		}
	}
}, os = /*@__PURE__*/ new WeakMap(), ss = class e {
	constructor(e, t) {
		this.from = e, this.text = t;
	}
	get to() {
		return this.from + this.text.length;
	}
	static get(t, n, r) {
		let i = os.get(t);
		if (!i || i.from >= r || i.to <= n) {
			let i = new e(n, t.sliceString(n, r));
			return os.set(t, i), i;
		}
		if (i.from == n && i.to == r) return i;
		let { text: a, from: o } = i;
		return o > n && (a = t.sliceString(n, o) + a, o = n), i.to < r && (a += t.sliceString(i.to, r)), os.set(t, new e(o, a)), new e(n, a.slice(n - o, r - o));
	}
}, cs = class {
	constructor(e, t, n, r, i) {
		this.text = e, this.to = i, this.done = !1, this.value = rs, this.matchPos = us(e, r), this.re = new RegExp(t, is + (n?.ignoreCase ? "i" : "")), this.test = n?.test, this.flat = ss.get(e, r, this.chunkEnd(r + 5e3));
	}
	chunkEnd(e) {
		return e >= this.to ? this.to : this.text.lineAt(e).to;
	}
	next() {
		for (;;) {
			let e = this.re.lastIndex = this.matchPos - this.flat.from, t = this.re.exec(this.flat.text);
			if (t && !t[0] && t.index == e && (this.re.lastIndex = e + 1, t = this.re.exec(this.flat.text)), t) {
				let e = this.flat.from + t.index, n = e + t[0].length;
				if ((this.flat.to >= this.to || t.index + t[0].length <= this.flat.text.length - 10) && (!this.test || this.test(e, n, t))) return this.value = {
					from: e,
					to: n,
					precise: !0,
					match: t
				}, this.matchPos = us(this.text, n + +(e == n)), this;
			}
			if (this.flat.to == this.to) return this.done = !0, this;
			this.flat = ss.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
		}
	}
};
typeof Symbol < "u" && (as.prototype[Symbol.iterator] = cs.prototype[Symbol.iterator] = function() {
	return this;
});
function ls(e) {
	try {
		return new RegExp(e, is), !0;
	} catch {
		return !1;
	}
}
function us(e, t) {
	if (t >= e.length) return t;
	let n = e.lineAt(t), r;
	for (; t < n.to && (r = n.text.charCodeAt(t - n.from)) >= 56320 && r < 57344;) t++;
	return t;
}
var ds = (e) => {
	let { state: t } = e, n = String(t.doc.lineAt(e.state.selection.main.head).number), { close: r, result: i } = Pe(e, {
		label: t.phrase("Go to line"),
		input: {
			type: "text",
			name: "line",
			value: n
		},
		focus: !0,
		submitLabel: t.phrase("go")
	});
	return i.then((n) => {
		let i = n && /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(n.elements.line.value);
		if (!i) {
			e.dispatch({ effects: r });
			return;
		}
		let a = t.doc.lineAt(t.selection.main.head), [, o, c, l, u] = i, d = l ? +l.slice(1) : 0, f = c ? +c : a.number;
		if (c && u) {
			let e = f / 100;
			o && (e = e * (o == "-" ? -1 : 1) + a.number / t.doc.lines), f = Math.round(t.doc.lines * e);
		} else c && o && (f = f * (o == "-" ? -1 : 1) + a.number);
		let p = t.doc.line(Math.max(1, Math.min(t.doc.lines, f))), m = Be.cursor(p.from + Math.max(0, Math.min(d, p.length)));
		e.dispatch({
			effects: [r, s.scrollIntoView(m.from, { y: "center" })],
			selection: m
		});
	}), !0;
}, fs = {
	highlightWordAroundCursor: !1,
	minSelectionLength: 1,
	maxMatches: 100,
	wholeWords: !1
}, ps = /*@__PURE__*/ ze.define({ combine(e) {
	return g(e, fs, {
		highlightWordAroundCursor: (e, t) => e || t,
		minSelectionLength: Math.min,
		maxMatches: Math.min
	});
} });
function ms(e) {
	let t = [bs, ys];
	return e && t.push(ps.of(e)), t;
}
var hs = /*@__PURE__*/ w.mark({ class: "cm-selectionMatch" }), gs = /*@__PURE__*/ w.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function _s(e, t, n, r) {
	return (n == 0 || e(t.sliceDoc(n - 1, n)) != ie.Word) && (r == t.doc.length || e(t.sliceDoc(r, r + 1)) != ie.Word);
}
function vs(e, t, n, r) {
	return e(t.sliceDoc(n, n + 1)) == ie.Word && e(t.sliceDoc(r - 1, r)) == ie.Word;
}
var ys = /*@__PURE__*/ d.fromClass(class {
	constructor(e) {
		this.decorations = this.getDeco(e);
	}
	update(e) {
		(e.selectionSet || e.docChanged || e.viewportChanged) && (this.decorations = this.getDeco(e.view));
	}
	getDeco(e) {
		let t = e.state.facet(ps), { state: n } = e, r = n.selection;
		if (r.ranges.length > 1) return w.none;
		let i = r.main, a, o = null;
		if (i.empty) {
			if (!t.highlightWordAroundCursor) return w.none;
			let e = n.wordAt(i.head);
			if (!e) return w.none;
			o = n.charCategorizer(i.head), a = n.sliceDoc(e.from, e.to);
		} else {
			let e = i.to - i.from;
			if (e < t.minSelectionLength || e > 200) return w.none;
			if (t.wholeWords) {
				if (a = n.sliceDoc(i.from, i.to), o = n.charCategorizer(i.head), !(_s(o, n, i.from, i.to) && vs(o, n, i.from, i.to))) return w.none;
			} else if (a = n.sliceDoc(i.from, i.to), !a) return w.none;
		}
		let s = [];
		for (let r of e.visibleRanges) {
			let e = new ns(n.doc, a, r.from, r.to);
			for (; !e.next().done;) {
				let { from: r, to: a } = e.value;
				if ((!o || _s(o, n, r, a)) && (i.empty && r <= i.from && a >= i.to ? s.push(gs.range(r, a)) : (r >= i.to || a <= i.from) && s.push(hs.range(r, a)), s.length > t.maxMatches)) return w.none;
			}
		}
		return w.set(s);
	}
}, { decorations: (e) => e.decorations }), bs = /*@__PURE__*/ s.baseTheme({
	".cm-selectionMatch": { backgroundColor: "#99ff7780" },
	".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
}), xs = ({ state: e, dispatch: t }) => {
	let { selection: n } = e, r = Be.create(n.ranges.map((t) => e.wordAt(t.head) || Be.cursor(t.head)), n.mainIndex);
	return r.eq(n) ? !1 : (t(e.update({ selection: r })), !0);
};
function Ss(e, t) {
	let { main: n, ranges: r } = e.selection, i = e.wordAt(n.head), a = i && i.from == n.from && i.to == n.to;
	for (let n = !1, i = new ns(e.doc, t, r[r.length - 1].to);;) if (i.next(), i.done) {
		if (n) return null;
		i = new ns(e.doc, t, 0, Math.max(0, r[r.length - 1].from - 1)), n = !0;
	} else {
		if (n && r.some((e) => e.from == i.value.from)) continue;
		if (a) {
			let t = e.wordAt(i.value.from);
			if (!t || t.from != i.value.from || t.to != i.value.to) continue;
		}
		return i.value;
	}
}
var Cs = ({ state: e, dispatch: t }) => {
	let { ranges: n } = e.selection;
	if (n.some((e) => e.from === e.to)) return xs({
		state: e,
		dispatch: t
	});
	let r = e.sliceDoc(n[0].from, n[0].to);
	if (e.selection.ranges.some((t) => e.sliceDoc(t.from, t.to) != r)) return !1;
	let i = Ss(e, r);
	return i ? (t(e.update({
		selection: e.selection.addRange(Be.range(i.from, i.to), !1),
		effects: s.scrollIntoView(i.to)
	})), !0) : !1;
}, ws = /*@__PURE__*/ ze.define({ combine(e) {
	return g(e, {
		top: !1,
		caseSensitive: !1,
		literal: !1,
		regexp: !1,
		wholeWord: !1,
		createPanel: (e) => new ic(e),
		scrollToMatch: (e) => s.scrollIntoView(e)
	});
} }), Ts = class {
	constructor(e) {
		this.search = e.search, this.caseSensitive = !!e.caseSensitive, this.literal = !!e.literal, this.regexp = !!e.regexp, this.replace = e.replace || "", this.valid = !!this.search && (!this.regexp || ls(this.search)), this.unquoted = this.unquote(this.search), this.wholeWord = !!e.wholeWord, this.test = e.test;
	}
	unquote(e) {
		return this.literal ? e : e.replace(/\\([nrt\\])/g, (e, t) => t == "n" ? "\n" : t == "r" ? "\r" : t == "t" ? "	" : "\\");
	}
	eq(e) {
		return this.search == e.search && this.replace == e.replace && this.caseSensitive == e.caseSensitive && this.regexp == e.regexp && this.wholeWord == e.wholeWord && this.test == e.test;
	}
	create() {
		return this.regexp ? new Is(this) : new As(this);
	}
	getCursor(e, t = 0, n) {
		let r = e.doc ? e : ce.create({ doc: e });
		return n ??= r.doc.length, this.regexp ? Ms(this, r, t, n) : Os(this, r, t, n);
	}
}, Es = class {
	constructor(e) {
		this.spec = e;
	}
};
function Ds(e, t, n) {
	return (r, i, a, o) => n && !n(r, i, a, o) ? !1 : e(r >= o && i <= o + a.length ? a.slice(r - o, i - o) : t.doc.sliceString(r, i), t, r, i);
}
function Os(e, t, n, r) {
	let i;
	return e.wholeWord && (i = ks(t.doc, t.charCategorizer(t.selection.main.head))), e.test && (i = Ds(e.test, t, i)), new ns(t.doc, e.unquoted, n, r, e.caseSensitive ? void 0 : (e) => e.toLowerCase(), i);
}
function ks(e, t) {
	return (n, r, i, a) => ((a > n || a + i.length < r) && (a = Math.max(0, n - 2), i = e.sliceString(a, Math.min(e.length, r + 2))), (t(Ns(i, n - a)) != ie.Word || t(Ps(i, n - a)) != ie.Word) && (t(Ps(i, r - a)) != ie.Word || t(Ns(i, r - a)) != ie.Word));
}
var As = class extends Es {
	constructor(e) {
		super(e);
	}
	nextMatch(e, t, n) {
		let r = Os(this.spec, e, n, e.doc.length).nextOverlapping();
		if (r.done) {
			let n = Math.min(e.doc.length, t + this.spec.unquoted.length);
			r = Os(this.spec, e, 0, n).nextOverlapping();
		}
		return r.done || r.value.from == t && r.value.to == n ? null : r.value;
	}
	prevMatchInRange(e, t, n) {
		for (let r = n;;) {
			let n = Math.max(t, r - 1e4 - this.spec.unquoted.length), i = Os(this.spec, e, n, r), a = null;
			for (; !i.nextOverlapping().done;) a = i.value;
			if (a) return a;
			if (n == t) return null;
			r -= 1e4;
		}
	}
	prevMatch(e, t, n) {
		let r = this.prevMatchInRange(e, 0, t);
		return r ||= this.prevMatchInRange(e, Math.max(0, n - this.spec.unquoted.length), e.doc.length), r && (r.from != t || r.to != n) ? r : null;
	}
	getReplacement(e) {
		return this.spec.unquote(this.spec.replace);
	}
	matchAll(e, t) {
		let n = Os(this.spec, e, 0, e.doc.length), r = [];
		for (; !n.next().done;) {
			if (r.length >= t) return null;
			r.push(n.value);
		}
		return r;
	}
	highlight(e, t, n, r) {
		let i = Os(this.spec, e, Math.max(0, t - this.spec.unquoted.length), Math.min(n + this.spec.unquoted.length, e.doc.length));
		for (; !i.next().done;) r(i.value.from, i.value.to);
	}
};
function js(e, t, n) {
	return (r, i, a) => (!n || n(r, i, a)) && e(a[0], t, r, i);
}
function Ms(e, t, n, r) {
	let i;
	return e.wholeWord && (i = Fs(t.charCategorizer(t.selection.main.head))), e.test && (i = js(e.test, t, i)), new as(t.doc, e.search, {
		ignoreCase: !e.caseSensitive,
		test: i
	}, n, r);
}
function Ns(e, t) {
	return e.slice(o(e, t, !1), t);
}
function Ps(e, t) {
	return e.slice(t, o(e, t));
}
function Fs(e) {
	return (t, n, r) => !r[0].length || (e(Ns(r.input, r.index)) != ie.Word || e(Ps(r.input, r.index)) != ie.Word) && (e(Ps(r.input, r.index + r[0].length)) != ie.Word || e(Ns(r.input, r.index + r[0].length)) != ie.Word);
}
var Is = class extends Es {
	nextMatch(e, t, n) {
		let r = Ms(this.spec, e, n, e.doc.length).next();
		return r.done && (r = Ms(this.spec, e, 0, t).next()), r.done ? null : r.value;
	}
	prevMatchInRange(e, t, n) {
		for (let r = 1;; r++) {
			let i = Math.max(t, n - r * 1e4), a = Ms(this.spec, e, i, n), o = null;
			for (; !a.next().done;) o = a.value;
			if (o && (i == t || o.from > i + 10)) return o;
			if (i == t) return null;
		}
	}
	prevMatch(e, t, n) {
		return this.prevMatchInRange(e, 0, t) || this.prevMatchInRange(e, n, e.doc.length);
	}
	getReplacement(e) {
		return this.spec.unquote(this.spec.replace).replace(/\$([$&]|\d+)/g, (t, n) => {
			if (n == "&") return e.match[0];
			if (n == "$") return "$";
			for (let t = n.length; t > 0; t--) {
				let r = +n.slice(0, t);
				if (r > 0 && r < e.match.length) return e.match[r] + n.slice(t);
			}
			return t;
		});
	}
	matchAll(e, t) {
		let n = Ms(this.spec, e, 0, e.doc.length), r = [];
		for (; !n.next().done;) {
			if (r.length >= t) return null;
			r.push(n.value);
		}
		return r;
	}
	highlight(e, t, n, r) {
		let i = Ms(this.spec, e, Math.max(0, t - 250), Math.min(n + 250, e.doc.length));
		for (; !i.next().done;) r(i.value.from, i.value.to);
	}
}, Ls = /*@__PURE__*/ a.define(), Rs = /*@__PURE__*/ a.define(), zs = /*@__PURE__*/ _.define({
	create(e) {
		return new Bs(Qs(e).create(), null);
	},
	update(e, t) {
		for (let n of t.effects) n.is(Ls) ? e = new Bs(n.value.create(), e.panel) : n.is(Rs) && (e = new Bs(e.query, n.value ? Zs : null));
		return e;
	},
	provide: (e) => ue.from(e, (e) => e.panel)
}), Bs = class {
	constructor(e, t) {
		this.query = e, this.panel = t;
	}
}, Vs = /*@__PURE__*/ w.mark({ class: "cm-searchMatch" }), Hs = /*@__PURE__*/ w.mark({ class: "cm-searchMatch cm-searchMatch-selected" }), Us = /*@__PURE__*/ d.fromClass(class {
	constructor(e) {
		this.view = e, this.decorations = this.highlight(e.state.field(zs));
	}
	update(e) {
		let t = e.state.field(zs);
		(t != e.startState.field(zs) || e.docChanged || e.selectionSet || e.viewportChanged) && (this.decorations = this.highlight(t));
	}
	highlight({ query: e, panel: t }) {
		if (!t || !e.spec.valid) return w.none;
		let { view: n } = this, r = new C();
		for (let t = 0, i = n.visibleRanges, a = i.length; t < a; t++) {
			let { from: o, to: s } = i[t];
			for (; t < a - 1 && s > i[t + 1].from - 500;) s = i[++t].to;
			e.highlight(n.state, o, s, (e, t) => {
				let i = n.state.selection.ranges.some((n) => n.from == e && n.to == t);
				r.add(e, t, i ? Hs : Vs);
			});
		}
		return r.finish();
	}
}, { decorations: (e) => e.decorations });
function Ws(e) {
	return (t) => {
		let n = t.state.field(zs, !1);
		return n && n.query.spec.valid ? e(t, n) : tc(t);
	};
}
var Gs = /*@__PURE__*/ Ws((e, { query: t }) => {
	let { to: n } = e.state.selection.main, r = t.nextMatch(e.state, n, n);
	if (!r) return !1;
	let i = Be.single(r.from, r.to), a = e.state.facet(ws);
	return e.dispatch({
		selection: i,
		effects: [cc(e, r), a.scrollToMatch(i.main, e)],
		userEvent: "select.search"
	}), ec(e), !0;
}), Ks = /*@__PURE__*/ Ws((e, { query: t }) => {
	let { state: n } = e, { from: r } = n.selection.main, i = t.prevMatch(n, r, r);
	if (!i) return !1;
	let a = Be.single(i.from, i.to), o = e.state.facet(ws);
	return e.dispatch({
		selection: a,
		effects: [cc(e, i), o.scrollToMatch(a.main, e)],
		userEvent: "select.search"
	}), ec(e), !0;
}), qs = /*@__PURE__*/ Ws((e, { query: t }) => {
	let n = t.matchAll(e.state, 1e3);
	return !n || !n.length ? !1 : (e.dispatch({
		selection: Be.create(n.map((e) => Be.range(e.from, e.to))),
		userEvent: "select.search.matches"
	}), !0);
}), Js = ({ state: e, dispatch: t }) => {
	let n = e.selection;
	if (n.ranges.length > 1 || n.main.empty) return !1;
	let { from: r, to: i } = n.main, a = [], o = 0;
	for (let t = new ns(e.doc, e.sliceDoc(r, i)); !t.next().done;) {
		if (a.length > 1e3) return !1;
		t.value.from == r && (o = a.length), a.push(Be.range(t.value.from, t.value.to));
	}
	return t(e.update({
		selection: Be.create(a, o),
		userEvent: "select.search.matches"
	})), !0;
}, Ys = /*@__PURE__*/ Ws((e, { query: t }) => {
	let { state: n } = e, { from: r, to: i } = n.selection.main;
	if (n.readOnly) return !1;
	let a = t.nextMatch(n, r, r);
	if (!a) return !1;
	let o = a, c = [], l, u, d = [];
	o.precise ? o.from == r && o.to == i && (u = n.toText(t.getReplacement(o)), c.push({
		from: o.from,
		to: o.to,
		insert: u
	}), o = t.nextMatch(n, o.from, o.to), d.push(s.announce.of(n.phrase("replaced match on line $", n.doc.lineAt(r).number) + "."))) : o = t.nextMatch(n, o.from, o.to);
	let f = e.state.changes(c);
	return o && (l = Be.single(o.from, o.to).map(f), d.push(cc(e, o)), d.push(n.facet(ws).scrollToMatch(l.main, e))), e.dispatch({
		changes: f,
		selection: l,
		effects: d,
		userEvent: "input.replace"
	}), !0;
}), Xs = /*@__PURE__*/ Ws((e, { query: t }) => {
	if (e.state.readOnly) return !1;
	let n = [];
	for (let r of t.matchAll(e.state, 1e9)) {
		let { from: e, to: i, precise: a } = r;
		a && n.push({
			from: e,
			to: i,
			insert: t.getReplacement(r)
		});
	}
	if (!n.length) return !1;
	let r = e.state.phrase("replaced $ matches", n.length) + ".";
	return e.dispatch({
		changes: n,
		effects: s.announce.of(r),
		userEvent: "input.replace.all"
	}), !0;
});
function Zs(e) {
	return e.state.facet(ws).createPanel(e);
}
function Qs(e, t) {
	let n = e.selection.main, r = n.empty || n.to > n.from + 100 ? "" : e.sliceDoc(n.from, n.to);
	if (t && !r) return t;
	let i = e.facet(ws);
	return new Ts({
		search: t?.literal ?? i.literal ? r : r.replace(/\n/g, "\\n"),
		caseSensitive: t?.caseSensitive ?? i.caseSensitive,
		literal: t?.literal ?? i.literal,
		regexp: t?.regexp ?? i.regexp,
		wholeWord: t?.wholeWord ?? i.wholeWord
	});
}
function $s(e) {
	let t = y(e, Zs);
	return t && t.dom.querySelector("[main-field]");
}
function ec(e) {
	let t = $s(e);
	t && t == e.root.activeElement && t.select();
}
var tc = (e) => {
	let t = e.state.field(zs, !1);
	if (t && t.panel) {
		let n = $s(e);
		if (n && n != e.root.activeElement) {
			let r = Qs(e.state, t.query.spec);
			r.valid && e.dispatch({ effects: Ls.of(r) }), n.focus(), n.select();
		}
	} else e.dispatch({ effects: [Rs.of(!0), t ? Ls.of(Qs(e.state, t.query.spec)) : a.appendConfig.of(uc)] });
	return !0;
}, nc = (e) => {
	let t = e.state.field(zs, !1);
	if (!t || !t.panel) return !1;
	let n = y(e, Zs);
	return n && n.dom.contains(e.root.activeElement) && e.focus(), e.dispatch({ effects: Rs.of(!1) }), !0;
}, rc = [
	{
		key: "Mod-f",
		run: tc,
		scope: "editor search-panel"
	},
	{
		key: "F3",
		run: Gs,
		shift: Ks,
		scope: "editor search-panel",
		preventDefault: !0
	},
	{
		key: "Mod-g",
		run: Gs,
		shift: Ks,
		scope: "editor search-panel",
		preventDefault: !0
	},
	{
		key: "Escape",
		run: nc,
		scope: "editor search-panel"
	},
	{
		key: "Mod-Shift-l",
		run: Js
	},
	{
		key: "Mod-Alt-g",
		run: ds
	},
	{
		key: "Mod-d",
		run: Cs,
		preventDefault: !0
	}
], ic = class {
	constructor(e) {
		this.view = e;
		let t = this.query = e.state.field(zs).query.spec;
		this.commit = this.commit.bind(this), this.searchField = Ee("input", {
			value: t.search,
			placeholder: ac(e, "Find"),
			"aria-label": ac(e, "Find"),
			class: "cm-textfield",
			name: "search",
			form: "",
			"main-field": "true",
			onchange: this.commit,
			onkeyup: this.commit
		}), this.replaceField = Ee("input", {
			value: t.replace,
			placeholder: ac(e, "Replace"),
			"aria-label": ac(e, "Replace"),
			class: "cm-textfield",
			name: "replace",
			form: "",
			onchange: this.commit,
			onkeyup: this.commit
		}), this.caseField = Ee("input", {
			type: "checkbox",
			name: "case",
			form: "",
			checked: t.caseSensitive,
			onchange: this.commit
		}), this.reField = Ee("input", {
			type: "checkbox",
			name: "re",
			form: "",
			checked: t.regexp,
			onchange: this.commit
		}), this.wordField = Ee("input", {
			type: "checkbox",
			name: "word",
			form: "",
			checked: t.wholeWord,
			onchange: this.commit
		});
		function n(e, t, n) {
			return Ee("button", {
				class: "cm-button",
				name: e,
				onclick: t,
				type: "button"
			}, n);
		}
		this.dom = Ee("div", {
			onkeydown: (e) => this.keydown(e),
			class: "cm-search"
		}, [
			this.searchField,
			n("next", () => Gs(e), [ac(e, "next")]),
			n("prev", () => Ks(e), [ac(e, "previous")]),
			n("select", () => qs(e), [ac(e, "all")]),
			Ee("label", null, [this.caseField, ac(e, "match case")]),
			Ee("label", null, [this.reField, ac(e, "regexp")]),
			Ee("label", null, [this.wordField, ac(e, "by word")]),
			...e.state.readOnly ? [] : [
				Ee("br"),
				this.replaceField,
				n("replace", () => Ys(e), [ac(e, "replace")]),
				n("replaceAll", () => Xs(e), [ac(e, "replace all")])
			],
			Ee("button", {
				name: "close",
				onclick: () => nc(e),
				"aria-label": ac(e, "close"),
				type: "button"
			}, ["×"])
		]);
	}
	commit() {
		let e = new Ts({
			search: this.searchField.value,
			caseSensitive: this.caseField.checked,
			regexp: this.reField.checked,
			wholeWord: this.wordField.checked,
			replace: this.replaceField.value
		});
		e.eq(this.query) || (this.query = e, this.view.dispatch({ effects: Ls.of(e) }));
	}
	keydown(e) {
		xe(this.view, e, "search-panel") ? e.preventDefault() : e.keyCode == 13 && e.target == this.searchField ? (e.preventDefault(), (e.shiftKey ? Ks : Gs)(this.view)) : e.keyCode == 13 && e.target == this.replaceField && (e.preventDefault(), Ys(this.view));
	}
	update(e) {
		for (let t of e.transactions) for (let e of t.effects) e.is(Ls) && !e.value.eq(this.query) && this.setQuery(e.value);
	}
	setQuery(e) {
		this.query = e, this.searchField.value = e.search, this.replaceField.value = e.replace, this.caseField.checked = e.caseSensitive, this.reField.checked = e.regexp, this.wordField.checked = e.wholeWord;
	}
	mount() {
		this.searchField.select();
	}
	get pos() {
		return 80;
	}
	get top() {
		return this.view.state.facet(ws).top;
	}
};
function ac(e, t) {
	return e.state.phrase(t);
}
var oc = 30, sc = /[\s\.,:;?!]/;
function cc(e, { from: t, to: n }) {
	let r = e.state.doc.lineAt(t), i = e.state.doc.lineAt(n).to, a = Math.max(r.from, t - oc), o = Math.min(i, n + oc), c = e.state.sliceDoc(a, o);
	if (a != r.from) {
		for (let e = 0; e < oc; e++) if (!sc.test(c[e + 1]) && sc.test(c[e])) {
			c = c.slice(e);
			break;
		}
	}
	if (o != i) {
		for (let e = c.length - 1; e > c.length - oc; e--) if (!sc.test(c[e - 1]) && sc.test(c[e])) {
			c = c.slice(0, e);
			break;
		}
	}
	return s.announce.of(`${e.state.phrase("current match")}. ${c} ${e.state.phrase("on line")} ${r.number}.`);
}
var lc = /*@__PURE__*/ s.baseTheme({
	".cm-panel.cm-search": {
		padding: "2px 6px 4px",
		position: "relative",
		"& [name=close]": {
			position: "absolute",
			top: "0",
			right: "4px",
			backgroundColor: "inherit",
			border: "none",
			font: "inherit",
			padding: 0,
			margin: 0
		},
		"& input, & button, & label": { margin: ".2em .6em .2em 0" },
		"& input[type=checkbox]": { marginRight: ".2em" },
		"& label": {
			fontSize: "80%",
			whiteSpace: "pre"
		}
	},
	"&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
	"&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
	"&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
	"&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
}), uc = [
	zs,
	/*@__PURE__*/ r.low(Us),
	lc
], dc = class {
	constructor(e, t, n) {
		this.from = e, this.to = t, this.diagnostic = n;
	}
}, fc = class e {
	constructor(e, t, n) {
		this.diagnostics = e, this.panel = t, this.selected = n;
	}
	static init(t, n, r) {
		let i = r.facet(kc).markerFilter;
		i && (t = i(t, r));
		let a = t.slice().sort((e, t) => e.from - t.from || e.to - t.to), o = new C(), s = [], c = 0, l = r.doc.iter(), u = 0, d = r.doc.length;
		for (let e = 0;;) {
			let t = e == a.length ? null : a[e];
			if (!t && !s.length) break;
			let n, r;
			if (s.length) n = c, r = s.reduce((e, t) => Math.min(e, t.to), t && t.from > n ? t.from : 1e8);
			else {
				if (n = t.from, n > d) break;
				r = t.to, s.push(t), e++;
			}
			for (; e < a.length;) {
				let t = a[e];
				if (t.from == n && (t.to > t.from || t.to == n)) s.push(t), e++, r = Math.min(t.to, r);
				else {
					r = Math.min(t.from, r);
					break;
				}
			}
			r = Math.min(r, d);
			let i = !1;
			if (s.some((e) => e.from == n && (e.to == r || r == d)) && (i = n == r, !i && r - n < 10)) {
				let e = n - (u + l.value.length);
				e > 0 && (l.next(e), u = n);
				for (let e = n;;) {
					if (e >= r) {
						i = !0;
						break;
					}
					if (!l.lineBreak && u + l.value.length > e) break;
					e = u + l.value.length, u += l.value.length, l.next();
				}
			}
			let f = Vc(s);
			if (i) o.add(n, n, w.widget({
				widget: new Pc(f),
				diagnostics: s.slice()
			}));
			else {
				let e = s.reduce((e, t) => t.markClass ? e + " " + t.markClass : e, "");
				o.add(n, r, w.mark({
					class: "cm-lintRange cm-lintRange-" + f + e,
					diagnostics: s.slice(),
					inclusiveEnd: s.some((e) => e.to > r)
				}));
			}
			if (c = r, c == d) break;
			for (let e = 0; e < s.length; e++) s[e].to <= c && s.splice(e--, 1);
		}
		let f = o.finish();
		return new e(f, n, pc(f));
	}
};
function pc(e, t = null, n = 0) {
	let r = null;
	return e.between(n, 1e9, (e, n, { spec: i }) => {
		if (!(t && i.diagnostics.indexOf(t) < 0)) if (!r) r = new dc(e, n, t || i.diagnostics[0]);
		else if (i.diagnostics.indexOf(r.diagnostic) < 0) return !1;
		else r = new dc(r.from, n, r.diagnostic);
	}), r;
}
function mc(e, t) {
	let n = t.pos, r = t.end || n, i = e.state.facet(kc).hideOn(e, n, r);
	if (i != null) return i;
	let a = e.startState.doc.lineAt(t.pos);
	return !!(e.effects.some((e) => e.is(_c)) || e.changes.touchesRange(a.from, Math.max(a.to, r)));
}
function hc(e, t) {
	return e.field(bc, !1) ? t : t.concat(a.appendConfig.of(Uc));
}
function gc(e, t) {
	return { effects: hc(e, [_c.of(t)]) };
}
var _c = /*@__PURE__*/ a.define(), vc = /*@__PURE__*/ a.define(), yc = /*@__PURE__*/ a.define(), bc = /*@__PURE__*/ _.define({
	create() {
		return new fc(w.none, null, null);
	},
	update(e, t) {
		if (t.docChanged && e.diagnostics.size) {
			let n = e.diagnostics.map(t.changes), r = null, i = e.panel;
			if (e.selected) {
				let i = t.changes.mapPos(e.selected.from, 1);
				r = pc(n, e.selected.diagnostic, i) || pc(n, null, i);
			}
			!n.size && i && t.state.facet(kc).autoPanel && (i = null), e = new fc(n, i, r);
		}
		for (let n of t.effects) if (n.is(_c)) {
			let r = t.state.facet(kc).autoPanel ? n.value.length ? Ic.open : null : e.panel;
			e = fc.init(n.value, r, t.state);
		} else n.is(vc) ? e = new fc(e.diagnostics, n.value ? Ic.open : null, e.selected) : n.is(yc) && (e = new fc(e.diagnostics, e.panel, n.value));
		return e;
	},
	provide: (e) => [ue.from(e, (e) => e.panel), s.decorations.from(e, (e) => e.diagnostics)]
}), xc = /*@__PURE__*/ w.mark({ class: "cm-lintRange cm-lintRange-active" });
function Sc(e, t, n) {
	let { diagnostics: r } = e.state.field(bc), i, a = -1, o = -1;
	r.between(t - +(n < 0), t + +(n > 0), (e, r, { spec: s }) => {
		if (t >= e && t <= r && (e == r || (t > e || n > 0) && (t < r || n < 0))) return i = s.diagnostics, a = e, o = r, !1;
	});
	let s = e.state.facet(kc).tooltipFilter;
	return i && s && (i = s(i, e.state)), i ? {
		pos: a,
		end: o,
		above: !0,
		create() {
			return { dom: Cc(e, i) };
		}
	} : null;
}
function Cc(e, t) {
	return Ee("ul", { class: "cm-tooltip-lint" }, t.map((t) => Nc(e, t, !1)));
}
var wc = (e) => {
	let t = e.state.field(bc, !1);
	(!t || !t.panel) && e.dispatch({ effects: hc(e.state, [vc.of(!0)]) });
	let n = y(e, Ic.open);
	return n && n.dom.querySelector(".cm-panel-lint ul").focus(), !0;
}, Tc = (e) => {
	let t = e.state.field(bc, !1);
	return !t || !t.panel ? !1 : (e.dispatch({ effects: vc.of(!1) }), !0);
}, Ec = [{
	key: "Mod-Shift-m",
	run: wc,
	preventDefault: !0
}, {
	key: "F8",
	run: (e) => {
		let t = e.state.field(bc, !1);
		if (!t) return !1;
		let n = e.state.selection.main, r = pc(t.diagnostics, null, n.to + 1);
		return !r && (r = pc(t.diagnostics, null, 0), !r || r.from == n.from && r.to == n.to) ? !1 : (e.dispatch({
			selection: {
				anchor: r.from,
				head: r.to
			},
			scrollIntoView: !0
		}), u(e, r.from, 1, {
			tooltip: Hc,
			until: (e) => e.docChanged || e.newSelection.main.head < r.from || e.newSelection.main.head > r.to
		}), !0);
	}
}], Dc = /*@__PURE__*/ d.fromClass(class {
	constructor(e) {
		this.view = e, this.timeout = -1, this.set = !0;
		let { delay: t } = e.state.facet(kc);
		this.lintTime = Date.now() + t, this.run = this.run.bind(this), this.timeout = setTimeout(this.run, t);
	}
	run() {
		clearTimeout(this.timeout);
		let e = Date.now();
		if (e < this.lintTime - 10) this.timeout = setTimeout(this.run, this.lintTime - e);
		else {
			this.set = !1;
			let { state: e } = this.view, { sources: t } = e.facet(kc);
			t.length && Oc(t.map((e) => Promise.resolve(e(this.view))), (t) => {
				this.view.state.doc == e.doc && this.view.dispatch(gc(this.view.state, t.reduce((e, t) => e.concat(t))));
			}, (e) => {
				Te(this.view.state, e);
			});
		}
	}
	update(e) {
		let t = e.state.facet(kc);
		(e.docChanged || t != e.startState.facet(kc) || t.needsRefresh && t.needsRefresh(e)) && (this.lintTime = Date.now() + t.delay, this.set || (this.set = !0, this.timeout = setTimeout(this.run, t.delay)));
	}
	force() {
		this.set && (this.lintTime = Date.now(), this.run());
	}
	destroy() {
		clearTimeout(this.timeout);
	}
});
function Oc(e, t, n) {
	let r = [], i = -1;
	for (let a of e) a.then((n) => {
		r.push(n), clearTimeout(i), r.length == e.length ? t(r) : i = setTimeout(() => t(r), 200);
	}, n);
}
var kc = /*@__PURE__*/ ze.define({ combine(e) {
	return {
		sources: e.map((e) => e.source).filter((e) => e != null),
		...g(e.map((e) => e.config), {
			delay: 750,
			markerFilter: null,
			tooltipFilter: null,
			needsRefresh: null,
			hideOn: () => null
		}, {
			delay: Math.max,
			markerFilter: Ac,
			tooltipFilter: Ac,
			needsRefresh: (e, t) => e ? t ? (n) => e(n) || t(n) : e : t,
			hideOn: (e, t) => e ? t ? (n, r, i) => e(n, r, i) || t(n, r, i) : e : t,
			autoPanel: (e, t) => e || t
		})
	};
} });
function Ac(e, t) {
	return e ? t ? (n, r) => t(e(n, r), r) : e : t;
}
function jc(e, t = {}) {
	return [
		kc.of({
			source: e,
			config: t
		}),
		Dc,
		Uc
	];
}
function Mc(e) {
	let t = [];
	if (e) actions: for (let { name: n } of e) {
		for (let e = 0; e < n.length; e++) {
			let r = n[e];
			if (/[a-zA-Z]/.test(r) && !t.some((e) => e.toLowerCase() == r.toLowerCase())) {
				t.push(r);
				continue actions;
			}
		}
		t.push("");
	}
	return t;
}
function Nc(e, t, n) {
	let r = n ? Mc(t.actions) : [];
	return Ee("li", { class: "cm-diagnostic cm-diagnostic-" + t.severity }, Ee("span", { class: "cm-diagnosticText" }, t.renderMessage ? t.renderMessage(e) : t.message), t.actions?.map((n, i) => {
		let a = !1, o = (r) => {
			if (r.preventDefault(), a) return;
			a = !0;
			let i = pc(e.state.field(bc).diagnostics, t);
			i && n.apply(e, i.from, i.to);
		}, { name: s } = n, c = r[i] ? s.indexOf(r[i]) : -1, l = c < 0 ? s : [
			s.slice(0, c),
			Ee("u", s.slice(c, c + 1)),
			s.slice(c + 1)
		];
		return Ee("button", {
			type: "button",
			class: "cm-diagnosticAction" + (n.markClass ? " " + n.markClass : ""),
			onclick: o,
			onmousedown: o,
			"aria-label": ` Action: ${s}${c < 0 ? "" : ` (access key "${r[i]})"`}.`
		}, l);
	}), t.source && Ee("div", { class: "cm-diagnosticSource" }, t.source));
}
var Pc = class extends De {
	constructor(e) {
		super(), this.sev = e;
	}
	eq(e) {
		return e.sev == this.sev;
	}
	toDOM() {
		return Ee("span", { class: "cm-lintPoint cm-lintPoint-" + this.sev });
	}
}, Fc = class {
	constructor(e, t) {
		this.diagnostic = t, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = Nc(e, t, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
	}
}, Ic = class e {
	constructor(e) {
		this.view = e, this.items = [];
		let t = (t) => {
			if (!(t.ctrlKey || t.altKey || t.metaKey)) {
				if (t.keyCode == 27) Tc(this.view), this.view.focus();
				else if (t.keyCode == 38 || t.keyCode == 33) this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
				else if (t.keyCode == 40 || t.keyCode == 34) this.moveSelection((this.selectedIndex + 1) % this.items.length);
				else if (t.keyCode == 36) this.moveSelection(0);
				else if (t.keyCode == 35) this.moveSelection(this.items.length - 1);
				else if (t.keyCode == 13) this.view.focus();
				else if (t.keyCode >= 65 && t.keyCode <= 90 && this.selectedIndex >= 0) {
					let { diagnostic: n } = this.items[this.selectedIndex], r = Mc(n.actions);
					for (let i = 0; i < r.length; i++) if (r[i].toUpperCase().charCodeAt(0) == t.keyCode) {
						let t = pc(this.view.state.field(bc).diagnostics, n);
						t && n.actions[i].apply(e, t.from, t.to);
					}
				} else return;
				t.preventDefault();
			}
		}, n = (e) => {
			for (let t = 0; t < this.items.length; t++) this.items[t].dom.contains(e.target) && this.moveSelection(t);
		};
		this.list = Ee("ul", {
			tabIndex: 0,
			role: "listbox",
			"aria-label": this.view.state.phrase("Diagnostics"),
			onkeydown: t,
			onclick: n
		}), this.dom = Ee("div", { class: "cm-panel-lint" }, this.list, Ee("button", {
			type: "button",
			name: "close",
			"aria-label": this.view.state.phrase("close"),
			onclick: () => Tc(this.view)
		}, "×")), this.update();
	}
	get selectedIndex() {
		let e = this.view.state.field(bc).selected;
		if (!e) return -1;
		for (let t = 0; t < this.items.length; t++) if (this.items[t].diagnostic == e.diagnostic) return t;
		return -1;
	}
	update() {
		let { diagnostics: e, selected: t } = this.view.state.field(bc), n = 0, r = !1, i = null, a = /* @__PURE__ */ new Set();
		for (e.between(0, this.view.state.doc.length, (e, o, { spec: s }) => {
			for (let e of s.diagnostics) {
				if (a.has(e)) continue;
				a.add(e);
				let o = -1, s;
				for (let t = n; t < this.items.length; t++) if (this.items[t].diagnostic == e) {
					o = t;
					break;
				}
				o < 0 ? (s = new Fc(this.view, e), this.items.splice(n, 0, s), r = !0) : (s = this.items[o], o > n && (this.items.splice(n, o - n), r = !0)), t && s.diagnostic == t.diagnostic ? s.dom.hasAttribute("aria-selected") || (s.dom.setAttribute("aria-selected", "true"), i = s) : s.dom.hasAttribute("aria-selected") && s.dom.removeAttribute("aria-selected"), n++;
			}
		}); n < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0);) r = !0, this.items.pop();
		this.items.length == 0 && (this.items.push(new Fc(this.view, {
			from: -1,
			to: -1,
			severity: "info",
			message: this.view.state.phrase("No diagnostics")
		})), r = !0), i ? (this.list.setAttribute("aria-activedescendant", i.id), this.view.requestMeasure({
			key: this,
			read: () => ({
				sel: i.dom.getBoundingClientRect(),
				panel: this.list.getBoundingClientRect()
			}),
			write: ({ sel: e, panel: t }) => {
				let n = t.height / this.list.offsetHeight;
				e.top < t.top ? this.list.scrollTop -= (t.top - e.top) / n : e.bottom > t.bottom && (this.list.scrollTop += (e.bottom - t.bottom) / n);
			}
		})) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), r && this.sync();
	}
	sync() {
		let e = this.list.firstChild;
		function t() {
			let t = e;
			e = t.nextSibling, t.remove();
		}
		for (let n of this.items) if (n.dom.parentNode == this.list) {
			for (; e != n.dom;) t();
			e = n.dom.nextSibling;
		} else this.list.insertBefore(n.dom, e);
		for (; e;) t();
	}
	moveSelection(e) {
		if (this.selectedIndex < 0) return;
		let t = pc(this.view.state.field(bc).diagnostics, this.items[e].diagnostic);
		t && this.view.dispatch({
			selection: {
				anchor: t.from,
				head: t.to
			},
			scrollIntoView: !0,
			effects: yc.of(t)
		});
	}
	static open(t) {
		return new e(t);
	}
};
function Lc(e, t = "viewBox=\"0 0 40 40\"") {
	return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${t}>${encodeURIComponent(e)}</svg>')`;
}
function Rc(e) {
	return Lc(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${e}" fill="none" stroke-width=".7"/>`, "width=\"6\" height=\"3\"");
}
var zc = /*@__PURE__*/ s.baseTheme({
	".cm-diagnostic": {
		padding: "3px 6px 3px 8px",
		marginLeft: "-1px",
		display: "block",
		whiteSpace: "pre-wrap"
	},
	".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
	".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
	".cm-diagnostic-info": { borderLeft: "5px solid #999" },
	".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
	".cm-diagnosticAction": {
		font: "inherit",
		border: "none",
		padding: "2px 4px",
		backgroundColor: "#444",
		color: "white",
		borderRadius: "3px",
		marginLeft: "8px",
		cursor: "pointer"
	},
	".cm-diagnosticSource": {
		fontSize: "70%",
		opacity: .7
	},
	".cm-lintRange": {
		backgroundPosition: "left bottom",
		backgroundRepeat: "repeat-x",
		paddingBottom: "0.7px"
	},
	".cm-lintRange-error": { backgroundImage: /*@__PURE__*/ Rc("#f11") },
	".cm-lintRange-warning": { backgroundImage: /*@__PURE__*/ Rc("orange") },
	".cm-lintRange-info": { backgroundImage: /*@__PURE__*/ Rc("#999") },
	".cm-lintRange-hint": { backgroundImage: /*@__PURE__*/ Rc("#66d") },
	".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
	".cm-tooltip-lint": {
		padding: 0,
		margin: 0
	},
	".cm-lintPoint": {
		position: "relative",
		"&:after": {
			content: "\"\"",
			position: "absolute",
			bottom: 0,
			left: "-2px",
			borderLeft: "3px solid transparent",
			borderRight: "3px solid transparent",
			borderBottom: "4px solid #d11"
		}
	},
	".cm-lintPoint-warning": { "&:after": { borderBottomColor: "orange" } },
	".cm-lintPoint-info": { "&:after": { borderBottomColor: "#999" } },
	".cm-lintPoint-hint": { "&:after": { borderBottomColor: "#66d" } },
	".cm-panel.cm-panel-lint": {
		position: "relative",
		"& ul": {
			maxHeight: "100px",
			overflowY: "auto",
			"& [aria-selected]": {
				backgroundColor: "#ddd",
				"& u": { textDecoration: "underline" }
			},
			"&:focus [aria-selected]": {
				background_fallback: "#bdf",
				backgroundColor: "Highlight",
				color_fallback: "white",
				color: "HighlightText"
			},
			"& u": { textDecoration: "none" },
			padding: 0,
			margin: 0
		},
		"& [name=close]": {
			position: "absolute",
			top: "0",
			right: "2px",
			background: "inherit",
			border: "none",
			font: "inherit",
			padding: 0,
			margin: 0
		}
	},
	"&dark .cm-lintRange-active": { backgroundColor: "#86714a80" },
	"&dark .cm-panel.cm-panel-lint ul": { "& [aria-selected]": { backgroundColor: "#2e343e" } }
});
function Bc(e) {
	return e == "error" ? 4 : e == "warning" ? 3 : e == "info" ? 2 : 1;
}
function Vc(e) {
	let t = "hint", n = 1;
	for (let r of e) {
		let e = Bc(r.severity);
		e > n && (n = e, t = r.severity);
	}
	return t;
}
var Hc = /*@__PURE__*/ Oe(Sc, { hideOn: mc }), Uc = [
	bc,
	/*@__PURE__*/ s.decorations.compute([bc], (e) => {
		let { selected: t, panel: n } = e.field(bc);
		return !t || !n || t.from == t.to ? w.none : w.set([xc.range(t.from, t.to)]);
	}),
	Hc,
	zc
], Wc = [
	oe(),
	Me(),
	we(),
	Gi(),
	me(),
	ee(),
	ne(),
	ce.allowMultipleSelections.of(!0),
	n(),
	ve(Ne, { fallback: !0 }),
	ke(),
	Ge(),
	Ue(),
	le(),
	te(),
	de(),
	ms(),
	ge.of([
		...He,
		...$o,
		...rc,
		...ua,
		...re,
		...We,
		...Ec
	])
], Gc = Object.freeze({
	autofocus: !1,
	disabled: !1,
	indentWithTab: !0,
	tabSize: 2,
	placeholder: "",
	autoDestroy: !0,
	extensions: [Wc]
}), Kc = Symbol("vue-codemirror-global-config"), qc, Jc = function(e) {
	var t = e.onUpdate, n = e.onChange, r = e.onFocus, i = e.onBlur, a = function(e, t) {
		var n = {};
		for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
		if (e != null && typeof Object.getOwnPropertySymbols == "function") {
			var i = 0;
			for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
		}
		return n;
	}(e, [
		"onUpdate",
		"onChange",
		"onFocus",
		"onBlur"
	]);
	return ce.create({
		doc: a.doc,
		selection: a.selection,
		extensions: (Array.isArray(a.extensions) ? a.extensions : [a.extensions]).concat([s.updateListener.of((function(e) {
			t(e), e.docChanged && n(e.state.doc.toString(), e), e.focusChanged && (e.view.hasFocus ? r(e) : i(e));
		}))])
	});
}, Yc = function(e) {
	var t = new Ie();
	return {
		compartment: t,
		run: function(n) {
			t.get(e.state) ? e.dispatch({ effects: t.reconfigure(n) }) : e.dispatch({ effects: a.appendConfig.of(t.of(n)) });
		}
	};
}, Xc = function(e, t) {
	var n = Yc(e), r = n.compartment, i = n.run;
	return function(n) {
		var a = r.get(e.state);
		i(n ?? a !== t ? t : []);
	};
}, Zc = {
	type: Boolean,
	default: void 0
}, Qc = {
	autofocus: Zc,
	disabled: Zc,
	indentWithTab: Zc,
	tabSize: Number,
	placeholder: String,
	style: Object,
	autoDestroy: Zc,
	phrases: Object,
	root: Object,
	extensions: Array,
	selection: Object
}, $c = { modelValue: {
	type: String,
	default: ""
} }, el = Object.assign(Object.assign({}, Qc), $c);
(function(e) {
	e.Change = "change", e.Update = "update", e.Focus = "focus", e.Blur = "blur", e.Ready = "ready", e.ModelUpdate = "update:modelValue";
})(qc ||= {});
var tl = {};
tl[qc.Change] = function(e, t) {
	return !0;
}, tl[qc.Update] = function(e) {
	return !0;
}, tl[qc.Focus] = function(e) {
	return !0;
}, tl[qc.Blur] = function(e) {
	return !0;
}, tl[qc.Ready] = function(e) {
	return !0;
};
var nl = {};
nl[qc.ModelUpdate] = tl[qc.Change];
var rl = Object.assign(Object.assign({}, tl), nl), il = P({
	name: "VueCodemirror",
	props: Object.assign({}, el),
	emits: Object.assign({}, rl),
	setup: function(e, t) {
		var n = ht(), r = ht(), i = ht(), a = Object.assign(Object.assign({}, Gc), et(Kc, {})), o = D((function() {
			var t = {};
			return Object.keys(_t(e)).forEach((function(n) {
				n !== "modelValue" && (t[n] = e[n] ?? a[n]);
			})), t;
		}));
		return lt((function() {
			r.value = Jc({
				doc: e.modelValue,
				selection: o.value.selection,
				extensions: a.extensions ?? [],
				onFocus: function(e) {
					return t.emit(qc.Focus, e);
				},
				onBlur: function(e) {
					return t.emit(qc.Blur, e);
				},
				onUpdate: function(e) {
					return t.emit(qc.Update, e);
				},
				onChange: function(n, r) {
					n !== e.modelValue && (t.emit(qc.Change, n, r), t.emit(qc.ModelUpdate, n, r));
				}
			}), i.value = function(e) {
				return new s(Object.assign({}, e));
			}({
				state: r.value,
				parent: n.value,
				root: o.value.root
			});
			var c = function(e) {
				var t = function() {
					return e.state.doc.toString();
				}, n = Yc(e).run, r = Xc(e, [s.editable.of(!1), ce.readOnly.of(!0)]), i = Xc(e, ge.of([es])), a = Yc(e).run, o = Yc(e).run, c = Yc(e).run, l = Yc(e).run;
				return {
					focus: function() {
						return e.focus();
					},
					getDoc: t,
					setDoc: function(n) {
						n !== t() && e.dispatch({ changes: {
							from: 0,
							to: e.state.doc.length,
							insert: n
						} });
					},
					reExtensions: n,
					toggleDisabled: r,
					toggleIndentWithTab: i,
					setTabSize: function(e) {
						a([ce.tabSize.of(e), S.of(" ".repeat(e))]);
					},
					setPhrases: function(e) {
						o([ce.phrases.of(e)]);
					},
					setPlaceholder: function(e) {
						c(Ae(e));
					},
					setStyle: function(e) {
						e === void 0 && (e = {}), l(s.theme({ "&": Object.assign({}, e) }));
					}
				};
			}(i.value);
			U((function() {
				return e.modelValue;
			}), (function(e) {
				e !== c.getDoc() && c.setDoc(e);
			})), U((function() {
				return e.extensions;
			}), (function(e) {
				return c.reExtensions(e || []);
			}), { immediate: !0 }), U((function() {
				return o.value.disabled;
			}), (function(e) {
				return c.toggleDisabled(e);
			}), { immediate: !0 }), U((function() {
				return o.value.indentWithTab;
			}), (function(e) {
				return c.toggleIndentWithTab(e);
			}), { immediate: !0 }), U((function() {
				return o.value.tabSize;
			}), (function(e) {
				return c.setTabSize(e);
			}), { immediate: !0 }), U((function() {
				return o.value.phrases;
			}), (function(e) {
				return c.setPhrases(e || {});
			}), { immediate: !0 }), U((function() {
				return o.value.placeholder;
			}), (function(e) {
				return c.setPlaceholder(e);
			}), { immediate: !0 }), U((function() {
				return o.value.style;
			}), (function(e) {
				return c.setStyle(e);
			}), { immediate: !0 }), o.value.autofocus && c.focus(), t.emit(qc.Ready, {
				state: r.value,
				view: i.value,
				container: n.value
			});
		})), st((function() {
			o.value.autoDestroy && i.value && function(e) {
				e.destroy();
			}(i.value);
		})), function() {
			return $e("div", {
				class: "v-codemirror",
				style: { display: "contents" },
				ref: n
			});
		};
	}
}), al = p({
	String: h.string,
	Number: h.number,
	"True False": h.bool,
	PropertyName: h.propertyName,
	Null: h.null,
	", :": h.separator,
	"[ ]": h.squareBracket,
	"{ }": h.brace
}), ol = Ke.deserialize({
	version: 14,
	states: "$bOVQPOOOOQO'#Cb'#CbOnQPO'#CeOvQPO'#ClOOQO'#Cr'#CrQOQPOOOOQO'#Cg'#CgO}QPO'#CfO!SQPO'#CtOOQO,59P,59PO![QPO,59PO!aQPO'#CuOOQO,59W,59WO!iQPO,59WOVQPO,59QOqQPO'#CmO!nQPO,59`OOQO1G.k1G.kOVQPO'#CnO!vQPO,59aOOQO1G.r1G.rOOQO1G.l1G.lOOQO,59X,59XOOQO-E6k-E6kOOQO,59Y,59YOOQO-E6l-E6l",
	stateData: "#O~OeOS~OQSORSOSSOTSOWQO_ROgPO~OVXOgUO~O^[O~PVO[^O~O]_OVhX~OVaO~O]bO^iX~O^dO~O]_OVha~O]bO^ia~O",
	goto: "!kjPPPPPPkPPkqwPPPPk{!RPPP!XP!e!hXSOR^bQWQRf_TVQ_Q`WRg`QcZRicQTOQZRQe^RhbRYQR]R",
	nodeNames: "⚠ JsonText True False Null Number String } { Object Property PropertyName : , ] [ Array",
	maxTerm: 25,
	nodeProps: [
		[
			"isolate",
			-2,
			6,
			11,
			""
		],
		[
			"openedBy",
			7,
			"{",
			14,
			"["
		],
		[
			"closedBy",
			8,
			"}",
			15,
			"]"
		]
	],
	propSources: [al],
	skippedNodes: [0],
	repeatNodeCount: 2,
	tokenData: "(|~RaXY!WYZ!W]^!Wpq!Wrs!]|}$u}!O$z!Q!R%T!R![&c![!]&t!}#O&y#P#Q'O#Y#Z'T#b#c'r#h#i(Z#o#p(r#q#r(w~!]Oe~~!`Wpq!]qr!]rs!xs#O!]#O#P!}#P;'S!];'S;=`$o<%lO!]~!}Og~~#QXrs!]!P!Q!]#O#P!]#U#V!]#Y#Z!]#b#c!]#f#g!]#h#i!]#i#j#m~#pR!Q![#y!c!i#y#T#Z#y~#|R!Q![$V!c!i$V#T#Z$V~$YR!Q![$c!c!i$c#T#Z$c~$fR!Q![!]!c!i!]#T#Z!]~$rP;=`<%l!]~$zO]~~$}Q!Q!R%T!R![&c~%YRT~!O!P%c!g!h%w#X#Y%w~%fP!Q![%i~%nRT~!Q![%i!g!h%w#X#Y%w~%zR{|&T}!O&T!Q![&Z~&WP!Q![&Z~&`PT~!Q![&Z~&hST~!O!P%c!Q![&c!g!h%w#X#Y%w~&yO[~~'OO_~~'TO^~~'WP#T#U'Z~'^P#`#a'a~'dP#g#h'g~'jP#X#Y'm~'rOR~~'uP#i#j'x~'{P#`#a(O~(RP#`#a(U~(ZOS~~(^P#f#g(a~(dP#i#j(g~(jP#X#Y(m~(rOQ~~(wOW~~(|OV~",
	tokenizers: [0],
	topRules: { JsonText: [0, 1] },
	tokenPrec: 0
}), sl = /* @__PURE__ */ b({
	json: () => dl,
	jsonLanguage: () => ul,
	jsonParseLinter: () => cl
}), cl = () => (e) => {
	try {
		JSON.parse(e.state.doc.toString());
	} catch (t) {
		if (!(t instanceof SyntaxError)) throw t;
		let n = ll(t, e.state.doc);
		return [{
			from: n,
			message: t.message,
			severity: "error",
			to: n
		}];
	}
	return [];
};
function ll(e, t) {
	let n;
	return (n = e.message.match(/at position (\d+)/)) ? Math.min(+n[1], t.length) : (n = e.message.match(/at line (\d+) column (\d+)/)) ? Math.min(t.line(+n[1]).from + +n[2] - 1, t.length) : 0;
}
var ul = /*@__PURE__*/ Ce.define({
	name: "json",
	parser: /*@__PURE__*/ ol.configure({ props: [/*@__PURE__*/ x.add({
		Object: /*@__PURE__*/ be({ except: /^\s*\}/ }),
		Array: /*@__PURE__*/ be({ except: /^\s*\]/ })
	}), /*@__PURE__*/ Fe.add({ "Object Array": fe })] }),
	languageData: {
		closeBrackets: { brackets: [
			"[",
			"{",
			"\""
		] },
		indentOnInput: /^\s*[\}\]]$/
	}
});
function dl() {
	return new ae(ul);
}
//#endregion
//#region src/components/composed/form/form-code-editor.vue
var fl = ["aria-label"], pl = { class: "code-editor-actions" }, ml = {
	key: 0,
	class: "code-editor-hint-message"
}, hl = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HFormCodeEditor",
	inheritAttrs: !1
}, {
	__name: "form-code-editor",
	props: {
		modelValue: {
			type: String,
			default: ""
		},
		language: {
			type: String,
			default: "json",
			validator: (e) => [
				"json",
				"javascript",
				"text"
			].includes(e)
		},
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: "mdi:mdi-code-json"
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "on-surface-variant"
		},
		rounded: {
			type: [
				Boolean,
				String,
				Number
			],
			default: void 0
		},
		density: {
			type: String,
			default: "comfortable"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		rows: {
			type: [String, Number],
			default: 8
		},
		autoGrow: {
			type: Boolean,
			default: !0
		},
		placeholder: {
			type: String,
			default: ""
		},
		rules: {
			type: Array,
			default: () => []
		},
		hint: {
			type: String,
			default: void 0
		},
		persistentHint: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		let r = G(e, "HFormCodeEditor"), i = n, a = ht(null), o = R(null), c = R(""), l = R(!1), u = R(""), d = D(() => {
			let e = o.value?.isValid === !1;
			return l.value || e;
		}), f = D(() => [...r.rules, (e) => {
			if (!e || e.trim() === "") return !0;
			if (r.language === "json") try {
				return JSON.parse(e), !0;
			} catch (e) {
				return `${K("json_invalid")}: ${e.message}`;
			}
			if (r.language === "javascript") try {
				return Function(e), !0;
			} catch (e) {
				return `${K("javascript_invalid")}: ${e.message}`;
			}
			return !0;
		}]), p = D(() => ["json"].includes(r.language)), m = D(() => ({
			json: "Format JSON",
			javascript: "Format JavaScript",
			text: "Plain text"
		})[r.language] || "Format Code"), h = D(() => `${(r.density === "compact" ? 20 : r.density === "comfortable" ? 24 : 28) * Number(r.rows)}px`), g = D(() => {
			let e = r.label || K("code_editor"), t = [
				s.lineWrapping,
				s.editable.of(!r.disabled),
				s.contentAttributes.of({
					"aria-label": e,
					"aria-multiline": "true"
				})
			];
			return r.language === "json" ? t.unshift(dl(), jc(cl())) : r.language === "javascript" && t.unshift(qe()), t;
		});
		function _(e) {
			a.value = e.view;
		}
		function v(e) {
			e.key === "Enter" && e.stopPropagation();
		}
		function y(e) {
			x(e);
		}
		function b() {
			S();
		}
		U(() => r.modelValue, (e) => {
			if (e !== c.value && (c.value = e || "", e)) if (r.language === "json") try {
				let t = JSON.parse(e);
				c.value = JSON.stringify(t, null, 2), l.value = !1, u.value = "";
			} catch {
				x(e);
			}
			else r.language === "javascript" && x(e);
		}, { immediate: !0 }), U(c, (e) => {
			i("update:modelValue", e);
		});
		function x(e = c.value) {
			if (!e || e.trim() === "") return l.value = !1, u.value = "", !0;
			if (r.language === "json") try {
				return JSON.parse(e), l.value = !1, u.value = "", !0;
			} catch (e) {
				return l.value = !0, u.value = `${K("json_invalid")}: ${e.message}`, !1;
			}
			if (r.language === "javascript") try {
				return Function(e), l.value = !1, u.value = "", !0;
			} catch (e) {
				return l.value = !0, u.value = `${K("javascript_invalid")}: ${e.message}`, !1;
			}
			return !0;
		}
		function S() {
			if (!c.value || c.value.trim() === "") {
				l.value = !1, u.value = "";
				return;
			}
			if (r.language === "json") try {
				let e = JSON.parse(c.value);
				c.value = JSON.stringify(e, null, 2), l.value = !1, u.value = "";
			} catch (e) {
				l.value = !0, u.value = `${K("json_invalid")}: ${e.message}`;
			}
			r.language;
		}
		function C() {
			a.value && a.value.focus();
		}
		return t({
			view: a,
			focus: C,
			formatCode: S,
			validateCode: x
		}), (t, n) => (L(), O(di, {
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error || d.value,
			"aria-label": e.ariaLabel
		}, {
			default: W(() => [N(wn, {
				ref_key: "vInputRef",
				ref: o,
				modelValue: c.value,
				"onUpdate:modelValue": n[1] ||= (e) => c.value = e,
				rules: f.value,
				"hide-details": "auto",
				class: "code-editor-v-input"
			}, {
				default: W(() => [j("div", {
					class: "code-editor-wrapper",
					role: "application",
					"aria-label": e.label || H(K)("code_editor"),
					onKeydown: v
				}, [j("div", { class: I(["code-editor-container", {
					"code-editor-error": d.value,
					"code-editor-disabled": e.disabled
				}]) }, [N(H(il), {
					modelValue: c.value,
					"onUpdate:modelValue": n[0] ||= (e) => c.value = e,
					placeholder: e.placeholder,
					style: ot({ height: h.value }),
					"indent-with-tab": !0,
					"tab-size": 2,
					extensions: g.value,
					disabled: e.disabled,
					onReady: _,
					onChange: y,
					onBlur: b
				}, null, 8, [
					"modelValue",
					"placeholder",
					"style",
					"extensions",
					"disabled"
				]), j("div", pl, [p.value ? (L(), O(un, {
					key: 0,
					text: m.value,
					location: "top"
				}, {
					activator: W(({ props: t }) => [N(J, F(t, {
						icon: "mdi:mdi-code-braces",
						size: "small",
						role: "button",
						tabindex: "0",
						"aria-label": H(K)("format_code"),
						class: "cursor-pointer",
						disabled: e.disabled || d.value,
						onClick: S
					}), null, 16, ["aria-label", "disabled"])]),
					_: 1
				}, 8, ["text"])) : k("", !0), d.value ? (L(), O(J, {
					key: 1,
					icon: "mdi:mdi-alert-circle",
					size: "small",
					color: "error"
				})) : c.value && !d.value ? (L(), O(J, {
					key: 2,
					icon: "mdi:mdi-check-circle",
					size: "small",
					color: "success"
				})) : k("", !0)])], 2), e.hint && (e.persistentHint || !d.value) ? (L(), A("div", ml, V(e.hint), 1)) : k("", !0)], 40, fl)]),
				_: 1
			}, 8, ["modelValue", "rules"])]),
			_: 1
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-374fe316"]]), gl = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({
	name: "HActionButton",
	inheritAttrs: !1
}, {
	__name: "action-button",
	props: {
		type: {
			type: String,
			default: "primary",
			validator: (e) => [
				"primary",
				"secondary",
				"info",
				"error",
				"warning",
				"success",
				"neutral",
				"custom"
			].includes(e)
		},
		name: {
			type: String,
			default: void 0,
			validator: (e) => e && !e.startsWith("HActionButton") ? (console.error(`[HActionButton] Invalid name "${e}": Theme scope names must start with "HActionButton" prefix. Example: "HActionButtonResetButton" instead of "${e}"`), !1) : !0
		},
		color: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: void 0
		},
		active: Boolean,
		appendIcon: String,
		block: Boolean,
		border: [
			Boolean,
			Number,
			String
		],
		density: String,
		disabled: Boolean,
		elevation: [Number, String],
		exact: Boolean,
		flat: Boolean,
		height: [Number, String],
		href: String,
		icon: [Boolean, String],
		loading: [Boolean, String],
		location: String,
		maxHeight: [Number, String],
		maxWidth: [Number, String],
		minHeight: [Number, String],
		minWidth: [Number, String],
		position: String,
		prependIcon: String,
		replace: Boolean,
		ripple: {
			type: [Boolean, Object],
			default: !0
		},
		rounded: [
			Boolean,
			Number,
			String
		],
		size: {
			type: [String, Number],
			default: "default"
		},
		slim: Boolean,
		stacked: Boolean,
		tag: {
			type: String,
			default: "button"
		},
		text: String,
		theme: String,
		tile: Boolean,
		to: [String, Object],
		value: null,
		width: [Number, String]
	},
	setup(e) {
		let t = e, n = G(t, D(() => {
			if (t.name) return t.name;
			let e = t.type || "primary", n = `HActionButton${e.charAt(0).toUpperCase() + e.slice(1)}`;
			if (t.size && t.size !== "default") {
				let e = typeof t.size == "string" ? t.size.charAt(0).toUpperCase() + t.size.slice(1) : t.size;
				n += e;
			}
			return n;
		}).value), r = {
			primary: {
				color: "primary",
				variant: "flat",
				rounded: "sm"
			},
			secondary: {
				color: "secondary",
				variant: "flat",
				rounded: "sm"
			},
			info: {
				color: "info",
				variant: "flat",
				rounded: "sm"
			},
			error: {
				color: "error",
				variant: "flat",
				rounded: "sm"
			},
			warning: {
				color: "warning",
				variant: "flat",
				rounded: "sm"
			},
			success: {
				color: "success",
				variant: "flat",
				rounded: "sm"
			},
			neutral: {
				color: "neutral-100",
				variant: "flat",
				rounded: "sm"
			},
			custom: {}
		}, i = D(() => n.type === "custom" || t.color ? t.color : n.color ? n.color : r[n.type]?.color || "primary"), a = D(() => n.type === "custom" || t.variant ? t.variant : n.variant ? n.variant : r[n.type]?.variant || "elevated"), o = D(() => n.type === "custom" || t.rounded !== void 0 ? t.rounded : n.rounded === void 0 ? r[n.type]?.rounded || 4 : n.rounded), s = D(() => n.type === "custom" || t.elevation !== void 0 ? t.elevation : n.elevation === void 0 ? r[n.type]?.elevation || 0 : n.elevation), c = D(() => n.type === "custom" || t.border !== void 0 ? t.border : n.border === void 0 ? r[n.type]?.border : n.border);
		return (e, t) => (L(), O(q, F({
			ref: "componentRef",
			class: H(n).type === "custom" ? void 0 : ["h-action-button", `h-action-button--${H(n).type}`]
		}, {
			color: i.value,
			variant: a.value,
			elevation: s.value,
			rounded: o.value,
			border: c.value,
			...e.$attrs,
			active: H(n).active,
			appendIcon: H(n).appendIcon,
			block: H(n).block,
			density: H(n).density,
			disabled: H(n).disabled,
			exact: H(n).exact,
			flat: H(n).flat,
			height: H(n).height,
			href: H(n).href,
			icon: H(n).icon,
			loading: H(n).loading,
			location: H(n).location,
			maxHeight: H(n).maxHeight,
			maxWidth: H(n).maxWidth,
			minHeight: H(n).minHeight,
			minWidth: H(n).minWidth,
			position: H(n).position,
			prependIcon: H(n).prependIcon,
			replace: H(n).replace,
			ripple: H(n).ripple,
			size: H(n).size,
			slim: H(n).slim,
			stacked: H(n).stacked,
			tag: H(n).tag,
			text: H(n).text,
			theme: H(n).theme,
			tile: H(n).tile,
			to: H(n).to,
			value: H(n).value,
			width: H(n).width
		}), Ye({ _: 2 }, [z(e.$slots, (t, n) => ({
			name: n,
			fn: W((t) => [B(e.$slots, n, at(Qe(t || {})), void 0, !0)])
		}))]), 1040, ["class"]));
	}
}), [["__scopeId", "data-v-e71debd6"]]), _l = /* @__PURE__ */ P({
	__name: "route-renderer",
	props: { route: {} },
	setup(e) {
		let t = e;
		dt(Dn, t.route);
		let n = D(() => {
			let e = t.route?.matched[0]?.components?.default;
			return e ? $e(e) : null;
		});
		return (e, t) => (L(), O(mt(n.value)));
	}
}), vl = /* @__PURE__ */ function(e) {
	return e.SELF = "_self", e.BLANK = "_blank", e.MODAL = "_modal", e.WINDOW = "_window", e;
}({}), yl = ["href", "target"], bl = ["href", "onClick"], xl = ["href"], Sl = ["href"], Cl = [
	"name",
	"title",
	"src"
], wl = {
	key: 1,
	class: "h-dialog-internal__content"
}, Tl = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	inheritAttrs: !1,
	__name: "action-link",
	props: {
		activeClass: { default: "active" },
		inactiveClass: { default: "inactive" },
		target: { default: vl.SELF },
		dialogTitle: { default: "" },
		to: {},
		noRoute: {
			type: Boolean,
			default: !1
		},
		windowName: {}
	},
	setup(e) {
		let t = G(e, "HActionLink"), n = kn(), r = R(null), { baseUrl: i } = Vt(), a = D(() => {
			let [e] = t.to?.split("|") ?? [""];
			return e;
		});
		function o(e, t) {
			e.defaultPrevented || t(e);
		}
		function s(e) {
			e.defaultPrevented || (e.preventDefault(), m(!0));
		}
		function c() {
			let [, e] = t.to.split("|") ?? ["", ""], n = e?.split(",").reduce((e, t) => {
				let [n, r] = t.split("=");
				return r ? e[n] = r === "true" ? !0 : r === "false" ? !1 : r : e[n] = null, e;
			}, {}) ?? {};
			n.width = n.width ?? (window.innerWidth < 600 ? window.innerWidth * .9 : 600), n.height = n.height ?? (window.innerHeight < 600 ? window.innerHeight * .9 : 600), n.left = window.screenX + (n.left ? +n.left : (window.innerWidth - n.width) / 2), n.right = window.screenY + (n.top ? +n.top : (window.innerHeight - n.height) / 2);
			let r = Object.entries(n).map(([e, t]) => t === null ? e : `${e}=${t}`).join(",");
			window.open(l.value, t.windowName ?? `h-window-${crypto.randomUUID()}`, r);
		}
		let l = D(() => jt(a.value, i, t.noRoute)), u = D(() => {
			let [, e] = t.to?.split("|") ?? ["", ""];
			return e ? e.split(",").reduce((e, t) => {
				let [n, r] = t.split(":");
				return e[n] = r === "true" ? !0 : r === "false" ? !1 : r, e;
			}, {}) : {};
		}), d = D(() => {
			let e = Object.assign({}, u.value);
			return e.fullscreen && (e.width = "100%", e.height = "100%"), e;
		}), f = D(() => u.value.fullscreen ? {
			height: "92%",
			position: "absolute"
		} : {}), [p, m] = Ln(), h = D(() => Mt(l.value)), g = D(() => h.value && !Nt(a.value, i));
		return U(() => l.value, (e) => {
			e && En(n.resolve(e)).then((e) => {
				r.value = e;
			}).catch(() => {
				r.value = null;
			});
		}, { immediate: !0 }), (t, n) => {
			let i = pt("h-dialog");
			return e.target !== H(vl).MODAL && e.target !== H(vl).WINDOW ? (L(), A(E, { key: 0 }, [h.value ? (L(), A("a", F({
				key: 0,
				class: "h-action-link"
			}, t.$attrs, {
				href: l.value,
				target: e.target
			}), [B(t.$slots, "default", {}, void 0, !0)], 16, yl)) : (L(), O(H(Tn), F({ key: 1 }, t.$props, {
				to: l.value,
				custom: ""
			}), {
				default: W(({ isActive: n, href: r, navigate: i }) => [j("a", F(t.$attrs, {
					class: ["h-action-link", n ? e.activeClass : e.inactiveClass],
					href: r,
					onClick: (e) => o(e, i)
				}), [B(t.$slots, "default", {}, void 0, !0)], 16, bl)]),
				_: 3
			}, 16, ["to"]))], 64)) : e.target === H(vl).WINDOW ? (L(), A("a", F({ key: 1 }, t.$attrs, {
				class: "h-action-link",
				href: l.value,
				target: "_blank",
				onClick: n[0] ||= Dt((e) => c(), ["prevent"])
			}), [B(t.$slots, "default", {}, void 0, !0)], 16, xl)) : (L(), A(E, { key: 2 }, [j("a", {
				class: "h-action-link",
				href: l.value,
				onClick: s
			}, [B(t.$slots, "default", {}, void 0, !0)], 8, Sl), N(i, F({
				modelValue: H(p),
				"onUpdate:modelValue": n[1] ||= (e) => tt(p) ? p.value = e : null,
				class: "h-custom-dialog"
			}, d.value, { "dialog-height": g.value ? "50%" : "auto" }), {
				header: W(() => [j("h4", null, V(e.dialogTitle), 1)]),
				default: W(() => [j("div", { class: I(["h-100", { "h-dialog-internal__container": !g.value }]) }, [g.value ? (L(), A("iframe", {
					key: 0,
					name: e.windowName,
					title: e.dialogTitle,
					src: l.value,
					class: "h-dialog-external__content",
					style: ot(f.value)
				}, null, 12, Cl)) : (L(), A("div", wl, [r.value ? (L(), O(_l, {
					key: 0,
					route: r.value
				}, null, 8, ["route"])) : k("", !0)]))], 2)]),
				_: 1
			}, 16, ["modelValue", "dialog-height"])], 64));
		};
	}
}), [["__scopeId", "data-v-bc1e26c3"]]), El = { class: "h-action-buttons" }, Dl = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({ name: "HActionButtons" }, {
	__name: "action-buttons",
	props: {
		actions: {
			type: Array,
			default: () => [],
			validator: (e) => e.every((e) => typeof e == "object" && e.description)
		},
		variant: {
			type: String,
			default: "buttons",
			validator: (e) => [
				"buttons",
				"dropdown",
				"icons",
				"dots"
			].includes(e)
		},
		buttonProps: {
			type: Object,
			default: () => ({})
		}
	},
	setup(e) {
		function t(e, t) {
			e.callback && typeof e.callback == "function" && e.callback(e, t) === !1 && (t.preventDefault(), t.stopPropagation(), t.stopImmediatePropagation());
		}
		return (n, r) => (L(), A("div", El, [
			e.variant === "buttons" ? (L(!0), A(E, { key: 0 }, z(e.actions, (e, n) => (L(), A(E, { key: n }, [e.url || e.to ? (L(), O(Tl, {
				key: 0,
				to: e.url || e.to,
				target: e.target
			}, {
				default: W(() => [N(gl, {
					type: e.type,
					color: e.color,
					"prepend-icon": e.icon,
					text: e.description,
					class: "h-action-buttons__button",
					onClick: (n) => t(e, n)
				}, null, 8, [
					"type",
					"color",
					"prepend-icon",
					"text",
					"onClick"
				])]),
				_: 2
			}, 1032, ["to", "target"])) : (L(), O(gl, {
				key: 1,
				type: e.type,
				color: e.color,
				"prepend-icon": e.icon,
				text: e.description,
				class: "h-action-buttons__button",
				onClick: (n) => t(e, n)
			}, null, 8, [
				"type",
				"color",
				"prepend-icon",
				"text",
				"onClick"
			]))], 64))), 128)) : k("", !0),
			e.variant === "icons" ? (L(!0), A(E, { key: 1 }, z(e.actions, (e, n) => (L(), A(E, { key: n }, [e.url || e.to ? (L(), O(Tl, {
				key: 0,
				to: e.url || e.to,
				target: e.target
			}, {
				default: W(() => [N(gl, {
					type: e.type,
					color: e.color,
					icon: !0,
					"aria-label": e.description,
					class: "h-action-buttons__icon",
					onClick: (n) => t(e, n)
				}, {
					default: W(() => [N(J, null, {
						default: W(() => [M(V(e.icon), 1)]),
						_: 2
					}, 1024), N(un, {
						activator: "parent",
						location: "bottom"
					}, {
						default: W(() => [M(V(e.description), 1)]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1032, [
					"type",
					"color",
					"aria-label",
					"onClick"
				])]),
				_: 2
			}, 1032, ["to", "target"])) : (L(), O(gl, {
				key: 1,
				type: e.type,
				color: e.color,
				icon: !0,
				"aria-label": e.description,
				class: "h-action-buttons__icon",
				onClick: (n) => t(e, n)
			}, {
				default: W(() => [N(J, null, {
					default: W(() => [M(V(e.icon), 1)]),
					_: 2
				}, 1024), N(un, {
					activator: "parent",
					location: "bottom"
				}, {
					default: W(() => [M(V(e.description), 1)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1032, [
				"type",
				"color",
				"aria-label",
				"onClick"
			]))], 64))), 128)) : k("", !0),
			e.variant === "dropdown" || e.variant === "dots" ? (L(), O(Sn, { key: 2 }, {
				activator: W(({ props: t }) => [e.variant === "dropdown" ? (L(), O(gl, F({ key: 0 }, {
					...t,
					...e.buttonProps
				}, {
					text: e.buttonProps?.text || H(K)("actions"),
					"append-icon": "mdi:mdi-chevron-down",
					class: "h-action-buttons__dropdown-trigger"
				}), null, 16, ["text"])) : (L(), O(gl, F({ key: 1 }, {
					...t,
					...e.buttonProps
				}, {
					icon: "mdi:mdi-dots-vertical",
					type: "custom",
					variant: "text",
					"aria-label": e.buttonProps?.["aria-label"] || H(K)("actions"),
					class: "h-action-buttons__dots-trigger"
				}), null, 16, ["aria-label"]))]),
				default: W(() => [N(Bn, { density: "compact" }, {
					default: W(() => [(L(!0), A(E, null, z(e.actions, (e, n) => (L(), A(E, { key: n }, [e.url || e.to ? (L(), O(Tl, {
						key: 0,
						to: e.url || e.to,
						target: e.target
					}, {
						default: W(() => [N(Hn, {
							"prepend-icon": e.icon,
							title: e.description,
							onClick: (n) => t(e, n)
						}, null, 8, [
							"prepend-icon",
							"title",
							"onClick"
						])]),
						_: 2
					}, 1032, ["to", "target"])) : (L(), O(Hn, {
						key: 1,
						"prepend-icon": e.icon,
						title: e.description,
						onClick: (n) => t(e, n)
					}, null, 8, [
						"prepend-icon",
						"title",
						"onClick"
					]))], 64))), 128))]),
					_: 1
				})]),
				_: 1
			})) : k("", !0)
		]));
	}
}), [["__scopeId", "data-v-f5ac694b"]]), Ol = { class: "h-admin-search-menu__settings" }, kl = /*#__PURE__*/ Y({
	__name: "search",
	props: /*@__PURE__*/ rt({
		autoSearchEnabled: {
			type: Boolean,
			default: !0
		},
		pageName: {
			type: String,
			default: ""
		},
		settingsMenu: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: {
			type: String,
			default: ""
		},
		modelModifiers: {}
	}),
	emits: /*@__PURE__*/ rt(["update:autoSearchEnabled", "search"], ["update:modelValue"]),
	setup(e, { emit: t }) {
		let n = xt(e, "modelValue"), r = G(e, "HSearch"), i = t, a = R(n.value ?? ""), o = R(null), s = R(!1), c = R([]), l = !1;
		U(s, async (e) => {
			e || (l = !0, await it(), l = !1);
		}, { flush: "sync" });
		function u(e) {
			e && r.settingsMenu && !l && (s.value = !0);
		}
		function d() {
			m(), s.value = !1;
		}
		function f(e) {
			a.value = e, d();
		}
		U(n, (e) => {
			let t = e ?? "";
			a.value !== t && (a.value = t);
		}), U(a, (e) => {
			if (!r.autoSearchEnabled) return;
			let t = e ?? "";
			n.value !== t && (n.value = t);
		});
		function p() {
			let e = a.value ?? "";
			n.value !== e && (n.value = e);
		}
		function m() {
			p();
			let e = a.value.trim();
			r.settingsMenu && e && (c.value = [e, ...c.value.filter((t) => t !== e)].slice(0, 5), s.value = !1), r.autoSearchEnabled || i("search");
		}
		function h() {
			a.value = "", p(), r.autoSearchEnabled || i("search");
		}
		function g() {
			let e = !r.autoSearchEnabled;
			i("update:autoSearchEnabled", e), e && p();
		}
		return (t, n) => (L(), O(hn, {
			ref_key: "searchField",
			ref: o,
			modelValue: a.value,
			"onUpdate:modelValue": n[1] ||= (e) => a.value = e,
			class: "h-search-field",
			label: e.pageName,
			type: "search",
			name: "search",
			autocomplete: "off",
			"data-1p-ignore": "",
			"data-lpignore": "true",
			variant: "solo",
			clearable: "",
			"hide-details": "",
			density: "compact",
			onKeyup: Et(m, ["enter"]),
			"onClick:clear": h,
			"onUpdate:focused": u
		}, Ye({
			"append-inner": W(() => [e.settingsMenu ? (L(), O(q, {
				key: 0,
				icon: "mdi:mdi-magnify",
				variant: "text",
				size: "small",
				"aria-label": e.pageName,
				onClick: Dt(d, ["stop"])
			}, null, 8, ["aria-label"])) : (L(), O(J, { key: 1 }, {
				default: W(() => [...n[2] ||= [M("mdi:mdi-magnify", -1)]]),
				_: 1
			})), e.settingsMenu ? (L(), O(Sn, {
				key: 2,
				modelValue: s.value,
				"onUpdate:modelValue": n[0] ||= (e) => s.value = e,
				activator: o.value?.$el?.querySelector("input"),
				target: o.value?.$el,
				"activator-props": {
					role: "combobox",
					"aria-haspopup": "dialog"
				},
				"open-on-click": !1,
				"close-on-content-click": !1,
				location: "bottom",
				"max-height": "360",
				"content-props": {
					class: "h-admin-search-menu",
					role: "dialog",
					"aria-label": H(K)("admin_search_settings")
				}
			}, {
				default: W(() => [N(rn, {
					rounded: "sm",
					color: "surface",
					class: "h-admin-search-menu__card"
				}, {
					default: W(() => [j("div", Ol, [j("span", null, V(H(K)("admin_search_settings")), 1), N(bn, {
						"model-value": e.autoSearchEnabled,
						label: H(K)("admin_enable_auto_search"),
						color: "primary",
						"hide-details": "",
						density: "compact",
						inset: "",
						"onUpdate:modelValue": g
					}, null, 8, ["model-value", "label"])]), c.value.length ? (L(), O(Bn, {
						key: 0,
						density: "compact"
					}, {
						default: W(() => [N(Gn, null, {
							default: W(() => [M(V(H(K)("admin_recent_searches")), 1)]),
							_: 1
						}), (L(!0), A(E, null, z(c.value, (e) => (L(), O(Hn, {
							key: e,
							title: e,
							onClick: (t) => f(e)
						}, null, 8, ["title", "onClick"]))), 128))]),
						_: 1
					})) : k("", !0)]),
					_: 1
				})]),
				_: 1
			}, 8, [
				"modelValue",
				"activator",
				"target",
				"content-props"
			])) : k("", !0)]),
			_: 2
		}, [e.settingsMenu ? void 0 : {
			name: "append",
			fn: W(() => [N(un, {
				text: e.autoSearchEnabled ? H(K)("auto_search_enabled") : H(K)("press_enter_to_search"),
				location: "bottom"
			}, {
				activator: W(({ props: t }) => [N(q, F(t, {
					icon: "",
					variant: "text",
					size: "small",
					color: e.autoSearchEnabled ? "primary" : "grey",
					"aria-label": e.autoSearchEnabled ? H(K)("auto_search_enabled") : H(K)("press_enter_to_search"),
					onClick: g
				}), {
					default: W(() => [N(J, null, {
						default: W(() => [M(V(e.autoSearchEnabled ? "mdi:mdi-flash" : "mdi:mdi-flash-off"), 1)]),
						_: 1
					})]),
					_: 1
				}, 16, ["color", "aria-label"])]),
				_: 1
			}, 8, ["text"])]),
			key: "0"
		}]), 1032, ["modelValue", "label"]));
	}
}, [["__scopeId", "data-v-a4acc3cb"]]), Al = { class: "h-filters-container-expansion-panel v-expansion-panels" }, jl = { class: "h-filters-container-expansion-panel-title py-2 font-weight-medium d-flex align-center justify-space-between px-4 w-100" }, Ml = { class: "d-flex ga-2" }, Nl = ["id"], Pl = { class: "d-flex flex-wrap ga-2" }, Fl = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "filters-container",
	props: /*@__PURE__*/ rt({
		results: { default: 0 },
		hideToggle: { type: Boolean },
		panelId: {},
		hideClear: { type: Boolean },
		active: { type: Boolean },
		clearDisabled: { type: Boolean }
	}, {
		expanded: {},
		expandedModifiers: {}
	}),
	emits: /*@__PURE__*/ rt(["clear-filters"], ["update:expanded"]),
	setup(e, { emit: t }) {
		let n = G(e, "HFiltersContainer"), r = `filters-${bt()}`, i = D(() => n.panelId || r), a = t, o = xt(e, "expanded");
		function s() {
			o.value = !o.value;
		}
		return (t, n) => (L(), A("div", { class: I(["h-filters-container-main-expansion-panels", {
			"h-filters-container--active": e.active,
			"h-filters-container--expanded": o.value
		}]) }, [j("div", Al, [j("div", jl, [B(t.$slots, "results", {}, () => [M(V(H(K)("admin_filter_results", { results: e.results })), 1)], !0), j("div", Ml, [!e.hideToggle || o.value ? (L(), O(q, {
			key: 0,
			density: "compact",
			size: "medium",
			class: "h-filters-container__toggle-filters text-label-small h-filters-container-toggle-btn",
			text: o.value ? H(K)("admin_hide_selected_filters") : H(K)("admin_show_selected_filters"),
			color: "warning",
			"aria-expanded": o.value ? "true" : "false",
			"aria-controls": i.value,
			onClick: n[0] ||= Dt((e) => s(), ["stop"])
		}, null, 8, [
			"text",
			"aria-expanded",
			"aria-controls"
		])) : k("", !0), e.hideClear ? k("", !0) : (L(), O(q, {
			key: 1,
			disabled: e.clearDisabled,
			density: "compact",
			size: "medium",
			class: "h-filters-container__clear-filters text-label-small h-filters-container-clear-btn",
			text: H(K)("admin_clear_filters"),
			color: "secondary",
			onClick: n[1] ||= Dt((e) => a("clear-filters"), ["stop"])
		}, null, 8, ["disabled", "text"]))])]), N(Kn, null, {
			default: W(() => [Tt(j("div", {
				id: i.value,
				class: "h-filters-container-expansion-panel-text pa-4 pt-2"
			}, [j("div", Pl, [B(t.$slots, "filters", {}, void 0, !0)])], 8, Nl), [[wt, o.value]])]),
			_: 3
		})])], 2));
	}
}), [["__scopeId", "data-v-be2e2a95"]]), Il = /*@__PURE__*/ Object.assign({
	name: "HTooltip",
	inheritAttrs: !1
}, {
	__name: "tooltip",
	props: {
		interactive: {
			type: Boolean,
			default: !1
		},
		stopPropagation: {
			type: Boolean,
			default: !0
		},
		modelValue: {
			type: Boolean,
			default: void 0
		},
		groupId: {
			type: String,
			default: void 0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = G(e, "HTooltip"), r = t, i = yt(), a = R(!1), o = R(!1), s = R(!1), c = null, { shouldOpen: l, setInactive: u, setHovered: d } = tn(n.groupId), f = () => s.value || o.value, p = () => {
			c &&= (clearTimeout(c), null), d(!0), l.value && (a.value = !0);
		}, m = () => {
			c &&= (clearTimeout(c), null), c = setTimeout(() => {
				f() || (d(!1), u(), a.value = !1);
			}, 150);
		}, h = (e) => {
			e ? p() : m();
		}, g = (e) => ({
			...e,
			onMouseenter: (t) => {
				s.value = !0, h(!0), n.stopPropagation && t.stopPropagation(), e.onMouseenter && e.onMouseenter(t);
			},
			onMouseleave: (t) => {
				s.value = !1, h(!1), n.stopPropagation && t.stopPropagation(), e.onMouseleave && e.onMouseleave(t);
			}
		}), _ = () => {
			o.value = !0, h(!0);
		}, v = () => {
			o.value = !1, h(!1);
		};
		U(a, (e) => {
			e && !l.value && (a.value = !1);
		}, { flush: "sync" }), U(l, (e) => {
			e && !a.value && f() ? a.value = !0 : !e && a.value && (a.value = !1);
		}), U(a, (e) => {
			n.modelValue !== void 0 && r("update:modelValue", e);
		}), U(() => n.modelValue, (e) => {
			e !== void 0 && e !== a.value && (a.value = e);
		});
		let y = (e) => {
			n.stopPropagation && e.stopPropagation();
		}, b = D(() => [n.interactive && "tooltip-interactive", i.contentClass].filter(Boolean).join(" "));
		lt(() => {
			if (i.activator === "parent") {
				let e = Ze()?.vnode?.el?.parentElement;
				e && (e.addEventListener("mouseenter", x), e.addEventListener("mouseleave", S));
			}
		}), st(() => {
			if (c && clearTimeout(c), i.activator === "parent") {
				let e = Ze()?.vnode?.el?.parentElement;
				e && (e.removeEventListener("mouseenter", x), e.removeEventListener("mouseleave", S));
			}
		});
		let x = (e) => {
			s.value = !0, h(!0), n.stopPropagation && e.stopPropagation();
		}, S = (e) => {
			s.value = !1, h(!1), n.stopPropagation && e.stopPropagation();
		};
		return (e, t) => (L(), O(un, F(e.$attrs, {
			modelValue: a.value,
			"onUpdate:modelValue": t[0] ||= (e) => a.value = e,
			"content-class": b.value,
			onClick: Dt(y, ["stop"])
		}), {
			activator: W(({ props: t, isActive: n }) => [B(e.$slots, "activator", {
				props: g(t),
				isActive: n
			}, () => [j("span", F(g(t), { style: { display: "contents" } }), null, 16)])]),
			default: W(() => [j("div", {
				tabindex: "-1",
				onMouseenter: _,
				onMouseleave: v,
				onFocus: _,
				onBlur: v
			}, [B(e.$slots, "default")], 32)]),
			_: 3
		}, 16, ["modelValue", "content-class"]));
	}
}), Ll = { class: "h-action-card__info-tooltip pa-2" }, Rl = {
	key: 0,
	class: "h-action-card__info-tooltip-text"
}, zl = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({ name: "ActionCardInfoIcon" }, {
	__name: "action-card-info-icon",
	props: {
		text: {
			type: String,
			default: ""
		},
		url: {
			type: String,
			default: null
		},
		isHorizontal: {
			type: Boolean,
			default: !1
		},
		tooltipGroupId: {
			type: String,
			default: void 0
		}
	},
	setup(e) {
		let { text: t, url: n, isHorizontal: r, tooltipGroupId: i } = G(e, "ActionCardInfoIcon");
		return (e, a) => (L(), A("div", { class: I(["h-action-card__info-icon", { "h-action-card__info-icon--horizontal": H(r) }]) }, [N(J, {
			icon: "mdi:mdi-information-outline",
			size: "24",
			color: "on-surface"
		}), N(Il, {
			activator: "parent",
			location: "top",
			interactive: !!H(n),
			"group-id": H(i)
		}, {
			default: W(() => [j("div", Ll, [H(t) ? (L(), A("div", Rl, V(H(t)), 1)) : k("", !0), H(n) ? (L(), O(gl, {
				key: 1,
				to: H(n),
				type: "secondary",
				size: "small",
				class: "mt-2",
				text: "Show more"
			}, null, 8, ["to"])) : k("", !0)])]),
			_: 1
		}, 8, ["interactive", "group-id"])], 2));
	}
}), [["__scopeId", "data-v-63ecef8f"]]), Bl = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({ name: "ActionCardTags" }, {
	__name: "action-card-tags",
	props: {
		tags: {
			type: Array,
			default: () => [],
			validator: (e) => e.every((e) => typeof e == "object" && e.text)
		},
		variant: {
			type: String,
			default: "vertical",
			validator: (e) => ["vertical", "horizontal"].includes(e)
		}
	},
	setup(e) {
		let { tags: t, variant: n } = G(e, "ActionCardTags"), r = D(() => n === "horizontal" ? "mt-1" : "");
		return (e, n) => H(t) && H(t).length ? (L(), A("div", {
			key: 0,
			class: I(["h-action-card__tags", r.value])
		}, [(L(!0), A(E, null, z(H(t), (e, t) => (L(), O(qn, {
			key: t,
			color: e.color || "info-lighten-4",
			size: "small",
			class: "h-action-card__tag"
		}, {
			default: W(() => [M(V(e.text), 1)]),
			_: 2
		}, 1032, ["color"]))), 128))], 2)) : k("", !0);
	}
}), [["__scopeId", "data-v-de4fc093"]]), Vl = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({ name: "ActionCardTitle" }, {
	__name: "action-card-title",
	props: {
		title: {
			type: String,
			required: !0
		},
		isHorizontal: {
			type: Boolean,
			default: !1
		},
		variantClass: {
			type: String,
			default: ""
		}
	},
	setup(e) {
		let { title: t, isHorizontal: n, variantClass: r } = G(e, "ActionCardTitle");
		return (e, i) => (L(), A("div", { class: I(["h-action-card__title-row", H(r)]) }, [j("div", { class: I(["h-action-card__title", { "h-action-card__title--horizontal": H(n) }]) }, V(H(t)), 3), N(J, {
			icon: "mdi:mdi-chevron-right",
			size: "24",
			class: "h-action-card__chevron"
		})], 2));
	}
}), [["__scopeId", "data-v-b34888e5"]]), Hl = {
	key: 0,
	class: "h-action-card__description text-body-medium text-medium-emphasis"
}, Ul = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({ name: "ActionCardDescription" }, {
	__name: "action-card-description",
	props: {
		description: {
			type: String,
			default: ""
		},
		maxLength: {
			type: Number,
			default: 100
		}
	},
	setup(e) {
		let { description: t, maxLength: n } = G(e, "ActionCardDescription"), r = R(!1), i = D(() => t.length > n), a = D(() => !i.value || r.value ? t : t.substring(0, n) + "...");
		return (e, n) => H(t) ? (L(), A("div", Hl, [j("span", null, V(a.value), 1), i.value ? (L(), O(q, {
			key: 0,
			variant: "text",
			size: "small",
			class: "h-action-card__description-toggle pa-0 ml-1",
			onClick: n[0] ||= Dt((e) => r.value = !r.value, ["stop"])
		}, {
			default: W(() => [M(V(r.value ? H(K)("show_less") : H(K)("show_more")), 1)]),
			_: 1
		})) : k("", !0)])) : k("", !0);
	}
}), [["__scopeId", "data-v-7c0750c4"]]), Wl = {
	key: 0,
	class: "h-action-card__notification-wrapper"
}, Gl = {
	key: 0,
	class: "h-action-card__info-icon-slot"
}, Kl = { class: "h-action-card__icon-wrapper" }, ql = { class: "h-action-card__icon-wrapper h-action-card__icon-wrapper--horizontal" }, Jl = {
	key: 1,
	class: "h-action-card__info-icon-slot"
}, Yl = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({ name: "HActionCard" }, {
	__name: "action-card",
	props: {
		variant: {
			type: String,
			default: "vertical",
			validator: (e) => ["vertical", "horizontal"].includes(e)
		},
		description: {
			type: String,
			default: null
		},
		showDescriptionInline: {
			type: Boolean,
			default: !1
		},
		title: {
			type: String,
			required: !0
		},
		icon: {
			type: String,
			default: null
		},
		iconUrl: {
			type: String,
			default: null
		},
		tags: {
			type: Array,
			default: () => []
		},
		showNotification: {
			type: Boolean,
			default: !1
		},
		notificationCount: {
			type: [Number, String],
			default: 0
		},
		infoTooltip: {
			type: [String, Object],
			default: "",
			validator: (e) => typeof e == "string" ? !0 : typeof e == "object" && e ? e.text !== void 0 || e.url !== void 0 : !1
		},
		to: {
			type: [String, Object],
			default: null
		},
		href: {
			type: String,
			default: null
		},
		target: {
			type: String,
			default: null
		},
		showActionButton: {
			type: Boolean,
			default: !0
		},
		color: {
			type: String,
			default: null
		},
		actionButtonsProps: {
			type: Object,
			default: null
		}
	},
	emits: ["action-click"],
	setup(e, { emit: t }) {
		let n = `action-card-${Ze()?.uid}`, r = G(e, "HActionCard"), i = D(() => typeof r.infoTooltip == "string" ? r.infoTooltip : r.infoTooltip?.text || ""), a = D(() => typeof r.infoTooltip == "object" && r.infoTooltip !== null && r.infoTooltip.url || null), o = D(() => !!(r.to || r.href)), s = D(() => o.value ? Tl : "div"), c = D(() => o.value ? {
			to: r.to || r.href,
			target: r.target
		} : {}), l = D(() => o.value ? "h-action-card__link" : "");
		return (t, r) => (L(), O(mt(s.value), F(c.value, { class: l.value }), {
			default: W(() => [N(rn, {
				class: I([
					"h-action-card",
					`h-action-card--${e.variant}`,
					{ "h-action-card--hoverable": o.value }
				]),
				color: e.color,
				elevation: 1
			}, {
				default: W(() => [e.description && !e.showDescriptionInline ? (L(), O(Il, {
					key: 0,
					activator: "parent",
					location: "top",
					"group-id": n
				}, {
					default: W(() => [M(V(e.description), 1)]),
					_: 1
				})) : k("", !0), e.variant === "vertical" ? (L(), O(cn, {
					key: 1,
					class: I([
						"h-action-card__content",
						"pa-6",
						{ "pr-8": i.value || a.value }
					])
				}, {
					default: W(() => [
						e.showNotification ? (L(), A("div", Wl, [N(Jn, {
							content: e.notificationCount,
							color: "secondary",
							class: "h-action-card__notification-badge"
						}, null, 8, ["content"])])) : k("", !0),
						N(pn, {
							"no-gutters": "",
							class: "h-action-card__header mb-3"
						}, {
							default: W(() => [N(dn, { cols: "12" }, {
								default: W(() => [i.value || a.value ? (L(), A("div", Gl, [N(zl, {
									text: i.value,
									url: a.value,
									"tooltip-group-id": n
								}, null, 8, ["text", "url"])])) : k("", !0), j("div", Kl, [e.iconUrl ? (L(), O(Yn, {
									key: 0,
									src: e.iconUrl,
									alt: e.title,
									class: "h-action-card__icon-image",
									width: 34,
									height: 34
								}, null, 8, ["src", "alt"])) : (L(), O(J, {
									key: 1,
									icon: e.icon || "mdi:mdi-file-document-outline",
									color: "info",
									size: "34"
								}, null, 8, ["icon"]))])]),
								_: 1
							})]),
							_: 1
						}),
						N(Vl, {
							title: e.title,
							"variant-class": "mb-3"
						}, null, 8, ["title"]),
						e.showDescriptionInline ? (L(), O(Ul, {
							key: 1,
							description: e.description,
							class: "mb-3"
						}, null, 8, ["description"])) : k("", !0),
						N(Bl, {
							tags: e.tags,
							variant: "vertical"
						}, null, 8, ["tags"]),
						e.showActionButton && e.actionButtonsProps && e.actionButtonsProps.variant !== "dots" ? (L(), A("div", {
							key: 2,
							class: "mt-3",
							onClick: r[0] ||= Dt(() => {}, ["stop"])
						}, [N(Dl, at(Qe(e.actionButtonsProps)), null, 16)])) : k("", !0)
					]),
					_: 1
				}, 8, ["class"])) : (L(), O(cn, {
					key: 2,
					class: I([
						"h-action-card__content",
						"pa-3",
						{ "pr-5": i.value || a.value }
					])
				}, {
					default: W(() => [N(pn, {
						"no-gutters": "",
						class: "align-center"
					}, {
						default: W(() => [
							N(dn, {
								cols: "auto",
								class: "mr-2"
							}, {
								default: W(() => [j("div", ql, [e.iconUrl ? (L(), O(Yn, {
									key: 0,
									src: e.iconUrl,
									alt: e.title,
									class: "h-action-card__icon-image",
									width: 24,
									height: 24
								}, null, 8, ["src", "alt"])) : (L(), O(J, {
									key: 1,
									icon: e.icon || "mdi:mdi-file-document-outline",
									color: "info",
									size: "24"
								}, null, 8, ["icon"]))])]),
								_: 1
							}),
							N(dn, { class: "flex-grow-1" }, {
								default: W(() => [
									N(Vl, {
										title: e.title,
										"is-horizontal": ""
									}, null, 8, ["title"]),
									e.showDescriptionInline ? (L(), O(Ul, {
										key: 0,
										description: e.description,
										class: "mt-1"
									}, null, 8, ["description"])) : k("", !0),
									N(Bl, {
										tags: e.tags,
										variant: "horizontal"
									}, null, 8, ["tags"]),
									e.showActionButton && e.actionButtonsProps && e.actionButtonsProps.variant !== "dots" ? (L(), A("div", {
										key: 1,
										class: "mt-2",
										onClick: r[1] ||= Dt(() => {}, ["stop"])
									}, [N(Dl, at(Qe(e.actionButtonsProps)), null, 16)])) : k("", !0)
								]),
								_: 1
							}),
							e.showActionButton && e.actionButtonsProps && e.actionButtonsProps.variant === "dots" ? (L(), O(dn, {
								key: 0,
								cols: "auto",
								class: "ml-2"
							}, {
								default: W(() => [j("div", { onClick: r[2] ||= Dt(() => {}, ["stop"]) }, [N(Dl, at(Qe(e.actionButtonsProps)), null, 16)])]),
								_: 1
							})) : k("", !0),
							i.value || a.value ? (L(), A("div", Jl, [N(zl, {
								text: i.value,
								url: a.value,
								"is-horizontal": "",
								"tooltip-group-id": n
							}, null, 8, ["text", "url"])])) : k("", !0)
						]),
						_: 1
					})]),
					_: 1
				}, 8, ["class"]))]),
				_: 1
			}, 8, ["class", "color"])]),
			_: 1
		}, 16, ["class"]));
	}
}), [["__scopeId", "data-v-3262236d"]]), Xl = {
	__name: "action-menu",
	props: {
		icon: {
			type: String,
			default: "mdi:mdi-dots-vertical"
		},
		options: {
			type: Array,
			required: !0
		}
	},
	setup(e) {
		return G(e, "HActionMenu"), (t, n) => {
			let r = pt("h-action-link");
			return L(), O(Sn, {
				"close-on-content-click": !0,
				"offset-y": ""
			}, {
				activator: W(({ props: t }) => [N(q, F(t, { icon: "" }), {
					default: W(() => [N(J, null, {
						default: W(() => [M(V(e.icon), 1)]),
						_: 1
					})]),
					_: 1
				}, 16)]),
				default: W(() => [N(Bn, null, {
					default: W(() => [(L(!0), A(E, null, z(e.options, (e, t) => (L(), O(Hn, {
						key: t,
						class: "action-menu",
						onClick: e.action
					}, {
						prepend: W(() => [N(J, { color: e.color }, {
							default: W(() => [M(V(e.icon), 1)]),
							_: 2
						}, 1032, ["color"])]),
						default: W(() => [e.url ? (L(), O(r, {
							key: 0,
							to: e.url,
							target: "_modal"
						}, {
							default: W(() => [M(V(e.label), 1)]),
							_: 2
						}, 1032, ["to"])) : (L(), A(E, { key: 1 }, [M(V(e.label), 1)], 64))]),
						_: 2
					}, 1032, ["onClick"]))), 128))]),
					_: 1
				})]),
				_: 1
			});
		};
	}
}, Zl = {
	key: 0,
	class: "h-data-table-selection"
}, Ql = { key: 1 }, $l = ["onClick"], eu = {
	key: 1,
	class: "d-flex justify-space-between"
}, tu = ["onMousedown"], nu = [
	"title",
	"role",
	"tabindex",
	"onClick",
	"onKeydown"
], ru = [
	"title",
	"role",
	"tabindex",
	"onClick",
	"onKeydown"
], iu = { class: "h-data-table-actions d-flex 1" }, au = /* @__PURE__ */ P({
	__name: "data-table",
	props: /*@__PURE__*/ rt({
		headers: { default: () => [] },
		data: {},
		isCellActive: {
			type: Function,
			default: () => !1
		},
		loading: {
			type: Boolean,
			default: !1
		},
		itemsPerPageOptions: { default: () => [
			10,
			25,
			50,
			100
		] },
		totalItemsLimit: { default: 1e4 },
		itemsPerPage: { default: 10 },
		showTotalRecordCount: {
			type: Boolean,
			default: !1
		},
		itemActions: { default: () => [] },
		pagination: {
			type: Boolean,
			default: !0
		},
		nonPaginatedLimit: {},
		page: { default: 1 },
		startingPage: {},
		sortBy: {},
		classPrefix: { default: "" },
		rowProps: {
			type: Function,
			default: void 0
		},
		showSelect: { type: Boolean },
		itemValue: {
			type: [String, Function],
			default: "id"
		},
		actionMenu: { type: Boolean }
	}, {
		selected: { default: () => [] },
		selectedModifiers: {}
	}),
	emits: /*@__PURE__*/ rt([
		"update:sort",
		"update:page",
		"update:page-size",
		"clicked:cell"
	], ["update:selected"]),
	setup(e, { emit: t }) {
		let n = G(e, "HDataTable"), { locale: r } = Kt(), i = t, a = xt(e, "selected"), o = R(null), s = R(n.pagination ? n.itemsPerPage : n.nonPaginatedLimit), c = R(Number(n.page) || Number(n.startingPage) || 1), l = R(c.value), u = R(s.value), d = {}, f = D(() => {
			let e = Number(n.data?.meta?.totalresults) || 0, t = n.totalItemsLimit ?? 1e4;
			return e < t ? e : t;
		});
		U(() => n.page, (e) => {
			let t = Number(e);
			Number.isFinite(t) && t > 0 && t !== c.value && (c.value = t, l.value = t);
		}), U(() => n.itemsPerPage, (e) => {
			!n.pagination || !e || e === s.value || (s.value = e, u.value = e);
		});
		let p = R(null), m = R(0), h = R(0);
		function g(e, t) {
			t < 0 || (p.value = t, m.value = e.clientX, h.value = +(n.headers[t]?.width || 150), document.addEventListener("mousemove", _), document.addEventListener("mouseup", v));
		}
		let _ = (e) => {
			if (p.value === null) return;
			let t = e.clientX - m.value, r = h.value + t;
			r > 20 && (n.headers[p.value] && (n.headers[p.value].width = r), document.querySelectorAll(`.h-datatable td:nth-child(${p.value + 1})`).forEach((e) => e.style.width = `${r}px`));
		}, v = () => {
			document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", v), p.value = null;
		};
		st(() => {
			document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", v);
		});
		function y() {
			let e = o.value, t = e instanceof HTMLElement ? e : e?.$el;
			if (!(t instanceof HTMLElement)) return;
			let n = t.querySelector(".v-table__wrapper");
			n instanceof HTMLElement && (n.setAttribute("tabindex", "0"), n.setAttribute("role", "region"), n.getAttribute("aria-labelledby") || n.setAttribute("aria-label", K("data_table")));
		}
		lt(() => {
			it(y);
		}), U(() => [
			n.data,
			n.loading,
			n.headers,
			r.value
		], () => {
			it(y);
		});
		function b(e) {
			let { page: t, itemsPerPage: r, sortBy: a } = e, o = a[0];
			if (r && r > 0 && r !== u.value && (s.value = r, u.value = r, i("update:page-size", s.value)), o) {
				let e = n.headers.find((e) => e.key === o.key);
				if (e) {
					let { customSortKey: t } = e;
					i("update:sort", {
						key: t ?? o.key,
						order: o.order
					});
				} else {
					let e = n.headers.find((e) => e.sortable && (e.key?.includes("date") || e.key?.includes("time"))) || n.headers.find((e) => e.sortable);
					e && i("update:sort", {
						key: e.customSortKey ?? e.key ?? o.key,
						order: o.order
					});
				}
			}
			Number.isFinite(t) && t > 0 && t !== l.value && (c.value = t, l.value = t, i("update:page", c.value)), T.value = {};
		}
		function x(e, t) {
			return t.key && (e[t.key] === void 0 || e[t.key] === null) && t.defaultValue !== void 0 ? {
				...e,
				[t.key]: t.defaultValue
			} : e;
		}
		n.headers.forEach((e) => {
			d[e.key ?? ""] = e.filterOnClick;
		});
		function S(e, t) {
			d[e] && d[e](t), i("clicked:cell", e, t);
		}
		function C(e) {
			return `item.${e}`;
		}
		function w(e, t) {
			if (!e.key) return "";
			let n = t?.[e.key], r = e.formatCell ? e.formatCell(n, t) : n;
			if (r == null || r === "") return "";
			if (Array.isArray(r) || typeof r == "object" && r.toString === Object.prototype.toString) try {
				return JSON.stringify(r, null, 2);
			} catch {
				return "";
			}
			return String(r);
		}
		let T = R({});
		function ee(e, t) {
			let n = `${e}__${t}`;
			T.value[n] ? delete T.value[n] : T.value[n] = !0;
		}
		function te(e, t) {
			return !!T.value[`${e}__${t}`];
		}
		return (t, r) => (L(), O($n, {
			ref_key: "tableRef",
			ref: o,
			modelValue: a.value,
			"onUpdate:modelValue": r[3] ||= (e) => a.value = e,
			page: c.value,
			"onUpdate:page": r[4] ||= (e) => c.value = e,
			"items-per-page": s.value,
			"onUpdate:itemsPerPage": r[5] ||= (e) => s.value = e,
			headers: e.headers,
			items: e.data?.records || [],
			"items-length": f.value,
			loading: e.loading,
			"items-per-page-options": e.itemsPerPageOptions,
			"sort-by": e.sortBy,
			"row-props": e.rowProps,
			"show-select": e.showSelect,
			"item-value": e.itemValue,
			"select-strategy": "page",
			class: I(["h-datatable h-data-table-main-server", { "h-datatable--has-actions": e.itemActions.length > 0 }]),
			"hide-default-footer": !H(n).pagination,
			"onUpdate:options": b
		}, Ye({
			"item.select": W(({ item: e }) => [N(Xn, {
				modelValue: a.value,
				"onUpdate:modelValue": r[0] ||= (e) => a.value = e,
				value: e,
				density: "compact",
				class: "h-data-table-select-checkbox"
			}, null, 8, ["modelValue", "value"])]),
			headers: W(({ columns: t, isSorted: n, getSortIcon: i, toggleSort: a, selectAll: o, allSelected: s, someSelected: c }) => [j("tr", null, [(L(!0), A(E, null, z(t, (t, l) => (L(), A("th", {
				key: t.key ?? l,
				class: "resizable-header",
				style: ot({
					width: t.width + "px",
					minWidth: t.width + "px",
					cursor: t.sortable ? "pointer" : "default"
				}),
				onClick: () => t.sortable && a(t)
			}, [t.key === "data-table-select" ? (L(), O(Zn, {
				key: 0,
				"model-value": s,
				indeterminate: c && !s,
				"aria-label": H(K)("admin_select_page"),
				"onUpdate:modelValue": (e) => o(e)
			}, null, 8, [
				"model-value",
				"indeterminate",
				"aria-label",
				"onUpdate:modelValue"
			])) : (L(), A("div", eu, [
				j("span", { class: I(["header-title", { "cursor-pointer": t.sortable }]) }, V(t.translate ? H(K)(t.title ?? "") : t.title), 3),
				n(t) ? (L(), O(J, {
					key: 0,
					icon: i(t),
					class: "h-data-table-sort-icon"
				}, null, 8, ["icon"])) : k("", !0),
				j("span", {
					class: "resizer",
					"aria-hidden": "true",
					onClick: r[2] ||= Dt(() => {}, ["stop"]),
					onMousedown: (n) => g(n, e.headers.findIndex((e) => e.key === t.key))
				}, null, 40, tu)
			]))], 12, $l))), 128))])]),
			"item.actions": W(({ item: t }) => [j("div", iu, [(L(!0), A(E, null, z(e.actionMenu ? e.itemActions.slice(0, 2) : e.itemActions, (e, n) => (L(), A(E, { key: n }, [e.hidden?.(t) ? k("", !0) : (L(), O(q, {
				key: 0,
				color: e.color || "grey-darken-1",
				variant: "text",
				size: "small",
				density: "compact",
				icon: "",
				class: "h-data-table-action-btn",
				"aria-label": e.label,
				onClick: (n) => e.action(t)
			}, {
				default: W(() => [N(J, null, {
					default: W(() => [M(V(e.icon), 1)]),
					_: 2
				}, 1024), N(un, {
					activator: "parent",
					location: "top"
				}, {
					default: W(() => [M(V(e.label), 1)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1032, [
				"color",
				"aria-label",
				"onClick"
			]))], 64))), 128)), e.actionMenu && e.itemActions.slice(2).some((e) => !e.hidden?.(t)) ? (L(), O(Sn, {
				key: 0,
				location: "bottom end"
			}, {
				activator: W(({ props: e }) => [N(q, F(e, {
					icon: "mdi:mdi-dots-horizontal",
					variant: "text",
					size: "small",
					density: "compact",
					class: "h-data-table-action-btn",
					"aria-label": H(K)("admin_more_actions")
				}), null, 16, ["aria-label"])]),
				default: W(() => [N(Bn, { density: "compact" }, {
					default: W(() => [(L(!0), A(E, null, z(e.itemActions.slice(2), (e, n) => (L(), A(E, { key: n }, [e.hidden?.(t) ? k("", !0) : (L(), O(Hn, {
						key: 0,
						title: e.label,
						"prepend-icon": e.icon,
						onClick: (n) => e.action(t)
					}, null, 8, [
						"title",
						"prepend-icon",
						"onClick"
					]))], 64))), 128))]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024)) : k("", !0)])]),
			_: 2
		}, [
			e.showTotalRecordCount || e.showSelect && a.value.length ? {
				name: "top",
				fn: W(() => [e.showSelect && a.value.length ? (L(), A("div", Zl, [j("span", null, V(H(K)("admin_selected_rows", { count: a.value.length })), 1), N(q, {
					variant: "text",
					size: "small",
					onClick: r[1] ||= (e) => a.value = []
				}, {
					default: W(() => [M(V(H(K)("admin_clear_selection")), 1)]),
					_: 1
				})])) : k("", !0), e.showTotalRecordCount ? (L(), A("span", Ql, V(H(K)("total")) + ": " + V(e.data?.meta?.totalresults || 0), 1)) : k("", !0)]),
				key: "0"
			} : void 0,
			z(e.headers.filter((e) => e.key !== "actions"), (n) => ({
				name: C(n.key),
				fn: W((r) => [B(t.$slots, C(n.key), at(Qe({
					...r,
					header: n,
					isActive: e.isCellActive(n.key, r.item[n.key])
				})), () => [n.component ? (L(), O(mt(n.component), F({
					key: 0,
					value: r.item[n.key] ?? n.defaultValue,
					item: x(r.item, n),
					"filter-on-click": n.filterOnClick,
					"is-filter-active": n.isFilterActive,
					"format-cell": n.formatCell,
					"class-prefix": e.classPrefix,
					"cell-key": n.key
				}, n.componentProps), null, 16, [
					"value",
					"item",
					"filter-on-click",
					"is-filter-active",
					"format-cell",
					"class-prefix",
					"cell-key"
				])) : d[n.key] ? (L(), A("span", {
					key: 1,
					class: I(["h-datatable__field h-datatable__cell-truncated", {
						"h-datatable__field--active": e.isCellActive(n.key, r.item[n.key]),
						"font-weight-bold": n.isFilterActive && n.isFilterActive(r.item),
						"h-datatable__cell--expanded": te(r.index, n.key)
					}]),
					title: w(n, r.item) || void 0,
					style: ot(w(n, r.item) ? "cursor: pointer" : void 0),
					role: w(n, r.item) ? "button" : void 0,
					tabindex: w(n, r.item) ? 0 : void 0,
					onClick: (e) => {
						ee(r.index, n.key), S(n.key, r.item);
					},
					onKeydown: [Et((e) => S(n.key, r.item), ["enter"]), Et(Dt((e) => S(n.key, r.item), ["prevent"]), ["space"])]
				}, V(w(n, r.item)), 47, nu)) : (L(), A("span", {
					key: 2,
					class: I(["h-datatable__cell-truncated", { "h-datatable__cell--expanded": te(r.index, n.key) }]),
					title: w(n, r.item) || void 0,
					style: ot(w(n, r.item) ? "cursor: pointer" : void 0),
					role: w(n, r.item) ? "button" : void 0,
					tabindex: w(n, r.item) ? 0 : void 0,
					onClick: (e) => ee(r.index, n.key),
					onKeydown: [Et((e) => ee(r.index, n.key), ["enter"]), Et(Dt((e) => ee(r.index, n.key), ["prevent"]), ["space"])]
				}, V(w(n, r.item)), 47, ru))])])
			})),
			t.$slots.bottom ? {
				name: "bottom",
				fn: W(() => [B(t.$slots, "bottom"), H(n).pagination ? (L(), A(E, { key: 0 }, [N(er), N(Qn, { "items-per-page-options": e.itemsPerPageOptions }, null, 8, ["items-per-page-options"])], 64)) : k("", !0)]),
				key: "1"
			} : void 0
		]), 1032, [
			"modelValue",
			"page",
			"items-per-page",
			"headers",
			"items",
			"items-length",
			"loading",
			"items-per-page-options",
			"sort-by",
			"row-props",
			"show-select",
			"item-value",
			"class",
			"hide-default-footer"
		]));
	}
}), ou = { class: "dialog-container__header" }, su = {
	__name: "view-code-dialog",
	props: {
		modelValue: Boolean,
		title: {
			type: String,
			default: ""
		},
		item: {
			type: Object,
			default: () => ({})
		},
		fieldName: {
			type: String,
			required: !0
		},
		fieldLabel: {
			type: String,
			required: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		G(e, "HViewCodeDialog");
		let n = t, r = (e) => {
			n("update:modelValue", e), e || (i.value = !0);
		}, i = R(!0), a = D(() => i.value ? "wrap" : "no-wrap"), o = async () => {
			i.value = !i.value, await it(), m();
		}, s = R(!1), c = D(() => s.value ? "100%" : "80%"), l = D(() => s.value ? "100vh" : "80%");
		function u() {
			s.value = !s.value;
		}
		let d = R(null), f = R(!1), p = async () => {
			if (!d.value) return;
			let e = d.value.$el.querySelector("code");
			if (e) try {
				await navigator.clipboard.writeText(e.innerText), f.value = !0, setTimeout(() => f.value = !1, 2e3);
			} catch (e) {
				console.error("Error copying the code:", e);
			}
		}, m = () => {
			let e = d.value?.$el?.querySelector("code");
			e && (e.style.wordWrap = i.value ? "break-word" : "normal", e.style.whiteSpace = i.value ? "pre-wrap" : "pre", e.style.overflowX = i.value ? "hidden" : "auto");
		};
		return (t, n) => {
			let m = pt("h-pretty-code"), h = pt("h-dialog");
			return L(), O(h, {
				"model-value": e.modelValue,
				fullscreen: s.value,
				width: c.value,
				height: l.value,
				persistent: !1,
				class: "h-view-code-dialog",
				"onUpdate:modelValue": r
			}, {
				header: W(() => [j("div", ou, [N(ln, { class: "ml-1 px-0" }, {
					default: W(() => [j("strong", null, V(e.item.title), 1)]),
					_: 1
				}), N(sn, { class: "ml-1 px-0" }, {
					default: W(() => [j("span", null, V(e.fieldLabel) + ":", 1), M(" " + V(e.item[e.fieldName]), 1)]),
					_: 1
				})])]),
				default: W(() => [N(rn, { class: "resizable-card" }, {
					default: W(() => [N(cn, { class: "scrollable-content d-flex justify-end" }, {
						default: W(() => [N(m, {
							ref_key: "codeBlock",
							ref: d,
							class: I(["ma-0 view-code-dialog", a.value]),
							language: "javascript"
						}, {
							default: W(() => [B(t.$slots, "raw-json")]),
							_: 3
						}, 8, ["class"])]),
						_: 3
					}), N(an, {
						class: "d-flex justify-end",
						style: { padding: "2.3rem" }
					}, {
						default: W(() => [
							N(mn),
							N(un, {
								location: "bottom",
								"open-delay": 1e3
							}, {
								activator: W(({ props: e }) => [N(J, F(e, {
									class: ["cursor-pointer wrap-icon", { "text-black": t.hoverSize || !i.value }],
									style: { color: t.hoverSize ? "purple" : i.value ? "black" : "inherit" },
									role: "button",
									tabindex: "0",
									"aria-label": i.value ? H(K)("disable_word_wrap") : H(K)("enable_word_wrap"),
									onClick: o,
									onKeydown: [Et(o, ["enter"]), Et(Dt(o, ["prevent"]), ["space"])],
									onMouseover: n[0] ||= (e) => t.hoverSize = !0,
									onMouseleave: n[1] ||= (e) => t.hoverSize = !1,
									onFocus: n[2] ||= (e) => t.hoverSize = !0,
									onBlur: n[3] ||= (e) => t.hoverSize = !1
								}), {
									default: W(() => [M(V(i.value ? "mdi:mdi-wrap" : "mdi:mdi-wrap-disabled"), 1)]),
									_: 1
								}, 16, [
									"class",
									"style",
									"aria-label",
									"onKeydown"
								])]),
								default: W(() => [j("span", null, V(i.value ? H(K)("disable_word_wrap") : H(K)("enable_word_wrap")), 1)]),
								_: 1
							}),
							N(un, {
								location: "bottom",
								"open-delay": 1e3
							}, {
								activator: W(({ props: e }) => [N(J, F(e, {
									class: ["cursor-pointer copy-icon", { "text-green": f.value }],
									style: { color: f.value ? "green" : t.hoverCopy ? "purple" : "inherit" },
									role: "button",
									tabindex: "0",
									"aria-label": f.value ? H(K)("copied") : H(K)("copy_to_clipboard"),
									onClick: p,
									onKeydown: [Et(p, ["enter"]), Et(Dt(p, ["prevent"]), ["space"])],
									onMouseover: n[4] ||= (e) => t.hoverCopy = !0,
									onMouseleave: n[5] ||= (e) => t.hoverCopy = !1,
									onFocus: n[6] ||= (e) => t.hoverCopy = !0,
									onBlur: n[7] ||= (e) => t.hoverCopy = !1
								}), {
									default: W(() => [...n[12] ||= [M(" mdi:mdi-content-copy ", -1)]]),
									_: 1
								}, 16, [
									"class",
									"style",
									"aria-label",
									"onKeydown"
								])]),
								default: W(() => [f.value ? (L(), O(J, {
									key: 0,
									class: "me-1"
								}, {
									default: W(() => [...n[13] ||= [M("mdi:mdi-check-circle", -1)]]),
									_: 1
								})) : k("", !0), j("span", null, V(f.value ? H(K)("copied") : H(K)("copy_to_clipboard")), 1)]),
								_: 1
							}),
							N(mn),
							N(un, {
								location: "bottom",
								"open-delay": 1e3
							}, {
								activator: W(({ props: e }) => [N(J, F(e, {
									class: ["cursor-pointer size-toggle-icon", { "text-purple": s.value }],
									style: { color: s.value || t.hoverSize ? "purple" : "inherit" },
									role: "button",
									tabindex: "0",
									"aria-label": s.value ? H(K)("exit_fullscreen") : H(K)("enter_fullscreen"),
									onClick: u,
									onKeydown: [Et(u, ["enter"]), Et(Dt(u, ["prevent"]), ["space"])],
									onMouseover: n[8] ||= (e) => t.hoverSize = !0,
									onMouseleave: n[9] ||= (e) => t.hoverSize = !1,
									onFocus: n[10] ||= (e) => t.hoverSize = !0,
									onBlur: n[11] ||= (e) => t.hoverSize = !1
								}), {
									default: W(() => [M(V(s.value ? "mdi:mdi-arrow-collapse" : "mdi:mdi-arrow-expand"), 1)]),
									_: 1
								}, 16, [
									"class",
									"style",
									"aria-label",
									"onKeydown"
								])]),
								default: W(() => [j("span", null, V(s.value ? H(K)("exit_fullscreen") : H(K)("enter_fullscreen")), 1)]),
								_: 1
							})
						]),
						_: 1
					})]),
					_: 3
				})]),
				_: 3
			}, 8, [
				"model-value",
				"fullscreen",
				"width",
				"height"
			]);
		};
	}
};
//#endregion
//#region ../../../node_modules/inherits-browser/dist/index.es.js
function cu(e, t) {
	t && (e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: {
		value: e,
		enumerable: !1,
		writable: !0,
		configurable: !0
	} }));
}
//#endregion
//#region ../../../node_modules/min-dash/dist/index.js
var lu = Object.prototype.toString, uu = Object.prototype.hasOwnProperty;
function du(e) {
	return e === void 0;
}
function fu(e) {
	return e !== void 0;
}
function pu(e) {
	return e == null;
}
function mu(e) {
	return lu.call(e) === "[object Array]";
}
function hu(e) {
	return lu.call(e) === "[object Object]";
}
function gu(e) {
	return lu.call(e) === "[object Number]";
}
function _u(e) {
	let t = lu.call(e);
	return t === "[object Function]" || t === "[object AsyncFunction]" || t === "[object GeneratorFunction]" || t === "[object AsyncGeneratorFunction]" || t === "[object Proxy]";
}
function vu(e) {
	return lu.call(e) === "[object String]";
}
function yu(e, t) {
	return !pu(e) && uu.call(e, t);
}
function bu(e, t) {
	let n = Ou(t), r;
	return X(e, function(e, t) {
		if (n(e, t)) return r = e, !1;
	}), r;
}
function xu(e, t) {
	let n = Ou(t), r = mu(e) ? -1 : void 0;
	return X(e, function(e, t) {
		if (n(e, t)) return r = t, !1;
	}), r;
}
function Su(e, t) {
	let n = Ou(t), r = [];
	return X(e, function(e, t) {
		n(e, t) && r.push(e);
	}), r;
}
function X(e, t) {
	let n, r;
	if (du(e)) return;
	let i = mu(e) ? Au : ku;
	for (let a in e) if (yu(e, a) && (n = e[a], r = t(n, i(a)), r === !1)) return n;
}
function Cu(e, t, n) {
	return X(e, function(e, r) {
		n = t(n, e, r);
	}), n;
}
function wu(e, t) {
	return !!Cu(e, function(e, n, r) {
		return e && t(n, r);
	}, !0);
}
function Tu(e, t) {
	return !!bu(e, t);
}
function Eu(e, t) {
	let n = [];
	return X(e, function(e, r) {
		n.push(t(e, r));
	}), n;
}
function Du(e) {
	return function(t) {
		return wu(e, function(e, n) {
			return t[n] === e;
		});
	};
}
function Ou(e) {
	return _u(e) ? e : (t) => t === e;
}
function ku(e) {
	return e;
}
function Au(e) {
	return Number(e);
}
function ju(e, t) {
	let n, r, i, a;
	function o(n) {
		let o = Date.now(), l = n ? 0 : a + t - o;
		if (l > 0) return s(l);
		e.apply(i, r), c();
	}
	function s(e) {
		n = setTimeout(o, e);
	}
	function c() {
		n && clearTimeout(n), n = a = r = i = void 0;
	}
	function l() {
		n && o(!0), c();
	}
	function u(...e) {
		a = Date.now(), r = e, i = this, n || s(t);
	}
	return u.flush = l, u.cancel = c, u;
}
function Mu(e, t) {
	return e.bind(t);
}
function Z(e, ...t) {
	return Object.assign(e, ...t);
}
function Nu(e, t, n) {
	let r = e;
	return X(t, function(e, i) {
		if (typeof e != "number" && typeof e != "string") throw Error("illegal key type: " + typeof e + ". Key should be of type number or string.");
		if (e === "constructor") throw Error("illegal key: constructor");
		if (e === "__proto__") throw Error("illegal key: __proto__");
		let a = t[i + 1], o = r[e];
		fu(a) && pu(o) && (o = r[e] = isNaN(+a) ? {} : []), du(a) ? du(n) ? delete r[e] : r[e] = n : r = o;
	}), e;
}
function Pu(e, t) {
	let n = {}, r = Object(e);
	return X(t, function(t) {
		t in r && (n[t] = e[t]);
	}), n;
}
function Fu(e, t) {
	let n = {};
	return X(Object(e), function(e, r) {
		t.indexOf(r) === -1 && (n[r] = e);
	}), n;
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/draw/BaseRenderer.js
var Iu = 1e3;
function Lu(e, t) {
	var n = this;
	t ||= Iu, e.on(["render.shape", "render.connection"], t, function(e, t) {
		var r = e.type, i = t.element, a = t.gfx, o = t.attrs;
		if (n.canRender(i)) return r === "render.shape" ? n.drawShape(a, i, o) : n.drawConnection(a, i, o);
	}), e.on(["render.getShapePath", "render.getConnectionPath"], t, function(e, t) {
		if (n.canRender(t)) return e.type === "render.getShapePath" ? n.getShapePath(t) : n.getConnectionPath(t);
	});
}
Lu.prototype.canRender = function(e) {}, Lu.prototype.drawShape = function(e, t) {}, Lu.prototype.drawConnection = function(e, t) {}, Lu.prototype.getShapePath = function(e) {}, Lu.prototype.getConnectionPath = function(e) {};
//#endregion
//#region ../../../node_modules/bpmn-js/lib/util/ModelUtil.js
function Q(e, t) {
	var n = zu(e);
	return n && typeof n.$instanceOf == "function" && n.$instanceOf(t);
}
function Ru(e, t) {
	return Tu(t, function(t) {
		return Q(e, t);
	});
}
function zu(e) {
	return e && e.businessObject || e;
}
function Bu(e) {
	return e && e.di;
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/util/DiUtil.js
function Vu(e, t) {
	return Q(e, "bpmn:CallActivity") ? !1 : Q(e, "bpmn:SubProcess") ? (t ||= Bu(e), t && Q(t, "bpmndi:BPMNPlane") ? !0 : t && !!t.isExpanded) : Q(e, "bpmn:Participant") ? !!zu(e).processRef : !0;
}
function Hu(e) {
	if (!(!Q(e, "bpmn:Participant") && !Q(e, "bpmn:Lane"))) {
		var t = Bu(e).isHorizontal;
		return t === void 0 ? !0 : t;
	}
}
function Uu(e) {
	return e && !!zu(e).triggeredByEvent;
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/ModelUtil.js
function Wu(e) {
	return hu(e) && yu(e, "waypoints");
}
function Gu(e) {
	return hu(e) && yu(e, "labelTarget");
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/util/LabelUtil.js
var Ku = {
	width: 90,
	height: 20
};
function qu(e) {
	return Q(e, "bpmn:Event") || Q(e, "bpmn:Gateway") || Q(e, "bpmn:DataStoreReference") || Q(e, "bpmn:DataObjectReference") || Q(e, "bpmn:DataInput") || Q(e, "bpmn:DataOutput") || Q(e, "bpmn:SequenceFlow") || Q(e, "bpmn:MessageFlow") || Q(e, "bpmn:Group");
}
function Ju(e) {
	var t = e.length / 2 - 1, n = e[Math.floor(t)], r = e[Math.ceil(t + .01)], i = Yu(e), a = Math.atan((r.y - n.y) / (r.x - n.x)), o = i.x, s = i.y;
	return Math.abs(a) < Math.PI / 2 ? s -= 15 : o += 15, {
		x: o,
		y: s
	};
}
function Yu(e) {
	var t = e.length / 2 - 1, n = e[Math.floor(t)], r = e[Math.ceil(t + .01)];
	return {
		x: n.x + (r.x - n.x) / 2,
		y: n.y + (r.y - n.y) / 2
	};
}
function Xu(e) {
	return e.waypoints ? Ju(e.waypoints) : Q(e, "bpmn:Group") ? {
		x: e.x + e.width / 2,
		y: e.y + Ku.height / 2
	} : {
		x: e.x + e.width / 2,
		y: e.y + e.height + Ku.height / 2
	};
}
function Zu(e, t) {
	var n, r, i, a = e.label;
	return a && a.bounds ? (i = a.bounds, r = {
		width: Math.max(Ku.width, i.width),
		height: i.height
	}, n = {
		x: i.x + i.width / 2,
		y: i.y + i.height / 2
	}) : (n = Xu(t), r = Ku), Z({
		x: n.x - r.width / 2,
		y: n.y - r.height / 2
	}, r);
}
function Qu(e) {
	if (Q(e, "bpmn:FlowElement") || Q(e, "bpmn:Participant") || Q(e, "bpmn:Lane") || Q(e, "bpmn:SequenceFlow") || Q(e, "bpmn:MessageFlow") || Q(e, "bpmn:DataInput") || Q(e, "bpmn:DataOutput")) return "name";
	if (Q(e, "bpmn:TextAnnotation")) return "text";
	if (Q(e, "bpmn:Group")) return "categoryValueRef";
}
function $u(e) {
	var t = e.categoryValueRef;
	return t && t.value || "";
}
function ed(e) {
	var t = e.businessObject, n = Qu(t);
	if (n) return n === "categoryValueRef" ? $u(t) : t[n] || "";
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/Elements.js
function td(e, t) {
	t = !!t, mu(e) || (e = [e]);
	var n, r, i, a;
	return X(e, function(e) {
		var o = e;
		e.waypoints && !t && (o = td(e.waypoints, !0));
		var s = o.x, c = o.y, l = o.height || 0, u = o.width || 0;
		(s < n || n === void 0) && (n = s), (c < r || r === void 0) && (r = c), (s + u > i || i === void 0) && (i = s + u), (c + l > a || a === void 0) && (a = c + l);
	}), {
		x: n,
		y: r,
		height: a - r,
		width: i - n
	};
}
function nd(e) {
	return "waypoints" in e ? "connection" : "x" in e ? "shape" : "root";
}
function rd(e) {
	return !!(e && e.isFrame);
}
//#endregion
//#region ../../../node_modules/tiny-svg/dist/index.js
function id(e, t) {
	if (e.ownerDocument !== t.ownerDocument) try {
		return t.ownerDocument.importNode(e, !0);
	} catch {}
	return e;
}
function ad(e, t) {
	return t.appendChild(id(e, t));
}
function od(e, t) {
	return ad(t, e), e;
}
var sd = 2, cd = {
	"alignment-baseline": 1,
	"baseline-shift": 1,
	clip: 1,
	"clip-path": 1,
	"clip-rule": 1,
	color: 1,
	"color-interpolation": 1,
	"color-interpolation-filters": 1,
	"color-profile": 1,
	"color-rendering": 1,
	cursor: 1,
	direction: 1,
	display: 1,
	"dominant-baseline": 1,
	"enable-background": 1,
	fill: 1,
	"fill-opacity": 1,
	"fill-rule": 1,
	filter: 1,
	"flood-color": 1,
	"flood-opacity": 1,
	font: 1,
	"font-family": 1,
	"font-size": sd,
	"font-size-adjust": 1,
	"font-stretch": 1,
	"font-style": 1,
	"font-variant": 1,
	"font-weight": 1,
	"glyph-orientation-horizontal": 1,
	"glyph-orientation-vertical": 1,
	"image-rendering": 1,
	kerning: 1,
	"letter-spacing": 1,
	"lighting-color": 1,
	marker: 1,
	"marker-end": 1,
	"marker-mid": 1,
	"marker-start": 1,
	mask: 1,
	opacity: 1,
	overflow: 1,
	"pointer-events": 1,
	"shape-rendering": 1,
	"stop-color": 1,
	"stop-opacity": 1,
	stroke: 1,
	"stroke-dasharray": 1,
	"stroke-dashoffset": 1,
	"stroke-linecap": 1,
	"stroke-linejoin": 1,
	"stroke-miterlimit": 1,
	"stroke-opacity": 1,
	"stroke-width": sd,
	"text-anchor": 1,
	"text-decoration": 1,
	"text-rendering": 1,
	"unicode-bidi": 1,
	visibility: 1,
	"word-spacing": 1,
	"writing-mode": 1
};
function ld(e, t) {
	return cd[t] ? e.style[t] : e.getAttributeNS(null, t);
}
function ud(e, t, n) {
	var r = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), i = cd[r];
	i ? (i === sd && typeof n == "number" && (n = String(n) + "px"), e.style[r] = n) : e.setAttributeNS(null, t, n);
}
function dd(e, t) {
	var n = Object.keys(t), r, i;
	for (r = 0; i = n[r]; r++) ud(e, i, t[i]);
}
function fd(e, t, n) {
	if (typeof t == "string") if (n !== void 0) ud(e, t, n);
	else return ld(e, t);
	else dd(e, t);
	return e;
}
var pd = Object.prototype.toString;
function md(e) {
	return new hd(e);
}
function hd(e) {
	if (!e || !e.nodeType) throw Error("A DOM element reference is required");
	this.el = e, this.list = e.classList;
}
hd.prototype.add = function(e) {
	return this.list.add(e), this;
}, hd.prototype.remove = function(e) {
	return pd.call(e) == "[object RegExp]" ? this.removeMatching(e) : (this.list.remove(e), this);
}, hd.prototype.removeMatching = function(e) {
	let t = this.array();
	for (let n = 0; n < t.length; n++) e.test(t[n]) && this.remove(t[n]);
	return this;
}, hd.prototype.toggle = function(e, t) {
	return (t === void 0 || t !== this.list.toggle(e, t)) && this.list.toggle(e), this;
}, hd.prototype.array = function() {
	return Array.from(this.list);
}, hd.prototype.has = hd.prototype.contains = function(e) {
	return this.list.contains(e);
};
function gd(e) {
	for (var t; t = e.firstChild;) e.removeChild(t);
	return e;
}
var _d = { svg: "http://www.w3.org/2000/svg" }, vd = "<svg xmlns=\"" + _d.svg + "\"";
function yd(e) {
	var t = !1;
	e.substring(0, 4) === "<svg" ? e.indexOf(_d.svg) === -1 && (e = vd + e.substring(4)) : (e = vd + ">" + e + "</svg>", t = !0);
	var n = bd(e);
	if (!t) return n;
	for (var r = document.createDocumentFragment(), i = n.firstChild; i.firstChild;) r.appendChild(i.firstChild);
	return r;
}
function bd(e) {
	var t = new DOMParser();
	return t.async = !1, t.parseFromString(e, "text/xml");
}
function xd(e, t) {
	var n;
	return e = e.trim(), e.charAt(0) === "<" ? (n = yd(e).firstChild, n = document.importNode(n, !0)) : n = document.createElementNS(_d.svg, e), t && fd(n, t), n;
}
var Sd = null;
function Cd() {
	return Sd === null && (Sd = xd("svg")), Sd;
}
function wd(e, t) {
	var n, r, i = Object.keys(t);
	for (n = 0; r = i[n]; n++) e[r] = t[r];
	return e;
}
function Td(e, t, n, r, i, a) {
	var o = Cd().createSVGMatrix();
	switch (arguments.length) {
		case 0: return o;
		case 1: return wd(o, e);
		case 6: return wd(o, {
			a: e,
			b: t,
			c: n,
			d: r,
			e: i,
			f: a
		});
	}
}
function Ed(e) {
	return e ? Cd().createSVGTransformFromMatrix(e) : Cd().createSVGTransform();
}
var Dd = /([&<>]{1})/g, Od = /([&<>\n\r"]{1})/g, kd = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "'"
};
function Ad(e, t) {
	function n(e, t) {
		return kd[t] || t;
	}
	return e.replace(t, n);
}
function jd(e, t) {
	var n, r, i, a, o;
	switch (e.nodeType) {
		case 3:
			t.push(Ad(e.textContent, Dd));
			break;
		case 1:
			if (t.push("<", e.tagName), e.hasAttributes()) for (i = e.attributes, n = 0, r = i.length; n < r; ++n) a = i.item(n), t.push(" ", a.name, "=\"", Ad(a.value, Od), "\"");
			if (e.hasChildNodes()) {
				for (t.push(">"), o = e.childNodes, n = 0, r = o.length; n < r; ++n) jd(o.item(n), t);
				t.push("</", e.tagName, ">");
			} else t.push("/>");
			break;
		case 8:
			t.push("<!--", Ad(e.nodeValue, Dd), "-->");
			break;
		case 4:
			t.push("<![CDATA[", e.nodeValue, "]]>");
			break;
		default: throw Error("unable to handle node " + e.nodeType);
	}
	return t;
}
function Md(e, t) {
	var n = yd(t);
	if (gd(e), t) {
		Pd(n) || (n = n.documentElement);
		for (var r = Id(n.childNodes), i = 0; i < r.length; i++) ad(r[i], e);
	}
}
function Nd(e) {
	for (var t = e.firstChild, n = []; t;) jd(t, n), t = t.nextSibling;
	return n.join("");
}
function Pd(e) {
	return e.nodeName === "#document-fragment";
}
function Fd(e, t) {
	if (t !== void 0) {
		try {
			Md(e, t);
		} catch (e) {
			throw Error("error parsing SVG: " + e.message);
		}
		return e;
	} else return Nd(e);
}
function Id(e) {
	return Array.prototype.slice.call(e);
}
function Ld(e) {
	var t = e.parentNode;
	return t && t.removeChild(e), e;
}
function Rd(e, t) {
	return t instanceof SVGMatrix ? e.createSVGTransformFromMatrix(t) : t;
}
function zd(e, t) {
	var n, r;
	for (e.clear(), n = 0; r = t[n]; n++) e.appendItem(Rd(e, r));
}
function Bd(e, t) {
	var n = e.transform.baseVal;
	return t && (Array.isArray(t) || (t = [t]), zd(n, t)), n.consolidate();
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/RenderUtil.js
function Vd(e) {
	return e.flat().join(",").replace(/,?([A-Za-z]),?/g, "$1");
}
function Hd(e) {
	return [
		"M",
		e.x,
		e.y
	];
}
function Ud(e) {
	return [
		"L",
		e.x,
		e.y
	];
}
function Wd(e, t, n) {
	return [
		"C",
		e.x,
		e.y,
		t.x,
		t.y,
		n.x,
		n.y
	];
}
function Gd(e, t) {
	let n = e.length, r = [Hd(e[0])];
	for (let i = 1; i < n; i++) {
		let n = e[i - 1], a = e[i], o = e[i + 1];
		if (!o || !t) {
			r.push(Ud(a));
			continue;
		}
		let s = Math.min(t, qd(a.x - n.x, a.y - n.y), qd(o.x - a.x, o.y - a.y));
		if (!s) {
			r.push(Ud(a));
			continue;
		}
		let c = Kd(a, n, s), l = Kd(a, n, s * .5), u = Kd(a, o, s), d = Kd(a, o, s * .5);
		r.push(Ud(c)), r.push(Wd(l, d, u));
	}
	return r;
}
function Kd(e, t, n) {
	let r = t.x - e.x, i = t.y - e.y, a = n / qd(r, i);
	return {
		x: e.x + r * a,
		y: e.y + i * a
	};
}
function qd(e, t) {
	return Math.sqrt(e ** 2 + t ** 2);
}
function Jd(e, t, n) {
	gu(t) && (n = t, t = null), t ||= {};
	let r = xd("path", t);
	return gu(n) && (r.dataset.cornerRadius = String(n)), Yd(r, e);
}
function Yd(e, t) {
	return fd(e, { d: Vd(Gd(t, parseInt(e.dataset.cornerRadius, 10) || 0)) }), e;
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/draw/BpmnRenderUtil.js
var Xd = "hsl(225, 10%, 15%)";
function Zd(e, t) {
	return Tu(e.eventDefinitions, function(e) {
		return e.$type === t;
	});
}
function Qd(e) {
	return e.$type === "bpmn:IntermediateThrowEvent" || e.$type === "bpmn:EndEvent";
}
function $d(e) {
	var t = e.dataObjectRef;
	return e.isCollection || t && t.isCollection;
}
function ef(e, t, n) {
	var r = Bu(e);
	return n || r.get("color:background-color") || r.get("bioc:fill") || t || "white";
}
function $(e, t, n) {
	var r = Bu(e);
	return n || r.get("color:border-color") || r.get("bioc:stroke") || t || "hsl(225, 10%, 15%)";
}
function tf(e, t, n, r) {
	var i = Bu(e).get("label");
	return r || i && i.get("color:color") || t || $(e, n);
}
function nf(e) {
	var t = e.x + e.width / 2, n = e.y + e.height / 2, r = e.width / 2;
	return Vd([
		[
			"M",
			t,
			n
		],
		[
			"m",
			0,
			-r
		],
		[
			"a",
			r,
			r,
			0,
			1,
			1,
			0,
			2 * r
		],
		[
			"a",
			r,
			r,
			0,
			1,
			1,
			0,
			-2 * r
		],
		["z"]
	]);
}
function rf(e, t) {
	var n = e.x, r = e.y, i = e.width, a = e.height;
	return Vd([
		[
			"M",
			n + t,
			r
		],
		[
			"l",
			i - t * 2,
			0
		],
		[
			"a",
			t,
			t,
			0,
			0,
			1,
			t,
			t
		],
		[
			"l",
			0,
			a - t * 2
		],
		[
			"a",
			t,
			t,
			0,
			0,
			1,
			-t,
			t
		],
		[
			"l",
			t * 2 - i,
			0
		],
		[
			"a",
			t,
			t,
			0,
			0,
			1,
			-t,
			-t
		],
		[
			"l",
			0,
			t * 2 - a
		],
		[
			"a",
			t,
			t,
			0,
			0,
			1,
			t,
			-t
		],
		["z"]
	]);
}
function af(e) {
	var t = e.width, n = e.height, r = e.x, i = e.y, a = t / 2, o = n / 2;
	return Vd([
		[
			"M",
			r + a,
			i
		],
		[
			"l",
			a,
			o
		],
		[
			"l",
			-a,
			o
		],
		[
			"l",
			-a,
			-o
		],
		["z"]
	]);
}
function of(e) {
	var t = e.x, n = e.y, r = e.width, i = e.height;
	return Vd([
		[
			"M",
			t,
			n
		],
		[
			"l",
			r,
			0
		],
		[
			"l",
			0,
			i
		],
		[
			"l",
			-r,
			0
		],
		["z"]
	]);
}
function sf(e, t = {}) {
	return {
		width: cf(e, t),
		height: lf(e, t)
	};
}
function cf(e, t = {}) {
	return yu(t, "width") ? t.width : e.width;
}
function lf(e, t = {}) {
	return yu(t, "height") ? t.height : e.height;
}
//#endregion
//#region ../../../node_modules/domify/index.js
var uf = {
	legend: [
		1,
		"<fieldset>",
		"</fieldset>"
	],
	tr: [
		2,
		"<table><tbody>",
		"</tbody></table>"
	],
	col: [
		2,
		"<table><tbody></tbody><colgroup>",
		"</colgroup></table>"
	],
	_default: [
		0,
		"",
		""
	]
};
uf.td = uf.th = [
	3,
	"<table><tbody><tr>",
	"</tr></tbody></table>"
], uf.option = uf.optgroup = [
	1,
	"<select multiple=\"multiple\">",
	"</select>"
], uf.thead = uf.tbody = uf.colgroup = uf.caption = uf.tfoot = [
	1,
	"<table>",
	"</table>"
], uf.polyline = uf.ellipse = uf.polygon = uf.circle = uf.text = uf.line = uf.path = uf.rect = uf.g = [
	1,
	"<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\">",
	"</svg>"
];
function df(e, t = globalThis.document) {
	if (typeof e != "string") throw TypeError("String expected");
	let n = /^<!--(.*?)-->$/s.exec(e);
	if (n) return t.createComment(n[1]);
	let r = /<([\w:]+)/.exec(e)?.[1];
	if (!r) return t.createTextNode(e);
	if (e = e.trim(), r === "body") {
		let n = t.createElement("html");
		n.innerHTML = e;
		let { lastChild: r } = n;
		return r.remove(), r;
	}
	let [i, a, o] = Object.hasOwn(uf, r) ? uf[r] : uf._default, s = t.createElement("div");
	for (s.innerHTML = a + e + o; i--;) s = s.lastChild;
	if (s.firstChild === s.lastChild) {
		let { firstChild: e } = s;
		return e.remove(), e;
	}
	let c = t.createDocumentFragment();
	return c.append(...s.childNodes), c;
}
//#endregion
//#region ../../../node_modules/min-dom/dist/index.js
function ff(e, t) {
	return t.forEach(function(t) {
		t && typeof t != "string" && !Array.isArray(t) && Object.keys(t).forEach(function(n) {
			if (n !== "default" && !(n in e)) {
				var r = Object.getOwnPropertyDescriptor(t, n);
				Object.defineProperty(e, n, r.get ? r : {
					enumerable: !0,
					get: function() {
						return t[n];
					}
				});
			}
		});
	}), Object.freeze(e);
}
function pf(e, ...t) {
	let n = e.style;
	return X(t, function(e) {
		e && X(e, function(e, t) {
			n[t] = e;
		});
	}), e;
}
function mf(e, t, n) {
	return arguments.length == 2 ? e.getAttribute(t) : n === null ? e.removeAttribute(t) : (e.setAttribute(t, n), e);
}
var hf = Object.prototype.toString;
function gf(e) {
	return new _f(e);
}
function _f(e) {
	if (!e || !e.nodeType) throw Error("A DOM element reference is required");
	this.el = e, this.list = e.classList;
}
_f.prototype.add = function(e) {
	return this.list.add(e), this;
}, _f.prototype.remove = function(e) {
	return hf.call(e) == "[object RegExp]" ? this.removeMatching(e) : (this.list.remove(e), this);
}, _f.prototype.removeMatching = function(e) {
	let t = this.array();
	for (let n = 0; n < t.length; n++) e.test(t[n]) && this.remove(t[n]);
	return this;
}, _f.prototype.toggle = function(e, t) {
	return (t === void 0 || t !== this.list.toggle(e, t)) && this.list.toggle(e), this;
}, _f.prototype.array = function() {
	return Array.from(this.list);
}, _f.prototype.has = _f.prototype.contains = function(e) {
	return this.list.contains(e);
};
function vf(e) {
	for (var t; t = e.firstChild;) e.removeChild(t);
	return e;
}
function yf(e, t, n) {
	var r = n ? e : e.parentNode;
	return r && typeof r.closest == "function" && r.closest(t) || null;
}
function bf(e) {
	return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xf = {}, Sf;
function Cf() {
	if (Sf) return xf;
	Sf = 1;
	var e, t, n;
	function r() {
		e = window.addEventListener ? "addEventListener" : "attachEvent", t = window.removeEventListener ? "removeEventListener" : "detachEvent", n = e === "addEventListener" ? "" : "on";
	}
	return xf.bind = function(t, i, a, o) {
		return e || r(), t[e](n + i, a, o || !1), a;
	}, xf.unbind = function(e, i, a, o) {
		return t || r(), e[t](n + i, a, o || !1), a;
	}, xf;
}
var wf = Cf(), Tf = /*#__PURE__*/ ff({
	__proto__: null,
	default: /* @__PURE__ */ bf(wf)
}, [wf]), Ef = ["focus", "blur"];
function Df(e, t, n, r, i) {
	return Ef.indexOf(n) !== -1 && (i = !0), Tf.bind(e, n, function(n) {
		n.delegateTarget = yf(n.target || n.srcElement, t, !0), n.delegateTarget && r.call(e, n);
	}, i);
}
function Of(e, t, n, r) {
	return Ef.indexOf(t) !== -1 && (r = !0), Tf.unbind(e, t, n, r);
}
var kf = {
	bind: Df,
	unbind: Of
};
function Af(e, t) {
	return t ||= document, t.querySelector(e);
}
function jf(e, t) {
	return t ||= document, t.querySelectorAll(e);
}
function Mf(e) {
	e.parentNode && e.parentNode.removeChild(e);
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/SvgTransformUtil.js
function Nf(e, t, n, r, i) {
	var a = Ed();
	a.setTranslate(t, n);
	var o = Ed();
	o.setRotate(r || 0, 0, 0);
	var s = Ed();
	s.setScale(i || 1, i || 1), Bd(e, [
		a,
		o,
		s
	]);
}
function Pf(e, t, n) {
	var r = Ed();
	r.setTranslate(t, n), Bd(e, r);
}
function Ff(e, t) {
	var n = Ed();
	n.setRotate(t, 0, 0), Bd(e, n);
}
//#endregion
//#region ../../../node_modules/ids/dist/index.js
function If(e) {
	return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Lf = { exports: {} }, Rf;
function zf() {
	if (Rf) return Lf.exports;
	Rf = 1;
	var e = Lf.exports = function(t, n) {
		if (n ||= 16, t === void 0 && (t = 128), t <= 0) return "0";
		for (var r = Math.log(2 ** t) / Math.log(n), i = 2; r === Infinity; i *= 2) r = Math.log(2 ** (t / i)) / Math.log(n) * i;
		for (var a = r - Math.floor(r), o = "", i = 0; i < Math.floor(r); i++) {
			var s = Math.floor(Math.random() * n).toString(n);
			o = s + o;
		}
		if (a) {
			var s = Math.floor(Math.random() * n ** +a).toString(n);
			o = s + o;
		}
		var c = parseInt(o, n);
		return c !== Infinity && c >= 2 ** t ? e(t, n) : o;
	};
	return e.rack = function(t, n, r) {
		var i = function(i) {
			var o = 0;
			do {
				if (o++ > 10) if (r) t += r;
				else throw Error("too many ID collisions, use more bits");
				var s = e(t, n);
			} while (Object.hasOwnProperty.call(a, s));
			return a[s] = i, s;
		}, a = i.hats = {};
		return i.get = function(e) {
			return i.hats[e];
		}, i.set = function(e, t) {
			return i.hats[e] = t, i;
		}, i.bits = t || 128, i.base = n || 16, i;
	}, Lf.exports;
}
var Bf = /*@__PURE__*/ If(zf());
function Vf(e) {
	if (!(this instanceof Vf)) return new Vf(e);
	e ||= [
		128,
		36,
		1
	], this._seed = e.length ? Bf.rack(e[0], e[1], e[2]) : e;
}
Vf.prototype.next = function(e) {
	return this._seed(e || !0);
}, Vf.prototype.nextPrefixed = function(e, t) {
	var n;
	do
		n = e + this.next(!0);
	while (this.assigned(n));
	return this.claim(n, t), n;
}, Vf.prototype.claim = function(e, t) {
	this._seed.set(e, t || !0);
}, Vf.prototype.assigned = function(e) {
	return this._seed.get(e) || !1;
}, Vf.prototype.unclaim = function(e) {
	delete this._seed.hats[e];
}, Vf.prototype.clear = function() {
	var e = this._seed.hats, t;
	for (t in e) this.unclaim(t);
};
//#endregion
//#region ../../../node_modules/bpmn-js/lib/draw/BpmnRenderer.js
var Hf = new Vf(), Uf = 10, Wf = 3, Gf = 1.5, Kf = 10, qf = 4, Jf = .95, Yf = 1, Xf = .25;
function Zf(e, t, n, r, i, a, o) {
	Lu.call(this, t, o);
	var s = e && e.defaultFillColor, c = e && e.defaultStrokeColor, l = e && e.defaultLabelColor;
	function u(e) {
		return n.computeStyle(e, {
			strokeLinecap: "round",
			strokeLinejoin: "round",
			stroke: Xd,
			strokeWidth: 2,
			fill: "white"
		});
	}
	function d(e) {
		return n.computeStyle(e, ["no-fill"], {
			strokeLinecap: "round",
			strokeLinejoin: "round",
			stroke: Xd,
			strokeWidth: 2
		});
	}
	function f(e, t) {
		var { ref: n = {
			x: 0,
			y: 0
		}, scale: r = 1, element: a, parentGfx: o = i._svg } = t, s = xd("marker", {
			id: e,
			viewBox: "0 0 20 20",
			refX: n.x,
			refY: n.y,
			markerWidth: 20 * r,
			markerHeight: 20 * r,
			orient: "auto"
		});
		od(s, a);
		var c = Af(":scope > defs", o);
		c || (c = xd("defs"), od(o, c)), od(c, s);
	}
	function p(e, t, n, r) {
		var i = Hf.nextPrefixed("marker-");
		return m(e, i, t, n, r), "url(#" + i + ")";
	}
	function m(e, t, n, r, i) {
		n === "sequenceflow-end" && f(t, {
			element: xd("path", {
				d: "M 1 5 L 11 10 L 1 15 Z",
				...u({
					fill: i,
					stroke: i,
					strokeWidth: 1
				})
			}),
			ref: {
				x: 11,
				y: 10
			},
			scale: .5,
			parentGfx: e
		}), n === "messageflow-start" && f(t, {
			element: xd("circle", {
				cx: 6,
				cy: 6,
				r: 3.5,
				...u({
					fill: r,
					stroke: i,
					strokeWidth: 1,
					strokeDasharray: [1e4, 1]
				})
			}),
			ref: {
				x: 6,
				y: 6
			},
			parentGfx: e
		}), n === "messageflow-end" && f(t, {
			element: xd("path", {
				d: "m 1 5 l 0 -3 l 7 3 l -7 3 z",
				...u({
					fill: r,
					stroke: i,
					strokeWidth: 1,
					strokeDasharray: [1e4, 1]
				})
			}),
			ref: {
				x: 8.5,
				y: 5
			},
			parentGfx: e
		}), n === "association-start" && f(t, {
			element: xd("path", {
				d: "M 11 5 L 1 10 L 11 15",
				...d({
					fill: "none",
					stroke: i,
					strokeWidth: 1.5,
					strokeDasharray: [1e4, 1]
				})
			}),
			ref: {
				x: 1,
				y: 10
			},
			scale: .5,
			parentGfx: e
		}), n === "association-end" && f(t, {
			element: xd("path", {
				d: "M 1 5 L 11 10 L 1 15",
				...d({
					fill: "none",
					stroke: i,
					strokeWidth: 1.5,
					strokeDasharray: [1e4, 1]
				})
			}),
			ref: {
				x: 11,
				y: 10
			},
			scale: .5,
			parentGfx: e
		}), n === "conditional-flow-marker" && f(t, {
			element: xd("path", {
				d: "M 0 10 L 8 6 L 16 10 L 8 14 Z",
				...u({
					fill: r,
					stroke: i
				})
			}),
			ref: {
				x: -1,
				y: 10
			},
			scale: .5,
			parentGfx: e
		}), n === "conditional-default-flow-marker" && f(t, {
			element: xd("path", {
				d: "M 6 4 L 10 16",
				...u({
					stroke: i,
					fill: "none"
				})
			}),
			ref: {
				x: 0,
				y: 10
			},
			scale: .5,
			parentGfx: e
		});
	}
	function h(e, t, n, r, i = {}) {
		hu(r) && (i = r, r = 0), r ||= 0, i = u(i);
		var a = xd("circle", {
			cx: t / 2,
			cy: n / 2,
			r: Math.round((t + n) / 4 - r),
			...i
		});
		return od(e, a), a;
	}
	function g(e, t, n, r, i, a) {
		hu(i) && (a = i, i = 0), i ||= 0, a = u(a);
		var o = xd("rect", {
			x: i,
			y: i,
			width: t - i * 2,
			height: n - i * 2,
			rx: r,
			ry: r,
			...a
		});
		return od(e, o), o;
	}
	function _(e, t, n, r) {
		var i = t / 2, a = n / 2, o = [
			{
				x: i,
				y: 0
			},
			{
				x: t,
				y: a
			},
			{
				x: i,
				y: n
			},
			{
				x: 0,
				y: a
			}
		].map(function(e) {
			return e.x + "," + e.y;
		}).join(" ");
		r = u(r);
		var s = xd("polygon", {
			...r,
			points: o
		});
		return od(e, s), s;
	}
	function v(e, t, n, r) {
		n = d(n);
		var i = Jd(t, n, r);
		return od(e, i), i;
	}
	function y(e, t, n) {
		return v(e, t, n, 5);
	}
	function b(e, t, n) {
		n = d(n);
		var r = xd("path", {
			...n,
			d: t
		});
		return od(e, r), r;
	}
	function x(e, t, n, r) {
		return b(t, n, Z({ "data-marker": e }, r));
	}
	function S(e) {
		return ge[e];
	}
	function C(e) {
		return function(t, n, r) {
			return S(e)(t, n, r);
		};
	}
	var w = {
		"bpmn:MessageEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_MESSAGE", {
				xScaleFactor: .9,
				yScaleFactor: .9,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .235,
					my: .315
				}
			}), {
				fill: i ? $(t, c, n.stroke) : ef(t, s, n.fill),
				stroke: i ? ef(t, s, n.fill) : $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:TimerEventDefinition": function(e, t, n = {}) {
			var i = n.width || t.width, a = n.height || t.height, o = n.width ? 1 : 2, l = h(e, i, a, .2 * a, {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: o
			});
			b(e, r.getScaledPath("EVENT_TIMER_WH", {
				xScaleFactor: .75,
				yScaleFactor: .75,
				containerWidth: i,
				containerHeight: a,
				position: {
					mx: .5,
					my: .5
				}
			}), {
				stroke: $(t, c, n.stroke),
				strokeWidth: o
			});
			for (var u = 0; u < 12; u++) {
				var d = r.getScaledPath("EVENT_TIMER_LINE", {
					xScaleFactor: .75,
					yScaleFactor: .75,
					containerWidth: i,
					containerHeight: a,
					position: {
						mx: .5,
						my: .5
					}
				}), f = i / 2, p = a / 2;
				b(e, d, {
					strokeWidth: 1,
					stroke: $(t, c, n.stroke),
					transform: "rotate(" + u * 30 + "," + p + "," + f + ")"
				});
			}
			return l;
		},
		"bpmn:EscalationEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_ESCALATION", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .5,
					my: .2
				}
			}), {
				fill: i ? $(t, c, n.stroke) : ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:ConditionalEventDefinition": function(e, t, n = {}) {
			return b(e, r.getScaledPath("EVENT_CONDITIONAL", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .5,
					my: .222
				}
			}), {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:LinkEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_LINK", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: .57,
					my: .263
				}
			}), {
				fill: i ? $(t, c, n.stroke) : ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:ErrorEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_ERROR", {
				xScaleFactor: 1.1,
				yScaleFactor: 1.1,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .2,
					my: .722
				}
			}), {
				fill: i ? $(t, c, n.stroke) : ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:CancelEventDefinition": function(e, t, n = {}, i) {
			var a = b(e, r.getScaledPath("EVENT_CANCEL_45", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: .638,
					my: -.055
				}
			}), {
				fill: i ? $(t, c, n.stroke) : "none",
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
			return Ff(a, 45), a;
		},
		"bpmn:CompensateEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_COMPENSATION", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .22,
					my: .5
				}
			}), {
				fill: i ? $(t, c, n.stroke) : ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:SignalEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_SIGNAL", {
				xScaleFactor: .9,
				yScaleFactor: .9,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .5,
					my: .2
				}
			}), {
				strokeWidth: 1,
				fill: i ? $(t, c, n.stroke) : ef(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			});
		},
		"bpmn:MultipleEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_MULTIPLE", {
				xScaleFactor: 1.1,
				yScaleFactor: 1.1,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .211,
					my: .36
				}
			}), {
				fill: i ? $(t, c, n.stroke) : ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:ParallelMultipleEventDefinition": function(e, t, n = {}) {
			return b(e, r.getScaledPath("EVENT_PARALLEL_MULTIPLE", {
				xScaleFactor: 1.2,
				yScaleFactor: 1.2,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .458,
					my: .194
				}
			}), {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:TerminateEventDefinition": function(e, t, n = {}) {
			return h(e, t.width, t.height, 8, {
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke),
				strokeWidth: 4
			});
		}
	};
	function T(e, t, n = {}, r) {
		var i = zu(e), a = Qd(i), o = r || e;
		return i.get("eventDefinitions") && i.get("eventDefinitions").length > 1 ? i.get("parallelMultiple") ? w["bpmn:ParallelMultipleEventDefinition"](t, o, n, a) : w["bpmn:MultipleEventDefinition"](t, o, n, a) : Zd(i, "bpmn:MessageEventDefinition") ? w["bpmn:MessageEventDefinition"](t, o, n, a) : Zd(i, "bpmn:TimerEventDefinition") ? w["bpmn:TimerEventDefinition"](t, o, n, a) : Zd(i, "bpmn:ConditionalEventDefinition") ? w["bpmn:ConditionalEventDefinition"](t, o, n, a) : Zd(i, "bpmn:SignalEventDefinition") ? w["bpmn:SignalEventDefinition"](t, o, n, a) : Zd(i, "bpmn:EscalationEventDefinition") ? w["bpmn:EscalationEventDefinition"](t, o, n, a) : Zd(i, "bpmn:LinkEventDefinition") ? w["bpmn:LinkEventDefinition"](t, o, n, a) : Zd(i, "bpmn:ErrorEventDefinition") ? w["bpmn:ErrorEventDefinition"](t, o, n, a) : Zd(i, "bpmn:CancelEventDefinition") ? w["bpmn:CancelEventDefinition"](t, o, n, a) : Zd(i, "bpmn:CompensateEventDefinition") ? w["bpmn:CompensateEventDefinition"](t, o, n, a) : Zd(i, "bpmn:TerminateEventDefinition") ? w["bpmn:TerminateEventDefinition"](t, o, n, a) : null;
	}
	var ee = {
		ParticipantMultiplicityMarker: function(e, t, n = {}) {
			var i = cf(t, n), a = lf(t, n);
			x("participant-multiplicity", e, r.getScaledPath("MARKER_PARALLEL", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: i,
				containerHeight: a,
				position: {
					mx: (i / 2 - 6) / i,
					my: (a - 15) / a
				}
			}), {
				strokeWidth: 2,
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			});
		},
		SubProcessMarker: function(e, t, n = {}) {
			Pf(g(e, 14, 14, 0, {
				strokeWidth: 1,
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			}), t.width / 2 - 7.5, t.height - 20), x("sub-process", e, r.getScaledPath("MARKER_SUB_PROCESS", {
				xScaleFactor: 1.5,
				yScaleFactor: 1.5,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: (t.width / 2 - 7.5) / t.width,
					my: (t.height - 20) / t.height
				}
			}), {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			});
		},
		ParallelMarker: function(e, t, n) {
			var i = cf(t, n), a = lf(t, n);
			x("parallel", e, r.getScaledPath("MARKER_PARALLEL", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: i,
				containerHeight: a,
				position: {
					mx: (i / 2 + n.parallel) / i,
					my: (a - 20) / a
				}
			}), {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			});
		},
		SequentialMarker: function(e, t, n) {
			x("sequential", e, r.getScaledPath("MARKER_SEQUENTIAL", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: (t.width / 2 + n.seq) / t.width,
					my: (t.height - 19) / t.height
				}
			}), {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			});
		},
		CompensationMarker: function(e, t, n) {
			x("compensation", e, r.getScaledPath("MARKER_COMPENSATION", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: (t.width / 2 + n.compensation) / t.width,
					my: (t.height - 13) / t.height
				}
			}), {
				strokeWidth: 1,
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			});
		},
		LoopMarker: function(e, t, n) {
			var i = cf(t, n), a = lf(t, n);
			x("loop", e, r.getScaledPath("MARKER_LOOP", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: i,
				containerHeight: a,
				position: {
					mx: (i / 2 + n.loop) / i,
					my: (a - 7) / a
				}
			}), {
				strokeWidth: 1.5,
				fill: "none",
				stroke: $(t, c, n.stroke),
				strokeMiterlimit: .5
			});
		},
		AdhocMarker: function(e, t, n) {
			var i = cf(t, n), a = lf(t, n);
			x("adhoc", e, r.getScaledPath("MARKER_ADHOC", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: i,
				containerHeight: a,
				position: {
					mx: (i / 2 + n.adhoc) / i,
					my: (a - 15) / a
				}
			}), {
				strokeWidth: 1,
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke)
			});
		}
	};
	function te(e, t, n, r) {
		ee[e](t, n, r);
	}
	function ne(e, t, n = [], r = {}) {
		r = {
			fill: r.fill,
			stroke: r.stroke,
			width: cf(t, r),
			height: lf(t, r)
		};
		var i = zu(t), a = n.includes("SubProcessMarker");
		r = a ? {
			...r,
			seq: -21,
			parallel: -22,
			compensation: -25,
			loop: -18,
			adhoc: 10
		} : {
			...r,
			seq: -5,
			parallel: -6,
			compensation: -7,
			loop: 0,
			adhoc: -8
		}, i.get("isForCompensation") && n.push("CompensationMarker"), Q(i, "bpmn:AdHocSubProcess") && (n.push("AdhocMarker"), a || Z(r, { compensation: r.compensation - 18 }));
		var o = i.get("loopCharacteristics"), s = o && o.get("isSequential");
		o && (Z(r, { compensation: r.compensation - 18 }), n.includes("AdhocMarker") && Z(r, {
			seq: -23,
			loop: -18,
			parallel: -24
		}), s === void 0 && n.push("LoopMarker"), s === !1 && n.push("ParallelMarker"), s === !0 && n.push("SequentialMarker")), n.includes("CompensationMarker") && n.length === 1 && Z(r, { compensation: -8 }), X(n, function(n) {
			te(n, e, t, r);
		});
	}
	function re(e, t, n = {}) {
		n = Z({ size: { width: 100 } }, n);
		var r = a.createText(t || "", n);
		return md(r).add("djs-label"), od(e, r), r;
	}
	function ie(e, t, n, r = {}) {
		var i = zu(t), a = sf({
			x: t.x,
			y: t.y,
			width: t.width,
			height: t.height
		}, r);
		return re(e, i.name, {
			align: n,
			box: a,
			padding: 7,
			style: { fill: tf(t, l, c, r.stroke) }
		});
	}
	function ae(e, t, n = {}) {
		var r = {
			width: t.width,
			height: t.height,
			x: t.width / 2 + t.x,
			y: t.height / 2 + t.y
		};
		return re(e, ed(t), {
			box: r,
			style: Z({}, a.getExternalStyle(), { fill: tf(t, l, c, n.stroke) })
		});
	}
	function oe(e, t, n, r = {}) {
		var i = Hu(n), a = re(e, t, {
			box: {
				height: 30,
				width: i ? lf(n, r) : cf(n, r)
			},
			align: "center-middle",
			style: { fill: tf(n, l, c, r.stroke) }
		});
		i && Nf(a, 0, -(-1 * lf(n, r)), 270);
	}
	function se(e, t, n = {}) {
		var { width: r, height: i } = sf(t, n);
		return g(e, r, i, Kf, {
			...n,
			fill: ef(t, s, n.fill),
			fillOpacity: Jf,
			stroke: $(t, c, n.stroke)
		});
	}
	function ce(e, t, n = {}) {
		var r = zu(t), i = ef(t, s, n.fill), a = $(t, c, n.stroke);
		return (r.get("associationDirection") === "One" || r.get("associationDirection") === "Both") && (n.markerEnd = p(e, "association-end", i, a)), r.get("associationDirection") === "Both" && (n.markerStart = p(e, "association-start", i, a)), n = Qf(n, ["markerStart", "markerEnd"]), y(e, t.waypoints, {
			...n,
			stroke: a,
			strokeDasharray: "0, 5"
		});
	}
	function le(e, t, n = {}) {
		var i = ef(t, s, n.fill), a = $(t, c, n.stroke), o = b(e, r.getScaledPath("DATA_OBJECT_PATH", {
			xScaleFactor: 1,
			yScaleFactor: 1,
			containerWidth: t.width,
			containerHeight: t.height,
			position: {
				mx: .474,
				my: .296
			}
		}), {
			fill: i,
			fillOpacity: Jf,
			stroke: a
		});
		return $d(zu(t)) && b(e, r.getScaledPath("DATA_OBJECT_COLLECTION_PATH", {
			xScaleFactor: 1,
			yScaleFactor: 1,
			containerWidth: t.width,
			containerHeight: t.height,
			position: {
				mx: .33,
				my: (t.height - 18) / t.height
			}
		}), {
			strokeWidth: 2,
			fill: i,
			stroke: a
		}), o;
	}
	function ue(e, t, n = {}) {
		return h(e, t.width, t.height, {
			fillOpacity: Jf,
			...n,
			fill: ef(t, s, n.fill),
			stroke: $(t, c, n.stroke)
		});
	}
	function de(e, t, n = {}) {
		return _(e, t.width, t.height, {
			fill: ef(t, s, n.fill),
			fillOpacity: Jf,
			stroke: $(t, c, n.stroke)
		});
	}
	function fe(e, t, n = {}) {
		var r = g(e, cf(t, n), lf(t, n), 0, {
			fill: ef(t, s, n.fill),
			fillOpacity: n.fillOpacity || Jf,
			stroke: $(t, c, n.stroke),
			strokeWidth: 1.5
		}), i = zu(t);
		return Q(i, "bpmn:Lane") && oe(e, i.get("name"), t, n), r;
	}
	function pe(e, t, n = {}) {
		var r = se(e, t, n), i = Vu(t);
		if (Uu(t) && (fd(r, {
			strokeDasharray: "0, 5.5",
			strokeWidth: 2.5
		}), !i)) {
			var a = (zu(t).flowElements || []).filter((e) => Q(e, "bpmn:StartEvent"));
			a.length === 1 && me(a[0], e, n, t);
		}
		return ie(e, t, i ? "center-top" : "center-middle", n), i ? ne(e, t, void 0, n) : ne(e, t, ["SubProcessMarker"], n), r;
	}
	function me(e, t, n, r) {
		var i = 22, a = {
			fill: ef(r, s, n.fill),
			stroke: $(r, c, n.stroke),
			width: i,
			height: i
		}, o = zu(e).isInterrupting, l = o ? 0 : 3, u = o ? 1 : 1.2, d = 20, f = (i - d) / 2, p = "translate(" + f + "," + f + ")";
		h(t, d, d, {
			fill: a.fill,
			stroke: a.stroke,
			strokeWidth: u,
			strokeDasharray: l,
			transform: p
		}), T(e, t, a, r);
	}
	function he(e, t, n = {}) {
		var r = se(e, t, n);
		return ie(e, t, "center-middle", n), ne(e, t, void 0, n), r;
	}
	var ge = this.handlers = {
		"bpmn:AdHocSubProcess": function(e, t, n = {}) {
			return n = Vu(t) ? Qf(n, [
				"fill",
				"stroke",
				"width",
				"height"
			]) : Qf(n, ["fill", "stroke"]), pe(e, t, n);
		},
		"bpmn:Association": function(e, t, n = {}) {
			return n = Qf(n, ["fill", "stroke"]), ce(e, t, n);
		},
		"bpmn:BoundaryEvent": function(e, t, n = {}) {
			var { renderIcon: r = !0 } = n;
			n = Qf(n, ["fill", "stroke"]);
			var i = zu(t).get("cancelActivity");
			n = {
				strokeWidth: 1.5,
				fill: ef(t, s, n.fill),
				fillOpacity: Yf,
				stroke: $(t, c, n.stroke)
			}, i || (n.strokeDasharray = "6");
			var a = ue(e, t, n);
			return h(e, t.width, t.height, Wf, {
				...n,
				fill: "none"
			}), r && T(t, e, n), a;
		},
		"bpmn:BusinessRuleTask": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = he(e, t, n);
			return fd(b(e, r.getScaledPath("TASK_TYPE_BUSINESS_RULE_MAIN", { abspos: {
				x: 8,
				y: 8
			} })), {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), fd(b(e, r.getScaledPath("TASK_TYPE_BUSINESS_RULE_HEADER", { abspos: {
				x: 8,
				y: 8
			} })), {
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), i;
		},
		"bpmn:CallActivity": function(e, t, n = {}) {
			return n = Qf(n, ["fill", "stroke"]), pe(e, t, {
				strokeWidth: 5,
				...n
			});
		},
		"bpmn:ComplexGateway": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = de(e, t, n);
			return b(e, r.getScaledPath("GATEWAY_COMPLEX", {
				xScaleFactor: .5,
				yScaleFactor: .5,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: .46,
					my: .26
				}
			}), {
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), i;
		},
		"bpmn:DataInput": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = r.getRawPath("DATA_ARROW"), a = le(e, t, n);
			return b(e, i, {
				fill: "none",
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), a;
		},
		"bpmn:DataInputAssociation": function(e, t, n = {}) {
			return n = Qf(n, ["fill", "stroke"]), ce(e, t, {
				...n,
				markerEnd: p(e, "association-end", ef(t, s, n.fill), $(t, c, n.stroke))
			});
		},
		"bpmn:DataObject": function(e, t, n = {}) {
			return n = Qf(n, ["fill", "stroke"]), le(e, t, n);
		},
		"bpmn:DataObjectReference": C("bpmn:DataObject"),
		"bpmn:DataOutput": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = r.getRawPath("DATA_ARROW"), a = le(e, t, n);
			return b(e, i, {
				strokeWidth: 1,
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke)
			}), a;
		},
		"bpmn:DataOutputAssociation": function(e, t, n = {}) {
			return n = Qf(n, ["fill", "stroke"]), ce(e, t, {
				...n,
				markerEnd: p(e, "association-end", ef(t, s, n.fill), $(t, c, n.stroke))
			});
		},
		"bpmn:DataStoreReference": function(e, t, n = {}) {
			return n = Qf(n, ["fill", "stroke"]), b(e, r.getScaledPath("DATA_STORE", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: 0,
					my: .133
				}
			}), {
				fill: ef(t, s, n.fill),
				fillOpacity: Jf,
				stroke: $(t, c, n.stroke),
				strokeWidth: 2
			});
		},
		"bpmn:EndEvent": function(e, t, n = {}) {
			var { renderIcon: r = !0 } = n;
			n = Qf(n, ["fill", "stroke"]);
			var i = ue(e, t, {
				...n,
				strokeWidth: 4
			});
			return r && T(t, e, n), i;
		},
		"bpmn:EventBasedGateway": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = zu(t), a = de(e, t, n);
			h(e, t.width, t.height, t.height * .2, {
				fill: ef(t, "none", n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
			var o = i.get("eventGatewayType"), s = !!i.get("instantiate");
			function l() {
				b(e, r.getScaledPath("GATEWAY_EVENT_BASED", {
					xScaleFactor: .18,
					yScaleFactor: .18,
					containerWidth: t.width,
					containerHeight: t.height,
					position: {
						mx: .36,
						my: .44
					}
				}), {
					fill: "none",
					stroke: $(t, c, n.stroke),
					strokeWidth: 2
				});
			}
			return o === "Parallel" ? b(e, r.getScaledPath("GATEWAY_PARALLEL", {
				xScaleFactor: .4,
				yScaleFactor: .4,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: .474,
					my: .296
				}
			}), {
				fill: "none",
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}) : o === "Exclusive" && (s || h(e, t.width, t.height, t.height * .26, {
				fill: "none",
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), l()), a;
		},
		"bpmn:ExclusiveGateway": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = de(e, t, n), a = r.getScaledPath("GATEWAY_EXCLUSIVE", {
				xScaleFactor: .4,
				yScaleFactor: .4,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: .32,
					my: .3
				}
			});
			return Bu(t).get("isMarkerVisible") && b(e, a, {
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), i;
		},
		"bpmn:Gateway": function(e, t, n = {}) {
			return n = Qf(n, ["fill", "stroke"]), de(e, t, n);
		},
		"bpmn:Group": function(e, t, n = {}) {
			return n = Qf(n, [
				"fill",
				"stroke",
				"width",
				"height"
			]), g(e, t.width, t.height, Kf, {
				stroke: $(t, c, n.stroke),
				strokeWidth: 1.5,
				strokeDasharray: "10, 6, 0, 6",
				fill: "none",
				pointerEvents: "none",
				width: cf(t, n),
				height: lf(t, n)
			});
		},
		"bpmn:InclusiveGateway": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var r = de(e, t, n);
			return h(e, t.width, t.height, t.height * .24, {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 2.5
			}), r;
		},
		"bpmn:IntermediateEvent": function(e, t, n = {}) {
			var { renderIcon: r = !0 } = n;
			n = Qf(n, ["fill", "stroke"]);
			var i = ue(e, t, {
				...n,
				strokeWidth: 1.5
			});
			return h(e, t.width, t.height, Wf, {
				fill: "none",
				stroke: $(t, c, n.stroke),
				strokeWidth: 1.5
			}), r && T(t, e, n), i;
		},
		"bpmn:IntermediateCatchEvent": C("bpmn:IntermediateEvent"),
		"bpmn:IntermediateThrowEvent": C("bpmn:IntermediateEvent"),
		"bpmn:Lane": function(e, t, n = {}) {
			return n = Qf(n, [
				"fill",
				"stroke",
				"width",
				"height"
			]), fe(e, t, {
				...n,
				fillOpacity: Xf
			});
		},
		"bpmn:ManualTask": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = he(e, t, n);
			return b(e, r.getScaledPath("TASK_TYPE_MANUAL", { abspos: {
				x: 17,
				y: 15
			} }), {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: .5
			}), i;
		},
		"bpmn:MessageFlow": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = zu(t), a = Bu(t), o = ef(t, s, n.fill), l = $(t, c, n.stroke), u = y(e, t.waypoints, {
				markerEnd: p(e, "messageflow-end", o, l),
				markerStart: p(e, "messageflow-start", o, l),
				stroke: l,
				strokeDasharray: "10, 11",
				strokeWidth: 1.5
			});
			if (i.get("messageRef")) {
				var d = u.getPointAtLength(u.getTotalLength() / 2), f = r.getScaledPath("MESSAGE_FLOW_MARKER", { abspos: {
					x: d.x,
					y: d.y
				} }), m = { strokeWidth: 1 };
				a.get("messageVisibleKind") === "initiating" ? (m.fill = o, m.stroke = l) : (m.fill = l, m.stroke = o);
				var h = b(e, f, m), g = re(e, i.get("messageRef").get("name"), {
					align: "center-top",
					fitBox: !0,
					style: { fill: l }
				}), _ = h.getBBox(), v = g.getBBox();
				Nf(g, d.x - v.width / 2, d.y + _.height / 2 + Uf, 0);
			}
			return u;
		},
		"bpmn:ParallelGateway": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = de(e, t, n);
			return b(e, r.getScaledPath("GATEWAY_PARALLEL", {
				xScaleFactor: .6,
				yScaleFactor: .6,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: .46,
					my: .2
				}
			}), {
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), i;
		},
		"bpmn:Participant": function(e, t, n = {}) {
			n = Qf(n, [
				"fill",
				"stroke",
				"width",
				"height"
			]);
			var r = fe(e, t, n), i = Vu(t), a = Hu(t), o = zu(t), s = o.get("name");
			if (i) v(e, a ? [{
				x: 30,
				y: 0
			}, {
				x: 30,
				y: lf(t, n)
			}] : [{
				x: 0,
				y: 30
			}, {
				x: cf(t, n),
				y: 30
			}], {
				stroke: $(t, c, n.stroke),
				strokeWidth: Gf
			}), oe(e, s, t, n);
			else {
				var u = sf(t, n);
				a || (u.height = cf(t, n), u.width = lf(t, n));
				var d = re(e, s, {
					box: u,
					align: "center-middle",
					style: { fill: tf(t, l, c, n.stroke) }
				});
				a || Nf(d, 0, -(-1 * lf(t, n)), 270);
			}
			return o.get("participantMultiplicity") && te("ParticipantMultiplicityMarker", e, t, n), r;
		},
		"bpmn:ReceiveTask": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = zu(t), a = he(e, t, n), o;
			return i.get("instantiate") ? (h(e, 28, 28, 20 * .22, {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), o = r.getScaledPath("TASK_TYPE_INSTANTIATING_SEND", { abspos: {
				x: 7.77,
				y: 9.52
			} })) : o = r.getScaledPath("TASK_TYPE_SEND", {
				xScaleFactor: .9,
				yScaleFactor: .9,
				containerWidth: 21,
				containerHeight: 14,
				position: {
					mx: .3,
					my: .4
				}
			}), b(e, o, {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), a;
		},
		"bpmn:ScriptTask": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = he(e, t, n);
			return b(e, r.getScaledPath("TASK_TYPE_SCRIPT", { abspos: {
				x: 15,
				y: 20
			} }), {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), i;
		},
		"bpmn:SendTask": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = he(e, t, n);
			return b(e, r.getScaledPath("TASK_TYPE_SEND", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: 21,
				containerHeight: 14,
				position: {
					mx: .285,
					my: .357
				}
			}), {
				fill: $(t, c, n.stroke),
				stroke: ef(t, s, n.fill),
				strokeWidth: 1
			}), i;
		},
		"bpmn:SequenceFlow": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var r = ef(t, s, n.fill), i = $(t, c, n.stroke), a = y(e, t.waypoints, {
				markerEnd: p(e, "sequenceflow-end", r, i),
				stroke: i
			}), o = zu(t), { source: l } = t;
			if (l) {
				var u = zu(l);
				o.get("conditionExpression") && Q(u, "bpmn:Activity") && fd(a, { markerStart: p(e, "conditional-flow-marker", r, i) }), u.get("default") && (Q(u, "bpmn:Gateway") || Q(u, "bpmn:Activity")) && u.get("default") === o && fd(a, { markerStart: p(e, "conditional-default-flow-marker", r, i) });
			}
			return a;
		},
		"bpmn:ServiceTask": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = he(e, t, n);
			return h(e, 10, 10, {
				fill: ef(t, s, n.fill),
				stroke: "none",
				transform: "translate(6, 6)"
			}), b(e, r.getScaledPath("TASK_TYPE_SERVICE", { abspos: {
				x: 12,
				y: 18
			} }), {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), h(e, 10, 10, {
				fill: ef(t, s, n.fill),
				stroke: "none",
				transform: "translate(11, 10)"
			}), b(e, r.getScaledPath("TASK_TYPE_SERVICE", { abspos: {
				x: 17,
				y: 22
			} }), {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), i;
		},
		"bpmn:StartEvent": function(e, t, n = {}) {
			var { renderIcon: r = !0 } = n;
			n = Qf(n, ["fill", "stroke"]), zu(t).get("isInterrupting") || (n = {
				...n,
				strokeDasharray: "6"
			});
			var i = ue(e, t, n);
			return r && T(t, e, n), i;
		},
		"bpmn:SubProcess": function(e, t, n = {}) {
			return n = Vu(t) ? Qf(n, [
				"fill",
				"stroke",
				"width",
				"height"
			]) : Qf(n, ["fill", "stroke"]), pe(e, t, n);
		},
		"bpmn:Task": function(e, t, n = {}) {
			return n = Qf(n, ["fill", "stroke"]), he(e, t, n);
		},
		"bpmn:TextAnnotation": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var { width: i, height: a } = sf(t, n), o = g(e, i, a, 0, 0, {
				fill: "none",
				stroke: "none"
			});
			return b(e, r.getScaledPath("TEXT_ANNOTATION", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: i,
				containerHeight: a,
				position: {
					mx: 0,
					my: 0
				}
			}), { stroke: $(t, c, n.stroke) }), re(e, zu(t).get("text") || "", {
				align: "left-top",
				box: sf(t, n),
				padding: 7,
				style: { fill: tf(t, l, c, n.stroke) }
			}), o;
		},
		"bpmn:Transaction": function(e, t, r = {}) {
			r = Vu(t) ? Qf(r, [
				"fill",
				"stroke",
				"width",
				"height"
			]) : Qf(r, ["fill", "stroke"]);
			var i = pe(e, t, {
				strokeWidth: 1.5,
				...r
			}), a = n.style(["no-fill", "no-events"], {
				stroke: $(t, c, r.stroke),
				strokeWidth: 1.5
			});
			return Vu(t) || (r = {}), g(e, cf(t, r), lf(t, r), Kf - Wf, Wf, a), i;
		},
		"bpmn:UserTask": function(e, t, n = {}) {
			n = Qf(n, ["fill", "stroke"]);
			var i = he(e, t, n), a = 15, o = 12;
			return b(e, r.getScaledPath("TASK_TYPE_USER_1", { abspos: {
				x: a,
				y: o
			} }), {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: .5
			}), b(e, r.getScaledPath("TASK_TYPE_USER_2", { abspos: {
				x: a,
				y: o
			} }), {
				fill: ef(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: .5
			}), b(e, r.getScaledPath("TASK_TYPE_USER_3", { abspos: {
				x: a,
				y: o
			} }), {
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke),
				strokeWidth: .5
			}), i;
		},
		label: function(e, t, n = {}) {
			return ae(e, t, n);
		}
	};
	this._drawPath = b, this._renderer = S;
}
cu(Zf, Lu), Zf.$inject = [
	"config.bpmnRenderer",
	"eventBus",
	"styles",
	"pathMap",
	"canvas",
	"textRenderer"
], Zf.prototype.canRender = function(e) {
	return Q(e, "bpmn:BaseElement");
}, Zf.prototype.drawShape = function(e, t, n = {}) {
	var { type: r } = t;
	return this._renderer(r)(e, t, n);
}, Zf.prototype.drawConnection = function(e, t, n = {}) {
	var { type: r } = t;
	return this._renderer(r)(e, t, n);
}, Zf.prototype.getShapePath = function(e) {
	return Gu(e) ? rf(e, qf) : Q(e, "bpmn:Event") ? nf(e) : Q(e, "bpmn:Activity") ? rf(e, Kf) : Q(e, "bpmn:Gateway") ? af(e) : of(e);
};
function Qf(e, t = []) {
	return t.reduce((t, n) => (e[n] && (t[n] = e[n]), t), {});
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/Text.js
var $f = 0, ep = {
	width: 150,
	height: 50
};
function tp(e) {
	var t = e.split("-");
	return {
		horizontal: t[0] || "center",
		vertical: t[1] || "top"
	};
}
function np(e) {
	return hu(e) ? Z({
		top: 0,
		left: 0,
		right: 0,
		bottom: 0
	}, e) : {
		top: e,
		left: e,
		right: e,
		bottom: e
	};
}
var rp = null;
function ip() {
	return rp ||= document.createElement("canvas").getContext("2d"), rp;
}
function ap(e) {
	var t = [];
	return e.fontStyle && t.push(e.fontStyle), e.fontVariant && t.push(e.fontVariant), e.fontWeight && t.push(e.fontWeight), e.fontStretch && t.push(e.fontStretch), t.push(op(e.fontSize) || "12px"), t.push(e.fontFamily || "sans-serif"), t.join(" ");
}
function op(e) {
	if (e != null) return typeof e == "number" || /^-?\d+(\.\d+)?$/.test(e) ? e + "px" : e;
}
function sp(e, t) {
	var n = ip();
	if (!n) return {
		width: 0,
		height: 0
	};
	n.font = ap(t), "letterSpacing" in n && (n.letterSpacing = op(t.letterSpacing) || "0px");
	var r = e === "", i = r ? "dummy" : e.replace(/\s+$/, ""), a = n.measureText(i);
	return {
		width: r ? 0 : a.width,
		height: "fontBoundingBoxAscent" in a ? a.fontBoundingBoxAscent + a.fontBoundingBoxDescent : a.actualBoundingBoxAscent + a.actualBoundingBoxDescent
	};
}
function cp(e, t, n) {
	for (var r = e.shift(), i = r, a;;) {
		if (a = sp(i, n), a.width = i ? a.width : 0, i === " " || i === "" || a.width < Math.round(t) || i.length < 2) return lp(e, i, r, a);
		i = fp(i, a.width, t);
	}
}
function lp(e, t, n, r) {
	if (t.length < n.length) {
		var i = n.slice(t.length).trim();
		e.unshift(i);
	}
	return {
		width: r.width,
		height: r.height,
		text: t
	};
}
var up = "­";
function dp(e, t) {
	var n = e.split(/(\s|-|\u00AD)/g), r, i = [], a = 0;
	if (n.length > 1) for (; r = n.shift();) if (r.length + a < t) i.push(r), a += r.length;
	else {
		(r === "-" || r === up) && i.pop();
		break;
	}
	var o = i[i.length - 1];
	return o && o === up && (i[i.length - 1] = "-"), i.join("");
}
function fp(e, t, n) {
	var r = Math.max(e.length * (n / t), 1), i = dp(e, r);
	return i ||= e.slice(0, Math.max(Math.round(r - 1), 1)), i;
}
function pp(e) {
	this._config = Z({}, {
		size: ep,
		padding: $f,
		style: {},
		align: "center-top"
	}, e || {});
}
pp.prototype.createText = function(e, t) {
	return this.layoutText(e, t).element;
}, pp.prototype.getDimensions = function(e, t) {
	return this.layoutText(e, t).dimensions;
}, pp.prototype.layoutText = function(e, t) {
	for (var n = Z({}, this._config.size, t.box), r = Z({}, this._config.style, t.style), i = tp(t.align || this._config.align), a = np(t.padding === void 0 ? this._config.padding : t.padding), o = t.fitBox || !1, s = mp(r), c = e.split(/\u00AD?\r?\n/), l = [], u = n.width - a.left - a.right; c.length;) l.push(cp(c, u, r));
	i.vertical === "middle" && (a.top = a.bottom = 0);
	var d = Cu(l, function(e, t, n) {
		return e + (s || t.height);
	}, 0) + a.top + a.bottom, f = Cu(l, function(e, t, n) {
		return t.width > e ? t.width : e;
	}, 0), p = a.top;
	i.vertical === "middle" && (p += (n.height - d) / 2), p -= (s || l[0].height) / 4;
	var m = xd("text");
	return fd(m, r), X(l, function(e) {
		var t;
		switch (p += s || e.height, i.horizontal) {
			case "left":
				t = a.left;
				break;
			case "right":
				t = (o ? f : u) - a.right - e.width;
				break;
			default: t = Math.max(((o ? f : u) - e.width) / 2 + a.left, 0);
		}
		var n = xd("tspan");
		fd(n, {
			x: t,
			y: p
		}), n.textContent = e.text, od(m, n);
	}), {
		dimensions: {
			width: f,
			height: d
		},
		element: m
	};
};
function mp(e) {
	if ("fontSize" in e && "lineHeight" in e) return e.lineHeight * parseInt(e.fontSize, 10);
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/draw/TextRenderer.js
var hp = 12, gp = 1.2, _p = 40;
function vp(e) {
	var t = Z({
		fontFamily: "Arial, sans-serif",
		fontSize: hp,
		fontWeight: "normal",
		lineHeight: gp
	}, e && e.defaultStyle || {}), n = Z({}, t, { fontSize: parseInt(t.fontSize, 10) - 1 }, e && e.externalStyle || {}), r = new pp({ style: t });
	this.getExternalLabelBounds = function(e, t) {
		var r = i(t, {
			width: Math.max(e.width, Ku.width),
			height: 30
		}, { style: n });
		return {
			x: Math.round(e.x + e.width / 2 - r.width / 2),
			y: e.y,
			width: Math.ceil(r.width),
			height: Math.ceil(r.height)
		};
	}, this.getTextAnnotationBounds = function(e, n) {
		var r = i(n, e, {
			style: t,
			align: "left-top",
			padding: 7
		});
		return {
			x: e.x,
			y: e.y,
			width: e.width,
			height: Math.max(_p, Math.round(r.height))
		};
	}, this.getDimensions = function(e, t) {
		return r.getDimensions(e, t || {});
	};
	function i(e, t, n) {
		return r.getDimensions(e, Z({ box: t }, n));
	}
	this.createText = function(e, t) {
		return r.createText(e, t || {});
	}, this.getDefaultStyle = function() {
		return t;
	}, this.getExternalStyle = function() {
		return n;
	};
}
vp.$inject = ["config.textRenderer"];
//#endregion
//#region ../../../node_modules/bpmn-js/lib/draw/PathMap.js
function yp() {
	this.pathMap = {
		EVENT_MESSAGE: {
			d: "m {mx},{my} l 0,{e.y1} l {e.x1},0 l 0,-{e.y1} z l {e.x0},{e.y0} l {e.x0},-{e.y0}",
			height: 36,
			width: 36,
			heightElements: [6, 14],
			widthElements: [10.5, 21]
		},
		EVENT_SIGNAL: {
			d: "M {mx},{my} l {e.x0},{e.y0} l -{e.x1},0 Z",
			height: 36,
			width: 36,
			heightElements: [18],
			widthElements: [10, 20]
		},
		EVENT_ESCALATION: {
			d: "M {mx},{my} l {e.x0},{e.y0} l -{e.x0},-{e.y1} l -{e.x0},{e.y1} Z",
			height: 36,
			width: 36,
			heightElements: [20, 7],
			widthElements: [8]
		},
		EVENT_CONDITIONAL: {
			d: "M {e.x0},{e.y0} l {e.x1},0 l 0,{e.y2} l -{e.x1},0 Z M {e.x2},{e.y3} l {e.x0},0 M {e.x2},{e.y4} l {e.x0},0 M {e.x2},{e.y5} l {e.x0},0 M {e.x2},{e.y6} l {e.x0},0 M {e.x2},{e.y7} l {e.x0},0 M {e.x2},{e.y8} l {e.x0},0 ",
			height: 36,
			width: 36,
			heightElements: [
				8.5,
				14.5,
				18,
				11.5,
				14.5,
				17.5,
				20.5,
				23.5,
				26.5
			],
			widthElements: [
				10.5,
				14.5,
				12.5
			]
		},
		EVENT_LINK: {
			d: "m {mx},{my} 0,{e.y0} -{e.x1},0 0,{e.y1} {e.x1},0 0,{e.y0} {e.x0},-{e.y2} -{e.x0},-{e.y2} z",
			height: 36,
			width: 36,
			heightElements: [
				4.4375,
				6.75,
				7.8125
			],
			widthElements: [9.84375, 13.5]
		},
		EVENT_ERROR: {
			d: "m {mx},{my} {e.x0},-{e.y0} {e.x1},-{e.y1} {e.x2},{e.y2} {e.x3},-{e.y3} -{e.x4},{e.y4} -{e.x5},-{e.y5} z",
			height: 36,
			width: 36,
			heightElements: [
				.023,
				8.737,
				8.151,
				16.564,
				10.591,
				8.714
			],
			widthElements: [
				.085,
				6.672,
				6.97,
				4.273,
				5.337,
				6.636
			]
		},
		EVENT_CANCEL_45: {
			d: "m {mx},{my} -{e.x1},0 0,{e.x0} {e.x1},0 0,{e.y1} {e.x0},0 0,-{e.y1} {e.x1},0 0,-{e.y0} -{e.x1},0 0,-{e.y1} -{e.x0},0 z",
			height: 36,
			width: 36,
			heightElements: [4.75, 8.5],
			widthElements: [4.75, 8.5]
		},
		EVENT_COMPENSATION: {
			d: "m {mx},{my} {e.x0},-{e.y0} 0,{e.y1} z m {e.x1},-{e.y2} {e.x2},-{e.y3} 0,{e.y1} -{e.x2},-{e.y3} z",
			height: 36,
			width: 36,
			heightElements: [
				6.5,
				13,
				.4,
				6.1
			],
			widthElements: [
				9,
				9.3,
				8.7
			]
		},
		EVENT_TIMER_WH: {
			d: "M {mx},{my} l {e.x0},-{e.y0} m -{e.x0},{e.y0} l {e.x1},{e.y1} ",
			height: 36,
			width: 36,
			heightElements: [10, 2],
			widthElements: [3, 7]
		},
		EVENT_TIMER_LINE: {
			d: "M {mx},{my} m {e.x0},{e.y0} l -{e.x1},{e.y1} ",
			height: 36,
			width: 36,
			heightElements: [10, 3],
			widthElements: [0, 0]
		},
		EVENT_MULTIPLE: {
			d: "m {mx},{my} {e.x1},-{e.y0} {e.x1},{e.y0} -{e.x0},{e.y1} -{e.x2},0 z",
			height: 36,
			width: 36,
			heightElements: [6.28099, 12.56199],
			widthElements: [
				3.1405,
				9.42149,
				12.56198
			]
		},
		EVENT_PARALLEL_MULTIPLE: {
			d: "m {mx},{my} {e.x0},0 0,{e.y1} {e.x1},0 0,{e.y0} -{e.x1},0 0,{e.y1} -{e.x0},0 0,-{e.y1} -{e.x1},0 0,-{e.y0} {e.x1},0 z",
			height: 36,
			width: 36,
			heightElements: [2.56228, 7.68683],
			widthElements: [2.56228, 7.68683]
		},
		GATEWAY_EXCLUSIVE: {
			d: "m {mx},{my} {e.x0},{e.y0} {e.x1},{e.y0} {e.x2},0 {e.x4},{e.y2} {e.x4},{e.y1} {e.x2},0 {e.x1},{e.y3} {e.x0},{e.y3} {e.x3},0 {e.x5},{e.y1} {e.x5},{e.y2} {e.x3},0 z",
			height: 17.5,
			width: 17.5,
			heightElements: [
				8.5,
				6.5312,
				-6.5312,
				-8.5
			],
			widthElements: [
				6.5,
				-6.5,
				3,
				-3,
				5,
				-5
			]
		},
		GATEWAY_PARALLEL: {
			d: "m {mx},{my} 0,{e.y1} -{e.x1},0 0,{e.y0} {e.x1},0 0,{e.y1} {e.x0},0 0,-{e.y1} {e.x1},0 0,-{e.y0} -{e.x1},0 0,-{e.y1} -{e.x0},0 z",
			height: 30,
			width: 30,
			heightElements: [5, 12.5],
			widthElements: [5, 12.5]
		},
		GATEWAY_EVENT_BASED: {
			d: "m {mx},{my} {e.x0},{e.y0} {e.x0},{e.y1} {e.x1},{e.y2} {e.x2},0 z",
			height: 11,
			width: 11,
			heightElements: [
				-6,
				6,
				12,
				-12
			],
			widthElements: [
				9,
				-3,
				-12
			]
		},
		GATEWAY_COMPLEX: {
			d: "m {mx},{my} 0,{e.y0} -{e.x0},-{e.y1} -{e.x1},{e.y2} {e.x0},{e.y1} -{e.x2},0 0,{e.y3} {e.x2},0  -{e.x0},{e.y1} l {e.x1},{e.y2} {e.x0},-{e.y1} 0,{e.y0} {e.x3},0 0,-{e.y0} {e.x0},{e.y1} {e.x1},-{e.y2} -{e.x0},-{e.y1} {e.x2},0 0,-{e.y3} -{e.x2},0 {e.x0},-{e.y1} -{e.x1},-{e.y2} -{e.x0},{e.y1} 0,-{e.y0} -{e.x3},0 z",
			height: 17.125,
			width: 17.125,
			heightElements: [
				4.875,
				3.4375,
				2.125,
				3
			],
			widthElements: [
				3.4375,
				2.125,
				4.875,
				3
			]
		},
		DATA_OBJECT_PATH: {
			d: "m 0,0 {e.x1},0 {e.x0},{e.y0} 0,{e.y1} -{e.x2},0 0,-{e.y2} {e.x1},0 0,{e.y0} {e.x0},0",
			height: 61,
			width: 51,
			heightElements: [
				10,
				50,
				60
			],
			widthElements: [
				10,
				40,
				50,
				60
			]
		},
		DATA_OBJECT_COLLECTION_PATH: {
			d: "m{mx},{my} m 3,2 l 0,10 m 3,-10 l 0,10 m 3,-10 l 0,10",
			height: 10,
			width: 10,
			heightElements: [],
			widthElements: []
		},
		DATA_ARROW: {
			d: "m 5,9 9,0 0,-3 5,5 -5,5 0,-3 -9,0 z",
			height: 61,
			width: 51,
			heightElements: [],
			widthElements: []
		},
		DATA_STORE: {
			d: "m  {mx},{my} l  0,{e.y2} c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0 l  0,-{e.y2} c -{e.x0},-{e.y1} -{e.x1},-{e.y1} -{e.x2},0c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0 m  -{e.x2},{e.y0}c  {e.x0},{e.y1} {e.x1},{e.y1} {e.x2},0m  -{e.x2},{e.y0}c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0",
			height: 61,
			width: 61,
			heightElements: [
				7,
				10,
				45
			],
			widthElements: [
				2,
				58,
				60
			]
		},
		TEXT_ANNOTATION: {
			d: "m {mx}, {my} m 10,0 l -10,0 l 0,{e.y0} l 10,0",
			height: 30,
			width: 10,
			heightElements: [30],
			widthElements: [10]
		},
		MARKER_SUB_PROCESS: {
			d: "m{mx},{my} m 7,2 l 0,10 m -5,-5 l 10,0",
			height: 10,
			width: 10,
			heightElements: [],
			widthElements: []
		},
		MARKER_PARALLEL: {
			d: "m{mx},{my} m 3,2 l 0,10 m 3,-10 l 0,10 m 3,-10 l 0,10",
			height: 10,
			width: 10,
			heightElements: [],
			widthElements: []
		},
		MARKER_SEQUENTIAL: {
			d: "m{mx},{my} m 0,3 l 10,0 m -10,3 l 10,0 m -10,3 l 10,0",
			height: 10,
			width: 10,
			heightElements: [],
			widthElements: []
		},
		MARKER_COMPENSATION: {
			d: "m {mx},{my} 7,-5 0,10 z m 7.1,-0.3 6.9,-4.7 0,10 -6.9,-4.7 z",
			height: 10,
			width: 21,
			heightElements: [],
			widthElements: []
		},
		MARKER_LOOP: {
			d: "m {mx},{my} c 3.526979,0 6.386161,-2.829858 6.386161,-6.320661 0,-3.490806 -2.859182,-6.320661 -6.386161,-6.320661 -3.526978,0 -6.38616,2.829855 -6.38616,6.320661 0,1.745402 0.714797,3.325567 1.870463,4.469381 0.577834,0.571908 1.265885,1.034728 2.029916,1.35457 l -0.718163,-3.909793 m 0.718163,3.909793 -3.885211,0.802902",
			height: 13.9,
			width: 13.7,
			heightElements: [],
			widthElements: []
		},
		MARKER_ADHOC: {
			d: "m {mx},{my} m 0.84461,2.64411 c 1.05533,-1.23780996 2.64337,-2.07882 4.29653,-1.97997996 2.05163,0.0805 3.85579,1.15803 5.76082,1.79107 1.06385,0.34139996 2.24454,0.1438 3.18759,-0.43767 0.61743,-0.33642 1.2775,-0.64078 1.7542,-1.17511 0,0.56023 0,1.12046 0,1.6807 -0.98706,0.96237996 -2.29792,1.62393996 -3.6918,1.66181996 -1.24459,0.0927 -2.46671,-0.2491 -3.59505,-0.74812 -1.35789,-0.55965 -2.75133,-1.33436996 -4.27027,-1.18121996 -1.37741,0.14601 -2.41842,1.13685996 -3.44288,1.96782996 z",
			height: 4,
			width: 15,
			heightElements: [],
			widthElements: []
		},
		TASK_TYPE_SEND: {
			d: "m {mx},{my} l 0,{e.y1} l {e.x1},0 l 0,-{e.y1} z l {e.x0},{e.y0} l {e.x0},-{e.y0}",
			height: 14,
			width: 21,
			heightElements: [6, 14],
			widthElements: [10.5, 21]
		},
		TASK_TYPE_SCRIPT: {
			d: "m {mx},{my} c 9.966553,-6.27276 -8.000926,-7.91932 2.968968,-14.938 l -8.802728,0 c -10.969894,7.01868 6.997585,8.66524 -2.968967,14.938 z m -7,-12 l 5,0 m -4.5,3 l 4.5,0 m -3,3 l 5,0m -4,3 l 5,0",
			height: 15,
			width: 12.6,
			heightElements: [6, 14],
			widthElements: [10.5, 21]
		},
		TASK_TYPE_USER_1: { d: "m {mx},{my} c 0.909,-0.845 1.594,-2.049 1.594,-3.385 0,-2.554 -1.805,-4.62199999 -4.357,-4.62199999 -2.55199998,0 -4.28799998,2.06799999 -4.28799998,4.62199999 0,1.348 0.974,2.562 1.89599998,3.405 -0.52899998,0.187 -5.669,2.097 -5.794,4.7560005 v 6.718 h 17 v -6.718 c 0,-2.2980005 -5.5279996,-4.5950005 -6.0509996,-4.7760005 zm -8,6 l 0,5.5 m 11,0 l 0,-5" },
		TASK_TYPE_USER_2: { d: "m {mx},{my} m 2.162,1.009 c 0,2.4470005 -2.158,4.4310005 -4.821,4.4310005 -2.66499998,0 -4.822,-1.981 -4.822,-4.4310005 " },
		TASK_TYPE_USER_3: { d: "m {mx},{my} m -6.9,-3.80 c 0,0 2.25099998,-2.358 4.27399998,-1.177 2.024,1.181 4.221,1.537 4.124,0.965 -0.098,-0.57 -0.117,-3.79099999 -4.191,-4.13599999 -3.57499998,0.001 -4.20799998,3.36699999 -4.20699998,4.34799999 z" },
		TASK_TYPE_MANUAL: { d: "m {mx},{my} c 0.234,-0.01 5.604,0.008 8.029,0.004 0.808,0 1.271,-0.172 1.417,-0.752 0.227,-0.898 -0.334,-1.314 -1.338,-1.316 -2.467,-0.01 -7.886,-0.004 -8.108,-0.004 -0.014,-0.079 0.016,-0.533 0,-0.61 0.195,-0.042 8.507,0.006 9.616,0.002 0.877,-0.007 1.35,-0.438 1.353,-1.208 0.003,-0.768 -0.479,-1.09 -1.35,-1.091 -2.968,-0.002 -9.619,-0.013 -9.619,-0.013 v -0.591 c 0,0 5.052,-0.016 7.225,-0.016 0.888,-0.002 1.354,-0.416 1.351,-1.193 -0.006,-0.761 -0.492,-1.196 -1.361,-1.196 -3.473,-0.005 -10.86,-0.003 -11.0829995,-0.003 -0.022,-0.047 -0.045,-0.094 -0.069,-0.139 0.3939995,-0.319 2.0409995,-1.626 2.4149995,-2.017 0.469,-0.4870005 0.519,-1.1650005 0.162,-1.6040005 -0.414,-0.511 -0.973,-0.5 -1.48,-0.236 -1.4609995,0.764 -6.5999995,3.6430005 -7.7329995,4.2710005 -0.9,0.499 -1.516,1.253 -1.882,2.19 -0.37000002,0.95 -0.17,2.01 -0.166,2.979 0.004,0.718 -0.27300002,1.345 -0.055,2.063 0.629,2.087 2.425,3.312 4.859,3.318 4.6179995,0.014 9.2379995,-0.139 13.8569995,-0.158 0.755,-0.004 1.171,-0.301 1.182,-1.033 0.012,-0.754 -0.423,-0.969 -1.183,-0.973 -1.778,-0.01 -5.824,-0.004 -6.04,-0.004 10e-4,-0.084 0.003,-0.586 10e-4,-0.67 z" },
		TASK_TYPE_INSTANTIATING_SEND: { d: "m {mx},{my} l 0,8.4 l 12.6,0 l 0,-8.4 z l 6.3,3.6 l 6.3,-3.6" },
		TASK_TYPE_SERVICE: { d: "m {mx},{my} v -1.71335 c 0.352326,-0.0705 0.703932,-0.17838 1.047628,-0.32133 0.344416,-0.14465 0.665822,-0.32133 0.966377,-0.52145 l 1.19431,1.18005 1.567487,-1.57688 -1.195028,-1.18014 c 0.403376,-0.61394 0.683079,-1.29908 0.825447,-2.01824 l 1.622133,-0.01 v -2.2196 l -1.636514,0.01 c -0.07333,-0.35153 -0.178319,-0.70024 -0.323564,-1.04372 -0.145244,-0.34406 -0.321407,-0.6644 -0.522735,-0.96217 l 1.131035,-1.13631 -1.583305,-1.56293 -1.129598,1.13589 c -0.614052,-0.40108 -1.302883,-0.68093 -2.022633,-0.82247 l 0.0093,-1.61852 h -2.241173 l 0.0042,1.63124 c -0.353763,0.0736 -0.705369,0.17977 -1.049785,0.32371 -0.344415,0.14437 -0.665102,0.32092 -0.9635006,0.52046 l -1.1698628,-1.15823 -1.5667691,1.5792 1.1684265,1.15669 c -0.4026573,0.61283 -0.68308,1.29797 -0.8247287,2.01713 l -1.6588041,0.003 v 2.22174 l 1.6724648,-0.006 c 0.073327,0.35077 0.1797598,0.70243 0.3242851,1.04472 0.1452428,0.34448 0.3214064,0.6644 0.5227339,0.96066 l -1.1993431,1.19723 1.5840256,1.56011 1.1964668,-1.19348 c 0.6140517,0.40346 1.3028827,0.68232 2.0233517,0.82331 l 7.19e-4,1.69892 h 2.226848 z m 0.221462,-3.9957 c -1.788948,0.7502 -3.8576,-0.0928 -4.6097055,-1.87438 -0.7521065,-1.78321 0.090598,-3.84627 1.8802645,-4.59604 1.78823,-0.74936 3.856881,0.0929 4.608987,1.87437 0.752106,1.78165 -0.0906,3.84612 -1.879546,4.59605 z" },
		TASK_TYPE_SERVICE_FILL: { d: "m {mx},{my} c -1.788948,0.7502 -3.8576,-0.0928 -4.6097055,-1.87438 -0.7521065,-1.78321 0.090598,-3.84627 1.8802645,-4.59604 1.78823,-0.74936 3.856881,0.0929 4.608987,1.87437 0.752106,1.78165 -0.0906,3.84612 -1.879546,4.59605 z" },
		TASK_TYPE_BUSINESS_RULE_HEADER: { d: "m {mx},{my} 0,4 20,0 0,-4 z" },
		TASK_TYPE_BUSINESS_RULE_MAIN: { d: "m {mx},{my} 0,12 20,0 0,-12 zm 0,8 l 20,0 m -13,-4 l 0,8" },
		MESSAGE_FLOW_MARKER: { d: "m {mx},{my} m -10.5 ,-7 l 0,14 l 21,0 l 0,-14 z l 10.5,6 l 10.5,-6" }
	}, this.getRawPath = function(e) {
		return this.pathMap[e].d;
	}, this.getScaledPath = function(e, t) {
		var n = this.pathMap[e], r, i;
		t.abspos ? (r = t.abspos.x, i = t.abspos.y) : (r = t.containerWidth * t.position.mx, i = t.containerHeight * t.position.my);
		var a = {};
		if (t.position) {
			for (var o = t.containerHeight / n.height * t.yScaleFactor, s = t.containerWidth / n.width * t.xScaleFactor, c = 0; c < n.heightElements.length; c++) a["y" + c] = n.heightElements[c] * o;
			for (var l = 0; l < n.widthElements.length; l++) a["x" + l] = n.widthElements[l] * s;
		}
		return Cp(n.d, {
			mx: r,
			my: i,
			e: a
		});
	};
}
var bp = /\{([^{}]+)\}/g, xp = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g;
function Sp(e, t, n) {
	var r = n;
	return t.replace(xp, function(e, t, n, i, a) {
		t ||= i, r && (t in r && (r = r[t]), typeof r == "function" && a && (r = r()));
	}), r = (r == null || r == n ? e : r) + "", r;
}
function Cp(e, t) {
	return String(e).replace(bp, function(e, n) {
		return Sp(e, n, t);
	});
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/draw/index.js
var wp = {
	__init__: ["bpmnRenderer"],
	bpmnRenderer: ["type", Zf],
	textRenderer: ["type", vp],
	pathMap: ["type", yp]
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/i18n/translate/translate.js
function Tp(e, t) {
	return t ||= {}, e.replace(/{([^}]+)}/g, function(e, n) {
		return t[n] || "{" + n + "}";
	});
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/i18n/translate/index.js
var Ep = { translate: ["value", Tp] }, Dp = Math;
Dp.PI, Dp.min, Dp.max, Dp.pow, Dp.abs, Array.isArray;
//#endregion
//#region ../../../node_modules/diagram-js/lib/layout/LayoutUtil.js
function Op(e) {
	return {
		x: Math.round(e.x),
		y: Math.round(e.y)
	};
}
function kp(e) {
	return {
		top: e.y,
		right: e.x + (e.width || 0),
		bottom: e.y + (e.height || 0),
		left: e.x
	};
}
function Ap(e) {
	return {
		x: e.left,
		y: e.top,
		width: e.right - e.left,
		height: e.bottom - e.top
	};
}
function jp(e) {
	return Op({
		x: e.x + (e.width || 0) / 2,
		y: e.y + (e.height || 0) / 2
	});
}
function Mp(e) {
	for (var t = e.waypoints, n = t.reduce(function(e, n, r) {
		var i = t[r - 1];
		if (i) {
			var a = e[e.length - 1], o = a && a.endLength || 0, s = Pp(i, n);
			e.push({
				start: i,
				end: n,
				startLength: o,
				endLength: o + s,
				length: s
			});
		}
		return e;
	}, []), r = n.reduce(function(e, t) {
		return e + t.length;
	}, 0) / 2, i = 0, a = n[i]; a.endLength < r;) a = n[++i];
	var o = (r - a.startLength) / a.length;
	return {
		x: a.start.x + (a.end.x - a.start.x) * o,
		y: a.start.y + (a.end.y - a.start.y) * o
	};
}
function Np(e) {
	return Wu(e) ? Mp(e) : jp(e);
}
function Pp(e, t) {
	return Math.sqrt((e.x - t.x) ** 2 + (e.y - t.y) ** 2);
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/import/Util.js
function Fp(e) {
	return e ? "<" + e.$type + (e.id ? " id=\"" + e.id : "") + "\" />" : "<null>";
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/import/BpmnImporter.js
function Ip(e, t, n) {
	return Z({
		id: e.id,
		type: e.$type,
		businessObject: e,
		di: t
	}, n);
}
function Lp(e, t, n) {
	var r = e.waypoint;
	return !r || r.length < 2 ? [Np(t), Np(n)] : r.map(function(e) {
		return {
			x: e.x,
			y: e.y
		};
	});
}
function Rp(e, t, n) {
	return /* @__PURE__ */ Error(`element ${Fp(t)} referenced by ${Fp(e)}#${n} not yet drawn`);
}
function zp(e, t, n, r, i) {
	this._eventBus = e, this._canvas = t, this._elementFactory = n, this._elementRegistry = r, this._textRenderer = i;
}
zp.$inject = [
	"eventBus",
	"canvas",
	"elementFactory",
	"elementRegistry",
	"textRenderer"
], zp.prototype.add = function(e, t, n) {
	var r, i, a;
	if (Q(t, "bpmndi:BPMNPlane")) {
		var o = Q(e, "bpmn:SubProcess") ? { id: e.id + "_plane" } : {};
		r = this._elementFactory.createRoot(Ip(e, t, o)), this._canvas.addRootElement(r);
	} else if (Q(t, "bpmndi:BPMNShape")) {
		var s = !Vu(e, t), c = Vp(e);
		i = n && (n.hidden || n.collapsed);
		var l = t.bounds;
		r = this._elementFactory.createShape(Ip(e, t, {
			collapsed: s,
			hidden: i,
			x: Math.round(l.x),
			y: Math.round(l.y),
			width: Math.round(l.width),
			height: Math.round(l.height),
			isFrame: c
		})), Q(e, "bpmn:BoundaryEvent") && this._attachBoundary(e, r), Q(e, "bpmn:Lane") && (a = 0), Q(e, "bpmn:DataStoreReference") && (Bp(n, Np(l)) || (n = this._canvas.findRoot(n))), this._canvas.addShape(r, n, a);
	} else if (Q(t, "bpmndi:BPMNEdge")) {
		var u = this._getSource(e), d = this._getTarget(e);
		i = n && (n.hidden || n.collapsed), r = this._elementFactory.createConnection(Ip(e, t, {
			hidden: i,
			source: u,
			target: d,
			waypoints: Lp(t, u, d)
		})), Q(e, "bpmn:DataAssociation") && (n = this._canvas.findRoot(n)), this._canvas.addConnection(r, n, a);
	} else throw Error(`unknown di ${Fp(t)} for element ${Fp(e)}`);
	return qu(e) && ed(r) && this.addLabel(e, t, r), this._eventBus.fire("bpmnElement.added", { element: r }), r;
}, zp.prototype._attachBoundary = function(e, t) {
	var n = e.attachedToRef;
	if (!n) throw Error(`missing ${Fp(e)}#attachedToRef`);
	var r = this._elementRegistry.get(n.id), i = r && r.attachers;
	if (!r) throw Rp(e, n, "attachedToRef");
	t.host = r, i || (r.attachers = i = []), i.indexOf(t) === -1 && i.push(t);
}, zp.prototype.addLabel = function(e, t, n) {
	var r = Zu(t, n), i = ed(n), a;
	return i && (r = this._textRenderer.getExternalLabelBounds(r, i)), a = this._elementFactory.createLabel(Ip(e, t, {
		id: e.id + "_label",
		labelTarget: n,
		type: "label",
		hidden: n.hidden || !ed(n),
		x: Math.round(r.x),
		y: Math.round(r.y),
		width: Math.round(r.width),
		height: Math.round(r.height)
	})), this._canvas.addShape(a, n.parent);
}, zp.prototype._getConnectedElement = function(e, t) {
	var n, r, i = e.$type;
	if (r = e[t + "Ref"], t === "source" && i === "bpmn:DataInputAssociation" && (r &&= r[0]), (t === "source" && i === "bpmn:DataOutputAssociation" || t === "target" && i === "bpmn:DataInputAssociation") && (r = e.$parent), n = r && this._getElement(r), n) return n;
	throw r ? Rp(e, r, t + "Ref") : Error(`${Fp(e)}#${t} Ref not specified`);
}, zp.prototype._getSource = function(e) {
	return this._getConnectedElement(e, "source");
}, zp.prototype._getTarget = function(e) {
	return this._getConnectedElement(e, "target");
}, zp.prototype._getElement = function(e) {
	return this._elementRegistry.get(e.id);
};
function Bp(e, t) {
	var n = t.x, r = t.y;
	return n >= e.x && n <= e.x + e.width && r >= e.y && r <= e.y + e.height;
}
function Vp(e) {
	return Q(e, "bpmn:Group");
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/core/index.js
var Hp = { __depends__: [wp, {
	__depends__: [Ep],
	bpmnImporter: ["type", zp]
}] };
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/IdGenerator.js
function Up(e) {
	this._counter = 0, this._prefix = (e ? e + "-" : "") + Math.floor(Math.random() * 1e9) + "-";
}
Up.prototype.next = function() {
	return this._prefix + ++this._counter;
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/overlays/Overlays.js
var Wp = new Up("ov"), Gp = 500;
function Kp(e, t, n, r) {
	this._eventBus = t, this._canvas = n, this._elementRegistry = r, this._ids = Wp, this._overlayDefaults = Z({
		show: null,
		scale: !0
	}, e && e.defaults), this._overlays = {}, this._overlayContainers = [], this._overlayRoot = qp(n.getContainer()), this._init();
}
Kp.$inject = [
	"config.overlays",
	"eventBus",
	"canvas",
	"elementRegistry"
], Kp.prototype.get = function(e) {
	if (vu(e) && (e = { id: e }), vu(e.element) && (e.element = this._elementRegistry.get(e.element)), e.element) {
		var t = this._getOverlayContainer(e.element, !0);
		return t ? e.type ? Su(t.overlays, Du({ type: e.type })) : t.overlays.slice() : [];
	} else if (e.type) return Su(this._overlays, Du({ type: e.type }));
	else return e.id ? this._overlays[e.id] : null;
}, Kp.prototype.add = function(e, t, n) {
	if (hu(t) && (n = t, t = null), e.id || (e = this._elementRegistry.get(e)), !n.position) throw Error("must specifiy overlay position");
	if (!n.html) throw Error("must specifiy overlay html");
	if (!e) throw Error("invalid element specified");
	var r = this._ids.next();
	return n = Z({}, this._overlayDefaults, n, {
		id: r,
		type: t,
		element: e,
		html: n.html
	}), this._addOverlay(n), r;
}, Kp.prototype.remove = function(e) {
	var t = this.get(e) || [];
	mu(t) || (t = [t]);
	var n = this;
	X(t, function(e) {
		var t = n._getOverlayContainer(e.element, !0);
		if (e && (Mf(e.html), Mf(e.htmlContainer), delete e.htmlContainer, delete e.element, delete n._overlays[e.id]), t) {
			var r = t.overlays.indexOf(e);
			r !== -1 && t.overlays.splice(r, 1);
		}
	});
}, Kp.prototype.isShown = function() {
	return this._overlayRoot.style.display !== "none";
}, Kp.prototype.show = function() {
	Yp(this._overlayRoot);
}, Kp.prototype.hide = function() {
	Yp(this._overlayRoot, !1);
}, Kp.prototype.clear = function() {
	this._overlays = {}, this._overlayContainers = [], vf(this._overlayRoot);
}, Kp.prototype._updateOverlayContainer = function(e) {
	var t = e.element, n = e.html, r = t.x, i = t.y;
	if (t.waypoints) {
		var a = td(t);
		r = a.x, i = a.y;
	}
	Jp(n, r, i), mf(e.html, "data-container-id", t.id);
}, Kp.prototype._updateOverlay = function(e) {
	var t = e.position, n = e.htmlContainer, r = e.element, i = t.left, a = t.top;
	if (t.right !== void 0) {
		var o = r.waypoints ? td(r).width : r.width;
		i = t.right * -1 + o;
	}
	if (t.bottom !== void 0) {
		var s = r.waypoints ? td(r).height : r.height;
		a = t.bottom * -1 + s;
	}
	Jp(n, i || 0, a || 0), this._updateOverlayVisibilty(e, this._canvas.viewbox());
}, Kp.prototype._createOverlayContainer = function(e) {
	var t = df("<div class=\"djs-overlays\" />");
	pf(t, { position: "absolute" }), this._overlayRoot.appendChild(t);
	var n = {
		html: t,
		element: e,
		overlays: []
	};
	return this._updateOverlayContainer(n), this._overlayContainers.push(n), n;
}, Kp.prototype._updateRoot = function(e) {
	var t = e.scale || 1, n = "matrix(" + [
		t,
		0,
		0,
		t,
		-1 * e.x * t,
		-1 * e.y * t
	].join(",") + ")";
	Xp(this._overlayRoot, n);
}, Kp.prototype._getOverlayContainer = function(e, t) {
	var n = bu(this._overlayContainers, function(t) {
		return t.element === e;
	});
	return !n && !t ? this._createOverlayContainer(e) : n;
}, Kp.prototype._addOverlay = function(e) {
	var t = e.id, n = e.element, r = e.html, i, a;
	r.get && r.constructor.prototype.jquery && (r = r.get(0)), vu(r) && (r = df(r)), a = this._getOverlayContainer(n), i = df("<div class=\"djs-overlay\" data-overlay-id=\"" + t + "\">"), pf(i, { position: "absolute" }), i.appendChild(r), e.type && gf(i).add("djs-overlay-" + e.type);
	var o = this._canvas.findRoot(n), s = this._canvas.getRootElement();
	Yp(i, o === s), e.htmlContainer = i, a.overlays.push(e), a.html.appendChild(i), this._overlays[t] = e, this._updateOverlay(e), this._updateOverlayVisibilty(e, this._canvas.viewbox());
}, Kp.prototype._updateOverlayVisibilty = function(e, t) {
	var n = e.show, r = this._canvas.findRoot(e.element), i = n && n.minZoom, a = n && n.maxZoom, o = e.htmlContainer, s = this._canvas.getRootElement(), c = !0;
	r === s ? n && (fu(i) && i > t.scale || fu(a) && a < t.scale) && (c = !1) : c = !1, Yp(o, c), this._updateOverlayScale(e, t);
}, Kp.prototype._updateOverlayScale = function(e, t) {
	var n = e.scale, r, i, a = e.htmlContainer, o, s = "";
	n !== !0 && (n === !1 ? (r = 1, i = 1) : (r = n.min, i = n.max), fu(r) && t.scale < r && (o = (1 / t.scale || 1) * r), fu(i) && t.scale > i && (o = (1 / t.scale || 1) * i)), fu(o) && (s = "scale(" + o + "," + o + ")"), Xp(a, s);
}, Kp.prototype._updateOverlaysVisibilty = function(e) {
	var t = this;
	X(this._overlays, function(n) {
		t._updateOverlayVisibilty(n, e);
	});
}, Kp.prototype._init = function() {
	var e = this._eventBus, t = this;
	function n(e) {
		t._updateRoot(e), t._updateOverlaysVisibilty(e), t.show();
	}
	e.on("canvas.viewbox.changing", function(e) {
		t.hide();
	}), e.on("canvas.viewbox.changed", function(e) {
		n(e.viewbox);
	}), e.on(["shape.remove", "connection.remove"], function(e) {
		var n = e.element;
		X(t.get({ element: n }), function(e) {
			t.remove(e.id);
		});
		var r = t._getOverlayContainer(n);
		if (r) {
			Mf(r.html);
			var i = t._overlayContainers.indexOf(r);
			i !== -1 && t._overlayContainers.splice(i, 1);
		}
	}), e.on("element.changed", Gp, function(e) {
		var n = e.element, r = t._getOverlayContainer(n, !0);
		r && (X(r.overlays, function(e) {
			t._updateOverlay(e);
		}), t._updateOverlayContainer(r));
	}), e.on("element.marker.update", function(e) {
		var n = t._getOverlayContainer(e.element, !0);
		n && gf(n.html)[e.add ? "add" : "remove"](e.marker);
	}), e.on("root.set", function() {
		t._updateOverlaysVisibilty(t._canvas.viewbox());
	}), e.on("diagram.clear", this.clear, this);
};
function qp(e) {
	var t = df("<div class=\"djs-overlay-container\" />");
	return pf(t, {
		position: "absolute",
		width: 0,
		height: 0
	}), e.insertBefore(t, e.firstChild), t;
}
function Jp(e, t, n) {
	pf(e, {
		left: t + "px",
		top: n + "px"
	});
}
function Yp(e, t) {
	e.style.display = t === !1 ? "none" : "";
}
function Xp(e, t) {
	e.style["transform-origin"] = "top left", [
		"",
		"-ms-",
		"-webkit-"
	].forEach(function(n) {
		e.style[n + "transform"] = t;
	});
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/overlays/index.js
var Zp = {
	__init__: ["overlays"],
	overlays: ["type", Kp]
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/change-support/ChangeSupport.js
function Qp(e, t, n, r) {
	e.on("element.changed", function(r) {
		var i = r.element;
		(i.parent || i === t.getRootElement()) && (r.gfx = n.getGraphics(i)), r.gfx && e.fire(nd(i) + ".changed", r);
	}), e.on("elements.changed", function(t) {
		var n = t.elements;
		n.forEach(function(t) {
			e.fire("element.changed", { element: t });
		}), r.updateContainments(n);
	}), e.on("shape.changed", function(e) {
		r.update("shape", e.element, e.gfx);
	}), e.on("connection.changed", function(e) {
		r.update("connection", e.element, e.gfx);
	});
}
Qp.$inject = [
	"eventBus",
	"canvas",
	"elementRegistry",
	"graphicsFactory"
];
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/change-support/index.js
var $p = {
	__init__: ["changeSupport"],
	changeSupport: ["type", Qp]
}, em = 1e3;
function tm(e) {
	this._eventBus = e;
}
tm.$inject = ["eventBus"];
function nm(e, t) {
	return function(n) {
		return e.call(t || null, n.context, n.command, n);
	};
}
tm.prototype.on = function(e, t, n, r, i, a) {
	if ((_u(t) || gu(t)) && (a = i, i = r, r = n, n = t, t = null), _u(n) && (a = i, i = r, r = n, n = em), hu(i) && (a = i, i = !1), !_u(r)) throw Error("handlerFn must be a function");
	mu(e) || (e = [e]);
	var o = this._eventBus;
	X(e, function(e) {
		var s = [
			"commandStack",
			e,
			t
		].filter(function(e) {
			return e;
		}).join(".");
		o.on(s, n, i ? nm(r, a) : r, a);
	});
}, tm.prototype.canExecute = rm("canExecute"), tm.prototype.preExecute = rm("preExecute"), tm.prototype.preExecuted = rm("preExecuted"), tm.prototype.execute = rm("execute"), tm.prototype.executed = rm("executed"), tm.prototype.postExecute = rm("postExecute"), tm.prototype.postExecuted = rm("postExecuted"), tm.prototype.revert = rm("revert"), tm.prototype.reverted = rm("reverted");
function rm(e) {
	return function(t, n, r, i, a) {
		(_u(t) || gu(t)) && (a = i, i = r, r = n, n = t, t = null), this.on(t, e, n, r, i, a);
	};
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/root-elements/RootElementsBehavior.js
function im(e, t) {
	t.invoke(tm, this), this.executed(function(t) {
		var n = t.context;
		n.rootElement ? e.setRootElement(n.rootElement) : n.rootElement = e.getRootElement();
	}), this.revert(function(t) {
		var n = t.context;
		n.rootElement && e.setRootElement(n.rootElement);
	});
}
cu(im, tm), im.$inject = ["canvas", "injector"];
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/root-elements/index.js
var am = {
	__init__: ["rootElementsBehavior"],
	rootElementsBehavior: ["type", im]
}, om = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
};
function sm(e) {
	return e = "" + e, e && e.replace(/[&<>"']/g, function(e) {
		return om[e];
	});
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/util/DrilldownUtil.js
var cm = "_plane";
function lm(e) {
	var t = e.id;
	return Q(e, "bpmn:SubProcess") ? um(t) : t;
}
function um(e) {
	return e + cm;
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/features/drilldown/DrilldownBreadcrumbs.js
var dm = "bjs-breadcrumbs-shown";
function fm(e, t, n) {
	var r = df("<ul class=\"bjs-breadcrumbs\"></ul>"), i = n.getContainer(), a = gf(i);
	i.appendChild(r);
	var o = [];
	e.on("element.changed", function(e) {
		var t = e.element, n = zu(t);
		bu(o, function(e) {
			return e === n;
		}) && s();
	});
	function s(e) {
		e && (o = pm(e));
		var i = o.flatMap(function(e) {
			var r = n.findRoot(lm(e)) || n.findRoot(e.id);
			if (!r && Q(e, "bpmn:Process")) {
				var i = t.find(function(t) {
					var n = zu(t);
					return n && n.get("processRef") === e;
				});
				r = i && n.findRoot(i.id);
			}
			if (!r) return [];
			var a = sm(e.name || e.id), o = df("<li><span class=\"bjs-crumb\"><a title=\"" + a + "\">" + a + "</a></span></li>");
			return o.addEventListener("click", function() {
				n.setRootElement(r);
			}), o;
		});
		r.innerHTML = "";
		var s = i.length > 1;
		a.toggle(dm, s), i.forEach(function(e) {
			r.appendChild(e);
		});
	}
	e.on("root.set", function(e) {
		s(e.element);
	});
}
fm.$inject = [
	"eventBus",
	"elementRegistry",
	"canvas"
];
function pm(e) {
	for (var t = zu(e), n = [], r = t; r; r = r.$parent) (Q(r, "bpmn:SubProcess") || Q(r, "bpmn:Process")) && n.push(r);
	return n.reverse();
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/features/drilldown/DrilldownCentering.js
function mm(e, t) {
	var n = null, r = new hm();
	e.on("root.set", function(e) {
		var i = e.element, a = t.viewbox(), o = r.get(i);
		if (r.set(n, {
			x: a.x,
			y: a.y,
			zoom: a.scale
		}), n = i, !(!Q(i, "bpmn:SubProcess") && !o)) {
			o ||= {
				x: 0,
				y: 0,
				zoom: 1
			};
			var s = (a.x - o.x) * a.scale, c = (a.y - o.y) * a.scale;
			(s !== 0 || c !== 0) && t.scroll({
				dx: s,
				dy: c
			}), o.zoom !== a.scale && t.zoom(o.zoom, {
				x: 0,
				y: 0
			});
		}
	}), e.on("diagram.clear", function() {
		r.clear(), n = null;
	});
}
mm.$inject = ["eventBus", "canvas"];
function hm() {
	this._entries = [], this.set = function(e, t) {
		var n = !1;
		for (var r in this._entries) if (this._entries[r][0] === e) {
			this._entries[r][1] = t, n = !0;
			break;
		}
		n || this._entries.push([e, t]);
	}, this.get = function(e) {
		for (var t in this._entries) if (this._entries[t][0] === e) return this._entries[t][1];
		return null;
	}, this.clear = function() {
		this._entries.length = 0;
	}, this.remove = function(e) {
		var t = -1;
		for (var n in this._entries) if (this._entries[n][0] === e) {
			t = n;
			break;
		}
		t !== -1 && this._entries.splice(t, 1);
	};
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/features/drilldown/SubprocessCompatibility.js
var gm = {
	x: 180,
	y: 160
};
function _m(e, t) {
	this._eventBus = e, this._moddle = t;
	var n = this;
	e.on("import.render.start", 1500, function(e, t) {
		n._handleImport(t.definitions);
	});
}
_m.prototype._handleImport = function(e) {
	if (e.diagrams) {
		var t = this;
		this._definitions = e, this._processToDiagramMap = {}, e.diagrams.forEach(function(e) {
			!e.plane || !e.plane.bpmnElement || (t._processToDiagramMap[e.plane.bpmnElement.id] = e);
		}), e.diagrams.filter((e) => e.plane).flatMap((e) => t._createNewDiagrams(e.plane)).forEach(function(e) {
			t._movePlaneElementsToOrigin(e.plane);
		});
	}
}, _m.prototype._createNewDiagrams = function(e) {
	var t = this, n = [], r = [];
	e.get("planeElement").forEach(function(t) {
		var i = t.bpmnElement;
		if (i) {
			var a = i.$parent;
			Q(i, "bpmn:SubProcess") && !t.isExpanded && n.push(i), bm(i, e) && r.push({
				diElement: t,
				parent: a
			});
		}
	});
	var i = [];
	return n.forEach(function(e) {
		if (!t._processToDiagramMap[e.id]) {
			var n = t._createDiagram(e);
			t._processToDiagramMap[e.id] = n, i.push(n);
		}
	}), r.forEach(function(e) {
		for (var r = e.diElement, i = e.parent; i && n.indexOf(i) === -1;) i = i.$parent;
		if (i) {
			var a = t._processToDiagramMap[i.id];
			t._moveToDiPlane(r, a.plane);
		}
	}), i;
}, _m.prototype._movePlaneElementsToOrigin = function(e) {
	var t = e.get("planeElement"), n = ym(e), r = {
		x: n.x - gm.x,
		y: n.y - gm.y
	};
	t.forEach(function(e) {
		e.waypoint ? e.waypoint.forEach(function(e) {
			e.x -= r.x, e.y -= r.y;
		}) : e.bounds && (e.bounds.x = e.bounds.x - r.x, e.bounds.y = e.bounds.y - r.y);
	});
}, _m.prototype._moveToDiPlane = function(e, t) {
	var n = vm(e).plane.get("planeElement");
	n.splice(n.indexOf(e), 1), t.get("planeElement").push(e);
}, _m.prototype._createDiagram = function(e) {
	var t = this._moddle.create("bpmndi:BPMNPlane", { bpmnElement: e }), n = this._moddle.create("bpmndi:BPMNDiagram", { plane: t });
	return t.$parent = n, t.bpmnElement = e, n.$parent = this._definitions, this._definitions.diagrams.push(n), n;
}, _m.$inject = ["eventBus", "moddle"];
function vm(e) {
	return Q(e, "bpmndi:BPMNDiagram") ? e : vm(e.$parent);
}
function ym(e) {
	var t = {
		top: Infinity,
		right: -Infinity,
		bottom: -Infinity,
		left: Infinity
	};
	return e.planeElement.forEach(function(e) {
		if (e.bounds) {
			var n = kp(e.bounds);
			t.top = Math.min(n.top, t.top), t.left = Math.min(n.left, t.left);
		}
	}), Ap(t);
}
function bm(e, t) {
	var n = e.$parent;
	return !(!Q(n, "bpmn:SubProcess") || n === t.bpmnElement || Ru(e, ["bpmn:DataInputAssociation", "bpmn:DataOutputAssociation"]));
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/features/drilldown/DrilldownOverlayBehavior.js
var xm = 250, Sm = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4.81801948,3.50735931 L10.4996894,9.1896894 L10.5,4 L12,4 L12,12 L4,12 L4,10.5 L9.6896894,10.4996894 L3.75735931,4.56801948 C3.46446609,4.27512627 3.46446609,3.80025253 3.75735931,3.50735931 C4.05025253,3.21446609 4.52512627,3.21446609 4.81801948,3.50735931 Z\"/></svg>", Cm = "bjs-drilldown-empty";
function wm(e, t, n, r, i) {
	tm.call(this, t), this._canvas = e, this._eventBus = t, this._elementRegistry = n, this._overlays = r, this._translate = i;
	var a = this;
	this.executed("shape.toggleCollapse", xm, function(e) {
		var t = e.shape;
		a._canDrillDown(t) ? a._addOverlay(t) : a._removeOverlay(t);
	}, !0), this.reverted("shape.toggleCollapse", xm, function(e) {
		var t = e.shape;
		a._canDrillDown(t) ? a._addOverlay(t) : a._removeOverlay(t);
	}, !0), this.executed([
		"shape.create",
		"shape.move",
		"shape.delete"
	], xm, function(e) {
		var t = e.oldParent, n = e.newParent || e.parent, r = e.shape;
		a._canDrillDown(r) && a._addOverlay(r), a._updateDrilldownOverlay(t), a._updateDrilldownOverlay(n), a._updateDrilldownOverlay(r);
	}, !0), this.reverted([
		"shape.create",
		"shape.move",
		"shape.delete"
	], xm, function(e) {
		var t = e.oldParent, n = e.newParent || e.parent, r = e.shape;
		a._canDrillDown(r) && a._addOverlay(r), a._updateDrilldownOverlay(t), a._updateDrilldownOverlay(n), a._updateDrilldownOverlay(r);
	}, !0), t.on("import.render.complete", function() {
		n.filter(function(e) {
			return a._canDrillDown(e);
		}).map(function(e) {
			a._addOverlay(e);
		});
	});
}
cu(wm, tm), wm.prototype._updateDrilldownOverlay = function(e) {
	var t = this._canvas;
	if (e) {
		var n = t.findRoot(e);
		n && this._updateOverlayVisibility(n);
	}
}, wm.prototype._canDrillDown = function(e) {
	var t = this._canvas;
	return Q(e, "bpmn:SubProcess") && t.findRoot(lm(e));
}, wm.prototype._updateOverlayVisibility = function(e) {
	var t = this._overlays, n = zu(e), r = t.get({
		element: n.id,
		type: "drilldown"
	})[0];
	if (r) {
		var i = n && n.get("flowElements") && n.get("flowElements").length;
		gf(r.html).toggle(Cm, !i);
	}
}, wm.prototype._addOverlay = function(e) {
	var t = this._canvas, n = this._overlays, r = zu(e);
	n.get({
		element: e,
		type: "drilldown"
	}).length && this._removeOverlay(e);
	var i = df("<button type=\"button\" class=\"bjs-drilldown\">" + Sm + "</button>"), a = r.get("name") || r.get("id"), o = this._translate("Open {element}", { element: a });
	i.setAttribute("title", o), i.addEventListener("click", function() {
		t.setRootElement(t.findRoot(lm(e)));
	}), n.add(e, "drilldown", {
		position: {
			bottom: -7,
			right: -8
		},
		html: i
	}), this._updateOverlayVisibility(e);
}, wm.prototype._removeOverlay = function(e) {
	this._overlays.remove({
		element: e,
		type: "drilldown"
	});
}, wm.$inject = [
	"canvas",
	"eventBus",
	"elementRegistry",
	"overlays",
	"translate"
];
//#endregion
//#region ../../../node_modules/bpmn-js/lib/features/drilldown/index.js
var Tm = {
	__depends__: [
		Zp,
		$p,
		am
	],
	__init__: [
		"drilldownBreadcrumbs",
		"drilldownOverlayBehavior",
		"drilldownCentering",
		"subprocessCompatibility"
	],
	drilldownBreadcrumbs: ["type", fm],
	drilldownCentering: ["type", mm],
	drilldownOverlayBehavior: ["type", wm],
	subprocessCompatibility: ["type", _m]
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/Event.js
function Em(e) {
	return e.originalEvent || e.srcEvent;
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/Mouse.js
function Dm(e, t) {
	return (Em(e) || e).button === t;
}
function Om(e) {
	return Dm(e, 0);
}
function km(e) {
	return Dm(e, 1);
}
function Am(e) {
	var t = Em(e) || e;
	return Om(e) && t.shiftKey;
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/interaction-events/InteractionEvents.js
function jm(e) {
	return !0;
}
function Mm(e) {
	return Om(e) || km(e);
}
var Nm = 500;
function Pm(e, t, n) {
	var r = this;
	function i(n, r, i) {
		if (!s(n, r)) {
			var a, o, c;
			i ? o = t.getGraphics(i) : (a = r.delegateTarget || r.target, a && (o = a, i = t.get(o))), !(!o || !i) && (c = e.fire(n, {
				element: i,
				gfx: o,
				originalEvent: r
			}), c === !1 && (r.stopPropagation(), r.preventDefault()));
		}
	}
	var a = {};
	function o(e) {
		return a[e];
	}
	function s(e, t) {
		return !(l[e] || Om)(t);
	}
	var c = {
		click: "element.click",
		contextmenu: "element.contextmenu",
		dblclick: "element.dblclick",
		mousedown: "element.mousedown",
		mousemove: "element.mousemove",
		mouseover: "element.hover",
		mouseout: "element.out",
		mouseup: "element.mouseup"
	}, l = {
		"element.contextmenu": jm,
		"element.mousedown": Mm,
		"element.mouseup": Mm,
		"element.click": Mm,
		"element.dblclick": Mm
	};
	function u(e, t, n) {
		var r = c[e];
		if (!r) throw Error("unmapped DOM event name <" + e + ">");
		return i(r, t, n);
	}
	var d = "svg, .djs-element";
	function f(e, t, n, r) {
		var o = a[n] = function(e) {
			i(n, e);
		};
		r && (l[n] = r), o.$delegate = kf.bind(e, d, t, o);
	}
	function p(e, t, n) {
		var r = o(n);
		r && kf.unbind(e, t, r.$delegate);
	}
	function m(e) {
		X(c, function(t, n) {
			f(e, n, t);
		});
	}
	function h(e) {
		X(c, function(t, n) {
			p(e, n, t);
		});
	}
	e.on("canvas.destroy", function(e) {
		h(e.svg);
	}), e.on("canvas.init", function(e) {
		m(e.svg);
	}), e.on(["shape.added", "connection.added"], function(t) {
		var n = t.element, r = t.gfx;
		e.fire("interactionEvents.createHit", {
			element: n,
			gfx: r
		});
	}), e.on(["shape.changed", "connection.changed"], Nm, function(t) {
		var n = t.element, r = t.gfx;
		e.fire("interactionEvents.updateHit", {
			element: n,
			gfx: r
		});
	}), e.on("interactionEvents.createHit", Nm, function(e) {
		var t = e.element, n = e.gfx;
		r.createDefaultHit(t, n);
	}), e.on("interactionEvents.updateHit", function(e) {
		var t = e.element, n = e.gfx;
		r.updateDefaultHit(t, n);
	});
	var g = y("djs-hit djs-hit-stroke"), _ = y("djs-hit djs-hit-click-stroke"), v = {
		all: y("djs-hit djs-hit-all"),
		"click-stroke": _,
		stroke: g,
		"no-move": y("djs-hit djs-hit-no-move")
	};
	function y(e, t) {
		return t = Z({
			stroke: "white",
			strokeWidth: 15
		}, t || {}), n.cls(e, ["no-fill", "no-border"], t);
	}
	function b(e, t) {
		var n = v[t];
		if (!n) throw Error("invalid hit type <" + t + ">");
		return fd(e, n), e;
	}
	function x(e, t) {
		od(e, t);
	}
	this.removeHits = function(e) {
		X(jf(".djs-hit", e), Ld);
	}, this.createDefaultHit = function(e, t) {
		var n = e.waypoints, r = e.isFrame, i;
		return n ? this.createWaypointsHit(t, n) : (i = r ? "stroke" : "all", this.createBoxHit(t, i, {
			width: e.width,
			height: e.height
		}));
	}, this.createWaypointsHit = function(e, t) {
		var n = Jd(t);
		return b(n, "stroke"), x(e, n), n;
	}, this.createBoxHit = function(e, t, n) {
		n = Z({
			x: 0,
			y: 0
		}, n);
		var r = xd("rect");
		return b(r, t), fd(r, n), x(e, r), r;
	}, this.updateDefaultHit = function(e, t) {
		var n = Af(".djs-hit", t);
		if (n) return e.waypoints ? Yd(n, e.waypoints) : fd(n, {
			width: e.width,
			height: e.height
		}), n;
	}, this.fire = i, this.triggerMouseEvent = u, this.mouseHandler = o, this.registerEvent = f, this.unregisterEvent = p;
}
Pm.$inject = [
	"eventBus",
	"elementRegistry",
	"styles"
];
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/interaction-events/index.js
var Fm = {
	__init__: ["interactionEvents"],
	interactionEvents: ["type", Pm]
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/selection/Selection.js
function Im(e, t) {
	this._eventBus = e, this._canvas = t, this._selectedElements = [];
	var n = this;
	e.on(["shape.remove", "connection.remove"], function(e) {
		var t = e.element;
		n.deselect(t);
	}), e.on(["diagram.clear", "root.set"], function(e) {
		n.select(null);
	});
}
Im.$inject = ["eventBus", "canvas"], Im.prototype.deselect = function(e) {
	var t = this._selectedElements, n = t.indexOf(e);
	if (n !== -1) {
		var r = t.slice();
		t.splice(n, 1), this._eventBus.fire("selection.changed", {
			oldSelection: r,
			newSelection: t
		});
	}
}, Im.prototype.get = function() {
	return this._selectedElements;
}, Im.prototype.isSelected = function(e) {
	return this._selectedElements.indexOf(e) !== -1;
}, Im.prototype.select = function(e, t) {
	var n = this._selectedElements, r = n.slice();
	mu(e) || (e = e ? [e] : []);
	var i = this._canvas, a = i.getRootElement();
	e = e.filter(function(e) {
		return a === i.findRoot(e);
	}), t ? X(e, function(e) {
		n.indexOf(e) === -1 && n.push(e);
	}) : this._selectedElements = n = e.slice(), this._eventBus.fire("selection.changed", {
		oldSelection: r,
		newSelection: n
	});
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/selection/SelectionVisuals.js
var Lm = "hover", Rm = "selected";
function zm(e, t) {
	this._canvas = e;
	function n(t, n) {
		e.addMarker(t, n);
	}
	function r(t, n) {
		e.removeMarker(t, n);
	}
	t.on("element.hover", function(e) {
		n(e.element, Lm);
	}), t.on("element.out", function(e) {
		r(e.element, Lm);
	}), t.on("selection.changed", function(e) {
		function t(e) {
			r(e, Rm);
		}
		function i(e) {
			n(e, Rm);
		}
		var a = e.oldSelection, o = e.newSelection;
		X(a, function(e) {
			o.indexOf(e) === -1 && t(e);
		}), X(o, function(e) {
			a.indexOf(e) === -1 && i(e);
		});
	});
}
zm.$inject = ["canvas", "eventBus"];
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/selection/SelectionBehavior.js
function Bm(e, t, n, r) {
	e.on("create.end", 500, function(e) {
		var n = e.context, r = n.canExecute, i = n.elements, a = (n.hints || {}).autoSelect;
		if (r) {
			if (a === !1) return;
			mu(a) ? t.select(a) : t.select(i.filter(Vm));
		}
	}), e.on("connect.end", 500, function(e) {
		var n = e.context.connection;
		n && t.select(n);
	}), e.on("shape.move.end", 500, function(e) {
		var n = e.previousSelection || [], i = r.get(e.context.shape.id);
		bu(n, function(e) {
			return i.id === e.id;
		}) || t.select(i);
	}), e.on("element.click", function(e) {
		if (Om(e)) {
			var r = e.element;
			r === n.getRootElement() && (r = null);
			var i = t.isSelected(r), a = t.get().length > 1, o = Am(e);
			if (i && a) return o ? t.deselect(r) : t.select(r);
			i ? t.deselect(r) : t.select(r, o);
		}
	});
}
Bm.$inject = [
	"eventBus",
	"selection",
	"canvas",
	"elementRegistry"
];
function Vm(e) {
	return !e.hidden;
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/selection/index.js
var Hm = {
	__init__: ["selectionVisuals", "selectionBehavior"],
	__depends__: [Fm],
	selection: ["type", Im],
	selectionVisuals: ["type", zm],
	selectionBehavior: ["type", Bm]
}, Um = /^class[ {]/;
function Wm(e) {
	return Um.test(e.toString());
}
function Gm(e) {
	return Array.isArray(e);
}
function Km(e, t) {
	return Object.prototype.hasOwnProperty.call(e, t);
}
function qm(...e) {
	e.length === 1 && Gm(e[0]) && (e = e[0]), e = [...e];
	let t = e.pop();
	return t.$inject = e, t;
}
var Jm = /constructor\s*[^(]*\(\s*([^)]*)\)/m, Ym = /^(?:async\s+)?(?:function\s*[^(]*)?(?:\(\s*([^)]*)\)|(\w+))/m, Xm = /\/\*([^*]*)\*\//m;
function Zm(e) {
	if (typeof e != "function") throw Error(`Cannot annotate "${e}". Expected a function!`);
	let t = e.toString().match(Wm(e) ? Jm : Ym);
	if (!t) return [];
	let n = t[1] || t[2];
	return n && n.split(",").map((e) => {
		let t = e.match(Xm);
		return (t && t[1] || e).trim();
	}) || [];
}
function Qm(e, t) {
	let n = t || { get: function(e, t) {
		if (r.push(e), t === !1) return null;
		throw s(`No provider for "${e}"!`);
	} }, r = [], i = this._providers = Object.create(n._providers || null), a = this._instances = Object.create(null), o = a.injector = this, s = function(e) {
		let t = r.join(" -> ");
		return r.length = 0, Error(t ? `${e} (Resolving: ${t})` : e);
	};
	function c(e, t) {
		if (!i[e] && e.includes(".")) {
			let t = e.split("."), n = c(t.shift());
			for (; t.length;) n = n[t.shift()];
			return n;
		}
		if (Km(a, e)) return a[e];
		if (Km(i, e)) {
			if (r.indexOf(e) !== -1) throw r.push(e), s("Cannot resolve circular dependency!");
			return r.push(e), a[e] = i[e][0](i[e][1]), r.pop(), a[e];
		}
		return n.get(e, t);
	}
	function l(e, t) {
		if (t === void 0 && (t = {}), typeof e != "function") if (Gm(e)) e = qm(e.slice());
		else throw s(`Cannot invoke "${e}". Expected a function!`);
		let n = (e.$inject || Zm(e)).map((e) => Km(t, e) ? t[e] : c(e));
		return {
			fn: e,
			dependencies: n
		};
	}
	function u(e) {
		let { fn: t, dependencies: n } = l(e);
		return new (Function.prototype.bind.call(t, null, ...n))();
	}
	function d(e, t, n) {
		let { fn: r, dependencies: i } = l(e, n);
		return r.apply(t, i);
	}
	function f(e) {
		return qm((t) => e.get(t));
	}
	function p(e, t) {
		if (t && t.length) {
			let n = Object.create(null), r = Object.create(null), a = [], o = [], s = [], c, l, u, d;
			for (let e in i) c = i[e], t.indexOf(e) !== -1 && (c[2] === "private" ? (l = a.indexOf(c[3]), l === -1 ? (u = c[3].createChild([], t), d = f(u), a.push(c[3]), o.push(u), s.push(d), n[e] = [
				d,
				e,
				"private",
				u
			]) : n[e] = [
				s[l],
				e,
				"private",
				o[l]
			]) : n[e] = [c[2], c[1]], r[e] = !0), (c[2] === "factory" || c[2] === "type") && c[1].$scope && t.forEach((t) => {
				c[1].$scope.indexOf(t) !== -1 && (n[e] = [c[2], c[1]], r[t] = !0);
			});
			t.forEach((e) => {
				if (!r[e]) throw Error("No provider for \"" + e + "\". Cannot use provider from the parent!");
			}), e.unshift(n);
		}
		return new Qm(e, o);
	}
	let m = {
		factory: d,
		type: u,
		value: function(e) {
			return e;
		}
	};
	function h(e, t) {
		let n = e.__init__ || [];
		return function() {
			n.forEach((e) => {
				typeof e == "string" ? t.get(e) : t.invoke(e);
			});
		};
	}
	function g(e) {
		let t = e.__exports__;
		if (t) {
			let n = e.__modules__, r = Object.keys(e).reduce((t, n) => (n !== "__exports__" && n !== "__modules__" && n !== "__init__" && n !== "__depends__" && (t[n] = e[n]), t), Object.create(null)), a = p((n || []).concat(r)), o = qm(function(e) {
				return a.get(e);
			});
			t.forEach(function(e) {
				i[e] = [
					o,
					e,
					"private",
					a
				];
			});
			let s = (e.__init__ || []).slice();
			return s.unshift(function() {
				a.init();
			}), e = Object.assign({}, e, { __init__: s }), h(e, a);
		}
		return Object.keys(e).forEach(function(t) {
			if (t === "__init__" || t === "__depends__") return;
			let n = e[t];
			if (n[2] === "private") {
				i[t] = n;
				return;
			}
			let r = n[0], a = n[1];
			i[t] = [
				m[r],
				$m(r, a),
				r
			];
		}), h(e, o);
	}
	function _(e, t) {
		return e.indexOf(t) !== -1 || (e = (t.__depends__ || []).reduce(_, e), e.indexOf(t) !== -1) ? e : e.concat(t);
	}
	function v(e) {
		let t = e.reduce(_, []).map(g), n = !1;
		return function() {
			n || (n = !0, t.forEach((e) => e()));
		};
	}
	this.get = c, this.invoke = d, this.instantiate = u, this.createChild = p, this.init = v(e);
}
function $m(e, t) {
	return e !== "value" && Gm(t) && (t = qm(t.slice())), t;
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/draw/DefaultRenderer.js
var eh = 1;
function th(e, t) {
	Lu.call(this, e, eh), this.CONNECTION_STYLE = t.style(["no-fill"], {
		strokeWidth: 5,
		stroke: "fuchsia"
	}), this.SHAPE_STYLE = t.style({
		fill: "white",
		stroke: "fuchsia",
		strokeWidth: 2
	}), this.FRAME_STYLE = t.style(["no-fill"], {
		stroke: "fuchsia",
		strokeDasharray: 4,
		strokeWidth: 2
	});
}
cu(th, Lu), th.prototype.canRender = function() {
	return !0;
}, th.prototype.drawShape = function(e, t, n) {
	var r = xd("rect");
	return fd(r, {
		x: 0,
		y: 0,
		width: t.width || 0,
		height: t.height || 0
	}), rd(t) ? fd(r, Z({}, this.FRAME_STYLE, n || {})) : fd(r, Z({}, this.SHAPE_STYLE, n || {})), od(e, r), r;
}, th.prototype.drawConnection = function(e, t, n) {
	var r = Jd(t.waypoints, Z({}, this.CONNECTION_STYLE, n || {}));
	return od(e, r), r;
}, th.prototype.getShapePath = function(e) {
	var t = e.x, n = e.y, r = e.width, i = e.height;
	return Vd([
		[
			"M",
			t,
			n
		],
		[
			"l",
			r,
			0
		],
		[
			"l",
			0,
			i
		],
		[
			"l",
			-r,
			0
		],
		["z"]
	]);
}, th.prototype.getConnectionPath = function(e) {
	var t = e.waypoints, n, r, i = [];
	for (n = 0; r = t[n]; n++) r = r.original || r, i.push([
		n === 0 ? "M" : "L",
		r.x,
		r.y
	]);
	return Vd(i);
}, th.$inject = ["eventBus", "styles"];
//#endregion
//#region ../../../node_modules/diagram-js/lib/draw/Styles.js
function nh() {
	var e = {
		"no-fill": { fill: "none" },
		"no-border": { strokeOpacity: 0 },
		"no-events": { pointerEvents: "none" }
	}, t = this;
	this.cls = function(e, t, n) {
		return Z(this.style(t, n), { class: e });
	}, this.style = function(t, n) {
		!mu(t) && !n && (n = t, t = []);
		var r = Cu(t, function(t, n) {
			return Z(t, e[n] || {});
		}, {});
		return n ? Z(r, n) : r;
	}, this.computeStyle = function(e, n, r) {
		return mu(n) || (r = n, n = []), t.style(n || [], Z({}, r, e || {}));
	};
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/draw/index.js
var rh = {
	__init__: ["defaultRenderer"],
	defaultRenderer: ["type", th],
	styles: ["type", nh]
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/Collections.js
function ih(e, t) {
	if (!e || !t) return -1;
	var n = e.indexOf(t);
	return n !== -1 && e.splice(n, 1), n;
}
function ah(e, t, n) {
	if (!(!e || !t)) {
		typeof n != "number" && (n = -1);
		var r = e.indexOf(t);
		if (r !== -1) {
			if (r === n) return;
			if (n !== -1) e.splice(r, 1);
			else return;
		}
		n === -1 ? e.push(t) : e.splice(n, 0, t);
	}
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/core/Canvas.js
function oh(e, t) {
	return Math.round(e * t) / t;
}
function sh(e) {
	return gu(e) ? e + "px" : e;
}
function ch(e) {
	for (; e.parent;) e = e.parent;
	return e;
}
function lh(e) {
	e = Z({}, {
		width: "100%",
		height: "100%"
	}, e);
	let t = e.container || document.body, n = document.createElement("div");
	return n.setAttribute("class", "djs-container djs-parent"), pf(n, {
		position: "relative",
		overflow: "hidden",
		width: sh(e.width),
		height: sh(e.height)
	}), t.appendChild(n), n;
}
function uh(e, t, n) {
	let r = xd("g");
	md(r).add(t);
	let i = n === void 0 ? e.childNodes.length - 1 : n;
	return e.insertBefore(r, e.childNodes[i] || null), r;
}
var dh = "base", fh = 0, ph = 1, mh = {
	shape: [
		"x",
		"y",
		"width",
		"height"
	],
	connection: ["waypoints"]
};
function hh(e, t, n, r) {
	this._eventBus = t, this._elementRegistry = r, this._graphicsFactory = n, this._rootsIdx = 0, this._layers = {}, this._planes = [], this._rootElement = null, this._focused = !1, this._init(e || {});
}
hh.$inject = [
	"config.canvas",
	"eventBus",
	"graphicsFactory",
	"elementRegistry"
], hh.prototype._init = function(e) {
	let t = this._eventBus, n = this._container = lh(e), r = this._svg = xd("svg");
	fd(r, {
		width: "100%",
		height: "100%"
	}), mf(r, "tabindex", 0), e.autoFocus && t.on("element.hover", () => {
		this.restoreFocus();
	}), t.on("element.mousedown", 500, (e) => {
		this.focus();
	}), r.addEventListener("focusin", () => {
		this._setFocused(!0);
	}), r.addEventListener("focusout", () => {
		this._setFocused(!1);
	}), r.addEventListener("mouseover", () => {
		this._eventBus.fire("canvas.mouseover");
	}), r.addEventListener("mouseout", () => {
		this._eventBus.fire("canvas.mouseout");
	}), od(n, r);
	let i = this._viewport = uh(r, "viewport");
	e.deferUpdate && (this._viewboxChanged = ju(Mu(this._viewboxChanged, this), 300)), t.on("diagram.init", () => {
		t.fire("canvas.init", {
			svg: r,
			viewport: i
		});
	}), t.on([
		"shape.added",
		"connection.added",
		"shape.removed",
		"connection.removed",
		"elements.changed",
		"root.set"
	], () => {
		delete this._cachedViewbox;
	}), t.on("diagram.destroy", 500, this._destroy, this), t.on("diagram.clear", 500, this._clear, this);
}, hh.prototype._destroy = function() {
	this._eventBus.fire("canvas.destroy", {
		svg: this._svg,
		viewport: this._viewport
	});
	let e = this._container.parentNode;
	e && e.removeChild(this._container), delete this._svg, delete this._container, delete this._layers, delete this._planes, delete this._rootElement, delete this._viewport;
}, hh.prototype._setFocused = function(e) {
	e != this._focused && (this._focused = e, this._eventBus.fire("canvas.focus.changed", { focused: e }));
}, hh.prototype._clear = function() {
	this._elementRegistry.getAll().forEach((e) => {
		let t = nd(e);
		t === "root" ? this.removeRootElement(e) : this._removeElement(e, t);
	}), this._planes = [], this._rootElement = null, delete this._cachedViewbox;
}, hh.prototype.focus = function() {
	this._svg.focus({ preventScroll: !0 }), this._setFocused(!0);
}, hh.prototype.restoreFocus = function() {
	document.activeElement === document.body && this.focus();
}, hh.prototype.isFocused = function() {
	return this._focused;
}, hh.prototype.getDefaultLayer = function() {
	return this.getLayer(dh, fh);
}, hh.prototype.getLayer = function(e, t) {
	if (!e) throw Error("must specify a name");
	let n = this._layers[e];
	if (n ||= this._layers[e] = this._createLayer(e, t), t !== void 0 && n.index !== t) throw Error("layer <" + e + "> already created at index <" + t + ">");
	return n.group;
}, hh.prototype._getChildIndex = function(e) {
	return Cu(this._layers, function(t, n) {
		return n.visible && e >= n.index && t++, t;
	}, 0);
}, hh.prototype._createLayer = function(e, t) {
	t === void 0 && (t = ph);
	let n = this._getChildIndex(t);
	return {
		group: uh(this._viewport, "layer-" + e, n),
		index: t,
		visible: !0
	};
}, hh.prototype.showLayer = function(e) {
	if (!e) throw Error("must specify a name");
	let t = this._layers[e];
	if (!t) throw Error("layer <" + e + "> does not exist");
	let n = this._viewport, r = t.group, i = t.index;
	if (t.visible) return r;
	let a = this._getChildIndex(i);
	return n.insertBefore(r, n.childNodes[a] || null), t.visible = !0, r;
}, hh.prototype.hideLayer = function(e) {
	if (!e) throw Error("must specify a name");
	let t = this._layers[e];
	if (!t) throw Error("layer <" + e + "> does not exist");
	let n = t.group;
	return t.visible ? (Ld(n), t.visible = !1, n) : n;
}, hh.prototype._removeLayer = function(e) {
	let t = this._layers[e];
	t && (delete this._layers[e], Ld(t.group));
}, hh.prototype.getActiveLayer = function() {
	let e = this._findPlaneForRoot(this.getRootElement());
	return e ? e.layer : null;
}, hh.prototype.findRoot = function(e) {
	if (typeof e == "string" && (e = this._elementRegistry.get(e)), e) return (this._findPlaneForRoot(ch(e)) || {}).rootElement;
}, hh.prototype.getRootElements = function() {
	return this._planes.map(function(e) {
		return e.rootElement;
	});
}, hh.prototype._findPlaneForRoot = function(e) {
	return bu(this._planes, function(t) {
		return t.rootElement === e;
	});
}, hh.prototype.getContainer = function() {
	return this._container;
}, hh.prototype._updateMarker = function(e, t, n) {
	let r;
	e.id || (e = this._elementRegistry.get(e)), e.markers = e.markers || /* @__PURE__ */ new Set(), r = this._elementRegistry._elements[e.id], r && (X([r.gfx, r.secondaryGfx], function(r) {
		r && (n ? (e.markers.add(t), md(r).add(t)) : (e.markers.delete(t), md(r).remove(t)));
	}), this._eventBus.fire("element.marker.update", {
		element: e,
		gfx: r.gfx,
		marker: t,
		add: !!n
	}));
}, hh.prototype.addMarker = function(e, t) {
	this._updateMarker(e, t, !0);
}, hh.prototype.removeMarker = function(e, t) {
	this._updateMarker(e, t, !1);
}, hh.prototype.hasMarker = function(e, t) {
	return e.id || (e = this._elementRegistry.get(e)), e.markers ? e.markers.has(t) : !1;
}, hh.prototype.toggleMarker = function(e, t) {
	this.hasMarker(e, t) ? this.removeMarker(e, t) : this.addMarker(e, t);
}, hh.prototype.getRootElement = function() {
	let e = this._rootElement;
	return e || this._planes.length ? e : this.setRootElement(this.addRootElement(null));
}, hh.prototype.addRootElement = function(e) {
	let t = this._rootsIdx++;
	e ||= {
		id: "__implicitroot_" + t,
		children: [],
		isImplicit: !0
	};
	let n = e.layer = "root-" + t;
	this._ensureValid("root", e);
	let r = this.getLayer(n, fh);
	return this.hideLayer(n), this._addRoot(e, r), this._planes.push({
		rootElement: e,
		layer: r
	}), e;
}, hh.prototype.removeRootElement = function(e) {
	if (typeof e == "string" && (e = this._elementRegistry.get(e)), this._findPlaneForRoot(e)) return this._removeRoot(e), this._removeLayer(e.layer), this._planes = this._planes.filter(function(t) {
		return t.rootElement !== e;
	}), this._rootElement === e && (this._rootElement = null), e;
}, hh.prototype.setRootElement = function(e) {
	if (e === this._rootElement) return e;
	let t;
	if (!e) throw Error("rootElement required");
	return t = this._findPlaneForRoot(e), t || (e = this.addRootElement(e)), this._setRoot(e), e;
}, hh.prototype._removeRoot = function(e) {
	let t = this._elementRegistry, n = this._eventBus;
	n.fire("root.remove", { element: e }), n.fire("root.removed", { element: e }), t.remove(e);
}, hh.prototype._addRoot = function(e, t) {
	let n = this._elementRegistry, r = this._eventBus;
	r.fire("root.add", { element: e }), n.add(e, t), r.fire("root.added", {
		element: e,
		gfx: t
	});
}, hh.prototype._setRoot = function(e, t) {
	let n = this._rootElement;
	n && (this._elementRegistry.updateGraphics(n, null, !0), this.hideLayer(n.layer)), e && (t ||= this._findPlaneForRoot(e).layer, this._elementRegistry.updateGraphics(e, this._svg, !0), this.showLayer(e.layer)), this._rootElement = e, this._eventBus.fire("root.set", { element: e });
}, hh.prototype._ensureValid = function(e, t) {
	if (!t.id) throw Error("element must have an id");
	if (this._elementRegistry.get(t.id)) throw Error("element <" + t.id + "> already exists");
	let n = mh[e];
	if (!wu(n, function(e) {
		return t[e] !== void 0;
	})) throw Error("must supply { " + n.join(", ") + " } with " + e);
}, hh.prototype._setParent = function(e, t, n) {
	ah(t.children, e, n), e.parent = t;
}, hh.prototype._addElement = function(e, t, n, r) {
	n ||= this.getRootElement();
	let i = this._eventBus, a = this._graphicsFactory;
	this._ensureValid(e, t), i.fire(e + ".add", {
		element: t,
		parent: n
	}), this._setParent(t, n, r);
	let o = a.create(e, t, r);
	return this._elementRegistry.add(t, o), a.update(e, t, o), i.fire(e + ".added", {
		element: t,
		gfx: o
	}), t;
}, hh.prototype.addShape = function(e, t, n) {
	return this._addElement("shape", e, t, n);
}, hh.prototype.addConnection = function(e, t, n) {
	return this._addElement("connection", e, t, n);
}, hh.prototype._removeElement = function(e, t) {
	let n = this._elementRegistry, r = this._graphicsFactory, i = this._eventBus;
	if (e = n.get(e.id || e), e) return i.fire(t + ".remove", { element: e }), r.remove(e), ih(e.parent && e.parent.children, e), e.parent = null, i.fire(t + ".removed", { element: e }), n.remove(e), e;
}, hh.prototype.removeShape = function(e) {
	return this._removeElement(e, "shape");
}, hh.prototype.removeConnection = function(e) {
	return this._removeElement(e, "connection");
}, hh.prototype.getGraphics = function(e, t) {
	return this._elementRegistry.getGraphics(e, t);
}, hh.prototype._changeViewbox = function(e) {
	this._eventBus.fire("canvas.viewbox.changing"), e.apply(this), this._cachedViewbox = null, this._viewboxChanged();
}, hh.prototype._viewboxChanged = function() {
	this._eventBus.fire("canvas.viewbox.changed", { viewbox: this.viewbox() });
}, hh.prototype.viewbox = function(e) {
	if (e === void 0 && this._cachedViewbox) return structuredClone(this._cachedViewbox);
	let t = this._viewport, n = this.getSize(), r, i, a, o, s, c, l;
	if (e) this._changeViewbox(function() {
		s = Math.min(n.width / e.width, n.height / e.height), Bd(t, this._svg.createSVGMatrix().scale(s).translate(-e.x, -e.y));
	});
	else return a = this._rootElement ? this.getActiveLayer() : null, r = a && a.getBBox() || {}, o = Bd(t), i = o ? o.matrix : Td(), s = oh(i.a, 1e3), c = oh(-i.e || 0, 1e3), l = oh(-i.f || 0, 1e3), e = this._cachedViewbox = {
		x: c ? c / s : 0,
		y: l ? l / s : 0,
		width: n.width / s,
		height: n.height / s,
		scale: s,
		inner: {
			width: r.width || 0,
			height: r.height || 0,
			x: r.x || 0,
			y: r.y || 0
		},
		outer: n
	}, e;
	return e;
}, hh.prototype.scroll = function(e) {
	let t = this._viewport, n = t.getCTM();
	return e && this._changeViewbox(function() {
		e = Z({
			dx: 0,
			dy: 0
		}, e || {}), n = this._svg.createSVGMatrix().translate(e.dx, e.dy).multiply(n), gh(t, n);
	}), {
		x: n.e,
		y: n.f
	};
}, hh.prototype.scrollToElement = function(e, t) {
	let n = 100;
	typeof e == "string" && (e = this._elementRegistry.get(e));
	let r = this.findRoot(e);
	if (r !== this.getRootElement() && this.setRootElement(r), r === e) return;
	t ||= {}, typeof t == "number" && (n = t), t = {
		top: t.top || n,
		right: t.right || n,
		bottom: t.bottom || n,
		left: t.left || n
	};
	let i = td(e), a = kp(i), o = this.viewbox(), s = this.zoom(), c, l;
	o.y += t.top / s, o.x += t.left / s, o.width -= (t.right + t.left) / s, o.height -= (t.bottom + t.top) / s;
	let u = kp(o);
	if (!(i.width < o.width && i.height < o.height)) c = i.x - o.x, l = i.y - o.y;
	else {
		let e = Math.max(0, a.right - u.right), t = Math.min(0, a.left - u.left), n = Math.max(0, a.bottom - u.bottom), r = Math.min(0, a.top - u.top);
		c = e || t, l = n || r;
	}
	this.scroll({
		dx: -c * s,
		dy: -l * s
	});
}, hh.prototype.zoom = function(e, t) {
	if (!e) return this.viewbox(e).scale;
	if (e === "fit-viewport") return this._fitViewport(t);
	let n, r;
	return this._changeViewbox(function() {
		typeof t != "object" && (n = this.viewbox().outer, t = {
			x: n.width / 2,
			y: n.height / 2
		}), r = this._setZoom(e, t);
	}), oh(r.a, 1e3);
};
function gh(e, t) {
	let n = "matrix(" + t.a + "," + t.b + "," + t.c + "," + t.d + "," + t.e + "," + t.f + ")";
	e.setAttribute("transform", n);
}
hh.prototype._fitViewport = function(e) {
	let t = this.viewbox(), n = t.outer, r = t.inner, i, a;
	return r.x >= 0 && r.y >= 0 && r.x + r.width <= n.width && r.y + r.height <= n.height && !e ? a = {
		x: 0,
		y: 0,
		width: Math.max(r.width + r.x, n.width),
		height: Math.max(r.height + r.y, n.height)
	} : (i = Math.min(1, n.width / r.width, n.height / r.height), a = {
		x: r.x + (e ? r.width / 2 - n.width / i / 2 : 0),
		y: r.y + (e ? r.height / 2 - n.height / i / 2 : 0),
		width: n.width / i,
		height: n.height / i
	}), this.viewbox(a), this.viewbox(!1).scale;
}, hh.prototype._setZoom = function(e, t) {
	let n = this._svg, r = this._viewport, i = n.createSVGMatrix(), a = n.createSVGPoint(), o, s, c, l, u;
	c = r.getCTM();
	let d = c.a;
	return t ? (o = Z(a, t), s = o.matrixTransform(c.inverse()), l = i.translate(s.x, s.y).scale(1 / d * e).translate(-s.x, -s.y), u = c.multiply(l)) : u = i.scale(e), gh(this._viewport, u), u;
}, hh.prototype.getSize = function() {
	return {
		width: this._container.clientWidth,
		height: this._container.clientHeight
	};
}, hh.prototype.getAbsoluteBBox = function(e) {
	let t = this.viewbox(), n;
	return n = e.waypoints ? this.getGraphics(e).getBBox() : e, {
		x: n.x * t.scale - t.x * t.scale,
		y: n.y * t.scale - t.y * t.scale,
		width: n.width * t.scale,
		height: n.height * t.scale
	};
}, hh.prototype.resized = function() {
	delete this._cachedViewbox, this._eventBus.fire("canvas.resized");
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/core/ElementRegistry.js
var _h = "data-element-id";
function vh(e) {
	this._elements = {}, this._eventBus = e;
}
vh.$inject = ["eventBus"], vh.prototype.add = function(e, t, n) {
	var r = e.id;
	this._validateId(r), fd(t, _h, r), n && fd(n, _h, r), this._elements[r] = {
		element: e,
		gfx: t,
		secondaryGfx: n
	};
}, vh.prototype.remove = function(e) {
	var t = this._elements, n = e.id || e, r = n && t[n];
	r && (fd(r.gfx, _h, ""), r.secondaryGfx && fd(r.secondaryGfx, _h, ""), delete t[n]);
}, vh.prototype.updateId = function(e, t) {
	this._validateId(t), typeof e == "string" && (e = this.get(e)), this._eventBus.fire("element.updateId", {
		element: e,
		newId: t
	});
	var n = this.getGraphics(e), r = this.getGraphics(e, !0);
	this.remove(e), e.id = t, this.add(e, n, r);
}, vh.prototype.updateGraphics = function(e, t, n) {
	var r = e.id || e, i = this._elements[r];
	return n ? i.secondaryGfx = t : i.gfx = t, t && fd(t, _h, r), t;
}, vh.prototype.get = function(e) {
	var t = typeof e == "string" ? e : e && fd(e, _h), n = this._elements[t];
	return n && n.element;
}, vh.prototype.filter = function(e) {
	var t = [];
	return this.forEach(function(n, r) {
		e(n, r) && t.push(n);
	}), t;
}, vh.prototype.find = function(e) {
	for (var t = this._elements, n = Object.keys(t), r = 0; r < n.length; r++) {
		var i = t[n[r]], a = i.element, o = i.gfx;
		if (e(a, o)) return a;
	}
}, vh.prototype.getAll = function() {
	return this.filter(function(e) {
		return e;
	});
}, vh.prototype.forEach = function(e) {
	var t = this._elements;
	Object.keys(t).forEach(function(n) {
		var r = t[n], i = r.element, a = r.gfx;
		return e(i, a);
	});
}, vh.prototype.getGraphics = function(e, t) {
	var n = e.id || e, r = this._elements[n];
	return r && (t ? r.secondaryGfx : r.gfx);
}, vh.prototype._validateId = function(e) {
	if (!e) throw Error("element must have an id");
	if (this._elements[e]) throw Error("element with id " + e + " already added");
};
//#endregion
//#region ../../../node_modules/object-refs/dist/index.js
function yh(e, t, n, r) {
	var i = n.inverse;
	return Object.defineProperty(e, "remove", { value: function(e) {
		var n = this.indexOf(e);
		return n !== -1 && (this.splice(n, 1), t.unset(e, i, r)), e;
	} }), Object.defineProperty(e, "contains", { value: function(e) {
		return this.indexOf(e) !== -1;
	} }), Object.defineProperty(e, "add", { value: function(e, n) {
		var a = this.indexOf(e);
		if (n === void 0) {
			if (a !== -1) return;
			n = this.length;
		}
		a !== -1 && this.splice(a, 1), this.splice(n, 0, e), a === -1 && t.set(e, i, r);
	} }), Object.defineProperty(e, "__refs_collection", { value: !0 }), e;
}
function bh(e) {
	return e.__refs_collection === !0;
}
function xh(e, t) {
	return Object.prototype.hasOwnProperty.call(e, t.name || t);
}
function Sh(e, t, n) {
	var r = yh(n[t.name] || [], e, t, n);
	Object.defineProperty(n, t.name, {
		enumerable: t.enumerable,
		value: r
	}), r.length && r.forEach(function(r) {
		e.set(r, t.inverse, n);
	});
}
function Ch(e, t, n) {
	var r = t.inverse, i = n[t.name];
	Object.defineProperty(n, t.name, {
		configurable: t.configurable,
		enumerable: t.enumerable,
		get: function() {
			return i;
		},
		set: function(t) {
			if (t !== i) {
				var a = i;
				i = null, a && e.unset(a, r, n), i = t, e.set(i, r, n);
			}
		}
	});
}
function wh(e, t) {
	if (!(this instanceof wh)) return new wh(e, t);
	e.inverse = t, t.inverse = e, this.props = {}, this.props[e.name] = e, this.props[t.name] = t;
}
wh.prototype.bind = function(e, t) {
	if (typeof t == "string") {
		if (!this.props[t]) throw Error("no property <" + t + "> in ref");
		t = this.props[t];
	}
	t.collection ? Sh(this, t, e) : Ch(this, t, e);
}, wh.prototype.ensureRefsCollection = function(e, t) {
	var n = e[t.name];
	return bh(n) || Sh(this, t, e), n;
}, wh.prototype.ensureBound = function(e, t) {
	xh(e, t) || this.bind(e, t);
}, wh.prototype.unset = function(e, t, n) {
	e && (this.ensureBound(e, t), t.collection ? this.ensureRefsCollection(e, t).remove(n) : e[t.name] = void 0);
}, wh.prototype.set = function(e, t, n) {
	e && (this.ensureBound(e, t), t.collection ? this.ensureRefsCollection(e, t).add(n) : e[t.name] = n);
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/model/index.js
var Th = new wh({
	name: "children",
	enumerable: !0,
	collection: !0
}, { name: "parent" }), Eh = new wh({
	name: "labels",
	enumerable: !0,
	collection: !0
}, { name: "labelTarget" }), Dh = new wh({
	name: "attachers",
	collection: !0
}, { name: "host" }), Oh = new wh({
	name: "outgoing",
	collection: !0
}, { name: "source" }), kh = new wh({
	name: "incoming",
	collection: !0
}, { name: "target" });
function Ah() {
	Object.defineProperty(this, "businessObject", { writable: !0 }), Object.defineProperty(this, "label", {
		get: function() {
			return this.labels[0];
		},
		set: function(e) {
			var t = this.label, n = this.labels;
			!e && t ? n.remove(t) : n.add(e, 0);
		}
	}), Th.bind(this, "parent"), Eh.bind(this, "labels"), Oh.bind(this, "outgoing"), kh.bind(this, "incoming");
}
function jh() {
	Ah.call(this), Th.bind(this, "children"), Dh.bind(this, "host"), Dh.bind(this, "attachers");
}
cu(jh, Ah);
function Mh() {
	Ah.call(this), Th.bind(this, "children");
}
cu(Mh, jh);
function Nh() {
	jh.call(this), Eh.bind(this, "labelTarget");
}
cu(Nh, jh);
function Ph() {
	Ah.call(this), Oh.bind(this, "source"), kh.bind(this, "target");
}
cu(Ph, Ah);
var Fh = {
	connection: Ph,
	shape: jh,
	label: Nh,
	root: Mh
};
function Ih(e, t) {
	var n = Fh[e];
	if (!n) throw Error("unknown type: <" + e + ">");
	return Z(new n(), t);
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/core/ElementFactory.js
function Lh() {
	this._uid = 12;
}
Lh.prototype.createRoot = function(e) {
	return this.create("root", e);
}, Lh.prototype.createLabel = function(e) {
	return this.create("label", e);
}, Lh.prototype.createShape = function(e) {
	return this.create("shape", e);
}, Lh.prototype.createConnection = function(e) {
	return this.create("connection", e);
}, Lh.prototype.create = function(e, t) {
	return t = Z({}, t || {}), t.id ||= e + "_" + this._uid++, Ih(e, t);
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/core/EventBus.js
var Rh = "__fn", zh = 1e3, Bh = Array.prototype.slice;
function Vh() {
	this._listeners = {}, this.on("diagram.destroy", 1, this._destroy, this);
}
Vh.prototype.on = function(e, t, n, r) {
	if (e = mu(e) ? e : [e], _u(t) && (r = n, n = t, t = zh), !gu(t)) throw Error("priority must be a number");
	var i = n;
	r && (i = Mu(n, r), i[Rh] = n[Rh] || n);
	var a = this;
	e.forEach(function(e) {
		a._addListener(e, {
			priority: t,
			callback: i,
			next: null
		});
	});
}, Vh.prototype.once = function(e, t, n, r) {
	var i = this;
	if (_u(t) && (r = n, n = t, t = zh), !gu(t)) throw Error("priority must be a number");
	function a() {
		a.__isTomb = !0;
		var t = n.apply(r, arguments);
		return i.off(e, a), t;
	}
	a[Rh] = n, this.on(e, t, a);
}, Vh.prototype.off = function(e, t) {
	e = mu(e) ? e : [e];
	var n = this;
	e.forEach(function(e) {
		n._removeListener(e, t);
	});
}, Vh.prototype.createEvent = function(e) {
	var t = new Hh();
	return t.init(e), t;
}, Vh.prototype.fire = function(e, t) {
	var n, r, i, a = Bh.call(arguments);
	if (typeof e == "object" && (t = e, e = t.type), !e) throw Error("no event type specified");
	if (r = this._listeners[e], r) {
		n = t instanceof Hh ? t : this.createEvent(t), a[0] = n;
		var o = n.type;
		e !== o && (n.type = e);
		try {
			i = this._invokeListeners(n, a, r);
		} finally {
			e !== o && (n.type = o);
		}
		return i === void 0 && n.defaultPrevented && (i = !1), i;
	}
}, Vh.prototype.handleError = function(e) {
	return this.fire("error", { error: e }) === !1;
}, Vh.prototype._destroy = function() {
	this._listeners = {};
}, Vh.prototype._invokeListeners = function(e, t, n) {
	for (var r; n && !e.cancelBubble;) r = this._invokeListener(e, t, n), n = n.next;
	return r;
}, Vh.prototype._invokeListener = function(e, t, n) {
	var r;
	if (n.callback.__isTomb) return r;
	try {
		r = Uh(n.callback, t), r !== void 0 && (e.returnValue = r, e.stopPropagation()), r === !1 && e.preventDefault();
	} catch (e) {
		if (!this.handleError(e)) throw console.error("unhandled error in event listener", e), e;
	}
	return r;
}, Vh.prototype._addListener = function(e, t) {
	var n = this._getListeners(e), r;
	if (!n) {
		this._setListeners(e, t);
		return;
	}
	for (; n;) {
		if (n.priority < t.priority) {
			t.next = n, r ? r.next = t : this._setListeners(e, t);
			return;
		}
		r = n, n = n.next;
	}
	r.next = t;
}, Vh.prototype._getListeners = function(e) {
	return this._listeners[e];
}, Vh.prototype._setListeners = function(e, t) {
	this._listeners[e] = t;
}, Vh.prototype._removeListener = function(e, t) {
	var n = this._getListeners(e), r, i, a;
	if (!t) {
		this._setListeners(e, null);
		return;
	}
	for (; n;) r = n.next, a = n.callback, (a === t || a[Rh] === t) && (i ? i.next = r : this._setListeners(e, r)), i = n, n = r;
};
function Hh() {}
Hh.prototype.stopPropagation = function() {
	this.cancelBubble = !0;
}, Hh.prototype.preventDefault = function() {
	this.defaultPrevented = !0;
}, Hh.prototype.init = function(e) {
	Z(this, e || {});
};
function Uh(e, t) {
	return e.apply(null, t);
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/GraphicsUtil.js
function Wh(e) {
	return e.childNodes[0];
}
function Gh(e) {
	return e.parentNode.childNodes[1];
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/core/GraphicsFactory.js
function Kh(e, t) {
	this._eventBus = e, this._elementRegistry = t;
}
Kh.$inject = ["eventBus", "elementRegistry"], Kh.prototype._getChildrenContainer = function(e) {
	var t = this._elementRegistry.getGraphics(e), n;
	return e.parent ? (n = Gh(t), n || (n = xd("g"), md(n).add("djs-children"), od(t.parentNode, n))) : n = t, n;
}, Kh.prototype._clear = function(e) {
	var t = Wh(e);
	return vf(t), t;
}, Kh.prototype._createContainer = function(e, t, n, r) {
	var i = xd("g");
	md(i).add("djs-group"), n === void 0 ? od(t, i) : qh(i, t, t.childNodes[n]);
	var a = xd("g");
	md(a).add("djs-element"), md(a).add("djs-" + e), r && md(a).add("djs-frame"), od(i, a);
	var o = xd("g");
	return md(o).add("djs-visual"), od(a, o), a;
}, Kh.prototype.create = function(e, t, n) {
	var r = this._getChildrenContainer(t.parent);
	return this._createContainer(e, r, n, rd(t));
}, Kh.prototype.updateContainments = function(e) {
	var t = this, n = this._elementRegistry;
	X(Cu(e, function(e, t) {
		return t.parent && (e[t.parent.id] = t.parent), e;
	}, {}), function(e) {
		var r = e.children;
		if (r) {
			var i = t._getChildrenContainer(e);
			X(r.slice().reverse(), function(e) {
				qh(n.getGraphics(e).parentNode, i);
			});
		}
	});
}, Kh.prototype.drawShape = function(e, t, n = {}) {
	return this._eventBus.fire("render.shape", {
		gfx: e,
		element: t,
		attrs: n
	});
}, Kh.prototype.getShapePath = function(e) {
	return this._eventBus.fire("render.getShapePath", e);
}, Kh.prototype.drawConnection = function(e, t, n = {}) {
	return this._eventBus.fire("render.connection", {
		gfx: e,
		element: t,
		attrs: n
	});
}, Kh.prototype.getConnectionPath = function(e) {
	return this._eventBus.fire("render.getConnectionPath", e);
}, Kh.prototype.update = function(e, t, n) {
	if (t.parent) {
		var r = this._clear(n);
		if (e === "shape") this.drawShape(r, t), Pf(n, t.x, t.y);
		else if (e === "connection") this.drawConnection(r, t);
		else throw Error("unknown type: " + e);
		t.hidden ? fd(n, "display", "none") : fd(n, "display", "block");
	}
}, Kh.prototype.remove = function(e) {
	Ld(this._elementRegistry.getGraphics(e).parentNode);
};
function qh(e, t, n) {
	var r = n || t.firstChild;
	e !== r && t.insertBefore(e, r);
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/core/index.js
var Jh = {
	__depends__: [rh],
	__init__: ["canvas"],
	canvas: ["type", hh],
	elementRegistry: ["type", vh],
	elementFactory: ["type", Lh],
	eventBus: ["type", Vh],
	graphicsFactory: ["type", Kh]
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/Diagram.js
function Yh(e) {
	var t = new Qm(e);
	return t.init(), t;
}
function Xh(e) {
	return e ||= {}, Yh([{ config: ["value", e] }, Jh].concat(e.modules || []));
}
function Zh(e, t) {
	this._injector = t || Xh(e), this.get("eventBus").fire("diagram.init");
}
Zh.prototype.get = function(e, t) {
	return this._injector.get(e, t);
}, Zh.prototype.invoke = function(e, t, n) {
	return this._injector.invoke(e, t, n);
}, Zh.prototype.destroy = function() {
	this.get("eventBus").fire("diagram.destroy");
}, Zh.prototype.clear = function() {
	this.get("eventBus").fire("diagram.clear");
};
//#endregion
//#region ../../../node_modules/moddle/dist/index.js
function Qh() {}
Qh.prototype.get = function(e) {
	return this.$model.properties.get(this, e);
}, Qh.prototype.set = function(e, t) {
	this.$model.properties.set(this, e, t);
};
function $h(e, t) {
	this.model = e, this.properties = t;
}
$h.prototype.createType = function(e) {
	var t = this.model, n = this.properties, r = Object.create(Qh.prototype);
	X(e.properties, function(e) {
		!e.isMany && e.default !== void 0 && (r[e.name] = e.default);
	}), n.defineModel(r, t), n.defineDescriptor(r, e);
	var i = e.ns.name;
	function a(e) {
		n.define(this, "$type", {
			value: i,
			enumerable: !0
		}), n.define(this, "$attrs", { value: {} }), n.define(this, "$parent", { writable: !0 }), X(e, Mu(function(e, t) {
			this.set(t, e);
		}, this));
	}
	return a.prototype = r, a.hasType = r.$instanceOf = this.model.hasType, n.defineModel(a, t), n.defineDescriptor(a, e), a;
};
var eg = {
	String: !0,
	Boolean: !0,
	Integer: !0,
	Real: !0,
	Element: !0
}, tg = {
	String: function(e) {
		return e;
	},
	Boolean: function(e) {
		return e === "true";
	},
	Integer: function(e) {
		return parseInt(e, 10);
	},
	Real: function(e) {
		return parseFloat(e);
	}
};
function ng(e, t) {
	var n = tg[e];
	return n ? n(t) : t;
}
function rg(e) {
	return !!eg[e];
}
function ig(e) {
	return !!tg[e];
}
function ag(e, t) {
	var n = e.split(/:/), r, i;
	if (n.length === 1) r = e, i = t;
	else if (n.length === 2) r = n[1], i = n[0];
	else throw Error("expected <prefix:localName> or <localName>, got " + e);
	return e = (i ? i + ":" : "") + r, {
		name: e,
		prefix: i,
		localName: r
	};
}
function og(e) {
	this.ns = e, this.name = e.name, this.allTypes = [], this.allTypesByName = {}, this.properties = [], this.propertiesByName = {};
}
og.prototype.build = function() {
	return Pu(this, [
		"ns",
		"name",
		"allTypes",
		"allTypesByName",
		"properties",
		"propertiesByName",
		"bodyProperty",
		"idProperty"
	]);
}, og.prototype.addProperty = function(e, t, n) {
	typeof t == "boolean" && (n = t, t = void 0), this.addNamedProperty(e, n !== !1);
	var r = this.properties;
	t === void 0 ? r.push(e) : r.splice(t, 0, e);
}, og.prototype.replaceProperty = function(e, t, n) {
	var r = e.ns, i = this.properties, a = this.propertiesByName, o = e.name !== t.name;
	if (e.isId) {
		if (!t.isId) throw Error("property <" + t.ns.name + "> must be id property to refine <" + e.ns.name + ">");
		this.setIdProperty(t, !1);
	}
	if (e.isBody) {
		if (!t.isBody) throw Error("property <" + t.ns.name + "> must be body property to refine <" + e.ns.name + ">");
		this.setBodyProperty(t, !1);
	}
	var s = i.indexOf(e);
	if (s === -1) throw Error("property <" + r.name + "> not found in property list");
	i.splice(s, 1), this.addProperty(t, n ? void 0 : s, o), a[r.name] = a[r.localName] = t;
}, og.prototype.redefineProperty = function(e, t, n) {
	var r = e.ns.prefix, i = t.split("#"), a = ag(i[0], r), o = ag(i[1], a.prefix).name, s = this.propertiesByName[o];
	if (s) this.replaceProperty(s, e, n);
	else throw Error("refined property <" + o + "> not found");
	delete e.redefines;
}, og.prototype.addNamedProperty = function(e, t) {
	var n = e.ns, r = this.propertiesByName;
	t && (this.assertNotDefined(e, n.name), this.assertNotDefined(e, n.localName)), r[n.name] = r[n.localName] = e;
}, og.prototype.removeNamedProperty = function(e) {
	var t = e.ns, n = this.propertiesByName;
	delete n[t.name], delete n[t.localName];
}, og.prototype.setBodyProperty = function(e, t) {
	if (t && this.bodyProperty) throw Error("body property defined multiple times (<" + this.bodyProperty.ns.name + ">, <" + e.ns.name + ">)");
	this.bodyProperty = e;
}, og.prototype.setIdProperty = function(e, t) {
	if (t && this.idProperty) throw Error("id property defined multiple times (<" + this.idProperty.ns.name + ">, <" + e.ns.name + ">)");
	this.idProperty = e;
}, og.prototype.assertNotTrait = function(e) {
	if ((e.extends || []).length) throw Error(`cannot create <${e.name}> extending <${e.extends}>`);
}, og.prototype.assertNotDefined = function(e, t) {
	var n = e.name, r = this.propertiesByName[n];
	if (r) throw Error("property <" + n + "> already defined; override of <" + r.definedBy.ns.name + "#" + r.ns.name + "> by <" + e.definedBy.ns.name + "#" + e.ns.name + "> not allowed without redefines");
}, og.prototype.hasProperty = function(e) {
	return this.propertiesByName[e];
}, og.prototype.addTrait = function(e, t) {
	t && this.assertNotTrait(e);
	var n = this.allTypesByName, r = this.allTypes, i = e.name;
	i in n || (X(e.properties, Mu(function(n) {
		n = Z({}, n, {
			name: n.ns.localName,
			inherited: t
		}), Object.defineProperty(n, "definedBy", { value: e });
		var r = n.replaces, i = n.redefines;
		r || i ? this.redefineProperty(n, r || i, r) : (n.isBody && this.setBodyProperty(n), n.isId && this.setIdProperty(n), this.addProperty(n));
	}, this)), r.push(e), n[i] = e);
};
function sg(e, t) {
	this.packageMap = {}, this.typeMap = {}, this.packages = [], this.properties = t, X(e, Mu(this.registerPackage, this));
}
sg.prototype.getPackage = function(e) {
	return this.packageMap[e];
}, sg.prototype.getPackages = function() {
	return this.packages;
}, sg.prototype.registerPackage = function(e) {
	e = Z({}, e);
	var t = this.packageMap;
	cg(t, e, "prefix"), cg(t, e, "uri"), X(e.types, Mu(function(t) {
		this.registerType(t, e);
	}, this)), t[e.uri] = t[e.prefix] = e, this.packages.push(e);
}, sg.prototype.registerType = function(e, t) {
	e = Z({}, e, {
		superClass: (e.superClass || []).slice(),
		extends: (e.extends || []).slice(),
		properties: (e.properties || []).slice(),
		meta: Z(e.meta || {})
	});
	var n = ag(e.name, t.prefix), r = n.name, i = {};
	X(e.properties, Mu(function(e) {
		var t = ag(e.name, n.prefix), r = t.name;
		rg(e.type) || (e.type = ag(e.type, t.prefix).name), Z(e, {
			ns: t,
			name: r
		}), i[r] = e;
	}, this)), Z(e, {
		ns: n,
		name: r,
		propertiesByName: i
	}), X(e.extends, Mu(function(e) {
		var t = ag(e, n.prefix), i = this.typeMap[t.name];
		i.traits = i.traits || [], i.traits.push(r);
	}, this)), this.definePackage(e, t), this.typeMap[r] = e;
}, sg.prototype.mapTypes = function(e, t, n) {
	var r = rg(e.name) ? { name: e.name } : this.typeMap[e.name], i = this;
	function a(n, r) {
		var a = ag(n, rg(n) ? "" : e.prefix);
		i.mapTypes(a, t, r);
	}
	function o(e) {
		return a(e, !0);
	}
	function s(e) {
		return a(e, !1);
	}
	if (!r) throw Error("unknown type <" + e.name + ">");
	X(r.superClass, n ? o : s), t(r, !n), X(r.traits, o);
}, sg.prototype.getEffectiveDescriptor = function(e) {
	var t = ag(e), n = new og(t);
	this.mapTypes(t, function(e, t) {
		n.addTrait(e, t);
	});
	var r = n.build();
	return this.definePackage(r, r.allTypes[r.allTypes.length - 1].$pkg), r;
}, sg.prototype.definePackage = function(e, t) {
	this.properties.define(e, "$pkg", { value: t });
};
function cg(e, t, n) {
	var r = t[n];
	if (r in e) throw Error("package with " + n + " <" + r + "> already defined");
}
function lg(e) {
	this.model = e;
}
lg.prototype.set = function(e, t, n) {
	if (!vu(t) || !t.length) throw TypeError("property name must be a non-empty string");
	var r = this.getProperty(e, t), i = r && r.name;
	ug(n) ? r ? delete e[i] : delete e.$attrs[fg(t)] : r ? i in e ? e[i] = n : dg(e, r, n) : e.$attrs[fg(t)] = n;
}, lg.prototype.get = function(e, t) {
	var n = this.getProperty(e, t);
	if (!n) return e.$attrs[fg(t)];
	var r = n.name;
	return !e[r] && n.isMany && dg(e, n, []), e[r];
}, lg.prototype.define = function(e, t, n) {
	if (!n.writable) {
		var r = n.value;
		n = Z({}, n, { get: function() {
			return r;
		} }), delete n.value;
	}
	Object.defineProperty(e, t, n);
}, lg.prototype.defineDescriptor = function(e, t) {
	this.define(e, "$descriptor", { value: t });
}, lg.prototype.defineModel = function(e, t) {
	this.define(e, "$model", { value: t });
}, lg.prototype.getProperty = function(e, t) {
	var n = this.model, r = n.getPropertyDescriptor(e, t);
	if (r) return r;
	if (t.includes(":")) return null;
	let i = n.config.strict;
	if (i !== void 0) {
		let n = /* @__PURE__ */ TypeError(`unknown property <${t}> on <${e.$type}>`);
		if (i) throw n;
		typeof console < "u" && console.warn(n);
	}
	return null;
};
function ug(e) {
	return e === void 0;
}
function dg(e, t, n) {
	Object.defineProperty(e, t.name, {
		enumerable: !t.isReference,
		writable: !0,
		value: n,
		configurable: !0
	});
}
function fg(e) {
	return e.replace(/^:/, "");
}
function pg(e, t = {}) {
	this.properties = new lg(this), this.factory = new $h(this, this.properties), this.registry = new sg(e, this.properties), this.typeCache = {}, this.config = t;
}
pg.prototype.create = function(e, t) {
	var n = this.getType(e);
	if (!n) throw Error("unknown type <" + e + ">");
	return new n(t);
}, pg.prototype.getType = function(e) {
	var t = this.typeCache, n = vu(e) ? e : e.ns.name, r = t[n];
	return r ||= (e = this.registry.getEffectiveDescriptor(n), t[n] = this.factory.createType(e)), r;
}, pg.prototype.createAny = function(e, t, n) {
	var r = ag(e), i = {
		$type: e,
		$instanceOf: function(e) {
			return e === this.$type;
		},
		get: function(e) {
			return this[e];
		},
		set: function(e, t) {
			Nu(this, [e], t);
		}
	}, a = {
		name: e,
		isGeneric: !0,
		ns: {
			prefix: r.prefix,
			localName: r.localName,
			uri: t
		}
	};
	return this.properties.defineDescriptor(i, a), this.properties.defineModel(i, this), this.properties.define(i, "get", {
		enumerable: !1,
		writable: !0
	}), this.properties.define(i, "set", {
		enumerable: !1,
		writable: !0
	}), this.properties.define(i, "$parent", {
		enumerable: !1,
		writable: !0
	}), this.properties.define(i, "$instanceOf", {
		enumerable: !1,
		writable: !0
	}), X(n, function(e, t) {
		hu(e) && e.value !== void 0 ? i[e.name] = e.value : i[t] = e;
	}), i;
}, pg.prototype.getPackage = function(e) {
	return this.registry.getPackage(e);
}, pg.prototype.getPackages = function() {
	return this.registry.getPackages();
}, pg.prototype.getElementDescriptor = function(e) {
	return e.$descriptor;
}, pg.prototype.hasType = function(e, t) {
	t === void 0 && (t = e, e = this);
	var n = e.$model.getElementDescriptor(e);
	return t in n.allTypesByName;
}, pg.prototype.getPropertyDescriptor = function(e, t) {
	return this.getElementDescriptor(e).propertiesByName[t];
}, pg.prototype.getTypeDescriptor = function(e) {
	return this.registry.typeMap[e];
};
//#endregion
//#region ../../../node_modules/saxen/dist/index.js
var mg = String.fromCharCode, hg = Object.prototype.hasOwnProperty, gg = /&#(\d+);|&#x([0-9a-f]+);|&(\w+);/gi, _g = {
	amp: "&",
	apos: "'",
	gt: ">",
	lt: "<",
	quot: "\""
};
Object.keys(_g).forEach(function(e) {
	_g[e.toUpperCase()] = _g[e];
});
function vg(e, t, n, r) {
	return r ? hg.call(_g, r) ? _g[r] : "&" + r + ";" : mg(t || parseInt(n, 16));
}
function yg(e) {
	return e.length > 3 && e.indexOf("&") !== -1 ? e.replace(gg, vg) : e;
}
var bg = "non-whitespace outside of root node";
function xg(e) {
	return Error(e);
}
function Sg(e) {
	return "missing namespace for prefix <" + e + ">";
}
function Cg(e) {
	return {
		get: e,
		enumerable: !0
	};
}
function wg(e) {
	var t = {}, n;
	for (n in e) t[n] = e[n];
	return t;
}
function Tg(e) {
	return e + "$uri";
}
function Eg(e) {
	var t = {}, n, r;
	for (n in e) r = e[n], t[r] = r, t[Tg(r)] = n;
	return t;
}
function Dg() {
	return {
		line: 0,
		column: 0
	};
}
function Og(e) {
	throw e;
}
function kg(e) {
	if (!this) return new kg(e);
	var t = e && e.proxy, n, r, i, a, o = Og, s, c, l, u, d = Dg, f = !1, p = !1, m = null, h = !1, g;
	function _(e) {
		e instanceof Error || (e = xg(e)), m = e, o(e, d);
	}
	function v(e) {
		s && (e instanceof Error || (e = xg(e)), s(e, d));
	}
	this.on = function(e, t) {
		if (typeof t != "function") throw xg("required args <name, cb>");
		switch (e) {
			case "openTag":
				r = t;
				break;
			case "text":
				n = t;
				break;
			case "closeTag":
				i = t;
				break;
			case "error":
				o = t;
				break;
			case "warn":
				s = t;
				break;
			case "cdata":
				a = t;
				break;
			case "attention":
				u = t;
				break;
			case "question":
				l = t;
				break;
			case "comment":
				c = t;
				break;
			default: throw xg("unsupported event: " + e);
		}
		return this;
	}, this.ns = function(e) {
		if (e === void 0 && (e = {}), typeof e != "object") throw xg("required args <nsMap={}>");
		var t = {}, n;
		for (n in e) t[n] = e[n];
		return p = !0, g = t, this;
	}, this.parse = function(e) {
		if (typeof e != "string") throw xg("required args <xml=string>");
		return m = null, y(e), d = Dg, h = !1, m;
	}, this.stop = function() {
		h = !0;
	};
	function y(e) {
		var o = p ? [] : null, s = p ? Eg(g) : null, m, y = [], b = 0, x = !1, S = !1, C = 0, w = 0, T, ee, te, ne, re, ie, ae, oe, se, ce = "", le = 0, ue;
		function de() {
			if (ue !== null) return ue;
			var e, t, n, r = p && s.xmlns, i = p && f ? [] : null, a = le, o = ce, c = o.length, l, u, d, m, h, _ = {}, y = {}, x, S, C;
			parseAttr: for (; a < c; a++) if (x = !1, S = o.charCodeAt(a), !(S === 32 || S < 14 && S > 8)) {
				for ((S < 65 || S > 122 || S > 90 && S < 97) && S !== 95 && S !== 58 && (v("illegal first char attribute name"), x = !0), C = a + 1; C < c; C++) if (S = o.charCodeAt(C), !(S > 96 && S < 123 || S > 64 && S < 91 || S > 47 && S < 59 || S === 46 || S === 45 || S === 95)) {
					if (S === 32 || S < 14 && S > 8) {
						v("missing attribute value"), a = C;
						continue parseAttr;
					}
					if (S === 61) break;
					v("illegal attribute name char"), x = !0;
				}
				if (h = o.substring(a, C), h === "xmlns:xmlns" && (v("illegal declaration of xmlns"), x = !0), S = o.charCodeAt(C + 1), S === 34) C = o.indexOf("\"", a = C + 2), C === -1 && (C = o.indexOf("'", a), C !== -1 && (v("attribute value quote missmatch"), x = !0));
				else if (S === 39) C = o.indexOf("'", a = C + 2), C === -1 && (C = o.indexOf("\"", a), C !== -1 && (v("attribute value quote missmatch"), x = !0));
				else for (v("missing attribute value quotes"), x = !0, C += 1; C < c && (S = o.charCodeAt(C + 1), !(S === 32 || S < 14 && S > 8)); C++);
				for (C === -1 && (v("missing closing quotes"), C = c, x = !0), x || (d = o.substring(a, C)), a = C; C + 1 < c && (S = o.charCodeAt(C + 1), !(S === 32 || S < 14 && S > 8)); C++) a === C && (v("illegal character after attribute end"), x = !0);
				if (a = C + 1, x) continue parseAttr;
				if (h in y) {
					v("attribute <" + h + "> already defined");
					continue;
				}
				if (y[h] = !0, !p) {
					_[h] = d;
					continue;
				}
				if (f) {
					if (u = h === "xmlns" ? "xmlns" : h.charCodeAt(0) === 120 && h.substr(0, 6) === "xmlns:" ? h.substr(6) : null, u !== null) {
						if (e = yg(d), t = Tg(u), m = g[e], !m) {
							if (u === "xmlns" || t in s && s[t] !== e) do
								m = "ns" + b++;
							while (s[m] !== void 0);
							else m = u;
							g[e] = m;
						}
						s[u] !== m && (l ||= (s = wg(s), !0), s[u] = m, u === "xmlns" && (s[Tg(m)] = e, r = m), s[t] = e), _[h] = d;
						continue;
					}
					i.push(h, d);
					continue;
				}
				if (S = h.indexOf(":"), S === -1) {
					_[h] = d;
					continue;
				}
				if (!(n = s[h.substring(0, S)])) {
					v(Sg(h.substring(0, S)));
					continue;
				}
				h = r === n ? h.substr(S + 1) : n + h.substr(S), _[h] = d;
			}
			if (f) for (a = 0, c = i.length; a < c; a++) {
				if (h = i[a++], d = i[a], S = h.indexOf(":"), S !== -1) {
					if (!(n = s[h.substring(0, S)])) {
						v(Sg(h.substring(0, S)));
						continue;
					}
					h = r === n ? h.substr(S + 1) : n + h.substr(S);
				}
				_[h] = d;
			}
			return ue = _;
		}
		function fe() {
			for (var t = /(\r\n|\r|\n)/g, n = 0, r = 0, i = 0, a = w, o, s; C >= i && (o = t.exec(e), !(!o || (a = o[0].length + o.index, a > C)));) n += 1, i = a;
			return C == -1 ? (r = a, s = e.substring(w)) : w === 0 ? s = e.substring(w, C) : (r = C - i, s = w == -1 ? e.substring(C) : e.substring(C, w + 1)), {
				data: s,
				line: n,
				column: r
			};
		}
		for (d = fe, t && (se = Object.create({}, {
			name: Cg(function() {
				return ae;
			}),
			originalName: Cg(function() {
				return oe;
			}),
			attrs: Cg(de),
			ns: Cg(function() {
				return s;
			})
		})); w !== -1;) {
			if (C = e.charCodeAt(w) === 60 ? w : e.indexOf("<", w), C === -1) {
				if (y.length) return _("unexpected end of file");
				if (w === 0) return _("missing start tag");
				w < e.length && e.substring(w).trim() && v(bg);
				return;
			}
			if (w !== C) {
				if (y.length) {
					if (n && (n(e.substring(w, C), yg, d), h)) return;
				} else if (e.substring(w, C).trim() && (v(bg), h)) return;
			}
			if (ne = e.charCodeAt(C + 1), ne === 33) {
				if (te = e.charCodeAt(C + 2), te === 91 && e.substr(C + 3, 6) === "CDATA[") {
					if (w = e.indexOf("]]>", C), w === -1) return _("unclosed cdata");
					if (a && (a(e.substring(C + 9, w), d), h)) return;
					w += 3;
					continue;
				}
				if (te === 45 && e.charCodeAt(C + 3) === 45) {
					if (w = e.indexOf("-->", C), w === -1) return _("unclosed comment");
					if (c && (c(e.substring(C + 4, w), yg, d), h)) return;
					w += 3;
					continue;
				}
			}
			if (ne === 63) {
				if (w = e.indexOf("?>", C), w === -1) return _("unclosed question");
				if (l && (l(e.substring(C, w + 2), d), h)) return;
				w += 2;
				continue;
			}
			for (T = C + 1;; T++) {
				if (re = e.charCodeAt(T), isNaN(re)) return w = -1, _("unclosed tag");
				if (re === 34) te = e.indexOf("\"", T + 1), T = te === -1 ? T : te;
				else if (re === 39) te = e.indexOf("'", T + 1), T = te === -1 ? T : te;
				else if (re === 62) {
					w = T;
					break;
				}
			}
			if (ne === 33) {
				if (u && (u(e.substring(C, w + 1), yg, d), h)) return;
				w += 1;
				continue;
			}
			if (ue = {}, ne === 47) {
				if (x = !1, S = !0, !y.length) return _("missing open tag");
				if (T = ae = y.pop(), te = C + 2 + T.length, e.substring(C + 2, te) !== T) return _("closing tag mismatch");
				for (; te < w; te++) if (ne = e.charCodeAt(te), !(ne === 32 || ne > 8 && ne < 14)) return _("close tag");
			} else {
				if (e.charCodeAt(w - 1) === 47 ? (T = ae = e.substring(C + 1, w - 1), x = !0, S = !0) : (T = ae = e.substring(C + 1, w), x = !0, S = !1), !(ne > 96 && ne < 123 || ne > 64 && ne < 91 || ne === 95 || ne === 58)) return _("illegal first char nodeName");
				for (te = 1, ee = T.length; te < ee; te++) if (ne = T.charCodeAt(te), !(ne > 96 && ne < 123 || ne > 64 && ne < 91 || ne > 47 && ne < 59 || ne === 45 || ne === 95 || ne == 46)) {
					if (ne === 32 || ne < 14 && ne > 8) {
						ae = T.substring(0, te), ue = null;
						break;
					}
					return _("invalid nodeName");
				}
				S || y.push(ae);
			}
			if (p) {
				if (m = s, x && (S || o.push(m), ue === null && (f = T.indexOf("xmlns", te) !== -1) && (le = te, ce = T, de(), f = !1)), oe = ae, ne = ae.indexOf(":"), ne !== -1) {
					if (ie = s[ae.substring(0, ne)], !ie) return _("missing namespace on <" + oe + ">");
					ae = ae.substr(ne + 1);
				} else ie = s.xmlns;
				ie && (ae = ie + ":" + ae);
			}
			if (x && (le = te, ce = T, r && (t ? r(se, yg, S, d) : r(ae, de, yg, S, d), h))) return;
			if (S) {
				if (i && (i(t ? se : ae, yg, x, d), h)) return;
				p && (s = x ? m : o.pop());
			}
			w += 1;
		}
	}
}
//#endregion
//#region ../../../node_modules/moddle-xml/dist/index.js
function Ag(e) {
	return e.xml && e.xml.tagAlias === "lowerCase";
}
var jg = {
	xsi: "http://www.w3.org/2001/XMLSchema-instance",
	xml: "http://www.w3.org/XML/1998/namespace"
}, Mg = "property";
function Ng(e) {
	return e.xml && e.xml.serialize;
}
function Pg(e) {
	let t = Ng(e);
	return t !== Mg && (t || null);
}
function Fg(e) {
	return e.charAt(0).toUpperCase() + e.slice(1);
}
function Ig(e, t) {
	return Ag(t) ? e.prefix + ":" + Fg(e.localName) : e.name;
}
function Lg(e, t) {
	var n = e.name, r = e.localName, i = t && t.xml && t.xml.typePrefix;
	return i && r.indexOf(i) === 0 ? e.prefix + ":" + r.slice(i.length) : n;
}
function Rg(e, t, n) {
	let r = ag(e, t.xmlns), i = ag(`${t[r.prefix] || r.prefix}:${r.localName}`);
	return Lg(i, n.getPackage(i.prefix));
}
function zg(e) {
	return Error(e);
}
function Bg(e) {
	return e.$descriptor;
}
function Vg(e) {
	Z(this, e), this.elementsById = {}, this.references = [], this.warnings = [], this.addReference = function(e) {
		this.references.push(e);
	}, this.addElement = function(e) {
		if (!e) throw zg("expected element");
		var t = this.elementsById, n = Bg(e).idProperty, r;
		if (n && (r = e.get(n.name), r)) {
			if (!/^([a-z][\w-.]*:)?[a-z_][\w-.]*$/i.test(r)) throw Error("illegal ID <" + r + ">");
			if (t[r]) throw zg("duplicate ID <" + r + ">");
			t[r] = e;
		}
	}, this.addWarning = function(e) {
		this.warnings.push(e);
	};
}
function Hg() {}
Hg.prototype.handleEnd = function() {}, Hg.prototype.handleText = function() {}, Hg.prototype.handleNode = function() {};
function Ug() {}
Ug.prototype = Object.create(Hg.prototype), Ug.prototype.handleNode = function() {
	return this;
};
function Wg() {}
Wg.prototype = Object.create(Hg.prototype), Wg.prototype.handleText = function(e) {
	this.body = (this.body || "") + e;
};
function Gg(e, t) {
	this.property = e, this.context = t;
}
Gg.prototype = Object.create(Wg.prototype), Gg.prototype.handleNode = function(e) {
	if (this.element) throw zg("expected no sub nodes");
	return this.element = this.createReference(e), this;
}, Gg.prototype.handleEnd = function() {
	this.element.id = this.body;
}, Gg.prototype.createReference = function(e) {
	return {
		property: this.property.ns.name,
		id: ""
	};
};
function Kg(e, t) {
	this.element = t, this.propertyDesc = e;
}
Kg.prototype = Object.create(Wg.prototype), Kg.prototype.handleEnd = function() {
	var e = this.body || "", t = this.element, n = this.propertyDesc;
	e = ng(n.type, e), n.isMany ? t.get(n.name).push(e) : t.set(n.name, e);
};
function qg() {}
qg.prototype = Object.create(Wg.prototype), qg.prototype.handleNode = function(e) {
	var t = this, n = this.element;
	return n ? t = this.handleChild(e) : (n = this.element = this.createElement(e), this.context.addElement(n)), t;
};
function Jg(e, t, n) {
	this.model = e, this.type = e.getType(t), this.context = n;
}
Jg.prototype = Object.create(qg.prototype), Jg.prototype.addReference = function(e) {
	this.context.addReference(e);
}, Jg.prototype.handleText = function(e) {
	var t = this.element;
	if (!Bg(t).bodyProperty) throw zg("unexpected body text <" + e + ">");
	Wg.prototype.handleText.call(this, e);
}, Jg.prototype.handleEnd = function() {
	var e = this.body, t = this.element, n = Bg(t).bodyProperty;
	n && e !== void 0 && (e = ng(n.type, e), t.set(n.name, e));
}, Jg.prototype.createElement = function(e) {
	var t = e.attributes, n = this.type, r = Bg(n), i = this.context, a = new n({}), o = this.model, s;
	return X(t, function(e, t) {
		var n = r.propertiesByName[t], c;
		n && n.isReference ? n.isMany ? (c = e.split(" "), X(c, function(e) {
			i.addReference({
				element: a,
				property: n.ns.name,
				id: e
			});
		})) : i.addReference({
			element: a,
			property: n.ns.name,
			id: e
		}) : (n ? e = ng(n.type, e) : t === "xmlns" ? t = ":" + t : (s = ag(t, r.ns.prefix), o.getPackage(s.prefix) && i.addWarning({
			message: "unknown attribute <" + t + ">",
			element: a,
			property: t,
			value: e
		})), a.set(t, e));
	}), a;
}, Jg.prototype.getPropertyForNode = function(e) {
	var t = e.name, n = ag(t), r = this.type, i = this.model, a = Bg(r), o = n.name, s = a.propertiesByName[o];
	if (s && !s.isAttr) {
		let t = Pg(s);
		if (t) {
			let n = e.attributes[t];
			if (n) {
				let t = Rg(n, e.ns, i), r = i.getType(t);
				return Z({}, s, { effectiveType: Bg(r).name });
			}
		}
		return s;
	}
	var c = i.getPackage(n.prefix);
	if (c) {
		let e = Ig(n, c), t = i.getType(e);
		if (s = bu(a.properties, function(e) {
			return !e.isVirtual && !e.isReference && !e.isAttribute && t.hasType(e.type);
		}), s) return Z({}, s, { effectiveType: Bg(t).name });
	} else if (s = bu(a.properties, function(e) {
		return !e.isReference && !e.isAttribute && e.type === "Element";
	}), s) return s;
	throw zg("unrecognized element <" + n.name + ">");
}, Jg.prototype.toString = function() {
	return "ElementDescriptor[" + Bg(this.type).name + "]";
}, Jg.prototype.valueHandler = function(e, t) {
	return new Kg(e, t);
}, Jg.prototype.referenceHandler = function(e) {
	return new Gg(e, this.context);
}, Jg.prototype.handler = function(e) {
	return e === "Element" ? new Xg(this.model, e, this.context) : new Jg(this.model, e, this.context);
}, Jg.prototype.handleChild = function(e) {
	var t = this.getPropertyForNode(e), n, r = this.element, i;
	if (n = t.effectiveType || t.type, ig(n)) return this.valueHandler(t, r);
	i = t.isReference ? this.referenceHandler(t).handleNode(e) : this.handler(n).handleNode(e);
	var a = i.element;
	return a !== void 0 && (t.isMany ? r.get(t.name).push(a) : r.set(t.name, a), t.isReference ? (Z(a, { element: r }), this.context.addReference(a)) : a.$parent = r), i;
};
function Yg(e, t, n) {
	Jg.call(this, e, t, n);
}
Yg.prototype = Object.create(Jg.prototype), Yg.prototype.createElement = function(e) {
	var t = e.name, n = ag(t), r = this.model, i = this.type, a = r.getPackage(n.prefix), o = a && Ig(n, a) || t;
	if (!i.hasType(o)) throw zg("unexpected element <" + e.originalName + ">");
	return Jg.prototype.createElement.call(this, e);
};
function Xg(e, t, n) {
	this.model = e, this.context = n;
}
Xg.prototype = Object.create(qg.prototype), Xg.prototype.createElement = function(e) {
	var t = e.name, n = ag(t).prefix, r = e.ns[n + "$uri"], i = e.attributes;
	return this.model.createAny(t, r, i);
}, Xg.prototype.handleChild = function(e) {
	var t = new Xg(this.model, "Element", this.context).handleNode(e), n = this.element, r = t.element, i;
	return r !== void 0 && (i = n.$children = n.$children || [], i.push(r), r.$parent = n), t;
}, Xg.prototype.handleEnd = function() {
	this.body && (this.element.$body = this.body);
};
function Zg(e) {
	e instanceof pg && (e = { model: e }), Z(this, { lax: !1 }, e);
}
Zg.prototype.fromXML = function(e, t, n) {
	var r = t.rootHandler;
	t instanceof Jg ? (r = t, t = {}) : typeof t == "string" ? (r = this.handler(t), t = {}) : typeof r == "string" && (r = this.handler(r));
	var i = this.model, a = this.lax, o = new Vg(Z({}, t, { rootHandler: r })), s = new kg({ proxy: !0 }), c = Qg();
	r.context = o, c.push(r);
	function l(e, t, n) {
		var r = t(), i = r.line, a = r.column, s = r.data;
		s.charAt(0) === "<" && s.indexOf(" ") !== -1 && (s = s.slice(0, s.indexOf(" ")) + ">");
		var c = "unparsable content " + (s ? s + " " : "") + "detected\n	line: " + i + "\n	column: " + a + "\n	nested error: " + e.message;
		if (n) return o.addWarning({
			message: c,
			error: e
		}), !0;
		throw zg(c);
	}
	function u(e, t) {
		return l(e, t, !0);
	}
	function d() {
		var e = o.elementsById, t = o.references, n, r;
		for (n = 0; r = t[n]; n++) {
			var i = r.element, a = e[r.id], s = Bg(i).propertiesByName[r.property];
			if (a || o.addWarning({
				message: "unresolved reference <" + r.id + ">",
				element: r.element,
				property: r.property,
				value: r.id
			}), s.isMany) {
				var c = i.get(s.name), l = c.indexOf(r);
				l === -1 && (l = c.length), a ? c[l] = a : c.splice(l, 1);
			} else i.set(s.name, a);
		}
	}
	function f() {
		c.pop().handleEnd();
	}
	var p = /^<\?xml /i, m = / encoding="([^"]+)"/i, h = /^utf-8$/i;
	function g(e) {
		if (p.test(e)) {
			var t = m.exec(e), n = t && t[1];
			!n || h.test(n) || o.addWarning({ message: "unsupported document encoding <" + n + ">, falling back to UTF-8" });
		}
	}
	function _(e, t) {
		var n = c.peek();
		try {
			c.push(n.handleNode(e));
		} catch (e) {
			l(e, t, a) && c.push(new Ug());
		}
	}
	function v(e, t) {
		try {
			c.peek().handleText(e);
		} catch (e) {
			u(e, t);
		}
	}
	function y(e, t) {
		e.trim() && v(e, t);
	}
	var b = i.getPackages().reduce(function(e, t) {
		return e[t.uri] = t.prefix, e;
	}, Object.entries(jg).reduce(function(e, [t, n]) {
		return e[n] = t, e;
	}, i.config && i.config.nsMap || {}));
	return s.ns(b).on("openTag", function(e, t, n, r) {
		var i = e.attrs || {}, a = Object.keys(i).reduce(function(e, n) {
			return e[n] = t(i[n]), e;
		}, {});
		_({
			name: e.name,
			originalName: e.originalName,
			attributes: a,
			ns: e.ns
		}, r);
	}).on("question", g).on("closeTag", f).on("cdata", v).on("text", function(e, t, n) {
		y(t(e), n);
	}).on("error", l).on("warn", u), new Promise(function(t, n) {
		var i;
		try {
			s.parse(e), d();
		} catch (e) {
			i = e;
		}
		var a = r.element;
		!i && !a && (i = zg("failed to parse document as <" + r.type.$descriptor.name + ">"));
		var c = o.warnings, l = o.references, u = o.elementsById;
		return i ? (i.warnings = c, n(i)) : t({
			rootElement: a,
			elementsById: u,
			references: l,
			warnings: c
		});
	});
}, Zg.prototype.handler = function(e) {
	return new Yg(this.model, e);
};
function Qg() {
	var e = [];
	return Object.defineProperty(e, "peek", { value: function() {
		return this[this.length - 1];
	} }), e;
}
var $g = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n", e_ = /<|>|'|"|&|\n\r|\n/g, t_ = /<|>|&/g;
function n_(e) {
	this.prefixMap = {}, this.uriMap = {}, this.used = {}, this.wellknown = [], this.custom = [], this.parent = e, this.defaultPrefixMap = e && e.defaultPrefixMap || {};
}
n_.prototype.mapDefaultPrefixes = function(e) {
	this.defaultPrefixMap = e;
}, n_.prototype.defaultUriByPrefix = function(e) {
	return this.defaultPrefixMap[e];
}, n_.prototype.byUri = function(e) {
	return this.uriMap[e] || this.parent && this.parent.byUri(e);
}, n_.prototype.add = function(e, t) {
	this.uriMap[e.uri] = e, t ? this.wellknown.push(e) : this.custom.push(e), this.mapPrefix(e.prefix, e.uri);
}, n_.prototype.uriByPrefix = function(e) {
	return this.prefixMap[e || "xmlns"] || this.parent && this.parent.uriByPrefix(e);
}, n_.prototype.mapPrefix = function(e, t) {
	this.prefixMap[e || "xmlns"] = t;
}, n_.prototype.getNSKey = function(e) {
	return e.prefix === void 0 ? e.uri : e.uri + "|" + e.prefix;
}, n_.prototype.logUsed = function(e) {
	var t = e.uri, n = this.getNSKey(e);
	this.used[n] = this.byUri(t), this.parent && this.parent.logUsed(e);
}, n_.prototype.getUsed = function(e) {
	return [].concat(this.wellknown, this.custom).filter((e) => {
		var t = this.getNSKey(e);
		return this.used[t];
	});
};
function r_(e) {
	return e.charAt(0).toLowerCase() + e.slice(1);
}
function i_(e, t) {
	return Ag(t) ? r_(e) : e;
}
function a_(e, t) {
	e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: {
		value: e,
		enumerable: !1,
		writable: !0,
		configurable: !0
	} });
}
function o_(e) {
	return vu(e) ? e : (e.prefix ? e.prefix + ":" : "") + e.localName;
}
function s_(e) {
	return e.getUsed().filter(function(e) {
		return e.prefix !== "xml";
	}).map(function(e) {
		return {
			name: "xmlns" + (e.prefix ? ":" + e.prefix : ""),
			value: e.uri
		};
	});
}
function c_(e, t) {
	return t.isGeneric ? Z({ localName: t.ns.localName }, e) : Z({ localName: i_(t.ns.localName, t.$pkg) }, e);
}
function l_(e, t) {
	return Z({ localName: t.ns.localName }, e);
}
function u_(e) {
	var t = e.$descriptor;
	return Su(t.properties, function(t) {
		var n = t.name;
		if (t.isVirtual || !yu(e, n)) return !1;
		var r = e[n];
		return r === t.default || r === null ? !1 : t.isMany ? r.length : !0;
	});
}
var d_ = {
	"\n": "#10",
	"\n\r": "#10",
	"\"": "#34",
	"'": "#39",
	"<": "#60",
	">": "#62",
	"&": "#38"
}, f_ = {
	"<": "lt",
	">": "gt",
	"&": "amp"
};
function p_(e, t, n) {
	return e = vu(e) ? e : "" + e, e.replace(t, function(e) {
		return "&" + n[e] + ";";
	});
}
function m_(e) {
	return p_(e, e_, d_);
}
function h_(e) {
	return p_(e, t_, f_);
}
function g_(e) {
	return Su(e, function(e) {
		return e.isAttr;
	});
}
function __(e) {
	return Su(e, function(e) {
		return !e.isAttr;
	});
}
function v_(e) {
	this.tagName = e;
}
v_.prototype.build = function(e) {
	return this.element = e, this;
}, v_.prototype.serializeTo = function(e) {
	e.appendIndent().append("<" + this.tagName + ">" + this.element.id + "</" + this.tagName + ">").appendNewLine();
};
function y_() {}
y_.prototype.serializeValue = y_.prototype.serializeTo = function(e) {
	e.append(this.escape ? h_(this.value) : this.value);
}, y_.prototype.build = function(e, t) {
	return this.value = t, e.type === "String" && t.search(t_) !== -1 && (this.escape = !0), this;
};
function b_(e) {
	this.tagName = e;
}
a_(b_, y_), b_.prototype.serializeTo = function(e) {
	e.appendIndent().append("<" + this.tagName + ">"), this.serializeValue(e), e.append("</" + this.tagName + ">").appendNewLine();
};
function x_(e, t) {
	this.body = [], this.attrs = [], this.parent = e, this.propertyDescriptor = t;
}
x_.prototype.build = function(e) {
	this.element = e;
	var t = e.$descriptor, n = this.propertyDescriptor, r, i, a = t.isGeneric;
	return r = a ? this.parseGenericNsAttributes(e) : this.parseNsAttributes(e), n ? this.ns = this.nsPropertyTagName(n) : this.ns = this.nsTagName(t), this.tagName = this.addTagName(this.ns), a ? this.parseGenericContainments(e) : (i = u_(e), this.parseAttributes(g_(i)), this.parseContainments(__(i))), this.parseGenericAttributes(e, r), this;
}, x_.prototype.nsTagName = function(e) {
	return c_(this.logNamespaceUsed(e.ns), e);
}, x_.prototype.nsPropertyTagName = function(e) {
	return l_(this.logNamespaceUsed(e.ns), e);
}, x_.prototype.isLocalNs = function(e) {
	return e.uri === this.ns.uri;
}, x_.prototype.nsAttributeName = function(e) {
	var t = vu(e) ? ag(e) : e.ns;
	if (e.inherited) return { localName: t.localName };
	var n = this.logNamespaceUsed(t);
	return this.getNamespaces().logUsed(n), this.isLocalNs(n) ? { localName: t.localName } : Z({ localName: t.localName }, n);
}, x_.prototype.parseGenericNsAttributes = function(e) {
	return Object.entries(e).filter(([t, n]) => !t.startsWith("$") && this.parseNsAttribute(e, t, n)).map(([e, t]) => ({
		name: e,
		value: t
	}));
}, x_.prototype.parseGenericContainments = function(e) {
	var t = e.$body;
	t && this.body.push(new y_().build({ type: "String" }, t));
	var n = e.$children;
	n && X(n, (e) => {
		this.body.push(new x_(this).build(e));
	});
}, x_.prototype.parseNsAttribute = function(e, t, n) {
	var r = e.$model, i = ag(t), a;
	if (i.prefix === "xmlns" && (a = {
		prefix: i.localName,
		uri: n
	}), !i.prefix && i.localName === "xmlns" && (a = { uri: n }), !a) return {
		name: t,
		value: n
	};
	if (r && r.getPackage(n)) this.logNamespace(a, !0, !0);
	else {
		var o = this.logNamespaceUsed(a, !0);
		this.getNamespaces().logUsed(o);
	}
}, x_.prototype.parseNsAttributes = function(e) {
	var t = this, n = e.$attrs, r = [];
	return X(n, function(n, i) {
		var a = t.parseNsAttribute(e, i, n);
		a && r.push(a);
	}), r;
}, x_.prototype.parseGenericAttributes = function(e, t) {
	var n = this;
	X(t, function(t) {
		try {
			n.addAttribute(n.nsAttributeName(t.name), t.value);
		} catch (n) {
			typeof console < "u" && console.warn(`missing namespace information for <${t.name}=${t.value}> on`, e, n);
		}
	});
}, x_.prototype.parseContainments = function(e) {
	var t = this, n = this.body, r = this.element;
	X(e, function(e) {
		var i = r.get(e.name), a = e.isReference;
		if (e.isMany || (i = [i]), e.isBody) n.push(new y_().build(e, i[0]));
		else if (ig(e.type)) X(i, function(r) {
			n.push(new b_(t.addTagName(t.nsPropertyTagName(e))).build(e, r));
		});
		else if (a) X(i, function(r) {
			n.push(new v_(t.addTagName(t.nsPropertyTagName(e))).build(r));
		});
		else {
			var o = Ng(e);
			X(i, function(r) {
				var i = o ? o === Mg ? new x_(t, e) : new S_(t, e, o) : new x_(t);
				n.push(i.build(r));
			});
		}
	});
}, x_.prototype.getNamespaces = function(e) {
	var t = this.namespaces, n = this.parent, r;
	return t || (r = n && n.getNamespaces(), e || !r ? this.namespaces = t = new n_(r) : t = r), t;
}, x_.prototype.logNamespace = function(e, t, n) {
	var r = this.getNamespaces(n), i = e.uri, a = e.prefix;
	return (!r.byUri(i) || n) && r.add(e, t), r.mapPrefix(a, i), e;
}, x_.prototype.logNamespaceUsed = function(e, t) {
	var n = this.getNamespaces(t), r = e.prefix, i = e.uri, a, o, s;
	if (!r && !i) return { localName: e.localName };
	if (s = n.defaultUriByPrefix(r), i = i || s || n.uriByPrefix(r), !i) throw Error("no namespace uri given for prefix <" + r + ">");
	if (e = n.byUri(i), !e && !r && (e = this.logNamespace({ uri: i }, s === i, !0)), !e) {
		for (a = r, o = 1; n.uriByPrefix(a);) a = r + "_" + o++;
		e = this.logNamespace({
			prefix: a,
			uri: i
		}, s === i);
	}
	return r && n.mapPrefix(r, i), e;
}, x_.prototype.parseAttributes = function(e) {
	var t = this, n = this.element;
	X(e, function(e) {
		var r = n.get(e.name);
		if (e.isReference) if (!e.isMany) r = r.id;
		else {
			var i = [];
			X(r, function(e) {
				i.push(e.id);
			}), r = i.join(" ");
		}
		t.addAttribute(t.nsAttributeName(e), r);
	});
}, x_.prototype.addTagName = function(e) {
	var t = this.logNamespaceUsed(e);
	return this.getNamespaces().logUsed(t), o_(e);
}, x_.prototype.addAttribute = function(e, t) {
	var n = this.attrs;
	vu(t) && (t = m_(t));
	var r = xu(n, function(t) {
		return t.name.localName === e.localName && t.name.uri === e.uri && t.name.prefix === e.prefix;
	}), i = {
		name: e,
		value: t
	};
	r === -1 ? n.push(i) : n.splice(r, 1, i);
}, x_.prototype.serializeAttributes = function(e) {
	var t = this.attrs, n = this.namespaces;
	n && (t = s_(n).concat(t)), X(t, function(t) {
		e.append(" ").append(o_(t.name)).append("=\"").append(t.value).append("\"");
	});
}, x_.prototype.serializeTo = function(e) {
	var t = this.body[0], n = t && t.constructor !== y_;
	e.appendIndent().append("<" + this.tagName), this.serializeAttributes(e), e.append(t ? ">" : " />"), t && (n && e.appendNewLine().indent(), X(this.body, function(t) {
		t.serializeTo(e);
	}), n && e.unindent().appendIndent(), e.append("</" + this.tagName + ">")), e.appendNewLine();
};
function S_(e, t, n) {
	x_.call(this, e, t), this.serialization = n;
}
a_(S_, x_), S_.prototype.parseNsAttributes = function(e) {
	var t = x_.prototype.parseNsAttributes.call(this, e).filter((e) => e.name !== this.serialization), n = e.$descriptor;
	if (n.name === this.propertyDescriptor.type) return t;
	var r = this.typeNs = this.nsTagName(n);
	this.getNamespaces().logUsed(this.typeNs);
	var i = e.$model.getPackage(r.uri), a = i.xml && i.xml.typePrefix || "";
	return this.addAttribute(this.nsAttributeName(this.serialization), (r.prefix ? r.prefix + ":" : "") + a + n.ns.localName), t;
}, S_.prototype.isLocalNs = function(e) {
	return e.uri === (this.typeNs || this.ns).uri;
};
function C_() {
	this.value = "", this.write = function(e) {
		this.value += e;
	};
}
function w_(e, t) {
	var n = [""];
	this.append = function(t) {
		return e.write(t), this;
	}, this.appendNewLine = function() {
		return t && e.write("\n"), this;
	}, this.appendIndent = function() {
		return t && e.write(n.join("  ")), this;
	}, this.indent = function() {
		return n.push(""), this;
	}, this.unindent = function() {
		return n.pop(), this;
	};
}
function T_(e) {
	e = Z({
		format: !1,
		preamble: !0
	}, e || {});
	function t(t, n) {
		var r = n || new C_(), i = new w_(r, e.format);
		e.preamble && i.append($g);
		var a = new x_(), o = t.$model;
		if (a.getNamespaces().mapDefaultPrefixes(E_(o)), a.build(t).serializeTo(i), !n) return r.value;
	}
	return { toXML: t };
}
function E_(e) {
	let t = e.config && e.config.nsMap || {}, n = {};
	for (let e in jg) n[e] = jg[e];
	for (let e in t) {
		let r = t[e];
		n[r] = e;
	}
	for (let t of e.getPackages()) n[t.prefix] = t.uri;
	return n;
}
//#endregion
//#region ../../../node_modules/bpmn-moddle/dist/index.js
function D_(e, t) {
	pg.call(this, e, t);
}
D_.prototype = Object.create(pg.prototype), D_.prototype.fromXML = function(e, t, n) {
	vu(t) || (n = t, t = "bpmn:Definitions");
	var r = new Zg(Z({
		model: this,
		lax: !0
	}, n)), i = r.handler(t);
	return r.fromXML(e, i);
}, D_.prototype.toXML = function(e, t) {
	var n = new T_(t);
	return new Promise(function(t, r) {
		try {
			return t({ xml: n.toXML(e) });
		} catch (e) {
			return r(e);
		}
	});
};
var O_ = {
	bpmn: {
		name: "BPMN20",
		uri: "http://www.omg.org/spec/BPMN/20100524/MODEL",
		prefix: "bpmn",
		associations: [],
		types: [
			{
				name: "Interface",
				superClass: ["RootElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "operations",
						type: "Operation",
						isMany: !0
					},
					{
						name: "implementationRef",
						isAttr: !0,
						type: "String"
					}
				]
			},
			{
				name: "Operation",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "inMessageRef",
						type: "Message",
						isReference: !0
					},
					{
						name: "outMessageRef",
						type: "Message",
						isReference: !0
					},
					{
						name: "errorRef",
						type: "Error",
						isMany: !0,
						isReference: !0
					},
					{
						name: "implementationRef",
						isAttr: !0,
						type: "String"
					}
				]
			},
			{
				name: "EndPoint",
				superClass: ["RootElement"]
			},
			{
				name: "Auditing",
				superClass: ["BaseElement"]
			},
			{
				name: "GlobalTask",
				superClass: ["CallableElement"],
				properties: [{
					name: "resources",
					type: "ResourceRole",
					isMany: !0
				}]
			},
			{
				name: "Monitoring",
				superClass: ["BaseElement"]
			},
			{
				name: "Performer",
				superClass: ["ResourceRole"]
			},
			{
				name: "Process",
				superClass: ["FlowElementsContainer", "CallableElement"],
				properties: [
					{
						name: "processType",
						type: "ProcessType",
						isAttr: !0
					},
					{
						name: "isClosed",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "auditing",
						type: "Auditing"
					},
					{
						name: "monitoring",
						type: "Monitoring"
					},
					{
						name: "properties",
						type: "Property",
						isMany: !0
					},
					{
						name: "laneSets",
						isMany: !0,
						replaces: "FlowElementsContainer#laneSets",
						type: "LaneSet"
					},
					{
						name: "flowElements",
						isMany: !0,
						replaces: "FlowElementsContainer#flowElements",
						type: "FlowElement"
					},
					{
						name: "artifacts",
						type: "Artifact",
						isMany: !0
					},
					{
						name: "resources",
						type: "ResourceRole",
						isMany: !0
					},
					{
						name: "correlationSubscriptions",
						type: "CorrelationSubscription",
						isMany: !0
					},
					{
						name: "supports",
						type: "Process",
						isMany: !0,
						isReference: !0
					},
					{
						name: "definitionalCollaborationRef",
						type: "Collaboration",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "isExecutable",
						isAttr: !0,
						type: "Boolean"
					}
				]
			},
			{
				name: "LaneSet",
				superClass: ["BaseElement"],
				properties: [{
					name: "lanes",
					type: "Lane",
					isMany: !0
				}, {
					name: "name",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Lane",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "partitionElementRef",
						type: "BaseElement",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "partitionElement",
						type: "BaseElement"
					},
					{
						name: "flowNodeRef",
						type: "FlowNode",
						isMany: !0,
						isReference: !0
					},
					{
						name: "childLaneSet",
						type: "LaneSet",
						xml: { serialize: "xsi:type" }
					}
				]
			},
			{
				name: "GlobalManualTask",
				superClass: ["GlobalTask"]
			},
			{
				name: "ManualTask",
				superClass: ["Task"]
			},
			{
				name: "UserTask",
				superClass: ["Task"],
				properties: [{
					name: "renderings",
					type: "Rendering",
					isMany: !0
				}, {
					name: "implementation",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Rendering",
				superClass: ["BaseElement"]
			},
			{
				name: "HumanPerformer",
				superClass: ["Performer"]
			},
			{
				name: "PotentialOwner",
				superClass: ["HumanPerformer"]
			},
			{
				name: "GlobalUserTask",
				superClass: ["GlobalTask"],
				properties: [{
					name: "implementation",
					isAttr: !0,
					type: "String"
				}, {
					name: "renderings",
					type: "Rendering",
					isMany: !0
				}]
			},
			{
				name: "Gateway",
				isAbstract: !0,
				superClass: ["FlowNode"],
				properties: [{
					name: "gatewayDirection",
					type: "GatewayDirection",
					default: "Unspecified",
					isAttr: !0
				}]
			},
			{
				name: "EventBasedGateway",
				superClass: ["Gateway"],
				properties: [{
					name: "instantiate",
					default: !1,
					isAttr: !0,
					type: "Boolean"
				}, {
					name: "eventGatewayType",
					type: "EventBasedGatewayType",
					isAttr: !0,
					default: "Exclusive"
				}]
			},
			{
				name: "ComplexGateway",
				superClass: ["Gateway"],
				properties: [{
					name: "activationCondition",
					type: "Expression",
					xml: { serialize: "xsi:type" }
				}, {
					name: "default",
					type: "SequenceFlow",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "ExclusiveGateway",
				superClass: ["Gateway"],
				properties: [{
					name: "default",
					type: "SequenceFlow",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "InclusiveGateway",
				superClass: ["Gateway"],
				properties: [{
					name: "default",
					type: "SequenceFlow",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "ParallelGateway",
				superClass: ["Gateway"]
			},
			{
				name: "RootElement",
				isAbstract: !0,
				superClass: ["BaseElement"]
			},
			{
				name: "Relationship",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "type",
						isAttr: !0,
						type: "String"
					},
					{
						name: "direction",
						type: "RelationshipDirection",
						isAttr: !0
					},
					{
						name: "source",
						isMany: !0,
						isReference: !0,
						type: "Element"
					},
					{
						name: "target",
						isMany: !0,
						isReference: !0,
						type: "Element"
					}
				]
			},
			{
				name: "BaseElement",
				isAbstract: !0,
				properties: [
					{
						name: "id",
						isAttr: !0,
						type: "String",
						isId: !0
					},
					{
						name: "documentation",
						type: "Documentation",
						isMany: !0
					},
					{
						name: "extensionDefinitions",
						type: "ExtensionDefinition",
						isMany: !0,
						isReference: !0
					},
					{
						name: "extensionElements",
						type: "ExtensionElements"
					}
				]
			},
			{
				name: "Extension",
				properties: [{
					name: "mustUnderstand",
					default: !1,
					isAttr: !0,
					type: "Boolean"
				}, {
					name: "definition",
					type: "ExtensionDefinition",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "ExtensionDefinition",
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}, {
					name: "extensionAttributeDefinitions",
					type: "ExtensionAttributeDefinition",
					isMany: !0
				}]
			},
			{
				name: "ExtensionAttributeDefinition",
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "type",
						isAttr: !0,
						type: "String"
					},
					{
						name: "isReference",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "extensionDefinition",
						type: "ExtensionDefinition",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "ExtensionElements",
				properties: [
					{
						name: "valueRef",
						isAttr: !0,
						isReference: !0,
						type: "Element"
					},
					{
						name: "values",
						type: "Element",
						isMany: !0
					},
					{
						name: "extensionAttributeDefinition",
						type: "ExtensionAttributeDefinition",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "Documentation",
				superClass: ["BaseElement"],
				properties: [{
					name: "text",
					type: "String",
					isBody: !0
				}, {
					name: "textFormat",
					default: "text/plain",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Event",
				isAbstract: !0,
				superClass: ["FlowNode", "InteractionNode"],
				properties: [{
					name: "properties",
					type: "Property",
					isMany: !0
				}]
			},
			{
				name: "IntermediateCatchEvent",
				superClass: ["CatchEvent"]
			},
			{
				name: "IntermediateThrowEvent",
				superClass: ["ThrowEvent"]
			},
			{
				name: "EndEvent",
				superClass: ["ThrowEvent"]
			},
			{
				name: "StartEvent",
				superClass: ["CatchEvent"],
				properties: [{
					name: "isInterrupting",
					default: !0,
					isAttr: !0,
					type: "Boolean"
				}]
			},
			{
				name: "ThrowEvent",
				isAbstract: !0,
				superClass: ["Event"],
				properties: [
					{
						name: "dataInputs",
						type: "DataInput",
						isMany: !0
					},
					{
						name: "dataInputAssociations",
						type: "DataInputAssociation",
						isMany: !0
					},
					{
						name: "inputSet",
						type: "InputSet"
					},
					{
						name: "eventDefinitions",
						type: "EventDefinition",
						isMany: !0
					},
					{
						name: "eventDefinitionRef",
						type: "EventDefinition",
						isMany: !0,
						isReference: !0
					}
				]
			},
			{
				name: "CatchEvent",
				isAbstract: !0,
				superClass: ["Event"],
				properties: [
					{
						name: "parallelMultiple",
						isAttr: !0,
						type: "Boolean",
						default: !1
					},
					{
						name: "dataOutputs",
						type: "DataOutput",
						isMany: !0
					},
					{
						name: "dataOutputAssociations",
						type: "DataOutputAssociation",
						isMany: !0
					},
					{
						name: "outputSet",
						type: "OutputSet"
					},
					{
						name: "eventDefinitions",
						type: "EventDefinition",
						isMany: !0
					},
					{
						name: "eventDefinitionRef",
						type: "EventDefinition",
						isMany: !0,
						isReference: !0
					}
				]
			},
			{
				name: "BoundaryEvent",
				superClass: ["CatchEvent"],
				properties: [{
					name: "cancelActivity",
					default: !0,
					isAttr: !0,
					type: "Boolean"
				}, {
					name: "attachedToRef",
					type: "Activity",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "EventDefinition",
				isAbstract: !0,
				superClass: ["RootElement"]
			},
			{
				name: "CancelEventDefinition",
				superClass: ["EventDefinition"]
			},
			{
				name: "ErrorEventDefinition",
				superClass: ["EventDefinition"],
				properties: [{
					name: "errorRef",
					type: "Error",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "TerminateEventDefinition",
				superClass: ["EventDefinition"]
			},
			{
				name: "EscalationEventDefinition",
				superClass: ["EventDefinition"],
				properties: [{
					name: "escalationRef",
					type: "Escalation",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "Escalation",
				properties: [
					{
						name: "structureRef",
						type: "ItemDefinition",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "escalationCode",
						isAttr: !0,
						type: "String"
					}
				],
				superClass: ["RootElement"]
			},
			{
				name: "CompensateEventDefinition",
				superClass: ["EventDefinition"],
				properties: [{
					name: "waitForCompletion",
					isAttr: !0,
					type: "Boolean",
					default: !0
				}, {
					name: "activityRef",
					type: "Activity",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "TimerEventDefinition",
				superClass: ["EventDefinition"],
				properties: [
					{
						name: "timeDate",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "timeCycle",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "timeDuration",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					}
				]
			},
			{
				name: "LinkEventDefinition",
				superClass: ["EventDefinition"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "target",
						type: "LinkEventDefinition",
						isReference: !0
					},
					{
						name: "source",
						type: "LinkEventDefinition",
						isMany: !0,
						isReference: !0
					}
				]
			},
			{
				name: "MessageEventDefinition",
				superClass: ["EventDefinition"],
				properties: [{
					name: "messageRef",
					type: "Message",
					isAttr: !0,
					isReference: !0
				}, {
					name: "operationRef",
					type: "Operation",
					isReference: !0
				}]
			},
			{
				name: "ConditionalEventDefinition",
				superClass: ["EventDefinition"],
				properties: [{
					name: "condition",
					type: "Expression",
					xml: { serialize: "xsi:type" }
				}]
			},
			{
				name: "SignalEventDefinition",
				superClass: ["EventDefinition"],
				properties: [{
					name: "signalRef",
					type: "Signal",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "Signal",
				superClass: ["RootElement"],
				properties: [{
					name: "structureRef",
					type: "ItemDefinition",
					isAttr: !0,
					isReference: !0
				}, {
					name: "name",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "ImplicitThrowEvent",
				superClass: ["ThrowEvent"]
			},
			{
				name: "DataState",
				superClass: ["BaseElement"],
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "ItemAwareElement",
				superClass: ["BaseElement"],
				properties: [{
					name: "itemSubjectRef",
					type: "ItemDefinition",
					isAttr: !0,
					isReference: !0
				}, {
					name: "dataState",
					type: "DataState"
				}]
			},
			{
				name: "DataAssociation",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "sourceRef",
						type: "ItemAwareElement",
						isMany: !0,
						isReference: !0
					},
					{
						name: "targetRef",
						type: "ItemAwareElement",
						isReference: !0
					},
					{
						name: "transformation",
						type: "FormalExpression",
						xml: { serialize: "property" }
					},
					{
						name: "assignment",
						type: "Assignment",
						isMany: !0
					}
				]
			},
			{
				name: "DataInput",
				superClass: ["ItemAwareElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "isCollection",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "inputSetRef",
						type: "InputSet",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "inputSetWithOptional",
						type: "InputSet",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "inputSetWithWhileExecuting",
						type: "InputSet",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					}
				]
			},
			{
				name: "DataOutput",
				superClass: ["ItemAwareElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "isCollection",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "outputSetRef",
						type: "OutputSet",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "outputSetWithOptional",
						type: "OutputSet",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "outputSetWithWhileExecuting",
						type: "OutputSet",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					}
				]
			},
			{
				name: "InputSet",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "dataInputRefs",
						type: "DataInput",
						isMany: !0,
						isReference: !0
					},
					{
						name: "optionalInputRefs",
						type: "DataInput",
						isMany: !0,
						isReference: !0
					},
					{
						name: "whileExecutingInputRefs",
						type: "DataInput",
						isMany: !0,
						isReference: !0
					},
					{
						name: "outputSetRefs",
						type: "OutputSet",
						isMany: !0,
						isReference: !0
					}
				]
			},
			{
				name: "OutputSet",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "dataOutputRefs",
						type: "DataOutput",
						isMany: !0,
						isReference: !0
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "inputSetRefs",
						type: "InputSet",
						isMany: !0,
						isReference: !0
					},
					{
						name: "optionalOutputRefs",
						type: "DataOutput",
						isMany: !0,
						isReference: !0
					},
					{
						name: "whileExecutingOutputRefs",
						type: "DataOutput",
						isMany: !0,
						isReference: !0
					}
				]
			},
			{
				name: "Property",
				superClass: ["ItemAwareElement"],
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "DataInputAssociation",
				superClass: ["DataAssociation"]
			},
			{
				name: "DataOutputAssociation",
				superClass: ["DataAssociation"]
			},
			{
				name: "InputOutputSpecification",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "dataInputs",
						type: "DataInput",
						isMany: !0
					},
					{
						name: "dataOutputs",
						type: "DataOutput",
						isMany: !0
					},
					{
						name: "inputSets",
						type: "InputSet",
						isMany: !0
					},
					{
						name: "outputSets",
						type: "OutputSet",
						isMany: !0
					}
				]
			},
			{
				name: "DataObject",
				superClass: ["FlowElement", "ItemAwareElement"],
				properties: [{
					name: "isCollection",
					default: !1,
					isAttr: !0,
					type: "Boolean"
				}]
			},
			{
				name: "InputOutputBinding",
				properties: [
					{
						name: "inputDataRef",
						type: "InputSet",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "outputDataRef",
						type: "OutputSet",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "operationRef",
						type: "Operation",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "Assignment",
				superClass: ["BaseElement"],
				properties: [{
					name: "from",
					type: "Expression",
					xml: { serialize: "xsi:type" }
				}, {
					name: "to",
					type: "Expression",
					xml: { serialize: "xsi:type" }
				}]
			},
			{
				name: "DataStore",
				superClass: ["RootElement", "ItemAwareElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "capacity",
						isAttr: !0,
						type: "Integer"
					},
					{
						name: "isUnlimited",
						default: !0,
						isAttr: !0,
						type: "Boolean"
					}
				]
			},
			{
				name: "DataStoreReference",
				superClass: ["ItemAwareElement", "FlowElement"],
				properties: [{
					name: "dataStoreRef",
					type: "DataStore",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "DataObjectReference",
				superClass: ["ItemAwareElement", "FlowElement"],
				properties: [{
					name: "dataObjectRef",
					type: "DataObject",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "ConversationLink",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "sourceRef",
						type: "InteractionNode",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "targetRef",
						type: "InteractionNode",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					}
				]
			},
			{
				name: "ConversationAssociation",
				superClass: ["BaseElement"],
				properties: [{
					name: "innerConversationNodeRef",
					type: "ConversationNode",
					isAttr: !0,
					isReference: !0
				}, {
					name: "outerConversationNodeRef",
					type: "ConversationNode",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "CallConversation",
				superClass: ["ConversationNode"],
				properties: [{
					name: "calledCollaborationRef",
					type: "Collaboration",
					isAttr: !0,
					isReference: !0
				}, {
					name: "participantAssociations",
					type: "ParticipantAssociation",
					isMany: !0
				}]
			},
			{
				name: "Conversation",
				superClass: ["ConversationNode"]
			},
			{
				name: "SubConversation",
				superClass: ["ConversationNode"],
				properties: [{
					name: "conversationNodes",
					type: "ConversationNode",
					isMany: !0
				}]
			},
			{
				name: "ConversationNode",
				isAbstract: !0,
				superClass: ["InteractionNode", "BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "participantRef",
						type: "Participant",
						isMany: !0,
						isReference: !0
					},
					{
						name: "messageFlowRefs",
						type: "MessageFlow",
						isMany: !0,
						isReference: !0
					},
					{
						name: "correlationKeys",
						type: "CorrelationKey",
						isMany: !0
					}
				]
			},
			{
				name: "GlobalConversation",
				superClass: ["Collaboration"]
			},
			{
				name: "PartnerEntity",
				superClass: ["RootElement"],
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}, {
					name: "participantRef",
					type: "Participant",
					isMany: !0,
					isReference: !0
				}]
			},
			{
				name: "PartnerRole",
				superClass: ["RootElement"],
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}, {
					name: "participantRef",
					type: "Participant",
					isMany: !0,
					isReference: !0
				}]
			},
			{
				name: "CorrelationProperty",
				superClass: ["RootElement"],
				properties: [
					{
						name: "correlationPropertyRetrievalExpression",
						type: "CorrelationPropertyRetrievalExpression",
						isMany: !0
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "type",
						type: "ItemDefinition",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "Error",
				superClass: ["RootElement"],
				properties: [
					{
						name: "structureRef",
						type: "ItemDefinition",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "errorCode",
						isAttr: !0,
						type: "String"
					}
				]
			},
			{
				name: "CorrelationKey",
				superClass: ["BaseElement"],
				properties: [{
					name: "correlationPropertyRef",
					type: "CorrelationProperty",
					isMany: !0,
					isReference: !0
				}, {
					name: "name",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Expression",
				superClass: ["BaseElement"],
				isAbstract: !1,
				properties: [{
					name: "body",
					isBody: !0,
					type: "String"
				}]
			},
			{
				name: "FormalExpression",
				superClass: ["Expression"],
				properties: [{
					name: "language",
					isAttr: !0,
					type: "String"
				}, {
					name: "evaluatesToTypeRef",
					type: "ItemDefinition",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "Message",
				superClass: ["RootElement"],
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}, {
					name: "itemRef",
					type: "ItemDefinition",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "ItemDefinition",
				superClass: ["RootElement"],
				properties: [
					{
						name: "itemKind",
						type: "ItemKind",
						isAttr: !0
					},
					{
						name: "structureRef",
						isAttr: !0,
						type: "String"
					},
					{
						name: "isCollection",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "import",
						type: "Import",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "FlowElement",
				isAbstract: !0,
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "auditing",
						type: "Auditing"
					},
					{
						name: "monitoring",
						type: "Monitoring"
					},
					{
						name: "categoryValueRef",
						type: "CategoryValue",
						isMany: !0,
						isReference: !0
					}
				]
			},
			{
				name: "SequenceFlow",
				superClass: ["FlowElement"],
				properties: [
					{
						name: "isImmediate",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "conditionExpression",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "sourceRef",
						type: "FlowNode",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "targetRef",
						type: "FlowNode",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "FlowElementsContainer",
				isAbstract: !0,
				superClass: ["BaseElement"],
				properties: [{
					name: "laneSets",
					type: "LaneSet",
					isMany: !0
				}, {
					name: "flowElements",
					type: "FlowElement",
					isMany: !0
				}]
			},
			{
				name: "CallableElement",
				isAbstract: !0,
				superClass: ["RootElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "ioSpecification",
						type: "InputOutputSpecification",
						xml: { serialize: "property" }
					},
					{
						name: "supportedInterfaceRef",
						type: "Interface",
						isMany: !0,
						isReference: !0
					},
					{
						name: "ioBinding",
						type: "InputOutputBinding",
						isMany: !0,
						xml: { serialize: "property" }
					}
				]
			},
			{
				name: "FlowNode",
				isAbstract: !0,
				superClass: ["FlowElement"],
				properties: [
					{
						name: "incoming",
						type: "SequenceFlow",
						isMany: !0,
						isReference: !0
					},
					{
						name: "outgoing",
						type: "SequenceFlow",
						isMany: !0,
						isReference: !0
					},
					{
						name: "lanes",
						type: "Lane",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					}
				]
			},
			{
				name: "CorrelationPropertyRetrievalExpression",
				superClass: ["BaseElement"],
				properties: [{
					name: "messagePath",
					type: "FormalExpression"
				}, {
					name: "messageRef",
					type: "Message",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "CorrelationPropertyBinding",
				superClass: ["BaseElement"],
				properties: [{
					name: "dataPath",
					type: "FormalExpression"
				}, {
					name: "correlationPropertyRef",
					type: "CorrelationProperty",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "Resource",
				superClass: ["RootElement"],
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}, {
					name: "resourceParameters",
					type: "ResourceParameter",
					isMany: !0
				}]
			},
			{
				name: "ResourceParameter",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "isRequired",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "type",
						type: "ItemDefinition",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "CorrelationSubscription",
				superClass: ["BaseElement"],
				properties: [{
					name: "correlationKeyRef",
					type: "CorrelationKey",
					isAttr: !0,
					isReference: !0
				}, {
					name: "correlationPropertyBinding",
					type: "CorrelationPropertyBinding",
					isMany: !0
				}]
			},
			{
				name: "MessageFlow",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "sourceRef",
						type: "InteractionNode",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "targetRef",
						type: "InteractionNode",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "messageRef",
						type: "Message",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "MessageFlowAssociation",
				superClass: ["BaseElement"],
				properties: [{
					name: "innerMessageFlowRef",
					type: "MessageFlow",
					isAttr: !0,
					isReference: !0
				}, {
					name: "outerMessageFlowRef",
					type: "MessageFlow",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "InteractionNode",
				isAbstract: !0,
				properties: [{
					name: "incomingConversationLinks",
					type: "ConversationLink",
					isMany: !0,
					isVirtual: !0,
					isReference: !0
				}, {
					name: "outgoingConversationLinks",
					type: "ConversationLink",
					isMany: !0,
					isVirtual: !0,
					isReference: !0
				}]
			},
			{
				name: "Participant",
				superClass: ["InteractionNode", "BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "interfaceRef",
						type: "Interface",
						isMany: !0,
						isReference: !0
					},
					{
						name: "participantMultiplicity",
						type: "ParticipantMultiplicity"
					},
					{
						name: "endPointRefs",
						type: "EndPoint",
						isMany: !0,
						isReference: !0
					},
					{
						name: "processRef",
						type: "Process",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "ParticipantAssociation",
				superClass: ["BaseElement"],
				properties: [{
					name: "innerParticipantRef",
					type: "Participant",
					isAttr: !0,
					isReference: !0
				}, {
					name: "outerParticipantRef",
					type: "Participant",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "ParticipantMultiplicity",
				properties: [{
					name: "minimum",
					default: 0,
					isAttr: !0,
					type: "Integer"
				}, {
					name: "maximum",
					default: 1,
					isAttr: !0,
					type: "Integer"
				}],
				superClass: ["BaseElement"]
			},
			{
				name: "Collaboration",
				superClass: ["RootElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "isClosed",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "participants",
						type: "Participant",
						isMany: !0
					},
					{
						name: "messageFlows",
						type: "MessageFlow",
						isMany: !0
					},
					{
						name: "artifacts",
						type: "Artifact",
						isMany: !0
					},
					{
						name: "conversations",
						type: "ConversationNode",
						isMany: !0
					},
					{
						name: "conversationAssociations",
						type: "ConversationAssociation"
					},
					{
						name: "participantAssociations",
						type: "ParticipantAssociation",
						isMany: !0
					},
					{
						name: "messageFlowAssociations",
						type: "MessageFlowAssociation",
						isMany: !0
					},
					{
						name: "correlationKeys",
						type: "CorrelationKey",
						isMany: !0
					},
					{
						name: "choreographyRef",
						type: "Choreography",
						isMany: !0,
						isReference: !0
					},
					{
						name: "conversationLinks",
						type: "ConversationLink",
						isMany: !0
					}
				]
			},
			{
				name: "ChoreographyActivity",
				isAbstract: !0,
				superClass: ["FlowNode"],
				properties: [
					{
						name: "participantRef",
						type: "Participant",
						isMany: !0,
						isReference: !0
					},
					{
						name: "initiatingParticipantRef",
						type: "Participant",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "correlationKeys",
						type: "CorrelationKey",
						isMany: !0
					},
					{
						name: "loopType",
						type: "ChoreographyLoopType",
						default: "None",
						isAttr: !0
					}
				]
			},
			{
				name: "CallChoreography",
				superClass: ["ChoreographyActivity"],
				properties: [{
					name: "calledChoreographyRef",
					type: "Choreography",
					isAttr: !0,
					isReference: !0
				}, {
					name: "participantAssociations",
					type: "ParticipantAssociation",
					isMany: !0
				}]
			},
			{
				name: "SubChoreography",
				superClass: ["ChoreographyActivity", "FlowElementsContainer"],
				properties: [{
					name: "artifacts",
					type: "Artifact",
					isMany: !0
				}]
			},
			{
				name: "ChoreographyTask",
				superClass: ["ChoreographyActivity"],
				properties: [{
					name: "messageFlowRef",
					type: "MessageFlow",
					isMany: !0,
					isReference: !0
				}]
			},
			{
				name: "Choreography",
				superClass: ["Collaboration", "FlowElementsContainer"]
			},
			{
				name: "GlobalChoreographyTask",
				superClass: ["Choreography"],
				properties: [{
					name: "initiatingParticipantRef",
					type: "Participant",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "TextAnnotation",
				superClass: ["Artifact"],
				properties: [{
					name: "text",
					type: "String"
				}, {
					name: "textFormat",
					default: "text/plain",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Group",
				superClass: ["Artifact"],
				properties: [{
					name: "categoryValueRef",
					type: "CategoryValue",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "Association",
				superClass: ["Artifact"],
				properties: [
					{
						name: "associationDirection",
						type: "AssociationDirection",
						isAttr: !0
					},
					{
						name: "sourceRef",
						type: "BaseElement",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "targetRef",
						type: "BaseElement",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "Category",
				superClass: ["RootElement"],
				properties: [{
					name: "categoryValue",
					type: "CategoryValue",
					isMany: !0
				}, {
					name: "name",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Artifact",
				isAbstract: !0,
				superClass: ["BaseElement"]
			},
			{
				name: "CategoryValue",
				superClass: ["BaseElement"],
				properties: [{
					name: "categorizedFlowElements",
					type: "FlowElement",
					isMany: !0,
					isVirtual: !0,
					isReference: !0
				}, {
					name: "value",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Activity",
				isAbstract: !0,
				superClass: ["FlowNode"],
				properties: [
					{
						name: "isForCompensation",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "default",
						type: "SequenceFlow",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "ioSpecification",
						type: "InputOutputSpecification",
						xml: { serialize: "property" }
					},
					{
						name: "boundaryEventRefs",
						type: "BoundaryEvent",
						isMany: !0,
						isReference: !0
					},
					{
						name: "properties",
						type: "Property",
						isMany: !0
					},
					{
						name: "dataInputAssociations",
						type: "DataInputAssociation",
						isMany: !0
					},
					{
						name: "dataOutputAssociations",
						type: "DataOutputAssociation",
						isMany: !0
					},
					{
						name: "startQuantity",
						default: 1,
						isAttr: !0,
						type: "Integer"
					},
					{
						name: "resources",
						type: "ResourceRole",
						isMany: !0
					},
					{
						name: "completionQuantity",
						default: 1,
						isAttr: !0,
						type: "Integer"
					},
					{
						name: "loopCharacteristics",
						type: "LoopCharacteristics"
					}
				]
			},
			{
				name: "ServiceTask",
				superClass: ["Task"],
				properties: [{
					name: "implementation",
					isAttr: !0,
					type: "String"
				}, {
					name: "operationRef",
					type: "Operation",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "SubProcess",
				superClass: [
					"Activity",
					"FlowElementsContainer",
					"InteractionNode"
				],
				properties: [{
					name: "triggeredByEvent",
					default: !1,
					isAttr: !0,
					type: "Boolean"
				}, {
					name: "artifacts",
					type: "Artifact",
					isMany: !0
				}]
			},
			{
				name: "LoopCharacteristics",
				isAbstract: !0,
				superClass: ["BaseElement"]
			},
			{
				name: "MultiInstanceLoopCharacteristics",
				superClass: ["LoopCharacteristics"],
				properties: [
					{
						name: "isSequential",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "behavior",
						type: "MultiInstanceBehavior",
						default: "All",
						isAttr: !0
					},
					{
						name: "loopCardinality",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "loopDataInputRef",
						type: "ItemAwareElement",
						isReference: !0
					},
					{
						name: "loopDataOutputRef",
						type: "ItemAwareElement",
						isReference: !0
					},
					{
						name: "inputDataItem",
						type: "DataInput",
						xml: { serialize: "property" }
					},
					{
						name: "outputDataItem",
						type: "DataOutput",
						xml: { serialize: "property" }
					},
					{
						name: "complexBehaviorDefinition",
						type: "ComplexBehaviorDefinition",
						isMany: !0
					},
					{
						name: "completionCondition",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "oneBehaviorEventRef",
						type: "EventDefinition",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "noneBehaviorEventRef",
						type: "EventDefinition",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "StandardLoopCharacteristics",
				superClass: ["LoopCharacteristics"],
				properties: [
					{
						name: "testBefore",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "loopCondition",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "loopMaximum",
						type: "Integer",
						isAttr: !0
					}
				]
			},
			{
				name: "CallActivity",
				superClass: ["Activity", "InteractionNode"],
				properties: [{
					name: "calledElement",
					type: "String",
					isAttr: !0
				}]
			},
			{
				name: "Task",
				superClass: ["Activity", "InteractionNode"]
			},
			{
				name: "SendTask",
				superClass: ["Task"],
				properties: [
					{
						name: "implementation",
						isAttr: !0,
						type: "String"
					},
					{
						name: "operationRef",
						type: "Operation",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "messageRef",
						type: "Message",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "ReceiveTask",
				superClass: ["Task"],
				properties: [
					{
						name: "implementation",
						isAttr: !0,
						type: "String"
					},
					{
						name: "instantiate",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "operationRef",
						type: "Operation",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "messageRef",
						type: "Message",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "ScriptTask",
				superClass: ["Task"],
				properties: [{
					name: "scriptFormat",
					isAttr: !0,
					type: "String"
				}, {
					name: "script",
					type: "String"
				}]
			},
			{
				name: "BusinessRuleTask",
				superClass: ["Task"],
				properties: [{
					name: "implementation",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "AdHocSubProcess",
				superClass: ["SubProcess"],
				properties: [
					{
						name: "completionCondition",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "ordering",
						type: "AdHocOrdering",
						isAttr: !0
					},
					{
						name: "cancelRemainingInstances",
						default: !0,
						isAttr: !0,
						type: "Boolean"
					}
				]
			},
			{
				name: "Transaction",
				superClass: ["SubProcess"],
				properties: [{
					name: "protocol",
					isAttr: !0,
					type: "String"
				}, {
					name: "method",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "GlobalScriptTask",
				superClass: ["GlobalTask"],
				properties: [{
					name: "scriptLanguage",
					isAttr: !0,
					type: "String"
				}, {
					name: "script",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "GlobalBusinessRuleTask",
				superClass: ["GlobalTask"],
				properties: [{
					name: "implementation",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "ComplexBehaviorDefinition",
				superClass: ["BaseElement"],
				properties: [{
					name: "condition",
					type: "FormalExpression"
				}, {
					name: "event",
					type: "ImplicitThrowEvent"
				}]
			},
			{
				name: "ResourceRole",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "resourceRef",
						type: "Resource",
						isReference: !0
					},
					{
						name: "resourceParameterBindings",
						type: "ResourceParameterBinding",
						isMany: !0
					},
					{
						name: "resourceAssignmentExpression",
						type: "ResourceAssignmentExpression"
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					}
				]
			},
			{
				name: "ResourceParameterBinding",
				properties: [{
					name: "expression",
					type: "Expression",
					xml: { serialize: "xsi:type" }
				}, {
					name: "parameterRef",
					type: "ResourceParameter",
					isAttr: !0,
					isReference: !0
				}],
				superClass: ["BaseElement"]
			},
			{
				name: "ResourceAssignmentExpression",
				properties: [{
					name: "expression",
					type: "Expression",
					xml: { serialize: "xsi:type" }
				}],
				superClass: ["BaseElement"]
			},
			{
				name: "Import",
				properties: [
					{
						name: "importType",
						isAttr: !0,
						type: "String"
					},
					{
						name: "location",
						isAttr: !0,
						type: "String"
					},
					{
						name: "namespace",
						isAttr: !0,
						type: "String"
					}
				]
			},
			{
				name: "Definitions",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "targetNamespace",
						isAttr: !0,
						type: "String"
					},
					{
						name: "expressionLanguage",
						default: "http://www.w3.org/1999/XPath",
						isAttr: !0,
						type: "String"
					},
					{
						name: "typeLanguage",
						default: "http://www.w3.org/2001/XMLSchema",
						isAttr: !0,
						type: "String"
					},
					{
						name: "imports",
						type: "Import",
						isMany: !0
					},
					{
						name: "extensions",
						type: "Extension",
						isMany: !0
					},
					{
						name: "rootElements",
						type: "RootElement",
						isMany: !0
					},
					{
						name: "diagrams",
						isMany: !0,
						type: "bpmndi:BPMNDiagram"
					},
					{
						name: "exporter",
						isAttr: !0,
						type: "String"
					},
					{
						name: "relationships",
						type: "Relationship",
						isMany: !0
					},
					{
						name: "exporterVersion",
						isAttr: !0,
						type: "String"
					}
				]
			}
		],
		enumerations: [
			{
				name: "ProcessType",
				literalValues: [
					{ name: "None" },
					{ name: "Public" },
					{ name: "Private" }
				]
			},
			{
				name: "GatewayDirection",
				literalValues: [
					{ name: "Unspecified" },
					{ name: "Converging" },
					{ name: "Diverging" },
					{ name: "Mixed" }
				]
			},
			{
				name: "EventBasedGatewayType",
				literalValues: [{ name: "Parallel" }, { name: "Exclusive" }]
			},
			{
				name: "RelationshipDirection",
				literalValues: [
					{ name: "None" },
					{ name: "Forward" },
					{ name: "Backward" },
					{ name: "Both" }
				]
			},
			{
				name: "ItemKind",
				literalValues: [{ name: "Physical" }, { name: "Information" }]
			},
			{
				name: "ChoreographyLoopType",
				literalValues: [
					{ name: "None" },
					{ name: "Standard" },
					{ name: "MultiInstanceSequential" },
					{ name: "MultiInstanceParallel" }
				]
			},
			{
				name: "AssociationDirection",
				literalValues: [
					{ name: "None" },
					{ name: "One" },
					{ name: "Both" }
				]
			},
			{
				name: "MultiInstanceBehavior",
				literalValues: [
					{ name: "None" },
					{ name: "One" },
					{ name: "All" },
					{ name: "Complex" }
				]
			},
			{
				name: "AdHocOrdering",
				literalValues: [{ name: "Parallel" }, { name: "Sequential" }]
			}
		],
		xml: {
			tagAlias: "lowerCase",
			typePrefix: "t"
		}
	},
	bpmndi: {
		name: "BPMNDI",
		uri: "http://www.omg.org/spec/BPMN/20100524/DI",
		prefix: "bpmndi",
		types: [
			{
				name: "BPMNDiagram",
				properties: [{
					name: "plane",
					type: "BPMNPlane",
					redefines: "di:Diagram#rootElement"
				}, {
					name: "labelStyle",
					type: "BPMNLabelStyle",
					isMany: !0
				}],
				superClass: ["di:Diagram"]
			},
			{
				name: "BPMNPlane",
				properties: [{
					name: "bpmnElement",
					isAttr: !0,
					isReference: !0,
					type: "bpmn:BaseElement",
					redefines: "di:DiagramElement#modelElement"
				}],
				superClass: ["di:Plane"]
			},
			{
				name: "BPMNShape",
				properties: [
					{
						name: "bpmnElement",
						isAttr: !0,
						isReference: !0,
						type: "bpmn:BaseElement",
						redefines: "di:DiagramElement#modelElement"
					},
					{
						name: "isHorizontal",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "isExpanded",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "isMarkerVisible",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "label",
						type: "BPMNLabel"
					},
					{
						name: "isMessageVisible",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "participantBandKind",
						type: "ParticipantBandKind",
						isAttr: !0
					},
					{
						name: "choreographyActivityShape",
						type: "BPMNShape",
						isAttr: !0,
						isReference: !0
					}
				],
				superClass: ["di:LabeledShape"]
			},
			{
				name: "BPMNEdge",
				properties: [
					{
						name: "label",
						type: "BPMNLabel"
					},
					{
						name: "bpmnElement",
						isAttr: !0,
						isReference: !0,
						type: "bpmn:BaseElement",
						redefines: "di:DiagramElement#modelElement"
					},
					{
						name: "sourceElement",
						isAttr: !0,
						isReference: !0,
						type: "di:DiagramElement",
						redefines: "di:Edge#source"
					},
					{
						name: "targetElement",
						isAttr: !0,
						isReference: !0,
						type: "di:DiagramElement",
						redefines: "di:Edge#target"
					},
					{
						name: "messageVisibleKind",
						type: "MessageVisibleKind",
						isAttr: !0,
						default: "initiating"
					}
				],
				superClass: ["di:LabeledEdge"]
			},
			{
				name: "BPMNLabel",
				properties: [{
					name: "labelStyle",
					type: "BPMNLabelStyle",
					isAttr: !0,
					isReference: !0,
					redefines: "di:DiagramElement#style"
				}],
				superClass: ["di:Label"]
			},
			{
				name: "BPMNLabelStyle",
				properties: [{
					name: "font",
					type: "dc:Font"
				}],
				superClass: ["di:Style"]
			}
		],
		enumerations: [{
			name: "ParticipantBandKind",
			literalValues: [
				{ name: "top_initiating" },
				{ name: "middle_initiating" },
				{ name: "bottom_initiating" },
				{ name: "top_non_initiating" },
				{ name: "middle_non_initiating" },
				{ name: "bottom_non_initiating" }
			]
		}, {
			name: "MessageVisibleKind",
			literalValues: [{ name: "initiating" }, { name: "non_initiating" }]
		}],
		associations: []
	},
	dc: {
		name: "DC",
		uri: "http://www.omg.org/spec/DD/20100524/DC",
		prefix: "dc",
		types: [
			{ name: "Boolean" },
			{ name: "Integer" },
			{ name: "Real" },
			{ name: "String" },
			{
				name: "Font",
				properties: [
					{
						name: "name",
						type: "String",
						isAttr: !0
					},
					{
						name: "size",
						type: "Real",
						isAttr: !0
					},
					{
						name: "isBold",
						type: "Boolean",
						isAttr: !0
					},
					{
						name: "isItalic",
						type: "Boolean",
						isAttr: !0
					},
					{
						name: "isUnderline",
						type: "Boolean",
						isAttr: !0
					},
					{
						name: "isStrikeThrough",
						type: "Boolean",
						isAttr: !0
					}
				]
			},
			{
				name: "Point",
				properties: [{
					name: "x",
					type: "Real",
					default: "0",
					isAttr: !0
				}, {
					name: "y",
					type: "Real",
					default: "0",
					isAttr: !0
				}]
			},
			{
				name: "Bounds",
				properties: [
					{
						name: "x",
						type: "Real",
						default: "0",
						isAttr: !0
					},
					{
						name: "y",
						type: "Real",
						default: "0",
						isAttr: !0
					},
					{
						name: "width",
						type: "Real",
						isAttr: !0
					},
					{
						name: "height",
						type: "Real",
						isAttr: !0
					}
				]
			}
		],
		associations: []
	},
	di: {
		name: "DI",
		uri: "http://www.omg.org/spec/DD/20100524/DI",
		prefix: "di",
		types: [
			{
				name: "DiagramElement",
				isAbstract: !0,
				properties: [
					{
						name: "id",
						isAttr: !0,
						isId: !0,
						type: "String"
					},
					{
						name: "extension",
						type: "Extension"
					},
					{
						name: "owningDiagram",
						type: "Diagram",
						isReadOnly: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "owningElement",
						type: "DiagramElement",
						isReadOnly: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "modelElement",
						isReadOnly: !0,
						isVirtual: !0,
						isReference: !0,
						type: "Element"
					},
					{
						name: "style",
						type: "Style",
						isReadOnly: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "ownedElement",
						type: "DiagramElement",
						isReadOnly: !0,
						isMany: !0,
						isVirtual: !0
					}
				]
			},
			{
				name: "Node",
				isAbstract: !0,
				superClass: ["DiagramElement"]
			},
			{
				name: "Edge",
				isAbstract: !0,
				superClass: ["DiagramElement"],
				properties: [
					{
						name: "source",
						type: "DiagramElement",
						isReadOnly: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "target",
						type: "DiagramElement",
						isReadOnly: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "waypoint",
						isUnique: !1,
						isMany: !0,
						type: "dc:Point",
						xml: { serialize: "xsi:type" }
					}
				]
			},
			{
				name: "Diagram",
				isAbstract: !0,
				properties: [
					{
						name: "id",
						isAttr: !0,
						isId: !0,
						type: "String"
					},
					{
						name: "rootElement",
						type: "DiagramElement",
						isReadOnly: !0,
						isVirtual: !0
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "documentation",
						isAttr: !0,
						type: "String"
					},
					{
						name: "resolution",
						isAttr: !0,
						type: "Real"
					},
					{
						name: "ownedStyle",
						type: "Style",
						isReadOnly: !0,
						isMany: !0,
						isVirtual: !0
					}
				]
			},
			{
				name: "Shape",
				isAbstract: !0,
				superClass: ["Node"],
				properties: [{
					name: "bounds",
					type: "dc:Bounds"
				}]
			},
			{
				name: "Plane",
				isAbstract: !0,
				superClass: ["Node"],
				properties: [{
					name: "planeElement",
					type: "DiagramElement",
					subsettedProperty: "DiagramElement-ownedElement",
					isMany: !0
				}]
			},
			{
				name: "LabeledEdge",
				isAbstract: !0,
				superClass: ["Edge"],
				properties: [{
					name: "ownedLabel",
					type: "Label",
					isReadOnly: !0,
					subsettedProperty: "DiagramElement-ownedElement",
					isMany: !0,
					isVirtual: !0
				}]
			},
			{
				name: "LabeledShape",
				isAbstract: !0,
				superClass: ["Shape"],
				properties: [{
					name: "ownedLabel",
					type: "Label",
					isReadOnly: !0,
					subsettedProperty: "DiagramElement-ownedElement",
					isMany: !0,
					isVirtual: !0
				}]
			},
			{
				name: "Label",
				isAbstract: !0,
				superClass: ["Node"],
				properties: [{
					name: "bounds",
					type: "dc:Bounds"
				}]
			},
			{
				name: "Style",
				isAbstract: !0,
				properties: [{
					name: "id",
					isAttr: !0,
					isId: !0,
					type: "String"
				}]
			},
			{
				name: "Extension",
				properties: [{
					name: "values",
					isMany: !0,
					type: "Element"
				}]
			}
		],
		associations: [],
		xml: { tagAlias: "lowerCase" }
	},
	bioc: {
		name: "bpmn.io colors for BPMN",
		uri: "http://bpmn.io/schema/bpmn/biocolor/1.0",
		prefix: "bioc",
		types: [{
			name: "ColoredShape",
			extends: ["bpmndi:BPMNShape"],
			properties: [{
				name: "stroke",
				isAttr: !0,
				type: "String"
			}, {
				name: "fill",
				isAttr: !0,
				type: "String"
			}]
		}, {
			name: "ColoredEdge",
			extends: ["bpmndi:BPMNEdge"],
			properties: [{
				name: "stroke",
				isAttr: !0,
				type: "String"
			}, {
				name: "fill",
				isAttr: !0,
				type: "String"
			}]
		}],
		enumerations: [],
		associations: []
	},
	color: {
		name: "BPMN in Color",
		uri: "http://www.omg.org/spec/BPMN/non-normative/color/1.0",
		prefix: "color",
		types: [
			{
				name: "ColoredLabel",
				extends: ["bpmndi:BPMNLabel"],
				properties: [{
					name: "color",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "ColoredShape",
				extends: ["bpmndi:BPMNShape"],
				properties: [{
					name: "background-color",
					isAttr: !0,
					type: "String"
				}, {
					name: "border-color",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "ColoredEdge",
				extends: ["bpmndi:BPMNEdge"],
				properties: [{
					name: "border-color",
					isAttr: !0,
					type: "String"
				}]
			}
		],
		enumerations: [],
		associations: []
	}
};
function k_(e, t) {
	return new D_(Z({}, O_, e), t);
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/import/BpmnTreeWalker.js
function A_(e, t) {
	return e.$instanceOf(t);
}
function j_(e) {
	return bu(e.rootElements, function(e) {
		return A_(e, "bpmn:Process") || A_(e, "bpmn:Collaboration");
	});
}
function M_(e) {
	var t = {}, n = [], r = {};
	function i(e, t) {
		return function(n) {
			e(n, t);
		};
	}
	function a(e) {
		t[e.id] = e;
	}
	function o(e) {
		return t[e.id];
	}
	function s(t, n) {
		if (t.gfx) throw Error(`already rendered ${Fp(t)}`);
		return e.element(t, r[t.id], n);
	}
	function c(t, n) {
		return e.root(t, r[t.id], n);
	}
	function l(e, t) {
		try {
			var n = r[e.id] && s(e, t);
			return a(e), n;
		} catch (t) {
			u(t.message, {
				element: e,
				error: t
			}), console.error(`failed to import ${Fp(e)}`, t);
		}
	}
	function u(t, n) {
		e.error(t, n);
	}
	var d = this.registerDi = function(e) {
		var t = e.bpmnElement;
		t ? r[t.id] ? u(`multiple DI elements defined for ${Fp(t)}`, { element: t }) : r[t.id] = e : u(`no bpmnElement referenced in ${Fp(e)}`, { element: e });
	};
	function f(e) {
		p(e.plane);
	}
	function p(e) {
		d(e), X(e.planeElement, m);
	}
	function m(e) {
		d(e);
	}
	this.handleDefinitions = function(e, t) {
		var i = e.diagrams;
		if (t && i.indexOf(t) === -1) throw Error("diagram not part of <bpmn:Definitions />");
		if (!t && i && i.length && (t = i[0]), !t) throw Error("no diagram to display");
		r = {}, f(t);
		var a = t.plane;
		if (!a) throw Error(`no plane for ${Fp(t)}`);
		var o = a.bpmnElement;
		if (!o) if (o = j_(e), o) u(`correcting missing bpmnElement on ${Fp(a)} to ${Fp(o)}`), a.bpmnElement = o, d(a);
		else throw Error("no process or collaboration to display");
		var s = c(o, a);
		if (A_(o, "bpmn:Process") || A_(o, "bpmn:SubProcess")) g(o, s);
		else if (A_(o, "bpmn:Collaboration")) ue(o, s), _(e.rootElements, s);
		else throw Error(`unsupported bpmnElement for ${Fp(a)}: ${Fp(o)}`);
		h(n);
	};
	var h = this.handleDeferred = function() {
		for (var e; n.length;) e = n.shift(), e();
	};
	function g(e, t) {
		se(e, t), T(e.ioSpecification, t), w(e.artifacts, t), a(e);
	}
	function _(e, t) {
		Su(e, function(e) {
			return !o(e) && A_(e, "bpmn:Process") && e.laneSets;
		}).forEach(i(g, t));
	}
	function v(e, t) {
		l(e, t);
	}
	function y(e, t) {
		X(e, i(v, t));
	}
	function b(e, t) {
		l(e, t);
	}
	function x(e, t) {
		l(e, t);
	}
	function S(e, t) {
		l(e, t);
	}
	function C(e, t) {
		l(e, t);
	}
	function w(e, t) {
		X(e, function(e) {
			A_(e, "bpmn:Association") ? n.push(function() {
				C(e, t);
			}) : C(e, t);
		});
	}
	function T(e, t) {
		e && (X(e.dataInputs, i(x, t)), X(e.dataOutputs, i(S, t)));
	}
	var ee = this.handleSubProcess = function(e, t) {
		se(e, t), w(e.artifacts, t);
	};
	function te(e, t) {
		var r = l(e, t);
		A_(e, "bpmn:SubProcess") && ee(e, r || t), A_(e, "bpmn:Activity") && T(e.ioSpecification, t), n.push(function() {
			X(e.dataInputAssociations, i(b, t)), X(e.dataOutputAssociations, i(b, t));
		});
	}
	function ne(e, t) {
		l(e, t);
	}
	function re(e, t) {
		l(e, t);
	}
	function ie(e, t) {
		n.push(function() {
			var n = l(e, t);
			e.childLaneSet && ae(e.childLaneSet, n || t), de(e);
		});
	}
	function ae(e, t) {
		X(e.lanes, i(ie, t));
	}
	function oe(e, t) {
		X(e, i(ae, t));
	}
	function se(e, t) {
		ce(e.flowElements, t), e.laneSets && oe(e.laneSets, t);
	}
	function ce(e, t) {
		X(e, function(e) {
			A_(e, "bpmn:SequenceFlow") ? n.push(function() {
				ne(e, t);
			}) : A_(e, "bpmn:BoundaryEvent") ? n.unshift(function() {
				te(e, t);
			}) : A_(e, "bpmn:FlowNode") ? te(e, t) : A_(e, "bpmn:DataObject") || (A_(e, "bpmn:DataStoreReference") || A_(e, "bpmn:DataObjectReference") ? re(e, t) : u(`unrecognized flowElement ${Fp(e)} in context ${Fp(t && t.businessObject)}`, {
				element: e,
				context: t
			}));
		});
	}
	function le(e, t) {
		var n = l(e, t), r = e.processRef;
		r && g(r, n || t);
	}
	function ue(e, t) {
		X(e.participants, i(le, t)), n.push(function() {
			y(e.messageFlows, t);
		}), w(e.artifacts, t);
	}
	function de(e) {
		X(e.flowNodeRef, function(t) {
			var n = t.get("lanes");
			n && n.push(e);
		});
	}
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/import/Importer.js
function N_(e, t, n) {
	var r, i, a, o, s = [];
	function c(e, t) {
		var n = new M_({
			root: function(e, t) {
				return r.add(e, t);
			},
			element: function(e, t, n) {
				return r.add(e, t, n);
			},
			error: function(e, t) {
				s.push({
					message: e,
					context: t
				});
			}
		});
		t ||= e.diagrams && e.diagrams[0];
		var i = P_(e, t);
		if (!i) throw Error("no diagram to display");
		X(i, function(t) {
			n.handleDefinitions(e, t);
		});
		var o = t.plane.bpmnElement.id;
		a.setRootElement(a.findRoot(o + "_plane") || a.findRoot(o));
	}
	return new Promise(function(l, u) {
		try {
			return r = e.get("bpmnImporter"), i = e.get("eventBus"), a = e.get("canvas"), i.fire("import.render.start", { definitions: t }), c(t, n), i.fire("import.render.complete", {
				error: o,
				warnings: s
			}), l({ warnings: s });
		} catch (e) {
			return e.warnings = s, u(e);
		}
	});
}
function P_(e, t) {
	if (!(!t || !t.plane)) {
		var n = t.plane.bpmnElement, r = n;
		!Q(n, "bpmn:Process") && !Q(n, "bpmn:Collaboration") && (r = I_(n));
		var i = Q(r, "bpmn:Collaboration") ? r : bu(e.rootElements, function(e) {
			if (Q(e, "bpmn:Collaboration")) return bu(e.participants, function(e) {
				return e.processRef === r;
			});
		}), a = [r];
		i && (a = Eu(i.participants, function(e) {
			return e.processRef;
		}), a.push(i));
		var o = F_(a), s = [t], c = [n];
		return X(e.diagrams, function(e) {
			if (e.plane) {
				var t = e.plane.bpmnElement;
				o.indexOf(t) !== -1 && c.indexOf(t) === -1 && (s.push(e), c.push(t));
			}
		}), s;
	}
}
function F_(e) {
	var t = [];
	return X(e, function(e) {
		e && (t.push(e), t = t.concat(F_(e.flowElements)));
	}), t;
}
function I_(e) {
	for (var t = e; t;) {
		if (Q(t, "bpmn:Process")) return t;
		t = t.$parent;
	}
}
var L_ = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.02 5.57\" width=\"53\" height=\"21\"><path fill=\"currentColor\" d=\"M1.88.92v.14c0 .41-.13.68-.4.8.33.14.46.44.46.86v.33c0 .61-.33.95-.95.95H0V0h.95c.65 0 .93.3.93.92zM.63.57v1.06h.24c.24 0 .38-.1.38-.43V.98c0-.28-.1-.4-.32-.4zm0 1.63v1.22h.36c.2 0 .32-.1.32-.39v-.35c0-.37-.12-.48-.4-.48H.63zM4.18.99v.52c0 .64-.31.98-.94.98h-.3V4h-.62V0h.92c.63 0 .94.35.94.99zM2.94.57v1.35h.3c.2 0 .3-.09.3-.37v-.6c0-.29-.1-.38-.3-.38h-.3zm2.89 2.27L6.25 0h.88v4h-.6V1.12L6.1 3.99h-.6l-.46-2.82v2.82h-.55V0h.87zM8.14 1.1V4h-.56V0h.79L9 2.4V0h.56v4h-.64zm2.49 2.29v.6h-.6v-.6zM12.12 1c0-.63.33-1 .95-1 .61 0 .95.37.95 1v2.04c0 .64-.34 1-.95 1-.62 0-.95-.37-.95-1zm.62 2.08c0 .28.13.39.33.39s.32-.1.32-.4V.98c0-.29-.12-.4-.32-.4s-.33.11-.33.4z\"/><path fill=\"currentColor\" d=\"M0 4.53h14.02v1.04H0zM11.08 0h.63v.62h-.63zm.63 4V1h-.63v2.98z\"/></svg>", R_ = { verticalAlign: "middle" }, z_ = { color: "#404040" }, B_ = {
	zIndex: "1001",
	position: "fixed",
	top: "0",
	left: "0",
	right: "0",
	bottom: "0"
}, V_ = {
	width: "100%",
	height: "100%",
	background: "rgba(40,40,40,0.2)"
}, H_ = {
	position: "absolute",
	left: "50%",
	top: "40%",
	transform: "translate(-50%)",
	width: "260px",
	padding: "10px",
	background: "white",
	boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
	fontFamily: "Helvetica, Arial, sans-serif",
	fontSize: "14px",
	display: "flex",
	lineHeight: "1.3"
}, U_ = "<div class=\"bjs-powered-by-lightbox\"><div class=\"backdrop\"></div><div class=\"notice\"><a href=\"https://bpmn.io\" target=\"_blank\" rel=\"noopener\" class=\"link\">" + L_ + "</a><span>Web-based tooling for BPMN, DMN and forms powered by <a href=\"https://bpmn.io\" target=\"_blank\" rel=\"noopener\">bpmn.io</a>.</span></div></div>", W_;
function G_() {
	W_ = df(U_), pf(W_, B_), pf(Af("svg", W_), R_), pf(Af(".backdrop", W_), V_), pf(Af(".notice", W_), H_), pf(Af(".link", W_), z_, {
		margin: "15px 20px 15px 10px",
		alignSelf: "center"
	});
}
function K_() {
	W_ || (G_(), kf.bind(W_, ".backdrop", "click", function(e) {
		document.body.removeChild(W_);
	})), document.body.appendChild(W_);
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/BaseViewer.js
function q_(e) {
	e = Z({}, X_, e), this._moddle = this._createModdle(e), this._container = this._createContainer(e), this._init(this._container, this._moddle, e), $_(this._container);
}
cu(q_, Zh), q_.prototype.importXML = async function(e, t) {
	let n = this;
	function r(e) {
		return n.get("eventBus").createEvent(e);
	}
	let i = [];
	try {
		e = this._emit("import.parse.start", { xml: e }) || e;
		let n;
		try {
			n = await this._moddle.fromXML(e, "bpmn:Definitions");
		} catch (e) {
			throw this._emit("import.parse.complete", { error: e }), e;
		}
		let a = n.rootElement, o = n.references, s = n.warnings, c = n.elementsById;
		i = i.concat(s), a = this._emit("import.parse.complete", r({
			error: null,
			definitions: a,
			elementsById: c,
			references: o,
			warnings: i
		})) || a;
		let l = await this.importDefinitions(a, t);
		return i = i.concat(l.warnings), this._emit("import.done", {
			error: null,
			warnings: i
		}), { warnings: i };
	} catch (e) {
		let t = e;
		throw i = i.concat(t.warnings || []), J_(t, i), t = Y_(t), this._emit("import.done", {
			error: t,
			warnings: t.warnings
		}), t;
	}
}, q_.prototype.importDefinitions = async function(e, t) {
	return this._setDefinitions(e), { warnings: (await this.open(t)).warnings };
}, q_.prototype.open = async function(e) {
	let t = this._definitions, n = e;
	if (!t) {
		let e = /* @__PURE__ */ Error("no XML imported");
		throw J_(e, []), e;
	}
	if (typeof e == "string" && (n = Q_(t, e), !n)) {
		let t = /* @__PURE__ */ Error("BPMNDiagram <" + e + "> not found");
		throw J_(t, []), t;
	}
	try {
		this.clear();
	} catch (e) {
		throw J_(e, []), e;
	}
	let { warnings: r } = await N_(this, t, n);
	return { warnings: r };
}, q_.prototype.saveXML = async function(e) {
	e ||= {};
	let t = this._definitions, n, r;
	try {
		if (!t) throw Error("no definitions loaded");
		t = this._emit("saveXML.start", { definitions: t }) || t, r = (await this._moddle.toXML(t, e)).xml, r = this._emit("saveXML.serialized", { xml: r }) || r;
	} catch (e) {
		n = e;
	}
	let i = n ? { error: n } : { xml: r };
	if (this._emit("saveXML.done", i), n) throw n;
	return i;
}, q_.prototype.saveSVG = async function() {
	this._emit("saveSVG.start");
	let e, t;
	try {
		let t = this.get("canvas"), n = t.getActiveLayer(), r = Af(":scope > defs", t._svg), i = Fd(n), a = r ? "<defs>" + Fd(r) + "</defs>" : "", o = n.getBBox();
		e = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- created with bpmn-js / http://bpmn.io -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"" + o.width + "\" height=\"" + o.height + "\" viewBox=\"" + o.x + " " + o.y + " " + o.width + " " + o.height + "\" version=\"1.1\">" + a + i + "</svg>";
	} catch (e) {
		t = e;
	}
	if (this._emit("saveSVG.done", {
		error: t,
		svg: e
	}), t) throw t;
	return { svg: e };
}, q_.prototype._setDefinitions = function(e) {
	this._definitions = e;
}, q_.prototype.getModules = function() {
	return this._modules;
}, q_.prototype.clear = function() {
	this.getDefinitions() && Zh.prototype.clear.call(this);
}, q_.prototype.destroy = function() {
	Zh.prototype.destroy.call(this), Mf(this._container);
}, q_.prototype.on = function(e, t, n, r) {
	return this.get("eventBus").on(e, t, n, r);
}, q_.prototype.off = function(e, t) {
	this.get("eventBus").off(e, t);
}, q_.prototype.attachTo = function(e) {
	if (!e) throw Error("parentNode required");
	this.detach(), e.get && e.constructor.prototype.jquery && (e = e.get(0)), typeof e == "string" && (e = Af(e)), e.appendChild(this._container), this._emit("attach", {}), this.get("canvas").resized();
}, q_.prototype.getDefinitions = function() {
	return this._definitions;
}, q_.prototype.detach = function() {
	let e = this._container, t = e.parentNode;
	t && (this._emit("detach", {}), t.removeChild(e));
}, q_.prototype._init = function(e, t, n) {
	let r = n.modules || this.getModules(n), i = n.additionalModules || [], a = [{
		bpmnjs: ["value", this],
		moddle: ["value", t]
	}], o = [].concat(a, r, i), s = Z(Fu(n, ["additionalModules"]), {
		canvas: Z({}, n.canvas, { container: e }),
		modules: o
	});
	Zh.call(this, s), n && n.container && this.attachTo(n.container);
}, q_.prototype._emit = function(e, t) {
	return this.get("eventBus").fire(e, t);
}, q_.prototype._createContainer = function(e) {
	let t = df("<div class=\"bjs-container\"></div>");
	return pf(t, {
		width: Z_(e.width),
		height: Z_(e.height),
		position: e.position
	}), t;
}, q_.prototype._createModdle = function(e) {
	return new k_(Z({}, this._moddleExtensions, e.moddleExtensions));
}, q_.prototype._modules = [];
function J_(e, t) {
	return e.warnings = t, e;
}
function Y_(e) {
	let t = /unparsable content <([^>]+)> detected([\s\S]*)$/.exec(e.message);
	return t && (e.message = "unparsable content <" + t[1] + "> detected; this may indicate an invalid BPMN 2.0 diagram file" + t[2]), e;
}
var X_ = {
	width: "100%",
	height: "100%",
	position: "relative"
};
function Z_(e) {
	return e + (gu(e) ? "px" : "");
}
function Q_(e, t) {
	return t && bu(e.diagrams, function(e) {
		return e.id === t;
	}) || null;
}
function $_(e) {
	let t = df("<a href=\"http://bpmn.io\" target=\"_blank\" class=\"bjs-powered-by\" title=\"Powered by bpmn.io\" >" + L_ + "</a>");
	pf(Af("svg", t), R_), pf(t, z_, {
		position: "absolute",
		bottom: "15px",
		right: "15px",
		zIndex: "100"
	}), e.appendChild(t), Tf.bind(t, "click", function(e) {
		K_(), e.preventDefault();
	});
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/Viewer.js
function ev(e) {
	q_.call(this, e);
}
cu(ev, q_), ev.prototype._modules = [
	Hp,
	Tm,
	Zp,
	Hm,
	Ep
], ev.prototype._moddleExtensions = {};
//#endregion
//#region src/components/general/view-workflow-dialog.vue
var tv = {
	key: 0,
	class: "mb-4"
}, nv = {
	key: 0,
	class: "text-headline-small"
}, rv = {
	class: "d-flex flex-column",
	style: { height: "100%" }
}, iv = ["aria-label"], av = { class: "center-controls" }, ov = { style: {
	width: "40px",
	display: "flex",
	"justify-content": "flex-end"
} }, sv = {
	__name: "view-workflow-dialog",
	props: /*@__PURE__*/ rt({
		bpmnData: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		},
		id: {
			type: String,
			default: ""
		}
	}, {
		dialogVisible: {},
		dialogVisibleModifiers: {}
	}),
	emits: ["update:dialogVisible"],
	setup(e) {
		let t = G(e, "HViewWorkflowDialog"), n = xt(e, "dialogVisible"), r = R(null), i = null, a = R(null), o = R(!1), s = R(1), c = R(!1), l = R({
			x: 0,
			y: 0
		});
		function u() {
			o.value = !o.value, setTimeout(() => {
				i && (i.get("canvas").resized(), i.get("canvas").zoom("fit-viewport", "auto"));
			}, 300);
		}
		function d() {
			if (!i) return;
			let e = i.get("canvas"), t = e.zoom(), n = Math.min(t * 1.2, 4);
			e.zoom(n), s.value = n;
		}
		function f() {
			if (!i) return;
			let e = i.get("canvas"), t = e.zoom(), n = Math.max(t * .8, .2);
			e.zoom(n), s.value = n;
		}
		function p(e) {
			i && (e.preventDefault(), e.deltaY < 0 ? d() : f());
		}
		function m(e) {
			!i || e.button !== 0 || (c.value = !0, l.value = {
				x: e.clientX,
				y: e.clientY
			}, e.target.style.cursor = "grabbing");
		}
		function h(e) {
			if (!c.value || !i) return;
			let t = e.clientX - l.value.x, n = e.clientY - l.value.y;
			i.get("canvas").scroll({
				dx: t,
				dy: n
			}), l.value = {
				x: e.clientX,
				y: e.clientY
			};
		}
		function g(e) {
			c.value && (c.value = !1, e.target && (e.target.style.cursor = "grab"));
		}
		async function _(e) {
			if (!e) {
				console.error("No BPMN-data provided");
				return;
			}
			i ||= new ev({ container: r.value });
			try {
				await it(), setTimeout(async () => {
					try {
						await i.importXML(e), i.get("canvas").zoom("fit-viewport", "auto");
					} catch (e) {
						console.error("Error importing XML", e);
					}
				}, 10);
			} catch (e) {
				console.error("Failed to render BPMN diagram: ", e);
			}
		}
		function v() {
			i && i.get("canvas").zoom("fit-viewport", "auto");
		}
		return U([() => n.value, () => t.bpmnData], async ([e, t]) => {
			e && t && (o.value = !1, await it(), r.value ? _(t) : console.error("Canvas reference not available"));
		}, { immediate: !0 }), U(() => n.value, (e) => {
			if (!e && i) try {
				i.destroy(), i = null;
			} catch (e) {
				console.error("Error destroying viewer:", e);
			}
		}), (e, i) => {
			let s = pt("h-dialog");
			return L(), O(s, {
				modelValue: n.value,
				"onUpdate:modelValue": i[0] ||= (e) => n.value = e,
				"dialog-height": "80vh",
				"dialog-width": "80vw",
				class: I(["bpmn-dialog-content", { "fullscreen-dialog": o.value }]),
				persistent: !1,
				fullscreen: o.value
			}, {
				header: W(() => [H(t).title || H(t).id ? (L(), A("div", tv, [H(t).title ? (L(), A("p", nv, V(H(t).title), 1)) : k("", !0), H(t).id ? (L(), O(sn, {
					key: 1,
					class: "ml-1 px-0"
				}, {
					default: W(() => [M("ID: " + V(H(t).id), 1)]),
					_: 1
				})) : k("", !0)])) : k("", !0)]),
				default: W(() => [j("div", rv, [j("div", {
					ref_key: "dialogRef",
					ref: a,
					class: I(["dialog", { fullscreen: o.value }])
				}, [j("div", {
					ref_key: "canvas",
					ref: r,
					class: I(["bpmn-canvas", { fullscreen: o.value }]),
					role: "application",
					tabindex: "0",
					"aria-label": H(K)("bpmn_diagram"),
					onWheel: p,
					onMousedown: m,
					onMousemove: h,
					onMouseup: g,
					onMouseleave: g,
					onBlur: g
				}, null, 42, iv), N(an, null, {
					default: W(() => [
						i[4] ||= j("div", { style: { width: "40px" } }, null, -1),
						N(mn),
						j("div", av, [
							N(un, {
								location: "bottom",
								text: H(K)("reset_view"),
								"open-delay": 1e3
							}, {
								activator: W(({ props: e }) => [N(q, F({
									icon: "",
									small: "",
									class: "mr-2"
								}, e, {
									"aria-label": H(K)("reset_view"),
									onClick: v
								}), {
									default: W(() => [N(J, null, {
										default: W(() => [...i[1] ||= [M("mdi:mdi-refresh", -1)]]),
										_: 1
									})]),
									_: 1
								}, 16, ["aria-label"])]),
								_: 1
							}, 8, ["text"]),
							N(un, {
								location: "bottom",
								text: H(K)("zoom_out"),
								"open-delay": 1e3
							}, {
								activator: W(({ props: e }) => [N(q, F({
									icon: "",
									small: "",
									class: "mr-2"
								}, e, {
									"aria-label": H(K)("zoom_out"),
									onClick: f
								}), {
									default: W(() => [N(J, null, {
										default: W(() => [...i[2] ||= [M("mdi:mdi-minus", -1)]]),
										_: 1
									})]),
									_: 1
								}, 16, ["aria-label"])]),
								_: 1
							}, 8, ["text"]),
							N(un, {
								location: "bottom",
								text: H(K)("zoom_in"),
								"open-delay": 1e3
							}, {
								activator: W(({ props: e }) => [N(q, F({
									icon: "",
									small: "",
									class: "mr-2"
								}, e, {
									"aria-label": H(K)("zoom_in"),
									onClick: d
								}), {
									default: W(() => [N(J, null, {
										default: W(() => [...i[3] ||= [M("mdi:mdi-plus", -1)]]),
										_: 1
									})]),
									_: 1
								}, 16, ["aria-label"])]),
								_: 1
							}, 8, ["text"])
						]),
						N(mn),
						j("div", ov, [N(un, {
							location: "bottom",
							text: o.value ? H(K)("exit_fullscreen") : H(K)("enter_fullscreen"),
							"open-delay": 1e3
						}, {
							activator: W(({ props: e }) => [N(q, F({ icon: "" }, e, {
								"aria-label": o.value ? H(K)("exit_fullscreen") : H(K)("enter_fullscreen"),
								onClick: u
							}), {
								default: W(() => [N(J, null, {
									default: W(() => [M(V(o.value ? "mdi:mdi-arrow-collapse" : "mdi:mdi-arrow-expand"), 1)]),
									_: 1
								})]),
								_: 1
							}, 16, ["aria-label"])]),
							_: 1
						}, 8, ["text"])])
					]),
					_: 1
				})], 2)])]),
				_: 1
			}, 8, [
				"modelValue",
				"class",
				"fullscreen"
			]);
		};
	}
}, cv = {
	__name: "widgets-container",
	props: { widgets: {
		type: Array,
		required: !0,
		validator: (e) => e.every((e) => "title" in e && "count" in e)
	} },
	setup(e) {
		return G(e, "HWidgetsContainer"), (t, n) => {
			let r = pt("h-widget");
			return L(), O(pn, null, {
				default: W(() => [(L(!0), A(E, null, z(e.widgets, (t, n) => (L(), O(dn, {
					key: n,
					cols: "12",
					sm: "6",
					md: e.widgets.length === 3 ? 4 : 3
				}, {
					default: W(() => [N(r, {
						title: t.title,
						count: t.count,
						description: t.description,
						icon: t.icon,
						color: t.color,
						"icon-color": t.iconColor
					}, null, 8, [
						"title",
						"count",
						"description",
						"icon",
						"color",
						"icon-color"
					])]),
					_: 2
				}, 1032, ["md"]))), 128))]),
				_: 1
			});
		};
	}
}, lv = { class: "d-flex flex-row align-center h-100" }, uv = { class: "d-flex ga-2" }, dv = { class: "d-flex flex-column h-admin-widget__content" }, fv = { class: "h-admin-widget__count" }, pv = { class: "h-admin-widget__title" }, mv = /*#__PURE__*/ Y({
	__name: "widget",
	props: {
		title: {
			type: String,
			required: !0
		},
		count: {
			type: [Number, String],
			required: !0
		},
		description: {
			type: String,
			default: ""
		},
		icon: {
			type: String,
			default: "mdi:mdi-information-outline"
		},
		color: {
			type: String,
			default: "grey-lighten-4"
		},
		iconColor: {
			type: String,
			default: ""
		}
	},
	setup(e) {
		return G(e, "HWidgets"), (t, n) => (L(), O(rn, { class: "pa-2 h-admin-widget" }, {
			default: W(() => [j("div", lv, [j("div", uv, [N(tr, {
				color: e.color,
				class: "mr-3",
				size: "56"
			}, {
				default: W(() => [N(J, {
					icon: e.icon,
					size: "x-large",
					color: e.iconColor,
					class: "h-admin-widget-icon"
				}, null, 8, ["icon", "color"])]),
				_: 1
			}, 8, ["color"])]), j("div", dv, [j("div", fv, V(e.count), 1), j("div", pv, V(e.title), 1)])])]),
			_: 1
		}));
	}
}, [["__scopeId", "data-v-404f1baa"]]), hv = /* @__PURE__ */ Ve((/* @__PURE__ */ f(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, y = "en", b = {};
		b[y] = g;
		var x = "$isDayjsObject", S = function(e) {
			return e instanceof ee || !(!e || !e[x]);
		}, C = function e(t, n, r) {
			var i;
			if (!t) return y;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				b[a] && (i = a), n && (b[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				b[s] = t, i = s;
			}
			return !r && i && (y = i), i || !r && y;
		}, w = function(e, t) {
			if (S(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new ee(n);
		}, T = v;
		T.l = C, T.i = S, T.w = function(e, t) {
			return w(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var ee = function() {
			function g(e) {
				this.$L = C(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[x] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (T.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return T;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = w(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return w(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < w(e);
			}, _.$g = function(e, t, n) {
				return T.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!T.u(t) || t, u = T.p(e), p = function(e, t) {
					var i = T.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return T.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var y = this.$locale().weekStart || 0, b = (h < y ? h + 7 : h) - y;
						return p(r ? _ - b : _ + (6 - b), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = T.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[T.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = T.p(u), h = function(e) {
					var t = w(p);
					return T.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return T.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = T.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return T.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return T.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return T.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return T.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return T.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return T.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return T.s(t.$s, 2, "0");
							case "SSS": return T.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = T.p(f), _ = w(r), v = (_.utcOffset() - this.utcOffset()) * t, y = this - _, b = function() {
					return T.m(h, _);
				};
				switch (g) {
					case d:
						m = b() / 12;
						break;
					case l:
						m = b();
						break;
					case u:
						m = b() / 3;
						break;
					case c:
						m = (y - v) / 6048e5;
						break;
					case s:
						m = (y - v) / 864e5;
						break;
					case o:
						m = y / n;
						break;
					case a:
						m = y / t;
						break;
					case i:
						m = y / e;
						break;
					default: m = y;
				}
				return p ? m : T.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return b[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = C(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return T.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), te = ee.prototype;
		return w.prototype = te, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			te[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), w.extend = function(e, t) {
			return e.$i ||= (e(t, ee, w), !0), w;
		}, w.locale = C, w.isDayjs = S, w.unix = function(e) {
			return w(1e3 * e);
		}, w.en = b[y], w.Ls = b, w.p = {}, w;
	}));
})))(), 1), gv = /* @__PURE__ */ P({
	__name: "filter-datetime",
	props: {
		modelValue: { default: null },
		label: { default: "Date Range" },
		minDateFilter: { default: null },
		minDatePresetFilter: { default: void 0 },
		dateRangeOptions: {},
		classPrefix: {},
		filterKey: {},
		manualSync: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = e, r = G(n, "HFilterDatetime"), i = et("adminFilterDesign", !1), a = t, o = et("filterGroupSyncSignal", R({
			action: null,
			timestamp: 0
		})), s = R(r.modelValue ?? null);
		U(() => r.modelValue, (e) => {
			r.manualSync && s.value !== e && (s.value = e ?? null);
		}), U(o, (e) => {
			r.manualSync && (e.action === "reset" ? s.value = r.modelValue ?? null : e.action === "apply" ? a("update:modelValue", s.value) : e.action === "clear" && (s.value = null, a("update:modelValue", null)));
		}, { deep: !0 });
		let c = D({
			get: () => r.manualSync ? s.value : r.modelValue,
			set: (e) => {
				let t = e;
				r.manualSync ? s.value = t : a("update:modelValue", t);
			}
		}), l = D(() => r.classPrefix && r.filterKey ? `h-${r.classPrefix}-filter-${r.filterKey}` : "");
		function u() {
			r.manualSync ? s.value = null : a("update:modelValue", null);
		}
		let { ranges: d, getPresetRange: f } = Ut(r.dateRangeOptions), p = [
			{
				value: "last15min",
				labelKey: "presets_last15min",
				subtitleKey: "sub_last15min"
			},
			{
				value: "last30min",
				labelKey: "presets_last30min",
				subtitleKey: "sub_last30min"
			},
			{
				value: "last1h",
				labelKey: "presets_last1h",
				subtitleKey: "sub_last1h"
			},
			{
				value: "last4h",
				labelKey: "presets_last4h",
				subtitleKey: "sub_last4h"
			},
			{
				value: "last6h",
				labelKey: "presets_last6h",
				subtitleKey: "sub_last6h"
			},
			{
				value: "last12h",
				labelKey: "presets_last12h",
				subtitleKey: "sub_last12h"
			},
			{
				value: "today",
				labelKey: "presets_today",
				subtitleKey: "sub_today"
			},
			{
				value: "yesterday",
				labelKey: "presets_yesterday",
				subtitleKey: "sub_yesterday"
			},
			{
				value: "last3d",
				labelKey: "presets_last3d",
				subtitleKey: "sub_last3d"
			},
			{
				value: "last7d",
				labelKey: "presets_last7d",
				subtitleKey: "sub_last7d"
			},
			{
				value: "last14d",
				labelKey: "presets_last14d",
				subtitleKey: "sub_last14d"
			},
			{
				value: "thisWeek",
				labelKey: "presets_this_week",
				subtitleKey: "sub_this_week"
			},
			{
				value: "lastWeek",
				labelKey: "presets_last_week",
				subtitleKey: "sub_last_week"
			},
			{
				value: "thisMonth",
				labelKey: "presets_this_month",
				subtitleKey: "sub_this_month"
			},
			{
				value: "lastMonth",
				labelKey: "presets_last_month",
				subtitleKey: "sub_last_month"
			},
			{
				value: "thisYear",
				labelKey: "presets_this_year",
				subtitleKey: "sub_presets_this_year"
			},
			{
				value: "lastYear",
				labelKey: "presets_last_year",
				subtitleKey: "sub_presets_last_year"
			}
		], m = (0, hv.default)(), h = D(() => n.minDateFilter ? n.minDateFilter : n.minDatePresetFilter ? f(n.minDatePresetFilter, m)?.start ?? null : null), g = D(() => {
			let e = (e) => h.value === null ? !1 : h.value.isValid() && e.isBefore(h.value);
			return p.map(({ value: t, labelKey: n, subtitleKey: r }) => {
				let i = f(t, m);
				return {
					value: t,
					label: K(n),
					subtitle: K(r),
					disabled: !i || e(i.start)
				};
			});
		});
		function _(e, t) {
			let n = (e) => e?.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") || "", r = n(e?.raw?.label), i = n(e?.raw?.subtitle), a = n(t), o = `${r} ${i}`;
			return o.includes(a) || a.split(" ").some((e) => o.includes(e));
		}
		return (t, n) => (L(), A("div", { class: I(["d-flex flex-column align-center justify-center my-0 h-filter h-filter-datetime", l.value]) }, [N(vn, {
			modelValue: c.value,
			"onUpdate:modelValue": n[1] ||= (e) => c.value = e,
			label: e.label,
			items: g.value,
			placeholder: H(K)("placeholder_search"),
			"item-title": "label",
			"item-value": "value",
			class: "rounded-xl custom-select h-filter-datetime-main-combobox",
			style: ot(H(i) ? void 0 : {
				maxWidth: "300px",
				minWidth: "300px"
			}),
			"hide-details": H(i),
			"menu-icon": H(i) ? "mdi:mdi-calendar-month" : void 0,
			"return-object": !1,
			filter: _,
			"allow-new": !1
		}, {
			"append-inner": W(() => [c.value ? (L(), O(J, {
				key: 0,
				class: "me-2 h-filter-datetime-clear-icon",
				style: { cursor: "pointer" },
				onClick: n[0] ||= Dt((e) => u(), ["stop"])
			})) : k("", !0)]),
			item: W(({ props: e, item: t }) => [N(Hn, F(e, {
				style: t.disabled ? {
					opacity: "0.5",
					pointerEvents: "none"
				} : {},
				disabled: t.disabled,
				class: "h-filter-datetime-list-item"
			}), {
				default: W(() => [t.subtitle ? (L(), O(Un, {
					key: 0,
					class: "h-filter-datetime-list-subtitle"
				})) : k("", !0)]),
				_: 2
			}, 1040, ["style", "disabled"])]),
			_: 1
		}, 8, [
			"modelValue",
			"label",
			"items",
			"placeholder",
			"style",
			"hide-details",
			"menu-icon"
		])], 2));
	}
}), _v = {
	key: 0,
	class: "h-admin-filter-selection-count"
}, vv = {
	key: 0,
	class: "h-admin-filter-chip-options"
}, yv = /* @__PURE__ */ P({
	__name: "filter-multiselect",
	props: {
		title: {},
		options: {},
		modelValue: {},
		showAsChips: { type: Boolean },
		icon: {},
		classPrefix: {},
		filterKey: {},
		getColor: { type: Function },
		getIcon: { type: Function }
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = G(e, "HFilterMultiselect"), r = et("adminFilterDesign", !1), { icon: i, showAsChips: a } = vt(n), o = D(() => r && n.showAsChips), s = D(() => {
			let e = H(n.options);
			return Array.isArray(e) ? e.filter((e) => e != null && e.value !== void 0) : [];
		}), c = D(() => n.classPrefix && n.filterKey ? `h-${n.classPrefix}-filter-${n.filterKey}` : ""), l = R(!1), u = R(Array.isArray(n.modelValue) ? [...n.modelValue] : []), d = R([...u.value]);
		U(l, (e) => {
			e && (d.value = [...u.value]);
		});
		function f(e) {
			d.value = d.value.includes(e) ? d.value.filter((t) => t !== e) : [...d.value, e];
		}
		function p() {
			u.value = [...d.value], l.value = !1;
		}
		let m = t;
		U(u, (e) => {
			m("update:modelValue", e);
		}), U(() => n.modelValue, (e) => {
			JSON.stringify(e) !== JSON.stringify(u.value) && (u.value = Array.isArray(e) ? [...e] : []);
		}, { deep: !0 });
		function h(e) {
			if (n.getColor) return n.getColor(e);
			if (e && e.color) return e.color;
		}
		function g(e) {
			return n.getIcon ? n.getIcon(e) : e && e.icon ? e.icon : null;
		}
		function _(e) {
			e && e.stopPropagation(), d.value = [], u.value = [], l.value = !1;
		}
		return (t, n) => (L(), A("div", { class: I(["h-filter-multi-select h-filter mr-2", c.value]) }, [N(Sn, {
			modelValue: l.value,
			"onUpdate:modelValue": n[1] ||= (e) => l.value = e,
			"close-on-content-click": !1,
			location: "bottom start",
			offset: H(r) ? 4 : 0,
			class: "h-filter-multiselect-main-menu"
		}, {
			activator: W(({ props: t }) => [N(q, F(t, {
				class: ["filter-button h-filter-multiselect-activator-btn", {
					"h-admin-filter-button": H(r),
					"h-admin-filter-button--open": H(r) && l.value,
					"h-admin-filter-button--active": H(r) && u.value.length > 0,
					"h-admin-filter-button--counted": H(r)
				}],
				"prepend-icon": H(i),
				"append-icon": H(r) ? l.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" : void 0,
				size: "small",
				variant: "outlined",
				color: u.value.length > 0 ? "primary" : void 0
			}), Ye({
				default: W(() => [M(V(e.title) + " " + V(!H(r) && u.value.length > 0 ? `(${u.value.length})` : "") + " ", 1), !H(r) && u.value.length > 0 ? (L(), O(J, {
					key: 0,
					size: "large",
					class: "ml-1 clear-icon h-filter-multiselect-clear-icon",
					onClick: _
				}, {
					default: W(() => [...n[2] ||= [M(" mdi:mdi-close ", -1)]]),
					_: 1
				})) : k("", !0)]),
				_: 2
			}, [H(r) ? {
				name: "append",
				fn: W(() => [
					u.value.length > 0 ? (L(), A("span", _v, V(u.value.length), 1)) : k("", !0),
					u.value.length ? (L(), O(J, {
						key: 1,
						"aria-label": H(K)("clear"),
						role: "button",
						tabindex: "0",
						icon: "mdi:mdi-close",
						onClick: Dt(_, ["stop"]),
						onKeydown: [Et(Dt(_, ["stop", "prevent"]), ["enter"]), Et(Dt(_, ["stop", "prevent"]), ["space"])]
					}, null, 8, ["aria-label", "onKeydown"])) : k("", !0),
					N(J, { icon: l.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" }, null, 8, ["icon"])
				]),
				key: "0"
			} : void 0]), 1040, [
				"prepend-icon",
				"append-icon",
				"class",
				"color"
			])]),
			default: W(() => [N(rn, {
				class: I([{
					"h-admin-filter-menu": H(r),
					"h-admin-filter-chip-menu": o.value
				}, "filter-menu h-filter-multiselect-menu-card"]),
				elevation: "1",
				rounded: "lg"
			}, {
				default: W(() => [N(cn, { class: "h-filter-multiselect-menu-text" }, {
					default: W(() => [o.value ? (L(), A("div", vv, [(L(!0), A(E, null, z(s.value, (e) => (L(), O(qn, {
						key: e.value,
						tag: "button",
						type: "button",
						variant: "outlined",
						color: h(e),
						class: I([{ "h-admin-filter-chip--selected": d.value.includes(e.value) }, "h-admin-filter-choice-chip"]),
						"aria-pressed": d.value.includes(e.value),
						onClick: (t) => f(e.value)
					}, {
						default: W(() => [
							g(e) ? (L(), O(J, {
								key: 0,
								icon: g(e) ?? void 0,
								size: "18",
								class: "mr-1"
							}, null, 8, ["icon"])) : k("", !0),
							M(" " + V(e.label) + " ", 1),
							d.value.includes(e.value) ? (L(), O(J, {
								key: 1,
								icon: "mdi:mdi-close-circle",
								size: "18",
								class: "ml-1"
							})) : k("", !0)
						]),
						_: 2
					}, 1032, [
						"color",
						"class",
						"aria-pressed",
						"onClick"
					]))), 128))])) : (L(), O(Bn, {
						key: 1,
						density: "compact",
						class: "h-filter-multiselect-list"
					}, {
						default: W(() => [(L(!0), A(E, null, z(s.value, (e) => (L(), O(Hn, {
							key: e.value,
							class: "h-filter-multiselect-list-item"
						}, {
							prepend: W(() => [N(Xn, {
								modelValue: u.value,
								"onUpdate:modelValue": n[0] ||= (e) => u.value = e,
								value: e.value,
								density: "compact",
								color: "primary",
								"hide-details": "",
								size: "small",
								class: "h-filter-multiselect-checkbox"
							}, null, 8, ["modelValue", "value"])]),
							default: W(() => [N(Wn, { class: "h-filter-multiselect-list-title" }, {
								default: W(() => [H(a) ? (L(), O(qn, {
									key: 0,
									size: "small",
									color: h(e),
									class: "ml-2 h-filter-multiselect-chip"
								}, {
									default: W(() => [g(e) ? (L(), O(J, {
										key: 0,
										size: "small",
										class: "mr-1 h-filter-multiselect-option-icon"
									}, {
										default: W(() => [M(V(g(e)), 1)]),
										_: 2
									}, 1024)) : k("", !0), M(" " + V(e.label), 1)]),
									_: 2
								}, 1032, ["color"])) : (L(), A(E, { key: 1 }, [g(e) ? (L(), O(J, {
									key: 0,
									size: "small",
									class: "mr-2 h-filter-multiselect-option-icon"
								}, {
									default: W(() => [M(V(g(e)), 1)]),
									_: 2
								}, 1024)) : k("", !0), M(" " + V(e.label), 1)], 64))]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024))), 128))]),
						_: 1
					}))]),
					_: 1
				}), o.value ? (L(), O(an, { key: 0 }, {
					default: W(() => [N(q, { onClick: p }, {
						default: W(() => [M(V(H(K)("apply")), 1)]),
						_: 1
					}), N(q, { onClick: _ }, {
						default: W(() => [M(V(H(K)("clear")), 1)]),
						_: 1
					})]),
					_: 1
				})) : k("", !0)]),
				_: 1
			}, 8, ["class"])]),
			_: 1
		}, 8, ["modelValue", "offset"])], 2));
	}
}), bv = ["title"], xv = {
	key: 0,
	class: "h-admin-filter-selection-count"
}, Sv = { class: "text-body-medium mb-2 d-block" }, Cv = { class: "d-flex flex-wrap mb-2" }, wv = /* @__PURE__ */ P({
	__name: "filter-multistring",
	props: {
		label: {},
		title: {},
		placeholder: { default: void 0 },
		modelValue: { default: () => [] },
		icon: {},
		classPrefix: {},
		filterKey: {}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = G(e, "HFilterMultistring"), r = et("adminFilterDesign", !1), { icon: i } = vt(n), a = t, o = D(() => n.placeholder ?? K("filter_enter_value_placeholder")), s = D(() => n.classPrefix && n.filterKey ? `h-${n.classPrefix}-filter-${n.filterKey}` : ""), c = R(!1), l = R(""), u = R(Array.isArray(n.modelValue) ? [...n.modelValue] : []);
		U(() => n.modelValue, (e) => {
			u.value = Array.isArray(e) ? [...e] : [];
		}, {
			immediate: !0,
			deep: !0
		});
		function d() {
			a("update:modelValue", [...u.value]), l.value = "", c.value = !1;
		}
		function f() {
			u.value = [], a("update:modelValue", []);
		}
		function p() {
			l.value = "";
		}
		function m() {
			let e = l.value.trim();
			e && !u.value.includes(e) && (u.value.push(e), l.value = "");
		}
		function h(e) {
			let t = u.value.indexOf(e);
			t > -1 ? u.value.splice(t, 1) : u.value.push(e), a("update:modelValue", [...u.value]);
		}
		function g() {
			l.value.trim() ? m() : d();
		}
		function _(e) {
			return u.value.includes(e);
		}
		function v(e) {
			u.value.splice(e, 1), a("update:modelValue", [...u.value]);
		}
		return (t, n) => (L(), A("div", { class: I(["h-filter-multistring h-filter mr-2", s.value]) }, [N(Sn, {
			modelValue: c.value,
			"onUpdate:modelValue": n[1] ||= (e) => c.value = e,
			"close-on-content-click": !1,
			location: "bottom start",
			offset: H(r) ? 4 : 0,
			class: "h-filter-multistring-main-menu"
		}, {
			activator: W(({ props: t }) => [N(q, F(t, {
				class: ["filter-button h-filter-multistring-activator-btn", {
					"h-admin-filter-button": H(r),
					"h-admin-filter-button--open": H(r) && c.value,
					"h-admin-filter-button--active": H(r) && u.value.length > 0
				}],
				"prepend-icon": H(i),
				"append-icon": H(r) ? c.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" : void 0,
				variant: "outlined",
				color: u.value.length ? "primary" : "",
				size: "small"
			}), Ye({
				default: W(() => [j("span", {
					class: "h-admin-filter-label",
					title: `${H(K)(e.label ?? "")}: ${u.value.join(", ")}`
				}, V(H(K)(e.label ?? "")) + " " + V(!H(r) && u.value.length ? `(${u.value.join(", ")})` : ""), 9, bv), u.value.length ? (L(), O(J, {
					key: 0,
					size: "large",
					class: "ml-1 clear-icon h-filter-multistring-clear-icon",
					onClick: Dt(f, ["stop"])
				}, {
					default: W(() => [...n[2] ||= [M(" mdi:mdi-close ", -1)]]),
					_: 1
				})) : k("", !0)]),
				_: 2
			}, [H(r) ? {
				name: "append",
				fn: W(() => [u.value.length > 0 ? (L(), A("span", xv, V(u.value.length), 1)) : k("", !0), N(J, { icon: c.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" }, null, 8, ["icon"])]),
				key: "0"
			} : void 0]), 1040, [
				"prepend-icon",
				"append-icon",
				"class",
				"color"
			])]),
			default: W(() => [N(rn, {
				class: I([{ "h-admin-filter-menu": H(r) }, "filter-menu h-filter-multistring-menu-card"]),
				elevation: "1",
				rounded: "lg",
				width: "300"
			}, {
				default: W(() => [N(cn, { class: "pa-2 h-filter-multistring-menu-text" }, {
					default: W(() => [
						j("span", Sv, V(e.title), 1),
						N(hn, {
							modelValue: l.value,
							"onUpdate:modelValue": n[0] ||= (e) => l.value = e,
							label: o.value,
							density: "compact",
							variant: "outlined",
							"hide-details": "",
							"single-line": "",
							class: "mb-2 h-filter-multistring-text-field",
							clearable: "",
							onKeyup: Et(g, ["enter"]),
							"onClick:clear": p
						}, null, 8, ["modelValue", "label"]),
						j("div", Cv, [(L(!0), A(E, null, z(u.value, (e, t) => (L(), O(qn, {
							key: t,
							closable: "",
							size: "small",
							class: I(["ma-1 h-filter-multistring-chip", _(e) ? "font-weight-bold" : ""]),
							onClick: (t) => h(e),
							"onClick:close": (e) => v(t)
						}, {
							default: W(() => [M(V(e), 1)]),
							_: 2
						}, 1032, [
							"class",
							"onClick",
							"onClick:close"
						]))), 128))]),
						N(an, null, {
							default: W(() => [N(q, {
								size: "small",
								color: "primary",
								class: "h-filter-multistring-apply-btn",
								onClick: d
							}, {
								default: W(() => [M(V(H(K)("apply")), 1)]),
								_: 1
							}), N(q, {
								size: "small",
								variant: "text",
								class: "mr-2 h-filter-multistring-clear-btn",
								onClick: f
							}, {
								default: W(() => [M(V(H(K)("clear")), 1)]),
								_: 1
							})]),
							_: 1
						})
					]),
					_: 1
				})]),
				_: 1
			}, 8, ["class"])]),
			_: 1
		}, 8, ["modelValue", "offset"])], 2));
	}
}), Tv = ["title"], Ev = { key: 1 }, Dv = { class: "h-filter-match-selector text-body-medium mr-1" }, Ov = /* @__PURE__ */ P({
	__name: "filter-string",
	props: /*@__PURE__*/ rt({
		title: { default: "Filter" },
		placeholder: { default: "Enter text..." },
		defaultMatchType: { default: "contains" },
		showMatchTypeSelector: {
			type: Boolean,
			default: !1
		},
		icon: { default: "mdi:mdi-filter-variant" },
		classPrefix: { default: void 0 },
		filterKey: { default: "" }
	}, {
		modelValue: {},
		modelModifiers: {},
		matchType: {},
		matchTypeModifiers: {}
	}),
	emits: /*@__PURE__*/ rt(["update:modelValue", "update:matchType"], ["update:modelValue", "update:matchType"]),
	setup(e, { emit: t }) {
		let n = G(e, "HFilterString"), r = et("adminFilterDesign", !1), { icon: i } = vt(n), a = D(() => n.classPrefix && n.filterKey ? `h-${n.classPrefix}-filter-${n.filterKey}` : ""), o = t, s = R(!1), c = R(!1), l = xt(e, "modelValue"), u = xt(e, "matchType"), d = R(l.value || ""), f = R(u.value || n.defaultMatchType), p = D({
			get: () => r ? d.value : l.value,
			set: (e) => {
				r ? d.value = e || "" : l.value = e;
			}
		});
		U(s, (e) => {
			e && (d.value = l.value || "", f.value = u.value || n.defaultMatchType);
		});
		let m = [{
			title: "Contains",
			value: "contains"
		}, {
			title: "Exact match",
			value: "exact"
		}];
		U(u, (e) => {
			o("update:matchType", e);
		});
		function h() {
			r && (l.value = d.value, u.value = f.value), s.value = !1;
		}
		function g(e) {
			e && e.stopPropagation(), l.value = "", o("update:modelValue", ""), o("update:matchType", "contains"), s.value = !1;
		}
		function _(e, t) {
			return e ? e.length > t ? e.substring(0, t) + "..." : e : "";
		}
		function v(e) {
			let t = m.find((t) => t.value === e);
			return t ? t.title : "Match type";
		}
		function y(e) {
			u.value = e, c.value = !1, o("update:matchType", e);
		}
		return (t, n) => (L(), A("div", { class: I(["h-filter-string h-filter mr-2", a.value]) }, [N(Sn, {
			modelValue: s.value,
			"onUpdate:modelValue": n[3] ||= (e) => s.value = e,
			"close-on-content-click": !1,
			location: "bottom start",
			offset: H(r) ? 4 : 0,
			class: "h-filter-string-main-menu"
		}, {
			activator: W(({ props: t }) => [N(q, F(t, {
				class: ["filter-button h-filter-string-activator-btn", {
					"h-admin-filter-button": H(r),
					"h-admin-filter-button--open": H(r) && s.value,
					"h-admin-filter-button--active": H(r) && !!l.value
				}],
				variant: "outlined",
				"prepend-icon": H(i),
				"append-icon": H(r) ? s.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" : void 0,
				color: l.value ? "primary" : void 0,
				size: "small"
			}), Ye({
				default: W(() => [j("span", {
					class: "h-admin-filter-label",
					title: l.value ? `${e.title}: ${l.value}` : e.title
				}, V(e.title) + " " + V(!H(r) && l.value ? `(${_(l.value, 12)})` : ""), 9, Tv), l.value ? (L(), O(J, {
					key: 0,
					size: "large",
					class: "ml-1 clear-icon h-filter-string-clear-icon",
					onClick: g
				}, {
					default: W(() => [...n[4] ||= [M(" mdi:mdi-close ", -1)]]),
					_: 1
				})) : k("", !0)]),
				_: 2
			}, [H(r) ? {
				name: "append",
				fn: W(() => [l.value ? (L(), O(J, {
					key: 0,
					class: "h-admin-filter-selected-icon",
					icon: "mdi:mdi-check-circle"
				})) : k("", !0), N(J, { icon: s.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" }, null, 8, ["icon"])]),
				key: "0"
			} : void 0]), 1040, [
				"prepend-icon",
				"append-icon",
				"class",
				"color"
			])]),
			default: W(() => [N(rn, {
				class: I([{ "h-admin-filter-menu": H(r) }, "filter-menu h-filter-string-menu-card"]),
				elevation: "1",
				rounded: "lg",
				width: H(r) ? 690 : 280,
				"max-width": "calc(100vw - 32px)"
			}, {
				default: W(() => [N(cn, { class: "pa-2 h-filter-string-menu-text" }, {
					default: W(() => [H(r) && e.showMatchTypeSelector ? (L(), O(gn, {
						key: 0,
						modelValue: f.value,
						"onUpdate:modelValue": n[0] ||= (e) => f.value = e,
						items: m,
						"aria-label": e.title,
						variant: "outlined",
						"hide-details": "",
						class: "h-admin-filter-match"
					}, null, 8, ["modelValue", "aria-label"])) : e.showMatchTypeSelector ? (L(), A("div", Ev, [j("span", Dv, V(e.title), 1), N(Sn, {
						modelValue: c.value,
						"onUpdate:modelValue": n[1] ||= (e) => c.value = e,
						class: "h-filter-string-match-menu"
					}, {
						activator: W(({ props: e }) => [j("strong", F(e, { class: "h-filter-match-selector strong-label" }), [M(V(v(u.value)) + " ", 1), N(J, { class: "h-filter-string-match-icon" }, {
							default: W(() => [...n[5] ||= [M("mdi:mdi-chevron-down", -1)]]),
							_: 1
						})], 16)]),
						default: W(() => [N(Bn, {
							density: "compact",
							class: "pa-0 h-filter-string-match-list"
						}, {
							default: W(() => [(L(), A(E, null, z(m, (e) => N(Hn, {
								key: e.value,
								value: e.value,
								class: "h-filter-string-match-item",
								onClick: Dt((t) => y(e.value), ["stop"])
							}, {
								default: W(() => [N(Wn, { class: "h-filter-string-match-title" }, {
									default: W(() => [M(V(e.title), 1)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, ["value", "onClick"])), 64))]),
							_: 1
						})]),
						_: 1
					}, 8, ["modelValue"])])) : k("", !0), N(hn, {
						modelValue: p.value,
						"onUpdate:modelValue": n[2] ||= (e) => p.value = e,
						label: e.placeholder,
						density: "compact",
						variant: "outlined",
						"hide-details": "",
						"single-line": "",
						class: "mb-2 h-filter-string-text-field",
						clearable: "",
						onKeyup: Et(h, ["enter"]),
						"onClick:clear": g
					}, null, 8, ["modelValue", "label"])]),
					_: 1
				}), N(an, null, {
					default: W(() => [N(q, {
						size: "small",
						color: "primary",
						class: "h-filter-string-apply-btn",
						onClick: h
					}, {
						default: W(() => [M(V(H(K)("apply")), 1)]),
						_: 1
					}), N(q, {
						size: "small",
						variant: "text",
						class: "mr-2 h-filter-string-clear-btn",
						onClick: g
					}, {
						default: W(() => [M(V(H(K)("clear")), 1)]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			}, 8, ["class", "width"])]),
			_: 1
		}, 8, ["modelValue", "offset"])], 2));
	}
}), kv = {
	key: 0,
	class: "h-admin-filter-selection-count"
}, Av = /* @__PURE__ */ P({
	__name: "filter-group",
	props: /*@__PURE__*/ rt({
		title: {},
		placeholder: { default: "Enter text..." },
		defaultMatchType: { default: "contains" },
		showMatchTypeSelector: {
			type: Boolean,
			default: !1
		},
		icon: { default: "mdi:mdi-filter-variant" },
		classPrefix: {},
		filterKey: { default: "" },
		controlsSync: {
			type: Boolean,
			default: !1
		},
		filterKeys: {}
	}, {
		filters: {},
		filtersModifiers: {},
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:filters", "update:modelValue"],
	setup(e) {
		let t = G(e, "HFilterGroup"), n = et("adminFilterDesign", !1), { icon: r } = vt(t), i = R({
			action: null,
			timestamp: 0
		});
		t.controlsSync && dt("filterGroupSyncSignal", i);
		let a = D(() => t.classPrefix && t.filterKey ? `h-${t.classPrefix}-filter-${t.filterKey}` : ""), o = xt(e, "filters"), s = ft({}), c = D(() => (t.filterKeys || Object.keys(s)).filter((e) => {
			let t = o.value?.[e];
			return t != null && t !== "" && (!Array.isArray(t) || t.length > 0);
		})), l = xt(e, "modelValue"), u = R(!1);
		function d() {
			o.value && Object.keys(s).forEach((e) => {
				s[e] = o.value?.[e];
			});
		}
		U(o, d, {
			immediate: !0,
			deep: !0
		}), U(u, (e) => {
			e && (d(), t.controlsSync && (i.value = {
				action: "reset",
				timestamp: Date.now()
			}));
		});
		function f() {
			o.value ||= {}, Object.keys(s).forEach((e) => {
				o.value[e] = s[e];
			});
		}
		function p() {
			t.controlsSync && (i.value = {
				action: "apply",
				timestamp: Date.now()
			}), f(), u.value = !1;
		}
		function m() {
			t.controlsSync && (i.value = {
				action: "clear",
				timestamp: Date.now()
			}), Object.keys(s).forEach((e) => {
				s[e] = null;
			}), o.value && t.filterKeys?.forEach((e) => {
				o.value[e] = null;
			}), f(), u.value = !1;
		}
		function h(e, t) {
			return e ? e.length > t ? e.substring(0, t) + "..." : e : "";
		}
		return (t, i) => {
			let o = pt("h-theme-scope"), d = pt("h-menu");
			return L(), A("div", { class: I(["h-filter-group h-filter", a.value]) }, [N(o, { name: "HScopedFilterGroupMenu" }, {
				default: W(() => [N(d, {
					modelValue: u.value,
					"onUpdate:modelValue": i[2] ||= (e) => u.value = e,
					"close-on-content-click": !1,
					offset: H(n) ? 4 : 0,
					location: "bottom end",
					class: "h-filter-group__menu"
				}, {
					activator: W(({ props: t }) => [N(o, { name: "HScopedFilterGroupMenuActivator" }, {
						default: W(() => [N(q, F(t, {
							variant: "outlined",
							size: "small",
							"prepend-icon": H(r),
							"append-icon": H(n) ? u.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" : void 0,
							class: {
								"h-admin-filter-button": H(n),
								"h-admin-filter-button--open": H(n) && u.value,
								"h-admin-filter-button--active": H(n) && c.value.length > 0,
								"h-admin-filter-button--counted": H(n)
							},
							color: c.value.length ? "filter-group-active" : "filter-group-inactive"
						}), Ye({
							default: W(() => [j("span", null, V(e.title) + " " + V(l.value ? `(${h(l.value, 12)})` : ""), 1), H(n) ? k("", !0) : (L(), O(o, {
								key: 0,
								name: "HScopedFilterGroupBadge"
							}, {
								default: W(() => [c.value.length ? (L(), O(Jn, {
									key: 0,
									class: "ml-auto",
									color: "filter-group-badge",
									content: c.value.length,
									inline: ""
								}, null, 8, ["content"])) : k("", !0)]),
								_: 1
							}))]),
							_: 2
						}, [H(n) ? {
							name: "append",
							fn: W(() => [
								c.value.length ? (L(), A("span", kv, V(c.value.length), 1)) : k("", !0),
								c.value.length ? (L(), O(J, {
									key: 1,
									"aria-label": H(K)("clear"),
									role: "button",
									tabindex: "0",
									icon: "mdi:mdi-close",
									onClick: Dt(m, ["stop"]),
									onKeydown: [Et(Dt(m, ["stop", "prevent"]), ["enter"]), Et(Dt(m, ["stop", "prevent"]), ["space"])]
								}, null, 8, ["aria-label", "onKeydown"])) : k("", !0),
								N(J, { icon: u.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" }, null, 8, ["icon"])
							]),
							key: "0"
						} : void 0]), 1040, [
							"prepend-icon",
							"append-icon",
							"class",
							"color"
						])]),
						_: 2
					}, 1024)]),
					default: W(() => [N(o, { name: "HScopedFilterGroupMenuCard" }, {
						default: W(() => [N(rn, { class: I(["h-filter-group__content", { "h-admin-filter-menu": H(n) }]) }, {
							default: W(() => [B(t.$slots, "menu-content", { internalFilters: s }, () => [N(on, null, {
								default: W(() => [N(cn, { class: "pt-2" }, {
									default: W(() => [B(t.$slots, "default", { internalFilters: s })]),
									_: 3
								}), N(an, null, {
									default: W(() => [N(o, { name: "HScopedFilterGroupApplyActionButton" }, {
										default: W(() => [N(q, { onClick: i[0] ||= (e) => p() }, {
											default: W(() => [M(V(H(K)("apply")), 1)]),
											_: 1
										})]),
										_: 1
									}), N(o, { name: "HScopedFilterGroupClearActionButton" }, {
										default: W(() => [N(q, { onClick: i[1] ||= (e) => m() }, {
											default: W(() => [M(V(H(K)("clear")), 1)]),
											_: 1
										})]),
										_: 1
									})]),
									_: 1
								})]),
								_: 3
							})])]),
							_: 3
						}, 8, ["class"])]),
						_: 3
					})]),
					_: 3
				}, 8, ["modelValue", "offset"])]),
				_: 3
			})], 2);
		};
	}
}), jv = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "filter-text",
	props: {
		modelValue: {},
		placeholder: {},
		classPrefix: {},
		filterKey: {}
	},
	emits: ["update:modelValue", "search"],
	setup(e, { emit: t }) {
		let n = G(e, "HFilterText"), r = t, i = R(n.modelValue || ""), a = D(() => n.classPrefix && n.filterKey ? `h-${n.classPrefix}-filter-${n.filterKey}` : "");
		U(() => n.modelValue, (e) => {
			e !== i.value && (i.value = e || "");
		});
		function o(e) {
			r("update:modelValue", e);
		}
		function s() {
			r("search", i.value), r("update:modelValue", i.value);
		}
		return (t, n) => (L(), A("div", { class: I(["h-filter-text", a.value]) }, [N(hn, {
			modelValue: i.value,
			"onUpdate:modelValue": [n[0] ||= (e) => i.value = e, o],
			placeholder: e.placeholder,
			density: "compact",
			variant: "outlined",
			"hide-details": "",
			"single-line": "",
			class: "h-filter-text-field",
			onKeyup: Et(s, ["enter"])
		}, {
			"prepend-inner": W(() => [N(J, { class: "h-filter-text-search-icon" }, {
				default: W(() => [...n[1] ||= [M("mdi:mdi-magnify", -1)]]),
				_: 1
			})]),
			_: 1
		}, 8, ["modelValue", "placeholder"])], 2));
	}
}), [["__scopeId", "data-v-1ba261a2"]]), Mv = { key: 1 }, Nv = {
	key: 0,
	class: "h-filter-select-checkbox-scroll-container"
}, Pv = {
	key: 1,
	class: "chip-list d-flex flex-wrap ga-1 py-1"
}, Fv = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "filter-select",
	props: {
		title: {},
		options: {},
		modelValue: {},
		type: {},
		icon: {},
		classPrefix: {},
		filterKey: {},
		selectLabel: {},
		multiple: { type: Boolean },
		clearable: { type: Boolean },
		buttonProps: {}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = G(e, "HFilterSelect"), r = et("adminFilterDesign", !1), { icon: i, type: a } = vt(n), o = D(() => n.classPrefix && n.filterKey ? `h-${n.classPrefix}-filter-${n.filterKey}` : ""), s = R(!1), c = R(n.multiple ? Array.isArray(n.modelValue) ? [...n.modelValue] : [] : n.modelValue == null ? [] : [n.modelValue]), l = R(n.multiple && Array.isArray(n.modelValue) ? [...n.modelValue] : []), u = R((n.multiple, null)), d = t, f = D(() => n.options.map((e) => ({
			title: e.label,
			value: e.value,
			raw: e,
			icon: e.icon,
			color: e.color
		}))), p = D(() => {
			if (n.multiple) return null;
			let e = c.value.length > 0 ? c.value[0] : null;
			return n.options.find((t) => t.value === e);
		}), m = D(() => c.value.length > 0), h = D({
			get: () => n.multiple ? l.value : u.value,
			set: (e) => {
				n.multiple ? l.value = e : u.value = e;
			}
		});
		U(() => n.modelValue, (e) => {
			if (n.multiple) JSON.stringify(e) !== JSON.stringify(c.value) && (c.value = Array.isArray(e) ? [...e] : [], l.value = Array.isArray(e) ? [...e] : []);
			else {
				let t = Array.isArray(e) ? e[0] : e, n = t == null ? [] : [t];
				JSON.stringify(n) !== JSON.stringify(c.value) && (c.value = n);
			}
		}, { deep: !0 }), U(s, (e) => {
			e && (n.multiple ? l.value = [...c.value] : n.type === "chip" ? l.value = c.value.length > 0 ? [...c.value] : [] : u.value = c.value.length > 0 ? c.value[0] : null);
		});
		function g(e) {
			return n.multiple ? l.value.includes(e) : l.value.length === 1 && l.value[0] === e;
		}
		function _(e) {
			let t = l.value.indexOf(e.value);
			t > -1 ? l.value.splice(t, 1) : l.value.push(e.value);
		}
		function v(e) {
			l.value[0] === e.value ? l.value = [] : l.value = [e.value];
		}
		function y(e) {
			let t = l.value.indexOf(e);
			t > -1 && l.value.splice(t, 1);
		}
		function b(e) {
			return g(e.value) ? e.color || "primary" : "default";
		}
		function x(e) {
			return e ? "on-surface" : void 0;
		}
		function S(e) {
			return e.color || "primary";
		}
		function C() {
			if (n.multiple) c.value = [...l.value], d("update:modelValue", l.value);
			else if (n.type === "chip") {
				let e = l.value.length > 0 ? l.value[0] : null;
				c.value = e == null ? [] : [e], d("update:modelValue", e);
			} else d("update:modelValue", u.value);
			s.value = !1;
		}
		function w(e) {
			e && e.stopPropagation(), c.value = [], l.value = [], u.value = null, d("update:modelValue", n.multiple ? [] : null);
		}
		function T() {
			w(), s.value = !1;
		}
		return (t, n) => {
			let l = pt("HActionButton");
			return L(), A("div", { class: I(["h-filter-select h-filter mr-2", o.value]) }, [N(Sn, {
				modelValue: s.value,
				"onUpdate:modelValue": n[1] ||= (e) => s.value = e,
				"close-on-content-click": !1,
				class: "h-filter-select-main-menu"
			}, {
				activator: W(({ props: t }) => [N(q, F(t, {
					class: ["filter-button h-filter-select-activator-btn", {
						"h-admin-filter-button": H(r),
						"h-admin-filter-button--active": H(r) && m.value,
						"h-admin-filter-button--open": H(r) && s.value
					}],
					"prepend-icon": H(i),
					size: e.buttonProps?.size || "default",
					variant: e.buttonProps?.variant || "flat",
					color: e.buttonProps?.color || "neutral-100"
				}), {
					append: W(() => [
						H(r) && m.value ? (L(), O(J, {
							key: 0,
							class: "h-admin-filter-selected-icon",
							icon: "mdi:mdi-check-circle"
						})) : k("", !0),
						e.clearable && m.value ? (L(), O(J, {
							key: 1,
							size: "large",
							class: "h-filter-select-clear-icon",
							onClick: Dt(w, ["stop"])
						}, {
							default: W(() => [...n[2] ||= [M(" mdi:mdi-close ", -1)]]),
							_: 1
						})) : k("", !0),
						N(J, { size: "large" }, {
							default: W(() => [M(V(s.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down"), 1)]),
							_: 1
						})
					]),
					default: W(() => [M(V(e.title) + " ", 1), m.value ? (L(), A(E, { key: 0 }, [e.multiple && c.value.length > 0 ? (L(), O(Jn, {
						key: 0,
						content: c.value.length,
						color: "error",
						inline: "",
						class: "ml-2"
					}, null, 8, ["content"])) : !e.multiple && p.value ? (L(), A("span", Mv, "(" + V(p.value.label) + ")", 1)) : k("", !0)], 64)) : k("", !0)]),
					_: 1
				}, 16, [
					"prepend-icon",
					"class",
					"size",
					"variant",
					"color"
				])]),
				default: W(() => [N(rn, {
					class: "filter-menu h-filter-select-menu-card",
					elevation: "1",
					rounded: "lg",
					"min-width": "300"
				}, {
					default: W(() => [
						N(cn, { class: "h-filter-select-menu-text pa-4" }, {
							default: W(() => [H(a) === "checkbox" ? (L(), A("div", Nv, [N(Bn, { class: "h-filter-select-checkbox-list pa-0" }, {
								default: W(() => [(L(!0), A(E, null, z(e.options, (t) => (L(), O(Hn, {
									key: t.value,
									class: "px-1 rounded",
									ripple: !1,
									active: !1,
									onClick: (n) => e.multiple ? _(t) : v(t)
								}, {
									prepend: W(() => [N(Zn, {
										"model-value": g(t.value),
										color: "primary",
										"hide-details": "",
										density: "compact",
										readonly: ""
									}, null, 8, ["model-value"])]),
									default: W(() => [N(Wn, { class: I(["text-body-large", { "font-weight-medium": g(t.value) }]) }, {
										default: W(() => [M(V(t.label), 1)]),
										_: 2
									}, 1032, ["class"])]),
									_: 2
								}, 1032, ["onClick"]))), 128))]),
								_: 1
							})])) : H(a) === "chip" ? (L(), A("div", Pv, [(L(!0), A(E, null, z(e.options, (t) => (L(), O(qn, {
								key: t.value,
								size: "small",
								color: b(t),
								class: I(["h-filter-select-chip-item", { "chip-active": g(t.value) }]),
								onClick: (n) => e.multiple ? _(t) : v(t)
							}, {
								default: W(() => [
									g(t.value) ? (L(), O(J, {
										key: 0,
										size: "x-small",
										class: "mr-1",
										color: x(!0)
									}, {
										default: W(() => [...n[3] ||= [M("mdi:mdi-check", -1)]]),
										_: 1
									}, 8, ["color"])) : k("", !0),
									j("span", { class: I({ "font-weight-medium": g(t.value) }) }, V(t.label), 3),
									e.multiple && g(t.value) ? (L(), O(J, {
										key: 1,
										size: "x-small",
										class: "ml-1",
										color: x(!0),
										onClick: Dt((e) => y(t.value), ["stop"])
									}, {
										default: W(() => [...n[4] ||= [M(" mdi:mdi-close ", -1)]]),
										_: 1
									}, 8, ["color", "onClick"])) : k("", !0)
								]),
								_: 2
							}, 1032, [
								"color",
								"class",
								"onClick"
							]))), 128))])) : H(a) === "autocomplete" ? (L(), O(_n, {
								key: 2,
								modelValue: h.value,
								"onUpdate:modelValue": n[0] ||= (e) => h.value = e,
								items: f.value,
								label: e.selectLabel,
								density: "compact",
								variant: "outlined",
								"hide-details": "",
								multiple: e.multiple,
								chips: e.multiple,
								"closable-chips": e.multiple,
								class: "h-filter-select-autocomplete"
							}, Ye({ _: 2 }, [e.multiple ? {
								name: "chip",
								fn: W(({ props: e, internalItem: t }) => [N(qn, F(e, {
									color: S(t.raw),
									size: "small"
								}), {
									default: W(() => [t.raw.icon ? (L(), O(J, {
										key: 0,
										size: "x-small",
										class: "mr-1"
									}, {
										default: W(() => [M(V(t.raw.icon), 1)]),
										_: 2
									}, 1024)) : k("", !0), M(" " + V(t.title), 1)]),
									_: 2
								}, 1040, ["color"])]),
								key: "0"
							} : void 0]), 1032, [
								"modelValue",
								"items",
								"label",
								"multiple",
								"chips",
								"closable-chips"
							])) : k("", !0)]),
							_: 1
						}),
						N(er),
						N(an, { class: "h-filter-select-actions pa-3" }, {
							default: W(() => [N(l, {
								type: "primary",
								size: "small",
								class: "h-filter-select-apply-btn text-uppercase",
								onClick: C
							}, {
								default: W(() => [M(V(H(K)("apply")), 1)]),
								_: 1
							}), N(l, {
								type: "neutral",
								size: "small",
								class: "h-filter-select-clear-all-btn text-uppercase",
								onClick: T
							}, {
								default: W(() => [M(V(H(K)("clear_all")), 1)]),
								_: 1
							})]),
							_: 1
						})
					]),
					_: 1
				})]),
				_: 1
			}, 8, ["modelValue"])], 2);
		};
	}
}), [["__scopeId", "data-v-96485e31"]]), Iv = { class: "d-flex align-center justify-space-between ga-4" }, Lv = { class: "text-body-medium h-filter-switch-menu-label" }, Rv = /* @__PURE__ */ P({
	__name: "filter-switch",
	props: /*@__PURE__*/ rt({
		title: {},
		icon: { default: "mdi:mdi-filter-variant" },
		classPrefix: { default: void 0 },
		filterKey: { default: "" }
	}, {
		modelValue: {
			type: [Boolean, null],
			default: null
		},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = G(e, "HFilterSwitch"), n = et("adminFilterDesign", !1), { icon: r, title: i } = vt(t), a = xt(e, "modelValue"), o = R(!1), s = R(!1), c = D(() => t.classPrefix && t.filterKey ? `h-${t.classPrefix}-filter-${t.filterKey}` : ""), l = D(() => a.value !== null && a.value !== void 0), u = D(() => a.value === !0 ? K("yes") : a.value === !1 ? K("no") : "");
		function d() {
			s.value = a.value === !0 || a.value === !1;
		}
		U(a, () => {
			o.value || d();
		}), U(o, (e) => {
			e && d();
		});
		function f(e) {
			return e ? a.value !== !1 : null;
		}
		function p(e) {
			s.value = !!e, a.value = f(!!e);
		}
		function m() {
			o.value = !1;
		}
		function h(e) {
			e && e.stopPropagation(), s.value = !1, a.value = null, o.value = !1;
		}
		return d(), (e, t) => (L(), A("div", { class: I(["h-filter-switch h-filter mr-2", c.value]) }, [N(Sn, {
			modelValue: o.value,
			"onUpdate:modelValue": t[0] ||= (e) => o.value = e,
			"close-on-content-click": !1,
			class: "h-filter-switch-main-menu"
		}, {
			activator: W(({ props: e }) => [N(q, F(e, {
				class: ["filter-button h-filter-switch-activator-btn", {
					"h-admin-filter-button": H(n),
					"h-admin-filter-button--active": H(n) && l.value,
					"h-admin-filter-button--open": H(n) && o.value
				}],
				variant: "outlined",
				"prepend-icon": H(r),
				color: l.value ? "primary" : void 0,
				size: "small"
			}), Ye({
				default: W(() => [M(V(H(i)) + " " + V(l.value ? `(${u.value})` : "") + " ", 1), l.value ? (L(), O(J, {
					key: 0,
					size: "large",
					class: "ml-1 clear-icon h-filter-switch-clear-icon",
					onClick: h
				}, {
					default: W(() => [...t[1] ||= [M(" mdi:mdi-close ", -1)]]),
					_: 1
				})) : k("", !0)]),
				_: 2
			}, [H(n) ? {
				name: "append",
				fn: W(() => [l.value ? (L(), O(J, {
					key: 0,
					class: "h-admin-filter-selected-icon",
					icon: "mdi:mdi-check-circle"
				})) : k("", !0), N(J, { icon: o.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" }, null, 8, ["icon"])]),
				key: "0"
			} : void 0]), 1040, [
				"prepend-icon",
				"class",
				"color"
			])]),
			default: W(() => [N(rn, {
				class: "filter-menu h-filter-switch-menu-card",
				elevation: "1",
				rounded: "lg",
				"min-width": "240"
			}, {
				default: W(() => [N(cn, { class: "pa-4 h-filter-switch-menu-text" }, {
					default: W(() => [j("div", Iv, [j("span", Lv, V(H(i)), 1), N(bn, {
						"model-value": s.value,
						class: "h-filter-switch-menu-switch",
						density: "compact",
						"hide-details": "",
						inset: "",
						color: "primary",
						"aria-label": H(i),
						"onUpdate:modelValue": p
					}, null, 8, ["model-value", "aria-label"])])]),
					_: 1
				}), N(an, null, {
					default: W(() => [N(q, {
						size: "small",
						color: "primary",
						class: "h-filter-switch-apply-btn",
						onClick: m
					}, {
						default: W(() => [M(V(H(K)("apply")), 1)]),
						_: 1
					}), N(q, {
						size: "small",
						variant: "text",
						class: "mr-2 h-filter-switch-clear-btn",
						onClick: h
					}, {
						default: W(() => [M(V(H(K)("clear")), 1)]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}, 8, ["modelValue"])], 2));
	}
}), zv = /*#__PURE__*/ Y({
	__name: "description-table-cell",
	props: {
		value: {
			type: String,
			default: ""
		},
		classPrefix: {
			type: String,
			default: ""
		}
	},
	setup(e) {
		let t = G(e, "HDescriptionTableCell"), n = D(() => t.classPrefix ? `h-${t.classPrefix}-table-cell-description` : ""), r = R(!1);
		function i() {
			r.value = !0;
		}
		return (t, a) => e.value ? (L(), A("span", {
			key: 0,
			class: I(n.value)
		}, [N(un, {
			location: "top",
			class: "h-description-cell-tooltip"
		}, {
			activator: W(({ props: e }) => [N(q, F(e, {
				icon: "mdi:mdi-message-text",
				variant: "text",
				size: "small",
				class: "h-description-cell-btn",
				"aria-label": H(K)("click_to_view_description"),
				onClick: i
			}), null, 16, ["aria-label"])]),
			default: W(() => [j("span", null, V(H(K)("click_to_view_description")), 1)]),
			_: 1
		}), N(nr, {
			modelValue: r.value,
			"onUpdate:modelValue": a[1] ||= (e) => r.value = e,
			"max-width": "600"
		}, {
			default: W(() => [N(rn, null, {
				default: W(() => [N(ln, { class: "text-headline-medium d-flex justify-space-between align-center" }, {
					default: W(() => [M(V(H(K)("description")) + " ", 1), N(q, {
						icon: "mdi:mdi-close",
						variant: "text",
						onClick: a[0] ||= (e) => r.value = !1
					})]),
					_: 1
				}), N(cn, { class: "description-content" }, {
					default: W(() => [M(V(e.value), 1)]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}, 8, ["modelValue"])], 2)) : k("", !0);
	}
}, [["__scopeId", "data-v-dd0687e5"]]), Bv = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "chip-group-table-cell",
	props: {
		value: { default: () => [] },
		filterOnClick: {
			type: Function,
			default: void 0
		},
		isFilterActive: {
			type: Function,
			default: () => !1
		},
		classPrefix: { default: "" },
		cellKey: { default: "" },
		column: {
			type: Boolean,
			default: !1
		},
		maxVisible: { default: 2 }
	},
	setup(e) {
		let t = G(e, "HChipGroupTableCell"), n = R(!1), r = et("adminResponsiveChips", !1), i = R(), { width: a } = Mn(i), o = R([]), s = () => {
			let e = i.value?.querySelector(".v-chip");
			if (!r || !e) return;
			let n = getComputedStyle(e), a = document.createElement("canvas").getContext("2d");
			if (!a) return;
			a.font = `${n.fontWeight} ${n.fontSize} ${n.fontFamily}`;
			let s = parseFloat(n.paddingLeft) + parseFloat(n.paddingRight) + 2;
			o.value = t.value.map((e) => a.measureText(String(e)).width + s);
		};
		lt(async () => {
			s(), await document.fonts?.ready, s();
		}), U(() => t.value, s, {
			deep: !0,
			flush: "post"
		});
		let c = D(() => {
			if (!r || !a.value || o.value.length !== t.value.length) return t.maxVisible;
			if (o.value.reduce((e, t) => e + t, 0) + Math.max(0, t.value.length - 1) * 4 <= a.value) return t.value.length;
			let e = 0, n = 0;
			for (let r of o.value) {
				let i = e + (n ? 4 : 0) + r;
				if (i + (n < t.value.length - 1 ? 44 : 0) > a.value) break;
				e = i, n++;
			}
			return Math.max(1, n);
		}), l = D(() => n.value || t.value.length <= c.value ? t.value : t.value.slice(0, c.value)), u = D(() => Math.max(0, t.value.length - c.value)), d = D(() => t.classPrefix && t.cellKey ? `h-${t.classPrefix}-table-cell-${t.cellKey}` : "");
		return (r, a) => {
			let o = pt("h-chip-table-cell");
			return L(), A("div", {
				ref_key: "container",
				ref: i,
				class: I(["h-chip-group-cell", [d.value, { "h-chip-group-cell--expanded": n.value }]])
			}, [
				(L(!0), A(E, null, z(l.value, (t) => (L(), O(o, {
					key: t,
					value: t,
					color: e.isFilterActive(t) ? "purple-lighten-2" : "tag-default",
					"filter-on-click": e.filterOnClick,
					"is-filter-active": e.isFilterActive,
					"overflow-tooltip": ""
				}, null, 8, [
					"value",
					"color",
					"filter-on-click",
					"is-filter-active"
				]))), 128)),
				u.value > 0 && !n.value ? (L(), O(qn, {
					key: 0,
					size: "small",
					color: "grey-lighten-1",
					variant: "tonal",
					class: "h-chip-group-cell__overflow",
					onClick: a[0] ||= Dt((e) => n.value = !0, ["stop"])
				}, {
					default: W(() => [M(" +" + V(u.value) + " › ", 1)]),
					_: 1
				})) : k("", !0),
				n.value && H(t).value.length > c.value ? (L(), O(qn, {
					key: 1,
					size: "small",
					color: "grey-lighten-1",
					variant: "tonal",
					class: "h-chip-group-cell__overflow",
					onClick: a[1] ||= Dt((e) => n.value = !1, ["stop"])
				}, {
					default: W(() => [...a[2] ||= [M(" ‹ ", -1)]]),
					_: 1
				})) : k("", !0)
			], 2);
		};
	}
}), [["__scopeId", "data-v-57471b07"]]), Vv = {
	key: 0,
	class: "h-chip-table-cell"
}, Hv = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "chip-table-cell",
	props: {
		value: { default: "" },
		item: { default: void 0 },
		color: { default: "default" },
		icon: { default: void 0 },
		getColor: {
			type: Function,
			default: void 0
		},
		getIcon: {
			type: Function,
			default: void 0
		},
		formatCell: {
			type: Function,
			default: void 0
		},
		filterOnClick: {
			type: Function,
			default: void 0
		},
		isFilterActive: {
			type: Function,
			default: void 0
		},
		classPrefix: { default: "" },
		cellKey: { default: "" },
		overflowTooltip: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let t = G(e, "HChipTableCell"), n = R(null), r = R(!1), i = null, a = D(() => t.formatCell ? t.formatCell(t.value) : typeof t.value == "string" ? t.value : t.value?.name || ""), o = D(() => t.classPrefix && t.cellKey ? `h-${t.classPrefix}-table-cell-${t.cellKey}` : ""), s = D(() => t.getColor && t.value ? t.getColor(t.value) : t.color), c = D(() => t.getIcon && t.value ? t.getIcon(t.value) : t.icon), l = D(() => t.isFilterActive && t.value ? t.isFilterActive(t.value) : !1), u = D(() => typeof t.filterOnClick == "function"), d = D(() => t.overflowTooltip || r.value);
		function f() {
			let e = n.value;
			return e ? e instanceof HTMLElement ? e : e.$el instanceof HTMLElement ? e.$el : null : null;
		}
		function p() {
			let e = f(), t = e?.querySelector(".v-chip__content") ?? e;
			if (!(t instanceof HTMLElement)) {
				r.value = !1;
				return;
			}
			r.value = t.scrollWidth > t.clientWidth + 1;
		}
		function m() {
			i?.disconnect();
			let e = f();
			!e || typeof ResizeObserver > "u" || (i = new ResizeObserver(() => p()), i.observe(e));
		}
		function h() {
			t.filterOnClick && t.value && t.filterOnClick(t.value);
		}
		return lt(async () => {
			await it(), p(), m(), window.addEventListener("resize", p);
		}), U(a, async () => {
			await it(), p();
		}), st(() => {
			window.removeEventListener("resize", p), i?.disconnect(), i = null;
		}), (e, t) => a.value ? (L(), A("span", Vv, [N(qn, {
			ref_key: "chipRef",
			ref: n,
			size: "small",
			color: s.value,
			"aria-label": a.value,
			role: u.value ? "button" : void 0,
			tabindex: u.value ? 0 : void 0,
			class: I([{
				"font-weight-bold": l.value,
				"h-datatable__field": u.value
			}, o.value]),
			onClick: h,
			onKeydown: [Et(h, ["enter"]), Et(Dt(h, ["prevent"]), ["space"])]
		}, {
			default: W(() => [c.value ? (L(), O(J, {
				key: 0,
				left: "",
				class: "mr-2"
			}, {
				default: W(() => [M(V(c.value), 1)]),
				_: 1
			})) : k("", !0), M(" " + V(a.value), 1)]),
			_: 1
		}, 8, [
			"color",
			"aria-label",
			"role",
			"tabindex",
			"class",
			"onKeydown"
		]), N(un, {
			activator: "parent",
			location: "top",
			text: a.value,
			disabled: !d.value
		}, null, 8, ["text", "disabled"])])) : k("", !0);
	}
}), [["__scopeId", "data-v-fbcd6874"]]), Uv = /* @__PURE__ */ P({
	__name: "btn-table-cell",
	props: {
		value: {
			type: [
				Boolean,
				String,
				Number
			],
			default: void 0
		},
		item: { default: void 0 },
		icon: { default: void 0 },
		color: { default: void 0 },
		getIcon: {
			type: Function,
			default: void 0
		},
		getColor: {
			type: Function,
			default: void 0
		},
		variant: { default: "text" },
		size: { default: "small" },
		filterOnClick: {
			type: Function,
			default: void 0
		},
		isFilterActive: {
			type: Function,
			default: void 0
		},
		classPrefix: { default: "" },
		cellKey: { default: "" }
	},
	setup(e) {
		let t = G(e, "HBtnTableCell"), n = D(() => t.classPrefix && t.cellKey ? `h-${t.classPrefix}-table-cell-${t.cellKey}` : ""), r = D(() => t.getIcon && t.item ? t.getIcon(t.item) : t.icon || "mdi:mdi-help-circle"), i = D(() => t.getColor && t.item ? t.getColor(t.item) : t.color || "grey"), a = D(() => t.isFilterActive && t.item ? t.isFilterActive(t.item) : !1), o = D(() => typeof t.filterOnClick == "function");
		function s() {
			t.filterOnClick && t.item && t.filterOnClick(t.item);
		}
		return (t, c) => e.value !== void 0 && e.value !== null ? (L(), O(q, {
			key: 0,
			icon: r.value,
			color: i.value,
			variant: e.variant,
			size: e.size,
			"aria-label": H(K)(e.cellKey),
			class: I([{
				"font-weight-bold": a.value,
				"h-datatable__field": o.value
			}, n.value]),
			onClick: Dt(s, ["stop"])
		}, {
			default: W(() => [N(J, { color: i.value }, {
				default: W(() => [M(V(r.value), 1)]),
				_: 1
			}, 8, ["color"])]),
			_: 1
		}, 8, [
			"icon",
			"color",
			"variant",
			"size",
			"aria-label",
			"class"
		])) : k("", !0);
	}
}), Wv = ["title"], Gv = { class: "h-pre-code-content" }, Kv = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "pre-code-table-cell",
	props: {
		value: { default: void 0 },
		formatCell: {
			type: Function,
			default: void 0
		},
		classPrefix: { default: "" },
		cellKey: { default: "" }
	},
	setup(e) {
		let t = G(e, "HPreCodeTableCell"), n = R(!1), r = D(() => t.value ? t.formatCell ? t.formatCell(t.value) : typeof t.value == "object" ? JSON.stringify(t.value, null, 2) : t.value : ""), i = D(() => t.classPrefix && t.cellKey ? `h-${t.classPrefix}-table-cell-${t.cellKey}` : "");
		return (e, t) => r.value ? (L(), A("div", {
			key: 0,
			class: I([
				"h-pre-code-table-cell",
				i.value,
				{ "h-pre-code-table-cell--expanded": n.value }
			]),
			style: { cursor: "pointer" },
			title: n.value ? "" : r.value,
			role: "button",
			tabindex: "0",
			onClick: t[0] ||= (e) => n.value = !n.value,
			onKeydown: t[1] ||= Et((e) => n.value = !n.value, ["enter"])
		}, [j("pre", Gv, V(r.value), 1)], 42, Wv)) : k("", !0);
	}
}), [["__scopeId", "data-v-e369f4cc"]]), qv = /* @__PURE__ */ P({
	__name: "level-options",
	props: {
		modelValue: { default: null },
		options: { default: () => [
			{
				title: "All",
				value: null
			},
			{
				title: "INFO",
				value: "INFO"
			},
			{
				title: "DEBUG",
				value: "DEBUG"
			},
			{
				title: "WARNING",
				value: "WARNING"
			},
			{
				title: "ERROR",
				value: "ERROR"
			}
		] }
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = Rn(e, "modelValue", t);
		return (t, r) => (L(), O(gn, {
			modelValue: H(n),
			"onUpdate:modelValue": r[0] ||= (e) => tt(n) ? n.value = e : null,
			class: "c-system-logs-level-options",
			items: e.options,
			"item-title": "title",
			"item-value": "value",
			"aria-label": H(K)("level"),
			clearable: "",
			placeholder: H(K)("level")
		}, null, 8, [
			"modelValue",
			"items",
			"aria-label",
			"placeholder"
		]));
	}
}), Jv = /* @__PURE__ */ P({
	__name: "source-options",
	props: {
		modelValue: { default: () => [] },
		options: { default: () => [{
			title: "API",
			value: "api"
		}, {
			title: "Worker",
			value: "worker"
		}] }
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = Rn(e, "modelValue", t);
		return (t, r) => (L(), O(gn, {
			modelValue: H(n),
			"onUpdate:modelValue": r[0] ||= (e) => tt(n) ? n.value = e : null,
			class: "c-admin-logs-source-options",
			items: e.options,
			"item-title": "title",
			"item-value": "value",
			"aria-label": H(K)("source"),
			multiple: "",
			placeholder: H(K)("source")
		}, null, 8, [
			"modelValue",
			"items",
			"aria-label",
			"placeholder"
		]));
	}
}), Yv = { class: "c-system-logs-table__header" }, Xv = { class: "c-system-logs-table__row-header" }, Zv = { class: "c-system-logs-table-header__message" }, Qv = { class: "c-system-logs-table-header__timestamp" }, $v = { class: "c-system-logs-table-header__log-level" }, ey = { class: "c-system-logs-table-header__source" }, ty = { class: "c-system-logs-table__body" }, ny = { class: "c-system-logs-table-body__message" }, ry = { class: "c-system-logs-table-body__timestamp" }, iy = { class: "c-system-logs-table-body__log-level" }, ay = { class: "c-system-logs-table-body__source" }, oy = {
	key: 0,
	class: "c-system-logs-table__empty-body"
}, sy = {
	colspan: "4",
	class: "c-system-logs-table-body__empty"
}, cy = /* @__PURE__ */ P({
	__name: "logs-table",
	props: { logs: { default: () => [] } },
	setup(e) {
		let { formatDate: t } = Gt();
		function n(e) {
			switch (e?.toUpperCase()) {
				case "ERROR": return "bg-error";
				case "WARNING":
				case "WARN": return "bg-warning";
				case "DEBUG": return "bg-tertiary";
				default: return "bg-primary";
			}
		}
		return (r, i) => (L(), O(rr, { class: "c-system-logs-table" }, {
			default: W(() => [j("thead", Yv, [j("tr", Xv, [
				j("th", Zv, V(H(K)("message")), 1),
				j("th", Qv, V(H(K)("timestamp")), 1),
				j("th", $v, V(H(K)("level")), 1),
				j("th", ey, V(H(K)("source")), 1)
			])]), j("tbody", ty, [(L(!0), A(E, null, z(e.logs, (e) => (L(), A("tr", {
				key: `${e["@timestamp"]}-${e.message}`,
				class: "c-system-logs-table__row-body"
			}, [
				j("td", ny, V(e.message), 1),
				j("td", ry, V(H(t)(e["@timestamp"])), 1),
				j("td", iy, [N(qn, { class: I(["c-system-log-level", n(e["log.level"])]) }, {
					default: W(() => [M(V(e["log.level"]), 1)]),
					_: 2
				}, 1032, ["class"])]),
				j("td", ay, V(e.name), 1)
			]))), 128)), e.logs?.length ? k("", !0) : (L(), A("tr", oy, [j("td", sy, V(H(K)("no_data_available")), 1)]))])]),
			_: 1
		}));
	}
}), ly = /* @__PURE__ */ P({
	__name: "from-date-options",
	props: {
		modelValue: { default: 300 },
		options: { default: () => [
			{
				title: K("admin_logs_last_5_minutes"),
				value: 300
			},
			{
				title: K("admin_logs_last_30_minutes"),
				value: 1800
			},
			{
				title: K("admin_logs_last_1_hour"),
				value: 3600
			},
			{
				title: K("admin_logs_last_4_hours"),
				value: 14400
			},
			{
				title: K("admin_logs_last_8_hours"),
				value: 28800
			},
			{
				title: K("admin_logs_last_1_day"),
				value: 86400
			},
			{
				title: K("admin_logs_last_3_days"),
				value: 259200
			}
		] }
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = Rn(e, "modelValue", t);
		return (t, r) => (L(), O(gn, {
			modelValue: H(n),
			"onUpdate:modelValue": r[0] ||= (e) => tt(n) ? n.value = e : null,
			class: "c-admin-logs-from-date-options",
			items: e.options,
			"item-title": "title",
			"item-value": "value",
			"aria-label": H(K)("admin_logs_time_range"),
			placeholder: H(K)("admin_logs_time_range")
		}, null, 8, [
			"modelValue",
			"items",
			"aria-label",
			"placeholder"
		]));
	}
}), uy = { class: "h-themepack-provider" }, dy = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "themepack-provider",
	setup(e) {
		let t = ar(), { hThemePack: n, hSetThemePack: r } = Xt(), i = On(), { defaults: a } = Zt();
		return U([() => n?.value?.name, () => i?.meta?.theme], ([e, n]) => {
			let i = !!n, a = n || e;
			a && (t.change(a), i && r(a, { temporary: !0 }));
		}, { immediate: !0 }), (e, t) => (L(), A("div", uy, [N(or, { defaults: H(a) }, {
			default: W(() => [B(e.$slots, "default", {}, void 0, !0)]),
			_: 3
		}, 8, ["defaults"])]));
	}
}), [["__scopeId", "data-v-9d7cf0df"]]), fy = { class: "text-body-medium font-weight-medium text-medium-emphasis" }, py = { class: "text-body-medium font-weight-semibold" }, my = /* @__PURE__ */ P({
	__name: "info-display",
	props: {
		variant: { default: "list" },
		title: {},
		description: {},
		avatar: {},
		avatarColor: { default: "#9dd5d6" },
		chipColor: { default: "#835400" },
		chipTextColor: { default: "white" },
		actionType: { default: "primary" },
		items: { default: () => [] }
	},
	setup(e) {
		return G(e, "HInfoDisplay"), (t, n) => (L(), O(fn, { class: I(["h-info-display pa-0", `h-info-display--${e.variant}`]) }, {
			default: W(() => [
				e.title || e.avatar ? (L(), O(pn, {
					key: 0,
					class: "h-info-display__header mb-0"
				}, {
					default: W(() => [N(dn, { cols: "12" }, {
						default: W(() => [B(t.$slots, "header", {
							title: e.title,
							description: e.description,
							avatar: e.avatar
						}, () => [N(pn, { class: "align-center ga-4 ma-0 mb-0" }, {
							default: W(() => [e.avatar ? (L(), O(dn, {
								key: 0,
								cols: "auto",
								class: "pa-0"
							}, {
								default: W(() => [B(t.$slots, "avatar", {
									avatar: e.avatar,
									avatarColor: e.avatarColor
								}, () => [N(tr, {
									size: "48",
									color: e.avatarColor,
									class: "h-info-display__avatar text-headline-small font-weight-medium"
								}, {
									default: W(() => [M(V(e.avatar), 1)]),
									_: 1
								}, 8, ["color"])])]),
								_: 3
							})) : k("", !0), e.title ? (L(), O(dn, {
								key: 1,
								cols: "auto",
								class: "text-headline-medium font-weight-semibold pa-0"
							}, {
								default: W(() => [B(t.$slots, "title", { title: e.title }, () => [M(V(e.title), 1)])]),
								_: 3
							})) : k("", !0)]),
							_: 3
						})])]),
						_: 3
					})]),
					_: 3
				})) : k("", !0),
				e.description ? (L(), O(pn, {
					key: 1,
					class: "h-info-display__description mb-0"
				}, {
					default: W(() => [N(dn, {
						cols: "12",
						class: "text-headline-small font-weight-regular"
					}, {
						default: W(() => [B(t.$slots, "description", { description: e.description }, () => [M(V(e.description), 1)])]),
						_: 3
					})]),
					_: 3
				})) : k("", !0),
				e.items && e.items.length > 0 ? (L(), O(fn, {
					key: 2,
					class: "h-info-display__items pa-0"
				}, {
					default: W(() => [(L(!0), A(E, null, z(e.items, (n, r) => (L(), A(E, { key: r }, [N(pn, { class: "h-info-display__item align-center py-3 ma-0" }, {
						default: W(() => [B(t.$slots, "item", { item: n }, () => [N(fn, { class: "pa-0" }, {
							default: W(() => [N(pn, {
								class: "align-center ma-0",
								style: { gap: "8px" }
							}, {
								default: W(() => [
									N(dn, {
										cols: "auto",
										class: "d-flex align-center pa-0",
										style: {
											"min-width": "150px",
											gap: "8px"
										}
									}, {
										default: W(() => [B(t.$slots, "item-icon", { item: n }, () => [n.icon ? (L(), O(J, {
											key: 0,
											size: "20",
											color: "medium-emphasis",
											class: "h-info-display__icon"
										}, {
											default: W(() => [M(V(n.icon), 1)]),
											_: 2
										}, 1024)) : k("", !0)]), B(t.$slots, "item-label", { item: n }, () => [j("span", fy, V(n.label), 1)])]),
										_: 2
									}, 1024),
									N(dn, {
										cols: "auto",
										class: "pa-0"
									}, {
										default: W(() => [B(t.$slots, "item-value", { item: n }, () => [j("span", py, V(n.value), 1)])]),
										_: 2
									}, 1024),
									n.chip ? (L(), O(dn, {
										key: 0,
										cols: "auto",
										class: "pa-0"
									}, {
										default: W(() => [B(t.$slots, "item-chip", { item: n }, () => [N(qn, {
											color: n.chip.color || e.chipColor,
											size: "small",
											class: "h-info-display__chip",
											style: ot({ color: n.chip.textColor || e.chipTextColor })
										}, {
											default: W(() => [n.chip.icon ? (L(), O(J, {
												key: 0,
												start: "",
												size: "15"
											}, {
												default: W(() => [M(V(n.chip.icon), 1)]),
												_: 2
											}, 1024)) : k("", !0), M(" " + V(n.chip.text), 1)]),
											_: 2
										}, 1032, ["color", "style"])])]),
										_: 2
									}, 1024)) : k("", !0),
									n.actions ? (L(), O(dn, {
										key: 1,
										cols: "auto",
										class: "ml-auto pa-0"
									}, {
										default: W(() => [B(t.$slots, "item-actions", { item: n }, () => [N(fn, { class: "pa-0" }, {
											default: W(() => [N(pn, {
												class: "ma-0",
												style: { gap: "8px" }
											}, {
												default: W(() => [(L(!0), A(E, null, z(Array.isArray(n.actions) ? n.actions : [n.actions], (t, n) => (L(), O(dn, {
													key: n,
													cols: "auto",
													class: "pa-0"
												}, {
													default: W(() => [N(gl, {
														type: t.type || e.actionType,
														color: t.color,
														size: "small",
														class: "h-info-display__action",
														onClick: t.onClick
													}, {
														default: W(() => [t.icon ? (L(), O(J, {
															key: 0,
															start: "",
															size: "16"
														}, {
															default: W(() => [M(V(t.icon), 1)]),
															_: 2
														}, 1024)) : k("", !0), M(" " + V(t.text), 1)]),
														_: 2
													}, 1032, [
														"type",
														"color",
														"onClick"
													])]),
													_: 2
												}, 1024))), 128))]),
												_: 2
											}, 1024)]),
											_: 2
										}, 1024)])]),
										_: 2
									}, 1024)) : k("", !0)
								]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)])]),
						_: 2
					}, 1024), r < e.items.length - 1 ? (L(), O(pn, {
						key: 0,
						class: "h-info-display__divider ma-0"
					}, {
						default: W(() => [N(dn, {
							cols: "12",
							class: "pa-0"
						}, {
							default: W(() => [N(er, { opacity: .3 })]),
							_: 1
						})]),
						_: 1
					})) : k("", !0)], 64))), 128))]),
					_: 3
				})) : (L(), O(pn, {
					key: 3,
					class: "h-info-display__empty"
				}, {
					default: W(() => [N(dn, {
						cols: "12",
						class: "text-body-medium text-medium-emphasis text-center py-6"
					}, {
						default: W(() => [B(t.$slots, "empty", {}, () => [M(V(H(K)("info_display_empty_state")), 1)])]),
						_: 3
					})]),
					_: 3
				}))
			]),
			_: 3
		}, 8, ["class"]));
	}
}), hy = { class: "h-live-updates d-flex" }, gy = {
	key: 0,
	class: "h-live-updates-interval-option"
}, _y = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "live-update-controls",
	props: {
		interval: {},
		isLiveUpdatesEnabled: {
			type: Boolean,
			default: () => !0
		},
		items: { default: () => [
			{
				title: K("n_seconds", { seconds: 1 }),
				value: 1e3
			},
			{
				title: K("n_seconds", { seconds: 2 }),
				value: 2e3
			},
			{
				title: K("n_seconds", { seconds: 5 }),
				value: 5e3
			},
			{
				title: K("n_seconds", { seconds: 30 }),
				value: 3e4
			},
			{
				title: K("n_minutes", { minutes: 1 }),
				value: 6e4
			},
			{
				title: K("n_minutes", { minutes: 5 }),
				value: 3e5
			}
		] }
	},
	emits: [
		"update:interval",
		"update:isLiveUpdatesEnabled",
		"interval-trigger"
	],
	setup(e, { emit: t }) {
		let n = G(e, "HLiveUpdateControls"), r = t, { interval: i, isLiveUpdatesEnabled: a } = zn(n, r), o = D(() => u.value ? "mdi:mdi-pause" : "mdi:mdi-play"), s = D(() => u.value ? K("pause_live_updates") : K("resume_live_updates")), { pause: c, resume: l, isActive: u } = Pn(() => {
			r("interval-trigger");
		}, i, { immediate: a.value }), d = () => {
			u.value ? c() : l(), a.value = u.value;
		};
		return (t, n) => (L(), A("div", hy, [N(q, {
			class: "h-live-updates__btn",
			"aria-label": s.value,
			onClick: d
		}, {
			default: W(() => [N(J, {
				class: "h-live-updates__btn-icon",
				icon: o.value
			}, null, 8, ["icon"])]),
			_: 1
		}, 8, ["aria-label"]), N(gn, {
			modelValue: H(i),
			"onUpdate:modelValue": n[0] ||= (e) => tt(i) ? i.value = e : null,
			class: "h-live-updates__interval-options",
			items: e.items,
			"aria-label": H(K)("update_interval")
		}, {
			selection: W(({ item: e }) => [e ? (L(), A("span", gy, V(H(K)("update_every_n", { value: e.title })), 1)) : k("", !0)]),
			_: 1
		}, 8, [
			"modelValue",
			"items",
			"aria-label"
		])]));
	}
}), [["__scopeId", "data-v-37f206d9"]]), vy = {
	key: 0,
	class: "h-alert__actions d-flex flex-wrap"
}, yy = {
	key: 0,
	class: "d-flex flex-wrap mt-2"
}, by = { class: "d-flex align-center" }, xy = { class: "d-flex ml-auto mr-0 justify-end" }, Sy = /* @__PURE__ */ P({
	__name: "alert-bar",
	props: { alert: {} },
	setup(e) {
		let t = G(e, "HAlertBar"), { smAndUp: n } = ir(), r = R(!!t.alert.hasTimedOut);
		In(() => {
			r.value = !0, t.alert.hasTimedOut = !0;
		}, () => t.alert.timeout || 0, { immediate: !!t.alert.timeout && !t.alert.hasTimedOut });
		let i = D(() => t.alert.details?.isCode ? "h-pretty-code" : "div"), a = D(() => {
			let e = t.alert.details?.additionalInfo;
			if (e == null) return "";
			if (typeof e == "string") return e;
			try {
				return JSON.stringify(e, null, 2);
			} catch {
				return String(e);
			}
		}), o = R(t.alert.details?.description ? void 0 : 0), s = D({
			get: () => t.alert.isShowingDetails,
			set: (e) => {
				t.alert.isShowingDetails = e;
			}
		});
		function c() {
			s.value = !1;
		}
		function l(e) {
			e.willShowDetailsOnClick && (s.value = !0), e.onClick && e.onClick();
		}
		function u() {
			t.alert.isClosed = !0;
		}
		async function d() {
			a.value && await navigator.clipboard.writeText(a.value);
		}
		return (t, f) => {
			let p = pt("h-theme-scope"), m = pt("h-pretty-code");
			return L(), A(E, null, [(!e.alert.timeout || !r.value) && !e.alert.hasTimedOut && !e.alert.isClosed ? (L(), O(fr, F({ key: 0 }, t.$attrs, {
				key: e.alert.id,
				class: "h-alert",
				type: e.alert.type,
				closable: e.alert.closable ?? !0,
				"onClick:close": f[0] ||= (e) => u()
			}), {
				title: W(() => [
					j("div", null, V(e.alert.title), 1),
					N(mn, { class: "h-alert-bar-title-spacer" }),
					H(n) ? (L(), A("div", vy, [(L(!0), A(E, null, z(e.alert.actions, (e) => (L(), O(p, {
						key: e.text,
						name: "HScopedAlertBarDesktopActionBtn",
						component: H(lr),
						class: "h-alert__action",
						href: e.href,
						target: e.target,
						color: e.buttonColor,
						variant: e.buttonVariant,
						density: "comfortable",
						onClick: (t) => l(e)
					}, {
						default: W(() => [M(V(e.text), 1)]),
						_: 2
					}, 1032, [
						"component",
						"href",
						"target",
						"color",
						"variant",
						"onClick"
					]))), 128))])) : k("", !0)
				]),
				text: W(() => [j("div", null, [j("div", null, V(e.alert.body), 1), H(n) ? k("", !0) : (L(), A("div", yy, [(L(!0), A(E, null, z(e.alert.actions, (e) => (L(), O(p, {
					key: e.text,
					name: "HScopedAlertBarMobileActionBtn",
					component: H(lr),
					class: "h-alert__action",
					href: e.href,
					target: e.target,
					color: e.buttonColor,
					variant: e.buttonVariant,
					density: "comfortable",
					onClick: (t) => l(e)
				}, {
					default: W(() => [M(V(e.text), 1)]),
					_: 2
				}, 1032, [
					"component",
					"href",
					"target",
					"color",
					"variant",
					"onClick"
				]))), 128))]))])]),
				_: 1
			}, 16, ["type", "closable"])) : k("", !0), N(nr, {
				modelValue: s.value,
				"onUpdate:modelValue": f[4] ||= (e) => s.value = e,
				class: "h-alert-details__dialog"
			}, {
				default: W(() => [N(rn, {
					class: "h-alert-details",
					color: e.alert.type
				}, {
					default: W(() => [N(ln, { class: "h-alert-bar-details-title" }, {
						default: W(() => [j("div", by, [j("div", null, V(e.alert.details?.title), 1), j("div", xy, [e.alert.canCopy ? (L(), O(H(lr), {
							key: 0,
							icon: "fa fa-copy",
							variant: "text",
							class: "h-alert-bar-details-copy-btn d-block text-body-large",
							onClick: f[1] ||= (e) => d()
						})) : k("", !0), N(H(lr), {
							icon: "fa fa-times",
							variant: "text",
							class: "h-alert-bar-details-close-btn d-block ml-2 text-body-large",
							onClick: f[2] ||= (e) => c()
						})])])]),
						_: 1
					}), N(cn, { class: "h-alert-bar-details-text pa-3" }, {
						default: W(() => [e.alert.details?.description ? (L(), O(pn, {
							key: 0,
							class: "h-alert-bar-details-row"
						}, {
							default: W(() => [N(dn, { class: "h-alert-bar-details-col" }, {
								default: W(() => [(L(), O(mt(i.value), {
									class: "h-alert-details__message",
									language: e.alert.details?.codeLanguage
								}, {
									default: W(() => [M(V(e.alert.details.description), 1)]),
									_: 1
								}, 8, ["language"]))]),
								_: 1
							})]),
							_: 1
						})) : k("", !0), N(pn, { class: "h-alert-bar-details-row" }, {
							default: W(() => [e.alert.details?.additionalInfo ? (L(), O(dn, {
								key: 0,
								class: "h-alert-bar-details-col"
							}, {
								default: W(() => [N(hr, {
									modelValue: o.value,
									"onUpdate:modelValue": f[3] ||= (e) => o.value = e,
									class: "h-alert-bar-details-expansion-panels"
								}, {
									default: W(() => [N(pr, {
										class: "h-alert-bar-details-expansion-panel",
										title: H(K)("alert_additional_info")
									}, {
										default: W(() => [N(mr, { class: "h-alert-bar-details-expansion-panel-text" }, {
											default: W(() => [N(m, null, {
												default: W(() => [M(V(a.value), 1)]),
												_: 1
											})]),
											_: 1
										})]),
										_: 1
									}, 8, ["title"])]),
									_: 1
								}, 8, ["modelValue"])]),
								_: 1
							})) : k("", !0)]),
							_: 1
						})]),
						_: 1
					})]),
					_: 1
				}, 8, ["color"])]),
				_: 1
			}, 8, ["modelValue"])], 64);
		};
	}
}), Cy = "h-alerts-provider", wy = /* @__PURE__ */ P({
	__name: "alerts-provider",
	props: {
		location: {},
		maxShownAlerts: {}
	},
	setup(e) {
		let t = $t(), n = G(e, "HAlertsProvider"), { hAlerts: r } = Rt(), i = R(n.location ?? t?.alerts_location ?? "bottom-center"), a = D(() => {
			switch (i.value) {
				case "top-right": return `${Cy}--top ${Cy}--right`;
				case "top-left": return `${Cy}--top ${Cy}--left`;
				case "bottom-right": return `${Cy}--bottom ${Cy}--right`;
				case "bottom-left": return `${Cy}--bottom ${Cy}--left`;
				case "bottom-center": return `${Cy}--bottom ${Cy}--center`;
				case "top-center": return `${Cy}--top ${Cy}--center`;
				default: return "";
			}
		});
		return (e, t) => (L(), A("div", { class: I({
			[Cy]: !0,
			[a.value]: !0
		}) }, [(L(!0), A(E, null, z(H(r), (e) => (L(), O(Sy, {
			key: e.id,
			class: "h-alerts-provider__alert",
			alert: e
		}, null, 8, ["alert"]))), 128))], 2));
	}
}), Ty = /* @__PURE__ */ P({
	__name: "file-upload",
	props: {
		uploadUrl: {},
		selectedFiles: {}
	},
	emits: ["update:selectedFiles"],
	setup(e, { emit: t }) {
		let { selectedFiles: n } = zn(G(e, "HFileUpload"), t);
		return (e, t) => (L(), O(gr, {
			modelValue: H(n),
			"onUpdate:modelValue": t[0] ||= (e) => tt(n) ? n.value = e : null,
			multiple: "",
			class: "h-file-upload",
			accept: "image/png, image/jpeg, .png, .jpg, .jpeg .doc, .docx, .xml,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
			"show-size": ""
		}, null, 8, ["modelValue"]));
	}
}), Ey = /* @__PURE__ */ P({
	inheritAttrs: !1,
	__name: "page-head",
	props: {
		pageTitle: {},
		pagePrefix: {},
		pageMeta: {}
	},
	setup(e) {
		let t = $t(), n = e, r = D(() => {
			let e = (n.pagePrefix ?? t?.custom_title?.value ?? "Onify - ").replace(/[\s-]+$/, "");
			return e ? `${e} - ` : "";
		}), { hSetTitle: i, hSetMeta: a, hDisposeHead: o, hUpdateHead: s } = Yt(), c = St(), l = D(() => c?.default?.()?.[0]);
		function u() {
			i(n.pageTitle ?? null, (e) => `${r.value}${e ?? ""}`);
		}
		function d() {
			a(n.pageMeta ?? []);
		}
		function f() {
			u(), d(), s();
		}
		return lt(f), ut(() => {
			o();
		}), U([
			() => n.pageTitle,
			() => n.pagePrefix,
			() => n.pageMeta,
			r
		], f), (e, t) => l.value ? (L(), O(mt(l.value), at(F({ key: 0 }, e.$attrs)), null, 16)) : k("", !0);
	}
}), Dy = { class: "text-display-small" }, Oy = { class: "text-headline-medium" }, ky = /* @__PURE__ */ P({
	__name: "legacy-form-container",
	props: {
		title: {},
		description: {},
		width: {},
		minWidth: {},
		maxWidth: {}
	},
	setup(e) {
		return G(e, "HLegacyFormContainer"), (t, n) => (L(), O(Ey, null, {
			default: W(() => [N(fn, { class: "h-legacy-form-container" }, {
				default: W(() => [N(pn, { class: "h-legacy-form-container-title-row" }, {
					default: W(() => [N(dn, { class: "h-legacy-form-container-title-col py-4" }, {
						default: W(() => [j("div", Dy, V(e.title), 1), j("div", Oy, V(e.description), 1)]),
						_: 1
					})]),
					_: 1
				}), N(pn, { class: "h-legacy-form-container-content-row" }, {
					default: W(() => [N(dn, { class: "h-legacy-form-container-content-col" }, {
						default: W(() => [N(_r, {
							class: "h-legacy-form-container__card rounded text-left bg-surface",
							width: e.width,
							"min-width": e.minWidth,
							"max-width": e.maxWidth
						}, {
							default: W(() => [B(t.$slots, "default")]),
							_: 3
						}, 8, [
							"width",
							"min-width",
							"max-width"
						])]),
						_: 3
					})]),
					_: 3
				})]),
				_: 3
			})]),
			_: 3
		}));
	}
}), Ay = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "form-container",
	setup(e) {
		return (e, t) => (L(), O(Ey, null, {
			default: W(() => [N(vr, { class: "h-form-container h-100" }, {
				default: W(() => [e.$vuetify.display.mdAndUp ? (L(), O(br, {
					key: 0,
					class: "h-form-container__drawer h-100",
					elevation: 0,
					permanent: "",
					floating: ""
				})) : k("", !0), N(yr, { class: "h-form-container-main-content" }, {
					default: W(() => [N(dn, { class: "h-form-container__form text-left" }, {
						default: W(() => [B(e.$slots, "default", {}, void 0, !0)]),
						_: 3
					})]),
					_: 3
				})]),
				_: 3
			})]),
			_: 3
		}));
	}
}), [["__scopeId", "data-v-c4de7168"]]), jy = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "page-container",
	props: {
		pageTitle: {},
		pagePrefix: {}
	},
	setup(e) {
		return G(e, "HPageContainer"), (t, n) => (L(), O(Ey, {
			"page-title": e.pageTitle,
			"page-prefix": e.pagePrefix
		}, {
			default: W(() => [N(fn, {
				class: "h-page-container text-left",
				fluid: ""
			}, {
				default: W(() => [N(pn, null, {
					default: W(() => [N(dn, null, {
						default: W(() => [B(t.$slots, "default", {}, void 0, !0)]),
						_: 3
					})]),
					_: 3
				})]),
				_: 3
			})]),
			_: 3
		}, 8, ["page-title", "page-prefix"]));
	}
}), [["__scopeId", "data-v-037b55fa"]]), My = {}, Ny = { class: "h-dialog-container" };
function Py(e, t) {
	return L(), A("div", Ny, [B(e.$slots, "default")]);
}
var Fy = /*#__PURE__*/ Y(My, [["render", Py]]), Iy = {}, Ly = { class: "h-page-title" };
function Ry(e, t) {
	return L(), A("div", Ly, [B(e.$slots, "default")]);
}
var zy = /*#__PURE__*/ Y(Iy, [["render", Ry]]), By = {}, Vy = { class: "h-page-subtitle" };
function Hy(e, t) {
	return L(), A("div", Vy, [B(e.$slots, "default", {}, void 0, !0)]);
}
var Uy = /*#__PURE__*/ Y(By, [["render", Hy], ["__scopeId", "data-v-96a9c924"]]), Wy = {}, Gy = { class: "h-page-description mb-2" };
function Ky(e, t) {
	return L(), A("div", Gy, [B(e.$slots, "default", {}, void 0, !0)]);
}
var qy = /*#__PURE__*/ Y(Wy, [["render", Ky], ["__scopeId", "data-v-5ccba0f4"]]), Jy = /* @__PURE__ */ Ve((/* @__PURE__ */ f(((e, t) => {
	var n = function(e) {
		var t = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, n = 0, r = {}, i = {
			manual: e.Prism && e.Prism.manual,
			disableWorkerMessageHandler: e.Prism && e.Prism.disableWorkerMessageHandler,
			util: {
				encode: function e(t) {
					return t instanceof a ? new a(t.type, e(t.content), t.alias) : Array.isArray(t) ? t.map(e) : t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
				},
				type: function(e) {
					return Object.prototype.toString.call(e).slice(8, -1);
				},
				objId: function(e) {
					return e.__id || Object.defineProperty(e, "__id", { value: ++n }), e.__id;
				},
				clone: function e(t, n) {
					n ||= {};
					var r, a;
					switch (i.util.type(t)) {
						case "Object":
							if (a = i.util.objId(t), n[a]) return n[a];
							for (var o in r = {}, n[a] = r, t) t.hasOwnProperty(o) && (r[o] = e(t[o], n));
							return r;
						case "Array": return a = i.util.objId(t), n[a] ? n[a] : (r = [], n[a] = r, t.forEach(function(t, i) {
							r[i] = e(t, n);
						}), r);
						default: return t;
					}
				},
				getLanguage: function(e) {
					for (; e;) {
						var n = t.exec(e.className);
						if (n) return n[1].toLowerCase();
						e = e.parentElement;
					}
					return "none";
				},
				setLanguage: function(e, n) {
					e.className = e.className.replace(RegExp(t, "gi"), ""), e.classList.add("language-" + n);
				},
				currentScript: function() {
					if (typeof document > "u") return null;
					if (document.currentScript && document.currentScript.tagName === "SCRIPT") return document.currentScript;
					try {
						throw Error();
					} catch (r) {
						var e = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(r.stack) || [])[1];
						if (e) {
							var t = document.getElementsByTagName("script");
							for (var n in t) if (t[n].src == e) return t[n];
						}
						return null;
					}
				},
				isActive: function(e, t, n) {
					for (var r = "no-" + t; e;) {
						var i = e.classList;
						if (i.contains(t)) return !0;
						if (i.contains(r)) return !1;
						e = e.parentElement;
					}
					return !!n;
				}
			},
			languages: {
				plain: r,
				plaintext: r,
				text: r,
				txt: r,
				extend: function(e, t) {
					var n = i.util.clone(i.languages[e]);
					for (var r in t) n[r] = t[r];
					return n;
				},
				insertBefore: function(e, t, n, r) {
					r ||= i.languages;
					var a = r[e], o = {};
					for (var s in a) if (a.hasOwnProperty(s)) {
						if (s == t) for (var c in n) n.hasOwnProperty(c) && (o[c] = n[c]);
						n.hasOwnProperty(s) || (o[s] = a[s]);
					}
					var l = r[e];
					return r[e] = o, i.languages.DFS(i.languages, function(t, n) {
						n === l && t != e && (this[t] = o);
					}), o;
				},
				DFS: function e(t, n, r, a) {
					a ||= {};
					var o = i.util.objId;
					for (var s in t) if (t.hasOwnProperty(s)) {
						n.call(t, s, t[s], r || s);
						var c = t[s], l = i.util.type(c);
						l === "Object" && !a[o(c)] ? (a[o(c)] = !0, e(c, n, null, a)) : l === "Array" && !a[o(c)] && (a[o(c)] = !0, e(c, n, s, a));
					}
				}
			},
			plugins: {},
			highlightAll: function(e, t) {
				i.highlightAllUnder(document, e, t);
			},
			highlightAllUnder: function(e, t, n) {
				var r = {
					callback: n,
					container: e,
					selector: "code[class*=\"language-\"], [class*=\"language-\"] code, code[class*=\"lang-\"], [class*=\"lang-\"] code"
				};
				i.hooks.run("before-highlightall", r), r.elements = Array.prototype.slice.apply(r.container.querySelectorAll(r.selector)), i.hooks.run("before-all-elements-highlight", r);
				for (var a = 0, o; o = r.elements[a++];) i.highlightElement(o, t === !0, r.callback);
			},
			highlightElement: function(t, n, r) {
				var a = i.util.getLanguage(t), o = i.languages[a];
				i.util.setLanguage(t, a);
				var s = t.parentElement;
				s && s.nodeName.toLowerCase() === "pre" && i.util.setLanguage(s, a);
				var c = {
					element: t,
					language: a,
					grammar: o,
					code: t.textContent
				};
				function l(e) {
					c.highlightedCode = e, i.hooks.run("before-insert", c), c.element.innerHTML = c.highlightedCode, i.hooks.run("after-highlight", c), i.hooks.run("complete", c), r && r.call(c.element);
				}
				if (i.hooks.run("before-sanity-check", c), s = c.element.parentElement, s && s.nodeName.toLowerCase() === "pre" && !s.hasAttribute("tabindex") && s.setAttribute("tabindex", "0"), !c.code) {
					i.hooks.run("complete", c), r && r.call(c.element);
					return;
				}
				if (i.hooks.run("before-highlight", c), !c.grammar) {
					l(i.util.encode(c.code));
					return;
				}
				if (n && e.Worker) {
					var u = new Worker(i.filename);
					u.onmessage = function(e) {
						l(e.data);
					}, u.postMessage(JSON.stringify({
						language: c.language,
						code: c.code,
						immediateClose: !0
					}));
				} else l(i.highlight(c.code, c.grammar, c.language));
			},
			highlight: function(e, t, n) {
				var r = {
					code: e,
					grammar: t,
					language: n
				};
				if (i.hooks.run("before-tokenize", r), !r.grammar) throw Error("The language \"" + r.language + "\" has no grammar.");
				return r.tokens = i.tokenize(r.code, r.grammar), i.hooks.run("after-tokenize", r), a.stringify(i.util.encode(r.tokens), r.language);
			},
			tokenize: function(e, t) {
				var n = t.rest;
				if (n) {
					for (var r in n) t[r] = n[r];
					delete t.rest;
				}
				var i = new c();
				return l(i, i.head, e), s(e, i, t, i.head, 0), d(i);
			},
			hooks: {
				all: {},
				add: function(e, t) {
					var n = i.hooks.all;
					n[e] = n[e] || [], n[e].push(t);
				},
				run: function(e, t) {
					var n = i.hooks.all[e];
					if (!(!n || !n.length)) for (var r = 0, a; a = n[r++];) a(t);
				}
			},
			Token: a
		};
		e.Prism = i;
		function a(e, t, n, r) {
			this.type = e, this.content = t, this.alias = n, this.length = (r || "").length | 0;
		}
		a.stringify = function e(t, n) {
			if (typeof t == "string") return t;
			if (Array.isArray(t)) {
				var r = "";
				return t.forEach(function(t) {
					r += e(t, n);
				}), r;
			}
			var a = {
				type: t.type,
				content: e(t.content, n),
				tag: "span",
				classes: ["token", t.type],
				attributes: {},
				language: n
			}, o = t.alias;
			o && (Array.isArray(o) ? Array.prototype.push.apply(a.classes, o) : a.classes.push(o)), i.hooks.run("wrap", a);
			var s = "";
			for (var c in a.attributes) s += " " + c + "=\"" + (a.attributes[c] || "").replace(/"/g, "&quot;") + "\"";
			return "<" + a.tag + " class=\"" + a.classes.join(" ") + "\"" + s + ">" + a.content + "</" + a.tag + ">";
		};
		function o(e, t, n, r) {
			e.lastIndex = t;
			var i = e.exec(n);
			if (i && r && i[1]) {
				var a = i[1].length;
				i.index += a, i[0] = i[0].slice(a);
			}
			return i;
		}
		function s(e, t, n, r, c, d) {
			for (var f in n) if (!(!n.hasOwnProperty(f) || !n[f])) {
				var p = n[f];
				p = Array.isArray(p) ? p : [p];
				for (var m = 0; m < p.length; ++m) {
					if (d && d.cause == f + "," + m) return;
					var h = p[m], g = h.inside, _ = !!h.lookbehind, v = !!h.greedy, y = h.alias;
					if (v && !h.pattern.global) {
						var b = h.pattern.toString().match(/[imsuy]*$/)[0];
						h.pattern = RegExp(h.pattern.source, b + "g");
					}
					for (var x = h.pattern || h, S = r.next, C = c; S !== t.tail && !(d && C >= d.reach); C += S.value.length, S = S.next) {
						var w = S.value;
						if (t.length > e.length) return;
						if (!(w instanceof a)) {
							var T = 1, ee;
							if (v) {
								if (ee = o(x, C, e, _), !ee || ee.index >= e.length) break;
								var te = ee.index, ne = ee.index + ee[0].length, re = C;
								for (re += S.value.length; te >= re;) S = S.next, re += S.value.length;
								if (re -= S.value.length, C = re, S.value instanceof a) continue;
								for (var ie = S; ie !== t.tail && (re < ne || typeof ie.value == "string"); ie = ie.next) T++, re += ie.value.length;
								T--, w = e.slice(C, re), ee.index -= C;
							} else if (ee = o(x, 0, w, _), !ee) continue;
							var te = ee.index, ae = ee[0], oe = w.slice(0, te), se = w.slice(te + ae.length), ce = C + w.length;
							d && ce > d.reach && (d.reach = ce);
							var le = S.prev;
							oe && (le = l(t, le, oe), C += oe.length), u(t, le, T);
							var ue = new a(f, g ? i.tokenize(ae, g) : ae, y, ae);
							if (S = l(t, le, ue), se && l(t, S, se), T > 1) {
								var de = {
									cause: f + "," + m,
									reach: ce
								};
								s(e, t, n, S.prev, C, de), d && de.reach > d.reach && (d.reach = de.reach);
							}
						}
					}
				}
			}
		}
		function c() {
			var e = {
				value: null,
				prev: null,
				next: null
			}, t = {
				value: null,
				prev: e,
				next: null
			};
			e.next = t, this.head = e, this.tail = t, this.length = 0;
		}
		function l(e, t, n) {
			var r = t.next, i = {
				value: n,
				prev: t,
				next: r
			};
			return t.next = i, r.prev = i, e.length++, i;
		}
		function u(e, t, n) {
			for (var r = t.next, i = 0; i < n && r !== e.tail; i++) r = r.next;
			t.next = r, r.prev = t, e.length -= i;
		}
		function d(e) {
			for (var t = [], n = e.head.next; n !== e.tail;) t.push(n.value), n = n.next;
			return t;
		}
		if (!e.document) return e.addEventListener && (i.disableWorkerMessageHandler || e.addEventListener("message", function(t) {
			var n = JSON.parse(t.data), r = n.language, a = n.code, o = n.immediateClose;
			e.postMessage(i.highlight(a, i.languages[r], r)), o && e.close();
		}, !1)), i;
		var f = i.util.currentScript();
		f && (i.filename = f.src, f.hasAttribute("data-manual") && (i.manual = !0));
		function p() {
			i.manual || i.highlightAll();
		}
		if (!i.manual) {
			var m = document.readyState;
			m === "loading" || m === "interactive" && f && f.defer ? document.addEventListener("DOMContentLoaded", p) : window.requestAnimationFrame ? window.requestAnimationFrame(p) : window.setTimeout(p, 16);
		}
		return i;
	}(typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {});
	t !== void 0 && t.exports && (t.exports = n), typeof global < "u" && (global.Prism = n), n.languages.markup = {
		comment: {
			pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
			greedy: !0
		},
		prolog: {
			pattern: /<\?[\s\S]+?\?>/,
			greedy: !0
		},
		doctype: {
			pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
			greedy: !0,
			inside: {
				"internal-subset": {
					pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
					lookbehind: !0,
					greedy: !0,
					inside: null
				},
				string: {
					pattern: /"[^"]*"|'[^']*'/,
					greedy: !0
				},
				punctuation: /^<!|>$|[[\]]/,
				"doctype-tag": /^DOCTYPE/i,
				name: /[^\s<>'"]+/
			}
		},
		cdata: {
			pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
			greedy: !0
		},
		tag: {
			pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
			greedy: !0,
			inside: {
				tag: {
					pattern: /^<\/?[^\s>\/]+/,
					inside: {
						punctuation: /^<\/?/,
						namespace: /^[^\s>\/:]+:/
					}
				},
				"special-attr": [],
				"attr-value": {
					pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
					inside: { punctuation: [{
						pattern: /^=/,
						alias: "attr-equals"
					}, {
						pattern: /^(\s*)["']|["']$/,
						lookbehind: !0
					}] }
				},
				punctuation: /\/?>/,
				"attr-name": {
					pattern: /[^\s>\/]+/,
					inside: { namespace: /^[^\s>\/:]+:/ }
				}
			}
		},
		entity: [{
			pattern: /&[\da-z]{1,8};/i,
			alias: "named-entity"
		}, /&#x?[\da-f]{1,8};/i]
	}, n.languages.markup.tag.inside["attr-value"].inside.entity = n.languages.markup.entity, n.languages.markup.doctype.inside["internal-subset"].inside = n.languages.markup, n.hooks.add("wrap", function(e) {
		e.type === "entity" && (e.attributes.title = e.content.replace(/&amp;/, "&"));
	}), Object.defineProperty(n.languages.markup.tag, "addInlined", { value: function(e, t) {
		var r = {};
		r["language-" + t] = {
			pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
			lookbehind: !0,
			inside: n.languages[t]
		}, r.cdata = /^<!\[CDATA\[|\]\]>$/i;
		var i = { "included-cdata": {
			pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
			inside: r
		} };
		i["language-" + t] = {
			pattern: /[\s\S]+/,
			inside: n.languages[t]
		};
		var a = {};
		a[e] = {
			pattern: RegExp("(<__[^>]*>)(?:<!\\[CDATA\\[(?:[^\\]]|\\](?!\\]>))*\\]\\]>|(?!<!\\[CDATA\\[)[\\s\\S])*?(?=<\\/__>)".replace(/__/g, function() {
				return e;
			}), "i"),
			lookbehind: !0,
			greedy: !0,
			inside: i
		}, n.languages.insertBefore("markup", "cdata", a);
	} }), Object.defineProperty(n.languages.markup.tag, "addAttribute", { value: function(e, t) {
		n.languages.markup.tag.inside["special-attr"].push({
			pattern: RegExp("(^|[\"'\\s])(?:" + e + ")\\s*=\\s*(?:\"[^\"]*\"|'[^']*'|[^\\s'\">=]+(?=[\\s>]))", "i"),
			lookbehind: !0,
			inside: {
				"attr-name": /^[^\s=]+/,
				"attr-value": {
					pattern: /=[\s\S]+/,
					inside: {
						value: {
							pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
							lookbehind: !0,
							alias: [t, "language-" + t],
							inside: n.languages[t]
						},
						punctuation: [{
							pattern: /^=/,
							alias: "attr-equals"
						}, /"|'/]
					}
				}
			}
		});
	} }), n.languages.html = n.languages.markup, n.languages.mathml = n.languages.markup, n.languages.svg = n.languages.markup, n.languages.xml = n.languages.extend("markup", {}), n.languages.ssml = n.languages.xml, n.languages.atom = n.languages.xml, n.languages.rss = n.languages.xml, (function(e) {
		var t = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
		e.languages.css = {
			comment: /\/\*[\s\S]*?\*\//,
			atrule: {
				pattern: RegExp("@[\\w-](?:[^;{\\s\"']|\\s+(?!\\s)|" + t.source + ")*?(?:;|(?=\\s*\\{))"),
				inside: {
					rule: /^@[\w-]+/,
					"selector-function-argument": {
						pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
						lookbehind: !0,
						alias: "selector"
					},
					keyword: {
						pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
						lookbehind: !0
					}
				}
			},
			url: {
				pattern: RegExp("\\burl\\((?:" + t.source + "|(?:[^\\\\\\r\\n()\"']|\\\\[\\s\\S])*)\\)", "i"),
				greedy: !0,
				inside: {
					function: /^url/i,
					punctuation: /^\(|\)$/,
					string: {
						pattern: RegExp("^" + t.source + "$"),
						alias: "url"
					}
				}
			},
			selector: {
				pattern: RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|" + t.source + ")*(?=\\s*\\{)"),
				lookbehind: !0
			},
			string: {
				pattern: t,
				greedy: !0
			},
			property: {
				pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
				lookbehind: !0
			},
			important: /!important\b/i,
			function: {
				pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
				lookbehind: !0
			},
			punctuation: /[(){};:,]/
		}, e.languages.css.atrule.inside.rest = e.languages.css;
		var n = e.languages.markup;
		n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
	})(n), n.languages.clike = {
		comment: [{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: !0,
			greedy: !0
		}, {
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: !0,
			greedy: !0
		}],
		string: {
			pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
			greedy: !0
		},
		"class-name": {
			pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
			lookbehind: !0,
			inside: { punctuation: /[.\\]/ }
		},
		keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
		boolean: /\b(?:false|true)\b/,
		function: /\b\w+(?=\()/,
		number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
		operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
		punctuation: /[{}[\];(),.:]/
	}, n.languages.javascript = n.languages.extend("clike", {
		"class-name": [n.languages.clike["class-name"], {
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
			lookbehind: !0
		}],
		keyword: [{
			pattern: /((?:^|\})\s*)catch\b/,
			lookbehind: !0
		}, {
			pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: !0
		}],
		function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
		number: {
			pattern: RegExp("(^|[^\\w$])(?:NaN|Infinity|0[bB][01]+(?:_[01]+)*n?|0[oO][0-7]+(?:_[0-7]+)*n?|0[xX][\\dA-Fa-f]+(?:_[\\dA-Fa-f]+)*n?|\\d+(?:_\\d+)*n|(?:\\d+(?:_\\d+)*(?:\\.(?:\\d+(?:_\\d+)*)?)?|\\.\\d+(?:_\\d+)*)(?:[Ee][+-]?\\d+(?:_\\d+)*)?)(?![\\w$])"),
			lookbehind: !0
		},
		operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
	}), n.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, n.languages.insertBefore("javascript", "keyword", {
		regex: {
			pattern: RegExp("((?:^|[^$\\w\\xA0-\\uFFFF.\"'\\])\\s]|\\b(?:return|yield))\\s*)\\/(?:(?:\\[(?:[^\\]\\\\\\r\\n]|\\\\.)*\\]|\\\\.|[^/\\\\\\[\\r\\n])+\\/[dgimyus]{0,7}|(?:\\[(?:[^[\\]\\\\\\r\\n]|\\\\.|\\[(?:[^[\\]\\\\\\r\\n]|\\\\.|\\[(?:[^[\\]\\\\\\r\\n]|\\\\.)*\\])*\\])*\\]|\\\\.|[^/\\\\\\[\\r\\n])+\\/[dgimyus]{0,7}v[dgimyus]{0,7})(?=(?:\\s|\\/\\*(?:[^*]|\\*(?!\\/))*\\*\\/)*(?:$|[\\r\\n,.;:})\\]]|\\/\\/))"),
			lookbehind: !0,
			greedy: !0,
			inside: {
				"regex-source": {
					pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
					lookbehind: !0,
					alias: "language-regex",
					inside: n.languages.regex
				},
				"regex-delimiter": /^\/|\/$/,
				"regex-flags": /^[a-z]+$/
			}
		},
		"function-variable": {
			pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
			alias: "function"
		},
		parameter: [
			{
				pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
				lookbehind: !0,
				inside: n.languages.javascript
			},
			{
				pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
				lookbehind: !0,
				inside: n.languages.javascript
			},
			{
				pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
				lookbehind: !0,
				inside: n.languages.javascript
			},
			{
				pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
				lookbehind: !0,
				inside: n.languages.javascript
			}
		],
		constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
	}), n.languages.insertBefore("javascript", "string", {
		hashbang: {
			pattern: /^#!.*/,
			greedy: !0,
			alias: "comment"
		},
		"template-string": {
			pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
			greedy: !0,
			inside: {
				"template-punctuation": {
					pattern: /^`|`$/,
					alias: "string"
				},
				interpolation: {
					pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
					lookbehind: !0,
					inside: {
						"interpolation-punctuation": {
							pattern: /^\$\{|\}$/,
							alias: "punctuation"
						},
						rest: n.languages.javascript
					}
				},
				string: /[\s\S]+/
			}
		},
		"string-property": {
			pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
			lookbehind: !0,
			greedy: !0,
			alias: "property"
		}
	}), n.languages.insertBefore("javascript", "operator", { "literal-property": {
		pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
		lookbehind: !0,
		alias: "property"
	} }), n.languages.markup && (n.languages.markup.tag.addInlined("script", "javascript"), n.languages.markup.tag.addAttribute("on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)", "javascript")), n.languages.js = n.languages.javascript, (function() {
		if (n === void 0 || typeof document > "u") return;
		Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
		var e = "Loading…", t = function(e, t) {
			return "✖ Error " + e + " while fetching file: " + t;
		}, r = "✖ Error: File does not exist or is empty", i = {
			js: "javascript",
			py: "python",
			rb: "ruby",
			ps1: "powershell",
			psm1: "powershell",
			sh: "bash",
			bat: "batch",
			h: "c",
			tex: "latex"
		}, a = "data-src-status", o = "loading", s = "loaded", c = "failed", l = "pre[data-src]:not([" + a + "=\"" + s + "\"]):not([" + a + "=\"" + o + "\"])";
		function u(e, n, i) {
			var a = new XMLHttpRequest();
			a.open("GET", e, !0), a.onreadystatechange = function() {
				a.readyState == 4 && (a.status < 400 && a.responseText ? n(a.responseText) : a.status >= 400 ? i(t(a.status, a.statusText)) : i(r));
			}, a.send(null);
		}
		function d(e) {
			var t = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(e || "");
			if (t) {
				var n = Number(t[1]), r = t[2], i = t[3];
				return r ? i ? [n, Number(i)] : [n, void 0] : [n, n];
			}
		}
		n.hooks.add("before-highlightall", function(e) {
			e.selector += ", " + l;
		}), n.hooks.add("before-sanity-check", function(t) {
			var r = t.element;
			if (r.matches(l)) {
				t.code = "", r.setAttribute(a, o);
				var f = r.appendChild(document.createElement("CODE"));
				f.textContent = e;
				var p = r.getAttribute("data-src"), m = t.language;
				if (m === "none") {
					var h = (/\.(\w+)$/.exec(p) || [, "none"])[1];
					m = i[h] || h;
				}
				n.util.setLanguage(f, m), n.util.setLanguage(r, m);
				var g = n.plugins.autoloader;
				g && g.loadLanguages(m), u(p, function(e) {
					r.setAttribute(a, s);
					var t = d(r.getAttribute("data-range"));
					if (t) {
						var i = e.split(/\r\n?|\n/g), o = t[0], c = t[1] == null ? i.length : t[1];
						o < 0 && (o += i.length), o = Math.max(0, Math.min(o - 1, i.length)), c < 0 && (c += i.length), c = Math.max(0, Math.min(c, i.length)), e = i.slice(o, c).join("\n"), r.hasAttribute("data-start") || r.setAttribute("data-start", String(o + 1));
					}
					f.textContent = e, n.highlightElement(f);
				}, function(e) {
					r.setAttribute(a, c), f.textContent = e;
				});
			}
		}), n.plugins.fileHighlight = { highlight: function(e) {
			for (var t = (e || document).querySelectorAll(l), r = 0, i; i = t[r++];) n.highlightElement(i);
		} };
		var f = !1;
		n.fileHighlight = function() {
			f ||= (console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead."), !0), n.plugins.fileHighlight.highlight.apply(this, arguments);
		};
	})();
})))(), 1), Yy = /* @__PURE__ */ P({
	__name: "pretty-code",
	props: { language: { default: "javascript" } },
	setup(e) {
		G(e, "HPrettyCode");
		let t = R(crypto.randomUUID());
		function n() {
			window.Prism = window.Prism || {}, window.Prism.manual = !0, Jy.default.highlightAll();
		}
		return lt(n), ct(() => {
			t.value = crypto.randomUUID(), it(n);
		}), (n, r) => (L(), A("pre", null, [(L(), A("code", {
			key: t.value,
			class: I(["h-pretty-code", `language-${e.language}`])
		}, [B(n.$slots, "default")], 2))]));
	}
});
//#endregion
//#region ../../../node_modules/lodash-es/isObject.js
function Xy(e) {
	var t = typeof e;
	return e != null && (t == "object" || t == "function");
}
//#endregion
//#region src/components/general/autocomplete-input.vue.ts
var Zy = P({
	inheritAttrs: !1,
	setup(e, t) {
		let n = t.attrs, r = t.emit, i = t.slots;
		function a(e) {
			return e && n.items?.length ? Array.isArray(e) ? n.items.filter((t) => e.includes(t[n["item-value"]])) : Xy(e) ? e : n.items.find((t) => t[n["item-value"]] === e) : null;
		}
		let o = R(a(n.modelValue)), s = D(() => (n.items ?? []).concat(o.value)), c = n.limit;
		function l(e) {
			return Array.isArray(e) ? e.map((e) => e[n["item-value"]]) : e?.[n["item-value"]];
		}
		function u(e) {
			let t = e;
			Array.isArray(t) && c && t.length > c && (t = t.slice(t.length - c)), o.value = t, r("update:modelValue", n["item-value"] ? l(t) : t);
		}
		return () => $e(sr, {
			...n,
			modelValue: o.value,
			returnObject: !0,
			autocompleteItems: s.value,
			"onUpdate:modelValue": u
		}, { ...i });
	}
}), Qy = { class: "h-bulletin__header d-flex justify-space-between mb-3" }, $y = { class: "font-weight-medium header__text" }, eb = { class: "h-bulletin__content" }, tb = { class: "h-bulletin__actions d-flex flex-wrap mt-3" }, nb = "action:", rb = /* @__PURE__ */ P({
	__name: "bulletin-item",
	props: {
		is: { default: "div" },
		bulletin: {},
		windowName: {}
	},
	emits: ["acknowledgeBulletin", "actionClicked"],
	setup(e, { emit: t }) {
		let n = G(e, "HBulletin"), r = t, i = yt(), a = D(() => Object.keys(i).filter((e) => e.startsWith(nb)).reduce((e, t) => (e[t.replace(nb, "")] = i[t], e), {}));
		function o() {
			r("acknowledgeBulletin", n.bulletin?.key);
		}
		function s(e, t, n) {
			r("actionClicked", e, t, n);
		}
		return (t, r) => {
			let i = pt("h-theme-scope"), c = pt("h-action-link");
			return L(), O(mt(e.is), F({
				...t.$attrs,
				...H(n)
			}, { class: ["h-bulletin d-flex flex-column", {
				"h-bulletin--sticky": e.bulletin?.sticky,
				[`h-bulletin--${e.bulletin?.status}`]: !0
			}] }), {
				default: W(() => [
					j("div", Qy, [B(t.$slots, "header", { bulletin: e.bulletin }, () => [j("h3", $y, V(e.bulletin?.title), 1), e.bulletin?.sticky ? k("", !0) : (L(), O(i, {
						key: 0,
						name: "HScopedBulletinAcknowledgeBtn",
						component: H(lr),
						class: "h-bulletin-acknowledge-btn",
						"aria-label": "Acknowledge bulletin",
						onClick: r[0] ||= (e) => o()
					}, null, 8, ["component"]))])]),
					j("div", eb, [B(t.$slots, "default", { bulletin: e.bulletin }, () => [M(V(e.bulletin?.description), 1)])]),
					j("div", tb, [B(t.$slots, "actions", {
						bulletin: e.bulletin,
						actionProps: a.value
					}, () => [(L(!0), A(E, null, z(e.bulletin?.action, (t) => (L(), O(c, {
						key: t.url,
						class: "h-bulletin-action-link",
						to: t.url,
						target: t.target,
						"window-name": e.windowName ?? e.bulletin?.key,
						"no-route": "",
						onClick: (n) => s(t, e.bulletin, n)
					}, {
						default: W(() => [N(i, F({
							name: "HScopedBulletinActionBtn",
							component: H(lr),
							class: ["h-bulletin-action-btn", { [`h-bulletin-action-btn--${e.bulletin?.status}`]: !0 }]
						}, { ref_for: !0 }, { ...a.value }), {
							default: W(() => [M(V(t.name), 1)]),
							_: 2
						}, 1040, ["component", "class"])]),
						_: 2
					}, 1032, [
						"to",
						"target",
						"window-name",
						"onClick"
					]))), 128))])])
				]),
				_: 3
			}, 16, ["class"]);
		};
	}
}), ib = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	inheritAttrs: !1,
	__name: "dialog-card",
	props: {
		modelValue: { type: Boolean },
		dialogWidth: { default: "850" },
		dialogHeight: { default: "auto" },
		hideClose: {
			type: Boolean,
			default: !1
		},
		background: {},
		customDefaults: {}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = G(e, "HDialog"), r = D(() => ({
			...xr().value,
			...n.customDefaults
		})), i = yt(), { smAndDown: a } = ir(), o = D(() => s.value ? "100%" : n.dialogHeight), s = D(() => i.fullscreen === void 0 ? !i["max-width"] && !i.width && a.value : i.fullscreen), c = Rn(n, "modelValue", t);
		return dt(kt, c), (t, i) => (L(), O(nr, F({
			modelValue: H(c),
			"onUpdate:modelValue": i[0] ||= (e) => tt(c) ? c.value = e : null,
			class: "h-dialog",
			persistent: "",
			fullscreen: s.value,
			width: e.dialogWidth,
			height: o.value
		}, t.$attrs, {
			"aria-label": H(K)("dialog"),
			"aria-labelledby": "hDialogHeader"
		}), {
			default: W(({ isActive: i }) => [N(or, { defaults: r.value }, {
				default: W(() => [N(rn, {
					class: "h-dialog-container",
					color: H(n).background
				}, {
					default: W(() => [N(ln, { class: "h-dialog-container__header" }, {
						default: W(() => [B(t.$slots, "header", {}, void 0, !0), e.hideClose ? k("", !0) : (L(), O(q, {
							key: 0,
							class: "h-dialog-card-close-btn",
							variant: "text",
							icon: "mdi:mdi-close",
							"aria-label": H(K)("close-dialog"),
							onClick: (e) => i.value = !1
						}, null, 8, ["aria-label", "onClick"]))]),
						_: 2
					}, 1024), B(t.$slots, "default", { class: "h-dialog-container__content" }, void 0, !0)]),
					_: 2
				}, 1032, ["color"])]),
				_: 2
			}, 1032, ["defaults"])]),
			_: 3
		}, 16, [
			"modelValue",
			"fullscreen",
			"width",
			"height",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-03436bd3"]]), ab = { class: "text-headline-small font-weight-medium h-action-dialog__title" }, ob = {
	key: 0,
	class: "text-body-medium mt-1"
}, sb = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	inheritAttrs: !1,
	__name: "action-dialog",
	props: {
		modelValue: { type: Boolean },
		title: {},
		subtitle: {},
		dialogWidth: { default: "600" },
		dialogHeight: { default: "auto" },
		hideClose: {
			type: Boolean,
			default: !1
		},
		closeText: { default: "Avbryt" },
		closeIcon: {},
		saveText: { default: "Spara" },
		saveIcon: {},
		hideSave: {
			type: Boolean,
			default: !1
		},
		saveLoading: {
			type: Boolean,
			default: !1
		},
		saveDisabled: {
			type: Boolean,
			default: !1
		},
		background: {},
		customDefaults: {}
	},
	emits: [
		"update:modelValue",
		"close",
		"save"
	],
	setup(e, { emit: t }) {
		let n = R(), r = G(e, "HActionDialog"), i = yt(), { smAndDown: a } = ir(), o = D(() => i.width === void 0 ? a.value ? "auto" : void 0 : i.width), s = D(() => i["max-width"] === void 0 ? a.value ? void 0 : "700" : i["max-width"]), c = D(() => l.value ? "100%" : r.dialogHeight), l = D(() => i.fullscreen === void 0 ? !i["max-width"] && !i.width && a.value : i.fullscreen), u = t, d = Rn(r, "modelValue", u);
		dt(kt, d);
		let f = (e) => {
			e.value = !1, u("close");
		}, p = async () => {
			if (n.value) {
				let { valid: e } = await n.value.validate();
				if (!e) return;
			}
			u("save");
		};
		return (t, i) => (L(), O(nr, F({
			modelValue: H(d),
			"onUpdate:modelValue": i[0] ||= (e) => tt(d) ? d.value = e : null,
			class: "h-action-dialog",
			persistent: "",
			fullscreen: l.value,
			width: o.value,
			"max-width": s.value,
			height: c.value
		}, t.$attrs, { "aria-label": H(K)("dialog") }), {
			default: W(({ isActive: i }) => [e.hideClose ? k("", !0) : (L(), O(gl, {
				key: 0,
				name: "HActionButtonClose",
				type: "custom",
				class: "h-action-dialog__close-btn",
				variant: "elevated",
				icon: "mdi:mdi-close",
				size: "36",
				color: "neutral-100",
				"aria-label": H(K)("close-dialog"),
				onClick: (e) => f(i)
			}, null, 8, ["aria-label", "onClick"])), N(rn, {
				class: "h-action-dialog__container position-relative",
				color: H(r).background
			}, {
				default: W(() => [
					N(fn, { class: "h-action-dialog__header pa-0" }, {
						default: W(() => [N(pn, { class: "ma-0 align-center justify-space-between ga-5" }, {
							default: W(() => [N(dn, { class: "pa-4 pb-0 h-action-dialog__header-left" }, {
								default: W(() => [B(t.$slots, "title", {}, () => [j("div", ab, V(e.title), 1), e.subtitle ? (L(), A("div", ob, V(e.subtitle), 1)) : k("", !0)], !0)]),
								_: 3
							}), t.$slots["header-right"] ? (L(), O(dn, {
								key: 0,
								class: "pa-4 pb-0 h-action-dialog__header-right"
							}, {
								default: W(() => [B(t.$slots, "header-right", {}, void 0, !0)]),
								_: 3
							})) : k("", !0)]),
							_: 3
						})]),
						_: 3
					}),
					N(Sr, {
						ref_key: "formRef",
						ref: n,
						onSubmit: Dt(p, ["prevent"])
					}, {
						default: W(() => [N(fn, { class: "h-action-dialog__content pa-4" }, {
							default: W(() => [N(pn, { class: "ma-0" }, {
								default: W(() => [N(dn, {
									cols: "12",
									class: "pa-0"
								}, {
									default: W(() => [B(t.$slots, "default", {}, void 0, !0)]),
									_: 3
								})]),
								_: 3
							})]),
							_: 3
						})]),
						_: 3
					}, 512),
					N(fn, { class: "h-action-dialog__footer pa-0" }, {
						default: W(() => [N(pn, { class: "ma-0 justify-end align-center" }, {
							default: W(() => [N(dn, {
								cols: "auto",
								class: "pa-4"
							}, {
								default: W(() => [B(t.$slots, "footer", {}, () => [N(fn, { class: "pa-0" }, {
									default: W(() => [N(pn, {
										class: "ma-0",
										style: { gap: "8px" }
									}, {
										default: W(() => [
											N(dn, {
												cols: "auto",
												class: "pa-0"
											}, {
												default: W(() => [B(t.$slots, "actions", {}, void 0, !0)]),
												_: 3
											}),
											N(dn, {
												cols: "auto",
												class: "pa-0"
											}, {
												default: W(() => [N(gl, {
													type: "neutral",
													size: "default",
													"prepend-icon": e.closeIcon,
													onClick: (e) => f(i)
												}, {
													default: W(() => [M(V(e.closeText), 1)]),
													_: 1
												}, 8, ["prepend-icon", "onClick"])]),
												_: 2
											}, 1024),
											e.hideSave ? k("", !0) : (L(), O(dn, {
												key: 0,
												cols: "auto",
												class: "pa-0"
											}, {
												default: W(() => [N(gl, {
													type: "primary",
													size: "default",
													"prepend-icon": e.saveIcon,
													loading: e.saveLoading,
													disabled: e.saveDisabled,
													onClick: p
												}, {
													default: W(() => [M(V(e.saveText), 1)]),
													_: 1
												}, 8, [
													"prepend-icon",
													"loading",
													"disabled"
												])]),
												_: 1
											}))
										]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)], !0)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)
				]),
				_: 2
			}, 1032, ["color"])]),
			_: 3
		}, 16, [
			"modelValue",
			"fullscreen",
			"width",
			"max-width",
			"height",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-0ac64a01"]]), cb = {
	class: "h-confirmation-dialog__symbol",
	"aria-hidden": "true"
}, lb = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	inheritAttrs: !1,
	__name: "confirmation-dialog",
	props: {
		modelValue: {
			type: Boolean,
			default: !1
		},
		title: { default: "" },
		message: { default: "" },
		confirmText: { default: "Confirm" },
		cancelText: { default: "Cancel" },
		maxWidth: { default: "400" }
	},
	emits: [
		"update:modelValue",
		"confirm",
		"cancel"
	],
	setup(e, { emit: t }) {
		let n = G(e, "HConfirmationDialog"), r = t, i = Rn(n, "modelValue", r), a = () => {
			r("confirm"), i.value = !1;
		}, o = () => {
			r("cancel"), i.value = !1;
		};
		return Nn(document, "keydown", (e) => {
			i.value && e.key === "Escape" && (e.preventDefault(), o());
		}), (t, n) => {
			let r = pt("h-action-button");
			return L(), O(H(ur), {
				modelValue: H(i),
				"onUpdate:modelValue": n[0] ||= (e) => tt(i) ? i.value = e : null,
				"max-width": e.maxWidth,
				persistent: "",
				"aria-label": e.title
			}, {
				default: W(() => [N(rn, { class: "h-confirmation-dialog" }, {
					default: W(() => [
						j("div", cb, [N(J, { icon: "mdi:mdi-alert-circle" })]),
						N(ln, { class: "h-confirmation-dialog__title" }, {
							default: W(() => [N(pn, { "no-gutters": "" }, {
								default: W(() => [N(dn, null, {
									default: W(() => [B(t.$slots, "title", {}, () => [j("h2", null, V(e.title), 1)], !0)]),
									_: 3
								})]),
								_: 3
							})]),
							_: 3
						}),
						N(cn, { class: "h-confirmation-dialog__message" }, {
							default: W(() => [N(pn, { "no-gutters": "" }, {
								default: W(() => [N(dn, null, {
									default: W(() => [B(t.$slots, "message", {}, () => [j("div", null, V(e.message), 1)], !0)]),
									_: 3
								})]),
								_: 3
							})]),
							_: 3
						}),
						N(an, { class: "h-confirmation-dialog__actions" }, {
							default: W(() => [N(pn, { "no-gutters": "" }, {
								default: W(() => [N(dn, {
									cols: "6",
									class: "pr-1"
								}, {
									default: W(() => [B(t.$slots, "cancel-action", {}, () => [N(r, {
										type: "neutral",
										block: "",
										onClick: o
									}, {
										default: W(() => [M(V(e.cancelText), 1)]),
										_: 1
									})], !0)]),
									_: 3
								}), N(dn, {
									cols: "6",
									class: "pl-1"
								}, {
									default: W(() => [B(t.$slots, "confirm-action", {}, () => [N(r, {
										type: "error",
										block: "",
										onClick: a
									}, {
										default: W(() => [M(V(e.confirmText), 1)]),
										_: 1
									})], !0)]),
									_: 3
								})]),
								_: 3
							})]),
							_: 3
						})
					]),
					_: 3
				})]),
				_: 3
			}, 8, [
				"modelValue",
				"max-width",
				"aria-label"
			]);
		};
	}
}), [["__scopeId", "data-v-c653d769"]]), ub = /* @__PURE__ */ f(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.defaultOptions = void 0, e.defaultOptions = {
		lowercase: !1,
		precision: 1,
		space: !1,
		units: [
			"",
			"K",
			"M",
			"B",
			"T",
			"P",
			"E"
		]
	};
})), db = /* @__PURE__ */ f(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.getLocales = e.getFractionDigits = e.roundTo = e.parseValue = void 0;
	function t(e) {
		let t = parseFloat(e?.toString());
		if (isNaN(t)) throw Error("Input value is not a number");
		if (t > 2 ** 53 - 1 || t < -(2 ** 53 - 1)) throw RangeError("Input value is outside of safe integer range");
		return t;
	}
	e.parseValue = t;
	function n(e, t) {
		if (!Number.isFinite(e)) throw Error("Input value is not a finite number");
		if (!Number.isInteger(t) || t < 0) throw Error("Precision is not a positive integer");
		return Number.isInteger(e) ? e : parseFloat(e.toFixed(t));
	}
	e.roundTo = n;
	function r(e) {
		return Number.isInteger(e) ? 0 : e.toString().split(".")[1]?.length ?? 0;
	}
	e.getFractionDigits = r;
	function i() {
		return typeof navigator > "u" ? [] : Array.from(navigator.languages ?? []);
	}
	e.getLocales = i;
})), fb = (/* @__PURE__ */ f(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.millify = void 0;
	var t = ub(), n = db(), r = 1e3;
	function* i(e) {
		let t = r;
		for (;;) {
			let n = e / t;
			if (n < 1) return;
			yield n, t *= r;
		}
	}
	function a(e, r) {
		let a = r ? {
			...t.defaultOptions,
			...r
		} : t.defaultOptions;
		if (!Array.isArray(a.units) || !a.units.length) throw Error("Option `units` must be a non-empty array");
		let o;
		try {
			o = n.parseValue(e);
		} catch (t) {
			return t instanceof Error && console.warn(`WARN: ${t.message} (millify)`), String(e);
		}
		let s = o < 0 ? "-" : "";
		o = Math.abs(o);
		let c = 0;
		for (let e of i(o)) o = e, c += 1;
		if (c >= a.units.length) return e.toString();
		let l = n.roundTo(o, a.precision);
		for (let e of i(l)) l = e, c += 1;
		let u = a.units[c] ?? "", d = a.lowercase ? u.toLowerCase() : u, f = a.space ? " " : "";
		return `${s}${l.toLocaleString(a.locales ?? n.getLocales(), { minimumFractionDigits: n.getFractionDigits(l) })}${f}${d}`;
	}
	e.millify = a;
})))(), pb = { key: 2 }, mb = { key: 1 }, hb = { class: "h-shortcut__title pt-3" }, gb = "badge:", _b = "tooltip:", vb = /* @__PURE__ */ P({
	inheritAttrs: !1,
	__name: "shortcut-item",
	props: {
		is: { default: "div" },
		workspace: {},
		wrapperClass: {},
		avatarColor: { default: "primary" },
		windowName: {},
		iconMode: { default: "icon" },
		shortcut: {},
		badgeProps: { default: () => ({ iconMode: "icon" }) },
		tooltipProps: {}
	},
	setup(e) {
		let t = yt(), n = D(() => Object.keys(t).filter((e) => e.startsWith(gb)).reduce((e, n) => (e[n.replace(gb, "")] = t[n], e), {})), r = D(() => Object.keys(t).filter((e) => e.startsWith(_b)).reduce((e, n) => (e[n.replace(_b, "")] = t[n], e), {})), i = G(e, "HShortcut"), a = St(), { hubApiPath: o } = Vt(), { hHttpRequest: s } = Bt(), { oGetImage: c } = Qt(), l = D(() => !!a["badge-content"]), u = D(() => {
			let e = i.shortcut?.badge?.url;
			return {
				...i.shortcut,
				badgeData: e ? s({ url: e.replace("{{workspace.slug}}", i.workspace).replace("{{config.api.url}}", o) }).data : null
			};
		});
		function d(e) {
			return e ? e.startsWith("http") || e.startsWith("https") || e.startsWith("/") : !1;
		}
		return (t, i) => {
			let a = pt("h-action-link");
			return L(), O(un, F({ ...r.value }, {
				disabled: !u.value?.description,
				text: u.value?.description,
				location: u.value?.tooltipLocation ?? "top",
				class: "h-shortcut-item"
			}), {
				activator: W(({ props: r }) => [N(Jn, F({
					...n.value,
					...r
				}, {
					"model-value": l.value || (u.value.badgeData?.value?.meta?.totalresults || 0) > 0,
					class: "h-shortcut__wrapper " + e.wrapperClass
				}), {
					badge: W(() => [B(t.$slots, "badge-content", {
						shortcut: u.value,
						isImage: d(u.value?.icon)
					}, () => [u.value.badge?.icon && (n.value.iconMode === "image" || d(e.shortcut?.badge?.icon)) ? (L(), O(Yn, {
						key: 0,
						width: "15",
						class: "h-shortcut-item-badge-image",
						src: H(c)(e.shortcut?.badge?.icon ?? ""),
						alt: H(K)("image_alt_shortcut_badge")
					}, null, 8, ["src", "alt"])) : u.value.badge?.icon && n.value.iconMode === "icon" ? (L(), O(J, {
						key: 1,
						class: "h-shortcut-item-badge-icon",
						icon: e.shortcut?.badge?.icon
					}, null, 8, ["icon"])) : u.value.badgeData?.value?.meta?.totalresults ? (L(), A("div", pb, V(H(fb.millify)(u.value.badgeData?.value?.meta?.totalresults)), 1)) : k("", !0)])]),
					default: W(() => [N(a, {
						class: "h-shortcut-item-action-link w-100",
						to: u.value.link,
						target: u.value.target,
						"no-route": "",
						"window-name": e.windowName ?? e.shortcut?.key
					}, {
						default: W(() => [(L(), O(mt(e.is), F(t.$attrs, {
							key: u.value.key,
							class: "h-shortcut__content",
							link: !0
						}), {
							default: W(() => [B(t.$slots, "avatar", {
								icon: u.value?.icon,
								shortcut: u.value,
								isImage: d(u.value?.icon)
							}, () => [N(tr, {
								class: "h-shortcut__avatar",
								rounded: "0",
								variant: "text"
							}, {
								default: W(() => [e.iconMode === "image" || d(u.value?.icon) ? (L(), O(Yn, {
									key: 0,
									class: "h-shortcut-item-avatar-image",
									cover: "",
									src: H(c)(u.value?.icon ?? ""),
									alt: H(K)("image_alt_shortcut_icon")
								}, {
									placeholder: W(() => [j("div", { class: I(["d-flex align-center justify-center fill-height text-headline-medium rounded-circle", { [`bg-${e.avatarColor}`]: !0 }]) }, [B(t.$slots, "avatar-content", {}, () => [M(V(u.value?.title?.[0]), 1)])], 2)]),
									_: 3
								}, 8, ["src", "alt"])) : e.iconMode === "icon" ? (L(), A(E, { key: 1 }, [u.value?.icon ? (L(), O(J, {
									key: 0,
									class: "h-shortcut__icon",
									icon: u.value?.icon
								}, null, 8, ["icon"])) : (L(), A("span", mb, V(u.value?.title?.[0]), 1))], 64)) : k("", !0)]),
								_: 3
							})]), j("div", hb, [B(t.$slots, "title", {
								title: u.value?.title,
								shortcut: u.value
							}, () => [M(V(u.value?.title), 1)])])]),
							_: 3
						}, 16))]),
						_: 3
					}, 8, [
						"to",
						"target",
						"window-name"
					])]),
					_: 3
				}, 16, ["model-value", "class"])]),
				_: 3
			}, 16, [
				"disabled",
				"text",
				"location"
			]);
		};
	}
}), yb = { class: "d-flex align-center h-item-card__wrapper" }, bb = { class: "h-item-card__header" }, xb = { class: "h-item-card__title-action" }, Sb = { key: 1 }, Cb = { class: "h-item-card__body" }, wb = { class: "h-item-card__footer" }, Tb = { class: "left-control" }, Eb = { class: "h-item-card__right-control" }, Db = ["aria-expanded", "aria-label"], Ob = 1, kb = "action:", Ab = /* @__PURE__ */ P({
	__name: "item-card",
	props: {
		item: {},
		subtitle: { default: "" },
		tableData: {},
		showActionsOnCollapse: {
			type: Boolean,
			default: !0
		},
		hideBody: {
			type: Boolean,
			default: !1
		},
		alwaysExpand: {
			type: Boolean,
			default: !1
		},
		hideTooltip: {
			type: Boolean,
			default: !1
		},
		actionsMenu: { type: Boolean },
		windowName: {}
	},
	setup(e) {
		let t = G(e, "HItemCard"), n = yt(), r = St(), i = D(() => Object.keys(n).filter((e) => e.startsWith(kb)).reduce((e, t) => (e[t.replace(kb, "")] = n[t], e), {})), [a, o] = Ln(), s = D(() => t.item.action?.find((e) => e.primary)), c = D(() => s.value?.url), l = D(() => (r.body ? r.body() : []).length > 0 || !!t.tableData);
		return (t, n) => {
			let r = pt("h-action-link"), u = pt("h-theme-scope"), d = pt("h-menu");
			return L(), A("div", yb, [N(rn, { class: "h-item-card" }, {
				default: W(() => [N(on, null, {
					default: W(() => [
						j("div", bb, [N(pn, {
							class: "h-item-card__header-content",
							density: "compact"
						}, {
							default: W(() => [
								N(dn, {
									class: "h-item-card__title",
									md: "7",
									cols: "12"
								}, {
									default: W(() => [B(t.$slots, "title", { item: e.item }, () => [c.value ? (L(), O(r, {
										key: 0,
										to: c.value,
										target: s.value?.target,
										class: "h-item-card__button d-inline-flex",
										"no-route": "",
										"window-name": e.windowName ?? e.item.key
									}, {
										default: W(() => [N(ln, { class: "h-item-card-title" }, {
											default: W(() => [M(V(e.item.name), 1)]),
											_: 1
										}), j("div", xb, [N(J, { class: "h-item-card-title-action-icon" }, {
											default: W(() => [...n[1] ||= [M("mdi:mdi-chevron-right", -1)]]),
											_: 1
										})])]),
										_: 1
									}, 8, [
										"to",
										"target",
										"window-name"
									])) : (L(), A("div", Sb, [N(ln, { class: "h-item-card-title" }, {
										default: W(() => [M(V(e.item.name), 1)]),
										_: 1
									})]))]), N(sn, {
										class: "h-item-card__subtitle",
										subtitle: e.subtitle,
										item: e.item
									}, {
										default: W(() => [B(t.$slots, "subtitle", {}, () => [M(V(e.subtitle), 1)])]),
										_: 3
									}, 8, ["subtitle", "item"])]),
									_: 3
								}),
								N(mn, { class: "h-item-card-spacer" }),
								N(dn, {
									class: "h-item-card-header-col",
									md: "5",
									cols: "12"
								}, {
									default: W(() => [B(t.$slots, "header", { open: H(a) })]),
									_: 3
								})
							]),
							_: 3
						})]),
						j("div", Cb, [N(Kn, { class: "h-item-card-expand-transition" }, {
							default: W(() => [Tt(j("div", null, [j("div", null, [B(t.$slots, "body")])], 512), [[wt, H(a) || e.alwaysExpand]])]),
							_: 3
						})]),
						j("div", wb, [j("div", Tb, [B(t.$slots, "actions", { item: e.item }, () => [H(a) || e.showActionsOnCollapse ? (L(), A(E, { key: 0 }, [e.actionsMenu && e.item.action?.length > Ob ? (L(), O(d, {
							key: 0,
							class: "h-item-card-menu",
							"close-on-content-click": !1
						}, {
							activator: W(({ props: e }) => [N(u, F({
								name: "HScopedItemCardMenuBtn",
								component: H(lr),
								class: "h-item-card-menu-btn mr-2 mt-4"
							}, {
								...i.value,
								...e
							}), {
								default: W(() => [M(V(H(K)("select_ction")), 1)]),
								_: 1
							}, 16, ["component"])]),
							default: W(() => [N(Bn, { class: "h-item-card-menu-item__list" }, {
								default: W(() => [(L(!0), A(E, null, z(e.item.action?.filter((e) => !e.primary), (t, n) => (L(), O(r, {
									key: n,
									class: "h-item-card-menu-item__link",
									to: t.url,
									target: t.target,
									"no-route": "",
									"window-name": e.windowName ?? e.item.key
								}, {
									default: W(() => [N(un, {
										class: "h-item-card-tooltip",
										disabled: !t?.description || e.hideTooltip,
										text: t?.description,
										location: t?.tooltipLocation ?? "bottom",
										"max-width": "600"
									}, {
										activator: W(({ props: e }) => [(L(), O(Hn, F({ ref_for: !0 }, { ...e }, {
											key: n,
											class: "h-item-card-menu-item",
											value: n,
											role: "option"
										}), {
											default: W(() => [N(Wn, { class: "h-item-card-menu-item__title" }, {
												default: W(() => [M(V(t.name), 1)]),
												_: 2
											}, 1024)]),
											_: 2
										}, 1040, ["value"]))]),
										_: 2
									}, 1032, [
										"disabled",
										"text",
										"location"
									])]),
									_: 2
								}, 1032, [
									"to",
									"target",
									"window-name"
								]))), 128))]),
								_: 1
							})]),
							_: 1
						})) : (L(!0), A(E, { key: 1 }, z(e.item.action?.filter((e) => !e.primary), (t, n) => (L(), O(r, {
							key: n,
							to: t.url,
							target: t.target,
							"no-route": "",
							"window-name": e.windowName ?? e.item.key
						}, {
							default: W(() => [N(un, {
								class: "h-item-card-action-tooltip",
								disabled: !t?.description || e.hideTooltip,
								text: t?.description,
								location: t?.tooltipLocation ?? "bottom",
								"max-width": "600"
							}, {
								activator: W(({ props: e }) => [(L(), O(u, F({ ref_for: !0 }, {
									...i.value,
									...e
								}, {
									key: t.id,
									name: "HScopedItemCardActionBtn",
									component: H(lr),
									color: "primary",
									class: "h-item-card-action-btn mr-2 mt-4"
								}), {
									default: W(() => [M(V(t.name), 1)]),
									_: 2
								}, 1040, ["component"]))]),
								_: 2
							}, 1032, [
								"disabled",
								"text",
								"location"
							])]),
							_: 2
						}, 1032, [
							"to",
							"target",
							"window-name"
						]))), 128))], 64)) : k("", !0)]), B(t.$slots, "footer", { item: e.item })]), j("div", Eb, [B(t.$slots, "rightControl", { item: e.item }, () => [l.value && !e.hideBody && !e.alwaysExpand ? (L(), A("button", {
							key: 0,
							class: "flex d-flex align-end space-x-3 h-item-card__toggle-button",
							"aria-expanded": H(a),
							"aria-label": e.item.name,
							onClick: n[0] ||= (e) => H(o)()
						}, [N(J, { class: I(["h-item-card__arrow", {
							"rotate-180": H(a),
							"rotate-0": !H(a)
						}]) }, {
							default: W(() => [...n[2] ||= [M(" mdi:mdi-chevron-down ", -1)]]),
							_: 1
						}, 8, ["class"])], 8, Db)) : k("", !0)])])])
					]),
					_: 3
				})]),
				_: 3
			})]);
		};
	}
}), jb = { class: "h-100 w-100 d-flex justify-center align-center flex-column ga-2 font-weight-medium text-center loader" }, Mb = {
	key: 0,
	class: "d-flex w-100 h-100 justify-center align-center flex-column ga-2 font-weight-medium text-center h-component-loader__content loader"
}, Nb = /* @__PURE__ */ P({
	__name: "loader",
	props: /*@__PURE__*/ rt({
		fullScreen: {
			type: Boolean,
			default: !0
		},
		percentage: {},
		text: {},
		size: { default: 100 },
		width: { default: 15 },
		rotate: { default: 360 },
		color: {},
		textColor: { default: "primary" },
		bgColor: {}
	}, {
		isLoading: {
			type: Boolean,
			default: !1
		},
		isLoadingModifiers: {}
	}),
	emits: ["update:isLoading"],
	setup(e) {
		let t = G(e, "HLoader"), n = xt(e, "isLoading"), r = D(() => ar().current.value.colors[t.textColor] ?? t.textColor), i = D(() => ({
			indeterminate: t.percentage === void 0,
			...t.percentage !== void 0 && { modelValue: t.percentage },
			...t
		}));
		return (t, a) => (L(), A(E, null, [e.fullScreen ? (L(), O(Cr, {
			key: 0,
			modelValue: n.value,
			"onUpdate:modelValue": a[0] ||= (e) => n.value = e,
			height: "100%",
			width: "100%",
			class: "h-page-loader"
		}, {
			default: W(() => [j("div", jb, [N(wr, F({ class: "h-loader-full-screen-progress" }, i.value), {
				default: W(() => [i.value.indeterminate ? k("", !0) : (L(), A("span", {
					key: 0,
					class: I(["h-page-loader__percentage", { "opacity-20": e.percentage < 5 }]),
					style: ot({ color: r.value })
				}, V(e.percentage) + " % ", 7))]),
				_: 1
			}, 16), j("span", {
				class: "h-page-loader__text",
				style: ot({ color: r.value })
			}, V(i.value.text), 5)])]),
			_: 1
		}, 8, ["modelValue"])) : k("", !0), N(Cr, {
			modelValue: n.value,
			"onUpdate:modelValue": a[1] ||= (e) => n.value = e,
			width: "100%",
			height: "100%",
			class: "h-loader-contained-overlay align-center justify-center",
			contained: ""
		}, {
			default: W(() => [e.fullScreen ? k("", !0) : (L(), A("div", Mb, [N(wr, F({ class: "h-loader-contained-progress" }, i.value), {
				default: W(() => [i.value.indeterminate ? k("", !0) : (L(), A("span", {
					key: 0,
					class: "h-page-loader__percentage",
					style: ot({ color: r.value })
				}, V(e.percentage) + " % ", 5))]),
				_: 1
			}, 16), j("div", {
				class: "h-page-loader__text",
				style: ot({ color: r.value })
			}, V(i.value.text), 5)]))]),
			_: 1
		}, 8, ["modelValue"])], 64));
	}
}), Pb = { class: "h-countdown-timer" }, Fb = { class: "h-countdown-timer__hours" }, Ib = {
	key: 0,
	class: "h-countdown-timer__label"
}, Lb = {
	key: 1,
	class: "h-countdown-timer__separator"
}, Rb = { class: "h-countdown-timer__minutes" }, zb = {
	key: 0,
	class: "h-countdown-timer__label"
}, Bb = {
	key: 1,
	class: "h-countdown-timer__separator"
}, Vb = { class: "h-countdown-timer__seconds" }, Hb = {
	key: 0,
	class: "h-countdown-timer__label"
}, Ub = /*#__PURE__*/ Y(/* @__PURE__ */ Object.assign({ name: "HCountdownTimer" }, {
	__name: "countdown-timer",
	props: {
		seconds: {
			type: Number,
			required: !0,
			validator: (e) => e >= 0
		},
		autoStart: {
			type: Boolean,
			default: !0
		},
		showHours: {
			type: Boolean,
			default: !0
		},
		showMinutes: {
			type: Boolean,
			default: !0
		},
		showSeconds: {
			type: Boolean,
			default: !0
		},
		showLabels: {
			type: Boolean,
			default: !1
		},
		separator: {
			type: String,
			default: ":"
		},
		customDefaults: {
			type: Object,
			default: void 0
		}
	},
	emits: [
		"update:seconds",
		"complete",
		"tick"
	],
	setup(e, { expose: t, emit: n }) {
		let r = n, i = G(e, "HCountdownTimer"), a = R(i.seconds), o = R(!1), s = null;
		U(() => i.seconds, (e) => {
			o.value || (a.value = e);
		});
		let c = D(() => Math.floor(a.value / 3600)), l = D(() => Math.floor(a.value % 3600 / 60)), u = D(() => a.value % 60), d = D(() => String(c.value).padStart(2, "0")), f = D(() => String(l.value).padStart(2, "0")), p = D(() => String(u.value).padStart(2, "0")), m = D(() => c.value === 1 ? K("time_hour") : K("time_hours")), h = D(() => l.value === 1 ? K("time_minute") : K("time_minutes")), g = D(() => u.value === 1 ? K("time_second") : K("time_seconds")), _ = () => {
			o.value || a.value <= 0 || (o.value = !0, s = setInterval(() => {
				a.value > 0 && (a.value--, r("update:seconds", a.value), r("tick", {
					hours: c.value,
					minutes: l.value,
					seconds: u.value
				}), a.value === 0 && (v(), r("complete")));
			}, 1e3));
		}, v = () => {
			o.value = !1, s &&= (clearInterval(s), null);
		}, y = () => {
			v(), a.value = i.seconds, r("update:seconds", a.value);
		};
		return lt(() => {
			i.autoStart && _();
		}), st(() => {
			v();
		}), t({
			start: _,
			pause: v,
			reset: y,
			restart: () => {
				y(), _();
			},
			isRunning: D(() => o.value),
			remainingSeconds: D(() => a.value)
		}), (t, n) => (L(), A("div", Pb, [
			e.showHours ? (L(), A(E, { key: 0 }, [
				j("span", Fb, V(d.value), 1),
				e.showLabels ? (L(), A("span", Ib, V(m.value), 1)) : k("", !0),
				!e.showLabels && (e.showMinutes || e.showSeconds) ? (L(), A("span", Lb, V(e.separator), 1)) : k("", !0)
			], 64)) : k("", !0),
			e.showMinutes ? (L(), A(E, { key: 1 }, [
				j("span", Rb, V(f.value), 1),
				e.showLabels ? (L(), A("span", zb, V(h.value), 1)) : k("", !0),
				!e.showLabels && e.showSeconds ? (L(), A("span", Bb, V(e.separator), 1)) : k("", !0)
			], 64)) : k("", !0),
			e.showSeconds ? (L(), A(E, { key: 2 }, [j("span", Vb, V(p.value), 1), e.showLabels ? (L(), A("span", Hb, V(g.value), 1)) : k("", !0)], 64)) : k("", !0)
		]));
	}
}), [["__scopeId", "data-v-0d79665f"]]), Wb = { class: "h-process-item-tooltip__title" }, Gb = /* @__PURE__ */ P({
	__name: "process-state",
	props: {
		process: {},
		tooltipClass: {},
		mobileBreakpoint: {}
	},
	setup(e) {
		let { thresholds: t } = ir(), n = G(e, "HProcessState"), r = R(!1), i = $t(), a = D(() => t.value[n.mobileBreakpoint ?? i?.default_mobile_breakpoint?.value ?? "md"]), o = R(null);
		function s(e) {
			return e.icon ? e.icon : e.result?.skipped ? "mdi:mdi-chevron-double-right" : "mdi-blank";
		}
		Fn(o, (e) => {
			requestAnimationFrame(() => {
				r.value = (e[0].contentBoxSize?.[0]?.inlineSize ?? 0) < a.value;
			});
		});
		let c = D(() => n.process?.slice().sort((e, t) => e.order - t.order).filter((e) => !e.result?.done && !e.result?.skipped)[0]?.order);
		return (t, n) => (L(), O(Tr, {
			ref_key: "processStateEl",
			ref: o,
			modelValue: c.value,
			"onUpdate:modelValue": n[0] ||= (e) => c.value = e,
			class: "h-process-stepper",
			"alt-labels": !r.value,
			mobile: r.value,
			flat: !0,
			style: ot({ "--step-count": e.process.length })
		}, {
			default: W(() => [N(Er, { class: "h-process-state-header" }, {
				default: W(() => [(L(!0), A(E, null, z(e.process, (t, n) => (L(), A(E, { key: t.id || n }, [n ? (L(), O(er, {
					key: 0,
					class: "h-process-state-divider",
					thickness: ""
				})) : k("", !0), N(un, {
					class: I(["h-process-item-tooltip", {
						[e.tooltipClass ?? ""]: !!e.tooltipClass,
						"h-process-item-tooltip--hide": t.hide,
						"h-process-item-tooltip--error": !!t.result?.error,
						"h-process-item-tooltip--skipped": !!t.result?.skipped,
						"h-process-item-tooltip--active": t.order === c.value,
						"h-process-item-tooltip--inactive": !t.result?.done && !t.result?.skipped && !t.result?.error && t.order !== c.value,
						"h-process-item-tooltip--done": !!t.result?.done
					}]),
					"open-on-hover": r.value,
					"open-on-click": r.value,
					location: "bottom"
				}, {
					default: W(() => [j("div", null, [j("div", Wb, V(t.name), 1), j("div", null, V(t.result?.statusmessage), 1)])]),
					activator: W(({ props: e }) => [N(Dr, F({ ref_for: !0 }, e, {
						value: t.order,
						icon: s(t),
						complete: !!t.result?.done,
						"complete-icon": t.completeIcon,
						"edit-icon": t.editIcon ?? s(t),
						"error-icon": t.errorIcon ?? "mdi:mdi-exclamation",
						title: t.name,
						subtitle: t.result?.statusmessage,
						rules: t.result?.error ? [() => !1] : void 0,
						editable: r.value,
						class: ["h-process-item", {
							"h-process-item--hide": t.hide,
							"h-process-item--error": t.result?.error,
							"h-process-item--skipped": t.result?.skipped,
							"h-process-item--active": t.order === c.value,
							"h-process-item--inactive": !t.result?.done && !t.result?.skipped && !t.result?.error && t.order !== c.value,
							"h-process-item--done": t.result?.done
						}],
						"aria-label": t.name
					}), null, 16, [
						"value",
						"icon",
						"complete",
						"complete-icon",
						"edit-icon",
						"error-icon",
						"title",
						"subtitle",
						"rules",
						"editable",
						"aria-label",
						"class"
					])]),
					_: 2
				}, 1032, [
					"open-on-hover",
					"open-on-click",
					"class"
				])], 64))), 128))]),
				_: 1
			})]),
			_: 1
		}, 8, [
			"modelValue",
			"alt-labels",
			"mobile",
			"style"
		]));
	}
}), Kb = { class: "tooltip-message" }, qb = /*#__PURE__*/ Y({
	__name: "process-state-simple",
	props: {
		result: Object,
		item: Object,
		maxVisible: {
			type: Number,
			default: Infinity
		}
	},
	setup(e) {
		let t = G(e, "HProcessStateSimple"), n = R(!1), r = D(() => n.value ? a.value : a.value.slice(0, t.maxVisible)), i = D(() => t.item || t.result || {}), a = D(() => (i.value?.state || []).filter((e) => !e.hide).map((e, t) => ({
			id: e.id || `step-${t}`,
			order: e.order ?? t + 1,
			name: e.name || `Step ${t + 1}`,
			status: e.status?.name || "Running",
			result: e.result || {}
		})));
		function o(e) {
			return e.result?.done ? "mini-stepper__step--step-done" : e.result?.error ? "mini-stepper__step--step-error" : e.status === "Running" && !e.result?.done ? "mini-stepper__step--process-running" : i.value?.status?.name === "Completed" ? "mini-stepper__step--process-completed" : i.value?.status?.name === "Stopped" ? "mini-stepper__step--process-stopped" : "mini-stepper__step--default";
		}
		function s(e) {
			return e.status === "Running" && !e.result?.done;
		}
		return (t, i) => (L(), O(fn, { class: "mini-stepper-container h-process-state-simple-main-container" }, {
			default: W(() => [N(Tr, { class: "mini-stepper h-process-state-simple-main-stepper" }, {
				default: W(() => [N(Er, { class: "mini-stepper-header h-process-state-simple-stepper-header" }, {
					default: W(() => [(L(!0), A(E, null, z(r.value, (e, t) => (L(), O(un, {
						key: e.id || t,
						location: "top",
						class: "h-process-state-simple-step-tooltip"
					}, {
						activator: W(({ props: t }) => [j("div", F({ class: ["mini-stepper__step-wrapper", { "mini-stepper__step-wrapper--current": s(e) }] }, { ref_for: !0 }, t), [j("div", { class: I(["mini-stepper__step", { [o(e)]: !0 }]) }, null, 2)], 16)]),
						default: W(() => [j("span", Kb, V(e.name || "No Name"), 1)]),
						_: 2
					}, 1024))), 128)), a.value.length > e.maxVisible ? (L(), O(qn, {
						key: 0,
						size: "small",
						variant: "outlined",
						onClick: i[0] ||= (e) => n.value = !n.value
					}, {
						default: W(() => [M(V(n.value ? "‹" : `+${a.value.length - e.maxVisible}`), 1)]),
						_: 1
					})) : k("", !0)]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}));
	}
}, [["__scopeId", "data-v-18021271"]]);
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
var Jb = (e, t) => (e = Math.ceil(e), t = Math.floor(t), Math.floor(Math.random() * (t - e + 1)) + e), Yb = {
	key: 0,
	class: "h-search-items-dialog"
}, Xb = { class: "h-search-items-dialog__header" }, Zb = { class: "text-headline-small" }, Qb = { class: "d-flex justify-space-between w-100 px-4 py-1" }, $b = { class: "h-search-items-dialog__results" }, ex = { class: "h-search-items-dialog__results-count" }, tx = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "search-dialog",
	props: {
		searching: { type: Boolean },
		term: {},
		searchProps: {},
		workspace: {},
		filter: {},
		pagesize: {},
		sort: {}
	},
	emits: ["update:searching", "update:term"],
	setup(e, { emit: t }) {
		let n = G(e, "HSearchItemsDialog"), { searching: r, term: i } = zn(n, t), { hHttpRequest: a } = Bt(), { data: o } = a({
			url: `my/workspaces/${n.workspace}`,
			immediate: !!n.workspace
		}, { throwHttpErrors: !1 }), s = R(K("what_are_you_looking_for")), c = D(() => o?.value?.help?.searchtext ?? []), { pause: l } = Pn(() => {
			if (!c.value.length) {
				l();
				return;
			}
			s.value = c.value[Jb(0, c.value.length - 1)];
		}, 2e3), { params: u, data: d, loading: f } = a({
			url: `/my/items/${n.workspace}`,
			params: {
				term: (e) => e?.trim() || "*",
				filter: n.filter,
				pagesize: n.pagesize,
				sort: n.sort
			},
			isLive: !0,
			immediate: !1
		}, { throwHttpErrors: !1 });
		return U(r, (e) => {
			e && i.value && (u.term = i.value);
		}, { immediate: !0 }), U(() => u.term, () => {
			i.value = u.term;
		}), ut(() => {
			i.value = null;
		}), (t, i) => {
			let a = pt("h-search-items-results");
			return L(), O(nr, {
				modelValue: H(r),
				"onUpdate:modelValue": i[2] ||= (e) => tt(r) ? r.value = e : null,
				class: "h-search-dialog-main-dialog",
				"aria-label": H(K)("search_items")
			}, {
				default: W(() => [H(r) ? (L(), A("div", Yb, [
					j("div", Xb, [j("h2", Zb, V(H(K)("search")), 1), N(q, {
						class: "h-search-items-dialog__close",
						icon: "mdi:mdi-close",
						variant: "text",
						"aria-label": H(K)("close-dialog"),
						onClick: i[0] ||= (e) => r.value = !1
					}, null, 8, ["aria-label"])]),
					B(t.$slots, "inner-search", { searchData: e.searchProps }, () => [N(hn, F({
						modelValue: H(u).term,
						"onUpdate:modelValue": i[1] ||= (e) => H(u).term = e
					}, { ...H(n).searchProps }, {
						variant: "solo",
						density: "compact",
						"single-line": !0,
						flat: !0,
						class: "h-search-items-dialog__field",
						placeholder: s.value,
						"hide-details": "",
						autofocus: "",
						loading: H(f)
					}), null, 16, [
						"modelValue",
						"placeholder",
						"loading"
					])], !0),
					H(d) === null || H(d) === void 0 ? k("", !0) : (L(), O(rn, {
						key: 0,
						class: "mt-2 h-search-items-dialog__items"
					}, {
						default: W(() => [N(on, { class: "h-search-dialog-results-card-item pa-0 flex-grow-1" }, {
							default: W(() => [N(ln, { class: "h-search-items-dialog__title" }, {
								default: W(() => [j("div", Qb, [j("div", $b, V(H(K)("search_results")), 1), j("div", ex, V(H(d)?.meta?.totalresults) + " " + V(H(K)("search_hits")), 1)]), N(er, {
									class: "h-search-dialog-results-divider",
									thickness: "1"
								})]),
								_: 1
							}), B(t.$slots, "items", {}, () => [N(a, {
								items: H(d)?.records,
								workspace: e.workspace
							}, null, 8, ["items", "workspace"])], !0)]),
							_: 3
						})]),
						_: 3
					}))
				])) : k("", !0)]),
				_: 3
			}, 8, ["modelValue", "aria-label"]);
		};
	}
}), [["__scopeId", "data-v-2ddc266e"]]), nx = { class: "h-search-items" }, rx = /* @__PURE__ */ P({
	__name: "search-activator",
	props: {
		workspace: {},
		persist: {
			type: Boolean,
			default: !1
		},
		showDialog: {
			type: Boolean,
			default: !0
		},
		filter: {},
		pagesize: {},
		sort: {}
	},
	emits: ["update:searching"],
	setup(e, { emit: t }) {
		G(e, "HSearchItems");
		let n = On(), r = Jt("search"), i = R(""), [a, o] = Ln();
		return U(n, () => {
			a.value = !1;
		}), (t, n) => (L(), A("div", nx, [B(t.$slots, "activator", {
			searchProps: H(r),
			toggleSearching: H(o)
		}, () => [N(hn, F({ ...H(r) }, {
			id: "searchItemsActivator",
			modelValue: i.value,
			"onUpdate:modelValue": n[0] ||= (e) => i.value = e,
			"hide-details": "",
			"aria-label": H(K)("search"),
			class: "h-search-activator-text-field",
			onClick: n[1] ||= (e) => H(o)(!0),
			onKeydown: n[2] ||= Et(Dt((e) => H(o)(!0), ["prevent"]), ["enter"])
		}), null, 16, ["modelValue", "aria-label"])]), e.showDialog ? B(t.$slots, "dialog", {
			key: 0,
			term: i.value,
			workspace: e.workspace,
			searching: H(a),
			searchProps: H(r),
			persist: e.persist,
			filter: e.filter,
			pagesize: e.pagesize,
			sort: e.sort
		}, () => [H(a) || e.persist ? (L(), O(tx, {
			key: 0,
			term: i.value,
			"onUpdate:term": n[3] ||= (e) => i.value = e,
			searching: H(a),
			"onUpdate:searching": n[4] ||= (e) => tt(a) ? a.value = e : null,
			workspace: e.workspace ?? "",
			"search-props": H(r),
			persist: e.persist,
			filter: e.filter,
			pagesize: e.pagesize,
			sort: e.sort
		}, null, 8, [
			"term",
			"searching",
			"workspace",
			"search-props",
			"persist",
			"filter",
			"pagesize",
			"sort"
		])) : k("", !0)]) : k("", !0)]));
	}
}), ix = /* @__PURE__ */ new Map();
function ax(e) {
	let t = ix.get(e);
	if (t) return t;
	let n = nt(Xe(e));
	return ix.set(e, n), n;
}
//#endregion
//#region src/components/general/item-card-template.vue
var ox = /* @__PURE__ */ P({
	__name: "item-card-template",
	props: {
		item: {},
		template: {}
	},
	setup(e) {
		let t = G(e, "HItemCardResolver"), n = D(() => i()), { resolveItemCard: r } = zt();
		function i() {
			let e = r(t.template ?? t.item.type ?? "");
			return e ? typeof e == "function" ? ax(e) : nt(e.default ?? e) : Ab;
		}
		return (e, r) => (L(), O(mt(n.value), {
			key: H(t).item?.key,
			item: H(t).item
		}, Ye({ _: 2 }, [z(e.$slots, (t, n) => ({
			name: n,
			fn: W(() => [B(e.$slots, n)])
		}))]), 1032, ["item"]));
	}
}), sx = { class: "h-search-items-results__row" }, cx = {
	key: 0,
	class: "h-search-items__no-results text-center w-100 mt-4"
}, lx = { class: "h-search-items-results__list" }, ux = ["aria-expanded", "aria-selected"], dx = { class: "w-100 h-100 d-flex justify-center align-center" }, fx = { class: "search-items-item__preview pb-4" }, px = {
	key: 1,
	class: "h-search-items-results__preview-wrapper"
}, mx = { class: "h-search-items-results__preview" }, hx = { class: "h-search-items-preview" }, gx = /* @__PURE__ */ P({
	__name: "search-results",
	props: { items: {} },
	setup(e) {
		let t = e;
		G(t, "HSearchItemsResults");
		let { oGetImage: n } = Qt(), { xs: r } = ir(), i = R({}), a = R(), o = D(() => r ? 40 : 60);
		U(D(() => t.items || []), () => {
			a.value = null;
		});
		function s(e) {
			return r.value && !!i.value[e.key];
		}
		function c(e) {
			return !r.value && a.value?.key === e.key;
		}
		function l(e) {
			i.value[e.key] = !i.value[e.key];
		}
		function u(e) {
			a.value = e;
		}
		return (t, i) => (L(), A("div", sx, [
			e.items?.length ? k("", !0) : (L(), A("div", cx, [N(J, {
				class: "h-search-items__no-results-icon",
				icon: "mdi:mdi-alert"
			}), j("h4", null, V(H(K)("no_results_found")), 1)])),
			j("div", lx, [e.items?.length ? (L(), O(Bn, {
				key: 0,
				class: "pt-0"
			}, {
				default: W(() => [(L(!0), A(E, null, z(e.items, (e) => (L(), A("div", {
					key: e.id || e.key,
					class: I(["h-search-items-item mb-sm-2", { "h-search-items-item--expanded": s(e) || c(e) }]),
					"aria-expanded": s(e),
					"aria-selected": c(e),
					role: "option"
				}, [j("div", null, [N(Hn, {
					class: "h-search-items-item__list-item",
					tabindex: H(r) ? -1 : 0,
					title: e.name,
					subtitle: e.description,
					onMouseover: (t) => u(e),
					onFocus: (t) => u(e)
				}, Ye({
					prepend: W(() => [N(Yn, {
						src: H(n)(e.icon ?? ""),
						width: o.value,
						height: o.value,
						class: "h-search-items-item__image rounded mr-4"
					}, {
						placeholder: W(() => [j("div", dx, [N(J, {
							class: "h-search-results-item-placeholder-icon",
							icon: "mdi:mdi-help-box",
							size: "large"
						}, {
							default: W(() => [M(V(e.icon), 1)]),
							_: 2
						}, 1024)])]),
						_: 2
					}, 1032, [
						"src",
						"width",
						"height"
					])]),
					_: 2
				}, [H(r) ? {
					name: "append",
					fn: W(() => [N(q, {
						icon: s(e) ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down",
						class: "h-search-items-item__show-more",
						variant: "text",
						rounded: !1,
						width: "30",
						onClick: (t) => l(e)
					}, null, 8, ["icon", "onClick"])]),
					key: "0"
				} : void 0]), 1032, [
					"tabindex",
					"title",
					"subtitle",
					"onMouseover",
					"onFocus"
				]), Tt(j("div", fx, [N(ox, {
					class: "search-items-item__preview-card",
					item: e,
					"action:density": "compact",
					"always-expand": !0
				}, null, 8, ["item"])], 512), [[wt, s(e)]])])], 10, ux))), 128))]),
				_: 1
			})) : k("", !0)]),
			!H(r) && a.value && e.items?.length > 0 ? (L(), A("div", px, [j("div", mx, [j("div", hx, [(L(), O(Je, null, [(L(), O(ox, {
				key: a.value.key,
				item: a.value,
				"always-expand": !0
			}, null, 8, ["item"]))], 1024))])])])) : k("", !0)
		]));
	}
}), _x = /* @__PURE__ */ function(e) {
	return e.New = "new", e.Read = "read", e;
}({}), vx = { class: "h-notification-item" }, yx = { class: "h-notification-item__type" }, bx = { class: "h-notification-item__time" }, xx = /* @__PURE__ */ P({
	__name: "notification-item",
	props: { notification: {} },
	emits: ["updateStatus"],
	setup(e, { emit: t }) {
		G(e, "HNotificationItem");
		let n = t;
		async function r(e, t) {
			n("updateStatus", e, t);
		}
		return (t, n) => (L(), A("div", vx, [
			N(q, {
				id: "btn-read",
				class: "h-notification-item-read-btn",
				"aria-label": "mark_as_read",
				onClick: n[0] ||= Dt((t) => r(e.notification.id, e.notification.status === H(_x).New ? H(_x).Read : H(_x).New), ["stop"])
			}, {
				default: W(() => [N(J, { class: "h-notification-item-read-icon" }), N(un, {
					class: "h-notification-tooltip",
					activator: "parent"
				}, {
					default: W(() => [M(V(e.notification.status === "read" ? H(K)("mark_as_unread") : H(K)("mark_as_read")), 1)]),
					_: 1
				})]),
				_: 1
			}),
			j("span", yx, V(e.notification.title), 1),
			n[1] ||= M("  •  ", -1),
			j("span", bx, V(e.notification.timeAgo), 1),
			j("div", { class: I(["h-notification-item__title mt-1", { "read-all": e.notification.status === "read" }]) }, V(e.notification.message), 3)
		]));
	}
}), Sx = { class: "h-notification-drawer" }, Cx = { id: "btn-notif-actions" }, wx = /* @__PURE__ */ P({
	__name: "notification-drawer",
	props: /*@__PURE__*/ rt({
		title: { default: "Notifications" },
		location: { default: "right" },
		width: { default: 400 },
		notificationData: { default: () => ({
			records: [],
			aggregations: { status_count: {
				doc_count_error_upper_bound: 0,
				sum_other_doc_count: 0,
				buckets: []
			} }
		}) }
	}, {
		modelValue: { type: Boolean },
		modelModifiers: {}
	}),
	emits: /*@__PURE__*/ rt([
		"getUnreadCount",
		"markAllAsRead",
		"updateStatus"
	], ["update:modelValue"]),
	setup(e, { emit: t }) {
		let n = G(e, "HNotificationDrawer"), r = qt(), { oUserSettings: i } = Rr(en()), a = t, o = xt(e, "modelValue"), s = R({}), c = An(async () => {
			let e = [];
			for (let t of n.notificationData.records) {
				let n = new Date(t.timestamp || t.createdate), a = await f(i.value?.settings?.locale || H(r));
				e.push({
					...t,
					timeAgo: Ar(n, /* @__PURE__ */ new Date(), {
						addSuffix: !0,
						locale: a
					})
				});
			}
			return e;
		});
		async function l() {
			a("markAllAsRead");
		}
		async function u(e, t) {
			a("updateStatus", e, t);
		}
		function d() {
			for (let e in s.value) s.value[e] = !1;
		}
		function f(e) {
			let t = {
				en: Fr,
				enUS: Fr,
				fi: Ir,
				sv: Lr
			};
			return t[e] ?? t[e?.split("-")[0]] ?? Fr;
		}
		return (t, n) => {
			let r = pt("h-theme-scope");
			return L(), A("div", Sx, [N(br, {
				modelValue: o.value,
				"onUpdate:modelValue": n[2] ||= (e) => o.value = e,
				location: "right",
				class: "h-notifications-panel bg-background",
				width: e.width,
				temporary: ""
			}, {
				default: W(() => [
					N(Hn, {
						title: e.title,
						class: "h-notification-drawer-header-list-item header bg-surface"
					}, {
						default: W(() => [j("div", Cx, [N(r, {
							name: "HScopedNotificationDrawerMarkAllBtn",
							component: H(lr),
							class: "h-notification-drawer-mark-all-btn mr-2",
							onClick: n[0] ||= (e) => l()
						}, {
							default: W(() => [M(V(H(K)("mark_all_as_read")), 1)]),
							_: 1
						}, 8, ["component"]), N(r, {
							name: "HScopedNotificationDrawerCloseBtn",
							component: H(lr),
							class: "h-notification-drawer-close-btn",
							"aria-label": "collapse_notifications",
							onClick: n[1] ||= (e) => {
								o.value = !1, d();
							}
						}, null, 8, ["component"])])]),
						_: 1
					}, 8, ["title"]),
					N(er, { class: "h-notification-drawer-divider" }),
					(L(!0), A(E, null, z(H(c), (e) => (L(), O(Hn, {
						key: e.id,
						link: "",
						class: I(["h-notification-drawer-notification-list-item notification bg-surface mx-6 my-3", { unread: e.status === H(_x).New }]),
						elevation: 1,
						onClick: (t) => u(e.id, e.status === H(_x).New ? H(_x).Read : H(_x).New)
					}, {
						default: W(() => [B(t.$slots, "item", { notification: e }, () => [t.$slots.item ? k("", !0) : (L(), O(xx, {
							key: 0,
							class: "h-100",
							notification: e,
							onUpdateStatus: u
						}, null, 8, ["notification"]))])]),
						_: 2
					}, 1032, ["class", "onClick"]))), 128))
				]),
				_: 3
			}, 8, ["modelValue", "width"])]);
		};
	}
}), Tx = /* @__PURE__ */ P({
	__name: "notification-badge",
	props: {
		aggregations: { default: () => ({ status_count: {
			doc_count_error_upper_bound: 0,
			sum_other_doc_count: 0,
			buckets: []
		} }) },
		color: {}
	},
	setup(e) {
		let t = G(e, "HNotificationBadge"), n = R(!1);
		function r() {
			n.value = !0;
		}
		let i = D(() => t.aggregations.status_count.buckets.find((e) => e.key === _x.New)?.doc_count || 0);
		return (t, n) => (L(), O(q, {
			id: "btn-notification",
			icon: "",
			class: "h-notification-badge",
			"aria-label": H(K)("notifications"),
			onClick: r
		}, {
			default: W(() => [i.value > 0 ? (L(), O(Jn, {
				key: 0,
				color: e.color,
				bordered: "",
				class: "h-notification-badge-count-badge"
			}, {
				badge: W(() => [j("span", null, V(i.value), 1)]),
				default: W(() => [N(J, { class: "h-notification-badge-icon" }, {
					default: W(() => [...n[0] ||= [M("mdi:mdi-bell-outline", -1)]]),
					_: 1
				})]),
				_: 1
			}, 8, ["color"])) : (L(), O(J, {
				key: 1,
				class: "h-notification-badge-unread-icon"
			}, {
				default: W(() => [...n[1] ||= [M("mdi:mdi-bell-outline", -1)]]),
				_: 1
			}))]),
			_: 1
		}, 8, ["aria-label"]));
	}
}), Ex = ["src", "alt"], Dx = { key: 1 }, Ox = /*#__PURE__*/ Y({
	__name: "onify-logo",
	props: {
		alt: String,
		fallbackSrc: String,
		src: {
			type: String,
			default: ""
		}
	},
	setup(e) {
		let t = e, n = ar(), r = R([]), i = D(() => n?.global?.current?.value?.dark), a = D(() => {
			let e = At();
			return t.src || Ft(e, Ot) || Ft(e, Pt);
		}), o = D(() => [a.value, t.fallbackSrc || "data:image/png;base64,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"].find((e) => e && !r.value.includes(e)));
		return (t, n) => (L(), A("div", { class: I(["h-onify-logo", {
			"h-onify-logo--dark": i.value,
			"h-onify-logo--custom": o.value && o.value === a.value
		}]) }, [o.value ? (L(), A("img", {
			key: 0,
			class: "h-onify-logo__image",
			src: o.value,
			alt: e.alt ?? "Onify Logo",
			onError: n[0] ||= (e) => r.value.push(o.value)
		}, null, 40, Ex)) : (L(), A("span", Dx, V(e.alt), 1))], 2));
	}
}, [["__scopeId", "data-v-785017e3"]]), kx = { key: 1 }, Ax = {
	key: 1,
	class: "h-layout__logo"
}, jx = { key: 2 }, Mx = { class: "mr-2" }, Nx = { key: 1 }, Px = { key: 2 }, Fx = /* @__PURE__ */ P({
	__name: "navigation-menu",
	props: /*@__PURE__*/ rt({
		workspaceSlug: {},
		loading: { type: Boolean },
		adminDesign: { type: Boolean },
		activePath: {}
	}, {
		modelValue: { type: Boolean },
		modelModifiers: {},
		loading: {},
		loadingModifiers: {}
	}),
	emits: ["update:modelValue", "update:loading"],
	setup(e) {
		let t = G(e, "HNavigationMenu"), n = xt(e, "modelValue"), r = R([]);
		function i(e) {
			try {
				return new URL(e, window.location.origin).pathname === t.activePath;
			} catch {
				return !1;
			}
		}
		U(n, (e) => {
			e && t.adminDesign && (r.value = t.activePath?.includes("/admin/connector/") ? ["administration", "connector"] : ["administration"]);
		});
		let a = xt(e, "loading");
		a.value = !0;
		let o = Vt().hubAppUrl.replace(/\/$/, ""), s = o, c = $t(), { adminResourcesEnabled: l } = It(), { isAdminLinkAvailable: u } = Lt(), { oUserSettings: d } = Rr(en()), { hHttpRequest: f } = Bt(), { oGetImage: p } = Qt(), m = `${s}/admin/dashboard`, { data: h, loading: g } = f({ url: "/my/workspaces" }), { data: _, execute: v, loading: y } = f({
			url: () => `/my/shortcuts/workspace/${t.workspaceSlug}?pagesize=50`,
			precondition: () => !!t.workspaceSlug
		}), { data: b } = f({ url: "/my/shortcuts?placement=menu&term=*&pagesize=50" }), x = D(() => h?.value?.map((e) => ({
			...e,
			link: e.startpage ? e.startpage : `${c?.workspaces_path?.value}/${e?.slug}`
		})) ?? []), S = D(() => t.workspaceSlug ? (_?.value ?? []).map((e) => ({
			...e,
			link: `${o}${e?.link}`
		})) ?? [] : []), C = D(() => b?.value?.records?.map((e) => ({
			...e,
			link: `${o}${e?.link}`
		})) ?? []), w = D(() => x.value?.find((e) => e.slug === t.workspaceSlug)), T = D(() => (d.value?.role ?? []).includes("admin")), ee = D(() => [
			{
				link: `${s}/admin/agents`,
				name: K("agents_page_title"),
				icon: "mdi:mdi-robot-outline"
			},
			{
				link: `${s}/admin/audit`,
				name: K("activity_log"),
				icon: "mdi:mdi-format-list-bulleted-triangle"
			},
			{
				link: `${s}/admin/bulletins`,
				name: K("bulletins_page_title"),
				icon: "mdi:mdi-newspaper-variant-outline"
			},
			{
				link: `${s}/admin/dashboards`,
				name: K("admin_dashboards_title"),
				icon: "mdi:mdi-view-dashboard-variant-outline"
			},
			{
				link: `${s}/admin/domains`,
				name: K("admin_domains_title"),
				icon: "mdi:mdi-domain"
			},
			{
				link: `${s}/admin/forms`,
				name: K("admin_forms_title"),
				icon: "mdi:mdi-form-select"
			},
			{
				link: `${s}/admin/guides`,
				name: K("admin_guides_title"),
				icon: "mdi:mdi-book-open-outline"
			},
			{
				link: `${s}/admin/items`,
				name: K("admin_items_title"),
				icon: "mdi:mdi-format-list-bulleted"
			},
			{
				link: `${s}/admin/locales`,
				name: K("locales_page_title"),
				icon: "mdi:mdi-web"
			},
			{
				link: `${s}/admin/options`,
				name: K("admin_options_title"),
				icon: "mdi:mdi-tune-variant"
			},
			{
				link: `${s}/admin/processes`,
				name: K("admin_processes_title"),
				icon: "mdi:mdi-sitemap-outline"
			},
			{
				link: `${s}/admin/roles`,
				name: K("roles_page_title"),
				icon: "mdi:mdi-shield-account-outline"
			},
			{
				link: `${s}/admin/settings`,
				name: K("admin_settings_title"),
				icon: "mdi:mdi-file-cog-outline"
			},
			{
				link: `${s}/admin/shortcuts`,
				name: K("admin_shortcuts_title"),
				icon: "mdi:mdi-arrow-top-right-thick"
			},
			{
				link: `${s}/admin/strings`,
				name: K("admin_strings_title"),
				icon: "mdi:mdi-translate"
			},
			{
				link: `${s}/admin/users`,
				name: K("users_page_title"),
				icon: "mdi:mdi-account-group-outline"
			},
			{
				link: `${s}/admin/workflows`,
				name: K("admin_workflows_title"),
				icon: "mdi:mdi-sitemap"
			},
			{
				link: `${s}/admin/workspaces`,
				name: K("admin_workspaces_title"),
				icon: "mdi:mdi-view-grid-outline"
			},
			{
				link: `${s}/admin/system-logs`,
				name: K("admin_system_logs_title"),
				icon: "mdi:mdi-view-list-outline"
			},
			...l.value ? [{
				link: `${s}/admin/resources`,
				name: K("admin_resources_title"),
				icon: "mdi:mdi-folder-outline"
			}] : []
		].filter((e) => u(e.link)).sort((e, t) => e.name.localeCompare(t.name, "sv"))), te = D(() => [
			{
				link: `${s}/admin/connector/pipelines`,
				name: K("admin_connector_pipelines_title"),
				icon: "mdi:mdi-pipe"
			},
			{
				link: `${s}/admin/connector/datasource/file`,
				name: K("admin_connector_datasource_file_title"),
				icon: "mdi:mdi-file-outline"
			},
			{
				link: `${s}/admin/connector/datasource/ldap`,
				name: K("admin_connector_datasource_ldap_title"),
				icon: "mdi:mdi-folder-network-outline"
			},
			{
				link: `${s}/admin/connector/datasource/rest`,
				name: K("admin_connector_datasource_rest_title"),
				icon: "mdi:mdi-api"
			},
			{
				link: `${s}/admin/connector/datasource/sql`,
				name: K("admin_connector_datasource_sql_title"),
				icon: "mdi:mdi-database-outline"
			},
			{
				link: `${s}/admin/connector/tasks/index`,
				name: K("admin_connector_index_title"),
				icon: "mdi:mdi-database-search-outline"
			},
			{
				link: `${s}/admin/connector/tasks/purge`,
				name: K("admin_connector_purge_title"),
				icon: "mdi:mdi-delete-sweep-outline"
			},
			{
				link: `${s}/admin/connector/tasks/reader`,
				name: K("admin_connector_reader_title"),
				icon: "mdi:mdi-book-open-page-variant-outline"
			},
			{
				link: `${s}/admin/connector/tasks/script`,
				name: K("admin_connector_script_title"),
				icon: "mdi:mdi-script-text-outline"
			},
			{
				link: `${s}/admin/connector/tasks/transform`,
				name: K("admin_connector_transform_title"),
				icon: "mdi:mdi-swap-horizontal"
			}
		].filter((e) => u(e.link)).sort((e, t) => e.name.localeCompare(t.name, "sv")));
		return U(() => t.workspaceSlug, () => {
			t.workspaceSlug && v();
		}), U([y, g], (e) => {
			a.value = !jn(e, (e) => !e).value;
		}), (t, a) => {
			let o = pt("h-onify-logo"), s = pt("h-theme-scope"), l = pt("h-action-link"), u = pt("h-shortcut");
			return L(), O(br, {
				modelValue: n.value,
				"onUpdate:modelValue": a[1] ||= (e) => n.value = e,
				class: I(["h-navigation-menu h-layout__nav", {
					[`h-layout__nav--${e.workspaceSlug}`]: !!e.workspaceSlug,
					"h-navigation-menu--admin": e.adminDesign
				}]),
				style: ot({
					"--workspace-item-bg-color": w.value?.color,
					"--workspace-item-text-color": "#ffffff"
				}),
				color: "navigation-menu",
				temporary: ""
			}, {
				prepend: W(() => [N(_r, { class: "h-layout__nav-header d-flex justify-center align-center py-3" }, {
					default: W(() => [B(t.$slots, "logo", {}, () => [w.value ? (L(), A("div", kx, [N(s, {
						name: "HScopedNavigationMenuLogoAvatar",
						component: H(cr),
						class: "h-layout__avatar"
					}, {
						default: W(() => [w.value.icon ? (L(), O(J, {
							key: 0,
							icon: w.value.icon,
							class: "h-layout__logo"
						}, null, 8, ["icon"])) : (L(), A("span", Ax, V(w.value.name[0]), 1))]),
						_: 1
					}, 8, ["component"])])) : (L(), O(o, { key: 0 }))])]),
					_: 3
				})]),
				default: W(() => [N(Bn, {
					opened: r.value,
					"onUpdate:opened": a[0] ||= (e) => r.value = e,
					"expand-icon": e.adminDesign ? "mdi:mdi-chevron-right" : void 0,
					"collapse-icon": e.adminDesign ? "mdi:mdi-chevron-down" : void 0,
					class: "h-navigation-menu-main-list",
					density: "compact",
					nav: "",
					"aria-label": H(K)("main_navigation")
				}, {
					default: W(() => [
						N(l, {
							to: m,
							"no-route": ""
						}, {
							default: W(() => [N(Hn, {
								class: "h-navigation-menu-home-list-item font-weight-medium",
								"prepend-icon": "mdi:mdi-home-outline",
								nav: "",
								link: "",
								title: H(K)("home"),
								role: "option"
							}, null, 8, ["title"])]),
							_: 1
						}),
						(L(!0), A(E, null, z(S.value, (t) => (L(), O(Hn, {
							key: t.key,
							link: "",
							class: "h-layout__root-item",
							role: "option"
						}, {
							default: W(() => [N(u, {
								workspace: e.workspaceSlug,
								class: "h-layout__shortcut",
								shortcut: t,
								"badge:color": "secondary",
								"badge:inline": ""
							}, {
								avatar: W(({ icon: e, isImage: n }) => [N(H(cr), { class: "h-navigation-menu-shortcut-avatar bg-gradient-shortcut-icon mr-4" }, {
									default: W(() => [e && !n ? (L(), O(J, {
										key: 0,
										class: "h-navigation-menu-shortcut-icon",
										icon: e
									}, null, 8, ["icon"])) : e && n ? (L(), O(Yn, {
										key: 1,
										class: "h-navigation-menu-shortcut-icon",
										height: "32",
										src: H(p)(e),
										alt: H(K)("image_alt_shortcut_icon")
									}, null, 8, ["src", "alt"])) : (L(), A("span", jx, V(t.title[0]), 1))]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, ["workspace", "shortcut"])]),
							_: 2
						}, 1024))), 128)),
						N(er, {
							class: "h-navigation-menu-main-divider my-5",
							role: "presentation"
						}),
						N(Vn, {
							value: "workspaces",
							class: "h-navigation-menu-workspaces-list-group mt-2",
							fluid: "",
							role: "group"
						}, {
							activator: W(({ props: e }) => [N(Hn, F(e, {
								class: "h-layout__group",
								"prepend-icon": "mdi:mdi-view-grid-outline",
								role: "option"
							}), {
								title: W(() => [j("span", Mx, V(H(K)("workspaces")), 1), N(l, {
									to: H(c)?.workspaces_path?.value ?? void 0,
									"no-route": ""
								}, {
									default: W(() => [N(q, {
										class: "h-navigation-menu-workspaces-btn",
										"aria-label": H(K)("open_in_new")
									}, null, 8, ["aria-label"])]),
									_: 1
								}, 8, ["to"])]),
								_: 1
							}, 16)]),
							default: W(() => [(L(!0), A(E, null, z(x.value, (t, n) => (L(), O(l, {
								key: t.link || n,
								class: "h-navigation-menu-workspaces-item-action-link",
								to: t.link ? t.link : void 0,
								"no-route": ""
							}, {
								default: W(() => [Tt((L(), O(Hn, {
									id: `workspace-admin_${n}`,
									key: `workspace_${n}`,
									title: t.name,
									value: t,
									link: "",
									class: I(["h-layout__grouped-item h-layout__workspace-item", { [`h-layout__workspace-item--${t.slug}`]: !!t.slug }]),
									style: ot({
										"--workspace-item-bg-color": t?.color,
										"--workspace-item-text-color": "#ffffff"
									}),
									active: t.slug === e.workspaceSlug,
									role: "option"
								}, {
									prepend: W(() => [N(H(cr), { class: "h-layout__workspace-item-avatar" }, {
										default: W(() => [t.icon ? (L(), O(J, {
											key: 0,
											class: "h-navigation-menu-workspaces-item-icon",
											icon: t.icon
										}, null, 8, ["icon"])) : (L(), A("span", Nx, V(t.name[0]), 1))]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1032, [
									"id",
									"title",
									"value",
									"class",
									"style",
									"active"
								])), [[zr, { text: t.description }]])]),
								_: 2
							}, 1032, ["to"]))), 128))]),
							_: 1
						}),
						T.value ? (L(), O(Vn, {
							key: 0,
							value: "administration",
							class: "h-navigation-menu-admin-list-group mt-2",
							fluid: "",
							role: "group"
						}, {
							activator: W(({ props: e }) => [N(Hn, F(e, {
								class: "h-layout__group",
								"prepend-icon": "mdi:mdi-cog-outline",
								title: H(K)("administration"),
								role: "option"
							}), null, 16, ["title"])]),
							default: W(() => [(L(!0), A(E, null, z(ee.value, (t, n) => (L(), O(l, {
								key: t.link || n,
								to: t.link ? t.link : void 0,
								"no-route": ""
							}, {
								default: W(() => [N(Hn, {
									id: `item-admin_${n}`,
									class: "h-navigation-menu-admin-item-list-item h-layout__grouped-item",
									"prepend-icon": t.icon,
									nav: "",
									link: "",
									title: t.name,
									active: e.adminDesign && i(t.link),
									role: "option"
								}, null, 8, [
									"id",
									"prepend-icon",
									"title",
									"active"
								])]),
								_: 2
							}, 1032, ["to"]))), 128)), te.value.length > 0 ? (L(), O(Vn, {
								key: 0,
								value: "connector",
								fluid: "",
								role: "group"
							}, {
								activator: W(({ props: e }) => [N(Hn, F(e, {
									class: "h-layout__grouped-item",
									"prepend-icon": "mdi:mdi-connection",
									nav: "",
									link: "",
									title: H(K)("connector"),
									role: "option"
								}), null, 16, ["title"])]),
								default: W(() => [(L(!0), A(E, null, z(te.value, (t, n) => (L(), O(l, {
									key: t.link || n,
									to: t.link ? t.link : void 0,
									"no-route": ""
								}, {
									default: W(() => [N(Hn, {
										id: `item-connector_${n}`,
										class: "h-navigation-menu-admin-item-list-item h-layout__grouped-item h-layout__connector-item",
										"prepend-icon": t.icon,
										nav: "",
										link: "",
										title: t.name,
										active: e.adminDesign && i(t.link),
										role: "option"
									}, null, 8, [
										"id",
										"prepend-icon",
										"title",
										"active"
									])]),
									_: 2
								}, 1032, ["to"]))), 128))]),
								_: 1
							})) : k("", !0)]),
							_: 1
						})) : k("", !0),
						C.value.length && e.workspaceSlug ? (L(), O(Vn, {
							key: 1,
							class: "h-navigation-menu-shortcuts-list-group mt-2",
							fluid: "",
							role: "group"
						}, {
							activator: W(({ props: e }) => [N(Hn, F(e, {
								class: "h-layout__group",
								"prepend-icon": "mdi:mdi-arrow-top-right-thick",
								title: H(K)("shortcuts"),
								role: "option"
							}), null, 16, ["title"])]),
							default: W(() => [(L(!0), A(E, null, z(C.value, (t, n) => (L(), O(Hn, {
								id: `item-admin_${n}`,
								key: `workspace_${n}`,
								class: "h-navigation-menu-shortcuts-item-list-item h-layout__grouped-item",
								nav: "",
								link: "",
								role: "option"
							}, {
								default: W(() => [N(u, {
									class: "h-layout__shortcut",
									workspace: e.workspaceSlug,
									shortcut: t,
									"badge:inline": "",
									"badge:color": "secondary"
								}, {
									avatar: W(({ icon: e, isImage: n }) => [N(H(cr), { class: "h-navigation-menu-shortcuts-item-avatar bg-gradient-shortcut-icon mr-4" }, {
										default: W(() => [e && !n ? (L(), O(J, {
											key: 0,
											class: "h-navigation-menu-shortcuts-item-icon",
											icon: e
										}, null, 8, ["icon"])) : e && n ? (L(), O(Yn, {
											key: 1,
											class: "h-navigation-menu-shortcut-icon",
											height: "32",
											src: H(p)(e),
											alt: H(K)("image_alt_shortcut_icon")
										}, null, 8, ["src", "alt"])) : (L(), A("span", Px, V(t.title[0]), 1))]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1032, ["workspace", "shortcut"])]),
								_: 2
							}, 1032, ["id"]))), 128))]),
							_: 1
						})) : k("", !0)
					]),
					_: 1
				}, 8, [
					"opened",
					"expand-icon",
					"collapse-icon",
					"aria-label"
				])]),
				_: 3
			}, 8, [
				"modelValue",
				"class",
				"style"
			]);
		};
	}
}), Ix = { class: "d-flex align-center h-breadcrumbs" }, Lx = {
	key: 1,
	class: "h-breadcrumb__item-text"
}, Rx = /* @__PURE__ */ P({
	__name: "breadcrumbs-nav",
	props: { items: {} },
	setup(e) {
		let { smAndDown: t } = ir();
		G(e, "HBreadcrumbs");
		let n = kn();
		function r() {
			n.back();
		}
		return (n, i) => {
			let a = pt("h-action-link");
			return L(), A("div", Ix, [H(t) ? (L(), O(q, {
				key: 0,
				class: "h-breadcrumbs-back-btn mr-2",
				onClick: i[0] ||= (e) => r()
			})) : k("", !0), N(pn, {
				"no-gutters": "",
				class: "h-breadcrumb__container"
			}, {
				default: W(() => [N(nn, {
					items: e.items,
					class: "h-breadcrumb pl-0 py-4"
				}, {
					divider: W(() => [N(J, { class: "h-breadcrumbs-divider-icon arrow" }, {
						default: W(() => [...i[1] ||= [M("mdi:mdi-chevron-right", -1)]]),
						_: 1
					})]),
					title: W(({ item: e }) => [N(a, {
						class: I(["h-breadcrumb__item", { "h-breadcrumb__item--with-icon": !!e.icon }]),
						to: e.href ?? "/",
						"aria-label": e.text
					}, {
						default: W(() => [e.icon ? (L(), O(J, {
							key: 0,
							class: "h-breadcrumb__item-icon"
						}, {
							default: W(() => [M(V(e.icon), 1)]),
							_: 2
						}, 1024)) : k("", !0), e.text ? (L(), A("span", Lx, V(e.text), 1)) : k("", !0)]),
						_: 2
					}, 1032, [
						"class",
						"to",
						"aria-label"
					])]),
					_: 1
				}, 8, ["items"])]),
				_: 1
			})]);
		};
	}
}), zx = { class: "h-workspace-item__content ga-8" }, Bx = { class: "h-workspace-item__icon" }, Vx = {
	key: 1,
	class: "h-workspace-item__avatar-text"
}, Hx = { class: "h-workspace-item__text" }, Ux = { class: "h-workspace-item__title mr-1" }, Wx = { class: "h-workspace-item__description text-medium-emphasis mb-2" }, Gx = { class: "h-workspace-item__collapsed-tags" }, Kx = /* @__PURE__ */ P({
	__name: "workspace-item",
	props: { workspace: {} },
	setup(e) {
		return G(e, "HWorkspaceItem"), (t, n) => {
			let r = pt("h-theme-scope"), i = pt("h-action-link");
			return L(), O(i, { class: "h-workspace-item-action-link h-workspace-item__link" }, {
				default: W(() => [N(rn, {
					link: !0,
					ripple: !0,
					class: I(["h-workspace-item pa-8", { [`h-workspace-item--${e.workspace.slug}`]: !0 }]),
					style: ot({ "--workspace-item-bg-color": e.workspace.color })
				}, {
					default: W(() => [N(cn, { class: "h-workspace-item-content-text h-100" }, {
						default: W(() => [j("div", zx, [j("div", Bx, [N(tr, { class: "h-workspace-item__avatar" }, {
							default: W(() => [e.workspace.icon ? (L(), O(H(dr), {
								key: 0,
								class: "h-workspace-item-icon",
								icon: e.workspace.icon
							}, null, 8, ["icon"])) : (L(), A("div", Vx, V(e.workspace.title?.[0]), 1))]),
							_: 1
						})]), j("div", Hx, [j("div", null, [
							j("span", Ux, V(e.workspace.title), 1),
							j("div", Wx, V(e.workspace.description), 1),
							j("div", null, [(L(!0), A(E, null, z(e.workspace?.tag?.slice(0, 2) ?? [], (e) => (L(), O(qn, {
								key: e,
								class: "h-workspace-item__tag mr-1",
								label: ""
							}, {
								default: W(() => [M(V(e), 1)]),
								_: 2
							}, 1024))), 128)), N(un, {
								class: I(["h-workspace-item__tooltip", { [`h-workspace-item__tooltip--${e.workspace.slug}`]: !0 }]),
								location: "bottom",
								style: ot({
									"--workspace-item-bg-color": e.workspace.color,
									"--workspace-item-text-color": "#ffffff"
								})
							}, {
								activator: W(({ props: t }) => [(e.workspace.tag?.length ?? 0) > 2 ? (L(), O(qn, F({ key: 0 }, t, {
									class: "h-workspace-item__tag mr-1",
									label: ""
								}), {
									default: W(() => [N(r, {
										name: "HScopedWorkspaceItemMoreTagsIcon",
										component: H(dr),
										class: "h-workspace-item-more-tags-icon"
									}, null, 8, ["component"])]),
									_: 1
								}, 16)) : k("", !0)]),
								default: W(() => [j("div", Gx, V(e.workspace.tag?.slice(2).join(", ")), 1)]),
								_: 1
							}, 8, ["class", "style"])])
						])])])]),
						_: 1
					})]),
					_: 1
				}, 8, ["class", "style"])]),
				_: 1
			});
		};
	}
}), qx = /* @__PURE__ */ P({
	inheritAttrs: !1,
	__name: "dropdown-menu",
	props: { customDefaults: {} },
	setup(e) {
		let t = G(e, "HMenu"), n = D(() => ({
			...xr().value,
			...t.customDefaults
		}));
		return (e, t) => (L(), O(Sn, F({ class: "h-dropdown-menu" }, e.$attrs), {
			activator: W((t) => [B(e.$slots, "activator", at(Qe(t)))]),
			default: W(() => [N(or, { defaults: n.value }, {
				default: W(() => [B(e.$slots, "default")]),
				_: 3
			}, 8, ["defaults"])]),
			_: 3
		}, 16));
	}
}), Jx = /*@__PURE__*/ Object.assign({
	name: "HThemeScope",
	inheritAttrs: !1
}, {
	__name: "theme-scope",
	props: {
		name: {
			type: String,
			required: !0,
			validator: (e) => e.startsWith("HScoped") ? !0 : (console.error(`[HThemeScope] Invalid name "${e}": Theme scope names must start with "HScoped" prefix. Example: "HScopedWorkspaceOpenBtn" instead of "${e}"`), !1)
		},
		component: {
			type: [String, Object],
			required: !1,
			default: null
		}
	},
	setup(e) {
		let t = e, n = Ze(), r = G({}, t.name);
		return n && (n.type && (n.type.name = t.name), n.proxy?.$options && (n.proxy.$options.name = t.name)), (t, n) => e.component ? (L(), O(mt(e.component), at(F({ key: 0 }, {
			...t.$attrs,
			...H(r)
		})), {
			default: W(() => [B(t.$slots, "default")]),
			_: 3
		}, 16)) : B(t.$slots, "default", { key: 1 });
	}
}), Yx = ["inert"], Xx = { class: "bg-neutral-90 admin-form-header" }, Zx = { class: "text-headline-small font-weight-medium" }, Qx = /*#__PURE__*/ Y({
	__name: "form-layout",
	props: {
		modelValue: {
			type: Boolean,
			default: !1
		},
		loading: {
			type: Boolean,
			default: !1
		},
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		hasChanges: {
			type: Boolean,
			default: !1
		},
		submitDisabled: {
			type: Boolean,
			default: !1
		},
		headerText: {
			type: String,
			default: ""
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: [
		"submit",
		"cancel",
		"update:modelValue"
	],
	setup(e, { expose: t, emit: n }) {
		let { confirm: r } = Ht(), i = e, a = n, o = R(null), s = R(!1), c = R(!1), l = R(0);
		U(() => i.modelValue, (e, t) => {
			t && !e && (s.value = !1, l.value += 1);
		});
		function u() {
			s.value = !s.value;
		}
		async function d() {
			i.loading || a("submit");
		}
		async function f(e) {
			e.target.tagName === "TEXTAREA" || e.target.closest(".v-combobox") || (e.preventDefault(), await d());
		}
		function p() {
			i.loading || (i.hasChanges ? h() : (s.value = !1, a("cancel")));
		}
		function m(e) {
			if (!i.loading) {
				if (e.preventDefault(), i.hasChanges) {
					h();
					return;
				}
				p();
			}
		}
		async function h() {
			(await r({
				title: K("discard_changes"),
				message: K("discard_changes_warning"),
				cancelText: K("keep_editing"),
				confirmText: K("discard")
			})).confirmed && (s.value = !1, a("update:modelValue", !1), a("cancel"));
		}
		async function g() {
			return await o.value?.validate();
		}
		function _() {
			return o.value?.reset();
		}
		function v() {
			return o.value?.resetValidation();
		}
		return t({
			validate: g,
			reset: _,
			resetValidation: v
		}), (t, n) => {
			let r = pt("HActionButton");
			return L(), O(br, {
				key: l.value,
				"model-value": e.modelValue,
				location: "right",
				width: s.value ? void 0 : e.drawerWidth,
				class: I({
					"fullscreen-drawer": s.value,
					"admin-form-drawer": !0
				}),
				temporary: "",
				touchless: "",
				"onUpdate:modelValue": n[4] ||= (e) => a("update:modelValue", e)
			}, {
				default: W(() => [j("div", {
					inert: e.modelValue ? void 0 : "",
					style: { display: "contents" }
				}, [N(rn, {
					flat: "",
					class: "h-100 d-flex flex-column"
				}, {
					default: W(() => [
						j("div", Xx, [N(pn, {
							"no-gutters": "",
							class: "flex-column"
						}, {
							default: W(() => [N(dn, {
								class: "px-6",
								style: {
									"padding-top": "2px",
									"padding-bottom": "2px"
								}
							}, {
								default: W(() => [N(pn, {
									"no-gutters": "",
									class: "align-center"
								}, {
									default: W(() => [N(dn, null, {
										default: W(() => [j("h2", Zx, V(e.headerText), 1)]),
										_: 1
									}), N(dn, { cols: "auto" }, {
										default: W(() => [N(un, {
											location: "bottom",
											"open-delay": 1e3
										}, {
											activator: W(({ props: e }) => [N(J, F(e, {
												size: "x-small",
												role: "button",
												tabindex: "0",
												"aria-label": s.value ? H(K)("exit_fullscreen") : H(K)("enter_fullscreen"),
												class: ["cursor-pointer size-toggle-icon mr-4", { "text-primary": s.value || c.value }],
												onClick: u,
												onKeydown: [Et(u, ["enter"]), Et(Dt(u, ["prevent"]), ["space"])],
												onMouseover: n[0] ||= (e) => c.value = !0,
												onMouseleave: n[1] ||= (e) => c.value = !1,
												onFocus: n[2] ||= (e) => c.value = !0,
												onBlur: n[3] ||= (e) => c.value = !1
											}), {
												default: W(() => [M(V(s.value ? "mdi:mdi-arrow-collapse" : "mdi:mdi-arrow-expand"), 1)]),
												_: 1
											}, 16, [
												"aria-label",
												"class",
												"onKeydown"
											])]),
											default: W(() => [j("span", null, V(s.value ? H(K)("exit_fullscreen") : H(K)("enter_fullscreen")), 1)]),
											_: 1
										}), N(q, {
											icon: "mdi:mdi-close",
											variant: "text",
											"aria-label": H(K)("close"),
											onClick: p
										}, null, 8, ["aria-label"])]),
										_: 1
									})]),
									_: 1
								})]),
								_: 1
							}), N(dn, { class: "pa-0" }, {
								default: W(() => [N(er, {
									thickness: 1,
									color: "neutral-80"
								})]),
								_: 1
							})]),
							_: 1
						})]),
						N(cn, { class: I(["flex-1 overflow-y-auto scroll-contain admin-form-content", [{ "px-16 py-8": s.value }, `bg-${e.bgColor}`]]) }, {
							default: W(() => [j("div", {
								class: I({ "mx-auto": s.value }),
								style: ot(s.value ? "width: 80%" : "")
							}, [N(Sr, {
								ref_key: "formRef",
								ref: o,
								onSubmit: Dt(d, ["prevent"]),
								onKeydown: [Et(Dt(f, ["prevent"]), ["enter"]), Et(Dt(m, ["prevent"]), ["esc"])]
							}, {
								default: W(() => [N(dn, { class: I([
									"d-flex",
									"flex-column",
									"ga-4",
									"pa-6",
									`bg-${e.bgColor}`
								]) }, {
									default: W(() => [B(t.$slots, "default", {}, void 0, !0)]),
									_: 3
								}, 8, ["class"])]),
								_: 3
							}, 8, ["onKeydown"])], 6)]),
							_: 3
						}, 8, ["class"]),
						N(pn, {
							class: I(["footer-actions ga-2 align-center admin-form-footer flex-shrink-0", [{ "footer-actions-bordered bg-white": !s.value }, { "justify-center": s.value }]]),
							"no-gutters": ""
						}, {
							default: W(() => [N(dn, { cols: "auto" }, {
								default: W(() => [N(r, {
									type: "neutral",
									disabled: e.loading,
									"prepend-icon": "mdi:mdi-close",
									onClick: p
								}, {
									default: W(() => [M(V(H(K)("cancel")), 1)]),
									_: 1
								}, 8, ["disabled"])]),
								_: 1
							}), N(dn, { cols: "auto" }, {
								default: W(() => [N(r, {
									type: "primary",
									loading: e.loading,
									disabled: e.loading || e.submitDisabled,
									"prepend-icon": "mdi:mdi-content-save",
									onClick: d
								}, {
									default: W(() => [M(V(H(K)("save")), 1)]),
									_: 1
								}, 8, ["loading", "disabled"])]),
								_: 1
							})]),
							_: 1
						}, 8, ["class"])
					]),
					_: 3
				})], 8, Yx)]),
				_: 3
			}, 8, [
				"model-value",
				"width",
				"class"
			]);
		};
	}
}, [["__scopeId", "data-v-099c17ae"]]), $x = { class: "h-milestone-timeline" }, eS = {
	key: 0,
	class: "text-body-large mb-3"
}, tS = { class: "font-weight-medium text-body-medium" }, nS = {
	key: 0,
	class: "text-body-small"
}, rS = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "milestone-timeline",
	props: {
		steps: {},
		currentStep: {},
		currentStepIndex: {},
		completed: {
			type: Boolean,
			default: !1
		},
		title: { default: "" }
	},
	setup(e) {
		let t = G(e, "HMilestoneTimeline"), n = D(() => {
			let e = t.currentStepIndex;
			return typeof e == "number" && Number.isInteger(e) && e >= -1 && e < t.steps.length ? e : t.steps.findIndex((e) => (typeof e == "string" ? e : e.title) === t.currentStep);
		});
		function r(e) {
			return t.completed || e < n.value ? "milestone-completed" : e === n.value ? "milestone-current" : "milestone-coming";
		}
		function i(e) {
			return t.completed || e < n.value ? "line-completed" : e === n.value ? "line-current" : "line-coming";
		}
		function a(e) {
			return t.completed || e < n.value ? "text-completed" : e === n.value ? "text-current" : "text-coming";
		}
		function o(e) {
			let n = t.steps[e];
			return !t.completed && typeof n == "object" && n.color ? { backgroundColor: n.color } : {};
		}
		function s(e) {
			let n = t.steps[e];
			return !t.completed && typeof n == "object" && n.color ? { backgroundColor: n.color } : {};
		}
		return (t, n) => (L(), A("div", $x, [e.title ? (L(), A("div", eS, V(e.title), 1)) : k("", !0), (L(!0), A(E, null, z(e.steps, (t, c) => (L(), O(pn, {
			key: c,
			"no-gutters": "",
			class: "milestone-item"
		}, {
			default: W(() => [N(dn, { cols: "auto" }, {
				default: W(() => [N(pn, {
					"no-gutters": "",
					class: "flex-column align-center milestone-icon-wrapper"
				}, {
					default: W(() => [N(dn, { cols: "auto" }, {
						default: W(() => [j("div", {
							class: I(["milestone-icon d-flex align-center justify-center", r(c)]),
							style: ot(o(c))
						}, [N(J, {
							size: "x-small",
							color: "white"
						}, {
							default: W(() => [...n[0] ||= [M("mdi:mdi-check", -1)]]),
							_: 1
						})], 6)]),
						_: 2
					}, 1024), c < e.steps.length - 1 ? (L(), O(dn, {
						key: 0,
						cols: "auto"
					}, {
						default: W(() => [j("div", {
							class: I(["milestone-line", i(c)]),
							style: ot(s(c))
						}, null, 6)]),
						_: 2
					}, 1024)) : k("", !0)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024), N(dn, { class: "ml-3" }, {
				default: W(() => [j("div", { class: I(["milestone-text", a(c)]) }, [j("div", tS, V(typeof t == "string" ? t : t.title), 1), typeof t == "object" && t.description ? (L(), A("div", nS, V(t.description), 1)) : k("", !0)], 2)]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1024))), 128))]));
	}
}), [["__scopeId", "data-v-00cccfc7"]]), iS = ["multiple"], aS = { class: "font-weight-medium" }, oS = { class: "text-right attachment-actions" }, sS = { key: 0 }, cS = {
	colspan: "2",
	class: "text-center pa-4 text-body-medium",
	style: { color: "rgb(var(--v-theme-neutral-40))" }
}, lS = /*#__PURE__*/ Y(/* @__PURE__ */ P({
	__name: "attachments",
	props: {
		attachments: {},
		title: { default: "" },
		elevation: { default: 2 },
		rounded: {
			type: [Boolean, String],
			default: "lg"
		},
		density: { default: "comfortable" },
		showViewButton: {
			type: Boolean,
			default: !1
		},
		showDownloadButton: {
			type: Boolean,
			default: !0
		},
		showDeleteButton: {
			type: Boolean,
			default: !1
		},
		showUploadButton: {
			type: Boolean,
			default: !1
		},
		uploadButtonProps: { default: () => ({ text: "browse_files" }) },
		uploadMultiple: {
			type: Boolean,
			default: !0
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		emptyMessage: { default: "no_attachments" },
		nameKey: { default: "name" }
	},
	emits: [
		"view",
		"download",
		"delete",
		"upload"
	],
	setup(e, { emit: t }) {
		let n = G(e, "HAttachments"), r = t, i = R(null);
		function a(e) {
			return e[n.nameKey] || e.name || e.filename || K("unnamed");
		}
		function o(e, t) {
			r("view", e, t);
		}
		function s(e, t) {
			r("download", e, t);
		}
		function c(e, t) {
			r("delete", t);
		}
		function l() {
			i.value?.click();
		}
		function u(e) {
			let t = e.target, n = Array.from(t.files || []);
			n.length > 0 && r("upload", n), t && (t.value = "");
		}
		return (t, n) => (L(), O(rn, {
			elevation: e.elevation,
			rounded: e.rounded
		}, {
			default: W(() => [e.title ? (L(), O(ln, {
				key: 0,
				class: "text-body-large pa-4 pb-0"
			}, {
				default: W(() => [M(V(e.title), 1)]),
				_: 1
			})) : k("", !0), N(cn, { class: I(e.showUploadButton ? "pa-2" : "pa-0") }, {
				default: W(() => [
					e.showUploadButton ? (L(), A("input", {
						key: 0,
						ref_key: "fileInput",
						ref: i,
						type: "file",
						multiple: e.uploadMultiple,
						style: { display: "none" },
						"aria-hidden": "true",
						onChange: u
					}, null, 40, iS)) : k("", !0),
					e.showUploadButton ? (L(), O(gl, {
						key: 1,
						type: e.uploadButtonProps?.type || "neutral",
						"prepend-icon": e.uploadButtonProps?.icon || "mdi:mdi-upload",
						size: e.uploadButtonProps?.size || "small",
						class: I(e.uploadButtonProps?.class || "text-uppercase"),
						disabled: e.disabled,
						onClick: l
					}, {
						default: W(() => [M(V(H(K)(e.uploadButtonProps?.text || "browse_files")), 1)]),
						_: 1
					}, 8, [
						"type",
						"prepend-icon",
						"size",
						"class",
						"disabled"
					])) : k("", !0),
					N(rr, {
						class: I(["h-attachments-table", { "mt-4": e.showUploadButton }]),
						density: e.density
					}, {
						default: W(() => [j("tbody", null, [(L(!0), A(E, null, z(e.attachments, (t, r) => (L(), A("tr", { key: r }, [j("td", aS, V(a(t)), 1), j("td", oS, [
							e.showViewButton ? (L(), O(q, {
								key: 0,
								icon: "",
								size: "x-small",
								variant: "text",
								disabled: !t || e.disabled,
								onClick: (e) => o(t, r)
							}, {
								default: W(() => [N(J, { size: "small" }, {
									default: W(() => [...n[0] ||= [M("mdi:mdi-eye-outline", -1)]]),
									_: 1
								})]),
								_: 1
							}, 8, ["disabled", "onClick"])) : k("", !0),
							e.showDownloadButton ? (L(), O(q, {
								key: 1,
								icon: "",
								size: "x-small",
								variant: "text",
								disabled: !t || e.disabled,
								onClick: (e) => s(t, r)
							}, {
								default: W(() => [N(J, { size: "small" }, {
									default: W(() => [...n[1] ||= [M("mdi:mdi-download", -1)]]),
									_: 1
								})]),
								_: 1
							}, 8, ["disabled", "onClick"])) : k("", !0),
							e.showDeleteButton ? (L(), O(q, {
								key: 2,
								icon: "",
								size: "x-small",
								variant: "text",
								disabled: !t || e.disabled,
								onClick: (e) => c(t, r)
							}, {
								default: W(() => [N(J, { size: "small" }, {
									default: W(() => [...n[2] ||= [M("mdi:mdi-delete", -1)]]),
									_: 1
								})]),
								_: 1
							}, 8, ["disabled", "onClick"])) : k("", !0)
						])]))), 128)), !e.attachments || e.attachments.length === 0 ? (L(), A("tr", sS, [j("td", cS, V(H(K)(e.emptyMessage)), 1)])) : k("", !0)])]),
						_: 1
					}, 8, ["class", "density"])
				]),
				_: 1
			}, 8, ["class"])]),
			_: 1
		}, 8, ["elevation", "rounded"]));
	}
}), [["__scopeId", "data-v-343624a6"]]), uS = 10 * 1e3 * 1e3, dS = {
	js: "javascript",
	mjs: "javascript",
	cjs: "javascript",
	jsx: "javascript",
	ts: "javascript",
	tsx: "javascript",
	json: "json",
	jsonc: "json",
	geojson: "json",
	xml: "xml",
	svg: "xml",
	xsl: "xml",
	xslt: "xml",
	xsd: "xml",
	wsdl: "xml",
	rss: "xml",
	atom: "xml",
	dmn: "xml",
	py: "python",
	vue: "vue",
	html: "html",
	htm: "html",
	css: "css",
	scss: "sass",
	sass: "sass",
	yml: "yaml",
	yaml: "yaml",
	md: "markdown",
	markdown: "markdown",
	sql: "sql",
	sh: "shell",
	bash: "shell",
	zsh: "shell",
	dockerfile: "dockerfile",
	ini: "ini",
	conf: "ini",
	cfg: "ini",
	env: "ini",
	properties: "ini",
	toml: "toml",
	txt: "text",
	log: "text",
	csv: "text",
	tsv: "text",
	gitignore: "text",
	gitkeep: "text",
	editorconfig: "text"
}, fS = [
	"png",
	"jpg",
	"jpeg",
	"gif",
	"svg",
	"webp",
	"ico",
	"bmp",
	"avif",
	"tif",
	"tiff",
	"apng"
], pS = [
	"woff",
	"woff2",
	"ttf",
	"otf",
	"eot",
	"zip",
	"tar",
	"gz",
	"mp3",
	"mp4",
	"wav",
	"xlsx",
	"docx",
	"pptx"
], mS = [...fS, "pdf"], hS = [
	"json",
	"javascript",
	"xml",
	"python",
	"vue",
	"html",
	"css",
	"sass",
	"yaml",
	"markdown",
	"sql"
], gS = {
	js: "mdi:mdi-language-javascript",
	mjs: "mdi:mdi-language-javascript",
	cjs: "mdi:mdi-language-javascript",
	jsx: "mdi:mdi-language-javascript",
	ts: "mdi:mdi-language-typescript",
	tsx: "mdi:mdi-language-typescript",
	json: "mdi:mdi-code-json",
	jsonc: "mdi:mdi-code-json",
	geojson: "mdi:mdi-code-json",
	html: "mdi:mdi-language-html5",
	htm: "mdi:mdi-language-html5",
	css: "mdi:mdi-language-css3",
	scss: "mdi:mdi-language-css3",
	sass: "mdi:mdi-language-css3",
	vue: "mdi:mdi-vuejs",
	md: "mdi:mdi-language-markdown",
	markdown: "mdi:mdi-language-markdown",
	yml: "mdi:mdi-file-document-outline",
	yaml: "mdi:mdi-file-document-outline",
	xml: "mdi:mdi-xml",
	py: "mdi:mdi-language-python",
	sql: "mdi:mdi-database",
	sh: "mdi:mdi-bash",
	bash: "mdi:mdi-bash",
	svg: "mdi:mdi-image-outline",
	png: "mdi:mdi-image-outline",
	jpg: "mdi:mdi-image-outline",
	jpeg: "mdi:mdi-image-outline",
	gif: "mdi:mdi-image-outline",
	webp: "mdi:mdi-image-outline",
	ico: "mdi:mdi-image-outline",
	bmp: "mdi:mdi-image-outline",
	avif: "mdi:mdi-image-outline",
	tif: "mdi:mdi-image-outline",
	tiff: "mdi:mdi-image-outline",
	apng: "mdi:mdi-image-outline",
	bpmn: "mdi:mdi-sitemap-outline",
	pdf: "mdi:mdi-file-pdf-box"
}, _S = {
	dockerfile: "dockerfile",
	".gitignore": "gitignore",
	gitignore: "gitignore",
	".gitkeep": "gitkeep",
	gitkeep: "gitkeep",
	".editorconfig": "editorconfig",
	editorconfig: "editorconfig"
};
function vS(e) {
	if (!e) return "";
	let t = String(e).split("/").pop() || "", n = t.toLowerCase();
	if (_S[n]) return _S[n];
	let r = t.split(".");
	return r.length < 2 ? "" : r.pop().toLowerCase();
}
function yS(e) {
	return dS[e] || "text";
}
function bS(e) {
	return yS(vS(e));
}
function xS(e) {
	return fS.includes(e);
}
function SS(e) {
	return pS.includes(e);
}
function CS(e) {
	return mS.includes(e);
}
function wS(e) {
	return !(e === "pdf" || e === "bpmn" || SS(e) || xS(e) && e !== "svg");
}
function TS(e) {
	return wS(vS(e));
}
function ES(e) {
	return gS[e] || "mdi:mdi-file-outline";
}
function DS(e, { mode: t = "file", existingNames: n = [] } = {}) {
	let r = String(e || "").trim();
	if (!r) return "admin_resources_name_required";
	if (r.includes("/")) return "admin_resources_name_invalid";
	if (t === "file") {
		let e = vS(r);
		if (e && !wS(e)) return "admin_resources_unsupported_extension";
	}
	return n.includes(r) ? "admin_resources_name_exists" : null;
}
function OS(e, t) {
	let n = String(t || "").replace(/^\/+/, ""), r = String(e || "").replace(/\/+$/, "");
	return r ? `${r}/${n}` : `/${n}`;
}
function kS(e) {
	if (!e) return "";
	let t = e.lastIndexOf("/");
	return t > 0 ? e.substring(0, t) : "";
}
//#endregion
//#region src/components/general/resource-view/resource-tree-menu.js
var AS = Symbol("resourceTreeOpenMenuPath"), jS = ["aria-label"], MS = /*#__PURE__*/ Y({
	__name: "resource-tree-draft",
	props: {
		mode: {
			type: String,
			default: "file"
		},
		parentPath: {
			type: String,
			default: ""
		},
		depth: {
			type: Number,
			default: 0
		},
		existingNames: {
			type: Array,
			default: () => []
		}
	},
	emits: ["confirm", "cancel"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = R(null), a = R(""), o = R(""), s = !1, c = !1, l = D(() => n.mode === "folder"), u = D(() => l.value ? K("admin_resources_new_folder") : K("admin_resources_new_file")), d = D(() => l.value ? "mdi:mdi-folder" : ES(vS(a.value))), f = D(() => l.value ? "amber-darken-2" : void 0), p = D(() => o.value ? K(o.value) : "");
		lt(() => {
			it(() => i.value?.focus());
		}), st(() => {
			s = !0;
		});
		function m() {
			return DS(a.value, {
				mode: n.mode,
				existingNames: n.existingNames
			});
		}
		function h() {
			let e = m();
			if (e) {
				o.value = e, i.value?.focus();
				return;
			}
			c = !0, s = !0, r("confirm", {
				mode: n.mode,
				parentPath: n.parentPath,
				name: a.value.trim()
			});
		}
		function g() {
			s = !0, r("cancel");
		}
		function _(e) {
			e.key === "Enter" && (e.preventDefault(), h()), e.key === "Escape" && (e.preventDefault(), g());
		}
		function v() {
			if (!(s || c)) {
				if (!a.value.trim()) {
					g();
					return;
				}
				h();
			}
		}
		return (t, n) => (L(), A("div", {
			class: "resource-tree-draft",
			"data-testid": "resource-tree-draft",
			onClick: n[1] ||= Dt(() => {}, ["stop"]),
			onMousedown: n[2] ||= Dt(() => {}, ["stop"]),
			onPointerdown: n[3] ||= Dt(() => {}, ["stop"])
		}, [j("div", {
			class: "resource-tree-draft__row d-flex align-center py-1",
			style: ot({
				paddingLeft: `${e.depth * 20 + 8}px`,
				paddingRight: "4px"
			})
		}, [
			n[4] ||= j("div", {
				class: "mr-1 flex-shrink-0",
				style: { width: "18px" }
			}, null, -1),
			N(J, {
				icon: d.value,
				color: f.value,
				size: "18",
				class: "mr-2 flex-shrink-0"
			}, null, 8, ["icon", "color"]),
			Tt(j("input", {
				ref_key: "inputRef",
				ref: i,
				"onUpdate:modelValue": n[0] ||= (e) => a.value = e,
				class: "resource-tree-draft__input text-body-medium",
				"aria-label": u.value,
				"data-testid": "resource-tree-draft-input",
				onKeydown: _,
				onBlur: v
			}, null, 40, jS), [[Ct, a.value]])
		], 4), p.value ? (L(), A("div", {
			key: 0,
			class: "resource-tree-draft__error text-caption text-error",
			style: ot({ paddingLeft: `${e.depth * 20 + 48}px` }),
			"data-testid": "resource-tree-draft-error"
		}, V(p.value), 5)) : k("", !0)], 32));
	}
}, [["__scopeId", "data-v-f8dea866"]]), NS = { class: "resource-tree-node" }, PS = ["aria-selected", "onKeydown"], FS = {
	key: 1,
	class: "mr-1 flex-shrink-0",
	style: { width: "18px" }
}, IS = { class: "text-body-medium text-truncate" }, LS = /*#__PURE__*/ Y({
	__name: "resource-tree-node",
	props: {
		node: {
			type: Object,
			required: !0
		},
		depth: {
			type: Number,
			default: 0
		},
		selectedPath: {
			type: String,
			default: ""
		},
		expandedPaths: {
			type: Array,
			default: () => []
		},
		createDraft: {
			type: Object,
			default: null
		}
	},
	emits: [
		"select",
		"action",
		"create-confirm",
		"cancel-create"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = R(n.expandedPaths.includes(n.node.path) || !1), a = R(!1), o = et(AS, null), s = D(() => n.node.path || n.node.name), c = D({
			get() {
				return o ? o.value === s.value : a.value;
			},
			set(e) {
				if (o) {
					e ? o.value = s.value : o.value === s.value && (o.value = null);
					return;
				}
				a.value = e;
			}
		}), l = R(void 0), u = D(() => l.value ? { target: l.value } : {});
		U(() => n.expandedPaths, (e, t) => {
			let r = n.node.path;
			e.includes(r) && !t?.includes(r) && (i.value = !0);
		}), U(c, (e) => {
			e || (l.value = void 0);
		});
		let d = D(() => n.node.type === "directory" || Array.isArray(n.node.children)), f = D(() => n.selectedPath && n.selectedPath === n.node.path), p = D(() => !!(n.createDraft && n.createDraft.parentPath === n.node.path)), m = D(() => d.value && (i.value || p.value)), h = D(() => n.node.children ? [...n.node.children].sort((e, t) => {
			let n = e.type === "directory" || Array.isArray(e.children), r = t.type === "directory" || Array.isArray(t.children);
			return n && !r ? -1 : !n && r ? 1 : (e.name || "").localeCompare(t.name || "");
		}) : []), g = D(() => h.value.map((e) => e.name));
		U(p, (e) => {
			e && (i.value = !0);
		}, { immediate: !0 });
		let _ = D(() => d.value ? i.value ? "mdi:mdi-folder-open" : "mdi:mdi-folder" : ES(vS(n.node.name))), v = D(() => d.value ? "amber-darken-2" : {
			js: "yellow-darken-3",
			mjs: "yellow-darken-3",
			cjs: "yellow-darken-3",
			jsx: "yellow-darken-3",
			ts: "blue",
			tsx: "blue",
			json: "green",
			html: "orange",
			css: "blue-darken-1",
			scss: "pink",
			vue: "green-darken-1",
			md: "grey",
			py: "blue-darken-2",
			bpmn: "deep-purple"
		}[vS(n.node.name)] || void 0);
		function y(e) {
			r("action", {
				type: e,
				node: n.node
			});
		}
		function b(e, t) {
			if (t === void 0) {
				r("select", e);
				return;
			}
			r("select", e, t);
		}
		function x(e) {
			r("select", n.node.path || n.node.name, { open: !!e });
		}
		function S() {
			o ? o.value = null : a.value = !1, l.value = void 0;
		}
		function C() {
			if (S(), d.value) {
				p.value || (i.value = !i.value), x(!1);
				return;
			}
			x(!0);
		}
		function w(e) {
			x(!1), l.value = [e.clientX, e.clientY], c.value = !0;
		}
		return (t, n) => {
			let r = pt("resource-tree-node", !0);
			return L(), A("div", NS, [j("div", {
				class: I(["resource-tree-node__item d-flex align-center py-1 rounded-sm", {
					"resource-tree-node__item--selected": f.value,
					"resource-tree-node__item--hover": !f.value,
					"resource-tree-node__item--menu-open": c.value
				}]),
				role: "treeitem",
				tabindex: "0",
				"aria-selected": f.value,
				style: ot({
					paddingLeft: `${e.depth * 20 + 8}px`,
					paddingRight: "4px",
					cursor: "pointer"
				}),
				onClick: C,
				onContextmenu: Dt(w, ["prevent", "stop"]),
				onKeydown: [Et(C, ["enter"]), Et(Dt(C, ["prevent"]), ["space"])]
			}, [
				d.value ? (L(), O(J, {
					key: 0,
					icon: i.value ? "mdi:mdi-chevron-down" : "mdi:mdi-chevron-right",
					size: "18",
					class: "mr-1 flex-shrink-0"
				}, null, 8, ["icon"])) : (L(), A("div", FS)),
				N(J, {
					icon: _.value,
					color: v.value,
					size: "18",
					class: "mr-2 flex-shrink-0"
				}, null, 8, ["icon", "color"]),
				j("span", IS, V(e.node.name), 1),
				N(Sn, F({
					modelValue: c.value,
					"onUpdate:modelValue": n[6] ||= (e) => c.value = e
				}, u.value, {
					location: "bottom end",
					"close-on-content-click": !0
				}), {
					activator: W(({ props: e }) => [N(q, F(e, {
						class: "resource-tree-node__actions ml-auto flex-shrink-0",
						icon: "mdi:mdi-dots-vertical",
						variant: "text",
						size: "x-small",
						"aria-label": H(K)("admin_resources_actions"),
						"data-testid": "resource-tree-node-actions",
						onClick: n[0] ||= Dt((e) => l.value = void 0, ["stop"])
					}), null, 16, ["aria-label"])]),
					default: W(() => [N(Bn, {
						density: "compact",
						"data-testid": "resource-tree-node-menu"
					}, {
						default: W(() => [
							d.value ? (L(), O(Hn, {
								key: 0,
								title: H(K)("admin_resources_new_file"),
								"prepend-icon": "mdi:mdi-file-plus-outline",
								"data-testid": "resource-tree-action-new-file",
								onClick: n[1] ||= (e) => y("new-file")
							}, null, 8, ["title"])) : k("", !0),
							d.value ? (L(), O(Hn, {
								key: 1,
								title: H(K)("admin_resources_new_folder"),
								"prepend-icon": "mdi:mdi-folder-plus-outline",
								"data-testid": "resource-tree-action-new-folder",
								onClick: n[2] ||= (e) => y("new-folder")
							}, null, 8, ["title"])) : k("", !0),
							d.value ? (L(), O(Hn, {
								key: 2,
								title: H(K)("admin_resources_upload"),
								"prepend-icon": "mdi:mdi-upload-outline",
								"data-testid": "resource-tree-action-upload",
								onClick: n[3] ||= (e) => y("upload")
							}, null, 8, ["title"])) : k("", !0),
							d.value ? (L(), O(Hn, {
								key: 3,
								title: H(K)("admin_resources_delete_folder"),
								"prepend-icon": "mdi:mdi-delete-outline",
								"data-testid": "resource-tree-action-delete-folder",
								onClick: n[4] ||= (e) => y("delete-folder")
							}, null, 8, ["title"])) : (L(), O(Hn, {
								key: 4,
								title: H(K)("admin_resources_delete_file"),
								"prepend-icon": "mdi:mdi-delete-outline",
								"data-testid": "resource-tree-action-delete-file",
								onClick: n[5] ||= (e) => y("delete-file")
							}, null, 8, ["title"]))
						]),
						_: 1
					})]),
					_: 1
				}, 16, ["modelValue"])
			], 46, PS), m.value ? (L(), A(E, { key: 0 }, [p.value ? (L(), O(MS, {
				key: 0,
				mode: e.createDraft.mode,
				"parent-path": e.createDraft.parentPath,
				depth: e.depth + 1,
				"existing-names": g.value,
				onConfirm: n[7] ||= (e) => t.$emit("create-confirm", e),
				onCancel: n[8] ||= (e) => t.$emit("cancel-create")
			}, null, 8, [
				"mode",
				"parent-path",
				"depth",
				"existing-names"
			])) : k("", !0), (L(!0), A(E, null, z(h.value, (i) => (L(), O(r, {
				key: i.path || i.name,
				node: i,
				depth: e.depth + 1,
				"selected-path": e.selectedPath,
				"expanded-paths": e.expandedPaths,
				"create-draft": e.createDraft,
				onSelect: b,
				onAction: n[9] ||= (e) => t.$emit("action", e),
				onCreateConfirm: n[10] ||= (e) => t.$emit("create-confirm", e),
				onCancelCreate: n[11] ||= (e) => t.$emit("cancel-create")
			}, null, 8, [
				"node",
				"depth",
				"selected-path",
				"expanded-paths",
				"create-draft"
			]))), 128))], 64)) : k("", !0)]);
		};
	}
}, [["__scopeId", "data-v-7c74704a"]]), RS = { class: "resource-tree-view fill-height" }, zS = {
	key: 0,
	class: "d-flex justify-center align-center pa-8"
}, BS = {
	key: 1,
	class: "pa-4 text-center text-medium-emphasis"
}, VS = { class: "text-body-medium" }, HS = {
	key: 2,
	class: "resource-tree-view__list pa-1 fill-height"
}, US = /*#__PURE__*/ Y({
	__name: "resource-tree-view",
	props: {
		items: {
			type: Array,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: !1
		},
		selectedPath: {
			type: String,
			default: ""
		},
		expandedPaths: {
			type: Array,
			default: () => []
		},
		emptyText: {
			type: String,
			default: void 0
		},
		createDraft: {
			type: Object,
			default: null
		}
	},
	emits: [
		"select",
		"action",
		"create-confirm",
		"cancel-create"
	],
	setup(e, { emit: t }) {
		let n = e, r = D(() => n.emptyText || K("admin_resources_no_resources_found")), i = t;
		dt(AS, R(null));
		function a(e, t) {
			if (t === void 0) {
				i("select", e);
				return;
			}
			i("select", e, t);
		}
		let o = D(() => n.items ? [...n.items].sort((e, t) => {
			let n = e.type === "directory" || Array.isArray(e.children), r = t.type === "directory" || Array.isArray(t.children);
			return n && !r ? -1 : !n && r ? 1 : (e.name || "").localeCompare(t.name || "");
		}) : []), s = D(() => !!(n.createDraft && !n.createDraft.parentPath)), c = D(() => o.value.map((e) => e.name));
		return (t, n) => (L(), A("div", RS, [e.loading ? (L(), A("div", zS, [N(wr, {
			indeterminate: "",
			size: "28",
			width: "2"
		})])) : !o.value.length && !s.value ? (L(), A("div", BS, [N(J, {
			icon: "mdi:mdi-folder-open-outline",
			size: "32",
			class: "mb-2 d-block mx-auto"
		}), j("span", VS, V(r.value), 1)])) : (L(), A("div", HS, [s.value ? (L(), O(MS, {
			key: 0,
			mode: e.createDraft.mode,
			"parent-path": e.createDraft.parentPath,
			depth: 0,
			"existing-names": c.value,
			onConfirm: n[0] ||= (e) => t.$emit("create-confirm", e),
			onCancel: n[1] ||= (e) => t.$emit("cancel-create")
		}, null, 8, [
			"mode",
			"parent-path",
			"existing-names"
		])) : k("", !0), (L(!0), A(E, null, z(o.value, (r) => (L(), O(LS, {
			key: r.path || r.name,
			node: r,
			depth: 0,
			"selected-path": e.selectedPath,
			"expanded-paths": e.expandedPaths,
			"create-draft": e.createDraft,
			onSelect: a,
			onAction: n[2] ||= (e) => t.$emit("action", e),
			onCreateConfirm: n[3] ||= (e) => t.$emit("create-confirm", e),
			onCancelCreate: n[4] ||= (e) => t.$emit("cancel-create")
		}, null, 8, [
			"node",
			"selected-path",
			"expanded-paths",
			"create-draft"
		]))), 128))]))]));
	}
}, [["__scopeId", "data-v-b6072887"]]);
//#endregion
//#region ../../../node_modules/marked/lib/marked.esm.js
function WS() {
	return {
		async: !1,
		breaks: !1,
		extensions: null,
		gfm: !0,
		hooks: null,
		pedantic: !1,
		renderer: null,
		silent: !1,
		tokenizer: null,
		walkTokens: null
	};
}
var GS = WS();
function KS(e) {
	GS = e;
}
var qS = { exec: () => null };
function JS(e) {
	let t = [];
	return (n) => {
		let r = Math.max(0, Math.min(3, n - 1)), i = t[r];
		return i || (i = e(r), t[r] = i), i;
	};
}
function YS(e, t = "") {
	let n = typeof e == "string" ? e : e.source, r = {
		replace: (e, t) => {
			let i = typeof t == "string" ? t : t.source;
			return i = i.replace(ZS.caret, "$1"), n = n.replace(e, i), r;
		},
		getRegex: () => new RegExp(n, t)
	};
	return r;
}
var XS = ((e = "") => {
	try {
		return !!RegExp("(?<=1)(?<!1)" + e);
	} catch {
		return !1;
	}
})(), ZS = {
	codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
	outputLinkReplace: /\\([\[\]])/g,
	indentCodeCompensation: /^(\s+)(?:```)/,
	beginningSpace: /^\s+/,
	endingHash: /#$/,
	startingSpaceChar: /^ /,
	endingSpaceChar: / $/,
	nonSpaceChar: /[^ ]/,
	newLineCharGlobal: /\n/g,
	tabCharGlobal: /\t/g,
	multipleSpaceGlobal: /\s+/g,
	blankLine: /^[ \t]*$/,
	doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
	blockquoteStart: /^ {0,3}>/,
	blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
	blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
	listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
	listIsTask: /^\[[ xX]\] +\S/,
	listReplaceTask: /^\[[ xX]\] +/,
	listTaskCheckbox: /\[[ xX]\]/,
	anyLine: /\n.*\n/,
	hrefBrackets: /^<(.*)>$/,
	tableDelimiter: /[:|]/,
	tableAlignChars: /^\||\| *$/g,
	tableRowBlankLine: /\n[ \t]*$/,
	tableAlignRight: /^ *-+: *$/,
	tableAlignCenter: /^ *:-+: *$/,
	tableAlignLeft: /^ *:-+ *$/,
	startATag: /^<a /i,
	endATag: /^<\/a>/i,
	startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
	endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
	startAngleBracket: /^</,
	endAngleBracket: />$/,
	pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
	unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
	escapeTest: /[&<>"']/,
	escapeReplace: /[&<>"']/g,
	escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
	escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
	caret: /(^|[^\[])\^/g,
	percentDecode: /%25/g,
	findPipe: /\|/g,
	splitPipe: / \|/,
	slashPipe: /\\\|/g,
	carriageReturn: /\r\n|\r/g,
	spaceLine: /^ +$/gm,
	notSpaceStart: /^\S*/,
	endingNewline: /\n$/,
	listItemRegex: (e) => RegExp(`^( {0,3}${e})((?:[	 ][^\\n]*)?(?:\\n|$))`),
	nextBulletRegex: JS((e) => RegExp(`^ {0,${e}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`)),
	hrRegex: JS((e) => RegExp(`^ {0,${e}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`)),
	fencesBeginRegex: JS((e) => RegExp(`^ {0,${e}}(?:\`\`\`|~~~)`)),
	headingBeginRegex: JS((e) => RegExp(`^ {0,${e}}#`)),
	htmlBeginRegex: JS((e) => RegExp(`^ {0,${e}}<(?:[a-z].*>|!--)`, "i")),
	blockquoteBeginRegex: JS((e) => RegExp(`^ {0,${e}}>`))
}, QS = /^(?:[ \t]*(?:\n|$))+/, $S = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, eC = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, tC = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, nC = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, rC = / {0,3}(?:[*+-]|\d{1,9}[.)])/, iC = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, aC = YS(iC).replace(/bull/g, rC).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), oC = YS(iC).replace(/bull/g, rC).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), sC = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, cC = /^[^\n]+/, lC = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, uC = YS(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", lC).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), dC = YS(/^(bull)([ \t][^\n]*?)?(?:\n|$)/).replace(/bull/g, rC).getRegex(), fC = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", pC = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, mC = YS("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", pC).replace("tag", fC).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), hC = YS(sC).replace("hr", tC).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]+[^ \\t\\n]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", fC).getRegex(), gC = {
	blockquote: YS(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", hC).getRegex(),
	code: $S,
	def: uC,
	fences: eC,
	heading: nC,
	hr: tC,
	html: mC,
	lheading: aC,
	list: dC,
	newline: QS,
	paragraph: hC,
	table: qS,
	text: cC
}, _C = YS("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", tC).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", fC).getRegex(), vC = {
	...gC,
	lheading: oC,
	table: _C,
	paragraph: YS(sC).replace("hr", tC).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", _C).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]+[^ \\t\\n]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", fC).getRegex()
}, yC = {
	...gC,
	html: YS("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", pC).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
	def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
	heading: /^(#{1,6})(.*)(?:\n+|$)/,
	fences: qS,
	lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
	paragraph: YS(sC).replace("hr", tC).replace("heading", " *#{1,6} *[^\n]").replace("lheading", aC).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, bC = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, xC = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, SC = /^( {2,}|\\)\n(?!\s*$)/, CC = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, wC = /[\p{P}\p{S}]/u, TC = /[\s\p{P}\p{S}]/u, EC = /[^\s\p{P}\p{S}]/u, DC = YS(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, TC).getRegex(), OC = /(?!~)[\p{P}\p{S}]/u, kC = /(?!~)[\s\p{P}\p{S}]/u, AC = /(?:[^\s\p{P}\p{S}]|~)/u, jC = YS(/link|precode-code|html/, "g").replace("link", /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace("precode-", XS ? "(?<!`)()" : "(^^|[^`])").replace("code", /(?<b>`+)[^`]+\k<b>(?!`)/).replace("html", /<(?! )[^<>]*?>/).getRegex(), MC = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, NC = YS(MC, "u").replace(/punct/g, wC).getRegex(), PC = YS(MC, "u").replace(/punct/g, OC).getRegex(), FC = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", IC = YS(FC, "gu").replace(/notPunctSpace/g, EC).replace(/punctSpace/g, TC).replace(/punct/g, wC).getRegex(), LC = YS(FC, "gu").replace(/notPunctSpace/g, AC).replace(/punctSpace/g, kC).replace(/punct/g, OC).getRegex(), RC = YS("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, EC).replace(/punctSpace/g, TC).replace(/punct/g, wC).getRegex(), zC = YS(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, wC).getRegex(), BC = YS("^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", "gu").replace(/notPunctSpace/g, EC).replace(/punctSpace/g, TC).replace(/punct/g, wC).getRegex(), VC = YS(/\\(punct)/, "gu").replace(/punct/g, wC).getRegex(), HC = YS(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), UC = YS(pC).replace("(?:-->|$)", "-->").getRegex(), WC = YS("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", UC).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), GC = /(?:\[(?:\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/, KC = YS(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?\s*\)/).replace("label", GC).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), qC = YS(/^!?\[(label)\]\[(ref)\]/).replace("label", GC).replace("ref", lC).getRegex(), JC = YS(/^!?\[(ref)\](?:\[\])?/).replace("ref", lC).getRegex(), YC = YS("reflink|nolink(?!\\()", "g").replace("reflink", qC).replace("nolink", JC).getRegex(), XC = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, ZC = {
	_backpedal: qS,
	anyPunctuation: VC,
	autolink: HC,
	blockSkip: jC,
	br: SC,
	code: xC,
	del: qS,
	delLDelim: qS,
	delRDelim: qS,
	emStrongLDelim: NC,
	emStrongRDelimAst: IC,
	emStrongRDelimUnd: RC,
	escape: bC,
	link: KC,
	nolink: JC,
	punctuation: DC,
	reflink: qC,
	reflinkSearch: YC,
	tag: WC,
	text: CC,
	url: qS
}, QC = {
	...ZC,
	link: YS(/^!?\[(label)\]\((.*?)\)/).replace("label", GC).getRegex(),
	reflink: YS(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", GC).getRegex()
}, $C = {
	...ZC,
	emStrongRDelimAst: LC,
	emStrongLDelim: PC,
	delLDelim: zC,
	delRDelim: BC,
	url: YS(/^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("protocol", XC).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
	_backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
	del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
	text: YS(/^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/).replace("protocol", XC).getRegex()
}, ew = {
	...$C,
	br: YS(SC).replace("{2,}", "*").getRegex(),
	text: YS($C.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, tw = {
	normal: gC,
	gfm: vC,
	pedantic: yC
}, nw = {
	normal: ZC,
	gfm: $C,
	breaks: ew,
	pedantic: QC
}, rw = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
}, iw = (e) => rw[e];
function aw(e, t) {
	if (t) {
		if (ZS.escapeTest.test(e)) return e.replace(ZS.escapeReplace, iw);
	} else if (ZS.escapeTestNoEncode.test(e)) return e.replace(ZS.escapeReplaceNoEncode, iw);
	return e;
}
function ow(e) {
	try {
		e = encodeURI(e).replace(ZS.percentDecode, "%");
	} catch {
		return null;
	}
	return e;
}
function sw(e, t) {
	let n = e.replace(ZS.findPipe, (e, t, n) => {
		let r = !1, i = t;
		for (; --i >= 0 && n[i] === "\\";) r = !r;
		return r ? "|" : " |";
	}).split(ZS.splitPipe), r = 0;
	if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), t) if (n.length > t) n.splice(t);
	else for (; n.length < t;) n.push("");
	for (; r < n.length; r++) n[r] = n[r].trim().replace(ZS.slashPipe, "|");
	return n;
}
function cw(e, t, n) {
	let r = e.length;
	if (r === 0) return "";
	let i = 0;
	for (; i < r;) {
		let a = e.charAt(r - i - 1);
		if (a === t && !n) i++;
		else if (a !== t && n) i++;
		else break;
	}
	return e.slice(0, r - i);
}
function lw(e) {
	let t = e.split("\n"), n = t.length - 1;
	for (; n >= 0 && ZS.blankLine.test(t[n]);) n--;
	return t.length - n <= 2 ? e : t.slice(0, n + 1).join("\n");
}
function uw(e, t) {
	if (e.indexOf(t[1]) === -1) return -1;
	let n = 0;
	for (let r = 0; r < e.length; r++) if (e[r] === "\\") r++;
	else if (e[r] === t[0]) n++;
	else if (e[r] === t[1] && (n--, n < 0)) return r;
	return n > 0 ? -2 : -1;
}
function dw(e, t = 0) {
	let n = t, r = "";
	for (let t of e) if (t === "	") {
		let e = 4 - n % 4;
		r += " ".repeat(e), n += e;
	} else r += t, n++;
	return r;
}
function fw(e, t, n, r, i) {
	let a = t.href, o = t.title || null, s = e[1].replace(i.other.outputLinkReplace, "$1");
	r.state.inLink = !0;
	let c = {
		type: e[0].charAt(0) === "!" ? "image" : "link",
		raw: n,
		href: a,
		title: o,
		text: s,
		tokens: r.inlineTokens(s)
	};
	return r.state.inLink = !1, c;
}
function pw(e, t, n) {
	let r = e.match(n.other.indentCodeCompensation);
	if (r === null) return t;
	let i = r[1];
	return t.split("\n").map((e) => {
		let t = e.match(n.other.beginningSpace);
		if (t === null) return e;
		let [r] = t;
		return r.length >= i.length ? e.slice(i.length) : e;
	}).join("\n");
}
var mw = class {
	options;
	rules;
	lexer;
	constructor(e) {
		this.options = e || GS;
	}
	space(e) {
		let t = this.rules.block.newline.exec(e);
		if (t && t[0].length > 0) return {
			type: "space",
			raw: t[0]
		};
	}
	code(e) {
		let t = this.rules.block.code.exec(e);
		if (t) {
			let e = this.options.pedantic ? t[0] : lw(t[0]);
			return {
				type: "code",
				raw: e,
				codeBlockStyle: "indented",
				text: e.replace(this.rules.other.codeRemoveIndent, "")
			};
		}
	}
	fences(e) {
		let t = this.rules.block.fences.exec(e);
		if (t) {
			let e = t[0], n = pw(e, t[3] || "", this.rules);
			return {
				type: "code",
				raw: e,
				lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
				text: n
			};
		}
	}
	heading(e) {
		let t = this.rules.block.heading.exec(e);
		if (t) {
			let e = t[2].trim();
			if (this.rules.other.endingHash.test(e)) {
				let t = cw(e, "#");
				(this.options.pedantic || !t || this.rules.other.endingSpaceChar.test(t)) && (e = t.trim());
			}
			return {
				type: "heading",
				raw: cw(t[0], "\n"),
				depth: t[1].length,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	hr(e) {
		let t = this.rules.block.hr.exec(e);
		if (t) return {
			type: "hr",
			raw: cw(t[0], "\n")
		};
	}
	blockquote(e) {
		let t = this.rules.block.blockquote.exec(e);
		if (t) {
			let e = cw(t[0], "\n").split("\n"), n = "", r = "", i = [];
			for (; e.length > 0;) {
				let t = !1, a = [], o;
				for (o = 0; o < e.length; o++) if (this.rules.other.blockquoteStart.test(e[o])) a.push(e[o]), t = !0;
				else if (!t) a.push(e[o]);
				else break;
				e = e.slice(o);
				let s = a.join("\n"), c = s.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
				n = n ? `${n}
${s}` : s, r = r ? `${r}
${c}` : c;
				let l = this.lexer.state.top;
				if (this.lexer.state.top = !0, this.lexer.blockTokens(c, i, !0), this.lexer.state.top = l, e.length === 0) break;
				let u = i.at(-1);
				if (u?.type === "code") break;
				if (u?.type === "blockquote") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.blockquote(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - t.raw.length) + o.raw, r = r.substring(0, r.length - t.text.length) + o.text;
					break;
				} else if (u?.type === "list") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.list(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - u.raw.length) + o.raw, r = r.substring(0, r.length - t.raw.length) + o.raw, e = a.substring(i.at(-1).raw.length).split("\n");
					continue;
				}
			}
			return {
				type: "blockquote",
				raw: n,
				tokens: i,
				text: r
			};
		}
	}
	list(e) {
		let t = this.rules.block.list.exec(e);
		if (t) {
			let n = t[1].trim(), r = n.length > 1, i = {
				type: "list",
				raw: "",
				ordered: r,
				start: r ? +n.slice(0, -1) : "",
				loose: !1,
				items: []
			};
			n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
			let a = this.rules.other.listItemRegex(n), o = !1;
			for (; e;) {
				let n = !1, r = "", s = "";
				if (!(t = a.exec(e)) || this.rules.block.hr.test(e)) break;
				r = t[0], e = e.substring(r.length);
				let c = dw(t[2].split("\n", 1)[0], t[1].length), l = e.split("\n", 1)[0], u = !c.trim(), d = 0;
				if (this.options.pedantic ? (d = 2, s = c.trimStart()) : u ? d = t[1].length + 1 : (d = c.search(this.rules.other.nonSpaceChar), d = d > 4 ? 1 : d, s = c.slice(d), d += t[1].length), u && this.rules.other.blankLine.test(l) && (r += l + "\n", e = e.substring(l.length + 1), n = !0), !n) {
					let t = this.rules.other.nextBulletRegex(d), n = this.rules.other.hrRegex(d), i = this.rules.other.fencesBeginRegex(d), a = this.rules.other.headingBeginRegex(d), o = this.rules.other.htmlBeginRegex(d), f = this.rules.other.blockquoteBeginRegex(d);
					for (; e;) {
						let p = e.split("\n", 1)[0], m;
						if (l = p, this.options.pedantic ? (l = l.replace(this.rules.other.listReplaceNesting, "  "), m = l) : m = l.replace(this.rules.other.tabCharGlobal, "    "), i.test(l) || a.test(l) || o.test(l) || f.test(l) || t.test(l) || n.test(l)) break;
						if (m.search(this.rules.other.nonSpaceChar) >= d || !l.trim()) s += "\n" + m.slice(d);
						else {
							if (u || c.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || i.test(c) || a.test(c) || n.test(c)) break;
							s += "\n" + l;
						}
						u = !l.trim(), r += p + "\n", e = e.substring(p.length + 1), c = m.slice(d);
					}
				}
				i.loose || (o ? i.loose = !0 : this.rules.other.doubleBlankLine.test(r) && (o = !0)), i.items.push({
					type: "list_item",
					raw: r,
					task: !!this.options.gfm && this.rules.other.listIsTask.test(s),
					loose: !1,
					text: s,
					tokens: []
				}), i.raw += r;
			}
			let s = i.items.at(-1);
			if (s) s.raw = s.raw.trimEnd(), s.text = s.text.trimEnd();
			else return;
			i.raw = i.raw.trimEnd();
			for (let e of i.items) {
				this.lexer.state.top = !1, e.tokens = this.lexer.blockTokens(e.text, []);
				let t = e.tokens[0];
				if (e.task && (t?.type === "text" || t?.type === "paragraph")) {
					e.text = e.text.replace(this.rules.other.listReplaceTask, ""), t.raw = t.raw.replace(this.rules.other.listReplaceTask, ""), t.text = t.text.replace(this.rules.other.listReplaceTask, "");
					for (let e = this.lexer.inlineQueue.length - 1; e >= 0; e--) if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[e].src)) {
						this.lexer.inlineQueue[e].src = this.lexer.inlineQueue[e].src.replace(this.rules.other.listReplaceTask, "");
						break;
					}
					let n = this.rules.other.listTaskCheckbox.exec(e.raw);
					if (n) {
						let t = {
							type: "checkbox",
							raw: n[0] + " ",
							checked: n[0] !== "[ ]"
						};
						e.checked = t.checked, i.loose ? e.tokens[0] && ["paragraph", "text"].includes(e.tokens[0].type) && "tokens" in e.tokens[0] && e.tokens[0].tokens ? (e.tokens[0].raw = t.raw + e.tokens[0].raw, e.tokens[0].text = t.raw + e.tokens[0].text, e.tokens[0].tokens.unshift(t)) : e.tokens.unshift({
							type: "paragraph",
							raw: t.raw,
							text: t.raw,
							tokens: [t]
						}) : e.tokens.unshift(t);
					}
				} else e.task &&= !1;
				if (!i.loose) {
					let t = e.tokens.filter((e) => e.type === "space");
					i.loose = t.length > 0 && t.some((e) => this.rules.other.anyLine.test(e.raw));
				}
			}
			if (i.loose) for (let e of i.items) {
				e.loose = !0;
				for (let t of e.tokens) t.type === "text" && (t.type = "paragraph");
			}
			return i;
		}
	}
	html(e) {
		let t = this.rules.block.html.exec(e);
		if (t) {
			let e = lw(t[0]);
			return {
				type: "html",
				block: !0,
				raw: e,
				pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
				text: e
			};
		}
	}
	def(e) {
		let t = this.rules.block.def.exec(e);
		if (t) {
			let e = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), n = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
			return {
				type: "def",
				tag: e,
				raw: cw(t[0], "\n"),
				href: n,
				title: r
			};
		}
	}
	table(e) {
		let t = this.rules.block.table.exec(e);
		if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
		let n = sw(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [], a = {
			type: "table",
			raw: cw(t[0], "\n"),
			header: [],
			align: [],
			rows: []
		};
		if (n.length === r.length) {
			for (let e of r) this.rules.other.tableAlignRight.test(e) ? a.align.push("right") : this.rules.other.tableAlignCenter.test(e) ? a.align.push("center") : this.rules.other.tableAlignLeft.test(e) ? a.align.push("left") : a.align.push(null);
			for (let e = 0; e < n.length; e++) a.header.push({
				text: n[e],
				tokens: this.lexer.inline(n[e]),
				header: !0,
				align: a.align[e]
			});
			for (let e of i) a.rows.push(sw(e, a.header.length).map((e, t) => ({
				text: e,
				tokens: this.lexer.inline(e),
				header: !1,
				align: a.align[t]
			})));
			return a;
		}
	}
	lheading(e) {
		let t = this.rules.block.lheading.exec(e);
		if (t) {
			let e = t[1].trim();
			return {
				type: "heading",
				raw: cw(t[0], "\n"),
				depth: t[2].charAt(0) === "=" ? 1 : 2,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	paragraph(e) {
		let t = this.rules.block.paragraph.exec(e);
		if (t) {
			let e = t[1].charAt(t[1].length - 1) === "\n" ? t[1].slice(0, -1) : t[1];
			return {
				type: "paragraph",
				raw: t[0],
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	text(e) {
		let t = this.rules.block.text.exec(e);
		if (t) return {
			type: "text",
			raw: t[0],
			text: t[0],
			tokens: this.lexer.inline(t[0])
		};
	}
	escape(e) {
		let t = this.rules.inline.escape.exec(e);
		if (t) return {
			type: "escape",
			raw: t[0],
			text: t[1]
		};
	}
	tag(e) {
		let t = this.rules.inline.tag.exec(e);
		if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
			type: "html",
			raw: t[0],
			inLink: this.lexer.state.inLink,
			inRawBlock: this.lexer.state.inRawBlock,
			block: !1,
			text: t[0]
		};
	}
	link(e) {
		let t = this.rules.inline.link.exec(e);
		if (t) {
			let e = t[2].trim();
			if (!this.options.pedantic && this.rules.other.startAngleBracket.test(e)) {
				if (!this.rules.other.endAngleBracket.test(e)) return;
				let t = cw(e.slice(0, -1), "\\");
				if ((e.length - t.length) % 2 == 0) return;
			} else {
				let e = uw(t[2], "()");
				if (e === -2) return;
				if (e > -1) {
					let n = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + e;
					t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, n).trim(), t[3] = "";
				}
			}
			let n = t[2], r = "";
			if (this.options.pedantic) {
				let e = this.rules.other.pedanticHrefTitle.exec(n);
				e && (n = e[1], r = e[3]);
			} else r = t[3] ? t[3].slice(1, -1) : "";
			return n = n.trim(), this.rules.other.startAngleBracket.test(n) && (n = this.options.pedantic && !this.rules.other.endAngleBracket.test(e) ? n.slice(1) : n.slice(1, -1)), fw(t, {
				href: n && n.replace(this.rules.inline.anyPunctuation, "$1"),
				title: r && r.replace(this.rules.inline.anyPunctuation, "$1")
			}, t[0], this.lexer, this.rules);
		}
	}
	reflink(e, t) {
		let n;
		if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
			let e = t[(n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " ").toLowerCase()];
			if (!e) {
				let e = n[0].charAt(0);
				return {
					type: "text",
					raw: e,
					text: e
				};
			}
			return fw(n, e, n[0], this.lexer, this.rules);
		}
	}
	emStrong(e, t, n = "") {
		let r = this.rules.inline.emStrongLDelim.exec(e);
		if (!(!r || !r[1] && !r[2] && !r[3] && !r[4] || r[4] && n.match(this.rules.other.unicodeAlphaNumeric)) && (!(r[1] || r[3]) || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = 0, c = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
			for (c.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = c.exec(t)) !== null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i) continue;
				if (a = [...i].length, r[3] || r[4]) {
					o += a;
					continue;
				} else if ((r[5] || r[6]) && n % 3 && !((n + a) % 3)) {
					s += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o + s);
				let t = [...r[0]][0].length, c = e.slice(0, n + r.index + t + a);
				if (Math.min(n, a) % 2) {
					let e = c.slice(1, -1);
					return {
						type: "em",
						raw: c,
						text: e,
						tokens: this.lexer.inlineTokens(e)
					};
				}
				let l = c.slice(2, -2);
				return {
					type: "strong",
					raw: c,
					text: l,
					tokens: this.lexer.inlineTokens(l)
				};
			}
		}
	}
	codespan(e) {
		let t = this.rules.inline.code.exec(e);
		if (t) {
			let e = t[2].replace(this.rules.other.newLineCharGlobal, " "), n = this.rules.other.nonSpaceChar.test(e), r = this.rules.other.startingSpaceChar.test(e) && this.rules.other.endingSpaceChar.test(e);
			return n && r && (e = e.substring(1, e.length - 1)), {
				type: "codespan",
				raw: t[0],
				text: e
			};
		}
	}
	br(e) {
		let t = this.rules.inline.br.exec(e);
		if (t) return {
			type: "br",
			raw: t[0]
		};
	}
	del(e, t, n = "") {
		let r = this.rules.inline.delLDelim.exec(e);
		if (r && (!r[1] || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = this.rules.inline.delRDelim;
			for (s.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = s.exec(t)) !== null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i || (a = [...i].length, a !== n)) continue;
				if (r[3] || r[4]) {
					o += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o);
				let t = [...r[0]][0].length, s = e.slice(0, n + r.index + t + a), c = s.slice(n, -n);
				return {
					type: "del",
					raw: s,
					text: c,
					tokens: this.lexer.inlineTokens(c)
				};
			}
		}
	}
	autolink(e) {
		let t = this.rules.inline.autolink.exec(e);
		if (t) {
			let e, n;
			return t[2] === "@" ? (e = t[1], n = "mailto:" + e) : (e = t[1], n = e), {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	url(e) {
		let t;
		if (t = this.rules.inline.url.exec(e)) {
			let e, n;
			if (t[2] === "@") e = t[0], n = "mailto:" + e;
			else {
				let r;
				do
					r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
				while (r !== t[0]);
				e = t[0], n = t[1] === "www." ? "http://" + t[0] : t[0];
			}
			return {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	inlineText(e) {
		let t = this.rules.inline.text.exec(e);
		if (t) {
			let e = this.lexer.state.inRawBlock;
			return {
				type: "text",
				raw: t[0],
				text: t[0],
				escaped: e
			};
		}
	}
}, hw = class e {
	tokens;
	options;
	state;
	inlineQueue;
	tokenizer;
	constructor(e) {
		this.tokens = [], this.tokens.links = Object.create(null), this.options = e || GS, this.options.tokenizer = this.options.tokenizer || new mw(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
			inLink: !1,
			inRawBlock: !1,
			top: !0
		};
		let t = {
			other: ZS,
			block: tw.normal,
			inline: nw.normal
		};
		this.options.pedantic ? (t.block = tw.pedantic, t.inline = nw.pedantic) : this.options.gfm && (t.block = tw.gfm, this.options.breaks ? t.inline = nw.breaks : t.inline = nw.gfm), this.tokenizer.rules = t;
	}
	static get rules() {
		return {
			block: tw,
			inline: nw
		};
	}
	static lex(t, n) {
		return new e(n).lex(t);
	}
	static lexInline(t, n) {
		return new e(n).inlineTokens(t);
	}
	lex(e) {
		e = e.replace(ZS.carriageReturn, "\n"), this.blockTokens(e, this.tokens);
		for (let e = 0; e < this.inlineQueue.length; e++) {
			let t = this.inlineQueue[e];
			this.inlineTokens(t.src, t.tokens);
		}
		return this.inlineQueue = [], this.tokens;
	}
	blockTokens(e, t = [], n = !1) {
		this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace(ZS.tabCharGlobal, "    ").replace(ZS.spaceLine, ""));
		let r = Infinity;
		for (; e;) {
			if (e.length < r) r = e.length;
			else {
				this.infiniteLoopError(e.charCodeAt(0));
				break;
			}
			let i;
			if (this.options.extensions?.block?.some((n) => (i = n.call({ lexer: this }, e, t)) ? (e = e.substring(i.raw.length), t.push(i), !0) : !1)) continue;
			if (i = this.tokenizer.space(e)) {
				e = e.substring(i.raw.length);
				let n = t.at(-1);
				i.raw.length === 1 && n !== void 0 ? n.raw += "\n" : t.push(i);
				continue;
			}
			if (i = this.tokenizer.code(e)) {
				e = e.substring(i.raw.length);
				let n = t.at(-1);
				n?.type === "paragraph" || n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + i.raw, n.text += "\n" + i.text, this.inlineQueue.at(-1).src = n.text) : t.push(i);
				continue;
			}
			if (i = this.tokenizer.fences(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.heading(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.hr(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.blockquote(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.list(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.html(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.def(e)) {
				e = e.substring(i.raw.length);
				let n = t.at(-1);
				n?.type === "paragraph" || n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + i.raw, n.text += "\n" + i.raw, this.inlineQueue.at(-1).src = n.text) : this.tokens.links[i.tag] || (this.tokens.links[i.tag] = {
					href: i.href,
					title: i.title
				}, t.push(i));
				continue;
			}
			if (i = this.tokenizer.table(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.lheading(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			let a = e;
			if (this.options.extensions?.startBlock) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startBlock.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (a = e.substring(0, t + 1));
			}
			if (this.state.top && (i = this.tokenizer.paragraph(a))) {
				let r = t.at(-1);
				n && r?.type === "paragraph" ? (r.raw += (r.raw.endsWith("\n") ? "" : "\n") + i.raw, r.text += "\n" + i.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = r.text) : t.push(i), n = a.length !== e.length, e = e.substring(i.raw.length);
				continue;
			}
			if (i = this.tokenizer.text(e)) {
				e = e.substring(i.raw.length);
				let n = t.at(-1);
				n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + i.raw, n.text += "\n" + i.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = n.text) : t.push(i);
				continue;
			}
			if (e) {
				this.infiniteLoopError(e.charCodeAt(0));
				break;
			}
		}
		return this.state.top = !0, t;
	}
	inline(e, t = []) {
		return this.inlineQueue.push({
			src: e,
			tokens: t
		}), t;
	}
	inlineTokens(e, t = []) {
		this.tokenizer.lexer = this;
		let n = e, r = null;
		if (this.tokens.links) {
			let e = Object.keys(this.tokens.links);
			if (e.length > 0) for (; (r = this.tokenizer.rules.inline.reflinkSearch.exec(n)) !== null;) e.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) && (n = n.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
		}
		for (; (r = this.tokenizer.rules.inline.anyPunctuation.exec(n)) !== null;) n = n.slice(0, r.index) + "++" + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
		let i;
		for (; (r = this.tokenizer.rules.inline.blockSkip.exec(n)) !== null;) i = r[2] ? r[2].length : 0, n = n.slice(0, r.index + i) + "[" + "a".repeat(r[0].length - i - 2) + "]" + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
		n = this.options.hooks?.emStrongMask?.call({ lexer: this }, n) ?? n;
		let a = !1, o = "", s = Infinity;
		for (; e;) {
			if (e.length < s) s = e.length;
			else {
				this.infiniteLoopError(e.charCodeAt(0));
				break;
			}
			a || (o = ""), a = !1;
			let r;
			if (this.options.extensions?.inline?.some((n) => (r = n.call({ lexer: this }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
			if (r = this.tokenizer.escape(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.tag(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.link(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.reflink(e, this.tokens.links)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				r.type === "text" && n?.type === "text" ? (n.raw += r.raw, n.text += r.text) : t.push(r);
				continue;
			}
			if (r = this.tokenizer.emStrong(e, n, o)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.codespan(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.br(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.del(e, n, o)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.autolink(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (!this.state.inLink && (r = this.tokenizer.url(e))) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			let i = e;
			if (this.options.extensions?.startInline) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startInline.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (i = e.substring(0, t + 1));
			}
			if (r = this.tokenizer.inlineText(i)) {
				e = e.substring(r.raw.length), r.raw.slice(-1) !== "_" && (o = r.raw.slice(-1)), a = !0;
				let n = t.at(-1);
				n?.type === "text" ? (n.raw += r.raw, n.text += r.text) : t.push(r);
				continue;
			}
			if (e) {
				this.infiniteLoopError(e.charCodeAt(0));
				break;
			}
		}
		return t;
	}
	infiniteLoopError(e) {
		let t = "Infinite loop on byte: " + e;
		if (this.options.silent) console.error(t);
		else throw Error(t);
	}
}, gw = class {
	options;
	parser;
	constructor(e) {
		this.options = e || GS;
	}
	space(e) {
		return "";
	}
	code({ text: e, lang: t, escaped: n }) {
		let r = (t || "").match(ZS.notSpaceStart)?.[0], i = e.replace(ZS.endingNewline, "") + "\n";
		return r ? "<pre><code class=\"language-" + aw(r) + "\">" + (n ? i : aw(i, !0)) + "</code></pre>\n" : "<pre><code>" + (n ? i : aw(i, !0)) + "</code></pre>\n";
	}
	blockquote({ tokens: e }) {
		return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
	}
	html({ text: e }) {
		return e;
	}
	def(e) {
		return "";
	}
	heading({ tokens: e, depth: t }) {
		return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
	}
	hr(e) {
		return "<hr>\n";
	}
	list(e) {
		let t = e.ordered, n = e.start, r = "";
		for (let t = 0; t < e.items.length; t++) {
			let n = e.items[t];
			r += this.listitem(n);
		}
		let i = t ? "ol" : "ul", a = t && n !== 1 ? " start=\"" + n + "\"" : "";
		return "<" + i + a + ">\n" + r + "</" + i + ">\n";
	}
	listitem(e) {
		return `<li>${this.parser.parse(e.tokens)}</li>
`;
	}
	checkbox({ checked: e }) {
		return "<input " + (e ? "checked=\"\" " : "") + "disabled=\"\" type=\"checkbox\"> ";
	}
	paragraph({ tokens: e }) {
		return `<p>${this.parser.parseInline(e)}</p>
`;
	}
	table(e) {
		let t = "", n = "";
		for (let t = 0; t < e.header.length; t++) n += this.tablecell(e.header[t]);
		t += this.tablerow({ text: n });
		let r = "";
		for (let t = 0; t < e.rows.length; t++) {
			let i = e.rows[t];
			n = "";
			for (let e = 0; e < i.length; e++) n += this.tablecell(i[e]);
			r += this.tablerow({ text: n });
		}
		return r &&= `<tbody>${r}</tbody>`, "<table>\n<thead>\n" + t + "</thead>\n" + r + "</table>\n";
	}
	tablerow({ text: e }) {
		return `<tr>
${e}</tr>
`;
	}
	tablecell(e) {
		let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
		return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
	}
	strong({ tokens: e }) {
		return `<strong>${this.parser.parseInline(e)}</strong>`;
	}
	em({ tokens: e }) {
		return `<em>${this.parser.parseInline(e)}</em>`;
	}
	codespan({ text: e }) {
		return `<code>${aw(e, !0)}</code>`;
	}
	br(e) {
		return "<br>";
	}
	del({ tokens: e }) {
		return `<del>${this.parser.parseInline(e)}</del>`;
	}
	link({ href: e, title: t, tokens: n }) {
		let r = this.parser.parseInline(n), i = ow(e);
		if (i === null) return r;
		e = i;
		let a = "<a href=\"" + e + "\"";
		return t && (a += " title=\"" + aw(t) + "\""), a += ">" + r + "</a>", a;
	}
	image({ href: e, title: t, text: n, tokens: r }) {
		r && (n = this.parser.parseInline(r, this.parser.textRenderer));
		let i = ow(e);
		if (i === null) return aw(n);
		e = i;
		let a = `<img src="${e}" alt="${aw(n)}"`;
		return t && (a += ` title="${aw(t)}"`), a += ">", a;
	}
	text(e) {
		return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : aw(e.text);
	}
}, _w = class {
	strong({ text: e }) {
		return e;
	}
	em({ text: e }) {
		return e;
	}
	codespan({ text: e }) {
		return e;
	}
	del({ text: e }) {
		return e;
	}
	html({ text: e }) {
		return e;
	}
	text({ text: e }) {
		return e;
	}
	link({ text: e }) {
		return "" + e;
	}
	image({ text: e }) {
		return "" + e;
	}
	br() {
		return "";
	}
	checkbox({ raw: e }) {
		return e;
	}
}, vw = class e {
	options;
	renderer;
	textRenderer;
	constructor(e) {
		this.options = e || GS, this.options.renderer = this.options.renderer || new gw(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new _w();
	}
	static parse(t, n) {
		return new e(n).parse(t);
	}
	static parseInline(t, n) {
		return new e(n).parseInline(t);
	}
	parse(e) {
		this.renderer.parser = this;
		let t = "";
		for (let n = 0; n < e.length; n++) {
			let r = e[n];
			if (this.options.extensions?.renderers?.[r.type]) {
				let e = r, n = this.options.extensions.renderers[e.type].call({ parser: this }, e);
				if (n !== !1 || ![
					"space",
					"hr",
					"heading",
					"code",
					"table",
					"blockquote",
					"list",
					"html",
					"def",
					"paragraph",
					"text"
				].includes(e.type)) {
					t += n || "";
					continue;
				}
			}
			let i = r;
			switch (i.type) {
				case "space":
					t += this.renderer.space(i);
					break;
				case "hr":
					t += this.renderer.hr(i);
					break;
				case "heading":
					t += this.renderer.heading(i);
					break;
				case "code":
					t += this.renderer.code(i);
					break;
				case "table":
					t += this.renderer.table(i);
					break;
				case "blockquote":
					t += this.renderer.blockquote(i);
					break;
				case "list":
					t += this.renderer.list(i);
					break;
				case "checkbox":
					t += this.renderer.checkbox(i);
					break;
				case "html":
					t += this.renderer.html(i);
					break;
				case "def":
					t += this.renderer.def(i);
					break;
				case "paragraph":
					t += this.renderer.paragraph(i);
					break;
				case "text":
					t += this.renderer.text(i);
					break;
				default: {
					let e = "Token with \"" + i.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return t;
	}
	parseInline(e, t = this.renderer) {
		this.renderer.parser = this;
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions?.renderers?.[i.type]) {
				let e = this.options.extensions.renderers[i.type].call({ parser: this }, i);
				if (e !== !1 || ![
					"escape",
					"html",
					"link",
					"image",
					"strong",
					"em",
					"codespan",
					"br",
					"del",
					"text"
				].includes(i.type)) {
					n += e || "";
					continue;
				}
			}
			let a = i;
			switch (a.type) {
				case "escape":
					n += t.text(a);
					break;
				case "html":
					n += t.html(a);
					break;
				case "link":
					n += t.link(a);
					break;
				case "image":
					n += t.image(a);
					break;
				case "checkbox":
					n += t.checkbox(a);
					break;
				case "strong":
					n += t.strong(a);
					break;
				case "em":
					n += t.em(a);
					break;
				case "codespan":
					n += t.codespan(a);
					break;
				case "br":
					n += t.br(a);
					break;
				case "del":
					n += t.del(a);
					break;
				case "text":
					n += t.text(a);
					break;
				default: {
					let e = "Token with \"" + a.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
}, yw = class {
	options;
	block;
	constructor(e) {
		this.options = e || GS;
	}
	static passThroughHooks = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens",
		"emStrongMask"
	]);
	static passThroughHooksRespectAsync = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens"
	]);
	preprocess(e) {
		return e;
	}
	postprocess(e) {
		return e;
	}
	processAllTokens(e) {
		return e;
	}
	emStrongMask(e) {
		return e;
	}
	provideLexer(e = this.block) {
		return e ? hw.lex : hw.lexInline;
	}
	provideParser(e = this.block) {
		return e ? vw.parse : vw.parseInline;
	}
}, bw = new class {
	defaults = WS();
	options = this.setOptions;
	parse = this.parseMarkdown(!0);
	parseInline = this.parseMarkdown(!1);
	Parser = vw;
	Renderer = gw;
	TextRenderer = _w;
	Lexer = hw;
	Tokenizer = mw;
	Hooks = yw;
	constructor(...e) {
		this.use(...e);
	}
	walkTokens(e, t) {
		let n = [];
		for (let r of e) switch (n = n.concat(t.call(this, r)), r.type) {
			case "table": {
				let e = r;
				for (let r of e.header) n = n.concat(this.walkTokens(r.tokens, t));
				for (let r of e.rows) for (let e of r) n = n.concat(this.walkTokens(e.tokens, t));
				break;
			}
			case "list": {
				let e = r;
				n = n.concat(this.walkTokens(e.items, t));
				break;
			}
			default: {
				let e = r;
				this.defaults.extensions?.childTokens?.[e.type] ? this.defaults.extensions.childTokens[e.type].forEach((r) => {
					let i = e[r].flat(Infinity);
					n = n.concat(this.walkTokens(i, t));
				}) : e.tokens && (n = n.concat(this.walkTokens(e.tokens, t)));
			}
		}
		return n;
	}
	use(...e) {
		let t = this.defaults.extensions || {
			renderers: {},
			childTokens: {}
		};
		return e.forEach((e) => {
			let n = { ...e };
			if (n.async = this.defaults.async || n.async || !1, e.extensions && (e.extensions.forEach((e) => {
				if (!e.name) throw Error("extension name required");
				if ("renderer" in e) {
					let n = t.renderers[e.name];
					n ? t.renderers[e.name] = function(...t) {
						let r = e.renderer.apply(this, t);
						return r === !1 && (r = n.apply(this, t)), r;
					} : t.renderers[e.name] = e.renderer;
				}
				if ("tokenizer" in e) {
					if (!e.level || e.level !== "block" && e.level !== "inline") throw Error("extension level must be 'block' or 'inline'");
					let n = t[e.level];
					n ? n.unshift(e.tokenizer) : t[e.level] = [e.tokenizer], e.start && (e.level === "block" ? t.startBlock ? t.startBlock.push(e.start) : t.startBlock = [e.start] : e.level === "inline" && (t.startInline ? t.startInline.push(e.start) : t.startInline = [e.start]));
				}
				"childTokens" in e && e.childTokens && (t.childTokens[e.name] = e.childTokens);
			}), n.extensions = t), e.renderer) {
				let t = this.defaults.renderer || new gw(this.defaults);
				for (let n in e.renderer) {
					if (!(n in t)) throw Error(`renderer '${n}' does not exist`);
					if (["options", "parser"].includes(n)) continue;
					let r = n, i = e.renderer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n || "";
					};
				}
				n.renderer = t;
			}
			if (e.tokenizer) {
				let t = this.defaults.tokenizer || new mw(this.defaults);
				for (let n in e.tokenizer) {
					if (!(n in t)) throw Error(`tokenizer '${n}' does not exist`);
					if ([
						"options",
						"rules",
						"lexer"
					].includes(n)) continue;
					let r = n, i = e.tokenizer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.tokenizer = t;
			}
			if (e.hooks) {
				let t = this.defaults.hooks || new yw();
				for (let n in e.hooks) {
					if (!(n in t)) throw Error(`hook '${n}' does not exist`);
					if (["options", "block"].includes(n)) continue;
					let r = n, i = e.hooks[r], a = t[r];
					yw.passThroughHooks.has(n) ? t[r] = (e) => {
						if (this.defaults.async && yw.passThroughHooksRespectAsync.has(n)) return (async () => {
							let n = await i.call(t, e);
							return a.call(t, n);
						})();
						let r = i.call(t, e);
						return a.call(t, r);
					} : t[r] = (...e) => {
						if (this.defaults.async) return (async () => {
							let n = await i.apply(t, e);
							return n === !1 && (n = await a.apply(t, e)), n;
						})();
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.hooks = t;
			}
			if (e.walkTokens) {
				let t = this.defaults.walkTokens, r = e.walkTokens;
				n.walkTokens = function(e) {
					let n = [];
					return n.push(r.call(this, e)), t && (n = n.concat(t.call(this, e))), n;
				};
			}
			this.defaults = {
				...this.defaults,
				...n
			};
		}), this;
	}
	setOptions(e) {
		return this.defaults = {
			...this.defaults,
			...e
		}, this;
	}
	lexer(e, t) {
		return hw.lex(e, t ?? this.defaults);
	}
	parser(e, t) {
		return vw.parse(e, t ?? this.defaults);
	}
	parseMarkdown(e) {
		return (t, n) => {
			let r = { ...n }, i = {
				...this.defaults,
				...r
			}, a = this.onError(!!i.silent, !!i.async);
			if (this.defaults.async === !0 && r.async === !1) return a(/* @__PURE__ */ Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
			if (typeof t > "u" || t === null) return a(/* @__PURE__ */ Error("marked(): input parameter is undefined or null"));
			if (typeof t != "string") return a(/* @__PURE__ */ Error("marked(): input parameter is of type " + Object.prototype.toString.call(t) + ", string expected"));
			if (i.hooks && (i.hooks.options = i, i.hooks.block = e), i.async) return (async () => {
				let n = i.hooks ? await i.hooks.preprocess(t) : t, r = await (i.hooks ? await i.hooks.provideLexer(e) : e ? hw.lex : hw.lexInline)(n, i), a = i.hooks ? await i.hooks.processAllTokens(r) : r;
				i.walkTokens && await Promise.all(this.walkTokens(a, i.walkTokens));
				let o = await (i.hooks ? await i.hooks.provideParser(e) : e ? vw.parse : vw.parseInline)(a, i);
				return i.hooks ? await i.hooks.postprocess(o) : o;
			})().catch(a);
			try {
				i.hooks && (t = i.hooks.preprocess(t));
				let n = (i.hooks ? i.hooks.provideLexer(e) : e ? hw.lex : hw.lexInline)(t, i);
				i.hooks && (n = i.hooks.processAllTokens(n)), i.walkTokens && this.walkTokens(n, i.walkTokens);
				let r = (i.hooks ? i.hooks.provideParser(e) : e ? vw.parse : vw.parseInline)(n, i);
				return i.hooks && (r = i.hooks.postprocess(r)), r;
			} catch (e) {
				return a(e);
			}
		};
	}
	onError(e, t) {
		return (n) => {
			if (n.message += "\nPlease report this to https://github.com/markedjs/marked.", e) {
				let e = "<p>An error occurred:</p><pre>" + aw(n.message + "", !0) + "</pre>";
				return t ? Promise.resolve(e) : e;
			}
			if (t) return Promise.reject(n);
			throw n;
		};
	}
}();
function xw(e, t) {
	return bw.parse(e, t);
}
xw.options = xw.setOptions = function(e) {
	return bw.setOptions(e), xw.defaults = bw.defaults, KS(xw.defaults), xw;
}, xw.getDefaults = WS, xw.defaults = GS, xw.use = function(...e) {
	return bw.use(...e), xw.defaults = bw.defaults, KS(xw.defaults), xw;
}, xw.walkTokens = function(e, t) {
	return bw.walkTokens(e, t);
}, xw.parseInline = bw.parseInline, xw.Parser = vw, xw.parser = vw.parse, xw.Renderer = gw, xw.TextRenderer = _w, xw.Lexer = hw, xw.lexer = hw.lex, xw.Tokenizer = mw, xw.Hooks = yw, xw.parse = xw, xw.options, xw.setOptions, xw.use, xw.walkTokens, xw.parseInline, vw.parse, hw.lex;
//#endregion
//#region ../../../node_modules/dompurify/dist/purify.es.mjs
function Sw(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Cw(e) {
	if (Array.isArray(e)) return e;
}
function ww(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function Tw() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Ew(e, t) {
	return Cw(e) || ww(e, t) || Dw(e, t) || Tw();
}
function Dw(e, t) {
	if (e) {
		if (typeof e == "string") return Sw(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Sw(e, t) : void 0;
	}
}
var Ow = Object.entries, kw = Object.setPrototypeOf, Aw = Object.isFrozen, jw = Object.getPrototypeOf, Mw = Object.getOwnPropertyDescriptor, Nw = Object.freeze, Pw = Object.seal, Fw = Object.create, Iw = typeof Reflect < "u" && Reflect, Lw = Iw.apply, Rw = Iw.construct;
Nw ||= function(e) {
	return e;
}, Pw ||= function(e) {
	return e;
}, Lw ||= function(e, t) {
	var n = [...arguments].slice(2);
	return e.apply(t, n);
}, Rw ||= function(e) {
	return new e(...[...arguments].slice(1));
};
var zw = aT(Array.prototype.forEach), Bw = aT(Array.prototype.lastIndexOf), Vw = aT(Array.prototype.pop), Hw = aT(Array.prototype.push), Uw = aT(Array.prototype.splice), Ww = Array.isArray, Gw = aT(String.prototype.toLowerCase), Kw = aT(String.prototype.toString), qw = aT(String.prototype.match), Jw = aT(String.prototype.replace), Yw = aT(String.prototype.indexOf), Xw = aT(String.prototype.trim), Zw = aT(Number.prototype.toString), Qw = aT(Boolean.prototype.toString), $w = typeof BigInt > "u" ? null : aT(BigInt.prototype.toString), eT = typeof Symbol > "u" ? null : aT(Symbol.prototype.toString), tT = aT(Object.prototype.hasOwnProperty), nT = aT(Object.prototype.toString), rT = aT(RegExp.prototype.test), iT = oT(TypeError);
function aT(e) {
	return function(t) {
		t instanceof RegExp && (t.lastIndex = 0);
		var n = [...arguments].slice(1);
		return Lw(e, t, n);
	};
}
function oT(e) {
	return function() {
		return Rw(e, [...arguments]);
	};
}
function sT(e, t) {
	let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Gw;
	if (kw && kw(e, null), !Ww(t)) return e;
	let r = t.length;
	for (; r--;) {
		let i = t[r];
		if (typeof i == "string") {
			let e = n(i);
			e !== i && (Aw(t) || (t[r] = e), i = e);
		}
		e[i] = !0;
	}
	return e;
}
function cT(e) {
	for (let t = 0; t < e.length; t++) tT(e, t) || (e[t] = null);
	return e;
}
function lT(e) {
	let t = Fw(null);
	for (let r of Ow(e)) {
		var n = Ew(r, 2);
		let i = n[0], a = n[1];
		tT(e, i) && (Ww(a) ? t[i] = cT(a) : a && typeof a == "object" && a.constructor === Object ? t[i] = lT(a) : t[i] = a);
	}
	return t;
}
function uT(e) {
	switch (typeof e) {
		case "string": return e;
		case "number": return Zw(e);
		case "boolean": return Qw(e);
		case "bigint": return $w ? $w(e) : "0";
		case "symbol": return eT ? eT(e) : "Symbol()";
		case "undefined": return nT(e);
		case "function":
		case "object": {
			if (e === null) return nT(e);
			let t = e, n = dT(t, "toString");
			if (typeof n == "function") {
				let e = n(t);
				return typeof e == "string" ? e : nT(e);
			}
			return nT(e);
		}
		default: return nT(e);
	}
}
function dT(e, t) {
	for (; e !== null;) {
		let n = Mw(e, t);
		if (n) {
			if (n.get) return aT(n.get);
			if (typeof n.value == "function") return aT(n.value);
		}
		e = jw(e);
	}
	function n() {
		return null;
	}
	return n;
}
function fT(e) {
	try {
		return rT(e, ""), !0;
	} catch {
		return !1;
	}
}
var pT = Nw(/* @__PURE__ */ "a.abbr.acronym.address.area.article.aside.audio.b.bdi.bdo.big.blink.blockquote.body.br.button.canvas.caption.center.cite.code.col.colgroup.content.data.datalist.dd.decorator.del.details.dfn.dialog.dir.div.dl.dt.element.em.fieldset.figcaption.figure.font.footer.form.h1.h2.h3.h4.h5.h6.head.header.hgroup.hr.html.i.img.input.ins.kbd.label.legend.li.main.map.mark.marquee.menu.menuitem.meter.nav.nobr.ol.optgroup.option.output.p.picture.pre.progress.q.rp.rt.ruby.s.samp.search.section.select.shadow.slot.small.source.spacer.span.strike.strong.style.sub.summary.sup.table.tbody.td.template.textarea.tfoot.th.thead.time.tr.track.tt.u.ul.var.video.wbr".split(".")), mT = Nw(/* @__PURE__ */ "svg.a.altglyph.altglyphdef.altglyphitem.animatecolor.animatemotion.animatetransform.circle.clippath.defs.desc.ellipse.enterkeyhint.exportparts.filter.font.g.glyph.glyphref.hkern.image.inputmode.line.lineargradient.marker.mask.metadata.mpath.part.path.pattern.polygon.polyline.radialgradient.rect.stop.style.switch.symbol.text.textpath.title.tref.tspan.view.vkern".split(".")), hT = Nw([
	"feBlend",
	"feColorMatrix",
	"feComponentTransfer",
	"feComposite",
	"feConvolveMatrix",
	"feDiffuseLighting",
	"feDisplacementMap",
	"feDistantLight",
	"feDropShadow",
	"feFlood",
	"feFuncA",
	"feFuncB",
	"feFuncG",
	"feFuncR",
	"feGaussianBlur",
	"feImage",
	"feMerge",
	"feMergeNode",
	"feMorphology",
	"feOffset",
	"fePointLight",
	"feSpecularLighting",
	"feSpotLight",
	"feTile",
	"feTurbulence"
]), gT = Nw([
	"animate",
	"color-profile",
	"cursor",
	"discard",
	"font-face",
	"font-face-format",
	"font-face-name",
	"font-face-src",
	"font-face-uri",
	"foreignobject",
	"hatch",
	"hatchpath",
	"mesh",
	"meshgradient",
	"meshpatch",
	"meshrow",
	"missing-glyph",
	"script",
	"set",
	"solidcolor",
	"unknown",
	"use"
]), _T = Nw(/* @__PURE__ */ "math.menclose.merror.mfenced.mfrac.mglyph.mi.mlabeledtr.mmultiscripts.mn.mo.mover.mpadded.mphantom.mroot.mrow.ms.mspace.msqrt.mstyle.msub.msup.msubsup.mtable.mtd.mtext.mtr.munder.munderover.mprescripts".split(".")), vT = Nw([
	"maction",
	"maligngroup",
	"malignmark",
	"mlongdiv",
	"mscarries",
	"mscarry",
	"msgroup",
	"mstack",
	"msline",
	"msrow",
	"semantics",
	"annotation",
	"annotation-xml",
	"mprescripts",
	"none"
]), yT = Nw(["#text"]), bT = Nw(/* @__PURE__ */ "accept.action.align.alt.autocapitalize.autocomplete.autopictureinpicture.autoplay.background.bgcolor.border.capture.cellpadding.cellspacing.checked.cite.class.clear.color.cols.colspan.command.commandfor.controls.controlslist.coords.crossorigin.datetime.decoding.default.dir.disabled.disablepictureinpicture.disableremoteplayback.download.draggable.enctype.enterkeyhint.exportparts.face.for.headers.height.hidden.high.href.hreflang.id.inert.inputmode.integrity.ismap.kind.label.lang.list.loading.loop.low.max.maxlength.media.method.min.minlength.multiple.muted.name.nonce.noshade.novalidate.nowrap.open.optimum.part.pattern.placeholder.playsinline.popover.popovertarget.popovertargetaction.poster.preload.pubdate.radiogroup.readonly.rel.required.rev.reversed.role.rows.rowspan.spellcheck.scope.selected.shape.size.sizes.slot.span.srclang.start.src.srcset.step.style.summary.tabindex.title.translate.type.usemap.valign.value.width.wrap.xmlns".split(".")), xT = Nw(/* @__PURE__ */ "accent-height.accumulate.additive.alignment-baseline.amplitude.ascent.attributename.attributetype.azimuth.basefrequency.baseline-shift.begin.bias.by.class.clip.clippathunits.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.cx.cy.d.dx.dy.diffuseconstant.direction.display.divisor.dominant-baseline.dur.edgemode.elevation.end.exponent.fill.fill-opacity.fill-rule.filter.filterunits.flood-color.flood-opacity.font-family.font-size.font-size-adjust.font-stretch.font-style.font-variant.font-weight.fx.fy.g1.g2.glyph-name.glyphref.gradientunits.gradienttransform.height.href.id.image-rendering.in.in2.intercept.k.k1.k2.k3.k4.kerning.keypoints.keysplines.keytimes.lang.lengthadjust.letter-spacing.kernelmatrix.kernelunitlength.lighting-color.local.marker-end.marker-mid.marker-start.markerheight.markerunits.markerwidth.maskcontentunits.maskunits.max.mask.mask-type.media.method.mode.min.name.numoctaves.offset.operator.opacity.order.orient.orientation.origin.overflow.paint-order.path.pathlength.patterncontentunits.patterntransform.patternunits.pointer-events.points.preservealpha.preserveaspectratio.primitiveunits.r.rx.ry.radius.refx.refy.repeatcount.repeatdur.restart.result.rotate.scale.seed.shape-rendering.slope.specularconstant.specularexponent.spreadmethod.startoffset.stddeviation.stitchtiles.stop-color.stop-opacity.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke.stroke-width.style.surfacescale.systemlanguage.tabindex.tablevalues.targetx.targety.transform.transform-origin.text-anchor.text-decoration.text-orientation.text-rendering.textlength.type.u1.u2.unicode.values.vector-effect.viewbox.visibility.version.vert-adv-y.vert-origin-x.vert-origin-y.width.word-spacing.wrap.writing-mode.xchannelselector.ychannelselector.x.x1.x2.xmlns.y.y1.y2.z.zoomandpan".split(".")), ST = Nw(/* @__PURE__ */ "accent.accentunder.align.bevelled.close.columnalign.columnlines.columnspacing.columnspan.denomalign.depth.dir.display.displaystyle.encoding.fence.frame.height.href.id.largeop.length.linethickness.lquote.lspace.mathbackground.mathcolor.mathsize.mathvariant.maxsize.minsize.movablelimits.notation.numalign.open.rowalign.rowlines.rowspacing.rowspan.rspace.rquote.scriptlevel.scriptminsize.scriptsizemultiplier.selection.separator.separators.stretchy.subscriptshift.supscriptshift.symmetric.voffset.width.xmlns".split(".")), CT = Nw([
	"xlink:href",
	"xml:id",
	"xlink:title",
	"xml:space",
	"xmlns:xlink"
]), wT = Pw(/{{[\w\W]*|^[\w\W]*}}/g), TT = Pw(/<%[\w\W]*|^[\w\W]*%>/g), ET = Pw(/\${[\w\W]*/g), DT = Pw(/^data-[\-\w.\u00B7-\uFFFF]+$/), OT = Pw(/^aria-[\-\w]+$/), kT = Pw(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), AT = Pw(/^(?:\w+script|data):/i), jT = Pw(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), MT = Pw(/^html$/i), NT = Pw(/^[a-z][.\w]*(-[.\w]+)+$/i), PT = Pw(/<[/\w!]/g), FT = Pw(/<[/\w]/g), IT = Pw(/<\/no(script|embed|frames)/i), LT = Pw(/\/>/i), RT = {
	element: 1,
	attribute: 2,
	text: 3,
	cdataSection: 4,
	entityReference: 5,
	entityNode: 6,
	processingInstruction: 7,
	comment: 8,
	document: 9,
	documentType: 10,
	documentFragment: 11,
	notation: 12
}, zT = [
	"style",
	"script",
	"xmp",
	"iframe",
	"noembed",
	"noframes",
	"plaintext",
	"noscript"
], BT = Nw(sT({}, zT)), VT = function() {
	let e = {};
	return zw(zT, (t) => {
		e[t] = Pw(RegExp("</" + t + "(?=[\\t\\n\\f\\r />])", "i"));
	}), Nw(e);
}(), HT = function() {
	return typeof window > "u" ? null : window;
}, UT = function(e, t) {
	if (typeof e != "object" || typeof e.createPolicy != "function") return null;
	let n = null, r = "data-tt-policy-suffix";
	t && t.hasAttribute(r) && (n = t.getAttribute(r));
	let i = "dompurify" + (n ? "#" + n : "");
	try {
		return e.createPolicy(i, {
			createHTML(e) {
				return e;
			},
			createScriptURL(e) {
				return e;
			}
		});
	} catch {
		return console.warn("TrustedTypes policy " + i + " could not be created."), null;
	}
}, WT = function() {
	return {
		afterSanitizeAttributes: [],
		afterSanitizeElements: [],
		afterSanitizeShadowDOM: [],
		beforeSanitizeAttributes: [],
		beforeSanitizeElements: [],
		beforeSanitizeShadowDOM: [],
		uponSanitizeAttribute: [],
		uponSanitizeElement: [],
		uponSanitizeShadowNode: []
	};
}, GT = function(e, t, n, r) {
	return tT(e, t) && Ww(e[t]) ? sT(r.base ? lT(r.base) : {}, e[t], r.transform) : n;
}, KT = function(e, t, n) {
	let r = tT(e, t) ? e[t] : void 0;
	return r && typeof r == "object" ? lT(r) : n();
};
function qT() {
	let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : HT(), t = (e) => qT(e);
	if (t.version = "3.4.14", t.removed = [], !e || !e.document || e.document.nodeType !== RT.document || !e.Element) return t.isSupported = !1, t;
	let n = e.document, r = n, i = r.currentScript;
	e.DocumentFragment;
	let a = e.HTMLTemplateElement, o = e.Node, s = e.Element, c = e.NodeFilter;
	e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
	let l = e.DOMParser, u = e.trustedTypes, d = s.prototype, f = dT(d, "cloneNode"), p = dT(d, "remove"), m = dT(d, "nextSibling"), h = dT(d, "childNodes"), g = dT(d, "parentNode"), _ = dT(d, "shadowRoot"), v = dT(d, "attributes"), y = o && o.prototype ? dT(o.prototype, "nodeType") : null, b = o && o.prototype ? dT(o.prototype, "nodeName") : null, x = o && o.prototype ? dT(o.prototype, "ownerDocument") : null, S = function(e) {
		return y ? y(e) : e.nodeType;
	}, C = function(e) {
		return b ? b(e) : e.nodeName;
	};
	if (typeof a == "function") {
		let e = n.createElement("template");
		e.content && e.content.ownerDocument && (n = e.content.ownerDocument);
	}
	let w, T = "", ee, te = !1, ne = 0, re = function() {
		if (ne > 0) throw iT("A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the \"DOMPurify and Trusted Types\" section of the README.");
	}, ie = function(e) {
		re(), ne++;
		try {
			return w.createHTML(e);
		} finally {
			ne--;
		}
	}, ae = function(e) {
		re(), ne++;
		try {
			return w.createScriptURL(e);
		} finally {
			ne--;
		}
	}, oe = function() {
		return te ||= (ee = UT(u, i), !0), ee;
	}, se = n, ce = se.implementation, le = se.createNodeIterator, ue = se.createDocumentFragment, de = se.getElementsByTagName, fe = r.importNode, pe = WT();
	t.isSupported = typeof Ow == "function" && typeof g == "function" && ce && ce.createHTMLDocument !== void 0;
	let me = wT, he = TT, ge = ET, _e = DT, ve = OT, ye = AT, be = jT, xe = NT, Se = kT, Ce = null, we = sT({}, [
		...pT,
		...mT,
		...hT,
		..._T,
		...yT
	]), Te = null, Ee = sT({}, [
		...bT,
		...xT,
		...ST,
		...CT
	]), De = Object.seal(Fw(null, {
		tagNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		allowCustomizedBuiltInElements: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: !1
		}
	})), Oe = null, ke = null, Ae = Object.seal(Fw(null, {
		tagCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		}
	})), je = !0, Me = !0, Ne = !1, Pe = !0, Fe = !1, Ie = !0, Le = !1, Re = !1, ze = null, Be = null, Ve = !1, He = !1, Ue = !1, We = !1, Ge = !0, Ke = !1, qe = "user-content-", E = !0, Je = !1, D = {}, O = null, k = sT({}, /* @__PURE__ */ "annotation-xml.audio.colgroup.desc.foreignobject.head.iframe.math.mi.mn.mo.ms.mtext.noembed.noframes.noscript.plaintext.script.selectedcontent.style.svg.template.thead.title.video.xmp".split(".")), A = null, j = sT({}, [
		"audio",
		"video",
		"img",
		"source",
		"image",
		"track"
	]), Ye = null, M = sT({}, [
		"alt",
		"class",
		"for",
		"id",
		"label",
		"name",
		"pattern",
		"placeholder",
		"role",
		"summary",
		"title",
		"value",
		"style",
		"xmlns"
	]), N = "http://www.w3.org/1998/Math/MathML", Xe = "http://www.w3.org/2000/svg", P = "http://www.w3.org/1999/xhtml", Ze = P, Qe = !1, $e = null, et = sT({}, [
		N,
		Xe,
		P
	], Kw), tt = Nw([
		"mi",
		"mo",
		"mn",
		"ms",
		"mtext"
	]), nt = sT({}, tt), rt = Nw(["annotation-xml"]), F = sT({}, rt), it = sT({}, [
		"title",
		"style",
		"font",
		"a",
		"script"
	]), I = null, at = ["application/xhtml+xml", "text/html"], ot = null, st = null, ct = n.createElement("form"), lt = function(e) {
		return e instanceof RegExp || e instanceof Function;
	}, ut = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		if (st && st === e) return;
		(!e || typeof e != "object") && (e = {}), e = lT(e), I = at.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? "text/html" : e.PARSER_MEDIA_TYPE, ot = I === "application/xhtml+xml" ? Kw : Gw, Ce = GT(e, "ALLOWED_TAGS", we, { transform: ot }), Te = GT(e, "ALLOWED_ATTR", Ee, { transform: ot }), $e = GT(e, "ALLOWED_NAMESPACES", et, { transform: Kw }), Ye = GT(e, "ADD_URI_SAFE_ATTR", M, {
			transform: ot,
			base: M
		}), A = GT(e, "ADD_DATA_URI_TAGS", j, {
			transform: ot,
			base: j
		}), O = GT(e, "FORBID_CONTENTS", k, { transform: ot }), Oe = GT(e, "FORBID_TAGS", lT({}), { transform: ot }), ke = GT(e, "FORBID_ATTR", lT({}), { transform: ot }), D = tT(e, "USE_PROFILES") ? e.USE_PROFILES && typeof e.USE_PROFILES == "object" ? lT(e.USE_PROFILES) : e.USE_PROFILES : !1, je = e.ALLOW_ARIA_ATTR !== !1, Me = e.ALLOW_DATA_ATTR !== !1, Ne = e.ALLOW_UNKNOWN_PROTOCOLS || !1, Pe = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Fe = e.SAFE_FOR_TEMPLATES || !1, Ie = e.SAFE_FOR_XML !== !1, Le = e.WHOLE_DOCUMENT || !1, He = e.RETURN_DOM || !1, Ue = e.RETURN_DOM_FRAGMENT || !1, We = e.RETURN_TRUSTED_TYPE || !1, Ve = e.FORCE_BODY || !1, Ge = e.SANITIZE_DOM !== !1, Ke = e.SANITIZE_NAMED_PROPS || !1, E = e.KEEP_CONTENT !== !1, Je = e.IN_PLACE || !1, Se = fT(e.ALLOWED_URI_REGEXP) ? e.ALLOWED_URI_REGEXP : kT, Ze = typeof e.NAMESPACE == "string" ? e.NAMESPACE : P, nt = KT(e, "MATHML_TEXT_INTEGRATION_POINTS", () => sT({}, tt)), F = KT(e, "HTML_INTEGRATION_POINTS", () => sT({}, rt));
		let t = KT(e, "CUSTOM_ELEMENT_HANDLING", () => Fw(null));
		if (De = Fw(null), tT(t, "tagNameCheck") && lt(t.tagNameCheck) && (De.tagNameCheck = t.tagNameCheck), tT(t, "attributeNameCheck") && lt(t.attributeNameCheck) && (De.attributeNameCheck = t.attributeNameCheck), tT(t, "allowCustomizedBuiltInElements") && typeof t.allowCustomizedBuiltInElements == "boolean" && (De.allowCustomizedBuiltInElements = t.allowCustomizedBuiltInElements), Pw(De), Fe && (Me = !1), Ue && (He = !0), D && (Ce = sT({}, yT), Te = Fw(null), D.html === !0 && (sT(Ce, pT), sT(Te, bT)), D.svg === !0 && (sT(Ce, mT), sT(Te, xT), sT(Te, CT)), D.svgFilters === !0 && (sT(Ce, hT), sT(Te, xT), sT(Te, CT)), D.mathMl === !0 && (sT(Ce, _T), sT(Te, ST), sT(Te, CT))), Ae.tagCheck = null, Ae.attributeCheck = null, tT(e, "ADD_TAGS") && (typeof e.ADD_TAGS == "function" ? Ae.tagCheck = e.ADD_TAGS : Ww(e.ADD_TAGS) && (Ce === we && (Ce = lT(Ce)), sT(Ce, e.ADD_TAGS, ot))), tT(e, "ADD_ATTR") && (typeof e.ADD_ATTR == "function" ? Ae.attributeCheck = e.ADD_ATTR : Ww(e.ADD_ATTR) && (Te === Ee && (Te = lT(Te)), sT(Te, e.ADD_ATTR, ot))), tT(e, "ADD_FORBID_CONTENTS") && Ww(e.ADD_FORBID_CONTENTS) && (O === k && (O = lT(O)), sT(O, e.ADD_FORBID_CONTENTS, ot)), E && (Ce["#text"] = !0), Le && sT(Ce, [
			"html",
			"head",
			"body"
		]), Ce.table && (sT(Ce, ["tbody"]), delete Oe.tbody), e.TRUSTED_TYPES_POLICY) {
			if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function") throw iT("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
			if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw iT("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
			let t = w;
			w = e.TRUSTED_TYPES_POLICY;
			try {
				T = ie("");
			} catch (e) {
				throw w = t, e;
			}
		} else e.TRUSTED_TYPES_POLICY === null ? (w = void 0, T = "") : (w === void 0 && (w = oe()), w && typeof T == "string" && (T = ie("")));
		Nw && Nw(e), st = e;
	}, L = sT({}, [
		...mT,
		...hT,
		...gT
	]), dt = sT({}, [..._T, ...vT]), ft = function(e, t, n) {
		return t.namespaceURI === P ? e === "svg" : t.namespaceURI === N ? e === "svg" && (n === "annotation-xml" || nt[n]) : !!L[e];
	}, R = function(e, t, n) {
		return t.namespaceURI === P ? e === "math" : t.namespaceURI === Xe ? e === "math" && F[n] : !!dt[e];
	}, z = function(e, t, n) {
		return t.namespaceURI === Xe && !F[n] || t.namespaceURI === N && !nt[n] ? !1 : !dt[e] && (it[e] || !L[e]);
	}, B = function(e) {
		let t = g(e);
		(!t || !t.tagName) && (t = {
			namespaceURI: Ze,
			tagName: "template"
		});
		let n = Gw(e.tagName), r = Gw(t.tagName);
		return $e[e.namespaceURI] ? e.namespaceURI === Xe ? ft(n, t, r) : e.namespaceURI === N ? R(n, t, r) : e.namespaceURI === P ? z(n, t, r) : !!(I === "application/xhtml+xml" && $e[e.namespaceURI]) : !1;
	}, pt = function(e) {
		Hw(t.removed, { element: e });
		try {
			g(e).removeChild(e);
		} catch {
			if (p(e), !g(e)) throw iT("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
		}
	}, mt = function(e, t, n) {
		try {
			e.removeAttributeNode(t);
		} catch {
			try {
				e.removeAttribute(n);
			} catch {}
		}
	}, ht = function(e) {
		_t(e);
		let t = h(e);
		if (t) {
			let e = [];
			zw(t, (t) => {
				Hw(e, t);
			}), zw(e, (e) => {
				try {
					p(e);
				} catch {}
			});
		}
		let n = v(e);
		if (n) for (let t = n.length - 1; t >= 0; --t) {
			let r = n[t], i = r && r.name;
			typeof i == "string" && mt(e, r, i);
		}
	}, V = function(e, n, r) {
		if (!r) try {
			r = n.getAttributeNode(e);
		} catch {
			r = null;
		}
		Hw(t.removed, {
			attribute: r || null,
			from: n
		});
		try {
			r ? n.removeAttributeNode(r) : n.removeAttribute(e);
		} catch {
			try {
				n.removeAttribute(e);
			} catch {}
		}
		if (e === "is") if (He || Ue) try {
			pt(n);
		} catch {}
		else try {
			n.setAttribute(e, "");
		} catch {}
	}, gt = function(e) {
		let t = v(e);
		if (t) for (let n = t.length - 1; n >= 0; --n) {
			let r = t[n], i = r && r.name;
			typeof i != "string" || Te[ot(i)] || mt(e, r, i);
		}
	}, _t = function(e) {
		let t = [e];
		for (; t.length > 0;) {
			let e = t.pop();
			S(e) === RT.element && gt(e);
			let n = h(e);
			if (n) for (let e = n.length - 1; e >= 0; --e) t.push(n[e]);
		}
	}, vt = function(e, t) {
		return Ie ? e === "patchsrc" ? !0 : e === "for" && t !== "label" && t !== "output" : !1;
	}, H = function(e) {
		if (!Ie) return;
		let t = [e];
		for (; t.length > 0;) {
			let e = t.pop(), n = S(e);
			if (n === RT.processingInstruction || n === RT.comment && rT(FT, e.data)) {
				try {
					p(e);
				} catch {}
				continue;
			}
			if (n === RT.element) {
				let t = e, n = ot(C(e));
				try {
					t.hasAttribute && t.hasAttribute("patchsrc") && t.removeAttribute("patchsrc"), t.hasAttribute && t.hasAttribute("for") && vt("for", n) && t.removeAttribute("for");
				} catch {}
			}
			let r = h(e);
			if (r) for (let e = r.length - 1; e >= 0; --e) t.push(r[e]);
		}
	}, yt = function(e) {
		let t = null, r = null;
		if (Ve) e = "<remove></remove>" + e;
		else {
			let t = qw(e, /^[\r\n\t ]+/);
			r = t && t[0];
		}
		I === "application/xhtml+xml" && Ze === P && (e = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + e + "</body></html>");
		let i = w ? ie(e) : e;
		if (Ze === P) try {
			t = new l().parseFromString(i, I);
		} catch {}
		if (!t || !t.documentElement) {
			t = ce.createDocument(Ze, "template", null);
			try {
				t.documentElement.innerHTML = Qe ? T : i;
			} catch {}
		}
		let a = t.body || t.documentElement;
		return e && r && a.insertBefore(n.createTextNode(r), a.childNodes[0] || null), Ze === P ? de.call(t, Le ? "html" : "body")[0] : Le ? t.documentElement : a;
	}, bt = function(e) {
		let t = x ? x(e) : e.ownerDocument;
		return le.call(t || e, e, c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION, null);
	}, xt = function(e) {
		return e = Jw(e, me, " "), e = Jw(e, he, " "), e = Jw(e, ge, " "), e;
	}, St = function(e) {
		e.normalize();
		let t = x ? x(e) : e.ownerDocument, n = le.call(t || e, e, c.SHOW_TEXT | c.SHOW_COMMENT | c.SHOW_CDATA_SECTION | c.SHOW_PROCESSING_INSTRUCTION, null), r = n.nextNode();
		for (; r;) r.data = xt(r.data), r = n.nextNode();
		let i = e.querySelectorAll?.call(e, "template");
		i && zw(i, (e) => {
			wt(e.content) && St(e.content);
		});
	}, Ct = function(e) {
		let t = b ? b(e) : null;
		return typeof t != "string" || ot(t) !== "form" ? !1 : typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || e.attributes !== v(e) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function" || e.nodeType !== y(e) || e.childNodes !== h(e);
	}, wt = function(e) {
		if (!y || typeof e != "object" || !e) return !1;
		try {
			return y(e) === RT.documentFragment;
		} catch {
			return !1;
		}
	}, U = function(e) {
		if (!y || typeof e != "object" || !e) return !1;
		try {
			return typeof y(e) == "number";
		} catch {
			return !1;
		}
	};
	function W(e, n, r) {
		e.length !== 0 && zw(e, (e) => {
			e.call(t, n, r, st);
		});
	}
	let Tt = function(e, t) {
		return !!(Ie && e.hasChildNodes() && !U(e.firstElementChild) && rT(PT, e.textContent) && rT(PT, e.innerHTML) || Ie && e.namespaceURI === P && BT[t] && (U(e.firstElementChild) || typeof e.textContent == "string" && rT(VT[t], e.textContent)) || e.nodeType === RT.processingInstruction || Ie && e.nodeType === RT.comment && rT(FT, e.data));
	}, Et = function(e, t) {
		return e instanceof RegExp ? rT(e, t) : e instanceof Function ? !!e(t, ...[...arguments].slice(2)) : !1;
	}, Dt = function(e, t, n) {
		if (!Oe[t] && Nt(t) && Et(De.tagNameCheck, t)) return !1;
		if (E && !O[t]) {
			let t = g(e), r = h(e);
			if (r && t) {
				let i = r.length;
				for (let a = i - 1; a >= 0; --a) {
					let i = e === n ? f(r[a], !0) : r[a];
					t.insertBefore(i, m(e));
				}
			}
		}
		return pt(e), !0;
	}, Ot = function(e, t, n, r) {
		return e.length === 0 ? t : t === n || t === r ? lT(t) : t;
	}, kt = function(e, t) {
		return e === t || g(e) !== null ? !1 : (Je && _t(e), !0);
	}, At = function(e, n) {
		if (W(pe.beforeSanitizeElements, e, null), kt(e, n)) return !0;
		if (Ct(e)) return pt(e), !0;
		let r = ot(C(e));
		if (Ce = Ot(pe.uponSanitizeElement, Ce, we, ze), W(pe.uponSanitizeElement, e, {
			tagName: r,
			allowedTags: Ce
		}), kt(e, n)) return !0;
		if (Tt(e, r)) return pt(e), !0;
		if (Oe[r] || !(Ae.tagCheck instanceof Function && Ae.tagCheck(r)) && !Ce[r]) {
			let t = Dt(e, r, n);
			return t === !1 && W(pe.afterSanitizeElements, e, null), t;
		}
		if (S(e) === RT.element && !B(e) || (r === "noscript" || r === "noembed" || r === "noframes") && rT(IT, e.innerHTML)) return pt(e), !0;
		if (Fe && e.nodeType === RT.text) {
			let n = xt(e.textContent);
			e.textContent !== n && (Hw(t.removed, { element: e.cloneNode() }), e.textContent = n);
		}
		return W(pe.afterSanitizeElements, e, null), !1;
	}, jt = function(e, t, r) {
		if (ke[t] || vt(t, e) || Ge && (t === "id" || t === "name") && (r in n || r in ct)) return !1;
		let i = Te[t] || Ae.attributeCheck instanceof Function && Ae.attributeCheck(t, e);
		return Me && rT(_e, t) || je && rT(ve, t) ? !0 : i ? Ye[t] || rT(Se, Jw(r, be, "")) || (t === "src" || t === "xlink:href" || t === "href") && e !== "script" && Yw(r, "data:") === 0 && A[e] || Ne && !rT(ye, Jw(r, be, "")) ? !0 : !r : Nt(e) && Et(De.tagNameCheck, e) && Et(De.attributeNameCheck, t, e) || t === "is" && De.allowCustomizedBuiltInElements && Et(De.tagNameCheck, r);
	}, Mt = sT({}, [
		"annotation-xml",
		"color-profile",
		"font-face",
		"font-face-format",
		"font-face-name",
		"font-face-src",
		"font-face-uri",
		"missing-glyph"
	]), Nt = function(e) {
		return !Mt[Gw(e)] && rT(xe, e);
	}, Pt = function(e, t, n, r) {
		if (w && typeof u == "object" && typeof u.getAttributeType == "function" && !n) switch (u.getAttributeType(e, t)) {
			case "TrustedHTML": return ie(r);
			case "TrustedScriptURL": return ae(r);
		}
		return r;
	}, Ft = function(e, n, r, i) {
		try {
			r ? e.setAttributeNS(r, n, i) : e.setAttribute(n, i), Ct(e) ? pt(e) : Vw(t.removed);
		} catch {
			V(n, e);
		}
	}, It = function(e) {
		W(pe.beforeSanitizeAttributes, e, null);
		let t = e.attributes;
		if (!t || Ct(e)) return;
		Te = Ot(pe.uponSanitizeAttribute, Te, Ee, Be);
		let n = {
			attrName: "",
			attrValue: "",
			keepAttr: !0,
			allowedAttributes: Te,
			forceKeepAttr: void 0
		}, r = t.length, i = ot(e.nodeName);
		for (; r--;) {
			let a = t[r], o = a.name, s = a.namespaceURI, c = a.value, l = ot(o), u = c, d = o === "value" ? u : Xw(u);
			if (n.attrName = l, n.attrValue = d, n.keepAttr = !0, n.forceKeepAttr = void 0, W(pe.uponSanitizeAttribute, e, n), d = n.attrValue, Ke && (l === "id" || l === "name") && Yw(d, qe) !== 0 && (V(o, e, a), d = qe + d), Ie && rT(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, d)) {
				V(o, e, a);
				continue;
			}
			if (l === "attributename" && qw(d, "href")) {
				V(o, e, a);
				continue;
			}
			if (!n.forceKeepAttr) {
				if (!n.keepAttr) {
					V(o, e, a);
					continue;
				}
				if (!Pe && rT(LT, d)) {
					V(o, e, a);
					continue;
				}
				if (Fe && (d = xt(d)), !jt(i, l, d)) {
					V(o, e, a);
					continue;
				}
				d = Pt(i, l, s, d), d !== u && Ft(e, o, s, d);
			}
		}
		W(pe.afterSanitizeAttributes, e, null);
	}, Lt = function(e) {
		let t = null, n = bt(e);
		for (W(pe.beforeSanitizeShadowDOM, e, null); t = n.nextNode();) if (W(pe.uponSanitizeShadowNode, t, null), At(t, e), It(t), wt(t.content) && Lt(t.content), S(t) === RT.element) {
			let e = _(t);
			wt(e) && (Rt(e), Lt(e));
		}
		W(pe.afterSanitizeShadowDOM, e, null);
	}, Rt = function(e) {
		let t = [{
			node: e,
			shadow: null
		}];
		for (; t.length > 0;) {
			let e = t.pop();
			if (e.shadow) {
				Lt(e.shadow);
				continue;
			}
			let n = e.node, r = S(n) === RT.element, i = h(n);
			if (i) for (let e = i.length - 1; e >= 0; --e) t.push({
				node: i[e],
				shadow: null
			});
			if (r) {
				let e = b ? b(n) : null;
				if (typeof e == "string" && ot(e) === "template") {
					let e = n.content;
					wt(e) && t.push({
						node: e,
						shadow: null
					});
				}
			}
			if (r) {
				let e = _(n);
				wt(e) && t.push({
					node: null,
					shadow: e
				}, {
					node: e,
					shadow: null
				});
			}
		}
	};
	return t.sanitize = function(e) {
		let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = null, a = null, o = null, s = null;
		if (Qe = !e, Qe && (e = "<!-->"), typeof e != "string" && !U(e) && (e = uT(e), typeof e != "string")) throw iT("dirty is not a string, aborting");
		if (!t.isSupported) return e;
		Re ? (Ce = ze, Te = Be) : ut(n), (pe.uponSanitizeElement.length > 0 || pe.uponSanitizeAttribute.length > 0) && (Ce = lT(Ce)), pe.uponSanitizeAttribute.length > 0 && (Te = lT(Te)), t.removed = [];
		let c = Je && typeof e != "string" && U(e);
		if (c) {
			H(e);
			let t = C(e);
			if (typeof t == "string") {
				let n = ot(t);
				if (!Ce[n] || Oe[n]) throw ht(e), iT("root node is forbidden and cannot be sanitized in-place");
			}
			if (Ct(e)) throw ht(e), iT("root node is clobbered and cannot be sanitized in-place");
			try {
				Rt(e);
			} catch (t) {
				throw ht(e), t;
			}
		} else if (U(e)) i = yt("<!---->"), a = i.ownerDocument.importNode(e, !0), a.nodeType === RT.element && a.nodeName === "BODY" || a.nodeName === "HTML" ? i = a : i.appendChild(a), Rt(a);
		else {
			if (!He && !Fe && !Le && e.indexOf("<") === -1) return w && We ? ie(e) : e;
			if (i = yt(e), !i) return He ? null : We ? T : "";
		}
		i && Ve && pt(i.firstChild);
		let l = c ? e : i;
		try {
			let e = bt(l);
			for (; o = e.nextNode();) At(o, l), It(o), wt(o.content) && Lt(o.content);
		} catch (n) {
			throw c && (ht(e), zw(t.removed, (e) => {
				e.element && _t(e.element);
			})), n;
		}
		if (c) return zw(t.removed, (e) => {
			e.element && _t(e.element);
		}), Fe && St(e), e;
		if (He) {
			if (Fe && St(i), Ue) for (s = ue.call(i.ownerDocument); i.firstChild;) s.appendChild(i.firstChild);
			else s = i;
			return (Te.shadowroot || Te.shadowrootmode) && (s = fe.call(r, s, !0)), s;
		}
		let u = Le ? i.outerHTML : i.innerHTML;
		return Le && Ce["!doctype"] && i.ownerDocument && i.ownerDocument.doctype && i.ownerDocument.doctype.name && rT(MT, i.ownerDocument.doctype.name) && (u = "<!DOCTYPE " + i.ownerDocument.doctype.name + ">\n" + u), Fe && (u = xt(u)), w && We ? ie(u) : u;
	}, t.setConfig = function() {
		ut(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}), Re = !0, ze = Ce, Be = Te;
	}, t.clearConfig = function() {
		st = null, Re = !1, ze = null, Be = null, w = ee, T = "";
	}, t.isValidAttribute = function(e, t, n) {
		return st || ut({}), jt(ot(e), ot(t), n);
	}, t.addHook = function(e, t) {
		typeof t == "function" && tT(pe, e) && Hw(pe[e], t);
	}, t.removeHook = function(e, t) {
		if (tT(pe, e)) {
			if (t !== void 0) {
				let n = Bw(pe[e], t);
				return n === -1 ? void 0 : Uw(pe[e], n, 1)[0];
			}
			return Vw(pe[e]);
		}
	}, t.removeHooks = function(e) {
		tT(pe, e) && (pe[e] = []);
	}, t.removeAllHooks = function() {
		pe = WT();
	}, t;
}
var JT = qT();
//#endregion
//#region src/components/general/resource-view/resource-syntax.js
function YT(e, t) {
	return !e || t <= 0 ? 1 : e.slice(0, t).split("\n").length;
}
function XT(e, t) {
	if (e) {
		if (typeof e.cursor == "function") {
			e.cursor().iterate(t);
			return;
		}
		typeof e.iterate == "function" && e.iterate({ enter: t });
	}
}
function ZT(e, t) {
	let n = [];
	return XT(t, (t) => t.type?.isError ? (n.push({
		message: "Syntax error",
		line: YT(e, t.from),
		from: t.from,
		to: t.to
	}), !1) : !0), n;
}
function QT(e, t) {
	let n = ZT(e, t)[0];
	return n ? {
		message: n.message,
		line: n.line
	} : null;
}
function $T(e) {
	try {
		return JSON.parse(e), null;
	} catch (t) {
		let n = String(t.message).match(/position\s+(\d+)/i), r = n ? Number(n[1]) : 0;
		return {
			message: t.message,
			line: YT(e, r)
		};
	}
}
function eE(e) {
	if (typeof DOMParser > "u") return null;
	let t = new DOMParser().parseFromString(e, "application/xml").querySelector("parsererror");
	return t ? {
		message: (t.textContent || "XML parse error").trim().split("\n")[0],
		line: 1
	} : null;
}
function tE(e, t, n = {}) {
	if (!t || !String(t).trim()) return null;
	if (e === "json") return $T(t);
	if (e === "xml") return eE(t);
	if (n.parser && typeof n.parser.parse == "function") try {
		return QT(t, n.parser.parse(t));
	} catch {
		return null;
	}
	return null;
}
function nE(e) {
	return hS.includes(e);
}
//#endregion
//#region src/components/general/resource-view/language-extensions.js
var rE = {
	javascript: () => import("./dist-BCsnVsiY.js").then((e) => e.t).then((e) => e.javascript({
		typescript: !0,
		jsx: !0
	})),
	json: () => Promise.resolve().then(() => sl).then((e) => e.json()),
	xml: () => import("./dist-C55S-XIL.js").then((e) => e.xml()),
	python: () => import("./dist-3fVA3we_.js").then((e) => e.python()),
	vue: () => import("./dist-gCPTGVbY.js").then((e) => e.vue()),
	html: () => import("./dist-C3YKa-Oh.js").then((e) => e.html()),
	css: () => import("./dist-Txixp1Jq.js").then((e) => e.i).then((e) => e.css()),
	sass: () => import("./dist-Dbp2LYme.js").then((e) => e.sass()),
	yaml: () => import("./dist-RRywBQPv.js").then((e) => e.yaml()),
	markdown: () => import("./dist-fM6xA6BL.js").then((e) => e.markdown()),
	sql: () => import("./dist-BtrFk-YZ.js").then((e) => e.sql()),
	shell: () => Promise.all([import("./dist-CkS8TOF-.js").then((e) => e.p), import("./shell-BbOqCke1.js")]).then(([e, t]) => e.StreamLanguage.define(t.shell)),
	dockerfile: () => Promise.all([import("./dist-CkS8TOF-.js").then((e) => e.p), import("./dockerfile-CWhfkFZy.js")]).then(([e, t]) => e.StreamLanguage.define(t.dockerFile)),
	ini: () => Promise.all([import("./dist-CkS8TOF-.js").then((e) => e.p), import("./properties-DhPqK3Kn.js")]).then(([e, t]) => e.StreamLanguage.define(t.properties)),
	toml: () => Promise.all([import("./dist-CkS8TOF-.js").then((e) => e.p), import("./toml-BYZooOEM.js")]).then(([e, t]) => e.StreamLanguage.define(t.toml))
}, iE = /* @__PURE__ */ new Map();
async function aE(e) {
	if (!e || e === "text") return [];
	if (iE.has(e)) return iE.get(e);
	let t = rE[e];
	if (!t) return iE.set(e, Promise.resolve([])), iE.get(e);
	let n = t().then((e) => e ? [e] : []).catch(() => []);
	return iE.set(e, n), n;
}
function oE(e) {
	if (!e) return null;
	if (Array.isArray(e)) {
		for (let t of e) {
			let e = oE(t);
			if (e) return e;
		}
		return null;
	}
	let t = e.language?.parser || e.parser;
	return t && typeof t.parse == "function" ? t : null;
}
//#endregion
//#region src/components/general/resource-view/resource-content-viewer.vue
var sE = { class: "resource-content-viewer d-flex flex-column fill-height flex-grow-1" }, cE = {
	key: 0,
	class: "resource-content-viewer__header d-flex align-center pa-3 border-b bg-surface flex-shrink-0"
}, lE = { class: "text-body-medium font-weight-medium text-truncate" }, uE = {
	key: 1,
	class: "d-flex justify-center align-center flex-grow-1"
}, dE = {
	key: 2,
	class: "d-flex justify-center align-center flex-grow-1"
}, fE = { class: "text-center text-medium-emphasis" }, pE = { class: "text-body-large" }, mE = {
	key: 3,
	class: "d-flex justify-center align-center flex-grow-1 pa-4 overflow-auto"
}, hE = ["src", "alt"], gE = {
	key: 4,
	class: "resource-content-viewer__pdf flex-grow-1 overflow-hidden"
}, _E = ["src"], vE = {
	key: 5,
	class: "resource-content-viewer__bpmn flex-grow-1 overflow-hidden position-relative"
}, yE = {
	key: 0,
	class: "d-flex justify-center align-center fill-height"
}, bE = { class: "text-center text-medium-emphasis" }, xE = { class: "text-body-large" }, SE = {
	key: 6,
	class: "resource-content-viewer__markdown flex-grow-1 overflow-y-auto pa-6"
}, CE = ["innerHTML"], wE = {
	key: 7,
	class: "d-flex justify-center align-center flex-grow-1"
}, TE = { class: "text-center text-medium-emphasis" }, EE = { class: "text-body-large" }, DE = { class: "resource-content-viewer__editor flex-grow-1 overflow-hidden" }, OE = {
	key: 0,
	class: "resource-content-viewer__footer d-flex align-center justify-space-between pa-3 border-t bg-surface flex-shrink-0",
	"data-testid": "resource-editor-footer"
}, kE = { class: "d-flex align-center ga-2 flex-shrink-0" }, AE = /*#__PURE__*/ Y({
	__name: "resource-content-viewer",
	props: {
		content: {
			type: String,
			default: ""
		},
		contentUrl: {
			type: String,
			default: ""
		},
		filePath: {
			type: String,
			default: ""
		},
		loading: {
			type: Boolean,
			default: !1
		},
		emptyText: {
			type: String,
			default: void 0
		},
		editable: {
			type: Boolean,
			default: !1
		},
		saving: {
			type: Boolean,
			default: !1
		},
		isNew: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"save",
		"dirty-change",
		"syntax-error"
	],
	setup(t, { emit: n }) {
		let i = t, a = n, o = D(() => i.emptyText || K("admin_resources_select_file")), c = D(() => vS(i.filePath)), l = D(() => yS(c.value)), u = D(() => xS(c.value)), d = D(() => c.value === "pdf"), f = D(() => c.value === "bpmn"), p = D(() => ["md", "markdown"].includes(c.value)), m = D(() => c.value === "svg"), h = D(() => SS(c.value)), g = R("preview"), _ = D(() => i.editable && (p.value || m.value)), v = D(() => p.value ? K("admin_resources_markdown_preview") : K("admin_resources_image_preview")), y = D(() => p.value ? K("admin_resources_markdown_source") : K("admin_resources_source")), b = D(() => u.value && (!i.editable || !m.value || g.value === "preview")), x = D(() => p.value && (!i.editable || g.value === "preview")), S = D(() => i.editable && !b.value && !x.value && !d.value && !f.value && !h.value), C = D(() => S.value), w = D(() => {
			if (!p.value || !i.content) return "";
			let e = xw.parse(i.content, {
				breaks: !0,
				gfm: !0
			});
			return JT.sanitize(e);
		}), T = R(null), ee = R(!1), te = null;
		function ne() {
			te &&= (te.destroy(), null);
		}
		async function re(e) {
			if (e && (await it(), T.value)) {
				ee.value = !1, ne(), te = new ev({ container: T.value });
				try {
					await te.importXML(e), te.get("canvas").zoom("fit-viewport", "auto");
				} catch (e) {
					console.error("Failed to render BPMN diagram:", e), ee.value = !0;
				}
			}
		}
		U([() => i.content, () => f.value], ([e, t]) => {
			t && e ? re(e) : ne();
		}), st(() => {
			ne();
		});
		let ie = {
			png: "image/png",
			jpg: "image/jpeg",
			jpeg: "image/jpeg",
			gif: "image/gif",
			svg: "image/svg+xml",
			webp: "image/webp",
			ico: "image/x-icon",
			bmp: "image/bmp",
			avif: "image/avif",
			tif: "image/tiff",
			tiff: "image/tiff",
			apng: "image/apng"
		}, ae = D(() => {
			if (!u.value) return "";
			if (i.contentUrl) return i.contentUrl;
			if (!i.content) return "";
			let e = c.value;
			return `data:${ie[e] || `image/${e}`};base64,${i.content}`;
		}), oe = R(""), se = R([]), ce = R(null), le = R(null), ue = D(() => oe.value !== (i.content || "")), de = D(() => !i.isNew || !!String(oe.value).trim()), fe = D(() => ue.value && !le.value && !i.saving && de.value);
		function pe(e) {
			let t = le.value;
			!t && !e || t && e && t.message === e.message && t.line === e.line || (le.value = e, a("syntax-error", e));
		}
		function me() {
			if (!S.value) {
				pe(null);
				return;
			}
			pe(tE(l.value, oe.value, { parser: ce.value }));
		}
		U(() => i.filePath, () => {
			g.value = "preview", oe.value = i.content || "", pe(null), a("dirty-change", !1);
		}), U(() => i.content, (e) => {
			oe.value = e || "";
		}, { immediate: !0 }), U(ue, (e) => {
			a("dirty-change", e);
		}), U(oe, () => {
			me();
		}), U(() => l.value, async (e) => {
			ce.value = null, se.value = [];
			let t = await aE(e);
			se.value = t, ce.value = oE(t[0]), me();
		}, { immediate: !0 }), U(S, () => {
			me();
		});
		function he() {
			fe.value && a("save", oe.value);
		}
		function _e() {
			oe.value = i.content || "";
		}
		let ve = r.highest(ge.of([{
			key: "Mod-s",
			preventDefault: !0,
			run: () => (he(), !0)
		}]));
		function ye(t) {
			return ZT(t.state.doc.toString(), e(t.state)).map((e) => ({
				from: e.from,
				to: e.to > e.from ? e.to : Math.min(e.from + 1, t.state.doc.length),
				severity: "error",
				message: e.message
			}));
		}
		let be = D(() => {
			let e = [s.lineWrapping, ...se.value];
			return S.value && (e.push(ve), nE(l.value) && e.push(jc(ye, { delay: 0 })), l.value === "json" && e.push(jc(cl(), { delay: 0 }))), e;
		}), xe = D(() => ES(c.value)), Se = D(() => le.value ? `${K("admin_resources_syntax_error")} (${le.value.line})` : i.isNew || ue.value ? K("admin_resources_unsaved_changes") : l.value !== "text" && !nE(l.value) ? K("admin_resources_no_syntax_check") : K("admin_resources_saved"));
		return (e, n) => (L(), A("div", sE, [t.filePath ? (L(), A("div", cE, [
			N(J, {
				icon: xe.value,
				size: "18",
				class: "mr-2"
			}, null, 8, ["icon"]),
			j("span", lE, V(t.filePath), 1),
			N(mn),
			_.value ? (L(), O(Br, {
				key: 0,
				modelValue: g.value,
				"onUpdate:modelValue": n[0] ||= (e) => g.value = e,
				density: "compact",
				mandatory: "",
				variant: "outlined",
				divided: "",
				class: "flex-shrink-0"
			}, {
				default: W(() => [N(q, {
					value: "preview",
					size: "x-small",
					"aria-label": v.value
				}, {
					default: W(() => [M(V(v.value), 1)]),
					_: 1
				}, 8, ["aria-label"]), N(q, {
					value: "source",
					size: "x-small",
					"aria-label": y.value
				}, {
					default: W(() => [M(V(y.value), 1)]),
					_: 1
				}, 8, ["aria-label"])]),
				_: 1
			}, 8, ["modelValue"])) : k("", !0)
		])) : k("", !0), t.loading ? (L(), A("div", uE, [N(wr, { indeterminate: "" })])) : t.filePath ? b.value ? (L(), A("div", mE, [j("img", {
			src: ae.value,
			alt: t.filePath,
			style: {
				"max-width": "100%",
				"max-height": "100%",
				"object-fit": "contain"
			}
		}, null, 8, hE)])) : d.value ? (L(), A("div", gE, [j("iframe", {
			src: t.contentUrl,
			class: "fill-height",
			style: {
				width: "100%",
				height: "100%",
				border: "none"
			},
			title: "PDF preview"
		}, null, 8, _E)])) : f.value ? (L(), A("div", vE, [ee.value ? (L(), A("div", yE, [j("div", bE, [N(J, {
			icon: "mdi:mdi-alert-circle-outline",
			size: "64",
			class: "mb-4 d-block mx-auto"
		}), j("div", xE, V(H(K)("admin_resources_bpmn_render_error")), 1)])])) : (L(), A("div", {
			key: 1,
			ref_key: "bpmnContainer",
			ref: T,
			class: "fill-height"
		}, null, 512))])) : x.value ? (L(), A("div", SE, [j("div", {
			class: "resource-content-viewer__markdown-body",
			innerHTML: w.value
		}, null, 8, CE)])) : h.value ? (L(), A("div", wE, [j("div", TE, [N(J, {
			icon: "mdi:mdi-file-alert-outline",
			size: "64",
			class: "mb-4 d-block mx-auto"
		}), j("div", EE, V(H(K)("admin_resources_binary_preview")), 1)])])) : (L(), A(E, { key: 8 }, [j("div", DE, [N(H(il), {
			modelValue: oe.value,
			"onUpdate:modelValue": n[1] ||= (e) => oe.value = e,
			extensions: be.value,
			disabled: !S.value,
			"indent-with-tab": !0,
			"tab-size": 2,
			style: { height: "100%" }
		}, null, 8, [
			"modelValue",
			"extensions",
			"disabled"
		])]), C.value ? (L(), A("div", OE, [j("span", {
			class: I(["text-body-small text-truncate", le.value ? "text-error" : void 0]),
			"data-testid": "resource-editor-status"
		}, V(Se.value), 3), j("div", kE, [N(q, {
			size: "small",
			variant: "text",
			disabled: !ue.value || t.saving,
			"data-testid": "resource-editor-discard",
			onClick: _e
		}, {
			default: W(() => [M(V(H(K)("admin_resources_discard")), 1)]),
			_: 1
		}, 8, ["disabled"]), N(q, {
			size: "small",
			color: "primary",
			disabled: !fe.value,
			loading: t.saving,
			"aria-label": H(K)("admin_resources_save"),
			"data-testid": "resource-editor-save",
			onClick: he
		}, {
			default: W(() => [M(V(H(K)("admin_resources_save")), 1)]),
			_: 1
		}, 8, [
			"disabled",
			"loading",
			"aria-label"
		])])])) : k("", !0)], 64)) : (L(), A("div", dE, [j("div", fE, [N(J, {
			icon: "mdi:mdi-file-document-outline",
			size: "64",
			class: "mb-4 d-block mx-auto"
		}), j("div", pE, V(o.value), 1)])]))]));
	}
}, [["__scopeId", "data-v-d3277482"]]), jE = { class: "h-resource-view d-flex overflow-hidden" }, ME = {
	key: 0,
	class: "h-resource-view__sidebar-top flex-shrink-0"
}, NE = {
	key: 2,
	class: "h-resource-view__sidebar-actions flex-shrink-0"
}, PE = /*#__PURE__*/ Y({
	__name: "resource-view",
	props: {
		items: {
			type: Array,
			default: () => []
		},
		treeLoading: {
			type: Boolean,
			default: !1
		},
		selectedPath: {
			type: String,
			default: ""
		},
		filePath: {
			type: String,
			default: void 0
		},
		expandedPaths: {
			type: Array,
			default: () => []
		},
		content: {
			type: String,
			default: ""
		},
		contentUrl: {
			type: String,
			default: ""
		},
		contentLoading: {
			type: Boolean,
			default: !1
		},
		sidebarWidth: {
			type: [Number, String],
			default: 320
		},
		sidebarBackground: {
			type: String,
			default: void 0
		},
		contentBackground: {
			type: String,
			default: void 0
		},
		emptyTreeText: {
			type: String,
			default: void 0
		},
		emptyContentText: {
			type: String,
			default: void 0
		},
		editable: {
			type: Boolean,
			default: !1
		},
		saving: {
			type: Boolean,
			default: !1
		},
		isNew: {
			type: Boolean,
			default: !1
		},
		createDraft: {
			type: Object,
			default: null
		}
	},
	emits: [
		"select",
		"action",
		"save",
		"dirty-change",
		"syntax-error",
		"create-confirm",
		"cancel-create"
	],
	setup(e, { emit: t }) {
		let n = G(e, "HResourceView"), r = t, i = D(() => n.filePath ?? n.selectedPath), a = !1;
		function o(e, t) {
			if (t === void 0) {
				r("select", e);
				return;
			}
			r("select", e, t);
		}
		function s(e) {
			a = !0, window.setTimeout(() => {
				a = !1;
			}, 0), r("create-confirm", e);
		}
		function c(e) {
			if (a) return;
			let t = e.target;
			t instanceof Element && (t.closest("[role=\"treeitem\"], .resource-tree-draft, .v-overlay") || r("select", "", { open: !1 }));
		}
		function l(e) {
			if (a) return;
			let t = e.target;
			t instanceof Element && (t.closest("a, button, .v-btn") || r("select", "", { open: !1 }));
		}
		let u = D(() => typeof n.sidebarWidth == "number" ? `${n.sidebarWidth}px` : n.sidebarWidth), d = D(() => n.sidebarBackground || "rgb(var(--v-theme-surface))"), f = D(() => n.contentBackground || void 0);
		return (t, n) => (L(), A("div", jE, [j("div", {
			class: "h-resource-view__sidebar d-flex flex-column flex-shrink-0 border-e",
			style: ot({
				width: u.value,
				background: d.value
			})
		}, [
			t.$slots["sidebar-top"] ? (L(), A("div", ME, [B(t.$slots, "sidebar-top", {}, void 0, !0)])) : k("", !0),
			j("div", {
				class: "h-resource-view__tree flex-grow-1 overflow-y-auto",
				"data-testid": "resource-tree-area",
				role: "presentation",
				onClick: c
			}, [N(US, {
				items: e.items,
				loading: e.treeLoading,
				"selected-path": e.selectedPath,
				"expanded-paths": e.expandedPaths,
				"empty-text": e.emptyTreeText,
				"create-draft": e.createDraft,
				onSelect: o,
				onAction: n[0] ||= (e) => t.$emit("action", e),
				onCreateConfirm: s,
				onCancelCreate: n[1] ||= (e) => t.$emit("cancel-create")
			}, null, 8, [
				"items",
				"loading",
				"selected-path",
				"expanded-paths",
				"empty-text",
				"create-draft"
			])]),
			t.$slots["sidebar-info"] ? (L(), A("div", {
				key: 1,
				class: "h-resource-view__sidebar-info flex-shrink-0",
				"data-testid": "resource-sidebar-info",
				role: "presentation",
				onClick: l
			}, [N(er), B(t.$slots, "sidebar-info", {}, void 0, !0)])) : k("", !0),
			t.$slots["sidebar-actions"] ? (L(), A("div", NE, [N(er), B(t.$slots, "sidebar-actions", {}, void 0, !0)])) : k("", !0)
		], 4), j("div", {
			class: "h-resource-view__content flex-grow-1 d-flex flex-column",
			style: ot({
				minWidth: 0,
				background: f.value
			})
		}, [B(t.$slots, "content-header", {}, void 0, !0), N(AE, {
			content: e.content,
			"content-url": e.contentUrl,
			"file-path": i.value,
			loading: e.contentLoading,
			"empty-text": e.emptyContentText,
			editable: e.editable,
			saving: e.saving,
			"is-new": e.isNew,
			onSave: n[2] ||= (e) => t.$emit("save", e),
			onDirtyChange: n[3] ||= (e) => t.$emit("dirty-change", e),
			onSyntaxError: n[4] ||= (e) => t.$emit("syntax-error", e)
		}, null, 8, [
			"content",
			"content-url",
			"file-path",
			"loading",
			"empty-text",
			"editable",
			"saving",
			"is-new"
		])], 4)]));
	}
}, [["__scopeId", "data-v-597046aa"]]), FE = { class: "flex-1-1" }, IE = { class: "flex-1-1" }, LE = {
	key: 0,
	class: "text-body-2 text-error d-flex align-center ga-1"
}, RE = {
	key: 1,
	class: "text-headline-medium font-weight-bold"
}, zE = { class: "text-body-2 text-medium-emphasis" }, BE = { class: "mt-1 d-flex align-center flex-wrap ga-1" }, VE = {
	__name: "metric-card",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		value: {
			type: [String, Number],
			default: null
		},
		loading: {
			type: Boolean,
			default: !1
		},
		error: {
			type: [String, Error],
			default: null
		},
		trend: {
			type: Object,
			default: null
		}
	},
	setup(e) {
		let t = G(e, "HMetricCard"), n = D(() => {
			if (t.trend) {
				if (t.trend.direction === "up") return "success";
				if (t.trend.direction === "down") return "error";
			}
		}), r = D(() => t.trend ? t.trend.percent === null || t.trend.percent === void 0 ? "—" : t.trend.percent < 0 ? "↓" : t.trend.percent > 0 ? "↑" : "—" : "");
		return (t, i) => (L(), O(rn, {
			class: I(["h-metric-card h-100", { "h-metric-card--clickable": !!e.widget.link }]),
			to: e.widget.link || void 0,
			ripple: !!e.widget.link,
			rounded: "lg",
			elevation: "1"
		}, {
			default: W(() => [e.loading && e.value === null ? (L(), O(cn, {
				key: 0,
				class: "h-metric-card__body"
			}, {
				default: W(() => [N(Vr, {
					type: "avatar",
					class: "flex-0-0 mr-3",
					width: "56",
					height: "56"
				}), j("div", FE, [
					N(Vr, {
						type: "text",
						width: "80",
						height: "28",
						class: "mb-1"
					}),
					N(Vr, {
						type: "text",
						width: "120",
						height: "16"
					}),
					N(Vr, {
						type: "chip",
						width: "60",
						height: "22",
						class: "mt-1"
					})
				])]),
				_: 1
			})) : (L(), O(cn, {
				key: 1,
				class: "h-metric-card__body"
			}, {
				default: W(() => [N(tr, {
					color: e.widget.color || "grey-lighten-4",
					size: "56",
					class: "mr-3 flex-0-0"
				}, {
					default: W(() => [N(J, {
						icon: e.widget.icon || "mdi:mdi-chart-line",
						size: "x-large"
					}, null, 8, ["icon"])]),
					_: 1
				}, 8, ["color"]), j("div", IE, [
					e.error ? (L(), A("div", LE, [N(J, {
						icon: "mdi:mdi-alert-circle-outline",
						size: "small"
					}), M(" " + V(H(K)("error")), 1)])) : (L(), A("div", RE, V(e.value ?? "—"), 1)),
					j("div", zE, V(e.widget.name), 1),
					j("div", BE, [e.loading && e.trend === null && e.widget.trend ? (L(), O(Vr, {
						key: 0,
						type: "chip",
						width: "60",
						height: "22"
					})) : e.trend ? (L(), O(qn, {
						key: 1,
						color: n.value,
						size: "x-small",
						variant: "tonal",
						class: "font-weight-semibold"
					}, {
						default: W(() => [M(V(r.value) + " " + V(e.trend.label), 1)]),
						_: 1
					}, 8, ["color"])) : k("", !0), e.widget.chip ? (L(), O(qn, {
						key: 2,
						color: e.widget.chip.color,
						size: "x-small",
						variant: "tonal",
						class: "font-weight-semibold"
					}, {
						default: W(() => [M(V(e.widget.chip.label), 1)]),
						_: 1
					}, 8, ["color"])) : k("", !0)])
				])]),
				_: 1
			}))]),
			_: 1
		}, 8, [
			"class",
			"to",
			"ripple"
		]));
	}
}, HE = ["href", "onClick"], UE = {
	key: 2,
	class: "h-metric-breakdown-card__label text-body-2 text-medium-emphasis"
}, WE = { class: "h-metric-breakdown-card__bar-bg mx-2 flex-1-1" }, GE = { class: "h-metric-breakdown-card__count text-body-2 font-weight-bold" }, KE = {
	key: 0,
	class: "h-metric-breakdown-card__toggle d-flex justify-center mt-1"
}, qE = {
	__name: "metric-breakdown-card",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		itemsData: {
			type: Object,
			default: () => ({})
		},
		loading: {
			type: Boolean,
			default: !1
		},
		maxVisibleRows: {
			type: Number,
			default: 10
		}
	},
	setup(e) {
		let t = G(e, "HMetricBreakdownCard"), n = kn(), r = R(!1), i = D(() => t.widget.items ?? []), a = D(() => i.value.length > t.maxVisibleRows), o = D(() => !a.value || r.value ? i.value : i.value.slice(0, t.maxVisibleRows)), s = D(() => `Visa ${i.value.length - t.maxVisibleRows} till`), c = D(() => "Visa färre"), l = D(() => t.loading && i.value.every((e) => !t.itemsData[e._id]));
		function u(e) {
			return t.itemsData[e._id] ?? null;
		}
		function d(e) {
			if (!e.url) return null;
			let t = e.params?.query;
			return t ? `${e.url}?query=${encodeURIComponent(t)}` : e.url;
		}
		function f(e) {
			let t = d(e);
			t && n.push(t);
		}
		let p = D(() => {
			let e = 0;
			for (let t of i.value) {
				let n = u(t)?.rawValue;
				typeof n == "number" && n > e && (e = n);
			}
			return e;
		});
		function m(e) {
			if (p.value === 0) return 0;
			let t = u(e)?.rawValue;
			return typeof t == "number" ? Math.round(t / p.value * 100) : 0;
		}
		return (t, n) => (L(), O(rn, {
			class: "h-metric-breakdown-card h-100",
			rounded: "lg",
			elevation: "1"
		}, {
			default: W(() => [N(ln, { class: "text-body-2 font-weight-semibold d-flex align-center ga-2 pb-2" }, {
				default: W(() => [e.widget.icon ? (L(), O(J, {
					key: 0,
					icon: e.widget.icon,
					size: "small",
					color: "primary"
				}, null, 8, ["icon"])) : k("", !0), M(" " + V(e.widget.name), 1)]),
				_: 1
			}), N(cn, { class: "pt-0 px-4 pb-4" }, {
				default: W(() => [l.value ? (L(), A(E, { key: 0 }, z(4, (e) => j("div", {
					key: e,
					class: "h-metric-breakdown-card__row mb-3"
				}, [
					N(Vr, {
						type: "text",
						width: "120",
						height: "14"
					}),
					N(Vr, {
						type: "text",
						class: "flex-1-1 mx-2",
						height: "8"
					}),
					N(Vr, {
						type: "text",
						width: "40",
						height: "14"
					})
				])), 64)) : (L(), A(E, { key: 1 }, [(L(!0), A(E, null, z(o.value, (e) => (L(), A("div", {
					key: e._id,
					class: "h-metric-breakdown-card__row mb-2"
				}, [
					e.icon ? (L(), O(J, {
						key: 0,
						icon: e.icon,
						size: "x-small",
						color: e.color || "primary",
						class: "flex-0-0 mr-1"
					}, null, 8, ["icon", "color"])) : k("", !0),
					d(e) ? (L(), A("a", {
						key: 1,
						href: d(e),
						class: "h-metric-breakdown-card__label h-metric-breakdown-card__label--link text-body-2",
						onClick: Dt((t) => f(e), ["prevent"])
					}, V(e.name), 9, HE)) : (L(), A("span", UE, V(e.name), 1)),
					j("div", WE, [j("div", {
						class: "h-metric-breakdown-card__bar-fill",
						style: ot({
							width: m(e) + "%",
							backgroundColor: e.color || "var(--v-theme-primary)"
						})
					}, null, 4)]),
					j("span", GE, [u(e)?.loading ? (L(), O(wr, {
						key: 0,
						indeterminate: "",
						size: "12",
						width: "2"
					})) : u(e)?.error ? (L(), O(J, {
						key: 1,
						icon: "mdi:mdi-alert-circle-outline",
						size: "x-small",
						color: "error"
					})) : (L(), A(E, { key: 2 }, [M(V(u(e)?.value ?? "—"), 1)], 64))])
				]))), 128)), a.value ? (L(), A("div", KE, [N(q, {
					variant: "text",
					size: "small",
					density: "compact",
					"append-icon": r.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down",
					onClick: n[0] ||= (e) => r.value = !r.value
				}, {
					default: W(() => [M(V(r.value ? c.value : s.value), 1)]),
					_: 1
				}, 8, ["append-icon"])])) : k("", !0)], 64))]),
				_: 1
			})]),
			_: 1
		}));
	}
}, JE = {
	key: 0,
	class: "h-metric-histogram-card__chart"
}, YE = {
	key: 1,
	class: "text-body-2 text-medium-emphasis text-center py-4"
}, XE = ["aria-label"], ZE = ["aria-label"], QE = { class: "h-metric-histogram-card__bar-label" }, $E = {
	key: 0,
	class: "h-metric-histogram-card__legend"
}, eD = { class: "h-metric-histogram-card__legend-item" }, tD = { class: "h-metric-histogram-card__legend-item" }, nD = {
	__name: "metric-histogram-card",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		buckets: {
			type: Array,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: !1
		},
		error: {
			type: [String, Error],
			default: null
		}
	},
	setup(e) {
		let t = Array.from({ length: 12 }, () => 20 + Math.floor(Math.random() * 60)), n = G(e, "HMetricHistogramCard"), r = D(() => n.widget.interval === "week" ? "d MMM yyyy" : n.widget.interval === "month" ? "MMM yyyy" : "d MMM yyyy"), i = D(() => n.widget.dateFormat || r.value), a = D(() => n.widget.weekends === !0), o = D(() => n.widget.stretchBars === !0), s = D(() => n.widget.weekdayColor || n.widget.color || "var(--v-theme-primary)"), c = D(() => n.widget.weekendColor || s.value), l = D(() => n.widget.weekendColor ? 1 : .35);
		function u(e) {
			if (e == null || e === "") return null;
			let t = String(e);
			if (/^\d{10,13}$/.test(t)) {
				let e = Number(t), n = t.length <= 10 ? e * 1e3 : e, r = new Date(n);
				return jr(r) ? r : null;
			}
			let n = Nr(t);
			return jr(n) ? n : null;
		}
		let d = D(() => n.buckets.map((e) => {
			let t = u(e.key), n = a.value && t ? Mr(t) : !1, r = t ? kr(t, i.value) : e.label;
			return {
				...e,
				date: t,
				isWeekend: n,
				formattedLabel: r
			};
		})), f = D(() => {
			let e = d.value;
			if (n.widget.interval !== "day" || !e.length) return e;
			let t = e.filter((e) => e.date);
			if (!t.length) return e;
			let r = new Map(t.map((e) => [Pr(e.date).getTime(), e])), o = Pr(/* @__PURE__ */ new Date()), s = (() => {
				if (n.widget._dateFrom) try {
					return Pr(Nr(n.widget._dateFrom));
				} catch {}
				return Pr(t[0].date);
			})(), c = (() => {
				if (n.widget._dateTo) try {
					let e = Pr(Nr(n.widget._dateTo));
					return e <= o ? e : o;
				} catch {
					return o;
				}
				return o;
			})(), l = [];
			for (let e = new Date(s); e <= c; e = Or(e, 1)) {
				let t = e.getTime();
				if (r.has(t)) l.push(r.get(t));
				else {
					let n = kr(e, i.value);
					l.push({
						key: t,
						value: 0,
						label: n,
						date: new Date(e),
						isWeekend: a.value && Mr(e),
						formattedLabel: n
					});
				}
			}
			return l;
		}), p = D(() => a.value && f.value.some((e) => e.isWeekend)), m = D(() => f.value.length ? Math.max(...f.value.map((e) => e.value)) : 1);
		function h(e) {
			return m.value === 0 ? 0 : Math.max(2, Math.round(e.value / m.value * 100));
		}
		function g(e) {
			return {
				height: h(e) + "%",
				backgroundColor: e.isWeekend ? c.value : s.value,
				opacity: e.isWeekend ? l.value : 1
			};
		}
		return (n, r) => (L(), O(rn, {
			class: "h-metric-histogram-card h-100",
			rounded: "lg",
			elevation: "1"
		}, {
			default: W(() => [N(ln, { class: "text-body-2 font-weight-semibold d-flex align-center ga-2 pb-2" }, {
				default: W(() => [e.widget.icon ? (L(), O(J, {
					key: 0,
					icon: e.widget.icon,
					size: "small",
					color: "primary"
				}, null, 8, ["icon"])) : k("", !0), M(" " + V(e.widget.name), 1)]),
				_: 1
			}), N(cn, { class: "pt-0 pb-4" }, {
				default: W(() => [e.loading ? (L(), A("div", JE, [(L(!0), A(E, null, z(H(t), (e, t) => (L(), A("div", {
					key: t,
					class: "h-metric-histogram-card__bar-wrap"
				}, [N(Vr, {
					type: "image",
					height: e,
					class: "h-metric-histogram-card__bar-skeleton"
				}, null, 8, ["height"])]))), 128))])) : d.value.length ? (L(), A(E, { key: 2 }, [j("div", {
					class: I(["h-metric-histogram-card__chart", { "h-metric-histogram-card__chart--fit": o.value }]),
					role: "img",
					"aria-label": e.widget.name
				}, [(L(!0), A(E, null, z(f.value, (e) => (L(), A("div", {
					key: e.key,
					class: "h-metric-histogram-card__bar-wrap"
				}, [N(un, {
					text: `${e.formattedLabel}: ${e.value}`,
					location: "top"
				}, {
					activator: W(({ props: t }) => [j("div", F({ ref_for: !0 }, t, {
						class: "h-metric-histogram-card__bar",
						style: g(e),
						"aria-label": `${e.formattedLabel}: ${e.value}`
					}), null, 16, ZE)]),
					_: 2
				}, 1032, ["text"]), j("span", QE, V(e.formattedLabel), 1)]))), 128))], 10, XE), p.value ? (L(), A("div", $E, [j("span", eD, [j("span", {
					class: "h-metric-histogram-card__legend-dot",
					style: ot({ backgroundColor: s.value })
				}, null, 4), M(" " + V(H(K)("histogram_weekday")), 1)]), j("span", tD, [j("span", {
					class: "h-metric-histogram-card__legend-dot",
					style: ot({
						backgroundColor: c.value,
						opacity: l.value
					})
				}, null, 4), M(" " + V(H(K)("histogram_weekend")), 1)])])) : k("", !0)], 64)) : (L(), A("div", YE, [N(J, {
					icon: "mdi:mdi-chart-bar-stacked",
					class: "mb-1"
				}), j("div", null, V(H(K)("no_data")), 1)]))]),
				_: 1
			})]),
			_: 1
		}));
	}
}, rD = { class: "d-flex align-center justify-space-between flex-wrap ga-3 w-100" }, iD = { class: "h-metric-alert-banner__title font-weight-medium" }, aD = { class: "d-flex align-center ga-3 flex-shrink-0" }, oD = {
	key: 0,
	class: "d-flex align-center"
}, sD = {
	key: 1,
	class: "d-flex align-center ga-1 text-body-2"
}, cD = {
	key: 2,
	class: "text-h6 font-weight-bold"
}, lD = ["href"], uD = /*#__PURE__*/ Y({
	__name: "metric-alert-banner",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		value: {
			type: [String, Number],
			default: null
		},
		loading: {
			type: Boolean,
			default: !1
		},
		error: {
			type: [String, Error],
			default: null
		}
	},
	setup(e) {
		let t = G(e, "HMetricAlertBanner"), n = D(() => t.widget.color || "error");
		function r(e) {
			if (e == null || e === "") return null;
			let t = typeof e == "string" ? parseFloat(String(e).replace(/[^0-9.]/g, "")) : Number(e);
			return Number.isFinite(t) ? t : null;
		}
		let i = D(() => {
			let e = r(t.value);
			return e === null ? !1 : e >= (t.widget.bannerThreshold ?? 1);
		});
		return (t, r) => i.value ? (L(), O(fr, {
			key: 0,
			class: "h-metric-alert-banner",
			color: n.value,
			icon: e.widget.icon || "mdi:mdi-alert-circle",
			variant: "outlined",
			rounded: "lg",
			href: e.widget.link || void 0,
			clickable: !!e.widget.link,
			density: "compact"
		}, {
			text: W(() => [j("div", rD, [j("span", iD, V(e.widget.name), 1), j("div", aD, [e.loading ? (L(), A("span", oD, [N(wr, {
				indeterminate: "",
				size: "16",
				width: "2",
				class: "mr-1"
			})])) : e.error ? (L(), A("span", sD, [N(J, {
				icon: "mdi:mdi-alert",
				size: "small"
			}), M(" " + V(typeof e.error == "string" ? e.error : e.error.message), 1)])) : e.value === null ? k("", !0) : (L(), A("span", cD, V(e.value), 1)), e.widget.link ? (L(), A("a", {
				key: 3,
				href: e.widget.link,
				class: "d-flex align-center ga-1 text-decoration-none font-weight-medium text-body-2",
				style: ot({ color: `rgb(var(--v-theme-${e.widget.linkColor || "primary"}))` })
			}, [M(V(e.widget.linkLabel || H(K)("view_all")) + " ", 1), N(J, {
				icon: "mdi:mdi-arrow-right",
				size: "small"
			})], 12, lD)) : k("", !0)])])]),
			_: 1
		}, 8, [
			"color",
			"icon",
			"href",
			"clickable"
		])) : k("", !0);
	}
}, [["__scopeId", "data-v-3cd646c9"]]), dD = { class: "text-body-1 font-weight-semibold" }, fD = {
	key: 0,
	class: "text-body-2 text-medium-emphasis mt-1"
}, pD = { class: "flex-1-1" }, mD = { class: "text-body-1 font-weight-semibold" }, hD = {
	key: 0,
	class: "text-body-2 text-medium-emphasis mt-1"
}, gD = {
	__name: "metric-info-card",
	props: { widget: {
		type: Object,
		required: !0
	} },
	setup(e) {
		let t = G(e, "HMetricInfoCard"), n = D(() => Array.isArray(t.widget.actions) && t.widget.actions.length > 0);
		return (t, r) => {
			let i = pt("h-action-button"), a = pt("h-action-link");
			return n.value ? (L(), O(rn, {
				key: 0,
				class: "h-metric-info-card h-metric-info-card--banner",
				rounded: "lg",
				elevation: "1"
			}, {
				default: W(() => [N(cn, null, {
					default: W(() => [N(pn, { class: "align-center" }, {
						default: W(() => [
							N(dn, { cols: "auto" }, {
								default: W(() => [N(tr, {
									color: "primary-lighten-4",
									size: "48"
								}, {
									default: W(() => [N(J, {
										icon: e.widget.icon || "mdi:mdi-information",
										color: "primary",
										size: "large"
									}, null, 8, ["icon"])]),
									_: 1
								})]),
								_: 1
							}),
							N(dn, null, {
								default: W(() => [j("div", dD, V(e.widget.name), 1), e.widget.description ? (L(), A("div", fD, V(e.widget.description), 1)) : k("", !0)]),
								_: 1
							}),
							N(dn, {
								cols: "12",
								sm: "auto",
								class: "d-flex flex-wrap ga-3 align-center"
							}, {
								default: W(() => [(L(!0), A(E, null, z(e.widget.actions, (e) => (L(), O(a, {
									key: e.name,
									to: e.link,
									target: "_blank"
								}, {
									default: W(() => [N(i, {
										type: e.type || "primary",
										"prepend-icon": e.icon,
										size: "small",
										tag: "span"
									}, {
										default: W(() => [M(V(e.name), 1)]),
										_: 2
									}, 1032, ["type", "prepend-icon"])]),
									_: 2
								}, 1032, ["to"]))), 128))]),
								_: 1
							})
						]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			})) : (L(), O(rn, {
				key: 1,
				class: I(["h-metric-info-card h-metric-info-card--nav h-100", { "h-metric-info-card--clickable": !!e.widget.link }]),
				to: e.widget.link || void 0,
				ripple: !!e.widget.link,
				rounded: "lg",
				elevation: "1"
			}, {
				default: W(() => [N(cn, { class: "h-metric-info-card__body" }, {
					default: W(() => [N(tr, {
						color: "primary-lighten-4",
						size: "48",
						class: "mr-3 flex-0-0"
					}, {
						default: W(() => [N(J, {
							icon: e.widget.icon || "mdi:mdi-link",
							color: "primary"
						}, null, 8, ["icon"])]),
						_: 1
					}), j("div", pD, [j("div", mD, V(e.widget.name), 1), e.widget.description ? (L(), A("div", hD, V(e.widget.description), 1)) : k("", !0)])]),
					_: 1
				})]),
				_: 1
			}, 8, [
				"class",
				"to",
				"ripple"
			]));
		};
	}
}, _D = {
	key: 0,
	class: "text-center py-4"
}, vD = { class: "h-metric-kpi-large__body text-center py-2" }, yD = {
	key: 0,
	class: "text-body-2 text-error d-flex align-center justify-center ga-1"
}, bD = {
	key: 1,
	class: "h-metric-kpi-large__value font-weight-bold"
}, xD = {
	key: 2,
	class: "text-body-2 text-medium-emphasis mt-1"
}, SD = { class: "mt-2" }, CD = { class: "h-metric-kpi-large__items" }, wD = { class: "text-caption text-medium-emphasis mt-1" }, TD = {
	__name: "metric-kpi-large",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		value: {
			type: [String, Number],
			default: null
		},
		loading: {
			type: Boolean,
			default: !1
		},
		error: {
			type: [String, Error],
			default: null
		},
		trend: {
			type: Object,
			default: null
		},
		breakdownData: {
			type: Object,
			default: () => ({})
		}
	},
	setup(e) {
		let t = G(e, "HMetricKpiLarge"), n = D(() => Array.isArray(t.widget.items) && t.widget.items.length > 0), r = D(() => t.widget.trend?.label ?? null), i = D(() => t.trend ? t.trend.percent === null || t.trend.percent === void 0 ? "—" : t.trend.percent < 0 ? "↓" : t.trend.percent > 0 ? "↑" : "—" : ""), a = D(() => {
			if (t.trend) return t.trend.direction === "up" ? "success" : t.trend.direction === "down" ? "error" : "default";
		});
		return (t, o) => (L(), O(rn, {
			class: "h-metric-kpi-large h-100",
			rounded: "lg",
			elevation: "1"
		}, {
			default: W(() => [N(ln, { class: "text-body-2 font-weight-semibold d-flex align-center ga-2 pb-2" }, {
				default: W(() => [e.widget.icon ? (L(), O(J, {
					key: 0,
					icon: e.widget.icon,
					size: "small",
					color: "primary"
				}, null, 8, ["icon"])) : k("", !0), M(" " + V(e.widget.name), 1)]),
				_: 1
			}), N(cn, { class: "pt-0 pb-4" }, {
				default: W(() => [e.loading && e.value === null ? (L(), A("div", _D, [
					N(Vr, {
						type: "heading",
						width: "120",
						class: "mx-auto mb-2"
					}),
					N(Vr, {
						type: "text",
						width: "80",
						class: "mx-auto mb-2"
					}),
					N(Vr, {
						type: "chip",
						width: "80",
						height: "22",
						class: "mx-auto"
					})
				])) : (L(), A(E, { key: 1 }, [j("div", vD, [
					e.error ? (L(), A("div", yD, [N(J, {
						icon: "mdi:mdi-alert-circle-outline",
						size: "small"
					}), M(" " + V(H(K)("error")), 1)])) : (L(), A("div", bD, V(e.value ?? "—"), 1)),
					e.widget.unit ? (L(), A("div", xD, V(e.widget.unit), 1)) : k("", !0),
					j("div", SD, [e.loading && e.trend === null && e.widget.trend ? (L(), O(Vr, {
						key: 0,
						type: "chip",
						width: "80",
						height: "22",
						class: "mx-auto"
					})) : e.trend ? (L(), O(qn, {
						key: 1,
						color: a.value,
						size: "x-small",
						variant: "tonal",
						class: "font-weight-semibold"
					}, {
						default: W(() => [M(V(i.value) + " " + V(e.trend.label) + " ", 1), r.value ? (L(), A(E, { key: 0 }, [M("· " + V(r.value), 1)], 64)) : k("", !0)]),
						_: 1
					}, 8, ["color"])) : k("", !0)])
				]), n.value ? (L(), A(E, { key: 0 }, [N(er, { class: "my-3" }), j("div", CD, [(L(!0), A(E, null, z(e.widget.items, (t) => (L(), A("div", {
					key: t._id ?? t.name,
					class: "h-metric-kpi-large__item text-center"
				}, [j("div", {
					class: "text-body-1 font-weight-bold",
					style: ot(t.color ? { color: t.color } : {})
				}, [e.breakdownData[t._id]?.loading ? (L(), O(wr, {
					key: 0,
					indeterminate: "",
					size: "14",
					width: "2"
				})) : e.breakdownData[t._id]?.error ? (L(), O(J, {
					key: 1,
					icon: "mdi:mdi-alert-circle-outline",
					size: "small",
					color: "error"
				})) : (L(), A(E, { key: 2 }, [M(V(e.breakdownData[t._id]?.value ?? "—"), 1)], 64))], 4), j("div", wD, V(t.name), 1)]))), 128))])], 64)) : k("", !0)], 64))]),
				_: 1
			})]),
			_: 1
		}));
	}
}, ED = {
	key: 1,
	class: "d-flex align-center ga-2 text-body-2 text-error py-2"
}, DD = {
	key: 2,
	class: "text-body-2 text-medium-emphasis py-2"
}, OD = { class: "h-metric-filtered__row h-metric-filtered__row--header mb-1" }, kD = { class: "h-metric-filtered__key text-caption text-medium-emphasis font-weight-semibold" }, AD = {
	key: 1,
	class: "text-caption text-medium-emphasis font-weight-semibold mb-1"
}, jD = {
	key: 2,
	class: "d-flex align-center ga-2 text-body-2 text-error py-1 mb-1"
}, MD = ["title"], ND = {
	key: 1,
	class: "text-body-2 text-medium-emphasis"
}, PD = {
	__name: "metric-filtered",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		groups: {
			type: Array,
			default: null
		},
		items: {
			type: Array,
			default: null
		},
		loading: {
			type: Boolean,
			default: !1
		},
		error: {
			type: [String, Error],
			default: null
		}
	},
	setup(e) {
		let t = G(e, "HMetricFiltered"), n = D(() => {
			let e = t.widget.link;
			return e ? typeof e == "string" ? e : e.to ?? e.href ?? e.url ?? null : null;
		}), r = D(() => {
			let e = t.widget.link;
			return e && typeof e == "object" && e.label ? e.label : t.widget.linkLabel ? t.widget.linkLabel : K("view_all");
		}), i = D(() => K("error")), a = D(() => t.error ? typeof t.error == "string" ? t.error : t.error.message || i.value : i.value), o = D(() => t.widget.emptyText || K("admin_dashboard_filtered_no_results")), s = D(() => t.widget.skeletonRows ?? 4), c = D(() => t.widget.maxItems ?? 10), l = D(() => Array.isArray(t.groups) && t.groups.length > 0 ? t.groups.map((e) => ({
			...e,
			items: Array.isArray(e.items) ? e.items.slice(0, c.value) : []
		})) : Array.isArray(t.items) ? [{
			label: t.widget.label,
			items: t.items.slice(0, c.value),
			error: null
		}] : []), u = D(() => l.value.some((e) => e.items.length > 0));
		return (t, i) => (L(), O(rn, {
			class: I(["h-metric-filtered h-100", { "h-metric-filtered--clickable": !!n.value }]),
			rounded: "lg",
			elevation: "1"
		}, {
			default: W(() => [N(ln, { class: "text-body-2 font-weight-semibold d-flex align-center ga-2 pb-2" }, {
				default: W(() => [
					e.widget.icon ? (L(), O(J, {
						key: 0,
						icon: e.widget.icon,
						size: "small",
						color: e.widget.color || "primary"
					}, null, 8, ["icon", "color"])) : k("", !0),
					M(" " + V(e.widget.name) + " ", 1),
					N(mn),
					n.value ? (L(), O(q, {
						key: 1,
						to: n.value,
						size: "x-small",
						variant: "text",
						color: "primary",
						density: "compact",
						class: "text-caption"
					}, {
						default: W(() => [M(V(r.value), 1)]),
						_: 1
					}, 8, ["to"])) : k("", !0)
				]),
				_: 1
			}), N(cn, { class: "pt-0 pb-4 px-4" }, {
				default: W(() => [e.loading && l.value.length === 0 ? (L(!0), A(E, { key: 0 }, z(s.value, (e) => (L(), A("div", {
					key: e,
					class: "h-metric-filtered__row h-metric-filtered__row--skeleton mb-2"
				}, [N(Vr, {
					type: "text",
					width: "120",
					height: "14"
				}), N(Vr, {
					type: "text",
					width: "80",
					height: "14"
				})]))), 128)) : e.error && !u.value ? (L(), A("div", ED, [N(J, {
					icon: "mdi:mdi-alert-circle-outline",
					size: "small"
				}), M(" " + V(a.value), 1)])) : !e.loading && !u.value ? (L(), A("div", DD, V(o.value), 1)) : (L(!0), A(E, { key: 3 }, z(l.value, (t, n) => (L(), A("section", {
					key: n,
					class: I({ "mt-3": n > 0 })
				}, [
					l.value.length === 1 && t.label ? (L(), A(E, { key: 0 }, [j("div", OD, [j("span", kD, V(t.label), 1), i[0] ||= j("span", { class: "h-metric-filtered__value" }, null, -1)]), N(er, { class: "mb-2" })], 64)) : l.value.length > 1 && t.label ? (L(), A("div", AD, V(t.label), 1)) : k("", !0),
					t.error ? (L(), A("div", jD, [N(J, {
						icon: "mdi:mdi-alert-circle-outline",
						size: "small"
					}), M(" " + V(t.error), 1)])) : k("", !0),
					(L(!0), A(E, null, z(t.items, (t, r) => (L(), A("div", {
						key: `${n}_${t.key}_${r}`,
						class: "h-metric-filtered__row mb-1"
					}, [j("span", {
						class: "h-metric-filtered__key text-body-2 font-weight-medium",
						title: t.key
					}, V(t.key), 9, MD), t.value ? (L(), O(qn, {
						key: 0,
						size: "x-small",
						variant: "tonal",
						color: e.widget.color || "default",
						class: "h-metric-filtered__value font-weight-medium"
					}, {
						default: W(() => [M(V(t.value), 1)]),
						_: 2
					}, 1032, ["color"])) : (L(), A("span", ND, "—"))]))), 128))
				], 2))), 128))]),
				_: 1
			})]),
			_: 1
		}, 8, ["class"]));
	}
}, FD = /* @__PURE__ */ b({
	BINARY_EXTENSIONS: () => pS,
	FILE_ICONS: () => gS,
	HActionButton: () => gl,
	HActionButtons: () => Dl,
	HActionCard: () => Yl,
	HActionDialog: () => sb,
	HActionLink: () => Tl,
	HActionMenu: () => Xl,
	HAdminDataView: () => ii,
	HAdminLayout: () => Yr,
	HAdminLogsFromDateOptions: () => ly,
	HAdminLogsLevelOptions: () => qv,
	HAdminLogsSourceOptions: () => Jv,
	HAdminLogsTable: () => cy,
	HAdminTemplate: () => oi,
	HAlertBar: () => Sy,
	HAlertsProvider: () => wy,
	HAttachments: () => lS,
	HAutocomplete: () => Zy,
	HBreadcrumbs: () => Rx,
	HBtnTableCell: () => Uv,
	HBulletin: () => rb,
	HChipGroupTableCell: () => Bv,
	HChipTableCell: () => Hv,
	HConfirmationDialog: () => lb,
	HCountdownTimer: () => Ub,
	HDataTable: () => au,
	HDescriptionTableCell: () => zv,
	HDialog: () => ib,
	HDialogContainer: () => Fy,
	HFileUpload: () => Ty,
	HFilterDatetime: () => gv,
	HFilterGroup: () => Av,
	HFilterMultiselect: () => yv,
	HFilterMultistring: () => wv,
	HFilterSelect: () => Fv,
	HFilterString: () => Ov,
	HFilterSwitch: () => Rv,
	HFilterText: () => jv,
	HFiltersContainer: () => Fl,
	HFormAutocomplete: () => mi,
	HFormCodeEditor: () => hl,
	HFormCombobox: () => hi,
	HFormContainer: () => Ay,
	HFormDatePicker: () => vi,
	HFormDateTimePicker: () => Ei,
	HFormField: () => di,
	HFormLabel: () => ci,
	HFormLayout: () => Qx,
	HFormOtpInput: () => Di,
	HFormPassword: () => Oi,
	HFormSelect: () => pi,
	HFormSwitch: () => _i,
	HFormText: () => fi,
	HFormTextarea: () => gi,
	HInfoDisplay: () => my,
	HItemCard: () => Ab,
	HItemCardTemplate: () => ox,
	HLegacyFormContainer: () => ky,
	HLiveUpdateControls: () => _y,
	HLoader: () => Nb,
	HMenu: () => qx,
	HMetricAlertBanner: () => uD,
	HMetricBreakdownCard: () => qE,
	HMetricCard: () => VE,
	HMetricFiltered: () => PD,
	HMetricHistogramCard: () => nD,
	HMetricInfoCard: () => gD,
	HMetricKpiLarge: () => TD,
	HMilestoneTimeline: () => rS,
	HNavigationMenu: () => Fx,
	HNotificationBadge: () => Tx,
	HNotificationDrawer: () => wx,
	HNotificationItem: () => xx,
	HOnifyLogo: () => Ox,
	HPageContainer: () => jy,
	HPageDescription: () => qy,
	HPageHead: () => Ey,
	HPageSubtitle: () => Uy,
	HPageTitle: () => zy,
	HPreCodeTableCell: () => Kv,
	HPrettyCode: () => Yy,
	HProcessState: () => Gb,
	HProcessStateSimple: () => qb,
	HResourceContentViewer: () => AE,
	HResourceTreeNode: () => LS,
	HResourceTreeView: () => US,
	HResourceView: () => PE,
	HSearch: () => kl,
	HSearchItems: () => rx,
	HSearchItemsDialog: () => tx,
	HSearchItemsResults: () => gx,
	HShortcut: () => vb,
	HThemePackProvider: () => dy,
	HThemeScope: () => Jx,
	HTooltip: () => Il,
	HViewCodeDialog: () => su,
	HViewWorkflowDialog: () => sv,
	HWidget: () => mv,
	HWidgetsContainer: () => cv,
	HWorkspaceItem: () => Kx,
	IMAGE_EXTENSIONS: () => fS,
	LANGUAGES_WITH_SYNTAX_CHECK: () => hS,
	LANGUAGE_BY_EXTENSION: () => dS,
	MAX_UPLOAD_BYTES: () => uS,
	STREAM_EXTENSIONS: () => mS,
	collectLezerErrors: () => ZT,
	getFileExtension: () => vS,
	getFileIcon: () => ES,
	getLanguageForExtension: () => yS,
	getLanguageForPath: () => bS,
	getParentDirectory: () => kS,
	isBinaryExtension: () => SS,
	isEditableExtension: () => wS,
	isEditableResource: () => TS,
	isImageExtension: () => xS,
	isStreamExtension: () => CS,
	joinResourcePath: () => OS,
	languageHasSyntaxCheck: () => nE,
	lineFromIndex: () => YT,
	lintLezerTree: () => QT,
	lintResourceText: () => tE,
	resourceNameError: () => DS
});
//#endregion
//#region src/index.ts
function ID() {
	return { install(e) {
		for (let t in FD) e.component(t, FD[t]);
	} };
}
//#endregion
export { pS as BINARY_EXTENSIONS, gS as FILE_ICONS, gl as HActionButton, Dl as HActionButtons, Yl as HActionCard, sb as HActionDialog, Tl as HActionLink, Xl as HActionMenu, ii as HAdminDataView, Yr as HAdminLayout, ly as HAdminLogsFromDateOptions, qv as HAdminLogsLevelOptions, Jv as HAdminLogsSourceOptions, cy as HAdminLogsTable, oi as HAdminTemplate, Sy as HAlertBar, wy as HAlertsProvider, lS as HAttachments, Zy as HAutocomplete, Rx as HBreadcrumbs, Uv as HBtnTableCell, rb as HBulletin, Bv as HChipGroupTableCell, Hv as HChipTableCell, lb as HConfirmationDialog, Ub as HCountdownTimer, au as HDataTable, zv as HDescriptionTableCell, ib as HDialog, Fy as HDialogContainer, Ty as HFileUpload, gv as HFilterDatetime, Av as HFilterGroup, yv as HFilterMultiselect, wv as HFilterMultistring, Fv as HFilterSelect, Ov as HFilterString, Rv as HFilterSwitch, jv as HFilterText, Fl as HFiltersContainer, mi as HFormAutocomplete, hl as HFormCodeEditor, hi as HFormCombobox, Ay as HFormContainer, vi as HFormDatePicker, Ei as HFormDateTimePicker, di as HFormField, ci as HFormLabel, Qx as HFormLayout, Di as HFormOtpInput, Oi as HFormPassword, pi as HFormSelect, _i as HFormSwitch, fi as HFormText, gi as HFormTextarea, my as HInfoDisplay, Ab as HItemCard, ox as HItemCardTemplate, ky as HLegacyFormContainer, _y as HLiveUpdateControls, Nb as HLoader, qx as HMenu, uD as HMetricAlertBanner, qE as HMetricBreakdownCard, VE as HMetricCard, PD as HMetricFiltered, nD as HMetricHistogramCard, gD as HMetricInfoCard, TD as HMetricKpiLarge, rS as HMilestoneTimeline, Fx as HNavigationMenu, Tx as HNotificationBadge, wx as HNotificationDrawer, xx as HNotificationItem, Ox as HOnifyLogo, jy as HPageContainer, qy as HPageDescription, Ey as HPageHead, Uy as HPageSubtitle, zy as HPageTitle, Kv as HPreCodeTableCell, Yy as HPrettyCode, Gb as HProcessState, qb as HProcessStateSimple, AE as HResourceContentViewer, LS as HResourceTreeNode, US as HResourceTreeView, PE as HResourceView, kl as HSearch, rx as HSearchItems, tx as HSearchItemsDialog, gx as HSearchItemsResults, vb as HShortcut, dy as HThemePackProvider, Jx as HThemeScope, Il as HTooltip, su as HViewCodeDialog, sv as HViewWorkflowDialog, mv as HWidget, cv as HWidgetsContainer, Kx as HWorkspaceItem, fS as IMAGE_EXTENSIONS, hS as LANGUAGES_WITH_SYNTAX_CHECK, dS as LANGUAGE_BY_EXTENSION, uS as MAX_UPLOAD_BYTES, mS as STREAM_EXTENSIONS, ZT as collectLezerErrors, vS as getFileExtension, ES as getFileIcon, yS as getLanguageForExtension, bS as getLanguageForPath, kS as getParentDirectory, ID as hCreateComponents, SS as isBinaryExtension, wS as isEditableExtension, TS as isEditableResource, xS as isImageExtension, CS as isStreamExtension, OS as joinResourcePath, nE as languageHasSyntaxCheck, YT as lineFromIndex, QT as lintLezerTree, tE as lintResourceText, DS as resourceNameError };

//# sourceMappingURL=helix-components.es.js.map